window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs, an) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.AICoach_Robby_Error = function() {
	this.initialize(img.MainAssets_AICoach_Robby_Error);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,363,238);


(lib.AICoach_Robby_Feedback = function() {
	this.initialize(img.MainAssets_AICoach_Robby_Feedback);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,680,556);


(lib.AICoach_RoboHead_eyes = function() {
	this.initialize(img.MainAssets_AICoach_RoboHead_eyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,89,42);


(lib.AICoach_RoboHead_mid_noeyes = function() {
	this.initialize(img.MainAssets_AICoach_RoboHead_mid_noeyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,173,136);


(lib.armachter_feedback = function() {
	this.initialize(img.MainAssets_armachter_feedback);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,241,273);


(lib.armvoor = function() {
	this.initialize(img.MainAssets_armvoor);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,189,237);


(lib.armvoor_feedback = function() {
	this.initialize(img.MainAssets_armvoor_feedback);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,179,253);


(lib.armvoor_zwaai = function() {
	this.initialize(img.MainAssets_armvoor_zwaai);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,219,169);


(lib.benen = function() {
	this.initialize(img.MainAssets_benen);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,507,207);


(lib.bg_endofgame = function() {
	this.initialize(img.MainAssets_bg_endofgame);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.bg_endofgame2 = function() {
	this.initialize(img.MainAssets_bg_endofgame2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.blueCircle = function() {
	this.initialize(img.MainAssets_blueCircle);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,87,87);


(lib.bodyRobbieZwaai = function() {
	this.initialize(img.MainAssets_bodyRobbieZwaai);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,357,229);


(lib.c01_hub_tile = function() {
	this.initialize(img.MainAssets_c01_hub_tile);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.c01_hub_tile_disabled = function() {
	this.initialize(img.MainAssets_c01_hub_tile_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.c01_hub_tile_over = function() {
	this.initialize(img.MainAssets_c01_hub_tile_over);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.c02_hub_tile = function() {
	this.initialize(img.MainAssets_c02_hub_tile);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.c02_hub_tile_disabled = function() {
	this.initialize(img.MainAssets_c02_hub_tile_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.c02_hub_tile_over = function() {
	this.initialize(img.MainAssets_c02_hub_tile_over);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.c03_hub_tile = function() {
	this.initialize(img.MainAssets_c03_hub_tile);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.c03_hub_tile_disabled = function() {
	this.initialize(img.MainAssets_c03_hub_tile_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.c03_hub_tile_over = function() {
	this.initialize(img.MainAssets_c03_hub_tile_over);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.c04_hub_tile = function() {
	this.initialize(img.MainAssets_c04_hub_tile);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.c04_hub_tile_disabled = function() {
	this.initialize(img.MainAssets_c04_hub_tile_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.c04_hub_tile_over = function() {
	this.initialize(img.MainAssets_c04_hub_tile_over);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.c05_hub_tile = function() {
	this.initialize(img.MainAssets_c05_hub_tile);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.c05_hub_tile_disabled = function() {
	this.initialize(img.MainAssets_c05_hub_tile_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.c05_hub_tile_over = function() {
	this.initialize(img.MainAssets_c05_hub_tile_over);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.chapterPanel = function() {
	this.initialize(img.MainAssets_chapterPanel);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1488,180);


(lib.ChapterScreen_BGHst01 = function() {
	this.initialize(img.MainAssets_ChapterScreen_BGHst01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.CharacterFeedbackGroep = function() {
	this.initialize(img.MainAssets_CharacterFeedbackGroep);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,88,59);


(lib.CharacterFeedbackHartje = function() {
	this.initialize(img.MainAssets_CharacterFeedbackHartje);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,74,66);


(lib.CharacterFeedbackPanel_balkje = function() {
	this.initialize(img.MainAssets_CharacterFeedbackPanel_balkje);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,333,41);


(lib.CharacterFeedbackPanel_balkje_1 = function() {
	this.initialize(img.MainAssets_CharacterFeedbackPanel_balkje_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,333,41);


(lib.CharacterFeedbackPanel_balkjeGroen = function() {
	this.initialize(img.MainAssets_CharacterFeedbackPanel_balkjeGroen);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,332,39);


(lib.CharacterFeedbackPanel_balkjeOranje = function() {
	this.initialize(img.MainAssets_CharacterFeedbackPanel_balkjeOranje);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,332,39);


(lib.CharacterFeedbackPanel_kort = function() {
	this.initialize(img.MainAssets_CharacterFeedbackPanel_kort);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,426,421);


(lib.CharacterFeedbackSingle = function() {
	this.initialize(img.MainAssets_CharacterFeedbackSingle);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,64,66);


(lib.CharacterFeedbackSmiley = function() {
	this.initialize(img.MainAssets_CharacterFeedbackSmiley);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,66,66);


(lib.colors = function() {
	this.initialize(img.MainAssets_colors);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,572,509);


(lib.colors_off = function() {
	this.initialize(img.MainAssets_colors_off);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,572,509);


(lib.Con_BG_Dialog02 = function() {
	this.initialize(img.MainAssets_Con_BG_Dialog02);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.Con_BG_Dialog_01_Total_disabled = function() {
	this.initialize(img.MainAssets_Con_BG_Dialog_01_Total_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,469,361);


(lib.Con_BG_Dialog_01_Total_newBlurred = function() {
	this.initialize(img.MainAssets_Con_BG_Dialog_01_Total_newBlurred);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.Con_panel_Dialog_01_over = function() {
	this.initialize(img.MainAssets_Con_panel_Dialog_01_over);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,666,231);


(lib.ConfettiBlauw1 = function() {
	this.initialize(img.MainAssets_ConfettiBlauw1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,51,59);


(lib.ConfettiBlauw2 = function() {
	this.initialize(img.MainAssets_ConfettiBlauw2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,53,79);


(lib.ConfettiGeel1 = function() {
	this.initialize(img.MainAssets_ConfettiGeel1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,38,67);


(lib.ConfettiGeel2 = function() {
	this.initialize(img.MainAssets_ConfettiGeel2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,63,105);


(lib.ConfettiGeel2_1 = function() {
	this.initialize(img.MainAssets_ConfettiGeel2_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,63,105);


(lib.ConfettiGroen1 = function() {
	this.initialize(img.MainAssets_ConfettiGroen1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,36,63);


(lib.ConfettiGroen2 = function() {
	this.initialize(img.MainAssets_ConfettiGroen2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,62,64);


(lib.ConfettiOranje1 = function() {
	this.initialize(img.MainAssets_ConfettiOranje1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,45,99);


(lib.ConfettiOranje2 = function() {
	this.initialize(img.MainAssets_ConfettiOranje2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,46,69);


(lib.ConfettiViolet1 = function() {
	this.initialize(img.MainAssets_ConfettiViolet1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,44,77);


(lib.ConfettiViolet2 = function() {
	this.initialize(img.MainAssets_ConfettiViolet2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,49,67);


(lib.demoInput = function() {
	this.initialize(img.MainAssets_demoInput);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,848,133);


(lib.Dialog_Chat_Action_Panel3 = function() {
	this.initialize(img.MainAssets_Dialog_Chat_Action_Panel3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,795,72);


(lib.Dialog_Chat_AIResponse_Panel = function() {
	this.initialize(img.MainAssets_Dialog_Chat_AIResponse_Panel);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,611,93);


(lib.Dialog_Chat_Outputfield4 = function() {
	this.initialize(img.MainAssets_Dialog_Chat_Outputfield4);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1416,73);


(lib.Dialog_Chat_Panel_Input6 = function() {
	this.initialize(img.MainAssets_Dialog_Chat_Panel_Input6);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1432,205);


(lib.Dialog_Chat_Send_button_Down3 = function() {
	this.initialize(img.MainAssets_Dialog_Chat_Send_button_Down3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,181,181);


(lib.Dialog_Chat_Send_button_Over3 = function() {
	this.initialize(img.MainAssets_Dialog_Chat_Send_button_Over3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,181,181);


(lib.Dialog_Chat_Send_button_Up3 = function() {
	this.initialize(img.MainAssets_Dialog_Chat_Send_button_Up3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,181,181);


(lib.Dialog_panel3_blue = function() {
	this.initialize(img.MainAssets_Dialog_panel3_blue);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,652,71);


(lib.Dialog_Robot_Circle_BG_blue = function() {
	this.initialize(img.MainAssets_Dialog_Robot_Circle_BG_blue);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,185,185);


(lib.Dialog_Robot_Circle_inner_circle = function() {
	this.initialize(img.MainAssets_Dialog_Robot_Circle_inner_circle);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,152,152);


(lib.DialogScr_CharacterProfile_BG3 = function() {
	this.initialize(img.MainAssets_DialogScr_CharacterProfile_BG3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,116,116);


(lib.DialogScr_CharacterProfile_broder2 = function() {
	this.initialize(img.MainAssets_DialogScr_CharacterProfile_broder2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,116,116);


(lib.download_Icon = function() {
	this.initialize(img.MainAssets_download_Icon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,32,31);


(lib.download_Icon_up = function() {
	this.initialize(img.MainAssets_download_Icon_up);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,32,41);


(lib.Download_over = function() {
	this.initialize(img.MainAssets_Download_over);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,594,167);


(lib.downloadButton = function() {
	this.initialize(img.MainAssets_downloadButton);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,594,167);


(lib.downloading_pdf = function() {
	this.initialize(img.MainAssets_downloading_pdf);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,43,43);


(lib.elips = function() {
	this.initialize(img.MainAssets_elips);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,695,695);


(lib.elipse_glow = function() {
	this.initialize(img.MainAssets_elipse_glow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,938,938);


(lib.Endframe = function() {
	this.initialize(img.MainAssets_Endframe);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.EndofGameScreen = function() {
	this.initialize(img.MainAssets_EndofGameScreen);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.eten = function() {
	this.initialize(img.MainAssets_eten);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,61,63);


(lib.feel = function() {
	this.initialize(img.MainAssets_feel);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,278,216);


(lib.GameSaved = function() {
	this.initialize(img.MainAssets_GameSaved);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,833,115);


(lib.group = function() {
	this.initialize(img.MainAssets_group);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,101,67);


(lib.handje = function() {
	this.initialize(img.MainAssets_handje);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,107,147);


(lib.hut = function() {
	this.initialize(img.MainAssets_hut);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,63,63);


(lib.loadingBG = function() {
	this.initialize(img.MainAssets_loadingBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.loadingScreenBG = function() {
	this.initialize(img.MainAssets_loadingScreenBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.locked = function() {
	this.initialize(img.MainAssets_locked);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,35,51);


(lib.Map_point = function() {
	this.initialize(img.MainAssets_Map_point);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,47,29);


(lib.mission_briefing_background = function() {
	this.initialize(img.MainAssets_mission_briefing_background);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2240,1080);


(lib.naamInvoerOK_down = function() {
	this.initialize(img.MainAssets_naamInvoerOK_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,181,181);


(lib.naamInvoerOK_over = function() {
	this.initialize(img.MainAssets_naamInvoerOK_over);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,181,181);


(lib.naamInvoerOK_up = function() {
	this.initialize(img.MainAssets_naamInvoerOK_up);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,181,181);


(lib.naamInvoerPanel = function() {
	this.initialize(img.MainAssets_naamInvoerPanel);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,848,147);


(lib.npc_erik_1 = function() {
	this.initialize(img.MainAssets_npc_erik_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,110,110);


(lib.panel_end = function() {
	this.initialize(img.MainAssets_panel_end);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,767,412);


(lib.pijltje = function() {
	this.initialize(img.MainAssets_pijltje);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,59,86);


(lib.pijlUp = function() {
	this.initialize(img.MainAssets_pijlUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,37,54);


(lib.pijlUpGreen = function() {
	this.initialize(img.MainAssets_pijlUpGreen);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,37,54);


(lib.pinpoint_disabled = function() {
	this.initialize(img.MainAssets_pinpoint_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,137,173);


(lib.Pinpoint_green = function() {
	this.initialize(img.MainAssets_Pinpoint_green);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,137,173);


(lib.pinpoint_orange = function() {
	this.initialize(img.MainAssets_pinpoint_orange);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,138,173);


(lib.PRIMARY = function() {
	this.initialize(img.MainAssets_PRIMARY);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,277,161);


(lib.PRIMARY_DOWN = function() {
	this.initialize(img.MainAssets_PRIMARY_DOWN);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,277,161);


(lib.PRIMARY_OVER = function() {
	this.initialize(img.MainAssets_PRIMARY_OVER);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,277,161);


(lib.ReflectionInput = function() {
	this.initialize(img.MainAssets_ReflectionInput);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1164,195);


(lib.RightArrow_down = function() {
	this.initialize(img.MainAssets_RightArrow_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,67,85);


(lib.RightArrow_over = function() {
	this.initialize(img.MainAssets_RightArrow_over);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,67,85);


(lib.RightArrow_up = function() {
	this.initialize(img.MainAssets_RightArrow_up);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,67,85);


(lib.Robby_headless_feedback = function() {
	this.initialize(img.MainAssets_Robby_headless_feedback);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,507,470);


(lib.roboGuru_feedbackPanel = function() {
	this.initialize(img.MainAssets_roboGuru_feedbackPanel);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1206,815);


(lib.roboGuru_feedbackPanel_1 = function() {
	this.initialize(img.MainAssets_roboGuru_feedbackPanel_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1206,815);


(lib.roboGuru_help_outputField = function() {
	this.initialize(img.MainAssets_roboGuru_help_outputField);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1416,73);


(lib.roboGuru_help_panel = function() {
	this.initialize(img.MainAssets_roboGuru_help_panel);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,890,288);


(lib.roboGuru_input = function() {
	this.initialize(img.MainAssets_roboGuru_input);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,890,288);


(lib.roboGuru_missionPanel = function() {
	this.initialize(img.MainAssets_roboGuru_missionPanel);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,890,979);


(lib.RoboGuru_totaal2 = function() {
	this.initialize(img.MainAssets_RoboGuru_totaal2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1000,1200);


(lib.RobotInputPanel = function() {
	this.initialize(img.MainAssets_RobotInputPanel);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,715,211);


(lib.scharm = function() {
	this.initialize(img.MainAssets_scharm);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,614,553);


(lib.signaal = function() {
	this.initialize(img.MainAssets_signaal);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,57,59);


(lib.solo = function() {
	this.initialize(img.MainAssets_solo);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,60,62);


(lib.vuur = function() {
	this.initialize(img.MainAssets_vuur);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,43,69);


(lib.water = function() {
	this.initialize(img.MainAssets_water);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,35,55);


(lib.wijzer = function() {
	this.initialize(img.MainAssets_wijzer);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,299,172);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.wijzer_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.wijzer();
	this.instance.setTransform(167.6,40.7,1,1,163.7392);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-167.6,-124.4,335.2,248.8);


(lib.vignette = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.lf(["#000000","rgba(0,0,0,0)"],[0,1],0,-199.9,0,200).s().p("Eiu/AfQIAA2gMAAAgnrIAAgFIAAgDIAAgMMFd/AAAMAAAA+fg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.vignette, new cjs.Rectangle(-1120,-200,2240,400), null);


(lib.Tween2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.downloading_pdf();
	this.instance.setTransform(-21.5,-21.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-21.5,-21.5,43,43);


(lib.Tween1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.downloading_pdf();
	this.instance.setTransform(-21.5,-21.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-21.5,-21.5,43,43);


(lib.roboPanelHitarea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EgnDgDyIAAhrMBOHAAAIAABrEAnEAFeIAAAAMhOHAAAIAAAA");
	this.shape.setTransform(0,7.4);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(6,5,2,0.008)").s().p("EAnEAEoMhOHAAAI2bAAIAApPIWbAAMBOHAAAIWbAAIAAJPg");
	this.shape_1.setTransform(0,12.725);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.roboPanelHitarea, new cjs.Rectangle(-393.5,-28.6,787,72), null);


(lib.roboGuruPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.coachTextField = new cjs.Text("Hoi! Mijn naam is Robo Guru Welkom op dit eiland hoeheet\nHoi! Mijn naam is Robo Guru Welkom op dit eiland hoeheet\nHoi! Mijn naam is Robo Guru Welkom op dit eiland hoeheet\nHoi! Mijn naam is Robo Guru Welkom op dit eiland hoeheet ", "22px 'JetBrains Mono'", "#FE9625");
	this.coachTextField.name = "coachTextField";
	this.coachTextField.lineHeight = 31;
	this.coachTextField.lineWidth = 749;
	this.coachTextField.parent = this;
	this.coachTextField.setTransform(-375.45,-83);
ranj.TextOffsetFixer.fix(this.coachTextField);

	this.instance = new lib.roboGuru_input();
	this.instance.setTransform(-445,-144);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.coachTextField}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.roboGuruPanel, new cjs.Rectangle(-445,-144,890,288), null);


(lib.RoboGuruOutputField = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.contentText = new cjs.Text("PLACEHOLDER PLACEHOLDER_PLACEHOLDERRRRRRRRRRRRRRRRRRRRRPRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRR", "22px 'JetBrains Mono'", "#FE9625");
	this.contentText.name = "contentText";
	this.contentText.lineHeight = 29;
	this.contentText.lineWidth = 1347;
	this.contentText.parent = this;
	this.contentText.setTransform(-485.95,-15.75);
ranj.TextOffsetFixer.fix(this.contentText);

	this.timeline.addTween(cjs.Tween.get(this.contentText).wait(1));

	// Layer_1
	this.instance = new lib.roboGuru_help_outputField();
	this.instance.setTransform(-511,-37);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RoboGuruOutputField, new cjs.Rectangle(-511,-37,1416,96.9), null);


(lib.roboGuru_mission = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.RoboGuru_totaal2();
	this.instance.setTransform(399.1,-863.45,1.2179,1.2179,0,-14.998,165.002);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.roboGuru_mission, new cjs.Rectangle(-777.3,-863.4,1554.6,1726.9), null);


(lib.roboGuru_knipper_onboarding = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.AICoach_RoboHead_eyes();
	this.instance.setTransform(-57,-15,0.8208,0.8208);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({scaleY:0.5467,skewX:-6.3782,x:-58.25,y:-9},0).wait(1).to({scaleY:0.12,skewX:-6.3724,x:-57.25,y:-0.1},0).wait(1).to({scaleX:0.8937,x:-58.65},0).wait(7).to({scaleX:0.8208,scaleY:0.5467,skewX:-6.3782,x:-58.25,y:-9},0).wait(2).to({scaleY:0.7001,skewX:-4.8032,x:-58.15,y:-12},0).wait(2).to({scaleY:0.8816,skewX:1.1426,x:-56.6,y:-18.25},0).wait(2).to({scaleY:0.8208,skewX:0,x:-57,y:-17},0).wait(2).to({scaleY:0.7016,y:-13},0).wait(2).to({scaleY:0.8208,y:-15},0).wait(19).to({scaleY:0.5467,skewX:-6.3782,x:-58.25,y:-9},0).wait(1).to({scaleY:0.12,skewX:-6.3724,x:-57.25,y:-0.1},0).wait(1).to({scaleX:0.8937,x:-58.65},0).wait(7).to({scaleX:0.8208,scaleY:0.5467,skewX:-6.3782,x:-58.25,y:-9},0).wait(1).to({scaleY:0.7001,skewX:-4.8032,x:-58.15,y:-12},0).wait(1).to({scaleY:0.8816,skewX:1.1426,x:-56.6,y:-18.25},0).wait(1).to({scaleY:0.8208,skewX:0,x:-57,y:-17},0).wait(1).to({scaleY:0.7016,y:-13},0).wait(1).to({scaleY:0.8208,y:-15},0).wait(9).to({_off:true},1).wait(92));

	// Layer_1
	this.instance_1 = new lib.AICoach_RoboHead_mid_noeyes();
	this.instance_1.setTransform(-71,-55.85,0.8208,0.8208);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(62).to({_off:true},1).wait(92));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-71,-55.8,142,111.6);


(lib.roboGuru_knipper = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.AICoach_RoboHead_eyes();
	this.instance.setTransform(-57,-15,0.8208,0.8208);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({scaleY:0.5467,skewX:-6.3782,x:-58.25,y:-9},0).wait(1).to({scaleY:0.12,skewX:-6.3724,x:-57.25,y:-0.1},0).wait(1).to({scaleX:0.8937,x:-58.65},0).wait(3).to({scaleX:0.8208,scaleY:0.5467,skewX:-6.3782,x:-58.25,y:-9},0).wait(1).to({scaleY:0.7001,skewX:-4.8032,x:-58.15,y:-12},0).wait(2).to({scaleY:0.8816,skewX:1.1426,x:-56.6,y:-18.25},0).wait(2).to({scaleY:0.8208,skewX:0,x:-57,y:-17},0).wait(2).to({scaleY:0.7016,y:-13},0).wait(2).to({scaleY:0.8208,y:-15},0).wait(8).to({_off:true},1).wait(1));

	// Layer_1
	this.instance_1 = new lib.AICoach_RoboHead_mid_noeyes();
	this.instance_1.setTransform(-71,-55.85,0.8208,0.8208);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(23).to({_off:true},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-71,-55.8,142,111.6);


(lib.roboGuru_idle = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.AICoach_RoboHead_eyes();
	this.instance.setTransform(-57,-15,0.8208,0.8208);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_2
	this.instance_1 = new lib.AICoach_RoboHead_mid_noeyes();
	this.instance_1.setTransform(-71,-55.85,0.8208,0.8208);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.roboGuru_idle, new cjs.Rectangle(-71,-55.8,142,111.6), null);


(lib.pointWhite = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Map_point();
	this.instance.setTransform(-23.5,-14.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.pointWhite, new cjs.Rectangle(-23.5,-14.5,47,29), null);


(lib.pinpoint_ALL = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_1 = function() {
		this.stop();
	}
	this.frame_2 = function() {
		this.stop();
	}
	this.frame_3 = function() {
		this.stop();
	}
	this.frame_4 = function() {
		this.stop();
	}
	this.frame_5 = function() {
		this.stop();
	}
	this.frame_6 = function() {
		this.stop();
	}
	this.frame_7 = function() {
		this.stop();
	}
	this.frame_8 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.stop();
	}
	this.frame_10 = function() {
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1).call(this.frame_2).wait(1).call(this.frame_3).wait(1).call(this.frame_4).wait(1).call(this.frame_5).wait(1).call(this.frame_6).wait(1).call(this.frame_7).wait(1).call(this.frame_8).wait(1).call(this.frame_9).wait(1).call(this.frame_10).wait(1));

	// Layer_6
	this.instance = new lib.locked();
	this.instance.setTransform(-18,-126);

	this.instance_1 = new lib.hut();
	this.instance_1.setTransform(-28,-129,0.9,0.9);

	this.instance_2 = new lib.water();
	this.instance_2.setTransform(-18,-124);

	this.instance_3 = new lib.eten();
	this.instance_3.setTransform(-31,-128);

	this.instance_4 = new lib.vuur();
	this.instance_4.setTransform(-22,-131);

	this.instance_5 = new lib.signaal();
	this.instance_5.setTransform(-29,-124);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).wait(1));

	// Layer_2
	this.instance_6 = new lib.blueCircle();
	this.instance_6.setTransform(-44,-140);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(11));

	// Layer_1
	this.instance_7 = new lib.pinpoint_disabled();
	this.instance_7.setTransform(-69,-155);

	this.instance_8 = new lib.pinpoint_orange();
	this.instance_8.setTransform(-69,-155);

	this.instance_9 = new lib.Pinpoint_green();
	this.instance_9.setTransform(-69,-155);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_7}]}).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_9}]},5).wait(5));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-69,-155,138,173);


(lib.loading = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.textField = new cjs.Text("[Aan het laden...]", "40px 'JetBrains Mono'", "#FFFFFF");
	this.textField.name = "textField";
	this.textField.textAlign = "center";
	this.textField.lineHeight = 55;
	this.textField.lineWidth = 724;
	this.textField.parent = this;
	this.textField.setTransform(0,-26.4);
ranj.TextOffsetFixer.fix(this.textField);

	this.timeline.addTween(cjs.Tween.get(this.textField).wait(1));

	// Layer_2
	this.instance = new lib.GameSaved();
	this.instance.setTransform(-417,-58);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.loading, new cjs.Rectangle(-417,-58,833,115), null);


(lib.handzwaai = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.handje();
	this.instance.setTransform(30.65,-98.6,1.3174,1.0266,0,-25.7896,154.2102);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.handzwaai, new cjs.Rectangle(-96.3,-98.6,192.6,197.3), null);


(lib.glowcircle = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.elipse_glow();
	this.instance.setTransform(-469,-469);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.glowcircle, new cjs.Rectangle(-469,-469,938,938), null);


(lib.eyesRobby = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.AICoach_Robby_Error();
	this.instance.setTransform(-181.5,-119);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-181.5,-119,363,238);


(lib.DownloadIconUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.download_Icon_up();
	this.instance.setTransform(-16,-20.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DownloadIconUp, new cjs.Rectangle(-16,-20.5,32,41), null);


(lib.DownloadIconDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.download_Icon();
	this.instance.setTransform(-16,-15.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DownloadIconDown, new cjs.Rectangle(-16,-15.5,32,31), null);


(lib.ConfettiOverlay = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ConfettiGeel2();
	this.instance.setTransform(-788,-138);

	this.instance_1 = new lib.ConfettiViolet2();
	this.instance_1.setTransform(-404,-194);

	this.instance_2 = new lib.ConfettiViolet1();
	this.instance_2.setTransform(88,24);

	this.instance_3 = new lib.ConfettiViolet1();
	this.instance_3.setTransform(-432,216);

	this.instance_4 = new lib.ConfettiViolet1();
	this.instance_4.setTransform(920,111);

	this.instance_5 = new lib.ConfettiViolet1();
	this.instance_5.setTransform(-977,73);

	this.instance_6 = new lib.ConfettiViolet2();
	this.instance_6.setTransform(-901,-485);

	this.instance_7 = new lib.ConfettiViolet2();
	this.instance_7.setTransform(746,-437);

	this.instance_8 = new lib.ConfettiBlauw2();
	this.instance_8.setTransform(-816,266);

	this.instance_9 = new lib.ConfettiBlauw1();
	this.instance_9.setTransform(-556,-302);

	this.instance_10 = new lib.ConfettiBlauw2();
	this.instance_10.setTransform(-252,380);

	this.instance_11 = new lib.ConfettiBlauw1();
	this.instance_11.setTransform(-156,-343);

	this.instance_12 = new lib.ConfettiOranje2();
	this.instance_12.setTransform(-578,51);

	this.instance_13 = new lib.ConfettiOranje1();
	this.instance_13.setTransform(-707,-485);

	this.instance_14 = new lib.ConfettiOranje2();
	this.instance_14.setTransform(736,65);

	this.instance_15 = new lib.ConfettiOranje1();
	this.instance_15.setTransform(562,-209);

	this.instance_16 = new lib.ConfettiOranje2();
	this.instance_16.setTransform(269,390);

	this.instance_17 = new lib.ConfettiOranje1();
	this.instance_17.setTransform(224,-324);

	this.instance_18 = new lib.ConfettiGeel2();
	this.instance_18.setTransform(-270,83);

	this.instance_19 = new lib.ConfettiGeel1();
	this.instance_19.setTransform(477,-437);

	this.instance_20 = new lib.ConfettiGeel1();
	this.instance_20.setTransform(-270,-496);

	this.instance_21 = new lib.ConfettiGroen1();
	this.instance_21.setTransform(-7,-190);

	this.instance_22 = new lib.ConfettiGroen2();
	this.instance_22.setTransform(817,384);

	this.instance_23 = new lib.ConfettiGroen1();
	this.instance_23.setTransform(29,321);

	this.instance_24 = new lib.ConfettiGroen2();
	this.instance_24.setTransform(-1039,466);

	this.instance_25 = new lib.ConfettiGroen1();
	this.instance_25.setTransform(746,-138);

	this.instance_26 = new lib.ConfettiViolet2();
	this.instance_26.setTransform(466,407);

	this.instance_27 = new lib.ConfettiViolet1();
	this.instance_27.setTransform(96,-506);

	this.instance_28 = new lib.ConfettiGroen2();
	this.instance_28.setTransform(-486,-485);

	this.instance_29 = new lib.ConfettiGroen1();
	this.instance_29.setTransform(-971,-194);

	this.instance_30 = new lib.ConfettiGeel2_1();
	this.instance_30.setTransform(-556,432);

	this.instance_31 = new lib.ConfettiGeel1();
	this.instance_31.setTransform(303,-75);

	this.instance_32 = new lib.ConfettiBlauw2();
	this.instance_32.setTransform(886,-343);

	this.instance_33 = new lib.ConfettiBlauw1();
	this.instance_33.setTransform(341,157);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_33},{t:this.instance_32},{t:this.instance_31},{t:this.instance_30},{t:this.instance_29},{t:this.instance_28},{t:this.instance_27},{t:this.instance_26},{t:this.instance_25},{t:this.instance_24},{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConfettiOverlay, new cjs.Rectangle(-1039,-506,2003,1043), null);


(lib.blue = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.DialogScr_CharacterProfile_BG3();
	this.instance.setTransform(0,-58);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.blue, new cjs.Rectangle(0,-58,116,116), null);


(lib.c02_over = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.c02_hub_tile_over();
	this.instance.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.c02_over, new cjs.Rectangle(-1120,-540,2240,1080), null);


(lib.SendDisabled = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Dialog_Chat_Send_button_Up3();
	this.instance.setTransform(-91,-91);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SendDisabled, new cjs.Rectangle(-91,-91,181,181), null);


(lib.selectionText = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FE9625").s().p("Eg4UADLIAAmVMBwpAAAIAAGVg");
	this.shape.setTransform(360.5,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.selectionText, new cjs.Rectangle(0,-20.2,721,40.5), null);


(lib.PulseRing = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().ls(["#FF5E00","#FFC444"],[0,1],-92.7,0,92.8,0).ss(5,1,1).p("AOHAAQAAF1kJEKQkJEIl1AAQl2AAkIkIQkIkKAAl1QAAl1EIkJQEIkIF2AAQF1AAEJEIQEJEJAAF1g");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PulseRing, new cjs.Rectangle(-92.7,-92.7,185.5,185.5), null);


(lib.panelkort = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.CharacterFeedbackPanel_kort();
	this.instance.setTransform(-213,-210.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.panelkort, new cjs.Rectangle(-213,-210.5,426,421), null);


(lib.GameSavedNotificationPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textField
	this.textField = new cjs.Text("[Progressie opgeslagen! Dit tekstveld moet gevuld z.]", "22px 'JetBrains Mono'", "#FFFFFF");
	this.textField.name = "textField";
	this.textField.textAlign = "right";
	this.textField.lineHeight = 31;
	this.textField.lineWidth = 716;
	this.textField.parent = this;
	this.textField.setTransform(358.05,-14.55);
ranj.TextOffsetFixer.fix(this.textField);

	this.timeline.addTween(cjs.Tween.get(this.textField).wait(1));

	// Dialog_Chat_Action_Panel_png
	this.instance = new lib.GameSaved();
	this.instance.setTransform(-409,-58);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GameSavedNotificationPanel, new cjs.Rectangle(-409,-58,833,115), null);


(lib.chapterPanel_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.narrativeTextField = new cjs.Text("[Placeholder][Placeholder][Placeholder][Placeholder][Placeholder][Placeholder][Placeholder][Placeholder]]]]\n[Placeholder][Placeholder][Placeholder][Placeholder][Placeholder][Placeholder][Placeholder][Placeholder]]]]\n[Placeholder][Placeholder][Placeholder][Placeholder][Placeholder][Placeholder][Placeholder][Placeholder]]]]\n[Placeholder][Placeholder][Placeholder][Placeholder][Placeholder][Placeholder][Placeholder][Placeholder]]]]", "22px 'JetBrains Mono'", "#FFFFFF");
	this.narrativeTextField.name = "narrativeTextField";
	this.narrativeTextField.lineHeight = 31;
	this.narrativeTextField.lineWidth = 1413;
	this.narrativeTextField.parent = this;
	this.narrativeTextField.setTransform(-706.4,-63.1);
ranj.TextOffsetFixer.fix(this.narrativeTextField);

	this.timeline.addTween(cjs.Tween.get(this.narrativeTextField).wait(1));

	// Layer_1
	this.instance = new lib.chapterPanel();
	this.instance.setTransform(-744,-88);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.chapterPanel_1, new cjs.Rectangle(-744,-88,1488,180), null);


(lib.oranjebalk = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.CharacterFeedbackPanel_balkjeOranje();
	this.instance.setTransform(-165.5,-20.5);

	this.instance_1 = new lib.CharacterFeedbackPanel_balkjeGroen();
	this.instance_1.setTransform(-165.5,-20.5);

	this.instance_2 = new lib.CharacterFeedbackPanel_balkje_1();
	this.instance_2.setTransform(-166.5,-20.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.oranjebalk, new cjs.Rectangle(-166.5,-20.5,333,41), null);


(lib.OKdisabled = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.naamInvoerOK_up();
	this.instance.setTransform(-91,-90.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.OKdisabled, new cjs.Rectangle(-91,-90.5,181,181), null);


(lib.missionbriefingBg_blurred = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Con_BG_Dialog_01_Total_newBlurred();
	this.instance.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.missionbriefingBg_blurred, new cjs.Rectangle(-1120,-540,2240,1080), null);


(lib.IntroductionBg_blurred = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.Endframe();
	this.instance.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.IntroductionBg_blurred, new cjs.Rectangle(-1120,-540,2240,1080), null);


(lib.haakjeSluiten = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FE9625").s().p("AghCEIAAgXIAqAAIAAjZIgqAAIAAgXIBDAAIAAEHg");
	this.shape.setTransform(9.625,0.025);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.haakjeSluiten, new cjs.Rectangle(0,-20.4,20.8,40.9), null);


(lib.haakjeOpenen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FE9625").s().p("AghCEIAAkHIBDAAIAAAXIgqAAIAADZIAqAAIAAAXg");
	this.shape.setTransform(-9.625,0.025);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.haakjeOpenen, new cjs.Rectangle(-20.8,-20.4,20.8,40.9), null);


(lib.Greenbalkje = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.CharacterFeedbackPanel_balkjeGroen();
	this.instance.setTransform(-166,-19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-166,-19.5,332,39);


(lib.demoInput_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.inputText = new cjs.Text("Vul hier je demo code in", "24px 'JetBrains Mono'", "#FFFFFF");
	this.inputText.name = "inputText";
	this.inputText.textAlign = "center";
	this.inputText.lineHeight = 34;
	this.inputText.lineWidth = 739;
	this.inputText.parent = this;
	this.inputText.setTransform(-8.6,-19.7);
ranj.TextOffsetFixer.fix(this.inputText);

	this.timeline.addTween(cjs.Tween.get(this.inputText).wait(1));

	// Layer_2
	this.instance = new lib.demoInput();
	this.instance.setTransform(-427,-68);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.demoInput_1, new cjs.Rectangle(-427,-68,848,133), null);


(lib.arrowMoveOrange = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.pijlUp();
	this.instance.setTransform(-18.5,-27);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.arrowMoveOrange, new cjs.Rectangle(-18.5,-27,37,54), null);


(lib.arrowMoveGreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.pijlUpGreen();
	this.instance.setTransform(-18.5,-27);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.arrowMoveGreen, new cjs.Rectangle(-18.5,-27,37,54), null);


(lib.arrow_disabled = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.RightArrow_up();
	this.instance.setTransform(33.5,-42.5,1,1,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.arrow_disabled, new cjs.Rectangle(-33.5,-42.5,67,85), null);


(lib.Arrow_animate = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.pijltje();
	this.instance.setTransform(-29.5,-43);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Arrow_animate, new cjs.Rectangle(-29.5,-43,59,86), null);


(lib.armvoorFeedback = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.armvoor_feedback();
	this.instance.setTransform(142.7,-113.3,1.1759,1.1759,0,16.2718,-163.7282);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.armvoorFeedback, new cjs.Rectangle(-142.7,-172.2,285.4,344.5), null);


(lib.armachter_feedback_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.armachter_feedback();
	this.instance.setTransform(81.1,-163,1,1,0,-14.9983,165.0017);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.armachter_feedback_1, new cjs.Rectangle(-151.7,-163,303.5,326.1), null);


(lib.arm_down = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.armvoor();
	this.instance.setTransform(71.35,133.75,1,1,-169.5176);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.arm_down, new cjs.Rectangle(-114.5,-133.7,229,267.5), null);


(lib.GameStatusScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// messageTextField
	this.messageTextField = new cjs.Text("[Maintenance Maintenance Maintenance Maintenance Maintenance Maintenance \nMaintenance Maintenance Maintenance Maintenance Maintenance Maintenance \nMaintenance Maintenance Maintenance Maintenance Maintenance Maintenance ", "32px 'JetBrains Mono'", "#FFFFFF");
	this.messageTextField.name = "messageTextField";
	this.messageTextField.textAlign = "center";
	this.messageTextField.lineHeight = 44;
	this.messageTextField.lineWidth = 1389;
	this.messageTextField.parent = this;
	this.messageTextField.setTransform(0,293.75);
ranj.TextOffsetFixer.fix(this.messageTextField);

	this.timeline.addTween(cjs.Tween.get(this.messageTextField).wait(1));

	// bg
	this.instance = new lib.chapterPanel();
	this.instance.setTransform(-744,273);

	this.instance_1 = new lib.EndofGameScreen();
	this.instance_1.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GameStatusScreenSkin, new cjs.Rectangle(-1120.5,-540.5,2241,1081), null);


(lib.TrustUpIcon = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.instance = new lib.CharacterFeedbackHartje();
	this.instance.setTransform(-18.5,-16.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TrustUpIcon, new cjs.Rectangle(-18.5,-16.5,37,33), null);


(lib.TrustDownIcon = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.instance = new lib.CharacterFeedbackSmiley();
	this.instance.setTransform(-16.5,-16.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TrustDownIcon, new cjs.Rectangle(-16.5,-16.5,33,33), null);


(lib.GroupSpiritUpIcon = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.instance = new lib.CharacterFeedbackGroep();
	this.instance.setTransform(-22,-14.75,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GroupSpiritUpIcon, new cjs.Rectangle(-22,-14.7,44,29.5), null);


(lib.GroupSpiritDownIcon = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.instance = new lib.CharacterFeedbackSingle();
	this.instance.setTransform(-16,-16.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GroupSpiritDownIcon, new cjs.Rectangle(-16,-16.5,32,33), null);


(lib.DarkendOverlay = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(0,0,0,0.498)").s().p("Eiu/BUYMAAAiovMFd/AAAMAAACovg");
	this.shape.setTransform(-0.025,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DarkendOverlay, new cjs.Rectangle(-1120,-540,2240,1080), null);


(lib.OnboardingStepContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.onboardingPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// header
	this.contentTextField = new cjs.Text("He waar kan ik je mee helpen?????]]\nHe waar kan ik je mee helpen?????]]", "28px 'JetBrains Mono'", "#FE9625");
	this.contentTextField.name = "contentTextField";
	this.contentTextField.lineHeight = 39;
	this.contentTextField.lineWidth = 591;
	this.contentTextField.parent = this;
	this.contentTextField.setTransform(-307.75,-17.35);
ranj.TextOffsetFixer.fix(this.contentTextField);

	this.timeline.addTween(cjs.Tween.get(this.contentTextField).wait(1));

	// Layer_2
	this.instance = new lib.RobotInputPanel();
	this.instance.setTransform(-368,-73);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.onboardingPanel, new cjs.Rectangle(-368,-73,715,211), null);


(lib.DialogOutputField = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.contentText = new cjs.Text("PLACEHOLDER PLACEHOLDER PLACEHOLDERRRRRRRRRRRRRRRRRRRRRPRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRR", "22px 'JetBrains Mono'", "#FFFFFF");
	this.contentText.name = "contentText";
	this.contentText.lineHeight = 29;
	this.contentText.lineWidth = 1364;
	this.contentText.parent = this;
	this.contentText.setTransform(-486.1,-15.15);
ranj.TextOffsetFixer.fix(this.contentText);

	this.timeline.addTween(cjs.Tween.get(this.contentText).wait(1));

	// Layer_1
	this.instance = new lib.Dialog_Chat_Outputfield4();
	this.instance.setTransform(-511,-37);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DialogOutputField, new cjs.Rectangle(-511,-37,1416,73), null);


(lib.dialogDisabled_black = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Con_BG_Dialog_01_Total_disabled();
	this.instance.setTransform(-317,-247);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.dialogDisabled_black, new cjs.Rectangle(-317,-247,469,361), null);


(lib.Dialog_Action_Panel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.responseText = new cjs.Text("PLACEHOLDER PLACEHOLDER PLACEHOLDERRRRRRRRRRRRRR", "22px 'JetBrains Mono'", "#FFFFFF");
	this.responseText.name = "responseText";
	this.responseText.lineHeight = 31;
	this.responseText.lineWidth = 735;
	this.responseText.parent = this;
	this.responseText.setTransform(-367.45,-14.55);
ranj.TextOffsetFixer.fix(this.responseText);

	this.timeline.addTween(cjs.Tween.get(this.responseText).wait(1));

	// Layer_1
	this.instance = new lib.Dialog_Chat_Action_Panel3();
	this.instance.setTransform(-397,-36);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Dialog_Action_Panel, new cjs.Rectangle(-397,-36,795,72), null);


(lib.ConversationPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.responseText = new cjs.Text("PLACEHOLDER PLACEHOLDER PLACEHOLDERRRRR ", "22px 'JetBrains Mono'", "#FFFFFF");
	this.responseText.name = "responseText";
	this.responseText.lineHeight = 31;
	this.responseText.lineWidth = 590;
	this.responseText.parent = this;
	this.responseText.setTransform(-295.1,-14.55);
ranj.TextOffsetFixer.fix(this.responseText);

	this.instance = new lib.Dialog_panel3_blue();
	this.instance.setTransform(-326,-36);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.responseText}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationPanel, new cjs.Rectangle(-326,-36,652,71), null);


(lib.CharImageContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Square
	this.instance = new lib.npc_erik_1();
	this.instance.setTransform(-55,-55);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.CharImageContainer, new cjs.Rectangle(-55,-55,110,110), null);


(lib.ConversationButton_Primary_Up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("-PRIMARY-", "24px 'JetBrains Mono'", "#FFFFFF");
	this.textfield.name = "textfield";
	this.textfield.textAlign = "center";
	this.textfield.lineHeight = 34;
	this.textfield.lineWidth = 134;
	this.textfield.alpha = 0.80000000;
	this.textfield.parent = this;
	this.textfield.setTransform(0.5,-18.35);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// PRIMARY_png
	this.instance = new lib.PRIMARY();
	this.instance.setTransform(-139,-81);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationButton_Primary_Up, new cjs.Rectangle(-139,-81,277,161), null);


(lib.ConversationButton_Primary_Over = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("-PRIMARY-", "24px 'JetBrains Mono'", "#FFFFFF");
	this.textfield.name = "textfield";
	this.textfield.textAlign = "center";
	this.textfield.lineHeight = 34;
	this.textfield.lineWidth = 134;
	this.textfield.parent = this;
	this.textfield.setTransform(0,-18.85);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// PRIMARY_OVER_png
	this.instance = new lib.PRIMARY_OVER();
	this.instance.setTransform(-138.5,-80.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationButton_Primary_Over, new cjs.Rectangle(-138.5,-80.5,277,161), null);


(lib.ConversationButton_Primary_Down = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("-PRIMARY-", "24px 'JetBrains Mono'", "#FFFFFF");
	this.textfield.name = "textfield";
	this.textfield.textAlign = "center";
	this.textfield.lineHeight = 34;
	this.textfield.lineWidth = 134;
	this.textfield.alpha = 0.80000000;
	this.textfield.parent = this;
	this.textfield.setTransform(0.5,-18.35);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// PRIMARY_DOWN_png
	this.instance = new lib.PRIMARY_DOWN();
	this.instance.setTransform(-138.5,-80.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationButton_Primary_Down, new cjs.Rectangle(-138.5,-80.5,277,161), null);


(lib.ConversationButton_Primary_Disabled = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("-PRIMARY-", "24px 'JetBrains Mono'", "#FFFFFF");
	this.textfield.name = "textfield";
	this.textfield.textAlign = "center";
	this.textfield.lineHeight = 34;
	this.textfield.lineWidth = 134;
	this.textfield.alpha = 0.49803922;
	this.textfield.parent = this;
	this.textfield.setTransform(0.5,-18.35);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// PRIMARY_png
	this.instance = new lib.PRIMARY();
	this.instance.setTransform(-139,-81);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationButton_Primary_Disabled, new cjs.Rectangle(-139,-81,277,161), null);


(lib.ConversationReflectionScrollPane = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// outputTextField
	this.outputTextField = new cjs.Text("COACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT\nCOACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT\nCOACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT\nCOACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT\nCOACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT\nCOACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT\nCOACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT\nCOACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT", "26px 'JetBrains Mono'", "#FFFFFF");
	this.outputTextField.name = "outputTextField";
	this.outputTextField.lineHeight = 36;
	this.outputTextField.lineWidth = 1033;
	this.outputTextField.parent = this;
	this.outputTextField.setTransform(2,2);
ranj.TextOffsetFixer.fix(this.outputTextField);

	this.timeline.addTween(cjs.Tween.get(this.outputTextField).wait(1));

	// divTextField
	this.divTextField = new cjs.Text("------------------------------------------------------------------", "26px 'JetBrains Mono'", "#FE9625");
	this.divTextField.name = "divTextField";
	this.divTextField.lineHeight = 36;
	this.divTextField.lineWidth = 1031;
	this.divTextField.parent = this;
	this.divTextField.setTransform(2,285.2);
ranj.TextOffsetFixer.fix(this.divTextField);

	this.timeline.addTween(cjs.Tween.get(this.divTextField).wait(1));

	// aiCoachTextField
	this.aiCoachTextField = new cjs.Text("COACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT\nCOACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT\nCOACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT\nCOACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT\nCOACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT\nCOACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT\nCOACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT\nCOACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT AI COACH TEXT", "26px 'JetBrains Mono'", "#FE9625");
	this.aiCoachTextField.name = "aiCoachTextField";
	this.aiCoachTextField.lineHeight = 36;
	this.aiCoachTextField.lineWidth = 1031;
	this.aiCoachTextField.parent = this;
	this.aiCoachTextField.setTransform(2,316.4);
ranj.TextOffsetFixer.fix(this.aiCoachTextField);

	this.timeline.addTween(cjs.Tween.get(this.aiCoachTextField).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationReflectionScrollPane, new cjs.Rectangle(-1,-1,1038,608.8), null);


(lib.ConversationPreviewBackgroundImageContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.instance = new lib.mission_briefing_background();
	this.instance.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationPreviewBackgroundImageContainer, new cjs.Rectangle(-1120,-540,2240,1080), null);


(lib.ChapterIntroductionImageContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.instance = new lib.ChapterScreen_BGHst01();
	this.instance.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChapterIntroductionImageContainer, new cjs.Rectangle(-1120,-540,2240,1080), null);


(lib.ConversationTeaserPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// descriptionTextField
	this.descriptionTextField = new cjs.Text("[Description][Description][Descript]\n[Description][Description][Descript]\n[Description][Description][Descript]", "24px 'JetBrains Mono'", "#FFFFFF");
	this.descriptionTextField.name = "descriptionTextField";
	this.descriptionTextField.textAlign = "center";
	this.descriptionTextField.lineHeight = 34;
	this.descriptionTextField.lineWidth = 615;
	this.descriptionTextField.parent = this;
	this.descriptionTextField.setTransform(0.55,-4.5);
ranj.TextOffsetFixer.fix(this.descriptionTextField);

	this.timeline.addTween(cjs.Tween.get(this.descriptionTextField).wait(1));

	// titleTextField
	this.titleTextField = new cjs.Text("[Title]", "36px 'JetBrains Mono'", "#FFFFFF");
	this.titleTextField.name = "titleTextField";
	this.titleTextField.textAlign = "center";
	this.titleTextField.lineHeight = 50;
	this.titleTextField.lineWidth = 614;
	this.titleTextField.parent = this;
	this.titleTextField.setTransform(1,-69.85);
ranj.TextOffsetFixer.fix(this.titleTextField);

	this.timeline.addTween(cjs.Tween.get(this.titleTextField).wait(1));

	// Layer_4
	this.instance = new lib.Con_panel_Dialog_01_over();
	this.instance.setTransform(-333,-94);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationTeaserPanel, new cjs.Rectangle(-333,-94,666,231), null);


(lib.con_05_over = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.c05_hub_tile_over();
	this.instance.setTransform(-76,-166);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.con_05_over, new cjs.Rectangle(-76,-166,2240,1080), null);


(lib.con_04_over = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.c04_hub_tile_over();
	this.instance.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.con_04_over, new cjs.Rectangle(-1120,-540,2240,1080), null);


(lib.con_03_over = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.c03_hub_tile_over();
	this.instance.setTransform(-1117,-561);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.con_03_over, new cjs.Rectangle(-1117,-561,2240,1080), null);


(lib.con_02_over = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.c02_hub_tile_over();
	this.instance.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.con_02_over, new cjs.Rectangle(-1120,-540,2240,1080), null);


(lib.con_01_over = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.c01_hub_tile_over();
	this.instance.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.con_01_over, new cjs.Rectangle(-1120,-540,2240,1080), null);


(lib.ChapterHubScreen_hitarea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(0,0,0,0.008)").s().p("Eg+qBNrMAAAibVMB9VAAAMAAACbVg");
	this.shape.setTransform(0,88.15);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChapterHubScreen_hitarea, new cjs.Rectangle(-401.1,-409,802.2,994.3), null);


(lib.ConversationScrollBarDragButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FE9625").s().p("AhLELIAAoVICXAAIAAIVg");
	this.shape.setTransform(-0.9,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationScrollBarDragButton, new cjs.Rectangle(-8.4,-26.7,15.100000000000001,53.4), null);


(lib.ConversationScrollBarDragArea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(254,150,37,0.2)").s().p("EgBKAv5MAAAhfyICVAAMAAABfyg");
	this.shape.setTransform(7.525,306.55);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationScrollBarDragArea, new cjs.Rectangle(0,0,15.1,613.1), null);


(lib.conversation_Bg_Dialog01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.Con_BG_Dialog02();
	this.instance.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.conversation_Bg_Dialog01, new cjs.Rectangle(-1120,-540,2240,1080), null);


(lib.roboGuru_Pulse = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_23 = function() {
		this.stop()
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(23).call(this.frame_23).wait(1));

	// Layer_1
	this.instance = new lib.roboGuru_knipper("synched",0);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:0.9106,scaleY:0.9106,rotation:-1.9773,startPosition:3},3).to({scaleX:0.9701,scaleY:0.9701,rotation:6.999,startPosition:13},10).to({scaleX:1,scaleY:1,rotation:0,startPosition:23},10).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-74.9,-62.1,149.9,124.30000000000001);


(lib.roboGuru_Onboarding_Select_ani = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_62 = function() {
		this.stop()
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(62).call(this.frame_62).wait(1));

	// Layer_1
	this.instance = new lib.roboGuru_knipper_onboarding("synched",0);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:0.9106,scaleY:0.9106,rotation:-1.9773,startPosition:11},11).to({scaleX:1.0999,scaleY:1.0999,rotation:22.21,startPosition:24},13).to({rotation:18.2183,startPosition:30},6).to({startPosition:62},32).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-95.4,-86.3,191,172.7);


(lib.roboGuru_missionbrief = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_23 = function() {
		this.stop()
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(23).call(this.frame_23).wait(1));

	// Layer_1
	this.instance = new lib.roboGuru_mission();
	this.instance.setTransform(-72.2,1105.8,0.9999,0.9999,-40.2632,0,0,-0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:0,regY:0,scaleX:1,scaleY:1,rotation:0,x:-64.2,y:0.05},11,cjs.Ease.cubicOut).to({regX:-0.1,rotation:-0.779,x:-64.35,y:48.05},6,cjs.Ease.quadInOut).to({regX:0,rotation:0,x:-64.2,y:0.05},6,cjs.Ease.quadInOut).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1223.3,-863.4,2302.3,3130.3);


(lib.roboGuru_Down = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_23 = function() {
		this.stop()
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(23).call(this.frame_23).wait(1));

	// Layer_1
	this.instance = new lib.roboGuru_knipper("synched",0);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:0.9106,scaleY:0.9106,rotation:-1.9773,startPosition:3},3).to({scaleX:1.1,scaleY:1.1,rotation:16.9984,startPosition:13},10).to({scaleX:1.078,scaleY:1.078,rotation:14.998,startPosition:23},10).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-92.6,-81.5,185.3,163);


(lib.RobbyHeadEnd = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.eyesRobby("synched",0);
	this.instance.setTransform(-112.1,-10.6,1,0.1924);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({x:-111.25,y:-10.25},11).to({scaleY:0.9011,skewX:3.3162,x:-112.6,y:-39.1},10).to({regX:-0.5,regY:-0.1,scaleX:0.9985,scaleY:0.8208,skewX:1.7108,skewY:-1.3547,x:-113.45,y:-17},10).to({regX:-0.2,regY:-0.2,scaleX:1,scaleY:0.387,skewX:0.9827,skewY:0,x:-109.4,y:-3.8},7).to({regX:-0.5,regY:-0.1,scaleX:0.9985,scaleY:0.8208,skewX:1.7108,skewY:-1.3547,x:-113.45,y:-17},6).to({startPosition:0},21).to({regX:-0.1,scaleX:1,scaleY:0.7455,skewX:0.9851,skewY:0,x:-107.2,y:-28.2},14).to({scaleY:0.8989,skewX:0.9863,x:-105.45,y:-32.1},4).to({regX:-0.2,regY:0,scaleY:0.2069,skewX:0.9846,x:-107.25,y:-28.2},3).to({regX:-0.1,regY:-0.1,scaleY:0.7455,skewX:0.9851,x:-107.2},5).to({startPosition:0},66).to({scaleY:0.8989,skewX:0.9863,x:-105.45,y:-32.1},4).to({regX:-0.2,regY:0,scaleY:0.2069,skewX:0.9846,x:-107.25,y:-28.2},3).to({regX:-0.1,regY:-0.1,scaleY:0.7455,skewX:0.9851,x:-107.2},4).to({startPosition:0},122).to({_off:true},1).wait(510));

	// Layer_2
	this.instance_1 = new lib.AICoach_Robby_Feedback();
	this.instance_1.setTransform(-366,-291);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(290).to({_off:true},1).wait(510));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-366,-291,680,556);


(lib.RobbyHead = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.eyesRobby("synched",0);
	this.instance.setTransform(-121.5,-10,1,0.1924);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({startPosition:0},11).to({scaleY:1,y:-24},10).to({scaleY:0.8151},10).to({regX:-0.2,regY:0.1,scaleX:0.9985,scaleY:0.56,skewX:-4.4552,skewY:-1.3547,x:-119.8,y:-6.35},4).to({regX:0,regY:0,scaleX:1,scaleY:0.8151,skewX:0,skewY:0,x:-121.5,y:-24},4).to({regX:-0.1,regY:-0.1,scaleY:0.8989,skewX:0.9863,x:-121.6,y:-32.1},10).to({startPosition:0},20).wait(1));

	// Layer_2
	this.instance_1 = new lib.AICoach_Robby_Feedback();
	this.instance_1.setTransform(-366,-291);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(70));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-366,-291,680,556);


(lib.robby_popup_ani = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.instance = new lib.armvoorFeedback();
	this.instance.setTransform(-32.55,279.5,1,1,0,0,0,59,-57.2);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(12).to({regX:58.9,regY:-57.1,rotation:34.0649,x:-46.6,y:279.6},12).to({regY:-57.2,rotation:-29.9464,x:-14.45,y:279.55},11).to({regY:-57.3,scaleX:0.9999,scaleY:0.9999,rotation:10.0336,x:-30.75,y:279.6},11).to({regX:59,regY:-57.2,scaleX:1,scaleY:1,rotation:0,x:-32.55,y:279.5},23).wait(1));

	// Layer_2
	this.instance_1 = new lib.RobbyHead("synched",0);
	this.instance_1.setTransform(126.6,-38.75,0.9501,1,0,11.9972,-168.0029,0.1,0);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({regY:-0.1,scaleY:0.9999,skewX:6.6644,skewY:-173.3338,x:109.4,y:-58.95,startPosition:12},12).to({regY:-0.3,scaleX:0.9825,scaleY:0.9195,skewX:11.9076,skewY:-168.0913,x:119.45,y:-5.65,startPosition:23},11,cjs.Ease.cubicIn).to({regX:0.2,regY:-0.2,scaleX:1.0162,scaleY:0.9314,rotation:4.7192,skewX:0,skewY:0,x:145.35,y:3.35,startPosition:24},1).to({regY:0,scaleX:0.9999,scaleY:0.9999,rotation:16.5108,x:211.8,y:-43.45,startPosition:35},11).to({regY:-0.1,rotation:17.364,x:214.55,y:-17.6,startPosition:46},11).to({regX:0.1,regY:0.1,rotation:19.0712,x:219.75,y:-24.25,startPosition:69},23).wait(1));

	// Layer_1
	this.instance_2 = new lib.Robby_headless_feedback();
	this.instance_2.setTransform(415.1,210.45,1,1,0,14.9983,-165.0017);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(70));

	// Layer_4
	this.instance_3 = new lib.armachter_feedback_1();
	this.instance_3.setTransform(278.75,351.4,1,1,0,0,0,-50.4,-34.6);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(12).to({rotation:-50.0965,x:278.7,y:289.85},12).to({rotation:44.9988,x:256.7,y:351.45},11).to({regX:-50.2,scaleX:0.9999,scaleY:0.9999,rotation:-10.6878,x:285.05,y:336.05},11).to({regX:-50.4,scaleX:1,scaleY:1,rotation:0,x:278.75,y:351.4},23).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-342.1,-426.4,953.7,1090.9);


(lib.Robby_popup = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_69 = function() {
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(69).call(this.frame_69).wait(1));

	// Layer_1
	this.instance = new lib.robby_popup_ani("synched",0);
	this.instance.setTransform(47.85,802.3,0.964,0.964,16.7615,0,0,-0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:0,regY:0,scaleX:0.9517,scaleY:1.0418,rotation:0,skewY:-1.7052,x:0,y:0,startPosition:13},13).to({regX:0.1,regY:0.2,scaleX:1.0908,scaleY:0.8904,rotation:-3.9918,skewY:0,x:10.15,y:72.2,startPosition:25},12).to({regX:0,regY:0,scaleX:1,scaleY:1,rotation:-4.9852,x:1.95,y:-26.05,startPosition:39},14).to({rotation:-3.7051,x:2,y:-14.05,startPosition:58},19).to({startPosition:69},11).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-305.6,-438.3,910.1,1935.3999999999999);


(lib.pinpoint_popup = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_55 = function() {
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(55).call(this.frame_55).wait(1));

	// Layer_1
	this.instance = new lib.pinpoint_ALL();
	this.instance.setTransform(0,-17.75,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:1,scaleY:1,x:0.5,y:-18},15,cjs.Ease.none).to({regX:0.1,scaleX:1.155,scaleY:1.155,x:0.6,y:-20.7},10,cjs.Ease.none).to({regX:0,scaleX:1,scaleY:1,x:0.5,y:-18},7,cjs.Ease.quadOut).to({scaleX:0.945,scaleY:0.945,x:0.4,y:-16.95},8,cjs.Ease.quadOut).to({regX:0.1,regY:-0.1,scaleX:0.969,scaleY:0.969,x:0.6,y:-18.4},7,cjs.Ease.quadIn).to({regX:0,regY:0,scaleX:1,scaleY:1,x:0.5,y:-18},8,cjs.Ease.quadIn).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-79.2,-199.7,158.3,199.79999999999998);


(lib.Pinpoint_05on = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.pinpoint_popup("synched",55,false);
	this.instance.setTransform(0.5,-86.5,1,1,0,0,0,0,-86.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({regX:0.5,regY:-99.8,x:1,y:-99.8,alpha:0.9022},0).wait(1).to({alpha:0.8063},0).wait(1).to({alpha:0.7143},0).wait(1).to({alpha:0.628},0).wait(1).to({alpha:0.5486},0).wait(1).to({alpha:0.4767},0).wait(1).to({alpha:0.4124},0).wait(1).to({alpha:0.3555},0).wait(1).to({alpha:0.3053},0).wait(1).to({alpha:0.2613},0).wait(1).to({alpha:0.2226},0).wait(1).to({alpha:0.1888},0).wait(1).to({alpha:0.1592},0).wait(1).to({alpha:0.1334},0).wait(1).to({alpha:0.1108},0).wait(1).to({alpha:0.0912},0).wait(1).to({alpha:0.0741},0).wait(1).to({alpha:0.0593},0).wait(1).to({alpha:0.0465},0).wait(1).to({alpha:0.0356},0).wait(1).to({alpha:0.0264},0).wait(1).to({alpha:0.0186},0).wait(1).to({alpha:0.0122},0).wait(1).to({alpha:0.0071},0).wait(1).to({alpha:0.003},0).wait(1).to({regX:0,regY:-86.5,x:0.5,y:-86.5,alpha:0},0).to({_off:true},1).wait(3));

	// Layer_1
	this.instance_1 = new lib.pinpoint_ALL("single",5);
	this.instance_1.setTransform(0,-104.5,1,1,0,0,0,0,-86.5);
	this.instance_1.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1).to({regY:-68.5,y:-86.5,alpha:0.0978},0).wait(1).to({alpha:0.1937},0).wait(1).to({alpha:0.2857},0).wait(1).to({alpha:0.372},0).wait(1).to({alpha:0.4514},0).wait(1).to({alpha:0.5233},0).wait(1).to({alpha:0.5876},0).wait(1).to({alpha:0.6445},0).wait(1).to({alpha:0.6947},0).wait(1).to({alpha:0.7387},0).wait(1).to({alpha:0.7774},0).wait(1).to({alpha:0.8112},0).wait(1).to({alpha:0.8408},0).wait(1).to({alpha:0.8666},0).wait(1).to({alpha:0.8892},0).wait(1).to({alpha:0.9088},0).wait(1).to({alpha:0.9259},0).wait(1).to({alpha:0.9407},0).wait(1).to({alpha:0.9535},0).wait(1).to({alpha:0.9644},0).wait(1).to({alpha:0.9736},0).wait(1).to({alpha:0.9814},0).wait(1).to({alpha:0.9878},0).wait(1).to({alpha:0.9929},0).wait(1).to({alpha:0.997},0).wait(1).to({regY:-86.5,y:-104.5,alpha:1},0).to({_off:true},1).wait(3));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-69,-173,138,173);


(lib.Pinpoint_05done = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.pinpoint_ALL("single",10);
	this.instance.setTransform(0,-104.5,1,1,0,0,0,0,-86.5);
	this.instance.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance).to({alpha:1},29,cjs.Ease.quadOut).wait(1));

	// Layer_1
	this.instance_1 = new lib.pinpoint_ALL("single",5);
	this.instance_1.setTransform(0,-104.5,1,1,0,0,0,0,-86.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({alpha:0},29,cjs.Ease.quadOut).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-69,-173,138,173);


(lib.Pinpoint_04on = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.pinpoint_popup("synched",55,false);
	this.instance.setTransform(0.5,-86.5,1,1,0,0,0,0,-86.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({regX:0.5,regY:-99.8,x:1,y:-99.8,alpha:0.9017},0).wait(1).to({alpha:0.8054},0).wait(1).to({alpha:0.7131},0).wait(1).to({alpha:0.6264},0).wait(1).to({alpha:0.5466},0).wait(1).to({alpha:0.4743},0).wait(1).to({alpha:0.4098},0).wait(1).to({alpha:0.3526},0).wait(1).to({alpha:0.3022},0).wait(1).to({alpha:0.258},0).wait(1).to({alpha:0.2192},0).wait(1).to({alpha:0.1852},0).wait(1).to({alpha:0.1555},0).wait(1).to({alpha:0.1295},0).wait(1).to({alpha:0.1069},0).wait(1).to({alpha:0.0871},0).wait(1).to({alpha:0.07},0).wait(1).to({alpha:0.0551},0).wait(1).to({alpha:0.0423},0).wait(1).to({alpha:0.0313},0).wait(1).to({alpha:0.022},0).wait(1).to({alpha:0.0142},0).wait(1).to({regX:0,regY:-86.5,x:0.5,y:-86.5,alpha:0.0078},0).to({_off:true},1).wait(6));

	// Layer_1
	this.instance_1 = new lib.pinpoint_ALL("single",4);
	this.instance_1.setTransform(0,-104.5,1,1,0,0,0,0,-86.5);
	this.instance_1.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1).to({regY:-68.5,y:-86.5,alpha:0.0983},0).wait(1).to({alpha:0.1946},0).wait(1).to({alpha:0.2869},0).wait(1).to({alpha:0.3736},0).wait(1).to({alpha:0.4534},0).wait(1).to({alpha:0.5257},0).wait(1).to({alpha:0.5902},0).wait(1).to({alpha:0.6474},0).wait(1).to({alpha:0.6978},0).wait(1).to({alpha:0.742},0).wait(1).to({alpha:0.7808},0).wait(1).to({alpha:0.8148},0).wait(1).to({alpha:0.8445},0).wait(1).to({alpha:0.8705},0).wait(1).to({alpha:0.8931},0).wait(1).to({alpha:0.9129},0).wait(1).to({alpha:0.93},0).wait(1).to({alpha:0.9449},0).wait(1).to({alpha:0.9577},0).wait(1).to({alpha:0.9687},0).wait(1).to({alpha:0.978},0).wait(1).to({alpha:0.9858},0).wait(1).to({regY:-86.5,y:-104.5,alpha:0.9922},0).to({_off:true},1).wait(6));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-69,-173,138,173);


(lib.Pinpoint_04done = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.pinpoint_ALL("single",9);
	this.instance.setTransform(0,-104.5,1,1,0,0,0,0,-86.5);
	this.instance.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance).to({alpha:1},29,cjs.Ease.quadOut).wait(1));

	// Layer_1
	this.instance_1 = new lib.pinpoint_ALL("single",4);
	this.instance_1.setTransform(0,-104.5,1,1,0,0,0,0,-86.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({alpha:0},29,cjs.Ease.quadOut).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-69,-173,138,173);


(lib.Pinpoint_03on = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.pinpoint_popup("synched",55,false);
	this.instance.setTransform(0.5,-86.5,1,1,0,0,0,0,-86.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({regX:0.5,regY:-99.8,x:1,y:-99.8,alpha:0.9017},0).wait(1).to({alpha:0.8054},0).wait(1).to({alpha:0.7131},0).wait(1).to({alpha:0.6264},0).wait(1).to({alpha:0.5466},0).wait(1).to({alpha:0.4743},0).wait(1).to({alpha:0.4098},0).wait(1).to({alpha:0.3526},0).wait(1).to({alpha:0.3022},0).wait(1).to({alpha:0.258},0).wait(1).to({alpha:0.2192},0).wait(1).to({alpha:0.1852},0).wait(1).to({alpha:0.1555},0).wait(1).to({alpha:0.1295},0).wait(1).to({alpha:0.1069},0).wait(1).to({alpha:0.0871},0).wait(1).to({alpha:0.07},0).wait(1).to({alpha:0.0551},0).wait(1).to({alpha:0.0423},0).wait(1).to({alpha:0.0313},0).wait(1).to({alpha:0.022},0).wait(1).to({alpha:0.0142},0).wait(1).to({regX:0,regY:-86.5,x:0.5,y:-86.5,alpha:0.0078},0).to({_off:true},1).wait(6));

	// Layer_1
	this.instance_1 = new lib.pinpoint_ALL("single",3);
	this.instance_1.setTransform(0,-104.5,1,1,0,0,0,0,-86.5);
	this.instance_1.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1).to({regY:-68.5,y:-86.5,alpha:0.0983},0).wait(1).to({alpha:0.1946},0).wait(1).to({alpha:0.2869},0).wait(1).to({alpha:0.3736},0).wait(1).to({alpha:0.4534},0).wait(1).to({alpha:0.5257},0).wait(1).to({alpha:0.5902},0).wait(1).to({alpha:0.6474},0).wait(1).to({alpha:0.6978},0).wait(1).to({alpha:0.742},0).wait(1).to({alpha:0.7808},0).wait(1).to({alpha:0.8148},0).wait(1).to({alpha:0.8445},0).wait(1).to({alpha:0.8705},0).wait(1).to({alpha:0.8931},0).wait(1).to({alpha:0.9129},0).wait(1).to({alpha:0.93},0).wait(1).to({alpha:0.9449},0).wait(1).to({alpha:0.9577},0).wait(1).to({alpha:0.9687},0).wait(1).to({alpha:0.978},0).wait(1).to({alpha:0.9858},0).wait(1).to({regY:-86.5,y:-104.5,alpha:0.9922},0).to({_off:true},1).wait(6));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-69,-173,138,173);


(lib.Pinpoint_03done = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.pinpoint_ALL("single",8);
	this.instance.setTransform(0,-104.5,1,1,0,0,0,0,-86.5);
	this.instance.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance).to({alpha:1},29,cjs.Ease.none).wait(1));

	// Layer_1
	this.instance_1 = new lib.pinpoint_ALL("single",3);
	this.instance_1.setTransform(0,-104.5,1,1,0,0,0,0,-86.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({alpha:0},29,cjs.Ease.none).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-69,-173,138,173);


(lib.Pinpoint_02on = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.pinpoint_popup("synched",55,false);
	this.instance.setTransform(0.5,-86.5,1,1,0,0,0,0,-86.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({regX:0.5,regY:-99.8,x:1,y:-99.8,alpha:0.9024},0).wait(1).to({alpha:0.8067},0).wait(1).to({alpha:0.7149},0).wait(1).to({alpha:0.6288},0).wait(1).to({alpha:0.5495},0).wait(1).to({alpha:0.4778},0).wait(1).to({alpha:0.4136},0).wait(1).to({alpha:0.3568},0).wait(1).to({alpha:0.3067},0).wait(1).to({alpha:0.2628},0).wait(1).to({alpha:0.2242},0).wait(1).to({alpha:0.1905},0).wait(1).to({alpha:0.161},0).wait(1).to({alpha:0.1352},0).wait(1).to({alpha:0.1127},0).wait(1).to({alpha:0.093},0).wait(1).to({alpha:0.076},0).wait(1).to({alpha:0.0612},0).wait(1).to({alpha:0.0485},0).wait(1).to({alpha:0.0376},0).wait(1).to({alpha:0.0284},0).wait(1).to({alpha:0.0206},0).wait(1).to({alpha:0.0143},0).wait(1).to({alpha:0.0091},0).wait(1).to({alpha:0.0051},0).wait(1).to({alpha:0.0021},0).wait(1).to({regX:0,regY:-86.5,x:0.5,y:-86.5,alpha:0},0).to({_off:true},1).wait(2));

	// Layer_1
	this.instance_1 = new lib.pinpoint_ALL("single",2);
	this.instance_1.setTransform(0,-104.5,1,1,0,0,0,0,-86.5);
	this.instance_1.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1).to({regY:-68.5,y:-86.5,alpha:0.0976},0).wait(1).to({alpha:0.1933},0).wait(1).to({alpha:0.2851},0).wait(1).to({alpha:0.3712},0).wait(1).to({alpha:0.4505},0).wait(1).to({alpha:0.5222},0).wait(1).to({alpha:0.5864},0).wait(1).to({alpha:0.6432},0).wait(1).to({alpha:0.6933},0).wait(1).to({alpha:0.7372},0).wait(1).to({alpha:0.7758},0).wait(1).to({alpha:0.8095},0).wait(1).to({alpha:0.839},0).wait(1).to({alpha:0.8648},0).wait(1).to({alpha:0.8873},0).wait(1).to({alpha:0.907},0).wait(1).to({alpha:0.924},0).wait(1).to({alpha:0.9388},0).wait(1).to({alpha:0.9515},0).wait(1).to({alpha:0.9624},0).wait(1).to({alpha:0.9716},0).wait(1).to({alpha:0.9794},0).wait(1).to({alpha:0.9857},0).wait(1).to({alpha:0.9909},0).wait(1).to({alpha:0.9949},0).wait(1).to({alpha:0.9979},0).wait(1).to({regY:-86.5,y:-104.5,alpha:1},0).to({_off:true},1).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-69,-173,138,173);


(lib.Pinpoint_02done = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.pinpoint_ALL("single",7);
	this.instance.setTransform(0,-104.5,1,1,0,0,0,0,-86.5);
	this.instance.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance).to({alpha:1},29,cjs.Ease.quadOut).wait(1));

	// Layer_1
	this.instance_1 = new lib.pinpoint_ALL("single",2);
	this.instance_1.setTransform(0,-104.5,1,1,0,0,0,0,-86.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({alpha:0},29,cjs.Ease.quadOut).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-69,-173,138,173);


(lib.Pinpoint_01on = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.pinpoint_popup("synched",55,false);
	this.instance.setTransform(0.5,-86.5,1,1,0,0,0,0,-86.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({alpha:0},29,cjs.Ease.cubicOut).wait(1));

	// Layer_1
	this.instance_1 = new lib.pinpoint_ALL("single",1);
	this.instance_1.setTransform(0,-104.5,1,1,0,0,0,0,-86.5);
	this.instance_1.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({alpha:1},29,cjs.Ease.cubicOut).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-69,-173,138,173);


(lib.Pinpoint_01done = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.pinpoint_ALL("single",6);
	this.instance.setTransform(0,-104.5,1,1,0,0,0,0,-86.5);
	this.instance.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance).to({alpha:1},29,cjs.Ease.quadOut).wait(1));

	// Layer_1
	this.instance_1 = new lib.pinpoint_ALL("single",1);
	this.instance_1.setTransform(0,-104.5,1,1,0,0,0,0,-86.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({alpha:0},29,cjs.Ease.quadOut).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-69,-173,138,173);


(lib.TrustMeter = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("A2kDGQhUAAg8g5Qg6g7gBhSQABhRA6g6QA8g6BUAAMAtIAAAQBVAAA7A6QA7A6ABBRQgBBSg7A7Qg7A5hVAAg");
	mask.setTransform(0,-0.75);

	// Layer_2
	this.instance = new lib.Greenbalkje("synched",0);
	this.instance.setTransform(-331,-1);

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).to({x:-0.5,y:-0.25},100).wait(1));

	// Layer_1
	this.instance_1 = new lib.CharacterFeedbackPanel_balkje();
	this.instance_1.setTransform(-167,-21);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(101));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-167,-21,333,41);


(lib.groupMeter = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("A2kDGQhUAAg8g5Qg6g7gBhSQABhRA6g6QA8g6BUAAMAtIAAAQBVAAA7A6QA7A6ABBRQgBBSg7A7Qg7A5hVAAg");
	mask.setTransform(0,-0.75);

	// Layer_1
	this.instance = new lib.oranjebalk();
	this.instance.setTransform(-331.25,-0.05);

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).to({x:0,y:0.5},100).wait(1));

	// Layer_4
	this.instance_1 = new lib.CharacterFeedbackPanel_balkje();
	this.instance_1.setTransform(-167,-21);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(101));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-167,-21,333,41);


(lib.mapPoint = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.pointWhite();
	this.instance.setTransform(0,0,0.1,0.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({scaleX:1,scaleY:1},11,cjs.Ease.quadIn).to({scaleX:1.25,scaleY:1.25},10,cjs.Ease.quadOut).to({scaleX:1,scaleY:1},10,cjs.Ease.quadIn).to({scaleX:0.9604,scaleY:0.9604},7,cjs.Ease.quadOut).to({scaleX:1,scaleY:1},7,cjs.Ease.quadIn).wait(91));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-29.3,-18.1,58.7,36.3);


(lib.glowcircleMeter = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.glowcircle();
	this.instance.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance).to({alpha:1},100).wait(1).to({_off:true},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-469,-469,938,938);


(lib.download_pdf = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Tween1("synched",0);

	this.instance_1 = new lib.Tween2("synched",0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},59).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true,rotation:360},59).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-30.4,-30.4,60.8,60.8);


(lib.Conversation_05_hoverGlow = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.con_05_over();
	this.instance.setTransform(-1044,-374);
	this.instance.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance).to({alpha:1},59).to({alpha:0},60).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1120,-540,2240,1080);


(lib.Conversation_04_hoverGlow = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.con_04_over();
	this.instance.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance).to({alpha:1},59,cjs.Ease.quadOut).to({alpha:0},60,cjs.Ease.quadIn).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1120,-540,2240,1080);


(lib.Conversation_03_hoverGlow = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.con_03_over();
	this.instance.setTransform(-1,-1);
	this.instance.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance).to({x:1,alpha:1},59).to({x:0,y:0,alpha:0},60).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1118,-562,2242,1081);


(lib.Conversation_02_hoverGlow = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.con_02_over();
	this.instance.setTransform(2,0);
	this.instance.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance).to({alpha:1},59).to({alpha:0},60).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1118,-540,2240,1080);


(lib.Conversation_01_hoverGlow = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.con_01_over();
	this.instance.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance).to({alpha:1},59).to({alpha:0},60).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1120,-540,2240,1080);


(lib.NameOK_Button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// DisabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("OK", "30px 'JetBrains Mono'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 42;
	this.disabledLabelTextField.lineWidth = 39;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-1,-21.9);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// DownLabelTextField
	this.downLabelTextField = new cjs.Text("OK", "30px 'JetBrains Mono'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 42;
	this.downLabelTextField.lineWidth = 39;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-1,-21.9);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("OK", "30px 'JetBrains Mono'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 42;
	this.overLabelTextField.lineWidth = 39;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-1,-21.9);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("OK", "30px 'JetBrains Mono'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 42;
	this.upLabelTextField.lineWidth = 39;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-1,-21.9);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Layer_4
	this.instance = new lib.OKdisabled();
	this.instance.setTransform(0,-0.5);

	this.instance_1 = new lib.naamInvoerOK_over();
	this.instance_1.setTransform(-91,-91);

	this.instance_2 = new lib.naamInvoerOK_down();
	this.instance_2.setTransform(-91,-91);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance,p:{alpha:1}}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance,p:{alpha:0.5}}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-91,-91,181,181);


(lib.nameInputPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.sendButton = new lib.NameOK_Button();
	this.sendButton.name = "sendButton";
	this.sendButton.setTransform(336,3.5);

	this.inputText = new cjs.Text("[Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum", "22px 'JetBrains Mono'", "#FFFFFF");
	this.inputText.name = "inputText";
	this.inputText.lineHeight = 31;
	this.inputText.lineWidth = 639;
	this.inputText.parent = this;
	this.inputText.setTransform(-379.3,-21.7);
ranj.TextOffsetFixer.fix(this.inputText);

	this.instance = new lib.naamInvoerPanel();
	this.instance.setTransform(-427,-71.55);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.inputText},{t:this.sendButton}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.nameInputPanel, new cjs.Rectangle(-427,-87.5,853,181), null);


(lib.Introduction_BG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_14 = function() {
		this.stop()
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(14).call(this.frame_14).wait(1));

	// Layer_2
	this.instance = new lib.IntroductionBg_blurred();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(15));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1120,-540,2240,1080);


(lib.ArrowAnimation_orange = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_119 = function() {
		this.stop()
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(119).call(this.frame_119).wait(1));

	// Layer_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("AjqFUIAAqnIHVAAIAAKng");
	mask.setTransform(0.55,-5.35);

	// Layer_4
	this.instance = new lib.arrowMoveOrange();
	this.instance.setTransform(0,44);
	this.instance._off = true;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(60).to({_off:false},0).to({y:0},59).wait(1));

	// Layer_3
	this.instance_1 = new lib.arrowMoveOrange();

	var maskedShapeInstanceList = [this.instance_1];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({y:-58},59).to({_off:true},1).wait(60));

	// Layer_1
	this.instance_2 = new lib.arrowMoveOrange();
	this.instance_2.setTransform(0,57.5);

	var maskedShapeInstanceList = [this.instance_2];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({y:0},59).to({y:-59},60).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-18.5,-39.3,37,68);


(lib.ArrowAnimation_green = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_119 = function() {
		this.stop()
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(119).call(this.frame_119).wait(1));

	// Layer_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("AjqFUIAAqnIHVAAIAAKng");
	mask.setTransform(0.55,-5.6);

	// Layer_4
	this.instance = new lib.arrowMoveGreen();
	this.instance.setTransform(0,44);
	this.instance._off = true;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(60).to({_off:false},0).to({y:0},59).wait(1));

	// Layer_3
	this.instance_1 = new lib.arrowMoveGreen();

	var maskedShapeInstanceList = [this.instance_1];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({y:-58},59).to({_off:true},1).wait(60));

	// Layer_1
	this.instance_2 = new lib.arrowMoveGreen();
	this.instance_2.setTransform(0,57.5);

	var maskedShapeInstanceList = [this.instance_2];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({y:0},59).to({y:-59},60).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-18.5,-39.6,37,68);


(lib.arrow = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Arrow_animate();
	this.instance.setTransform(0,-80);
	this.instance.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:0,alpha:1},50).to({y:24,alpha:0},51).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-29.5,-123,59,190);


(lib.armzwaai = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.handzwaai();
	this.instance.setTransform(-42.65,-60.3,1,1,20.4644,0,0,23.6,66.4);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:23.5,regY:66.3,rotation:-9.9359,x:-37.2,y:-62.9},14).to({regX:23.6,rotation:-45,x:-35.65,y:-66.55},16).to({regX:23.5,rotation:-9.9359,x:-37.2,y:-62.9},14).to({regX:23.6,regY:66.4,rotation:20.4644,x:-42.65,y:-60.3},15).wait(1));

	// Layer_1
	this.instance_1 = new lib.armvoor_zwaai();
	this.instance_1.setTransform(133.95,-34.3,1,1,0,23.2868,-156.7132);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(60));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-237,-256.8,371,377.8);


(lib.OnboardingStepScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// onboardingStepContainer
	this.onboardingStepContainer = new lib.OnboardingStepContainer();
	this.onboardingStepContainer.name = "onboardingStepContainer";

	this.timeline.addTween(cjs.Tween.get(this.onboardingStepContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.OnboardingStepScreenSkin, new cjs.Rectangle(-1120.5,-540.5,2241,1081), null);


(lib.GameSavedNotificationOverlayScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// notificationPanel
	this.notificationPanel = new lib.GameSavedNotificationPanel();
	this.notificationPanel.name = "notificationPanel";
	this.notificationPanel.setTransform(494.65,-427);

	this.timeline.addTween(cjs.Tween.get(this.notificationPanel).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GameSavedNotificationOverlayScreenSkin, new cjs.Rectangle(-1120.5,-540.5,2241,1081), null);


(lib.DownloadPdfButtonUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// buttonText
	this.textfield = new cjs.Text("DOWNLOAD JOUW INZICHTEN", "28px 'JetBrains Mono'", "#FFFFFF");
	this.textfield.name = "textfield";
	this.textfield.textAlign = "center";
	this.textfield.lineHeight = 39;
	this.textfield.lineWidth = 391;
	this.textfield.parent = this;
	this.textfield.setTransform(22.55,-23.45);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// icon
	this.icon = new lib.DownloadIconUp();
	this.icon.name = "icon";
	this.icon.setTransform(-207.5,-7);

	this.timeline.addTween(cjs.Tween.get(this.icon).wait(1));

	// downloadButton_png
	this.instance = new lib.downloadButton();
	this.instance.setTransform(-297,-86);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DownloadPdfButtonUp, new cjs.Rectangle(-297,-86,594,167), null);


(lib.DownloadPdfButtonOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// buttonText
	this.textfield = new cjs.Text("DOWNLOAD JOUW INZICHTEN", "28px 'JetBrains Mono'", "#FFFFFF");
	this.textfield.name = "textfield";
	this.textfield.textAlign = "center";
	this.textfield.lineHeight = 39;
	this.textfield.lineWidth = 391;
	this.textfield.parent = this;
	this.textfield.setTransform(22.55,-21.45);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// icon
	this.icon = new lib.DownloadIconDown();
	this.icon.name = "icon";
	this.icon.setTransform(-207.5,-4);

	this.timeline.addTween(cjs.Tween.get(this.icon).wait(1));

	// downloadButton_png
	this.instance = new lib.Download_over();
	this.instance.setTransform(-297,-84);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DownloadPdfButtonOver, new cjs.Rectangle(-297,-84,594,167), null);


(lib.DownloadPdfButtonDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// buttonText
	this.textfield = new cjs.Text("DOWNLOAD JOUW INZICHTEN", "28px 'JetBrains Mono'", "#FFFFFF");
	this.textfield.name = "textfield";
	this.textfield.textAlign = "center";
	this.textfield.lineHeight = 39;
	this.textfield.lineWidth = 391;
	this.textfield.parent = this;
	this.textfield.setTransform(22.55,-20.95);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// icon
	this.icon = new lib.DownloadIconDown();
	this.icon.name = "icon";
	this.icon.setTransform(-207.5,-3.5);

	this.timeline.addTween(cjs.Tween.get(this.icon).wait(1));

	// downloadButton_png
	this.instance = new lib.downloadButton();
	this.instance.setTransform(-297,-83.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DownloadPdfButtonDown, new cjs.Rectangle(-297,-83.5,594,167), null);


(lib.DownloadPdfButtonDisabled = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// buttonText
	this.textfield = new cjs.Text("DOWNLOAD JOUW INZICHTEN", "28px 'JetBrains Mono'", "#FFFFFF");
	this.textfield.name = "textfield";
	this.textfield.textAlign = "center";
	this.textfield.lineHeight = 39;
	this.textfield.lineWidth = 391;
	this.textfield.parent = this;
	this.textfield.setTransform(22.55,-21.45);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// icon
	this.downloadPdf = new lib.download_pdf();
	this.downloadPdf.name = "downloadPdf";
	this.downloadPdf.setTransform(-208.5,-3.5);

	this.timeline.addTween(cjs.Tween.get(this.downloadPdf).wait(1));

	// downloadButton_png
	this.instance = new lib.downloadButton();
	this.instance.setTransform(-297,-84);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DownloadPdfButtonDisabled, new cjs.Rectangle(-297,-84,594,167), null);


(lib.profilePicture = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// border
	this.instance = new lib.DialogScr_CharacterProfile_broder2();
	this.instance.setTransform(-60,-58);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// mask_idn (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("AlkIxQjIAAgEjEIAArRQAAjMDMAAILJAAQDMAAAADMIAALRQgEDEjIAAg");
	mask.setTransform(-2.05,0.25);

	// profile_image
	this.charImageContainer = new lib.CharImageContainer();
	this.charImageContainer.name = "charImageContainer";
	this.charImageContainer.setTransform(-2.1,0.25);

	var maskedShapeInstanceList = [this.charImageContainer];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.charImageContainer).wait(1));

	// Layer_2
	this.instance_1 = new lib.blue();
	this.instance_1.setTransform(-2,0,1,1,0,0,0,58,0);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// nameTextField
	this.nameTextField = new cjs.Text("EUGENE", "32px 'JetBrains Mono'", "#FFFFFF");
	this.nameTextField.name = "nameTextField";
	this.nameTextField.textAlign = "center";
	this.nameTextField.lineHeight = 44;
	this.nameTextField.lineWidth = 268;
	this.nameTextField.parent = this;
	this.nameTextField.setTransform(-2.5,64.05);
ranj.TextOffsetFixer.fix(this.nameTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameTextField).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.profilePicture, new cjs.Rectangle(-138.7,-58,272.5,166.3), null);


(lib.Dialog_pulseRing_animationTimmer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_45 = function() {
		this.stop()
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(45).call(this.frame_45).wait(1));

	// Layer_4
	this.instance = new lib.PulseRing();
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(13).to({_off:false},0).to({scaleX:1.3062,scaleY:1.3062,alpha:0},19).to({_off:true},1).wait(13));

	// Layer_5
	this.instance_1 = new lib.PulseRing();
	this.instance_1.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({alpha:1},3).wait(29).to({alpha:0},13).wait(1));

	// Layer_1
	this.instance_2 = new lib.PulseRing();
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(3).to({_off:false},0).to({scaleX:1.3062,scaleY:1.3062,alpha:0},18).to({_off:true},1).wait(24));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-133.1,-133.1,273,273);


(lib.Dialog_pulseRing_animation = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.instance = new lib.PulseRing();
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(11).to({_off:false},0).to({scaleX:1.3062,scaleY:1.3062,alpha:0},19).wait(1));

	// Layer_5
	this.instance_1 = new lib.PulseRing();

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(31));

	// Layer_1
	this.instance_2 = new lib.PulseRing();

	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({scaleX:1.3062,scaleY:1.3062,alpha:0},19).to({_off:true},1).wait(11));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-133.1,-133.1,273,273);


(lib.Dialog_Arrow_button_verder = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.instance = new lib.arrow_disabled();
	this.instance.setTransform(-0.5,-0.5,1,1,0,0,180);

	this.instance_1 = new lib.RightArrow_over();
	this.instance_1.setTransform(-34,-43);

	this.instance_2 = new lib.RightArrow_down();
	this.instance_2.setTransform(-34,-43);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance,p:{alpha:1}}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance,p:{alpha:0.5}}]},1).wait(1));

	// Layer_3
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(0,0,0,0.008)").s().p("Egr0An8MAAAhP3MBXqAAAMAAABP3g");
	this.shape.setTransform(-29.45,-3.425);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-310,-259,561.1,511.2);


(lib.Dialog_Arrow_button_terug = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.instance = new lib.arrow_disabled();
	this.instance.setTransform(-0.5,-0.5);

	this.instance_1 = new lib.RightArrow_over();
	this.instance_1.setTransform(33,-43,1,1,0,0,180);

	this.instance_2 = new lib.RightArrow_down();
	this.instance_2.setTransform(33,-43,1,1,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance,p:{alpha:1}}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance,p:{alpha:0.5}}]},1).wait(1));

	// Layer_3
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(0,0,0,0.008)").s().p("Egr1An8MAAAhP3MBXqAAAMAAABP3g");
	this.shape.setTransform(10.55,-3.425);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-270,-259,561.1,511.2);


(lib.Conversation_SendButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.instance = new lib.Dialog_Chat_Send_button_Up3();
	this.instance.setTransform(-91,-91);

	this.instance_1 = new lib.Dialog_Chat_Send_button_Down3();
	this.instance_1.setTransform(-91,-91);

	this.instance_2 = new lib.Dialog_Chat_Send_button_Over3();
	this.instance_2.setTransform(-91,-91);

	this.instance_3 = new lib.SendDisabled();
	this.instance_3.setTransform(0.5,0.5);
	this.instance_3.alpha = 0.5;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-91,-91,181.5,181.5);


(lib.Con_05_Button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_5
	this.instance = new lib.con_05_over();
	this.instance.setTransform(-1044,-374);

	this.instance_1 = new lib.c05_hub_tile_disabled();
	this.instance_1.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance,p:{alpha:1}}]},1).to({state:[{t:this.instance,p:{alpha:0.8008}}]},1).to({state:[{t:this.instance_1}]},1).wait(1));

	// hitarea
	this.hitArea = new lib.ChapterHubScreen_hitarea();
	this.hitArea.name = "hitArea";
	this.hitArea.setTransform(-17,-45);

	this.timeline.addTween(cjs.Tween.get(this.hitArea).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1120,-540,2240,1080.3);


(lib.Con_04_Button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_5
	this.instance = new lib.con_04_over();

	this.instance_1 = new lib.c04_hub_tile_disabled();
	this.instance_1.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance,p:{alpha:1}}]},1).to({state:[{t:this.instance,p:{alpha:0.8008}}]},1).to({state:[{t:this.instance_1}]},1).wait(1));

	// hitarea
	this.hitArea = new lib.ChapterHubScreen_hitarea();
	this.hitArea.name = "hitArea";
	this.hitArea.setTransform(-17,-45);

	this.timeline.addTween(cjs.Tween.get(this.hitArea).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1120,-540,2240,1080.3);


(lib.Con_03_Button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_5
	this.instance = new lib.con_03_over();
	this.instance.setTransform(-3,21);

	this.instance_1 = new lib.c03_hub_tile_disabled();
	this.instance_1.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance,p:{alpha:1}}]},1).to({state:[{t:this.instance,p:{alpha:0.8008}}]},1).to({state:[{t:this.instance_1}]},1).wait(1));

	// hitarea
	this.hitArea = new lib.ChapterHubScreen_hitarea();
	this.hitArea.name = "hitArea";
	this.hitArea.setTransform(-17,-45);

	this.timeline.addTween(cjs.Tween.get(this.hitArea).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1120,-540,2240,1080.3);


(lib.Con_02_Button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_5
	this.instance = new lib.c02_over();

	this.instance_1 = new lib.c02_hub_tile_disabled();
	this.instance_1.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance,p:{alpha:1}}]},1).to({state:[{t:this.instance,p:{alpha:0.8008}}]},1).to({state:[{t:this.instance_1}]},1).wait(1));

	// Layer_4
	this.hitArea = new lib.ChapterHubScreen_hitarea();
	this.hitArea.name = "hitArea";
	this.hitArea.setTransform(-17,-45);

	this.timeline.addTween(cjs.Tween.get(this.hitArea).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1120,-540,2240,1080.3);


(lib.Con_01_Button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_5
	this.instance = new lib.con_01_over();
	this.instance.setTransform(-0.4,0);

	this.instance_1 = new lib.c01_hub_tile_disabled();
	this.instance_1.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance,p:{alpha:1}}]},1).to({state:[{t:this.instance,p:{alpha:0.8008}}]},1).to({state:[{t:this.instance_1}]},1).wait(1));

	// hitarea
	this.hitArea = new lib.ChapterHubScreen_hitarea();
	this.hitArea.name = "hitArea";
	this.hitArea.setTransform(-17,-45);

	this.timeline.addTween(cjs.Tween.get(this.hitArea).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1120.4,-540,2240.4,1080.3);


(lib.ConversationButton_Primary = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// up
	this.up = new lib.ConversationButton_Primary_Up();
	this.up.name = "up";
	this.up.setTransform(-0.5,-0.5);

	this.timeline.addTween(cjs.Tween.get(this.up).wait(1));

	// over
	this.over = new lib.ConversationButton_Primary_Over();
	this.over.name = "over";
	this.over.setTransform(-0.5,-0.5);

	this.timeline.addTween(cjs.Tween.get(this.over).wait(1));

	// down
	this.down = new lib.ConversationButton_Primary_Down();
	this.down.name = "down";
	this.down.setTransform(-0.5,-0.5);

	this.timeline.addTween(cjs.Tween.get(this.down).wait(1));

	// disabled
	this.disabled = new lib.ConversationButton_Primary_Disabled();
	this.disabled.name = "disabled";
	this.disabled.setTransform(-0.5,-0.5);

	this.timeline.addTween(cjs.Tween.get(this.disabled).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationButton_Primary, new cjs.Rectangle(-139.5,-81.5,277.5,161.5), null);


(lib.CharacterFeedbackPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// text
	this.groupSpiritUpIcon = new lib.GroupSpiritUpIcon();
	this.groupSpiritUpIcon.name = "groupSpiritUpIcon";
	this.groupSpiritUpIcon.setTransform(160,-27.25);

	this.groupSpiritDownIcon = new lib.GroupSpiritDownIcon();
	this.groupSpiritDownIcon.name = "groupSpiritDownIcon";
	this.groupSpiritDownIcon.setTransform(-161,-26.5);

	this.trustDownIcon = new lib.TrustDownIcon();
	this.trustDownIcon.name = "trustDownIcon";
	this.trustDownIcon.setTransform(-160.5,-138.5);

	this.trustUpIcon = new lib.TrustUpIcon();
	this.trustUpIcon.name = "trustUpIcon";
	this.trustUpIcon.setTransform(163.5,-138.5);

	this.groupLevelName = new cjs.Text("Groepsgevoel", "24px 'JetBrains Mono'", "#FFFFFF");
	this.groupLevelName.name = "groupLevelName";
	this.groupLevelName.textAlign = "center";
	this.groupLevelName.lineHeight = 34;
	this.groupLevelName.lineWidth = 268;
	this.groupLevelName.parent = this;
	this.groupLevelName.setTransform(-0.55,-43.7);
ranj.TextOffsetFixer.fix(this.groupLevelName);

	this.trustLevelName = new cjs.Text("Vertrouwen in jou", "24px 'JetBrains Mono'", "#FFFFFF");
	this.trustLevelName.name = "trustLevelName";
	this.trustLevelName.textAlign = "center";
	this.trustLevelName.lineHeight = 34;
	this.trustLevelName.lineWidth = 268;
	this.trustLevelName.parent = this;
	this.trustLevelName.setTransform(-0.55,-155.25);
ranj.TextOffsetFixer.fix(this.trustLevelName);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.trustLevelName},{t:this.groupLevelName},{t:this.trustUpIcon},{t:this.trustDownIcon},{t:this.groupSpiritDownIcon},{t:this.groupSpiritUpIcon}]}).wait(1));

	// profile
	this.profile = new lib.profilePicture();
	this.profile.name = "profile";
	this.profile.setTransform(-0.5,-263.9,1,1,0,0,0,-2.5,25.2);

	this.timeline.addTween(cjs.Tween.get(this.profile).wait(1));

	// Layer_4
	this.groupMeter = new lib.groupMeter();
	this.groupMeter.name = "groupMeter";
	this.groupMeter.setTransform(-0.5,25.55);

	this.trustMeter = new lib.TrustMeter();
	this.trustMeter.name = "trustMeter";
	this.trustMeter.setTransform(-0.5,-87.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.trustMeter},{t:this.groupMeter}]}).wait(1));

	// panelkort
	this.instance = new lib.panelkort();
	this.instance.setTransform(0,-86.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.CharacterFeedbackPanel, new cjs.Rectangle(-498.2,-491.1,711.2,848.1), null);


(lib.RoboGuru_Buttonverder = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// DisabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("VERDER", "28px 'JetBrains Mono'", "#060502");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "right";
	this.disabledLabelTextField.lineHeight = 37;
	this.disabledLabelTextField.lineWidth = 101;
	this.disabledLabelTextField.alpha = 0.00000000;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(50.45,-18.45);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// DownLabelTextField
	this.downLabelTextField = new cjs.Text("VERDER", "28px 'JetBrains Mono'", "#060502");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "right";
	this.downLabelTextField.lineHeight = 37;
	this.downLabelTextField.lineWidth = 101;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(50.45,-18.45);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("VERDER", "28px 'JetBrains Mono'", "#060502");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "right";
	this.overLabelTextField.lineHeight = 37;
	this.overLabelTextField.lineWidth = 101;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(50.45,-18.45);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("VERDER", "28px 'JetBrains Mono'", "#FE9625");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "right";
	this.upLabelTextField.lineHeight = 37;
	this.upLabelTextField.lineWidth = 101;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(50.45,-18.45);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// haakjedynamisch
	this.haakjeOpen = new lib.haakjeOpenen();
	this.haakjeOpen.name = "haakjeOpen";
	this.haakjeOpen.setTransform(-50.65,0);

	this.haakjeSluiten = new lib.haakjeSluiten();
	this.haakjeSluiten.name = "haakjeSluiten";
	this.haakjeSluiten.setTransform(51.1,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.haakjeSluiten},{t:this.haakjeOpen}]}).to({state:[]},3).wait(1));

	// outline
	this.selectionText = new lib.selectionText();
	this.selectionText.name = "selectionText";
	this.selectionText.setTransform(53.75,-0.1,0.148,1,180,0,0,-0.4,0.1);
	this.selectionText._off = true;

	this.timeline.addTween(cjs.Tween.get(this.selectionText).wait(1).to({_off:false},0).to({_off:true},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-71.4,-20.4,143.3,66.6);


(lib.RoboGuru_Buttontok = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// DisabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("OK", "28px 'JetBrains Mono'", "#060502");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 39;
	this.disabledLabelTextField.lineWidth = 107;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-2.75,-17.85);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// DownLabelTextField
	this.downLabelTextField = new cjs.Text("OK", "28px 'JetBrains Mono'", "#060502");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 39;
	this.downLabelTextField.lineWidth = 107;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-2.75,-17.85);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("OK", "28px 'JetBrains Mono'", "#FE9625");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 39;
	this.overLabelTextField.lineWidth = 107;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-2.75,-17.85);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("OK", "28px 'JetBrains Mono'", "#FE9625");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 39;
	this.upLabelTextField.lineWidth = 107;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-2.75,-17.85);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// haakjedynamisch
	this.haakjeOpen = new lib.haakjeOpenen();
	this.haakjeOpen.name = "haakjeOpen";
	this.haakjeOpen.setTransform(-14.9,0.6,1,1,0,0,0,10.4,0);

	this.haakjeSluiten = new lib.haakjeSluiten();
	this.haakjeSluiten.name = "haakjeSluiten";
	this.haakjeSluiten.setTransform(32.5,0.6,1,1,0,0,0,10.4,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.haakjeSluiten},{t:this.haakjeOpen}]}).wait(4));

	// outline
	this.selectionText = new lib.selectionText();
	this.selectionText.name = "selectionText";
	this.selectionText.setTransform(-28,0.4,0.0727,1);
	this.selectionText._off = true;

	this.timeline.addTween(cjs.Tween.get(this.selectionText).wait(1).to({_off:false},0).to({_off:true},2).wait(1));

	// hitarea
	this.hitarea = new lib.roboPanelHitarea();
	this.hitarea.name = "hitarea";
	this.hitarea.setTransform(0,-5,0.1945,1);

	this.timeline.addTween(cjs.Tween.get(this.hitarea).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-76.5,-33.1,153.1,71);


(lib.RoboGuru_Buttonterug = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// DisabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("TERUG", "28px 'JetBrains Mono'", "#060502");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 39;
	this.disabledLabelTextField.lineWidth = 107;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-43.35,-17.85);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// DownLabelTextField
	this.downLabelTextField = new cjs.Text("TERUG", "28px 'JetBrains Mono'", "#060502");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 39;
	this.downLabelTextField.lineWidth = 107;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-43.6,-17.85);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("TERUG", "28px 'JetBrains Mono'", "#060502");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 39;
	this.overLabelTextField.lineWidth = 107;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-43.6,-17.85);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("TERUG", "28px 'JetBrains Mono'", "#FE9625");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 39;
	this.upLabelTextField.lineWidth = 107;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-43.6,-17.85);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// haakjedynamisch
	this.haakjeOpen = new lib.haakjeOpenen();
	this.haakjeOpen.name = "haakjeOpen";
	this.haakjeOpen.setTransform(-44.35,0.6);

	this.haakjeSluiten = new lib.haakjeSluiten();
	this.haakjeSluiten.name = "haakjeSluiten";
	this.haakjeSluiten.setTransform(35.65,0.6,1,1,0,0,0,-7.2,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.haakjeSluiten},{t:this.haakjeOpen}]}).to({state:[]},3).wait(1));

	// outline
	this.selectionText = new lib.selectionText();
	this.selectionText.name = "selectionText";
	this.selectionText.setTransform(-46.6,0.4,0.1276,1);
	this.selectionText._off = true;

	this.timeline.addTween(cjs.Tween.get(this.selectionText).wait(1).to({_off:false},0).to({_off:true},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-65.1,-19.8,130.3,40.900000000000006);


(lib.RoboGuru_ButtonClose = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// DisabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("X", "28px 'JetBrains Mono'", "#060502");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 39;
	this.disabledLabelTextField.lineWidth = 107;
	this.disabledLabelTextField.alpha = 0.00000000;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0,-17.85);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// DownLabelTextField
	this.downLabelTextField = new cjs.Text("X", "28px 'JetBrains Mono'", "#060502");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 39;
	this.downLabelTextField.lineWidth = 107;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0,-17.85);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("X", "28px 'JetBrains Mono'", "#060502");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 39;
	this.overLabelTextField.lineWidth = 107;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0,-17.85);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("X", "28px 'JetBrains Mono'", "#FE9625");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 39;
	this.upLabelTextField.lineWidth = 107;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0,-17.85);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// haakjedynamisch
	this.haakjeOpen = new lib.haakjeOpenen();
	this.haakjeOpen.name = "haakjeOpen";
	this.haakjeOpen.setTransform(-6.95,0.6);

	this.haakjeSluiten = new lib.haakjeSluiten();
	this.haakjeSluiten.name = "haakjeSluiten";
	this.haakjeSluiten.setTransform(17.3,0.6,1,1,0,0,0,10.4,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.haakjeSluiten},{t:this.haakjeOpen}]}).to({state:[]},3).wait(1));

	// outline
	this.selectionText = new lib.selectionText();
	this.selectionText.name = "selectionText";
	this.selectionText.setTransform(-11.05,0.4,0.0304,1);
	this.selectionText._off = true;

	this.timeline.addTween(cjs.Tween.get(this.selectionText).wait(1).to({_off:false},0).to({_off:true},2).wait(1));

	// hitarea
	this.hitarea = new lib.roboPanelHitarea();
	this.hitarea.name = "hitarea";
	this.hitarea.setTransform(0,-5,0.1945,1);

	this.timeline.addTween(cjs.Tween.get(this.hitarea).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-76.5,-33.1,153.1,71);


(lib.RoboGuru_ButtonBekijkImpact = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// DisabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("BEKIJK IMPACT", "28px 'JetBrains Mono'", "#060502");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "right";
	this.disabledLabelTextField.lineHeight = 37;
	this.disabledLabelTextField.lineWidth = 221;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(105.55,-18.45);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// DownLabelTextField
	this.downLabelTextField = new cjs.Text("BEKIJK IMPACT", "28px 'JetBrains Mono'", "#060502");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "right";
	this.downLabelTextField.lineHeight = 37;
	this.downLabelTextField.lineWidth = 221;
	this.downLabelTextField.alpha = 0.49803922;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(105.55,-18.45);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("BEKIJK IMPACT", "28px 'JetBrains Mono'", "#060502");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "right";
	this.overLabelTextField.lineHeight = 37;
	this.overLabelTextField.lineWidth = 221;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(105.55,-18.45);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("BEKIJK IMPACT", "28px 'JetBrains Mono'", "#FE9625");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "right";
	this.upLabelTextField.lineHeight = 37;
	this.upLabelTextField.lineWidth = 221;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(105.55,-18.45);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// haakjedynamisch
	this.haakjeOpen = new lib.haakjeOpenen();
	this.haakjeOpen.name = "haakjeOpen";
	this.haakjeOpen.setTransform(-113.35,0);

	this.haakjeSluiten = new lib.haakjeSluiten();
	this.haakjeSluiten.name = "haakjeSluiten";
	this.haakjeSluiten.setTransform(105.1,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.haakjeSluiten},{t:this.haakjeOpen}]}).to({state:[]},3).wait(1));

	// outline
	this.selectionText = new lib.selectionText();
	this.selectionText.name = "selectionText";
	this.selectionText.setTransform(108.8,-0.3,0.3126,1,180,0,0,-0.7,0.1);
	this.selectionText._off = true;

	this.timeline.addTween(cjs.Tween.get(this.selectionText).wait(1).to({_off:false},0).to({_off:true},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-134.1,-20.4,260,40.9);


(lib.PlaceholderButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// DisabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Laat de introductietekst nog een keer zien", "28px 'JetBrains Mono'", "#060502");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 39;
	this.disabledLabelTextField.lineWidth = 757;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-353.45,-17.85);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// DownLabelTextField
	this.downLabelTextField = new cjs.Text("Laat de introductietekst nog een keer zien", "28px 'JetBrains Mono'", "#060502");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 39;
	this.downLabelTextField.lineWidth = 757;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-353.45,-17.85);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Laat de introductietekst nog een keer zien", "28px 'JetBrains Mono'", "#060502");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 39;
	this.overLabelTextField.lineWidth = 757;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-353.45,-17.85);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Laat de introductietekst nog een keer zien", "28px 'JetBrains Mono'", "#FE9625");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 39;
	this.upLabelTextField.lineWidth = 757;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-353.45,-17.85);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// haakjedynamisch
	this.haakjeOpen = new lib.haakjeOpenen();
	this.haakjeOpen.name = "haakjeOpen";
	this.haakjeOpen.setTransform(-350.05,0.6,1,1,0,0,0,10.4,0);

	this.haakjeSluiten = new lib.haakjeSluiten();
	this.haakjeSluiten.name = "haakjeSluiten";
	this.haakjeSluiten.setTransform(356.55,0.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.haakjeSluiten},{t:this.haakjeOpen}]}).wait(4));

	// outline
	this.selectionText = new lib.selectionText();
	this.selectionText.name = "selectionText";
	this.selectionText.setTransform(-362.55,0.8);
	this.selectionText._off = true;

	this.timeline.addTween(cjs.Tween.get(this.selectionText).wait(1).to({_off:false},0).to({_off:true},2).wait(1));

	// hitarea
	this.hitarea = new lib.roboPanelHitarea();
	this.hitarea.name = "hitarea";
	this.hitarea.setTransform(0,-5);

	this.timeline.addTween(cjs.Tween.get(this.hitarea).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-393.5,-33.1,799.5,71);


(lib.ConversationScrollBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// dragButton
	this.dragButton = new lib.ConversationScrollBarDragButton();
	this.dragButton.name = "dragButton";
	this.dragButton.setTransform(8.5,26.7);

	this.timeline.addTween(cjs.Tween.get(this.dragButton).wait(1));

	// dragArea
	this.dragArea = new lib.ConversationScrollBarDragArea();
	this.dragArea.name = "dragArea";
	this.dragArea.setTransform(12.5,400,1,1,0,0,0,12.5,400);

	this.timeline.addTween(cjs.Tween.get(this.dragArea).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationScrollBar, new cjs.Rectangle(0,0,15.2,613.1), null);


(lib.Coach_Introduction_Panel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// closeButton
	this.closeButton = new lib.RoboGuru_ButtonClose();
	this.closeButton.name = "closeButton";
	this.closeButton.setTransform(340.5,-409.3,1,1,0,0,0,0,2.4);

	this.timeline.addTween(cjs.Tween.get(this.closeButton).wait(1));

	// backButton
	this.backButton = new lib.RoboGuru_Buttonterug();
	this.backButton.name = "backButton";
	this.backButton.setTransform(-289.85,385.05,1,1,0,0,0,0,2.4);

	this.timeline.addTween(cjs.Tween.get(this.backButton).wait(1));

	// continueButton
	this.continueButton = new lib.RoboGuru_Buttonverder();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(296.5,385.65,1,1,0,0,0,0,2.4);

	this.timeline.addTween(cjs.Tween.get(this.continueButton).wait(1));

	// contentTextField
	this.contentTextField = new cjs.Text("IntroductionIntroductionIntroductionInt\nIntroductionIntroductionIntroductionInt\nIntroductionIntroductionIntroductionInt\nIntroductionIntroductionIntroductionInt\nIntroductionIntroductionIntroductionInt\nIntroductionIntroductionIntroductionInt\nIntroductionIntroductionIntroductionInt\nIntroductionIntroductionIntroductionInt\nIntroductionIntroductionIntroductionInt\nIntroductionIntroductionIntroductionInt\nIntroductionIntroductionIntroductionInt\nIntroductionIntroductionIntroductionInt\nIntroductionIntroductionIntroductionInt\nIntroductionIntroductionIntroductionInt\nIntroductionIntroductionIntroductionInt\nIntroductionIntroductionIntroductionInt\nIntroductionIntroductionIntroductionInt\nIntroductionIntroductionIntroductionInt\nIntroductionIntroductionIntroductionInt\nIntroductionIntroductionIntroductionInt", "28px 'JetBrains Mono'", "#FE9625");
	this.contentTextField.name = "contentTextField";
	this.contentTextField.lineHeight = 39;
	this.contentTextField.lineWidth = 666;
	this.contentTextField.parent = this;
	this.contentTextField.setTransform(-359.85,-433.75,1.0001,1);
ranj.TextOffsetFixer.fix(this.contentTextField);

	this.timeline.addTween(cjs.Tween.get(this.contentTextField).wait(1));

	// roboGuru_missionPanel_png
	this.instance = new lib.roboGuru_missionPanel();
	this.instance.setTransform(-445,-490);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Coach_Introduction_Panel, new cjs.Rectangle(-445,-490,890,979), null);


(lib.Coach_Feedback_Panel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// backButton
	this.backButton = new lib.RoboGuru_Buttonterug();
	this.backButton.name = "backButton";
	this.backButton.setTransform(-297.4,237,1,1,0,0,0,0,2.4);

	this.timeline.addTween(cjs.Tween.get(this.backButton).wait(1));

	// continueButton
	this.continueButton = new lib.RoboGuru_Buttonverder();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(618.6,237.6,1,1,0,0,0,0,2.4);

	this.timeline.addTween(cjs.Tween.get(this.continueButton).wait(1));

	// contentTextField
	this.contentTextYou = new cjs.Text("YourTextYourTextYourTextYourTextYourTextYourTextYourTextYourTT\nYourTextYourTextYourTextYourTextYourTextYourTextYourTextYourTT\nYourTextYourTextYourTextYourTextYourTextYourTextYourTextYourTT\nYourTextYourTextYourTextYourTextYourTextYourTextYourTextYourTT", "28px 'JetBrains Mono'", "#FE9625");
	this.contentTextYou.name = "contentTextYou";
	this.contentTextYou.lineHeight = 39;
	this.contentTextYou.lineWidth = 1042;
	this.contentTextYou.parent = this;
	this.contentTextYou.setTransform(-358.1,-260.9);
ranj.TextOffsetFixer.fix(this.contentTextYou);

	this.contentHeaderYou = new cjs.Text("YouSaidYouSaidYouSaidYouSaidYouSaidYouSaidYouSaidYouSaidYouSai", "28px 'JetBrains Mono'", "#FE9625");
	this.contentHeaderYou.name = "contentHeaderYou";
	this.contentHeaderYou.lineHeight = 39;
	this.contentHeaderYou.lineWidth = 1042;
	this.contentHeaderYou.parent = this;
	this.contentHeaderYou.setTransform(-358.1,-303.7,1.0001,1);
ranj.TextOffsetFixer.fix(this.contentHeaderYou);

	this.contentFeedback = new cjs.Text("FeedbackTekstFeedbackTekstFeedbackTekstFeedbackTekstFeedbackTT\nFeedbackTekstFeedbackTekstFeedbackTekstFeedbackTekstFeedbackTT\nFeedbackTekstFeedbackTekstFeedbackTekstFeedbackTekstFeedbackTT\nFeedbackTekstFeedbackTekstFeedbackTekstFeedbackTekstFeedbackTT\nFeedbackTekstFeedbackTekstFeedbackTekstFeedbackTekstFeedbackTT\nFeedbackTekstFeedbackTekstFeedbackTekstFeedbackTekstFeedbackTT", "28px 'JetBrains Mono'", "#FE9625");
	this.contentFeedback.name = "contentFeedback";
	this.contentFeedback.lineHeight = 39;
	this.contentFeedback.lineWidth = 1044;
	this.contentFeedback.parent = this;
	this.contentFeedback.setTransform(-358.1,-24.7,1.0001,1);
ranj.TextOffsetFixer.fix(this.contentFeedback);

	this.contentFeedbackHeader = new cjs.Text("Feedback:", "28px 'JetBrains Mono'", "#FE9625");
	this.contentFeedbackHeader.name = "contentFeedbackHeader";
	this.contentFeedbackHeader.lineHeight = 39;
	this.contentFeedbackHeader.lineWidth = 970;
	this.contentFeedbackHeader.parent = this;
	this.contentFeedbackHeader.setTransform(-358.1,-75.65,1.0001,1);
ranj.TextOffsetFixer.fix(this.contentFeedbackHeader);

	this.lineBreakSingle = new cjs.Text("--------------------------------------------------------------", "28px 'JetBrains Mono'", "#FE9625");
	this.lineBreakSingle.name = "lineBreakSingle";
	this.lineBreakSingle.lineHeight = 39;
	this.lineBreakSingle.lineWidth = 1044;
	this.lineBreakSingle.parent = this;
	this.lineBreakSingle.setTransform(-358.1,-106.2,1.0001,1);
ranj.TextOffsetFixer.fix(this.lineBreakSingle);

	this.lineBreakDouble = new cjs.Text("==============================================================", "28px 'JetBrains Mono'", "#FE9625");
	this.lineBreakDouble.name = "lineBreakDouble";
	this.lineBreakDouble.lineHeight = 39;
	this.lineBreakDouble.lineWidth = 1044;
	this.lineBreakDouble.parent = this;
	this.lineBreakDouble.setTransform(-358.1,-348.65,1.0001,1);
ranj.TextOffsetFixer.fix(this.lineBreakDouble);

	this.contentTextHeader = new cjs.Text("He Ferry! Dit viel me op in het gesprek.\n[Extra regel tekst]", "28px 'JetBrains Mono'", "#FE9625");
	this.contentTextHeader.name = "contentTextHeader";
	this.contentTextHeader.lineHeight = 39;
	this.contentTextHeader.lineWidth = 970;
	this.contentTextHeader.parent = this;
	this.contentTextHeader.setTransform(-357.9,-427.8,1.0001,1);
ranj.TextOffsetFixer.fix(this.contentTextHeader);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.contentTextHeader},{t:this.lineBreakDouble},{t:this.lineBreakSingle},{t:this.contentFeedbackHeader},{t:this.contentFeedback},{t:this.contentHeaderYou},{t:this.contentTextYou}]}).wait(1));

	// roboGuru_missionPanel_png
	this.instance = new lib.roboGuru_feedbackPanel_1();
	this.instance.setTransform(-445,-490);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Coach_Feedback_Panel, new cjs.Rectangle(-445,-490,1206,910.7), null);


(lib.HubTile_chapter_1_conversation_5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// startConversationButton
	this.conAttract = new lib.Conversation_05_hoverGlow();
	this.conAttract.name = "conAttract";

	this.timeline.addTween(cjs.Tween.get(this.conAttract).wait(1));

	// __Conversation_1__
	this.button = new lib.Con_05_Button();
	this.button.name = "button";
	this.button.setTransform(0,0,1,1,0,0,0,-0.5,0);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	// Layer_6
	this.instance = new lib.c05_hub_tile();
	this.instance.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HubTile_chapter_1_conversation_5, new cjs.Rectangle(-1120,-540,2240,1080.3), null);


(lib.HubTile_chapter_1_conversation_4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// startConversationButton
	this.conAttract = new lib.Conversation_04_hoverGlow();
	this.conAttract.name = "conAttract";

	this.timeline.addTween(cjs.Tween.get(this.conAttract).wait(1));

	// __Conversation_1__
	this.button = new lib.Con_04_Button();
	this.button.name = "button";
	this.button.setTransform(0,0,1,1,0,0,0,-0.5,0);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	// Layer_6
	this.instance = new lib.c04_hub_tile();
	this.instance.setTransform(-1120,-540);

	this.instance_1 = new lib.c01_hub_tile();
	this.instance_1.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HubTile_chapter_1_conversation_4, new cjs.Rectangle(-1120,-540,2240,1080.3), null);


(lib.HubTile_chapter_1_conversation_3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// startConversationButton
	this.conAttract = new lib.Conversation_03_hoverGlow();
	this.conAttract.name = "conAttract";
	this.conAttract.setTransform(-2.25,22);

	this.timeline.addTween(cjs.Tween.get(this.conAttract).wait(1));

	// __Conversation_1__
	this.button = new lib.Con_03_Button();
	this.button.name = "button";
	this.button.setTransform(0,0,1,1,0,0,0,-0.5,0);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	// bg
	this.instance = new lib.c03_hub_tile();
	this.instance.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HubTile_chapter_1_conversation_3, new cjs.Rectangle(-1120.2,-540,2240.2,1080.3), null);


(lib.HubTile_chapter_1_conversation_2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// startConversationButton
	this.conAttract = new lib.Conversation_02_hoverGlow();
	this.conAttract.name = "conAttract";
	this.conAttract.setTransform(-2,0);

	this.timeline.addTween(cjs.Tween.get(this.conAttract).wait(1));

	// __Conversation_1__
	this.button = new lib.Con_02_Button();
	this.button.name = "button";
	this.button.setTransform(0,0,1,1,0,0,0,-0.5,0);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	// bg
	this.instance = new lib.c02_hub_tile();
	this.instance.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HubTile_chapter_1_conversation_2, new cjs.Rectangle(-1120,-540,2240,1080.3), null);


(lib.HubTile_chapter_1_conversation_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// glowHover
	this.conAttract = new lib.Conversation_01_hoverGlow();
	this.conAttract.name = "conAttract";

	this.timeline.addTween(cjs.Tween.get(this.conAttract).wait(1));

	// startConversationButton
	this.button = new lib.Con_01_Button();
	this.button.name = "button";
	this.button.setTransform(0,0,1,1,0,0,0,-0.5,0);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	// bg
	this.instance = new lib.c01_hub_tile();
	this.instance.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HubTile_chapter_1_conversation_1, new cjs.Rectangle(-1120,-540,2240,1080.3), null);


(lib.teamOmeter = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// wijzer
	this.instance = new lib.wijzer_1("synched",0);
	this.instance.setTransform(3.5,-8.4,1,1,-3.2216,0,0,96,-69);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({rotation:269.5812,x:3.4},99).to({startPosition:0},1).to({startPosition:0},1).wait(1));

	// teamText
	this.teamMeterText = new cjs.Text("TEAM\n-O-\nMETER", "52px 'JetBrains Mono'", "#FFFFFF");
	this.teamMeterText.name = "teamMeterText";
	this.teamMeterText.textAlign = "center";
	this.teamMeterText.lineHeight = 71;
	this.teamMeterText.lineWidth = 236;
	this.teamMeterText.parent = this;
	this.teamMeterText.setTransform(0,98.95);
ranj.TextOffsetFixer.fix(this.teamMeterText);

	this.timeline.addTween(cjs.Tween.get(this.teamMeterText).wait(102));

	// Layer_7
	this.instance_1 = new lib.solo();
	this.instance_1.setTransform(-182,15);

	this.instance_2 = new lib.group();
	this.instance_2.setTransform(89,13);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1}]}).wait(102));

	// Layer_6
	this.instance_3 = new lib.feel();
	this.instance_3.setTransform(-137,-165);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(102));

	// Layer_9 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_0 = new cjs.Graphics().p("Ay9KkIQVsjQCICwCuCLIsyQIQkujvjrkxg");
	var mask_graphics_3 = new cjs.Graphics().p("A1dCmISbpNQC0FpE7D6IsyQIQohmwk3pug");
	var mask_graphics_7 = new cjs.Graphics().p("A3BlWITvl4QCkImHAFkIsyQIQsHpnkauzg");
	var mask_graphics_11 = new cjs.Graphics().p("AyMEHQkxovg+p8IUgiAQAjFxCxFEQCxFGEhDlIsyQIQn0mNkxowg");
	var mask_graphics_15 = new cjs.Graphics().p("A0HCVQk4rcBLsZIUgB8QgsHMC1GpQC0GoFqEfIsyQJQpwnvk4rdg");
	var mask_graphics_19 = new cjs.Graphics().p("A1eC/QlEvGEyvMITpGLQixI0C7IwQC8IwHhFWIr7QyQs/pPlEvGg");
	var mask_graphics_23 = new cjs.Graphics().p("A27CWQjsxMIHvoISSJfQktJDCJJ/QCJJ+H+GWIsyQIQtyq8jsxNg");
	var mask_graphics_27 = new cjs.Graphics().p("A3tBpQiU0JMnv6IQIMzQnUJOBXLsQBWLsJNHUIsyQIQv6sniV0Lg");
	var mask_graphics_31 = new cjs.Graphics().p("A1uOfQkiuSEPuXQEPuYLjpjINHP4QmtFiicIWQidIVCoIRQCnITG0FZIsyQJQrwpUkhuTg");
	var mask_graphics_35 = new cjs.Graphics().p("A2jODQkBwRGrvOQGqvOOxoDIJ2SFQokErj3I1Qj3I0CVJcQCVJdHkGAIsyQJQtEqXkBwUg");
	var mask_graphics_39 = new cjs.Graphics().p("A3MM2QjTyRJgvwQJgvwRploIGOToQqPDRlhJIQlfJJB6KlQB6KnIWGoIsyQJQuarcjTySg");
	var mask_graphics_43 = new cjs.Graphics().p("A1uT/QkiuSEPuXQEPuYLkpjQLipjO6hdICAUgQopA2mtFiQmtFjicIVQidIUCoITQCnISG0FZIsyQJQrwpUkhuTg");
	var mask_graphics_48 = new cjs.Graphics().p("A5HR3QkLvxGBvEQGBvEN8odQN7oeQOBfIh8UgQpag3oGE6QoEE6jfIvQjfIuCaJKQCbJJHWF2IsyQIQssqEkLvyg");
	var mask_graphics_52 = new cjs.Graphics().p("A+TPnQjsxNIHvnQIHvoQLm6QQLm5Q5E/Il1TwQpyi5pZEAQpYEAksJEQktJCCJJ/QCIJ/IAGVIszQJQtzq8jrxNg");
	var mask_graphics_56 = new cjs.Graphics().p("EgjFANSQjEyuKPv2QKPv2SWk3QSWk2QyIrIpfSSQpulCqpC0QqoC0l9JMQl8JMBzK2QByK4IkGzIszQIQuyrujFyvg");
	var mask_graphics_60 = new cjs.Graphics().p("EgmQASRQkPvgFqu8QFqu8NbosQNborQBA4QQEA5MVKJItFP6QnKl4pTghQpUghnxFCQnyFCjSIrQjSIqCeI/QCdI/HRFwIszQJQshp7kQvgg");
	var mask_graphics_65 = new cjs.Graphics().p("EgqBAQfQj5wqHPvbQHQvaPSnkQPSnjQvDkQQwDkKxNFIv4NHQmPnlpuiEQpuiEo2EYQo3EYkNI8QkMI7CQJrQCRJrHtGHIszQJQtRqij7wsg");
	var mask_graphics_69 = new cjs.Graphics().p("EgtFAOrQjcxzI8vwQI9vxRFmHQREmHQ5GYQQ5GXIwQDIyFJ2QlFpTpyjsQpzjtp5DjQp6DjlMJJQlMJICAKVQB/KVIPGiIszQIQuMrQjdx1g");
	var mask_graphics_73 = new cjs.Graphics().p("EgvOAM2Qi8zAKvv7QKvv6SvkXQSukWQoJcQQpJcF2SXIzpGOQjYqppqlfQppleq2ChQq3CimPJPQmOJPBtLAQBtLBIsG5IszQJQu/r5i8zAg");
	var mask_graphics_77 = new cjs.Graphics().p("EgvZARCQkAwSGqvNQGqvOOwoAQOvoAQjCpQQlCqLWMHQLXMIBrQsI0fCAQg/prmlnCQmlnBpnhjQpmhiojEpQojEpj3I1Qj4IzCVJdQCVJdHlGAIszQJQtEqXkBwUg");
	var mask_graphics_81 = new cjs.Graphics().p("Egv6APRQjoxeIUvlQIUvmQemqQQemqQ+FbQRAFbJaO+QJbO9iPRlI0birQBTqLleosQldorp2jJQp2jJpkD3QpjD3k0JCQk0JCCGKIQCGKJICGXIszQJQt1q+joxfg");
	var mask_graphics_85 = new cjs.Graphics().p("EgwRAN8QjQyRJsv3QJrv2RwldQRwldQ6HsQQ6HrHlQ9QHlQ8llRuIzpmLQDOqRkZp0QkZp1pzkdQp0kdqRDKQqTDLlnJMQloJMB5KlQB5KnIbGsIszQJQujrjjQySg");
	var mask_graphics_89 = new cjs.Graphics().p("EgwdAMUQizzWLJv2QLKv2TFj6QTFj6QjKPQQjKPE/S1QE/S1pNREIyHp0QFWp5i6q6Qi4q6pnl9Qpml7rDCQQrECRmeJMQmdJNBnLNQBoLPIzG/IszQIQvMsCiyzYg");
	var mask_graphics_93 = new cjs.Graphics().p("EgvrAQGQj1w7HkvcQHjvdPvnUQPwnUQxEJQQyEJKZNsQKZNsgeRWQgdRYrJNEIvstXQGenlARqEQARqDmCn8QmBn9pviZQpuiapIEQQpIEPkYI9QkYI8CNJ1QCOJ1HzGMIszQJQtdqsj0w8g");
	var mask_graphics_97 = new cjs.Graphics().p("APtbzQIxlzC2qMQC2qLkepkQkeplpkkTQpjkSqJC/QqKC+lsI1QltI2BcKdQBdKfH4G9ItnPdQtnsAifyEQifyDJ1vQQJ1vQRglIQRflIQfHZQQfHZHuQhQHtQik6RiQk6RkvIKAg");

	this.timeline.addTween(cjs.Tween.get(mask).to({graphics:mask_graphics_0,x:-121.4181,y:122.0055}).wait(3).to({graphics:mask_graphics_3,x:-137.3828,y:122.0055}).wait(4).to({graphics:mask_graphics_7,x:-147.4323,y:122.0055}).wait(4).to({graphics:mask_graphics_11,x:-153.2003,y:122.0055}).wait(4).to({graphics:mask_graphics_15,x:-153.9791,y:106.3084}).wait(4).to({graphics:mask_graphics_19,x:-154.1827,y:79.3873}).wait(4).to({graphics:mask_graphics_23,x:-154.1591,y:48.8936}).wait(4).to({graphics:mask_graphics_27,x:-154.0812,y:23.6633}).wait(4).to({graphics:mask_graphics_31,x:-154.1169,y:0.2522}).wait(4).to({graphics:mask_graphics_35,x:-154.0406,y:-16.5885}).wait(4).to({graphics:mask_graphics_39,x:-153.9249,y:-28.373}).wait(4).to({graphics:mask_graphics_43,x:-154.1169,y:-34.96}).wait(5).to({graphics:mask_graphics_48,x:-136.2867,y:-35.7136}).wait(4).to({graphics:mask_graphics_52,x:-106.9239,y:-35.9799}).wait(4).to({graphics:mask_graphics_56,x:-78.8635,y:-35.8986}).wait(4).to({graphics:mask_graphics_60,x:-51.5084,y:-35.5692}).wait(5).to({graphics:mask_graphics_65,x:-30.1659,y:-35.6783}).wait(4).to({graphics:mask_graphics_69,x:-13.4714,y:-36.0079}).wait(4).to({graphics:mask_graphics_73,x:-1.5665,y:-35.868}).wait(4).to({graphics:mask_graphics_77,x:4.9432,y:-35.6828}).wait(4).to({graphics:mask_graphics_81,x:5.846,y:-35.781}).wait(4).to({graphics:mask_graphics_85,x:5.9205,y:-36.0502}).wait(4).to({graphics:mask_graphics_89,x:6.0564,y:-35.8231}).wait(4).to({graphics:mask_graphics_93,x:5.527,y:-35.747}).wait(4).to({graphics:mask_graphics_97,x:6.0322,y:-28.6002}).wait(5));

	// colors
	this.instance_4 = new lib.colors();
	this.instance_4.setTransform(-286,-298);

	var maskedShapeInstanceList = [this.instance_4];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(102));

	// colors_off
	this.instance_5 = new lib.colors_off();
	this.instance_5.setTransform(-286,-298);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(102));

	// Layer_4
	this.instance_6 = new lib.scharm();
	this.instance_6.setTransform(-307,-319);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(102));

	// circle
	this.instance_7 = new lib.elips();
	this.instance_7.setTransform(-348,-351);

	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(102));

	// glow
	this.instance_8 = new lib.elipse_glow();
	this.instance_8.setTransform(-469,-480);

	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(102));

	// glow
	this.glow = new lib.glowcircleMeter("synched",0);
	this.glow.name = "glow";
	this.glow.setTransform(0,-11);

	this.timeline.addTween(cjs.Tween.get(this.glow).wait(102));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-469,-480,938,938);


(lib.RoboGuru_OnboardingSelect = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_62 = function() {
		this.stop()
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(62).call(this.frame_62).wait(1));

	// robo
	this.robotGuru = new lib.roboGuru_Onboarding_Select_ani("synched",0);
	this.robotGuru.name = "robotGuru";
	this.robotGuru.setTransform(2,-10.15);

	this.timeline.addTween(cjs.Tween.get(this.robotGuru).wait(63));

	// black
	this.instance = new lib.Dialog_Robot_Circle_inner_circle();
	this.instance.setTransform(-75.5,-80.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(63));

	// BG
	this.instance_1 = new lib.Dialog_Robot_Circle_BG_blue();
	this.instance_1.setTransform(-91,-93);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(63));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-93.4,-96.5,191,188.5);


(lib.RoboGuru_Help = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3,selectedUp:4,selectedOver:5,selectedDown:6,selectedDisabled:7};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// attract
	this.attract = new lib.Dialog_pulseRing_animation();
	this.attract.name = "attract";
	this.attract.setTransform(0.05,-5);

	this.timeline.addTween(cjs.Tween.get(this.attract).wait(8));

	// robo
	this.robotGuru_idle = new lib.roboGuru_idle();
	this.robotGuru_idle.name = "robotGuru_idle";
	this.robotGuru_idle.setTransform(2,-10.15);

	this.robotGuru_pulse = new lib.roboGuru_Pulse();
	this.robotGuru_pulse.name = "robotGuru_pulse";
	this.robotGuru_pulse.setTransform(2,-10.15);

	this.robotGuru_down = new lib.roboGuru_Down();
	this.robotGuru_down.name = "robotGuru_down";
	this.robotGuru_down.setTransform(2,-10.15);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.robotGuru_idle}]}).to({state:[{t:this.robotGuru_pulse,p:{regX:0,regY:0,scaleX:1,scaleY:1,x:2,y:-10.15}}]},1).to({state:[{t:this.robotGuru_pulse,p:{regX:0.1,regY:-0.1,scaleX:0.9,scaleY:0.9,x:2.05,y:-10.2}}]},1).to({state:[{t:this.robotGuru_down}]},2).to({state:[{t:this.robotGuru_pulse,p:{regX:0,regY:0,scaleX:1,scaleY:1,x:2,y:-10.15}}]},1).to({state:[{t:this.robotGuru_pulse,p:{regX:0.1,regY:-0.1,scaleX:0.9,scaleY:0.9,x:2.05,y:-10.2}}]},1).to({state:[{t:this.robotGuru_idle}]},1).wait(1));

	// pulls
	this.pulseRing = new lib.Dialog_pulseRing_animation();
	this.pulseRing.name = "pulseRing";
	this.pulseRing.setTransform(0.05,-5);
	this.pulseRing._off = true;

	this.timeline.addTween(cjs.Tween.get(this.pulseRing).wait(1).to({_off:false},0).to({_off:true},1).wait(3).to({_off:false},0).to({_off:true},2).wait(1));

	// pulls
	this.instance = new lib.PulseRing();
	this.instance.setTransform(0.05,-5);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2).to({_off:false},0).to({_off:true},1).wait(2).to({_off:false},0).to({_off:true},2).wait(1));

	// black
	this.instance_1 = new lib.Dialog_Robot_Circle_inner_circle();
	this.instance_1.setTransform(-75.5,-80.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1).to({scaleX:1.2128,scaleY:1.2128,x:-92,y:-97},0).wait(2).to({scaleX:1,scaleY:1,x:-75.5,y:-80.5},0).wait(2).to({scaleX:1.2128,scaleY:1.2128,x:-92,y:-97},0).wait(2).to({scaleX:1,scaleY:1,x:-75.5,y:-80.5},0).wait(1));

	// BG
	this.instance_2 = new lib.Dialog_Robot_Circle_BG_blue();
	this.instance_2.setTransform(-91,-93);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(8));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-92.7,-97.7,186.7,189.7);


(lib.robby_popup_aniEnd = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_10
	this.instance = new lib.armvoor();
	this.instance.setTransform(-42.75,453.05,1,1,-169.5176);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true},38).wait(249));

	// Layer_8
	this.instance_1 = new lib.armzwaai("synched",31);
	this.instance_1.setTransform(-35.75,274.7,0.9927,1.0087,0,-7.4983,-10.3739,70.6,51);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(38).to({_off:false},0).to({regX:70.7,scaleX:1,scaleY:1,rotation:12.6939,skewX:0,skewY:0,x:-35.7,y:252.95,startPosition:2},31).to({regX:70.6,scaleX:0.9927,scaleY:1.0087,rotation:0,skewX:-7.4983,skewY:-10.3739,x:-35.75,y:274.7,startPosition:33},31).to({regX:70.7,scaleX:1,scaleY:1,rotation:12.6939,skewX:0,skewY:0,x:-35.7,y:252.95,startPosition:4},31).to({regX:70.6,scaleX:0.9927,scaleY:1.0087,rotation:0,skewX:-7.4983,skewY:-10.3739,x:-35.75,y:274.7,startPosition:35},31).to({regX:70.7,scaleX:1,scaleY:1,rotation:12.6939,skewX:0,skewY:0,x:-35.7,y:252.95,startPosition:6},31).to({regY:51.1,scaleX:0.9969,scaleY:1.0036,rotation:0,skewX:4.2263,skewY:3.0191,x:-35.6,y:262.2,startPosition:19},13).to({_off:true},1).wait(80));

	// Layer_2
	this.instance_2 = new lib.RobbyHeadEnd("synched",0);
	this.instance_2.setTransform(137.05,-20.6,0.95,0.9998,0,16.2087,-163.7908,0.1,-0.4);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regY:-0.2,scaleY:0.9999,skewX:10.4559,skewY:-169.5434,x:111.35,y:-42.15,startPosition:19},19).to({regX:0,scaleY:0.9998,skewX:15.221,skewY:-164.7787,x:128,y:-16.95,startPosition:38},19).to({regY:-0.3,skewX:12.5736,skewY:-167.4255,x:118.8,y:-31.1,startPosition:43},5).to({regX:0.1,regY:-0.2,scaleY:0.9999,skewX:10.4559,skewY:-169.5434,x:111.35,y:-42.15,startPosition:47},4).to({startPosition:53},6).to({regX:-0.1,regY:-0.3,scaleY:0.9998,skewX:6.9169,skewY:-173.0845,x:93.6,y:-35.45,startPosition:69},16).to({scaleX:0.9499,skewX:20.4753,skewY:-159.5253,x:150.45,y:-22.6,startPosition:100},31,cjs.Ease.cubicInOut).to({scaleX:0.95,skewX:6.9169,skewY:-173.0845,x:93.6,y:-35.45,startPosition:131},31,cjs.Ease.cubicInOut).to({scaleX:0.9499,skewX:20.4753,skewY:-159.5253,x:150.45,y:-22.6,startPosition:162},31,cjs.Ease.cubicInOut).to({scaleX:0.95,skewX:6.9169,skewY:-173.0845,x:93.6,y:-35.45,startPosition:193},31,cjs.Ease.cubicInOut).wait(1).to({regX:-26,regY:-13,skewX:6.9564,skewY:-173.0449,x:119.65,y:-45,startPosition:194},0).wait(1).to({skewX:7.0192,skewY:-172.9821,x:119.95,y:-44.95,startPosition:195},0).wait(1).to({skewX:7.1083,skewY:-172.893,x:120.35,y:-44.8,startPosition:196},0).wait(1).to({skewX:7.2274,skewY:-172.7739,x:120.9,y:-44.65,startPosition:197},0).wait(1).to({skewX:7.3808,skewY:-172.6204,x:121.55,y:-44.45,startPosition:198},0).wait(1).to({skewX:7.5741,skewY:-172.427,x:122.4,y:-44.15,startPosition:199},0).wait(1).to({skewX:7.8142,skewY:-172.1869,x:123.4,y:-43.85,startPosition:200},0).wait(1).to({skewX:8.1096,skewY:-171.8914,x:124.75,y:-43.35,startPosition:201},0).wait(1).to({skewX:8.4715,skewY:-171.5294,x:126.3,y:-42.9,startPosition:202},0).wait(1).to({scaleX:0.9499,skewX:8.9138,skewY:-171.0869,x:128.2,y:-42.3,startPosition:203},0).wait(1).to({scaleX:0.95,skewX:9.4544,skewY:-170.5462,x:130.6,y:-41.55,startPosition:204},0).wait(1).to({skewX:10.1144,skewY:-169.8859,x:133.45,y:-40.6,startPosition:205},0).wait(1).to({regX:-0.1,regY:-0.4,scaleX:0.9499,skewX:10.9153,skewY:-169.0848,x:110.45,y:-31.8,startPosition:206},0).to({_off:true},1).wait(80));

	// lijf
	this.instance_3 = new lib.bodyRobbieZwaai();
	this.instance_3.setTransform(-68.1,151.75,1,1,14.9983);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(206).to({_off:true},1).wait(80));

	// Layer_6
	this.instance_4 = new lib.armachter_feedback();
	this.instance_4.setTransform(410.2,287,0.9925,1,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(206).to({_off:true},1).wait(80));

	// benen
	this.instance_5 = new lib.benen();
	this.instance_5.setTransform(-143,335.1,1,1,14.9983);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(206).to({_off:true},1).wait(80));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-324.1,-399.2,901.8000000000001,1065.5);


(lib.robby_popup_ani_intro = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_10
	this.instance = new lib.armvoor();
	this.instance.setTransform(-42.75,453.05,1,1,-169.5176);

	this.instance_1 = new lib.arm_down();
	this.instance_1.setTransform(-48.2,259.35,1,1,6.0535,0,0,65.9,-59.9);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[]},38).to({state:[{t:this.instance_1}]},235).to({state:[{t:this.instance_1}]},7).to({state:[{t:this.instance_1}]},4).to({state:[]},1).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(273).to({_off:false},0).to({regY:-60,rotation:4.2441,y:259.3},7).to({regX:65.8,regY:-59.9,rotation:5.73,x:-48.35,y:259.35},4).to({_off:true},1).wait(6));

	// Layer_8
	this.instance_2 = new lib.armzwaai("synched",31);
	this.instance_2.setTransform(-35.75,274.7,0.9927,1.0087,0,-7.4983,-10.3739,70.6,51);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(38).to({_off:false},0).to({regX:70.7,scaleX:1,scaleY:1,rotation:12.6939,skewX:0,skewY:0,x:-35.7,y:252.95,startPosition:2},31).to({regX:70.6,scaleX:0.9927,scaleY:1.0087,rotation:0,skewX:-7.4983,skewY:-10.3739,x:-35.75,y:274.7,startPosition:33},31).to({regX:70.7,scaleX:1,scaleY:1,rotation:12.6939,skewX:0,skewY:0,x:-35.7,y:252.95,startPosition:4},31).to({regX:70.6,scaleX:0.9927,scaleY:1.0087,rotation:0,skewX:-7.4983,skewY:-10.3739,x:-35.75,y:274.7,startPosition:35},31).to({regX:70.7,scaleX:1,scaleY:1,rotation:12.6939,skewX:0,skewY:0,x:-35.7,y:252.95,startPosition:6},31).to({regX:70.6,scaleX:0.9927,scaleY:1.0087,rotation:0,skewX:-7.4983,skewY:-10.3739,x:-35.75,y:274.7,startPosition:37},31).to({regX:70.7,scaleX:1,scaleY:1,rotation:12.6939,skewX:0,skewY:0,x:-35.7,y:252.95,startPosition:8},31).to({regX:70.5,regY:51.1,scaleX:0.9927,scaleY:1.0086,rotation:0,skewX:-15.2246,skewY:-18.1007,x:-37.6,y:274.8,startPosition:24},16).to({regX:70.6,regY:51,scaleX:0.9926,skewX:-134.7769,skewY:48.0992,x:-37.55,y:274.75,startPosition:25},1).to({_off:true},1).wait(18));

	// Layer_2
	this.instance_3 = new lib.RobbyHeadEnd("synched",0);
	this.instance_3.setTransform(137.05,-20.6,0.95,0.9998,0,16.2087,-163.7908,0.1,-0.4);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).to({regY:-0.2,scaleY:0.9999,skewX:10.4559,skewY:-169.5434,x:111.35,y:-42.15,startPosition:19},19).to({regX:0,scaleY:0.9998,skewX:15.221,skewY:-164.7787,x:128,y:-16.95,startPosition:38},19).to({regY:-0.3,skewX:12.5736,skewY:-167.4255,x:118.8,y:-31.1,startPosition:43},5).to({regX:0.1,regY:-0.2,scaleY:0.9999,skewX:10.4559,skewY:-169.5434,x:111.35,y:-42.15,startPosition:47},4).to({startPosition:53},6).to({regX:-0.1,regY:-0.3,scaleY:0.9998,skewX:6.9169,skewY:-173.0845,x:93.6,y:-35.45,startPosition:69},16).to({scaleX:0.9499,skewX:20.4753,skewY:-159.5253,x:150.45,y:-22.6,startPosition:100},31,cjs.Ease.cubicInOut).to({scaleX:0.95,skewX:6.9169,skewY:-173.0845,x:93.6,y:-35.45,startPosition:131},31,cjs.Ease.cubicInOut).to({scaleX:0.9499,skewX:20.4753,skewY:-159.5253,x:150.45,y:-22.6,startPosition:162},31,cjs.Ease.cubicInOut).to({scaleX:0.95,skewX:6.9169,skewY:-173.0845,x:93.6,y:-35.45,startPosition:193},31,cjs.Ease.cubicInOut).to({scaleX:0.9499,skewX:20.4753,skewY:-159.5253,x:150.45,y:-22.6,startPosition:224},31,cjs.Ease.cubicInOut).to({scaleX:0.95,skewX:6.9169,skewY:-173.0845,x:93.6,y:-35.45,startPosition:255},31,cjs.Ease.cubicInOut).to({regY:-0.5,scaleX:0.9499,skewX:15.1233,skewY:-164.8793,x:127.75,y:-28.9,startPosition:271},16,cjs.Ease.cubicInOut).wait(1).to({regX:-26,regY:-13,skewX:15.0985,skewY:-164.904,x:154.65,y:-34.5,startPosition:272},0).wait(1).to({skewX:15.052,skewY:-164.9506,x:154.5,y:-34.6,startPosition:273},0).wait(1).to({skewX:14.9785,skewY:-165.024,x:154.2,y:-34.65,startPosition:274},0).wait(1).to({skewX:14.871,skewY:-165.1315,x:153.85,y:-34.8,startPosition:275},0).wait(1).to({skewX:14.7191,skewY:-165.2834,x:153.3,y:-35.05,startPosition:276},0).wait(1).to({skewX:14.5077,skewY:-165.4947,x:152.55,y:-35.35,startPosition:277},0).wait(1).to({skewX:14.2145,skewY:-165.7878,x:151.55,y:-35.8,startPosition:278},0).wait(1).to({skewX:13.8103,skewY:-166.1919,x:150.15,y:-36.35,startPosition:279},0).wait(1).to({skewX:13.2797,skewY:-166.7224,x:148.3,y:-37.15,startPosition:280},0).wait(1).to({skewX:12.6862,skewY:-167.3157,x:146.2,y:-38,startPosition:281},0).wait(1).to({skewX:12.165,skewY:-167.8368,x:144.4,y:-38.7,startPosition:282},0).wait(1).to({skewX:11.7754,skewY:-168.2263,x:143.05,y:-39.25,startPosition:283},0).wait(1).to({regX:-0.1,regY:-0.5,scaleY:0.9997,skewX:11.4988,skewY:-168.5029,x:115.45,y:-32.4,startPosition:284},0).to({_off:true},1).wait(6));

	// lijf
	this.instance_4 = new lib.bodyRobbieZwaai();
	this.instance_4.setTransform(-68.1,151.75,1,1,14.9983);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(284).to({_off:true},1).wait(6));

	// Layer_6
	this.instance_5 = new lib.armachter_feedback();
	this.instance_5.setTransform(410.2,287,0.9925,1,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(284).to({_off:true},1).wait(6));

	// benen
	this.instance_6 = new lib.benen();
	this.instance_6.setTransform(-143,335.1,1,1,14.9983);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(284).to({_off:true},1).wait(6));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-349.6,-399.2,927.3000000000001,1065.5);


(lib.progressionPath = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {scenario_1:0,scenario_2:213,scenario_3:308,scenario_4:384,scenario_5:450,passive_3:537};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_212 = function() {
		this.stop();
	}
	this.frame_307 = function() {
		this.stop();
	}
	this.frame_383 = function() {
		this.stop();
	}
	this.frame_449 = function() {
		this.stop();
	}
	this.frame_536 = function() {
		this.stop();
	}
	this.frame_578 = function() {
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(212).call(this.frame_212).wait(95).call(this.frame_307).wait(76).call(this.frame_383).wait(66).call(this.frame_449).wait(87).call(this.frame_536).wait(42).call(this.frame_578).wait(1));

	// pinpoint5
	this.instance = new lib.pinpoint_popup("synched",0,false);
	this.instance.setTransform(-516.95,153.55,1,1,0,0,0,0,-86.5);

	this.instance_1 = new lib.Pinpoint_05on("synched",0,false);
	this.instance_1.setTransform(-516.95,153.55,1,1,0,0,0,0,-86.5);

	this.instance_2 = new lib.Pinpoint_05done("synched",0,false);
	this.instance_2.setTransform(-516.95,153.55,1,1,0,0,0,0,-86.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance}]},69).to({state:[{t:this.instance_1}]},441).to({state:[{t:this.instance_2}]},27).wait(42));

	// pinpoint4
	this.instance_3 = new lib.pinpoint_popup("synched",0,false);
	this.instance_3.setTransform(507.35,151.5,1,1,0,0,0,0,-86.5);

	this.instance_4 = new lib.Pinpoint_04on("synched",0,false);
	this.instance_4.setTransform(507.35,151.5,1,1,0,0,0,0,-86.5);

	this.instance_5 = new lib.Pinpoint_04done("synched",0,false);
	this.instance_5.setTransform(507.35,151.5,1,1,0,0,0,0,-86.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_3}]},47).to({state:[{t:this.instance_4}]},379).to({state:[{t:this.instance_5}]},24).wait(129));

	// pinpoint3
	this.instance_6 = new lib.pinpoint_popup("synched",0,false);
	this.instance_6.setTransform(220.75,-73.6,1,1,0,0,0,0,-86.5);

	this.instance_7 = new lib.Pinpoint_03on("synched",0,false);
	this.instance_7.setTransform(220.25,-73.6,1,1,0,0,0,0,-86.5);

	this.instance_8 = new lib.Pinpoint_03done("synched",0,false);
	this.instance_8.setTransform(220.25,-73.6,1,1,0,0,0,0,-86.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_6}]},38).to({state:[{t:this.instance_7}]},322).to({state:[{t:this.instance_8}]},24).wait(195));

	// pinpoint2
	this.instance_9 = new lib.pinpoint_popup("synched",0,false);
	this.instance_9.setTransform(-37.25,-345.85,1,1,0,0,0,0,-86.5);

	this.instance_10 = new lib.Pinpoint_02on("synched",0,false);
	this.instance_10.setTransform(-37.75,-345.85,1,1,0,0,0,0,-86.5);

	this.instance_11 = new lib.Pinpoint_02done("synched",0,false);
	this.instance_11.setTransform(-37.75,-345.85,1,1,0,0,0,0,-86.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_9}]},27).to({state:[{t:this.instance_10}]},253).to({state:[{t:this.instance_11}]},28).wait(271));

	// pinpoint1
	this.instance_12 = new lib.pinpoint_popup("synched",0,false);
	this.instance_12.setTransform(-106.2,-49.6,1,1,0,0,0,0,-86.5);

	this.instance_13 = new lib.Pinpoint_01on("synched",0,false);
	this.instance_13.setTransform(-106.85,-49.7,1,1,0,0,0,0,-86.5);

	this.instance_14 = new lib.Pinpoint_01done("synched",0,false);
	this.instance_14.setTransform(-106.85,-49.7,1,1,0,0,0,0,-86.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_12}]},8).to({state:[{t:this.instance_13}]},167).to({state:[{t:this.instance_14}]},38).wait(366));

	// dot5
	this.instance_15 = new lib.mapPoint("synched",0,false);
	this.instance_15.setTransform(-514.5,221.9);
	this.instance_15._off = true;
	var instance_15Filter_1 = new cjs.ColorFilter(1,1,1,1,0,0,0,0);
	this.instance_15.filters = [instance_15Filter_1];
	this.instance_15.cache(-31,-20,63,40);

	this.timeline.addTween(cjs.Tween.get(this.instance_15).wait(69).to({_off:false},0).wait(441).to({startPosition:136},0).to({startPosition:136},7).to({startPosition:136},20).to({startPosition:136},24).wait(18));
	this.timeline.addTween(cjs.Tween.get(instance_15Filter_1).wait(510).to(new cjs.ColorFilter(1,1,1,1,0,0,0,0), 0).to(new cjs.ColorFilter(0,0,0,1,255,100,20,0), 7).wait(20).to(new cjs.ColorFilter(0,0,0,1,43,177,180,0), 24).wait(18));

	// dot4
	this.instance_16 = new lib.mapPoint("synched",0,false);
	this.instance_16.setTransform(508.15,217.9);
	this.instance_16._off = true;
	var instance_16Filter_2 = new cjs.ColorFilter(1,1,1,1,0,0,0,0);
	this.instance_16.filters = [instance_16Filter_2];
	this.instance_16.cache(-31,-20,63,40);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).wait(47).to({_off:false},0).wait(379).to({startPosition:136},0).to({startPosition:136},12).to({startPosition:136},12).to({startPosition:136},16).wait(113));
	this.timeline.addTween(cjs.Tween.get(instance_16Filter_2).wait(426).to(new cjs.ColorFilter(1,1,1,1,0,0,0,0), 0).to(new cjs.ColorFilter(0,0,0,1,255,100,20,0), 12).wait(12).to(new cjs.ColorFilter(0,0,0,1,43,177,180,0), 16).wait(113));

	// dot3
	this.instance_17 = new lib.mapPoint("synched",0,false);
	this.instance_17.setTransform(219,-6.5);
	this.instance_17._off = true;
	var instance_17Filter_3 = new cjs.ColorFilter(1,1,1,1,0,0,0,0);
	this.instance_17.filters = [instance_17Filter_3];
	this.instance_17.cache(-31,-20,63,40);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).wait(37).to({_off:false},0).wait(323).to({startPosition:136},0).to({startPosition:136},14).to({startPosition:136},10).to({startPosition:136},10).wait(185));
	this.timeline.addTween(cjs.Tween.get(instance_17Filter_3).wait(360).to(new cjs.ColorFilter(1,1,1,1,0,0,0,0), 0).to(new cjs.ColorFilter(0,0,0,1,255,100,20,0), 14).wait(10).to(new cjs.ColorFilter(0,0,0,1,43,177,180,0), 10).wait(185));

	// dot2
	this.instance_18 = new lib.mapPoint("synched",0,false);
	this.instance_18.setTransform(-38.15,-277.45);
	this.instance_18._off = true;
	var instance_18Filter_4 = new cjs.ColorFilter(1,1,1,1,0,0,0,0);
	this.instance_18.filters = [instance_18Filter_4];
	this.instance_18.cache(-31,-20,63,40);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).wait(26).to({_off:false},0).wait(254).to({startPosition:136},0).to({startPosition:136},7).to({startPosition:136},21).to({startPosition:136},22).wait(249));
	this.timeline.addTween(cjs.Tween.get(instance_18Filter_4).wait(280).to(new cjs.ColorFilter(1,1,1,1,0,0,0,0), 0).to(new cjs.ColorFilter(0,0,0,1,254,117,15,0), 7).wait(21).to(new cjs.ColorFilter(0,0,0,1,43,177,180,0), 22).wait(249));

	// dot1
	this.instance_19 = new lib.mapPoint("synched",0,false);
	this.instance_19.setTransform(-106.1,19.5);
	this.instance_19._off = true;
	var instance_19Filter_5 = new cjs.ColorFilter(1,1,1,1,0,0,0,0);
	this.instance_19.filters = [instance_19Filter_5];
	this.instance_19.cache(-31,-20,63,40);

	this.timeline.addTween(cjs.Tween.get(this.instance_19).wait(8).to({_off:false},0).wait(167).to({startPosition:103},0).wait(38).to({startPosition:135},0).to({startPosition:136},15).to({startPosition:136},102).wait(249));
	this.timeline.addTween(cjs.Tween.get(instance_19Filter_5).wait(175).to(new cjs.ColorFilter(0,0,0,1,254,117,15,0), 0).wait(38).to(new cjs.ColorFilter(0,0,0,1,43,177,180,0), 15).wait(351));

	// pathMove
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#2BB1B4").s().p("EBRgAkvQBFhqAPhrIAyAHQgQB0hNB2gEBQYAa2IAlgiQBdBpArBpIgvATQgphjhVhggEhS+AdGQgngnAAg3QAAg3AngnQAngnA4AAQA2AAAnAnQAnAnAAA3QAAA3gnAnQgnAng2AAQg4AAgngngEhMrAZgIDVhKIAPAwIjTBKgEBKjAWKIAagqQBxBFBaBHIgfAnQhVhDhxhGgEhGCAXNIDVhIIAQAvIjVBJgEg/ZAU9IDVhHIAQAvIjVBHgEBD4ASpIAVgtQBxAzBrA4IgYAsQhng2hyg0gEg4uASvIBrgjQA3gSA3gPIANAxQgvAMg9AUIhqAjgEgx1AQ3QBngWB7gUIAIAxQiDAWhdAUgEA84APxIARguQBuAoB1AwIgTAuQhpgrh4gtgEgqxAPqIDjgfIAGAyIjhAfgEgjrAOtIDigfIAHAyIjjAfgEA1sANWIAPgwQCGAqBiAhIgQAwQh3gphwgigA8oNrQB+gWBhgWIAMAwQhaAWiIAXgA1yL+QCGg2AjhCIAsAXQgqBSiYA9gEAuaALPIANgwQBjAaCIAnIgOAwQhmgdiEgkgEAo8AJ5IgCAAIAAgBIgBAAIgBAAQg2gQg3gUIAQgvIBsAjIByAbIgLAwgEAgnAGVIAcgqQBRA2B0AzIgUAuQh3g0hWg5gA1IGDQgogjgpgfIAdgoQAoAdAtAnQAwArAkArIgnAfQggglgugqgEg2wAFBQBtgGBugVIAJAxQhyAWhwAGgEg9yAE/IAOgwQBlAhByAMIgFAyQh3gNhpgigEgv+ADwQAsgNA+gXIBmgiIAQAvQgwAPg1AUQg8AVgwAOgAeXgEIAqAaQhABkAtBbIgtAWQg6h0BQh7gEhCfACRQgvg2gDhGIAygCQACA1AkAnQAdAhA1AjIgcApQg5glgjgmgA8RCMIAOgxQBsAeBgAvIgWAtQhcgthogcgEgpfABuQBqgaBrgQIAHAxQhgAPhvAbgEgixABhIgCgyQBygFBnALIgFAxQhlgKhtAFgEAg+gCqQBQg8Byg/IAYAsQhuA+hOA5gEhBtgDQQBHhTBxhMIAcApQhsBKhDBMgEAnNgGNIBogvIBygxIATAuIhwAxIhoAvgEg7kgHnQBngyB2gsIARAuQhzAshlAxgEAuGgJLQgCAFAEAGIADAEIgCgBIgOgFQgigJiWgVIAHgxIBzARQAzAIAXAGQAOADALAFQANAHAHALQAIASgKAQQgGAKgMAHgEg0kgKRQBqgfB+gdIALAwQh6AdhrAfgEAjcgKxIAKgxQBrAVCGAWIgIAyQh0gUh/gYgEgtSgL+IB2gUIB2gUIAJAxQhEANgzAIIh1AUgAb6saIAMgxQBmAZCKAeIgMAxQh1gah7gdgEgl9gNYQB7gfBngmIARAvQhmAmiAAhgAWTt3Qg6gQg+gUIAPgvQA2ARBAASIB3AgIgNAwgA/HwAQBmg8BVhRIAiAlQhZBUhqA/gANVxkIAZgsQBtA/BsAwIgUAtQhwgwhuhAgAHG2MIAhglQBeBWBeBFIgeApQhlhMhahTgA5v08QAug6BjiEIAoAeQh4CegaAhgAB275IAngfQBcByBCBIIglAiQhKhThWhqgA1I62QBQhgBQhUIAkAiQhQBVhPBdgEgC+gh2IAkgiQBABDBfB7IgmAfQheh4g/hDgEgP9ggUQA7g4AegaQAzguAtgiIAfAoQg0AogqAmQgqAlgvArgEgJXgkEIgQgvQCIgvB5AxIgTAuQhngqh3Apg");
	this.shape.setTransform(11.05,-44.1946);
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(467).to({_off:false},0).wait(112));

	// pathMove
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#2BB1B4").s().p("EhAnAg1QgngnAAg3QAAg3AngnQAngnA4AAQA3AAAnAnQAnAnAAA3QAAA3gnAnQgnAng3AAQg4AAgngngEg6UAdPIDVhKIAQAwIjUBKgEgzrAa8IDVhIIAQAvIjVBJgEgtCAYsIDWhHIAPAvIjVBHgEgmXAWeIBrgjQA4gSA2gPIANAxQguAMg+AUIhqAjgA/eUmQBngWB7gUIAIAxQiDAWhdAUgA4aTZIDjgfIAHAyIjiAfgAxUScIDigfIAIAyIjjAfgAqRRaQB/gWBhgWIALAwQhaAWiIAXgAjaPtQCGg2AihCIAtAXQgrBSiYA9gAixJyQgngjgqgfIAdgoQAoAdAtAnQAxArAjArIgnAfQgfglgvgqgEgkZAIwQBtgGBugVIAKAxQhzAWhwAGgEgrbAIuIAPgwQBkAhBzAMIgGAyQh3gNhpgigA9nHfQAsgNA+gXIBmgiIAQAvQgwAPg1AUQg7AVgxAOgEAwuADqIAqAbQhABkAtBbIgtAWQg6h0BQh8gEgwHAGAQgwg2gDhGIAygCQADA1AjAnQAdAhA1AjIgcApQg4glgjgmgAp5F7IANgxQBsAeBgAvIgVAtQhdgthngcgA3HFdQBqgaBqgQIAHAxQhgAPhvAbgAwaFQIgCgyQBygFBnALIgEAxQhmgKhtAFgEAzVABEQBQg8Bzg+IAYAsQhvA9hOA5gEgvWAAeQBHhSBxhMIAcApQhsBKhCBLgEA5kgCeIBogvIBygxIATAuIhwAxIhoAvgEgpNgD4QBngyB2gsIASAuQh0AshlAxgEBAdgFcQgBAFADAGIADAEIgBgBIgPgFQgigJiWgVIAHgxIBzARQAzAIAXAGQAOADALAFQAOAHAGALQAJASgLAQQgFAKgNAHgEgiMgGiQBqgfB9gdIAMAwQh7AdhqAfgEA10gHCIAJgxQBrAVCHAWIgIAyQh1gUh+gYgA66oPIB2gUIB1gUIAJAxQhDANg0AIIh0AUgEAuRgIrIAMgxQBmAZCKAeIgLAxQh2gah7gdgAzmppQB8gfBmgmIASAvQhmAmiBAhgEAoqgKIQg6gQg+gUIAQgvQA2ARA/ASIB3AgIgMAwgAsvsRQBlg8BVhRIAiAlQhYBUhrA/gAfst1IAZgsQBuA/BrAwIgUAtQhvgwhvhAgAZdydIAhglQBeBWBeBFIgeApQhlhMhahTgAnYxNQAug6BjiEIAoAeQh4CegaAhgAUN4KIAngfQBdByBCBIIglAiQhLhThWhqgAix3HQBQhgBQhUIAjAiQhPBVhOBdgAPY+HIAkgiQBABDBgB7IgnAfQheh4g/hDgACZ8lQA7g4AegaQA0guAtgiIAeAoQg0AogqAmQgqAlguArgEAI/ggVIgQgvQCIgvB5AxIgTAuQhngqh3Apg");
	this.shape_1.setTransform(-106.4599,-68.0696);
	this.shape_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(395).to({_off:false},0).wait(184));

	// pathMove
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#2BB1B4").s().p("EgmXAg1QgognAAg3QAAg3AognQAngnA3AAQA3AAAnAnQAnAnAAA3QAAA3gnAnQgnAng3AAQg3AAgngngEggFAdPIDVhKIAQAwIjUBKgA5ba8IDUhIIAQAvIjVBJgAyyYsIDVhHIAPAvIjUBHgAsIWeIBrgjQA4gSA2gPIAOAxQgvAMg9AUIhrAjgAlPUmQBogWB6gUIAIAxQiCAWheAUgAB1TZIDjgfIAGAyIjiAfgAI6ScIDigfIAIAyIjjAfgAP9RaQB/gWBhgWIALAwQhaAWiIAXgAW0PtQCGg2AjhCIAsAXQgrBSiXA9gAXdJyQgngjgqgfIAegoQAnAdAtAnQAxArAjArIgnAfQgfglgvgqgAqKIwQBtgGBvgVIAJAxQhzAWhvAGgAxMIuIAPgwQBlAhByAMIgGAyQh3gNhpgigAjXHfQArgNA+gXIBngiIAOAvQgvAPg1AUQg7AVgxAOgA14GAQgvg2gEhGIAzgCQACA1AjAnQAdAhA1AjIgcApQg4glgjgmgAQVF7IANgxQBsAeBhAvIgWAtQhcgthogcgADHFdQBqgaBqgQIAHAxQhgAPhvAbgAJ0FQIgCgyQBzgFBmALIgEAxQhlgKhuAFgA1HAeQBIhSBxhMIAbApQhsBKhCBLgAu+j4QBngyB3gsIARAuQh0AshkAxgAn9miQBqgfB+gdIALAwQh7AdhqAfgAgroPIB1gUIB2gUIAJAxQhEANgzAIIh0AUgAGpppQB7gfBngmIARAvQhmAmiBAhgANfsRQBlg8BVhRIAiAlQhYBUhrA/gAS3xNQAtg6BkiEIAnAeQh3CegbAhgAXd3HQBQhgBQhUIAkAiQhPBVhPBdgAco8lQA7g4AegaQA0guAtgiIAeAoQg0AogpAmQgqAlgvArgEAjOggVIgQgvQCJgvB5AxIgTAuQhogqh3Apg");
	this.shape_2.setTransform(-274.4,-68.0696);
	this.shape_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(330).to({_off:false},0).wait(249));

	// pathselected
	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.lf(["#FF5E00","#FF6821"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_3.setTransform(-510.625,132.625);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_4.setTransform(-468.325,117.725);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_5.setTransform(-425.825,103.1);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_6.setTransform(-340.575,74.725);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_7.setTransform(-383.3,88.725);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_8.setTransform(-296.25,64.05);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_9.setTransform(-251.075,56.95);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_10.setTransform(-205.675,50.875);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_11.setTransform(-160.5,43.575);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.lf(["#FF5E00","#FF6821"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_12.setTransform(-117.75,28.75);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.lf(["#F1640C","#F16D2B"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_13.setTransform(-510.625,132.625);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.lf(["#F1640C","#F16D2B"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_14.setTransform(-468.325,117.725);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.lf(["#F1640C","#F16D2B"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_15.setTransform(-425.825,103.1);

	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.lf(["#F1640C","#F16D2B"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_16.setTransform(-340.575,74.725);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.lf(["#F1640C","#F16D2B"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_17.setTransform(-383.3,88.725);

	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.lf(["#F1640C","#F16D2B"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_18.setTransform(-296.25,64.05);

	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.lf(["#F1640C","#F16D2B"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_19.setTransform(-251.075,56.95);

	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.lf(["#F1640C","#F16D2B"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_20.setTransform(-205.675,50.875);

	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.lf(["#F1640C","#F16D2B"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_21.setTransform(-160.5,43.575);

	this.shape_22 = new cjs.Shape();
	this.shape_22.graphics.lf(["#F1640C","#F16D2B"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_22.setTransform(-117.75,28.75);

	this.shape_23 = new cjs.Shape();
	this.shape_23.graphics.lf(["#E36918","#E37235"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_23.setTransform(-510.625,132.625);

	this.shape_24 = new cjs.Shape();
	this.shape_24.graphics.lf(["#E36918","#E37235"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_24.setTransform(-468.325,117.725);

	this.shape_25 = new cjs.Shape();
	this.shape_25.graphics.lf(["#E36918","#E37235"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_25.setTransform(-425.825,103.1);

	this.shape_26 = new cjs.Shape();
	this.shape_26.graphics.lf(["#E36918","#E37235"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_26.setTransform(-340.575,74.725);

	this.shape_27 = new cjs.Shape();
	this.shape_27.graphics.lf(["#E36918","#E37235"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_27.setTransform(-383.3,88.725);

	this.shape_28 = new cjs.Shape();
	this.shape_28.graphics.lf(["#E36918","#E37235"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_28.setTransform(-296.25,64.05);

	this.shape_29 = new cjs.Shape();
	this.shape_29.graphics.lf(["#E36918","#E37235"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_29.setTransform(-251.075,56.95);

	this.shape_30 = new cjs.Shape();
	this.shape_30.graphics.lf(["#E36918","#E37235"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_30.setTransform(-205.675,50.875);

	this.shape_31 = new cjs.Shape();
	this.shape_31.graphics.lf(["#E36918","#E37235"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_31.setTransform(-160.5,43.575);

	this.shape_32 = new cjs.Shape();
	this.shape_32.graphics.lf(["#E36918","#E37235"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_32.setTransform(-117.75,28.75);

	this.shape_33 = new cjs.Shape();
	this.shape_33.graphics.lf(["#D56F24","#D5773E"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_33.setTransform(-510.625,132.625);

	this.shape_34 = new cjs.Shape();
	this.shape_34.graphics.lf(["#D56F24","#D5773E"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_34.setTransform(-468.325,117.725);

	this.shape_35 = new cjs.Shape();
	this.shape_35.graphics.lf(["#D56F24","#D5773E"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_35.setTransform(-425.825,103.1);

	this.shape_36 = new cjs.Shape();
	this.shape_36.graphics.lf(["#D56F24","#D5773E"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_36.setTransform(-340.575,74.725);

	this.shape_37 = new cjs.Shape();
	this.shape_37.graphics.lf(["#D56F24","#D5773E"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_37.setTransform(-383.3,88.725);

	this.shape_38 = new cjs.Shape();
	this.shape_38.graphics.lf(["#D56F24","#D5773E"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_38.setTransform(-296.25,64.05);

	this.shape_39 = new cjs.Shape();
	this.shape_39.graphics.lf(["#D56F24","#D5773E"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_39.setTransform(-251.075,56.95);

	this.shape_40 = new cjs.Shape();
	this.shape_40.graphics.lf(["#D56F24","#D5773E"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_40.setTransform(-205.675,50.875);

	this.shape_41 = new cjs.Shape();
	this.shape_41.graphics.lf(["#D56F24","#D5773E"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_41.setTransform(-160.5,43.575);

	this.shape_42 = new cjs.Shape();
	this.shape_42.graphics.lf(["#D56F24","#D5773E"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_42.setTransform(-117.75,28.75);

	this.shape_43 = new cjs.Shape();
	this.shape_43.graphics.lf(["#C67430","#C67B48"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_43.setTransform(-510.625,132.625);

	this.shape_44 = new cjs.Shape();
	this.shape_44.graphics.lf(["#C67430","#C67B48"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_44.setTransform(-468.325,117.725);

	this.shape_45 = new cjs.Shape();
	this.shape_45.graphics.lf(["#C67430","#C67B48"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_45.setTransform(-425.825,103.1);

	this.shape_46 = new cjs.Shape();
	this.shape_46.graphics.lf(["#C67430","#C67B48"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_46.setTransform(-340.575,74.725);

	this.shape_47 = new cjs.Shape();
	this.shape_47.graphics.lf(["#C67430","#C67B48"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_47.setTransform(-383.3,88.725);

	this.shape_48 = new cjs.Shape();
	this.shape_48.graphics.lf(["#C67430","#C67B48"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_48.setTransform(-296.25,64.05);

	this.shape_49 = new cjs.Shape();
	this.shape_49.graphics.lf(["#C67430","#C67B48"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_49.setTransform(-251.075,56.95);

	this.shape_50 = new cjs.Shape();
	this.shape_50.graphics.lf(["#C67430","#C67B48"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_50.setTransform(-205.675,50.875);

	this.shape_51 = new cjs.Shape();
	this.shape_51.graphics.lf(["#C67430","#C67B48"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_51.setTransform(-160.5,43.575);

	this.shape_52 = new cjs.Shape();
	this.shape_52.graphics.lf(["#C67430","#C67B48"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_52.setTransform(-117.75,28.75);

	this.shape_53 = new cjs.Shape();
	this.shape_53.graphics.lf(["#B87A3C","#B88052"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_53.setTransform(-510.625,132.625);

	this.shape_54 = new cjs.Shape();
	this.shape_54.graphics.lf(["#B87A3C","#B88052"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_54.setTransform(-468.325,117.725);

	this.shape_55 = new cjs.Shape();
	this.shape_55.graphics.lf(["#B87A3C","#B88052"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_55.setTransform(-425.825,103.1);

	this.shape_56 = new cjs.Shape();
	this.shape_56.graphics.lf(["#B87A3C","#B88052"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_56.setTransform(-340.575,74.725);

	this.shape_57 = new cjs.Shape();
	this.shape_57.graphics.lf(["#B87A3C","#B88052"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_57.setTransform(-383.3,88.725);

	this.shape_58 = new cjs.Shape();
	this.shape_58.graphics.lf(["#B87A3C","#B88052"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_58.setTransform(-296.25,64.05);

	this.shape_59 = new cjs.Shape();
	this.shape_59.graphics.lf(["#B87A3C","#B88052"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_59.setTransform(-251.075,56.95);

	this.shape_60 = new cjs.Shape();
	this.shape_60.graphics.lf(["#B87A3C","#B88052"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_60.setTransform(-205.675,50.875);

	this.shape_61 = new cjs.Shape();
	this.shape_61.graphics.lf(["#B87A3C","#B88052"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_61.setTransform(-160.5,43.575);

	this.shape_62 = new cjs.Shape();
	this.shape_62.graphics.lf(["#B87A3C","#B88052"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_62.setTransform(-117.75,28.75);

	this.shape_63 = new cjs.Shape();
	this.shape_63.graphics.lf(["#AA7F48","#AA855C"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_63.setTransform(-510.625,132.625);

	this.shape_64 = new cjs.Shape();
	this.shape_64.graphics.lf(["#AA7F48","#AA855C"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_64.setTransform(-468.325,117.725);

	this.shape_65 = new cjs.Shape();
	this.shape_65.graphics.lf(["#AA7F48","#AA855C"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_65.setTransform(-425.825,103.1);

	this.shape_66 = new cjs.Shape();
	this.shape_66.graphics.lf(["#AA7F48","#AA855C"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_66.setTransform(-340.575,74.725);

	this.shape_67 = new cjs.Shape();
	this.shape_67.graphics.lf(["#AA7F48","#AA855C"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_67.setTransform(-383.3,88.725);

	this.shape_68 = new cjs.Shape();
	this.shape_68.graphics.lf(["#AA7F48","#AA855C"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_68.setTransform(-296.25,64.05);

	this.shape_69 = new cjs.Shape();
	this.shape_69.graphics.lf(["#AA7F48","#AA855C"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_69.setTransform(-251.075,56.95);

	this.shape_70 = new cjs.Shape();
	this.shape_70.graphics.lf(["#AA7F48","#AA855C"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_70.setTransform(-205.675,50.875);

	this.shape_71 = new cjs.Shape();
	this.shape_71.graphics.lf(["#AA7F48","#AA855C"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_71.setTransform(-160.5,43.575);

	this.shape_72 = new cjs.Shape();
	this.shape_72.graphics.lf(["#AA7F48","#AA855C"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_72.setTransform(-117.75,28.75);

	this.shape_73 = new cjs.Shape();
	this.shape_73.graphics.lf(["#9C8554","#9C8A66"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_73.setTransform(-510.625,132.625);

	this.shape_74 = new cjs.Shape();
	this.shape_74.graphics.lf(["#9C8554","#9C8A66"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_74.setTransform(-468.325,117.725);

	this.shape_75 = new cjs.Shape();
	this.shape_75.graphics.lf(["#9C8554","#9C8A66"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_75.setTransform(-425.825,103.1);

	this.shape_76 = new cjs.Shape();
	this.shape_76.graphics.lf(["#9C8554","#9C8A66"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_76.setTransform(-340.575,74.725);

	this.shape_77 = new cjs.Shape();
	this.shape_77.graphics.lf(["#9C8554","#9C8A66"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_77.setTransform(-383.3,88.725);

	this.shape_78 = new cjs.Shape();
	this.shape_78.graphics.lf(["#9C8554","#9C8A66"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_78.setTransform(-296.25,64.05);

	this.shape_79 = new cjs.Shape();
	this.shape_79.graphics.lf(["#9C8554","#9C8A66"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_79.setTransform(-251.075,56.95);

	this.shape_80 = new cjs.Shape();
	this.shape_80.graphics.lf(["#9C8554","#9C8A66"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_80.setTransform(-205.675,50.875);

	this.shape_81 = new cjs.Shape();
	this.shape_81.graphics.lf(["#9C8554","#9C8A66"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_81.setTransform(-160.5,43.575);

	this.shape_82 = new cjs.Shape();
	this.shape_82.graphics.lf(["#9C8554","#9C8A66"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_82.setTransform(-117.75,28.75);

	this.shape_83 = new cjs.Shape();
	this.shape_83.graphics.lf(["#8E8A60","#8E8F6F"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_83.setTransform(-510.625,132.625);

	this.shape_84 = new cjs.Shape();
	this.shape_84.graphics.lf(["#8E8A60","#8E8F6F"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_84.setTransform(-468.325,117.725);

	this.shape_85 = new cjs.Shape();
	this.shape_85.graphics.lf(["#8E8A60","#8E8F6F"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_85.setTransform(-425.825,103.1);

	this.shape_86 = new cjs.Shape();
	this.shape_86.graphics.lf(["#8E8A60","#8E8F6F"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_86.setTransform(-340.575,74.725);

	this.shape_87 = new cjs.Shape();
	this.shape_87.graphics.lf(["#8E8A60","#8E8F6F"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_87.setTransform(-383.3,88.725);

	this.shape_88 = new cjs.Shape();
	this.shape_88.graphics.lf(["#8E8A60","#8E8F6F"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_88.setTransform(-296.25,64.05);

	this.shape_89 = new cjs.Shape();
	this.shape_89.graphics.lf(["#8E8A60","#8E8F6F"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_89.setTransform(-251.075,56.95);

	this.shape_90 = new cjs.Shape();
	this.shape_90.graphics.lf(["#8E8A60","#8E8F6F"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_90.setTransform(-205.675,50.875);

	this.shape_91 = new cjs.Shape();
	this.shape_91.graphics.lf(["#8E8A60","#8E8F6F"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_91.setTransform(-160.5,43.575);

	this.shape_92 = new cjs.Shape();
	this.shape_92.graphics.lf(["#8E8A60","#8E8F6F"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_92.setTransform(-117.75,28.75);

	this.shape_93 = new cjs.Shape();
	this.shape_93.graphics.lf(["#80906C","#809479"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_93.setTransform(-510.625,132.625);

	this.shape_94 = new cjs.Shape();
	this.shape_94.graphics.lf(["#80906C","#809479"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_94.setTransform(-468.325,117.725);

	this.shape_95 = new cjs.Shape();
	this.shape_95.graphics.lf(["#80906C","#809479"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_95.setTransform(-425.825,103.1);

	this.shape_96 = new cjs.Shape();
	this.shape_96.graphics.lf(["#80906C","#809479"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_96.setTransform(-340.575,74.725);

	this.shape_97 = new cjs.Shape();
	this.shape_97.graphics.lf(["#80906C","#809479"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_97.setTransform(-383.3,88.725);

	this.shape_98 = new cjs.Shape();
	this.shape_98.graphics.lf(["#80906C","#809479"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_98.setTransform(-296.25,64.05);

	this.shape_99 = new cjs.Shape();
	this.shape_99.graphics.lf(["#80906C","#809479"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_99.setTransform(-251.075,56.95);

	this.shape_100 = new cjs.Shape();
	this.shape_100.graphics.lf(["#80906C","#809479"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_100.setTransform(-205.675,50.875);

	this.shape_101 = new cjs.Shape();
	this.shape_101.graphics.lf(["#80906C","#809479"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_101.setTransform(-160.5,43.575);

	this.shape_102 = new cjs.Shape();
	this.shape_102.graphics.lf(["#80906C","#809479"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_102.setTransform(-117.75,28.75);

	this.shape_103 = new cjs.Shape();
	this.shape_103.graphics.lf(["#729578","#729983"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_103.setTransform(-510.625,132.625);

	this.shape_104 = new cjs.Shape();
	this.shape_104.graphics.lf(["#729578","#729983"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_104.setTransform(-468.325,117.725);

	this.shape_105 = new cjs.Shape();
	this.shape_105.graphics.lf(["#729578","#729983"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_105.setTransform(-425.825,103.1);

	this.shape_106 = new cjs.Shape();
	this.shape_106.graphics.lf(["#729578","#729983"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_106.setTransform(-340.575,74.725);

	this.shape_107 = new cjs.Shape();
	this.shape_107.graphics.lf(["#729578","#729983"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_107.setTransform(-383.3,88.725);

	this.shape_108 = new cjs.Shape();
	this.shape_108.graphics.lf(["#729578","#729983"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_108.setTransform(-296.25,64.05);

	this.shape_109 = new cjs.Shape();
	this.shape_109.graphics.lf(["#729578","#729983"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_109.setTransform(-251.075,56.95);

	this.shape_110 = new cjs.Shape();
	this.shape_110.graphics.lf(["#729578","#729983"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_110.setTransform(-205.675,50.875);

	this.shape_111 = new cjs.Shape();
	this.shape_111.graphics.lf(["#729578","#729983"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_111.setTransform(-160.5,43.575);

	this.shape_112 = new cjs.Shape();
	this.shape_112.graphics.lf(["#729578","#729983"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_112.setTransform(-117.75,28.75);

	this.shape_113 = new cjs.Shape();
	this.shape_113.graphics.lf(["#649B84","#649E8D"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_113.setTransform(-510.625,132.625);

	this.shape_114 = new cjs.Shape();
	this.shape_114.graphics.lf(["#649B84","#649E8D"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_114.setTransform(-468.325,117.725);

	this.shape_115 = new cjs.Shape();
	this.shape_115.graphics.lf(["#649B84","#649E8D"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_115.setTransform(-425.825,103.1);

	this.shape_116 = new cjs.Shape();
	this.shape_116.graphics.lf(["#649B84","#649E8D"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_116.setTransform(-340.575,74.725);

	this.shape_117 = new cjs.Shape();
	this.shape_117.graphics.lf(["#649B84","#649E8D"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_117.setTransform(-383.3,88.725);

	this.shape_118 = new cjs.Shape();
	this.shape_118.graphics.lf(["#649B84","#649E8D"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_118.setTransform(-296.25,64.05);

	this.shape_119 = new cjs.Shape();
	this.shape_119.graphics.lf(["#649B84","#649E8D"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_119.setTransform(-251.075,56.95);

	this.shape_120 = new cjs.Shape();
	this.shape_120.graphics.lf(["#649B84","#649E8D"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_120.setTransform(-205.675,50.875);

	this.shape_121 = new cjs.Shape();
	this.shape_121.graphics.lf(["#649B84","#649E8D"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_121.setTransform(-160.5,43.575);

	this.shape_122 = new cjs.Shape();
	this.shape_122.graphics.lf(["#649B84","#649E8D"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_122.setTransform(-117.75,28.75);

	this.shape_123 = new cjs.Shape();
	this.shape_123.graphics.lf(["#55A090","#55A297"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_123.setTransform(-510.625,132.625);

	this.shape_124 = new cjs.Shape();
	this.shape_124.graphics.lf(["#55A090","#55A297"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_124.setTransform(-468.325,117.725);

	this.shape_125 = new cjs.Shape();
	this.shape_125.graphics.lf(["#55A090","#55A297"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_125.setTransform(-425.825,103.1);

	this.shape_126 = new cjs.Shape();
	this.shape_126.graphics.lf(["#55A090","#55A297"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_126.setTransform(-340.575,74.725);

	this.shape_127 = new cjs.Shape();
	this.shape_127.graphics.lf(["#55A090","#55A297"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_127.setTransform(-383.3,88.725);

	this.shape_128 = new cjs.Shape();
	this.shape_128.graphics.lf(["#55A090","#55A297"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_128.setTransform(-296.25,64.05);

	this.shape_129 = new cjs.Shape();
	this.shape_129.graphics.lf(["#55A090","#55A297"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_129.setTransform(-251.075,56.95);

	this.shape_130 = new cjs.Shape();
	this.shape_130.graphics.lf(["#55A090","#55A297"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_130.setTransform(-205.675,50.875);

	this.shape_131 = new cjs.Shape();
	this.shape_131.graphics.lf(["#55A090","#55A297"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_131.setTransform(-160.5,43.575);

	this.shape_132 = new cjs.Shape();
	this.shape_132.graphics.lf(["#55A090","#55A297"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_132.setTransform(-117.75,28.75);

	this.shape_133 = new cjs.Shape();
	this.shape_133.graphics.lf(["#47A69C","#47A7A0"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_133.setTransform(-510.625,132.625);

	this.shape_134 = new cjs.Shape();
	this.shape_134.graphics.lf(["#47A69C","#47A7A0"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_134.setTransform(-468.325,117.725);

	this.shape_135 = new cjs.Shape();
	this.shape_135.graphics.lf(["#47A69C","#47A7A0"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_135.setTransform(-425.825,103.1);

	this.shape_136 = new cjs.Shape();
	this.shape_136.graphics.lf(["#47A69C","#47A7A0"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_136.setTransform(-340.575,74.725);

	this.shape_137 = new cjs.Shape();
	this.shape_137.graphics.lf(["#47A69C","#47A7A0"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_137.setTransform(-383.3,88.725);

	this.shape_138 = new cjs.Shape();
	this.shape_138.graphics.lf(["#47A69C","#47A7A0"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_138.setTransform(-296.25,64.05);

	this.shape_139 = new cjs.Shape();
	this.shape_139.graphics.lf(["#47A69C","#47A7A0"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_139.setTransform(-251.075,56.95);

	this.shape_140 = new cjs.Shape();
	this.shape_140.graphics.lf(["#47A69C","#47A7A0"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_140.setTransform(-205.675,50.875);

	this.shape_141 = new cjs.Shape();
	this.shape_141.graphics.lf(["#47A69C","#47A7A0"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_141.setTransform(-160.5,43.575);

	this.shape_142 = new cjs.Shape();
	this.shape_142.graphics.lf(["#47A69C","#47A7A0"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_142.setTransform(-117.75,28.75);

	this.shape_143 = new cjs.Shape();
	this.shape_143.graphics.lf(["#39ABA8","#39ACAA"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_143.setTransform(-510.625,132.625);

	this.shape_144 = new cjs.Shape();
	this.shape_144.graphics.lf(["#39ABA8","#39ACAA"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_144.setTransform(-468.325,117.725);

	this.shape_145 = new cjs.Shape();
	this.shape_145.graphics.lf(["#39ABA8","#39ACAA"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_145.setTransform(-425.825,103.1);

	this.shape_146 = new cjs.Shape();
	this.shape_146.graphics.lf(["#39ABA8","#39ACAA"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_146.setTransform(-340.575,74.725);

	this.shape_147 = new cjs.Shape();
	this.shape_147.graphics.lf(["#39ABA8","#39ACAA"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_147.setTransform(-383.3,88.725);

	this.shape_148 = new cjs.Shape();
	this.shape_148.graphics.lf(["#39ABA8","#39ACAA"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_148.setTransform(-296.25,64.05);

	this.shape_149 = new cjs.Shape();
	this.shape_149.graphics.lf(["#39ABA8","#39ACAA"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_149.setTransform(-251.075,56.95);

	this.shape_150 = new cjs.Shape();
	this.shape_150.graphics.lf(["#39ABA8","#39ACAA"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_150.setTransform(-205.675,50.875);

	this.shape_151 = new cjs.Shape();
	this.shape_151.graphics.lf(["#39ABA8","#39ACAA"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_151.setTransform(-160.5,43.575);

	this.shape_152 = new cjs.Shape();
	this.shape_152.graphics.lf(["#39ABA8","#39ACAA"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_152.setTransform(-117.75,28.75);

	this.shape_153 = new cjs.Shape();
	this.shape_153.graphics.f("#2BB1B4").s().p("A/8JMQgngnAAg3QAAg3AngnQAngnA3AAQA3AAAnAnQAnAnAAA3QAAA3gnAnQgnAog3AAQg3AAgngogA5pFnIDUhKIAQAvIjUBKgAzADTIDUhIIAQAwIjUBIgAsXBDIDVhGIAQAvIjVBHgAlthJIBrgjQA4gTA3gPIANAxQgvAMg9AUIhrAjgABMjCQBngVB6gVIAJAxQiDAXhdATgAIQkOIDjggIAGAyIjiAfgAPWlLIDigfIAHAxIjjAfgAWZmOQB+gVBhgXIAMAwQhbAWiIAXgAdPn7QCGg2AjhCIAsAYQgqBRiYA+g");
	this.shape_153.setTransform(-315.525,83.2);
	this.shape_153._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3}]},213).to({state:[{t:this.shape_22},{t:this.shape_21},{t:this.shape_20},{t:this.shape_19},{t:this.shape_18},{t:this.shape_17},{t:this.shape_16},{t:this.shape_15},{t:this.shape_14},{t:this.shape_13}]},1).to({state:[{t:this.shape_32},{t:this.shape_31},{t:this.shape_30},{t:this.shape_29},{t:this.shape_28},{t:this.shape_27},{t:this.shape_26},{t:this.shape_25},{t:this.shape_24},{t:this.shape_23}]},1).to({state:[{t:this.shape_42},{t:this.shape_41},{t:this.shape_40},{t:this.shape_39},{t:this.shape_38},{t:this.shape_37},{t:this.shape_36},{t:this.shape_35},{t:this.shape_34},{t:this.shape_33}]},1).to({state:[{t:this.shape_52},{t:this.shape_51},{t:this.shape_50},{t:this.shape_49},{t:this.shape_48},{t:this.shape_47},{t:this.shape_46},{t:this.shape_45},{t:this.shape_44},{t:this.shape_43}]},1).to({state:[{t:this.shape_62},{t:this.shape_61},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55},{t:this.shape_54},{t:this.shape_53}]},1).to({state:[{t:this.shape_72},{t:this.shape_71},{t:this.shape_70},{t:this.shape_69},{t:this.shape_68},{t:this.shape_67},{t:this.shape_66},{t:this.shape_65},{t:this.shape_64},{t:this.shape_63}]},1).to({state:[{t:this.shape_82},{t:this.shape_81},{t:this.shape_80},{t:this.shape_79},{t:this.shape_78},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75},{t:this.shape_74},{t:this.shape_73}]},1).to({state:[{t:this.shape_92},{t:this.shape_91},{t:this.shape_90},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84},{t:this.shape_83}]},1).to({state:[{t:this.shape_102},{t:this.shape_101},{t:this.shape_100},{t:this.shape_99},{t:this.shape_98},{t:this.shape_97},{t:this.shape_96},{t:this.shape_95},{t:this.shape_94},{t:this.shape_93}]},1).to({state:[{t:this.shape_112},{t:this.shape_111},{t:this.shape_110},{t:this.shape_109},{t:this.shape_108},{t:this.shape_107},{t:this.shape_106},{t:this.shape_105},{t:this.shape_104},{t:this.shape_103}]},1).to({state:[{t:this.shape_122},{t:this.shape_121},{t:this.shape_120},{t:this.shape_119},{t:this.shape_118},{t:this.shape_117},{t:this.shape_116},{t:this.shape_115},{t:this.shape_114},{t:this.shape_113}]},1).to({state:[{t:this.shape_132},{t:this.shape_131},{t:this.shape_130},{t:this.shape_129},{t:this.shape_128},{t:this.shape_127},{t:this.shape_126},{t:this.shape_125},{t:this.shape_124},{t:this.shape_123}]},1).to({state:[{t:this.shape_142},{t:this.shape_141},{t:this.shape_140},{t:this.shape_139},{t:this.shape_138},{t:this.shape_137},{t:this.shape_136},{t:this.shape_135},{t:this.shape_134},{t:this.shape_133}]},1).to({state:[{t:this.shape_152},{t:this.shape_151},{t:this.shape_150},{t:this.shape_149},{t:this.shape_148},{t:this.shape_147},{t:this.shape_146},{t:this.shape_145},{t:this.shape_144},{t:this.shape_143}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_153}]},1).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.shape_153).wait(228).to({_off:false},0).wait(351));

	// pathMove
	this.shape_154 = new cjs.Shape();
	this.shape_154.graphics.lf(["#FF5E00","#FF6821"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_154.setTransform(-510.625,132.625);

	this.shape_155 = new cjs.Shape();
	this.shape_155.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_155.setTransform(-468.325,117.725);

	this.shape_156 = new cjs.Shape();
	this.shape_156.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_156.setTransform(-425.825,103.1);

	this.shape_157 = new cjs.Shape();
	this.shape_157.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_157.setTransform(-383.3,88.725);

	this.shape_158 = new cjs.Shape();
	this.shape_158.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_158.setTransform(-340.575,74.725);

	this.shape_159 = new cjs.Shape();
	this.shape_159.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_159.setTransform(-296.25,64.05);

	this.shape_160 = new cjs.Shape();
	this.shape_160.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_160.setTransform(-251.075,56.95);

	this.shape_161 = new cjs.Shape();
	this.shape_161.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_161.setTransform(-205.675,50.875);

	this.shape_162 = new cjs.Shape();
	this.shape_162.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_162.setTransform(-160.5,43.575);

	this.shape_163 = new cjs.Shape();
	this.shape_163.graphics.lf(["#FF5E00","#FF6821"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_163.setTransform(-117.75,28.75);

	this.shape_164 = new cjs.Shape();
	this.shape_164.graphics.lf(["#FF5E00","#FF6821"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_164.setTransform(-122.5,-6.825);

	this.shape_165 = new cjs.Shape();
	this.shape_165.graphics.lf(["#FF5E00","#FF6821"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_165.setTransform(-159.025,-28.975);

	this.shape_166 = new cjs.Shape();
	this.shape_166.graphics.lf(["#FF5E00","#FF6821"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_166.setTransform(-200.9,-36.7925);

	this.shape_167 = new cjs.Shape();
	this.shape_167.graphics.lf(["#FF5E00","#FF6821"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_167.setTransform(-243.525,-32.85);

	this.shape_168 = new cjs.Shape();
	this.shape_168.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_168.setTransform(-284.875,-21.325);

	this.shape_169 = new cjs.Shape();
	this.shape_169.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_169.setTransform(-328.05,-10.925);

	this.shape_170 = new cjs.Shape();
	this.shape_170.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_170.setTransform(-373,-12.325);

	this.shape_171 = new cjs.Shape();
	this.shape_171.graphics.lf(["#FF5E00","#FF6821"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_171.setTransform(-411.075,-32.2);

	this.shape_172 = new cjs.Shape();
	this.shape_172.graphics.lf(["#FF5E00","#FF6821"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_172.setTransform(-398.975,-71.425);

	this.shape_173 = new cjs.Shape();
	this.shape_173.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_173.setTransform(-358.325,-95.45);

	this.shape_174 = new cjs.Shape();
	this.shape_174.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_174.setTransform(-313.25,-110.575);

	this.shape_175 = new cjs.Shape();
	this.shape_175.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_175.setTransform(-266.575,-120.375);

	this.shape_176 = new cjs.Shape();
	this.shape_176.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_176.setTransform(-219.775,-130.875);

	this.shape_177 = new cjs.Shape();
	this.shape_177.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_177.setTransform(-177.075,-151.575);

	this.shape_178 = new cjs.Shape();
	this.shape_178.graphics.lf(["#FF5E00","#FF6821"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_178.setTransform(-144.525,-186.225);

	this.shape_179 = new cjs.Shape();
	this.shape_179.graphics.lf(["#FF5E00","#FF6821"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_179.setTransform(-114.5,-223.5);

	this.shape_180 = new cjs.Shape();
	this.shape_180.graphics.lf(["#FF5E00","#FF6821"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_180.setTransform(-80.375,-257.35);

	this.shape_181 = new cjs.Shape();
	this.shape_181.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_181.setTransform(-37.725,-278.5196);

	this.shape_182 = new cjs.Shape();
	this.shape_182.graphics.lf(["#F56209","#F56B28"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_182.setTransform(-510.625,132.625);

	this.shape_183 = new cjs.Shape();
	this.shape_183.graphics.lf(["#F56209","#F56B28"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_183.setTransform(-468.325,117.725);

	this.shape_184 = new cjs.Shape();
	this.shape_184.graphics.lf(["#F56209","#F56B28"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_184.setTransform(-425.825,103.1);

	this.shape_185 = new cjs.Shape();
	this.shape_185.graphics.lf(["#F56209","#F56B28"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_185.setTransform(-340.575,74.725);

	this.shape_186 = new cjs.Shape();
	this.shape_186.graphics.lf(["#F56209","#F56B28"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_186.setTransform(-383.3,88.725);

	this.shape_187 = new cjs.Shape();
	this.shape_187.graphics.lf(["#F56209","#F56B28"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_187.setTransform(-296.25,64.05);

	this.shape_188 = new cjs.Shape();
	this.shape_188.graphics.lf(["#F56209","#F56B28"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_188.setTransform(-251.075,56.95);

	this.shape_189 = new cjs.Shape();
	this.shape_189.graphics.lf(["#F56209","#F56B28"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_189.setTransform(-205.675,50.875);

	this.shape_190 = new cjs.Shape();
	this.shape_190.graphics.lf(["#F56209","#F56B28"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_190.setTransform(-160.5,43.575);

	this.shape_191 = new cjs.Shape();
	this.shape_191.graphics.lf(["#F56209","#F56B28"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_191.setTransform(-117.75,28.75);

	this.shape_192 = new cjs.Shape();
	this.shape_192.graphics.lf(["#F56209","#F56B28"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_192.setTransform(-122.5,-6.825);

	this.shape_193 = new cjs.Shape();
	this.shape_193.graphics.lf(["#F56209","#F56B28"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_193.setTransform(-144.525,-186.225);

	this.shape_194 = new cjs.Shape();
	this.shape_194.graphics.lf(["#F56209","#F56B28"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_194.setTransform(-159.025,-28.975);

	this.shape_195 = new cjs.Shape();
	this.shape_195.graphics.lf(["#F56209","#F56B28"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_195.setTransform(-200.9,-36.7925);

	this.shape_196 = new cjs.Shape();
	this.shape_196.graphics.lf(["#F56209","#F56B28"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_196.setTransform(-243.525,-32.85);

	this.shape_197 = new cjs.Shape();
	this.shape_197.graphics.lf(["#F56209","#F56B28"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_197.setTransform(-284.875,-21.325);

	this.shape_198 = new cjs.Shape();
	this.shape_198.graphics.lf(["#F56209","#F56B28"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_198.setTransform(-266.575,-120.375);

	this.shape_199 = new cjs.Shape();
	this.shape_199.graphics.lf(["#F56209","#F56B28"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_199.setTransform(-313.25,-110.575);

	this.shape_200 = new cjs.Shape();
	this.shape_200.graphics.lf(["#F56209","#F56B28"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_200.setTransform(-219.775,-130.875);

	this.shape_201 = new cjs.Shape();
	this.shape_201.graphics.lf(["#F56209","#F56B28"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_201.setTransform(-177.075,-151.575);

	this.shape_202 = new cjs.Shape();
	this.shape_202.graphics.lf(["#F56209","#F56B28"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_202.setTransform(-37.725,-278.5196);

	this.shape_203 = new cjs.Shape();
	this.shape_203.graphics.lf(["#F56209","#F56B28"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_203.setTransform(-114.5,-223.5);

	this.shape_204 = new cjs.Shape();
	this.shape_204.graphics.lf(["#F56209","#F56B28"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_204.setTransform(-80.375,-257.35);

	this.shape_205 = new cjs.Shape();
	this.shape_205.graphics.lf(["#F56209","#F56B28"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_205.setTransform(-328.05,-10.925);

	this.shape_206 = new cjs.Shape();
	this.shape_206.graphics.lf(["#F56209","#F56B28"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_206.setTransform(-373,-12.325);

	this.shape_207 = new cjs.Shape();
	this.shape_207.graphics.lf(["#F56209","#F56B28"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_207.setTransform(-358.325,-95.45);

	this.shape_208 = new cjs.Shape();
	this.shape_208.graphics.lf(["#F56209","#F56B28"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_208.setTransform(-411.075,-32.2);

	this.shape_209 = new cjs.Shape();
	this.shape_209.graphics.lf(["#F56209","#F56B28"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_209.setTransform(-398.975,-71.425);

	this.shape_210 = new cjs.Shape();
	this.shape_210.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_210.setTransform(-510.625,132.625);

	this.shape_211 = new cjs.Shape();
	this.shape_211.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_211.setTransform(-468.325,117.725);

	this.shape_212 = new cjs.Shape();
	this.shape_212.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_212.setTransform(-425.825,103.1);

	this.shape_213 = new cjs.Shape();
	this.shape_213.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_213.setTransform(-340.575,74.725);

	this.shape_214 = new cjs.Shape();
	this.shape_214.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_214.setTransform(-383.3,88.725);

	this.shape_215 = new cjs.Shape();
	this.shape_215.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_215.setTransform(-296.25,64.05);

	this.shape_216 = new cjs.Shape();
	this.shape_216.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_216.setTransform(-251.075,56.95);

	this.shape_217 = new cjs.Shape();
	this.shape_217.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_217.setTransform(-205.675,50.875);

	this.shape_218 = new cjs.Shape();
	this.shape_218.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_218.setTransform(-160.5,43.575);

	this.shape_219 = new cjs.Shape();
	this.shape_219.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_219.setTransform(-117.75,28.75);

	this.shape_220 = new cjs.Shape();
	this.shape_220.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_220.setTransform(-122.5,-6.825);

	this.shape_221 = new cjs.Shape();
	this.shape_221.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_221.setTransform(-144.525,-186.225);

	this.shape_222 = new cjs.Shape();
	this.shape_222.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_222.setTransform(-159.025,-28.975);

	this.shape_223 = new cjs.Shape();
	this.shape_223.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_223.setTransform(-200.9,-36.7925);

	this.shape_224 = new cjs.Shape();
	this.shape_224.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_224.setTransform(-243.525,-32.85);

	this.shape_225 = new cjs.Shape();
	this.shape_225.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_225.setTransform(-284.875,-21.325);

	this.shape_226 = new cjs.Shape();
	this.shape_226.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_226.setTransform(-266.575,-120.375);

	this.shape_227 = new cjs.Shape();
	this.shape_227.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_227.setTransform(-313.25,-110.575);

	this.shape_228 = new cjs.Shape();
	this.shape_228.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_228.setTransform(-219.775,-130.875);

	this.shape_229 = new cjs.Shape();
	this.shape_229.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_229.setTransform(-177.075,-151.575);

	this.shape_230 = new cjs.Shape();
	this.shape_230.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_230.setTransform(-37.725,-278.5196);

	this.shape_231 = new cjs.Shape();
	this.shape_231.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_231.setTransform(-114.5,-223.5);

	this.shape_232 = new cjs.Shape();
	this.shape_232.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_232.setTransform(-80.375,-257.35);

	this.shape_233 = new cjs.Shape();
	this.shape_233.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_233.setTransform(-328.05,-10.925);

	this.shape_234 = new cjs.Shape();
	this.shape_234.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_234.setTransform(-373,-12.325);

	this.shape_235 = new cjs.Shape();
	this.shape_235.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_235.setTransform(-358.325,-95.45);

	this.shape_236 = new cjs.Shape();
	this.shape_236.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_236.setTransform(-411.075,-32.2);

	this.shape_237 = new cjs.Shape();
	this.shape_237.graphics.lf(["#EB6611","#EB6F2F"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_237.setTransform(-398.975,-71.425);

	this.shape_238 = new cjs.Shape();
	this.shape_238.graphics.lf(["#E16A1A","#E17236"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_238.setTransform(-510.625,132.625);

	this.shape_239 = new cjs.Shape();
	this.shape_239.graphics.lf(["#E16A1A","#E17236"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_239.setTransform(-468.325,117.725);

	this.shape_240 = new cjs.Shape();
	this.shape_240.graphics.lf(["#E16A1A","#E17236"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_240.setTransform(-425.825,103.1);

	this.shape_241 = new cjs.Shape();
	this.shape_241.graphics.lf(["#E16A1A","#E17236"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_241.setTransform(-340.575,74.725);

	this.shape_242 = new cjs.Shape();
	this.shape_242.graphics.lf(["#E16A1A","#E17236"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_242.setTransform(-383.3,88.725);

	this.shape_243 = new cjs.Shape();
	this.shape_243.graphics.lf(["#E16A1A","#E17236"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_243.setTransform(-296.25,64.05);

	this.shape_244 = new cjs.Shape();
	this.shape_244.graphics.lf(["#E16A1A","#E17236"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_244.setTransform(-251.075,56.95);

	this.shape_245 = new cjs.Shape();
	this.shape_245.graphics.lf(["#E16A1A","#E17236"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_245.setTransform(-205.675,50.875);

	this.shape_246 = new cjs.Shape();
	this.shape_246.graphics.lf(["#E16A1A","#E17236"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_246.setTransform(-160.5,43.575);

	this.shape_247 = new cjs.Shape();
	this.shape_247.graphics.lf(["#E16A1A","#E17236"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_247.setTransform(-117.75,28.75);

	this.shape_248 = new cjs.Shape();
	this.shape_248.graphics.lf(["#E16A1A","#E17236"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_248.setTransform(-122.5,-6.825);

	this.shape_249 = new cjs.Shape();
	this.shape_249.graphics.lf(["#E16A1A","#E17236"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_249.setTransform(-144.525,-186.225);

	this.shape_250 = new cjs.Shape();
	this.shape_250.graphics.lf(["#E16A1A","#E17236"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_250.setTransform(-159.025,-28.975);

	this.shape_251 = new cjs.Shape();
	this.shape_251.graphics.lf(["#E16A1A","#E17236"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_251.setTransform(-200.9,-36.7925);

	this.shape_252 = new cjs.Shape();
	this.shape_252.graphics.lf(["#E16A1A","#E17236"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_252.setTransform(-243.525,-32.85);

	this.shape_253 = new cjs.Shape();
	this.shape_253.graphics.lf(["#E16A1A","#E17236"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_253.setTransform(-284.875,-21.325);

	this.shape_254 = new cjs.Shape();
	this.shape_254.graphics.lf(["#E16A1A","#E17236"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_254.setTransform(-266.575,-120.375);

	this.shape_255 = new cjs.Shape();
	this.shape_255.graphics.lf(["#E16A1A","#E17236"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_255.setTransform(-313.25,-110.575);

	this.shape_256 = new cjs.Shape();
	this.shape_256.graphics.lf(["#E16A1A","#E17236"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_256.setTransform(-219.775,-130.875);

	this.shape_257 = new cjs.Shape();
	this.shape_257.graphics.lf(["#E16A1A","#E17236"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_257.setTransform(-177.075,-151.575);

	this.shape_258 = new cjs.Shape();
	this.shape_258.graphics.lf(["#E16A1A","#E17236"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_258.setTransform(-37.725,-278.5196);

	this.shape_259 = new cjs.Shape();
	this.shape_259.graphics.lf(["#E16A1A","#E17236"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_259.setTransform(-114.5,-223.5);

	this.shape_260 = new cjs.Shape();
	this.shape_260.graphics.lf(["#E16A1A","#E17236"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_260.setTransform(-80.375,-257.35);

	this.shape_261 = new cjs.Shape();
	this.shape_261.graphics.lf(["#E16A1A","#E17236"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_261.setTransform(-328.05,-10.925);

	this.shape_262 = new cjs.Shape();
	this.shape_262.graphics.lf(["#E16A1A","#E17236"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_262.setTransform(-373,-12.325);

	this.shape_263 = new cjs.Shape();
	this.shape_263.graphics.lf(["#E16A1A","#E17236"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_263.setTransform(-358.325,-95.45);

	this.shape_264 = new cjs.Shape();
	this.shape_264.graphics.lf(["#E16A1A","#E17236"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_264.setTransform(-411.075,-32.2);

	this.shape_265 = new cjs.Shape();
	this.shape_265.graphics.lf(["#E16A1A","#E17236"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_265.setTransform(-398.975,-71.425);

	this.shape_266 = new cjs.Shape();
	this.shape_266.graphics.lf(["#D76E22","#D7763D"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_266.setTransform(-510.625,132.625);

	this.shape_267 = new cjs.Shape();
	this.shape_267.graphics.lf(["#D76E22","#D7763D"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_267.setTransform(-468.325,117.725);

	this.shape_268 = new cjs.Shape();
	this.shape_268.graphics.lf(["#D76E22","#D7763D"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_268.setTransform(-425.825,103.1);

	this.shape_269 = new cjs.Shape();
	this.shape_269.graphics.lf(["#D76E22","#D7763D"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_269.setTransform(-340.575,74.725);

	this.shape_270 = new cjs.Shape();
	this.shape_270.graphics.lf(["#D76E22","#D7763D"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_270.setTransform(-383.3,88.725);

	this.shape_271 = new cjs.Shape();
	this.shape_271.graphics.lf(["#D76E22","#D7763D"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_271.setTransform(-296.25,64.05);

	this.shape_272 = new cjs.Shape();
	this.shape_272.graphics.lf(["#D76E22","#D7763D"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_272.setTransform(-251.075,56.95);

	this.shape_273 = new cjs.Shape();
	this.shape_273.graphics.lf(["#D76E22","#D7763D"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_273.setTransform(-205.675,50.875);

	this.shape_274 = new cjs.Shape();
	this.shape_274.graphics.lf(["#D76E22","#D7763D"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_274.setTransform(-160.5,43.575);

	this.shape_275 = new cjs.Shape();
	this.shape_275.graphics.lf(["#D76E22","#D7763D"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_275.setTransform(-117.75,28.75);

	this.shape_276 = new cjs.Shape();
	this.shape_276.graphics.lf(["#D76E22","#D7763D"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_276.setTransform(-122.5,-6.825);

	this.shape_277 = new cjs.Shape();
	this.shape_277.graphics.lf(["#D76E22","#D7763D"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_277.setTransform(-144.525,-186.225);

	this.shape_278 = new cjs.Shape();
	this.shape_278.graphics.lf(["#D76E22","#D7763D"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_278.setTransform(-159.025,-28.975);

	this.shape_279 = new cjs.Shape();
	this.shape_279.graphics.lf(["#D76E22","#D7763D"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_279.setTransform(-200.9,-36.7925);

	this.shape_280 = new cjs.Shape();
	this.shape_280.graphics.lf(["#D76E22","#D7763D"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_280.setTransform(-243.525,-32.85);

	this.shape_281 = new cjs.Shape();
	this.shape_281.graphics.lf(["#D76E22","#D7763D"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_281.setTransform(-284.875,-21.325);

	this.shape_282 = new cjs.Shape();
	this.shape_282.graphics.lf(["#D76E22","#D7763D"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_282.setTransform(-266.575,-120.375);

	this.shape_283 = new cjs.Shape();
	this.shape_283.graphics.lf(["#D76E22","#D7763D"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_283.setTransform(-313.25,-110.575);

	this.shape_284 = new cjs.Shape();
	this.shape_284.graphics.lf(["#D76E22","#D7763D"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_284.setTransform(-219.775,-130.875);

	this.shape_285 = new cjs.Shape();
	this.shape_285.graphics.lf(["#D76E22","#D7763D"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_285.setTransform(-177.075,-151.575);

	this.shape_286 = new cjs.Shape();
	this.shape_286.graphics.lf(["#D76E22","#D7763D"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_286.setTransform(-37.725,-278.5196);

	this.shape_287 = new cjs.Shape();
	this.shape_287.graphics.lf(["#D76E22","#D7763D"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_287.setTransform(-114.5,-223.5);

	this.shape_288 = new cjs.Shape();
	this.shape_288.graphics.lf(["#D76E22","#D7763D"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_288.setTransform(-80.375,-257.35);

	this.shape_289 = new cjs.Shape();
	this.shape_289.graphics.lf(["#D76E22","#D7763D"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_289.setTransform(-328.05,-10.925);

	this.shape_290 = new cjs.Shape();
	this.shape_290.graphics.lf(["#D76E22","#D7763D"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_290.setTransform(-373,-12.325);

	this.shape_291 = new cjs.Shape();
	this.shape_291.graphics.lf(["#D76E22","#D7763D"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_291.setTransform(-358.325,-95.45);

	this.shape_292 = new cjs.Shape();
	this.shape_292.graphics.lf(["#D76E22","#D7763D"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_292.setTransform(-411.075,-32.2);

	this.shape_293 = new cjs.Shape();
	this.shape_293.graphics.lf(["#D76E22","#D7763D"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_293.setTransform(-398.975,-71.425);

	this.shape_294 = new cjs.Shape();
	this.shape_294.graphics.lf(["#CD722B","#CD7944"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_294.setTransform(-510.625,132.625);

	this.shape_295 = new cjs.Shape();
	this.shape_295.graphics.lf(["#CD722B","#CD7944"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_295.setTransform(-468.325,117.725);

	this.shape_296 = new cjs.Shape();
	this.shape_296.graphics.lf(["#CD722B","#CD7944"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_296.setTransform(-425.825,103.1);

	this.shape_297 = new cjs.Shape();
	this.shape_297.graphics.lf(["#CD722B","#CD7944"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_297.setTransform(-340.575,74.725);

	this.shape_298 = new cjs.Shape();
	this.shape_298.graphics.lf(["#CD722B","#CD7944"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_298.setTransform(-383.3,88.725);

	this.shape_299 = new cjs.Shape();
	this.shape_299.graphics.lf(["#CD722B","#CD7944"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_299.setTransform(-296.25,64.05);

	this.shape_300 = new cjs.Shape();
	this.shape_300.graphics.lf(["#CD722B","#CD7944"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_300.setTransform(-251.075,56.95);

	this.shape_301 = new cjs.Shape();
	this.shape_301.graphics.lf(["#CD722B","#CD7944"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_301.setTransform(-205.675,50.875);

	this.shape_302 = new cjs.Shape();
	this.shape_302.graphics.lf(["#CD722B","#CD7944"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_302.setTransform(-160.5,43.575);

	this.shape_303 = new cjs.Shape();
	this.shape_303.graphics.lf(["#CD722B","#CD7944"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_303.setTransform(-117.75,28.75);

	this.shape_304 = new cjs.Shape();
	this.shape_304.graphics.lf(["#CD722B","#CD7944"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_304.setTransform(-122.5,-6.825);

	this.shape_305 = new cjs.Shape();
	this.shape_305.graphics.lf(["#CD722B","#CD7944"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_305.setTransform(-144.525,-186.225);

	this.shape_306 = new cjs.Shape();
	this.shape_306.graphics.lf(["#CD722B","#CD7944"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_306.setTransform(-159.025,-28.975);

	this.shape_307 = new cjs.Shape();
	this.shape_307.graphics.lf(["#CD722B","#CD7944"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_307.setTransform(-200.9,-36.7925);

	this.shape_308 = new cjs.Shape();
	this.shape_308.graphics.lf(["#CD722B","#CD7944"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_308.setTransform(-243.525,-32.85);

	this.shape_309 = new cjs.Shape();
	this.shape_309.graphics.lf(["#CD722B","#CD7944"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_309.setTransform(-284.875,-21.325);

	this.shape_310 = new cjs.Shape();
	this.shape_310.graphics.lf(["#CD722B","#CD7944"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_310.setTransform(-266.575,-120.375);

	this.shape_311 = new cjs.Shape();
	this.shape_311.graphics.lf(["#CD722B","#CD7944"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_311.setTransform(-313.25,-110.575);

	this.shape_312 = new cjs.Shape();
	this.shape_312.graphics.lf(["#CD722B","#CD7944"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_312.setTransform(-219.775,-130.875);

	this.shape_313 = new cjs.Shape();
	this.shape_313.graphics.lf(["#CD722B","#CD7944"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_313.setTransform(-177.075,-151.575);

	this.shape_314 = new cjs.Shape();
	this.shape_314.graphics.lf(["#CD722B","#CD7944"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_314.setTransform(-37.725,-278.5196);

	this.shape_315 = new cjs.Shape();
	this.shape_315.graphics.lf(["#CD722B","#CD7944"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_315.setTransform(-114.5,-223.5);

	this.shape_316 = new cjs.Shape();
	this.shape_316.graphics.lf(["#CD722B","#CD7944"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_316.setTransform(-80.375,-257.35);

	this.shape_317 = new cjs.Shape();
	this.shape_317.graphics.lf(["#CD722B","#CD7944"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_317.setTransform(-328.05,-10.925);

	this.shape_318 = new cjs.Shape();
	this.shape_318.graphics.lf(["#CD722B","#CD7944"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_318.setTransform(-373,-12.325);

	this.shape_319 = new cjs.Shape();
	this.shape_319.graphics.lf(["#CD722B","#CD7944"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_319.setTransform(-358.325,-95.45);

	this.shape_320 = new cjs.Shape();
	this.shape_320.graphics.lf(["#CD722B","#CD7944"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_320.setTransform(-411.075,-32.2);

	this.shape_321 = new cjs.Shape();
	this.shape_321.graphics.lf(["#CD722B","#CD7944"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_321.setTransform(-398.975,-71.425);

	this.shape_322 = new cjs.Shape();
	this.shape_322.graphics.lf(["#C27633","#C27D4B"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_322.setTransform(-510.625,132.625);

	this.shape_323 = new cjs.Shape();
	this.shape_323.graphics.lf(["#C27633","#C27D4B"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_323.setTransform(-468.325,117.725);

	this.shape_324 = new cjs.Shape();
	this.shape_324.graphics.lf(["#C27633","#C27D4B"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_324.setTransform(-425.825,103.1);

	this.shape_325 = new cjs.Shape();
	this.shape_325.graphics.lf(["#C27633","#C27D4B"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_325.setTransform(-340.575,74.725);

	this.shape_326 = new cjs.Shape();
	this.shape_326.graphics.lf(["#C27633","#C27D4B"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_326.setTransform(-383.3,88.725);

	this.shape_327 = new cjs.Shape();
	this.shape_327.graphics.lf(["#C27633","#C27D4B"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_327.setTransform(-296.25,64.05);

	this.shape_328 = new cjs.Shape();
	this.shape_328.graphics.lf(["#C27633","#C27D4B"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_328.setTransform(-251.075,56.95);

	this.shape_329 = new cjs.Shape();
	this.shape_329.graphics.lf(["#C27633","#C27D4B"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_329.setTransform(-205.675,50.875);

	this.shape_330 = new cjs.Shape();
	this.shape_330.graphics.lf(["#C27633","#C27D4B"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_330.setTransform(-160.5,43.575);

	this.shape_331 = new cjs.Shape();
	this.shape_331.graphics.lf(["#C27633","#C27D4B"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_331.setTransform(-117.75,28.75);

	this.shape_332 = new cjs.Shape();
	this.shape_332.graphics.lf(["#C27633","#C27D4B"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_332.setTransform(-122.5,-6.825);

	this.shape_333 = new cjs.Shape();
	this.shape_333.graphics.lf(["#C27633","#C27D4B"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_333.setTransform(-144.525,-186.225);

	this.shape_334 = new cjs.Shape();
	this.shape_334.graphics.lf(["#C27633","#C27D4B"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_334.setTransform(-159.025,-28.975);

	this.shape_335 = new cjs.Shape();
	this.shape_335.graphics.lf(["#C27633","#C27D4B"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_335.setTransform(-200.9,-36.7925);

	this.shape_336 = new cjs.Shape();
	this.shape_336.graphics.lf(["#C27633","#C27D4B"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_336.setTransform(-243.525,-32.85);

	this.shape_337 = new cjs.Shape();
	this.shape_337.graphics.lf(["#C27633","#C27D4B"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_337.setTransform(-284.875,-21.325);

	this.shape_338 = new cjs.Shape();
	this.shape_338.graphics.lf(["#C27633","#C27D4B"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_338.setTransform(-266.575,-120.375);

	this.shape_339 = new cjs.Shape();
	this.shape_339.graphics.lf(["#C27633","#C27D4B"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_339.setTransform(-313.25,-110.575);

	this.shape_340 = new cjs.Shape();
	this.shape_340.graphics.lf(["#C27633","#C27D4B"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_340.setTransform(-219.775,-130.875);

	this.shape_341 = new cjs.Shape();
	this.shape_341.graphics.lf(["#C27633","#C27D4B"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_341.setTransform(-177.075,-151.575);

	this.shape_342 = new cjs.Shape();
	this.shape_342.graphics.lf(["#C27633","#C27D4B"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_342.setTransform(-37.725,-278.5196);

	this.shape_343 = new cjs.Shape();
	this.shape_343.graphics.lf(["#C27633","#C27D4B"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_343.setTransform(-114.5,-223.5);

	this.shape_344 = new cjs.Shape();
	this.shape_344.graphics.lf(["#C27633","#C27D4B"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_344.setTransform(-80.375,-257.35);

	this.shape_345 = new cjs.Shape();
	this.shape_345.graphics.lf(["#C27633","#C27D4B"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_345.setTransform(-328.05,-10.925);

	this.shape_346 = new cjs.Shape();
	this.shape_346.graphics.lf(["#C27633","#C27D4B"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_346.setTransform(-373,-12.325);

	this.shape_347 = new cjs.Shape();
	this.shape_347.graphics.lf(["#C27633","#C27D4B"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_347.setTransform(-358.325,-95.45);

	this.shape_348 = new cjs.Shape();
	this.shape_348.graphics.lf(["#C27633","#C27D4B"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_348.setTransform(-411.075,-32.2);

	this.shape_349 = new cjs.Shape();
	this.shape_349.graphics.lf(["#C27633","#C27D4B"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_349.setTransform(-398.975,-71.425);

	this.shape_350 = new cjs.Shape();
	this.shape_350.graphics.lf(["#B87A3C","#B88052"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_350.setTransform(-510.625,132.625);

	this.shape_351 = new cjs.Shape();
	this.shape_351.graphics.lf(["#B87A3C","#B88052"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_351.setTransform(-468.325,117.725);

	this.shape_352 = new cjs.Shape();
	this.shape_352.graphics.lf(["#B87A3C","#B88052"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_352.setTransform(-425.825,103.1);

	this.shape_353 = new cjs.Shape();
	this.shape_353.graphics.lf(["#B87A3C","#B88052"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_353.setTransform(-340.575,74.725);

	this.shape_354 = new cjs.Shape();
	this.shape_354.graphics.lf(["#B87A3C","#B88052"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_354.setTransform(-383.3,88.725);

	this.shape_355 = new cjs.Shape();
	this.shape_355.graphics.lf(["#B87A3C","#B88052"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_355.setTransform(-296.25,64.05);

	this.shape_356 = new cjs.Shape();
	this.shape_356.graphics.lf(["#B87A3C","#B88052"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_356.setTransform(-251.075,56.95);

	this.shape_357 = new cjs.Shape();
	this.shape_357.graphics.lf(["#B87A3C","#B88052"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_357.setTransform(-205.675,50.875);

	this.shape_358 = new cjs.Shape();
	this.shape_358.graphics.lf(["#B87A3C","#B88052"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_358.setTransform(-160.5,43.575);

	this.shape_359 = new cjs.Shape();
	this.shape_359.graphics.lf(["#B87A3C","#B88052"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_359.setTransform(-117.75,28.75);

	this.shape_360 = new cjs.Shape();
	this.shape_360.graphics.lf(["#B87A3C","#B88052"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_360.setTransform(-122.5,-6.825);

	this.shape_361 = new cjs.Shape();
	this.shape_361.graphics.lf(["#B87A3C","#B88052"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_361.setTransform(-144.525,-186.225);

	this.shape_362 = new cjs.Shape();
	this.shape_362.graphics.lf(["#B87A3C","#B88052"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_362.setTransform(-159.025,-28.975);

	this.shape_363 = new cjs.Shape();
	this.shape_363.graphics.lf(["#B87A3C","#B88052"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_363.setTransform(-200.9,-36.7925);

	this.shape_364 = new cjs.Shape();
	this.shape_364.graphics.lf(["#B87A3C","#B88052"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_364.setTransform(-243.525,-32.85);

	this.shape_365 = new cjs.Shape();
	this.shape_365.graphics.lf(["#B87A3C","#B88052"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_365.setTransform(-284.875,-21.325);

	this.shape_366 = new cjs.Shape();
	this.shape_366.graphics.lf(["#B87A3C","#B88052"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_366.setTransform(-266.575,-120.375);

	this.shape_367 = new cjs.Shape();
	this.shape_367.graphics.lf(["#B87A3C","#B88052"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_367.setTransform(-313.25,-110.575);

	this.shape_368 = new cjs.Shape();
	this.shape_368.graphics.lf(["#B87A3C","#B88052"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_368.setTransform(-219.775,-130.875);

	this.shape_369 = new cjs.Shape();
	this.shape_369.graphics.lf(["#B87A3C","#B88052"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_369.setTransform(-177.075,-151.575);

	this.shape_370 = new cjs.Shape();
	this.shape_370.graphics.lf(["#B87A3C","#B88052"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_370.setTransform(-37.725,-278.5196);

	this.shape_371 = new cjs.Shape();
	this.shape_371.graphics.lf(["#B87A3C","#B88052"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_371.setTransform(-114.5,-223.5);

	this.shape_372 = new cjs.Shape();
	this.shape_372.graphics.lf(["#B87A3C","#B88052"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_372.setTransform(-80.375,-257.35);

	this.shape_373 = new cjs.Shape();
	this.shape_373.graphics.lf(["#B87A3C","#B88052"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_373.setTransform(-328.05,-10.925);

	this.shape_374 = new cjs.Shape();
	this.shape_374.graphics.lf(["#B87A3C","#B88052"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_374.setTransform(-373,-12.325);

	this.shape_375 = new cjs.Shape();
	this.shape_375.graphics.lf(["#B87A3C","#B88052"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_375.setTransform(-358.325,-95.45);

	this.shape_376 = new cjs.Shape();
	this.shape_376.graphics.lf(["#B87A3C","#B88052"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_376.setTransform(-411.075,-32.2);

	this.shape_377 = new cjs.Shape();
	this.shape_377.graphics.lf(["#B87A3C","#B88052"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_377.setTransform(-398.975,-71.425);

	this.shape_378 = new cjs.Shape();
	this.shape_378.graphics.lf(["#AE7E45","#AE8459"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_378.setTransform(-510.625,132.625);

	this.shape_379 = new cjs.Shape();
	this.shape_379.graphics.lf(["#AE7E45","#AE8459"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_379.setTransform(-468.325,117.725);

	this.shape_380 = new cjs.Shape();
	this.shape_380.graphics.lf(["#AE7E45","#AE8459"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_380.setTransform(-425.825,103.1);

	this.shape_381 = new cjs.Shape();
	this.shape_381.graphics.lf(["#AE7E45","#AE8459"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_381.setTransform(-340.575,74.725);

	this.shape_382 = new cjs.Shape();
	this.shape_382.graphics.lf(["#AE7E45","#AE8459"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_382.setTransform(-383.3,88.725);

	this.shape_383 = new cjs.Shape();
	this.shape_383.graphics.lf(["#AE7E45","#AE8459"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_383.setTransform(-296.25,64.05);

	this.shape_384 = new cjs.Shape();
	this.shape_384.graphics.lf(["#AE7E45","#AE8459"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_384.setTransform(-251.075,56.95);

	this.shape_385 = new cjs.Shape();
	this.shape_385.graphics.lf(["#AE7E45","#AE8459"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_385.setTransform(-205.675,50.875);

	this.shape_386 = new cjs.Shape();
	this.shape_386.graphics.lf(["#AE7E45","#AE8459"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_386.setTransform(-160.5,43.575);

	this.shape_387 = new cjs.Shape();
	this.shape_387.graphics.lf(["#AE7E45","#AE8459"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_387.setTransform(-117.75,28.75);

	this.shape_388 = new cjs.Shape();
	this.shape_388.graphics.lf(["#AE7E45","#AE8459"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_388.setTransform(-122.5,-6.825);

	this.shape_389 = new cjs.Shape();
	this.shape_389.graphics.lf(["#AE7E45","#AE8459"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_389.setTransform(-144.525,-186.225);

	this.shape_390 = new cjs.Shape();
	this.shape_390.graphics.lf(["#AE7E45","#AE8459"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_390.setTransform(-159.025,-28.975);

	this.shape_391 = new cjs.Shape();
	this.shape_391.graphics.lf(["#AE7E45","#AE8459"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_391.setTransform(-200.9,-36.7925);

	this.shape_392 = new cjs.Shape();
	this.shape_392.graphics.lf(["#AE7E45","#AE8459"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_392.setTransform(-243.525,-32.85);

	this.shape_393 = new cjs.Shape();
	this.shape_393.graphics.lf(["#AE7E45","#AE8459"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_393.setTransform(-284.875,-21.325);

	this.shape_394 = new cjs.Shape();
	this.shape_394.graphics.lf(["#AE7E45","#AE8459"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_394.setTransform(-266.575,-120.375);

	this.shape_395 = new cjs.Shape();
	this.shape_395.graphics.lf(["#AE7E45","#AE8459"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_395.setTransform(-313.25,-110.575);

	this.shape_396 = new cjs.Shape();
	this.shape_396.graphics.lf(["#AE7E45","#AE8459"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_396.setTransform(-219.775,-130.875);

	this.shape_397 = new cjs.Shape();
	this.shape_397.graphics.lf(["#AE7E45","#AE8459"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_397.setTransform(-177.075,-151.575);

	this.shape_398 = new cjs.Shape();
	this.shape_398.graphics.lf(["#AE7E45","#AE8459"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_398.setTransform(-37.725,-278.5196);

	this.shape_399 = new cjs.Shape();
	this.shape_399.graphics.lf(["#AE7E45","#AE8459"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_399.setTransform(-114.5,-223.5);

	this.shape_400 = new cjs.Shape();
	this.shape_400.graphics.lf(["#AE7E45","#AE8459"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_400.setTransform(-80.375,-257.35);

	this.shape_401 = new cjs.Shape();
	this.shape_401.graphics.lf(["#AE7E45","#AE8459"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_401.setTransform(-328.05,-10.925);

	this.shape_402 = new cjs.Shape();
	this.shape_402.graphics.lf(["#AE7E45","#AE8459"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_402.setTransform(-373,-12.325);

	this.shape_403 = new cjs.Shape();
	this.shape_403.graphics.lf(["#AE7E45","#AE8459"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_403.setTransform(-358.325,-95.45);

	this.shape_404 = new cjs.Shape();
	this.shape_404.graphics.lf(["#AE7E45","#AE8459"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_404.setTransform(-411.075,-32.2);

	this.shape_405 = new cjs.Shape();
	this.shape_405.graphics.lf(["#AE7E45","#AE8459"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_405.setTransform(-398.975,-71.425);

	this.shape_406 = new cjs.Shape();
	this.shape_406.graphics.lf(["#A4824D","#A48760"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_406.setTransform(-510.625,132.625);

	this.shape_407 = new cjs.Shape();
	this.shape_407.graphics.lf(["#A4824D","#A48760"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_407.setTransform(-468.325,117.725);

	this.shape_408 = new cjs.Shape();
	this.shape_408.graphics.lf(["#A4824D","#A48760"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_408.setTransform(-425.825,103.1);

	this.shape_409 = new cjs.Shape();
	this.shape_409.graphics.lf(["#A4824D","#A48760"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_409.setTransform(-340.575,74.725);

	this.shape_410 = new cjs.Shape();
	this.shape_410.graphics.lf(["#A4824D","#A48760"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_410.setTransform(-383.3,88.725);

	this.shape_411 = new cjs.Shape();
	this.shape_411.graphics.lf(["#A4824D","#A48760"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_411.setTransform(-296.25,64.05);

	this.shape_412 = new cjs.Shape();
	this.shape_412.graphics.lf(["#A4824D","#A48760"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_412.setTransform(-251.075,56.95);

	this.shape_413 = new cjs.Shape();
	this.shape_413.graphics.lf(["#A4824D","#A48760"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_413.setTransform(-205.675,50.875);

	this.shape_414 = new cjs.Shape();
	this.shape_414.graphics.lf(["#A4824D","#A48760"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_414.setTransform(-160.5,43.575);

	this.shape_415 = new cjs.Shape();
	this.shape_415.graphics.lf(["#A4824D","#A48760"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_415.setTransform(-117.75,28.75);

	this.shape_416 = new cjs.Shape();
	this.shape_416.graphics.lf(["#A4824D","#A48760"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_416.setTransform(-122.5,-6.825);

	this.shape_417 = new cjs.Shape();
	this.shape_417.graphics.lf(["#A4824D","#A48760"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_417.setTransform(-144.525,-186.225);

	this.shape_418 = new cjs.Shape();
	this.shape_418.graphics.lf(["#A4824D","#A48760"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_418.setTransform(-159.025,-28.975);

	this.shape_419 = new cjs.Shape();
	this.shape_419.graphics.lf(["#A4824D","#A48760"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_419.setTransform(-200.9,-36.7925);

	this.shape_420 = new cjs.Shape();
	this.shape_420.graphics.lf(["#A4824D","#A48760"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_420.setTransform(-243.525,-32.85);

	this.shape_421 = new cjs.Shape();
	this.shape_421.graphics.lf(["#A4824D","#A48760"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_421.setTransform(-284.875,-21.325);

	this.shape_422 = new cjs.Shape();
	this.shape_422.graphics.lf(["#A4824D","#A48760"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_422.setTransform(-266.575,-120.375);

	this.shape_423 = new cjs.Shape();
	this.shape_423.graphics.lf(["#A4824D","#A48760"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_423.setTransform(-313.25,-110.575);

	this.shape_424 = new cjs.Shape();
	this.shape_424.graphics.lf(["#A4824D","#A48760"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_424.setTransform(-219.775,-130.875);

	this.shape_425 = new cjs.Shape();
	this.shape_425.graphics.lf(["#A4824D","#A48760"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_425.setTransform(-177.075,-151.575);

	this.shape_426 = new cjs.Shape();
	this.shape_426.graphics.lf(["#A4824D","#A48760"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_426.setTransform(-37.725,-278.5196);

	this.shape_427 = new cjs.Shape();
	this.shape_427.graphics.lf(["#A4824D","#A48760"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_427.setTransform(-114.5,-223.5);

	this.shape_428 = new cjs.Shape();
	this.shape_428.graphics.lf(["#A4824D","#A48760"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_428.setTransform(-80.375,-257.35);

	this.shape_429 = new cjs.Shape();
	this.shape_429.graphics.lf(["#A4824D","#A48760"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_429.setTransform(-328.05,-10.925);

	this.shape_430 = new cjs.Shape();
	this.shape_430.graphics.lf(["#A4824D","#A48760"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_430.setTransform(-373,-12.325);

	this.shape_431 = new cjs.Shape();
	this.shape_431.graphics.lf(["#A4824D","#A48760"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_431.setTransform(-358.325,-95.45);

	this.shape_432 = new cjs.Shape();
	this.shape_432.graphics.lf(["#A4824D","#A48760"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_432.setTransform(-411.075,-32.2);

	this.shape_433 = new cjs.Shape();
	this.shape_433.graphics.lf(["#A4824D","#A48760"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_433.setTransform(-398.975,-71.425);

	this.shape_434 = new cjs.Shape();
	this.shape_434.graphics.lf(["#9A8656","#9A8B67"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_434.setTransform(-510.625,132.625);

	this.shape_435 = new cjs.Shape();
	this.shape_435.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_435.setTransform(-468.325,117.725);

	this.shape_436 = new cjs.Shape();
	this.shape_436.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_436.setTransform(-425.825,103.1);

	this.shape_437 = new cjs.Shape();
	this.shape_437.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_437.setTransform(-340.575,74.725);

	this.shape_438 = new cjs.Shape();
	this.shape_438.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_438.setTransform(-383.3,88.725);

	this.shape_439 = new cjs.Shape();
	this.shape_439.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_439.setTransform(-296.25,64.05);

	this.shape_440 = new cjs.Shape();
	this.shape_440.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_440.setTransform(-251.075,56.95);

	this.shape_441 = new cjs.Shape();
	this.shape_441.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_441.setTransform(-205.675,50.875);

	this.shape_442 = new cjs.Shape();
	this.shape_442.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_442.setTransform(-160.5,43.575);

	this.shape_443 = new cjs.Shape();
	this.shape_443.graphics.lf(["#9A8656","#9A8B67"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_443.setTransform(-117.75,28.75);

	this.shape_444 = new cjs.Shape();
	this.shape_444.graphics.lf(["#9A8656","#9A8B67"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_444.setTransform(-122.5,-6.825);

	this.shape_445 = new cjs.Shape();
	this.shape_445.graphics.lf(["#9A8656","#9A8B67"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_445.setTransform(-144.525,-186.225);

	this.shape_446 = new cjs.Shape();
	this.shape_446.graphics.lf(["#9A8656","#9A8B67"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_446.setTransform(-159.025,-28.975);

	this.shape_447 = new cjs.Shape();
	this.shape_447.graphics.lf(["#9A8656","#9A8B67"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_447.setTransform(-200.9,-36.7925);

	this.shape_448 = new cjs.Shape();
	this.shape_448.graphics.lf(["#9A8656","#9A8B67"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_448.setTransform(-243.525,-32.85);

	this.shape_449 = new cjs.Shape();
	this.shape_449.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_449.setTransform(-284.875,-21.325);

	this.shape_450 = new cjs.Shape();
	this.shape_450.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_450.setTransform(-266.575,-120.375);

	this.shape_451 = new cjs.Shape();
	this.shape_451.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_451.setTransform(-313.25,-110.575);

	this.shape_452 = new cjs.Shape();
	this.shape_452.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_452.setTransform(-219.775,-130.875);

	this.shape_453 = new cjs.Shape();
	this.shape_453.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_453.setTransform(-177.075,-151.575);

	this.shape_454 = new cjs.Shape();
	this.shape_454.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_454.setTransform(-37.725,-278.5196);

	this.shape_455 = new cjs.Shape();
	this.shape_455.graphics.lf(["#9A8656","#9A8B67"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_455.setTransform(-114.5,-223.5);

	this.shape_456 = new cjs.Shape();
	this.shape_456.graphics.lf(["#9A8656","#9A8B67"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_456.setTransform(-80.375,-257.35);

	this.shape_457 = new cjs.Shape();
	this.shape_457.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_457.setTransform(-328.05,-10.925);

	this.shape_458 = new cjs.Shape();
	this.shape_458.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_458.setTransform(-373,-12.325);

	this.shape_459 = new cjs.Shape();
	this.shape_459.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_459.setTransform(-358.325,-95.45);

	this.shape_460 = new cjs.Shape();
	this.shape_460.graphics.lf(["#9A8656","#9A8B67"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_460.setTransform(-411.075,-32.2);

	this.shape_461 = new cjs.Shape();
	this.shape_461.graphics.lf(["#9A8656","#9A8B67"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_461.setTransform(-398.975,-71.425);

	this.shape_462 = new cjs.Shape();
	this.shape_462.graphics.lf(["#90895E","#908E6E"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_462.setTransform(-510.625,132.625);

	this.shape_463 = new cjs.Shape();
	this.shape_463.graphics.lf(["#90895E","#908E6E"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_463.setTransform(-468.325,117.725);

	this.shape_464 = new cjs.Shape();
	this.shape_464.graphics.lf(["#90895E","#908E6E"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_464.setTransform(-425.825,103.1);

	this.shape_465 = new cjs.Shape();
	this.shape_465.graphics.lf(["#90895E","#908E6E"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_465.setTransform(-340.575,74.725);

	this.shape_466 = new cjs.Shape();
	this.shape_466.graphics.lf(["#90895E","#908E6E"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_466.setTransform(-383.3,88.725);

	this.shape_467 = new cjs.Shape();
	this.shape_467.graphics.lf(["#90895E","#908E6E"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_467.setTransform(-296.25,64.05);

	this.shape_468 = new cjs.Shape();
	this.shape_468.graphics.lf(["#90895E","#908E6E"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_468.setTransform(-251.075,56.95);

	this.shape_469 = new cjs.Shape();
	this.shape_469.graphics.lf(["#90895E","#908E6E"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_469.setTransform(-205.675,50.875);

	this.shape_470 = new cjs.Shape();
	this.shape_470.graphics.lf(["#90895E","#908E6E"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_470.setTransform(-160.5,43.575);

	this.shape_471 = new cjs.Shape();
	this.shape_471.graphics.lf(["#90895E","#908E6E"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_471.setTransform(-117.75,28.75);

	this.shape_472 = new cjs.Shape();
	this.shape_472.graphics.lf(["#90895E","#908E6E"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_472.setTransform(-122.5,-6.825);

	this.shape_473 = new cjs.Shape();
	this.shape_473.graphics.lf(["#90895E","#908E6E"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_473.setTransform(-144.525,-186.225);

	this.shape_474 = new cjs.Shape();
	this.shape_474.graphics.lf(["#90895E","#908E6E"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_474.setTransform(-159.025,-28.975);

	this.shape_475 = new cjs.Shape();
	this.shape_475.graphics.lf(["#90895E","#908E6E"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_475.setTransform(-200.9,-36.7925);

	this.shape_476 = new cjs.Shape();
	this.shape_476.graphics.lf(["#90895E","#908E6E"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_476.setTransform(-243.525,-32.85);

	this.shape_477 = new cjs.Shape();
	this.shape_477.graphics.lf(["#90895E","#908E6E"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_477.setTransform(-284.875,-21.325);

	this.shape_478 = new cjs.Shape();
	this.shape_478.graphics.lf(["#90895E","#908E6E"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_478.setTransform(-266.575,-120.375);

	this.shape_479 = new cjs.Shape();
	this.shape_479.graphics.lf(["#90895E","#908E6E"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_479.setTransform(-313.25,-110.575);

	this.shape_480 = new cjs.Shape();
	this.shape_480.graphics.lf(["#90895E","#908E6E"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_480.setTransform(-219.775,-130.875);

	this.shape_481 = new cjs.Shape();
	this.shape_481.graphics.lf(["#90895E","#908E6E"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_481.setTransform(-177.075,-151.575);

	this.shape_482 = new cjs.Shape();
	this.shape_482.graphics.lf(["#90895E","#908E6E"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_482.setTransform(-37.725,-278.5196);

	this.shape_483 = new cjs.Shape();
	this.shape_483.graphics.lf(["#90895E","#908E6E"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_483.setTransform(-114.5,-223.5);

	this.shape_484 = new cjs.Shape();
	this.shape_484.graphics.lf(["#90895E","#908E6E"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_484.setTransform(-80.375,-257.35);

	this.shape_485 = new cjs.Shape();
	this.shape_485.graphics.lf(["#90895E","#908E6E"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_485.setTransform(-328.05,-10.925);

	this.shape_486 = new cjs.Shape();
	this.shape_486.graphics.lf(["#90895E","#908E6E"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_486.setTransform(-373,-12.325);

	this.shape_487 = new cjs.Shape();
	this.shape_487.graphics.lf(["#90895E","#908E6E"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_487.setTransform(-358.325,-95.45);

	this.shape_488 = new cjs.Shape();
	this.shape_488.graphics.lf(["#90895E","#908E6E"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_488.setTransform(-411.075,-32.2);

	this.shape_489 = new cjs.Shape();
	this.shape_489.graphics.lf(["#90895E","#908E6E"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_489.setTransform(-398.975,-71.425);

	this.shape_490 = new cjs.Shape();
	this.shape_490.graphics.lf(["#868D67","#869275"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_490.setTransform(-510.625,132.625);

	this.shape_491 = new cjs.Shape();
	this.shape_491.graphics.lf(["#868D67","#869275"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_491.setTransform(-468.325,117.725);

	this.shape_492 = new cjs.Shape();
	this.shape_492.graphics.lf(["#868D67","#869275"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_492.setTransform(-425.825,103.1);

	this.shape_493 = new cjs.Shape();
	this.shape_493.graphics.lf(["#868D67","#869275"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_493.setTransform(-340.575,74.725);

	this.shape_494 = new cjs.Shape();
	this.shape_494.graphics.lf(["#868D67","#869275"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_494.setTransform(-383.3,88.725);

	this.shape_495 = new cjs.Shape();
	this.shape_495.graphics.lf(["#868D67","#869275"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_495.setTransform(-296.25,64.05);

	this.shape_496 = new cjs.Shape();
	this.shape_496.graphics.lf(["#868D67","#869275"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_496.setTransform(-251.075,56.95);

	this.shape_497 = new cjs.Shape();
	this.shape_497.graphics.lf(["#868D67","#869275"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_497.setTransform(-205.675,50.875);

	this.shape_498 = new cjs.Shape();
	this.shape_498.graphics.lf(["#868D67","#869275"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_498.setTransform(-160.5,43.575);

	this.shape_499 = new cjs.Shape();
	this.shape_499.graphics.lf(["#868D67","#869275"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_499.setTransform(-117.75,28.75);

	this.shape_500 = new cjs.Shape();
	this.shape_500.graphics.lf(["#868D67","#869275"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_500.setTransform(-122.5,-6.825);

	this.shape_501 = new cjs.Shape();
	this.shape_501.graphics.lf(["#868D67","#869275"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_501.setTransform(-144.525,-186.225);

	this.shape_502 = new cjs.Shape();
	this.shape_502.graphics.lf(["#868D67","#869275"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_502.setTransform(-159.025,-28.975);

	this.shape_503 = new cjs.Shape();
	this.shape_503.graphics.lf(["#868D67","#869275"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_503.setTransform(-200.9,-36.7925);

	this.shape_504 = new cjs.Shape();
	this.shape_504.graphics.lf(["#868D67","#869275"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_504.setTransform(-243.525,-32.85);

	this.shape_505 = new cjs.Shape();
	this.shape_505.graphics.lf(["#868D67","#869275"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_505.setTransform(-284.875,-21.325);

	this.shape_506 = new cjs.Shape();
	this.shape_506.graphics.lf(["#868D67","#869275"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_506.setTransform(-266.575,-120.375);

	this.shape_507 = new cjs.Shape();
	this.shape_507.graphics.lf(["#868D67","#869275"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_507.setTransform(-313.25,-110.575);

	this.shape_508 = new cjs.Shape();
	this.shape_508.graphics.lf(["#868D67","#869275"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_508.setTransform(-219.775,-130.875);

	this.shape_509 = new cjs.Shape();
	this.shape_509.graphics.lf(["#868D67","#869275"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_509.setTransform(-177.075,-151.575);

	this.shape_510 = new cjs.Shape();
	this.shape_510.graphics.lf(["#868D67","#869275"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_510.setTransform(-37.725,-278.5196);

	this.shape_511 = new cjs.Shape();
	this.shape_511.graphics.lf(["#868D67","#869275"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_511.setTransform(-114.5,-223.5);

	this.shape_512 = new cjs.Shape();
	this.shape_512.graphics.lf(["#868D67","#869275"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_512.setTransform(-80.375,-257.35);

	this.shape_513 = new cjs.Shape();
	this.shape_513.graphics.lf(["#868D67","#869275"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_513.setTransform(-328.05,-10.925);

	this.shape_514 = new cjs.Shape();
	this.shape_514.graphics.lf(["#868D67","#869275"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_514.setTransform(-373,-12.325);

	this.shape_515 = new cjs.Shape();
	this.shape_515.graphics.lf(["#868D67","#869275"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_515.setTransform(-358.325,-95.45);

	this.shape_516 = new cjs.Shape();
	this.shape_516.graphics.lf(["#868D67","#869275"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_516.setTransform(-411.075,-32.2);

	this.shape_517 = new cjs.Shape();
	this.shape_517.graphics.lf(["#868D67","#869275"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_517.setTransform(-398.975,-71.425);

	this.shape_518 = new cjs.Shape();
	this.shape_518.graphics.lf(["#7C916F","#7C957C"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_518.setTransform(-510.625,132.625);

	this.shape_519 = new cjs.Shape();
	this.shape_519.graphics.lf(["#7C916F","#7C957C"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_519.setTransform(-468.325,117.725);

	this.shape_520 = new cjs.Shape();
	this.shape_520.graphics.lf(["#7C916F","#7C957C"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_520.setTransform(-425.825,103.1);

	this.shape_521 = new cjs.Shape();
	this.shape_521.graphics.lf(["#7C916F","#7C957C"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_521.setTransform(-340.575,74.725);

	this.shape_522 = new cjs.Shape();
	this.shape_522.graphics.lf(["#7C916F","#7C957C"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_522.setTransform(-383.3,88.725);

	this.shape_523 = new cjs.Shape();
	this.shape_523.graphics.lf(["#7C916F","#7C957C"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_523.setTransform(-296.25,64.05);

	this.shape_524 = new cjs.Shape();
	this.shape_524.graphics.lf(["#7C916F","#7C957C"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_524.setTransform(-251.075,56.95);

	this.shape_525 = new cjs.Shape();
	this.shape_525.graphics.lf(["#7C916F","#7C957C"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_525.setTransform(-205.675,50.875);

	this.shape_526 = new cjs.Shape();
	this.shape_526.graphics.lf(["#7C916F","#7C957C"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_526.setTransform(-160.5,43.575);

	this.shape_527 = new cjs.Shape();
	this.shape_527.graphics.lf(["#7C916F","#7C957C"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_527.setTransform(-117.75,28.75);

	this.shape_528 = new cjs.Shape();
	this.shape_528.graphics.lf(["#7C916F","#7C957C"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_528.setTransform(-122.5,-6.825);

	this.shape_529 = new cjs.Shape();
	this.shape_529.graphics.lf(["#7C916F","#7C957C"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_529.setTransform(-144.525,-186.225);

	this.shape_530 = new cjs.Shape();
	this.shape_530.graphics.lf(["#7C916F","#7C957C"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_530.setTransform(-159.025,-28.975);

	this.shape_531 = new cjs.Shape();
	this.shape_531.graphics.lf(["#7C916F","#7C957C"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_531.setTransform(-200.9,-36.7925);

	this.shape_532 = new cjs.Shape();
	this.shape_532.graphics.lf(["#7C916F","#7C957C"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_532.setTransform(-243.525,-32.85);

	this.shape_533 = new cjs.Shape();
	this.shape_533.graphics.lf(["#7C916F","#7C957C"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_533.setTransform(-284.875,-21.325);

	this.shape_534 = new cjs.Shape();
	this.shape_534.graphics.lf(["#7C916F","#7C957C"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_534.setTransform(-266.575,-120.375);

	this.shape_535 = new cjs.Shape();
	this.shape_535.graphics.lf(["#7C916F","#7C957C"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_535.setTransform(-313.25,-110.575);

	this.shape_536 = new cjs.Shape();
	this.shape_536.graphics.lf(["#7C916F","#7C957C"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_536.setTransform(-219.775,-130.875);

	this.shape_537 = new cjs.Shape();
	this.shape_537.graphics.lf(["#7C916F","#7C957C"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_537.setTransform(-177.075,-151.575);

	this.shape_538 = new cjs.Shape();
	this.shape_538.graphics.lf(["#7C916F","#7C957C"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_538.setTransform(-37.725,-278.5196);

	this.shape_539 = new cjs.Shape();
	this.shape_539.graphics.lf(["#7C916F","#7C957C"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_539.setTransform(-114.5,-223.5);

	this.shape_540 = new cjs.Shape();
	this.shape_540.graphics.lf(["#7C916F","#7C957C"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_540.setTransform(-80.375,-257.35);

	this.shape_541 = new cjs.Shape();
	this.shape_541.graphics.lf(["#7C916F","#7C957C"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_541.setTransform(-328.05,-10.925);

	this.shape_542 = new cjs.Shape();
	this.shape_542.graphics.lf(["#7C916F","#7C957C"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_542.setTransform(-373,-12.325);

	this.shape_543 = new cjs.Shape();
	this.shape_543.graphics.lf(["#7C916F","#7C957C"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_543.setTransform(-358.325,-95.45);

	this.shape_544 = new cjs.Shape();
	this.shape_544.graphics.lf(["#7C916F","#7C957C"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_544.setTransform(-411.075,-32.2);

	this.shape_545 = new cjs.Shape();
	this.shape_545.graphics.lf(["#7C916F","#7C957C"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_545.setTransform(-398.975,-71.425);

	this.shape_546 = new cjs.Shape();
	this.shape_546.graphics.lf(["#729578","#729983"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_546.setTransform(-510.625,132.625);

	this.shape_547 = new cjs.Shape();
	this.shape_547.graphics.lf(["#729578","#729983"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_547.setTransform(-468.325,117.725);

	this.shape_548 = new cjs.Shape();
	this.shape_548.graphics.lf(["#729578","#729983"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_548.setTransform(-425.825,103.1);

	this.shape_549 = new cjs.Shape();
	this.shape_549.graphics.lf(["#729578","#729983"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_549.setTransform(-340.575,74.725);

	this.shape_550 = new cjs.Shape();
	this.shape_550.graphics.lf(["#729578","#729983"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_550.setTransform(-383.3,88.725);

	this.shape_551 = new cjs.Shape();
	this.shape_551.graphics.lf(["#729578","#729983"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_551.setTransform(-296.25,64.05);

	this.shape_552 = new cjs.Shape();
	this.shape_552.graphics.lf(["#729578","#729983"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_552.setTransform(-251.075,56.95);

	this.shape_553 = new cjs.Shape();
	this.shape_553.graphics.lf(["#729578","#729983"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_553.setTransform(-205.675,50.875);

	this.shape_554 = new cjs.Shape();
	this.shape_554.graphics.lf(["#729578","#729983"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_554.setTransform(-160.5,43.575);

	this.shape_555 = new cjs.Shape();
	this.shape_555.graphics.lf(["#729578","#729983"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_555.setTransform(-117.75,28.75);

	this.shape_556 = new cjs.Shape();
	this.shape_556.graphics.lf(["#729578","#729983"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_556.setTransform(-122.5,-6.825);

	this.shape_557 = new cjs.Shape();
	this.shape_557.graphics.lf(["#729578","#729983"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_557.setTransform(-144.525,-186.225);

	this.shape_558 = new cjs.Shape();
	this.shape_558.graphics.lf(["#729578","#729983"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_558.setTransform(-159.025,-28.975);

	this.shape_559 = new cjs.Shape();
	this.shape_559.graphics.lf(["#729578","#729983"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_559.setTransform(-200.9,-36.7925);

	this.shape_560 = new cjs.Shape();
	this.shape_560.graphics.lf(["#729578","#729983"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_560.setTransform(-243.525,-32.85);

	this.shape_561 = new cjs.Shape();
	this.shape_561.graphics.lf(["#729578","#729983"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_561.setTransform(-284.875,-21.325);

	this.shape_562 = new cjs.Shape();
	this.shape_562.graphics.lf(["#729578","#729983"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_562.setTransform(-266.575,-120.375);

	this.shape_563 = new cjs.Shape();
	this.shape_563.graphics.lf(["#729578","#729983"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_563.setTransform(-313.25,-110.575);

	this.shape_564 = new cjs.Shape();
	this.shape_564.graphics.lf(["#729578","#729983"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_564.setTransform(-219.775,-130.875);

	this.shape_565 = new cjs.Shape();
	this.shape_565.graphics.lf(["#729578","#729983"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_565.setTransform(-177.075,-151.575);

	this.shape_566 = new cjs.Shape();
	this.shape_566.graphics.lf(["#729578","#729983"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_566.setTransform(-37.725,-278.5196);

	this.shape_567 = new cjs.Shape();
	this.shape_567.graphics.lf(["#729578","#729983"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_567.setTransform(-114.5,-223.5);

	this.shape_568 = new cjs.Shape();
	this.shape_568.graphics.lf(["#729578","#729983"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_568.setTransform(-80.375,-257.35);

	this.shape_569 = new cjs.Shape();
	this.shape_569.graphics.lf(["#729578","#729983"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_569.setTransform(-328.05,-10.925);

	this.shape_570 = new cjs.Shape();
	this.shape_570.graphics.lf(["#729578","#729983"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_570.setTransform(-373,-12.325);

	this.shape_571 = new cjs.Shape();
	this.shape_571.graphics.lf(["#729578","#729983"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_571.setTransform(-358.325,-95.45);

	this.shape_572 = new cjs.Shape();
	this.shape_572.graphics.lf(["#729578","#729983"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_572.setTransform(-411.075,-32.2);

	this.shape_573 = new cjs.Shape();
	this.shape_573.graphics.lf(["#729578","#729983"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_573.setTransform(-398.975,-71.425);

	this.shape_574 = new cjs.Shape();
	this.shape_574.graphics.lf(["#689981","#689C8A"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_574.setTransform(-510.625,132.625);

	this.shape_575 = new cjs.Shape();
	this.shape_575.graphics.lf(["#689981","#689C8A"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_575.setTransform(-468.325,117.725);

	this.shape_576 = new cjs.Shape();
	this.shape_576.graphics.lf(["#689981","#689C8A"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_576.setTransform(-425.825,103.1);

	this.shape_577 = new cjs.Shape();
	this.shape_577.graphics.lf(["#689981","#689C8A"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_577.setTransform(-340.575,74.725);

	this.shape_578 = new cjs.Shape();
	this.shape_578.graphics.lf(["#689981","#689C8A"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_578.setTransform(-383.3,88.725);

	this.shape_579 = new cjs.Shape();
	this.shape_579.graphics.lf(["#689981","#689C8A"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_579.setTransform(-296.25,64.05);

	this.shape_580 = new cjs.Shape();
	this.shape_580.graphics.lf(["#689981","#689C8A"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_580.setTransform(-251.075,56.95);

	this.shape_581 = new cjs.Shape();
	this.shape_581.graphics.lf(["#689981","#689C8A"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_581.setTransform(-205.675,50.875);

	this.shape_582 = new cjs.Shape();
	this.shape_582.graphics.lf(["#689981","#689C8A"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_582.setTransform(-160.5,43.575);

	this.shape_583 = new cjs.Shape();
	this.shape_583.graphics.lf(["#689981","#689C8A"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_583.setTransform(-117.75,28.75);

	this.shape_584 = new cjs.Shape();
	this.shape_584.graphics.lf(["#689981","#689C8A"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_584.setTransform(-122.5,-6.825);

	this.shape_585 = new cjs.Shape();
	this.shape_585.graphics.lf(["#689981","#689C8A"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_585.setTransform(-144.525,-186.225);

	this.shape_586 = new cjs.Shape();
	this.shape_586.graphics.lf(["#689981","#689C8A"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_586.setTransform(-159.025,-28.975);

	this.shape_587 = new cjs.Shape();
	this.shape_587.graphics.lf(["#689981","#689C8A"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_587.setTransform(-200.9,-36.7925);

	this.shape_588 = new cjs.Shape();
	this.shape_588.graphics.lf(["#689981","#689C8A"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_588.setTransform(-243.525,-32.85);

	this.shape_589 = new cjs.Shape();
	this.shape_589.graphics.lf(["#689981","#689C8A"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_589.setTransform(-284.875,-21.325);

	this.shape_590 = new cjs.Shape();
	this.shape_590.graphics.lf(["#689981","#689C8A"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_590.setTransform(-266.575,-120.375);

	this.shape_591 = new cjs.Shape();
	this.shape_591.graphics.lf(["#689981","#689C8A"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_591.setTransform(-313.25,-110.575);

	this.shape_592 = new cjs.Shape();
	this.shape_592.graphics.lf(["#689981","#689C8A"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_592.setTransform(-219.775,-130.875);

	this.shape_593 = new cjs.Shape();
	this.shape_593.graphics.lf(["#689981","#689C8A"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_593.setTransform(-177.075,-151.575);

	this.shape_594 = new cjs.Shape();
	this.shape_594.graphics.lf(["#689981","#689C8A"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_594.setTransform(-37.725,-278.5196);

	this.shape_595 = new cjs.Shape();
	this.shape_595.graphics.lf(["#689981","#689C8A"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_595.setTransform(-114.5,-223.5);

	this.shape_596 = new cjs.Shape();
	this.shape_596.graphics.lf(["#689981","#689C8A"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_596.setTransform(-80.375,-257.35);

	this.shape_597 = new cjs.Shape();
	this.shape_597.graphics.lf(["#689981","#689C8A"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_597.setTransform(-328.05,-10.925);

	this.shape_598 = new cjs.Shape();
	this.shape_598.graphics.lf(["#689981","#689C8A"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_598.setTransform(-373,-12.325);

	this.shape_599 = new cjs.Shape();
	this.shape_599.graphics.lf(["#689981","#689C8A"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_599.setTransform(-358.325,-95.45);

	this.shape_600 = new cjs.Shape();
	this.shape_600.graphics.lf(["#689981","#689C8A"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_600.setTransform(-411.075,-32.2);

	this.shape_601 = new cjs.Shape();
	this.shape_601.graphics.lf(["#689981","#689C8A"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_601.setTransform(-398.975,-71.425);

	this.shape_602 = new cjs.Shape();
	this.shape_602.graphics.lf(["#5D9D89","#5DA091"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_602.setTransform(-510.625,132.625);

	this.shape_603 = new cjs.Shape();
	this.shape_603.graphics.lf(["#5D9D89","#5DA091"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_603.setTransform(-468.325,117.725);

	this.shape_604 = new cjs.Shape();
	this.shape_604.graphics.lf(["#5D9D89","#5DA091"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_604.setTransform(-425.825,103.1);

	this.shape_605 = new cjs.Shape();
	this.shape_605.graphics.lf(["#5D9D89","#5DA091"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_605.setTransform(-340.575,74.725);

	this.shape_606 = new cjs.Shape();
	this.shape_606.graphics.lf(["#5D9D89","#5DA091"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_606.setTransform(-383.3,88.725);

	this.shape_607 = new cjs.Shape();
	this.shape_607.graphics.lf(["#5D9D89","#5DA091"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_607.setTransform(-296.25,64.05);

	this.shape_608 = new cjs.Shape();
	this.shape_608.graphics.lf(["#5D9D89","#5DA091"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_608.setTransform(-251.075,56.95);

	this.shape_609 = new cjs.Shape();
	this.shape_609.graphics.lf(["#5D9D89","#5DA091"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_609.setTransform(-205.675,50.875);

	this.shape_610 = new cjs.Shape();
	this.shape_610.graphics.lf(["#5D9D89","#5DA091"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_610.setTransform(-160.5,43.575);

	this.shape_611 = new cjs.Shape();
	this.shape_611.graphics.lf(["#5D9D89","#5DA091"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_611.setTransform(-117.75,28.75);

	this.shape_612 = new cjs.Shape();
	this.shape_612.graphics.lf(["#5D9D89","#5DA091"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_612.setTransform(-122.5,-6.825);

	this.shape_613 = new cjs.Shape();
	this.shape_613.graphics.lf(["#5D9D89","#5DA091"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_613.setTransform(-144.525,-186.225);

	this.shape_614 = new cjs.Shape();
	this.shape_614.graphics.lf(["#5D9D89","#5DA091"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_614.setTransform(-159.025,-28.975);

	this.shape_615 = new cjs.Shape();
	this.shape_615.graphics.lf(["#5D9D89","#5DA091"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_615.setTransform(-200.9,-36.7925);

	this.shape_616 = new cjs.Shape();
	this.shape_616.graphics.lf(["#5D9D89","#5DA091"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_616.setTransform(-243.525,-32.85);

	this.shape_617 = new cjs.Shape();
	this.shape_617.graphics.lf(["#5D9D89","#5DA091"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_617.setTransform(-284.875,-21.325);

	this.shape_618 = new cjs.Shape();
	this.shape_618.graphics.lf(["#5D9D89","#5DA091"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_618.setTransform(-266.575,-120.375);

	this.shape_619 = new cjs.Shape();
	this.shape_619.graphics.lf(["#5D9D89","#5DA091"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_619.setTransform(-313.25,-110.575);

	this.shape_620 = new cjs.Shape();
	this.shape_620.graphics.lf(["#5D9D89","#5DA091"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_620.setTransform(-219.775,-130.875);

	this.shape_621 = new cjs.Shape();
	this.shape_621.graphics.lf(["#5D9D89","#5DA091"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_621.setTransform(-177.075,-151.575);

	this.shape_622 = new cjs.Shape();
	this.shape_622.graphics.lf(["#5D9D89","#5DA091"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_622.setTransform(-37.725,-278.5196);

	this.shape_623 = new cjs.Shape();
	this.shape_623.graphics.lf(["#5D9D89","#5DA091"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_623.setTransform(-114.5,-223.5);

	this.shape_624 = new cjs.Shape();
	this.shape_624.graphics.lf(["#5D9D89","#5DA091"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_624.setTransform(-80.375,-257.35);

	this.shape_625 = new cjs.Shape();
	this.shape_625.graphics.lf(["#5D9D89","#5DA091"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_625.setTransform(-328.05,-10.925);

	this.shape_626 = new cjs.Shape();
	this.shape_626.graphics.lf(["#5D9D89","#5DA091"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_626.setTransform(-373,-12.325);

	this.shape_627 = new cjs.Shape();
	this.shape_627.graphics.lf(["#5D9D89","#5DA091"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_627.setTransform(-358.325,-95.45);

	this.shape_628 = new cjs.Shape();
	this.shape_628.graphics.lf(["#5D9D89","#5DA091"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_628.setTransform(-411.075,-32.2);

	this.shape_629 = new cjs.Shape();
	this.shape_629.graphics.lf(["#5D9D89","#5DA091"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_629.setTransform(-398.975,-71.425);

	this.shape_630 = new cjs.Shape();
	this.shape_630.graphics.lf(["#53A192","#53A398"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_630.setTransform(-510.625,132.625);

	this.shape_631 = new cjs.Shape();
	this.shape_631.graphics.lf(["#53A192","#53A398"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_631.setTransform(-468.325,117.725);

	this.shape_632 = new cjs.Shape();
	this.shape_632.graphics.lf(["#53A192","#53A398"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_632.setTransform(-425.825,103.1);

	this.shape_633 = new cjs.Shape();
	this.shape_633.graphics.lf(["#53A192","#53A398"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_633.setTransform(-340.575,74.725);

	this.shape_634 = new cjs.Shape();
	this.shape_634.graphics.lf(["#53A192","#53A398"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_634.setTransform(-383.3,88.725);

	this.shape_635 = new cjs.Shape();
	this.shape_635.graphics.lf(["#53A192","#53A398"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_635.setTransform(-296.25,64.05);

	this.shape_636 = new cjs.Shape();
	this.shape_636.graphics.lf(["#53A192","#53A398"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_636.setTransform(-251.075,56.95);

	this.shape_637 = new cjs.Shape();
	this.shape_637.graphics.lf(["#53A192","#53A398"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_637.setTransform(-205.675,50.875);

	this.shape_638 = new cjs.Shape();
	this.shape_638.graphics.lf(["#53A192","#53A398"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_638.setTransform(-160.5,43.575);

	this.shape_639 = new cjs.Shape();
	this.shape_639.graphics.lf(["#53A192","#53A398"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_639.setTransform(-117.75,28.75);

	this.shape_640 = new cjs.Shape();
	this.shape_640.graphics.lf(["#53A192","#53A398"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_640.setTransform(-122.5,-6.825);

	this.shape_641 = new cjs.Shape();
	this.shape_641.graphics.lf(["#53A192","#53A398"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_641.setTransform(-144.525,-186.225);

	this.shape_642 = new cjs.Shape();
	this.shape_642.graphics.lf(["#53A192","#53A398"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_642.setTransform(-159.025,-28.975);

	this.shape_643 = new cjs.Shape();
	this.shape_643.graphics.lf(["#53A192","#53A398"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_643.setTransform(-200.9,-36.7925);

	this.shape_644 = new cjs.Shape();
	this.shape_644.graphics.lf(["#53A192","#53A398"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_644.setTransform(-243.525,-32.85);

	this.shape_645 = new cjs.Shape();
	this.shape_645.graphics.lf(["#53A192","#53A398"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_645.setTransform(-284.875,-21.325);

	this.shape_646 = new cjs.Shape();
	this.shape_646.graphics.lf(["#53A192","#53A398"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_646.setTransform(-266.575,-120.375);

	this.shape_647 = new cjs.Shape();
	this.shape_647.graphics.lf(["#53A192","#53A398"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_647.setTransform(-313.25,-110.575);

	this.shape_648 = new cjs.Shape();
	this.shape_648.graphics.lf(["#53A192","#53A398"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_648.setTransform(-219.775,-130.875);

	this.shape_649 = new cjs.Shape();
	this.shape_649.graphics.lf(["#53A192","#53A398"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_649.setTransform(-177.075,-151.575);

	this.shape_650 = new cjs.Shape();
	this.shape_650.graphics.lf(["#53A192","#53A398"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_650.setTransform(-37.725,-278.5196);

	this.shape_651 = new cjs.Shape();
	this.shape_651.graphics.lf(["#53A192","#53A398"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_651.setTransform(-114.5,-223.5);

	this.shape_652 = new cjs.Shape();
	this.shape_652.graphics.lf(["#53A192","#53A398"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_652.setTransform(-80.375,-257.35);

	this.shape_653 = new cjs.Shape();
	this.shape_653.graphics.lf(["#53A192","#53A398"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_653.setTransform(-328.05,-10.925);

	this.shape_654 = new cjs.Shape();
	this.shape_654.graphics.lf(["#53A192","#53A398"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_654.setTransform(-373,-12.325);

	this.shape_655 = new cjs.Shape();
	this.shape_655.graphics.lf(["#53A192","#53A398"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_655.setTransform(-358.325,-95.45);

	this.shape_656 = new cjs.Shape();
	this.shape_656.graphics.lf(["#53A192","#53A398"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_656.setTransform(-411.075,-32.2);

	this.shape_657 = new cjs.Shape();
	this.shape_657.graphics.lf(["#53A192","#53A398"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_657.setTransform(-398.975,-71.425);

	this.shape_658 = new cjs.Shape();
	this.shape_658.graphics.lf(["#49A59A","#49A79F"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_658.setTransform(-510.625,132.625);

	this.shape_659 = new cjs.Shape();
	this.shape_659.graphics.lf(["#49A59A","#49A79F"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_659.setTransform(-468.325,117.725);

	this.shape_660 = new cjs.Shape();
	this.shape_660.graphics.lf(["#49A59A","#49A79F"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_660.setTransform(-425.825,103.1);

	this.shape_661 = new cjs.Shape();
	this.shape_661.graphics.lf(["#49A59A","#49A79F"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_661.setTransform(-340.575,74.725);

	this.shape_662 = new cjs.Shape();
	this.shape_662.graphics.lf(["#49A59A","#49A79F"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_662.setTransform(-383.3,88.725);

	this.shape_663 = new cjs.Shape();
	this.shape_663.graphics.lf(["#49A59A","#49A79F"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_663.setTransform(-296.25,64.05);

	this.shape_664 = new cjs.Shape();
	this.shape_664.graphics.lf(["#49A59A","#49A79F"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_664.setTransform(-251.075,56.95);

	this.shape_665 = new cjs.Shape();
	this.shape_665.graphics.lf(["#49A59A","#49A79F"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_665.setTransform(-205.675,50.875);

	this.shape_666 = new cjs.Shape();
	this.shape_666.graphics.lf(["#49A59A","#49A79F"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_666.setTransform(-160.5,43.575);

	this.shape_667 = new cjs.Shape();
	this.shape_667.graphics.lf(["#49A59A","#49A79F"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_667.setTransform(-117.75,28.75);

	this.shape_668 = new cjs.Shape();
	this.shape_668.graphics.lf(["#49A59A","#49A79F"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_668.setTransform(-122.5,-6.825);

	this.shape_669 = new cjs.Shape();
	this.shape_669.graphics.lf(["#49A59A","#49A79F"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_669.setTransform(-144.525,-186.225);

	this.shape_670 = new cjs.Shape();
	this.shape_670.graphics.lf(["#49A59A","#49A79F"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_670.setTransform(-159.025,-28.975);

	this.shape_671 = new cjs.Shape();
	this.shape_671.graphics.lf(["#49A59A","#49A79F"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_671.setTransform(-200.9,-36.7925);

	this.shape_672 = new cjs.Shape();
	this.shape_672.graphics.lf(["#49A59A","#49A79F"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_672.setTransform(-243.525,-32.85);

	this.shape_673 = new cjs.Shape();
	this.shape_673.graphics.lf(["#49A59A","#49A79F"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_673.setTransform(-284.875,-21.325);

	this.shape_674 = new cjs.Shape();
	this.shape_674.graphics.lf(["#49A59A","#49A79F"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_674.setTransform(-266.575,-120.375);

	this.shape_675 = new cjs.Shape();
	this.shape_675.graphics.lf(["#49A59A","#49A79F"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_675.setTransform(-313.25,-110.575);

	this.shape_676 = new cjs.Shape();
	this.shape_676.graphics.lf(["#49A59A","#49A79F"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_676.setTransform(-219.775,-130.875);

	this.shape_677 = new cjs.Shape();
	this.shape_677.graphics.lf(["#49A59A","#49A79F"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_677.setTransform(-177.075,-151.575);

	this.shape_678 = new cjs.Shape();
	this.shape_678.graphics.lf(["#49A59A","#49A79F"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_678.setTransform(-37.725,-278.5196);

	this.shape_679 = new cjs.Shape();
	this.shape_679.graphics.lf(["#49A59A","#49A79F"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_679.setTransform(-114.5,-223.5);

	this.shape_680 = new cjs.Shape();
	this.shape_680.graphics.lf(["#49A59A","#49A79F"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_680.setTransform(-80.375,-257.35);

	this.shape_681 = new cjs.Shape();
	this.shape_681.graphics.lf(["#49A59A","#49A79F"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_681.setTransform(-328.05,-10.925);

	this.shape_682 = new cjs.Shape();
	this.shape_682.graphics.lf(["#49A59A","#49A79F"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_682.setTransform(-373,-12.325);

	this.shape_683 = new cjs.Shape();
	this.shape_683.graphics.lf(["#49A59A","#49A79F"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_683.setTransform(-358.325,-95.45);

	this.shape_684 = new cjs.Shape();
	this.shape_684.graphics.lf(["#49A59A","#49A79F"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_684.setTransform(-411.075,-32.2);

	this.shape_685 = new cjs.Shape();
	this.shape_685.graphics.lf(["#49A59A","#49A79F"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_685.setTransform(-398.975,-71.425);

	this.shape_686 = new cjs.Shape();
	this.shape_686.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_686.setTransform(-510.625,132.625);

	this.shape_687 = new cjs.Shape();
	this.shape_687.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_687.setTransform(-468.325,117.725);

	this.shape_688 = new cjs.Shape();
	this.shape_688.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_688.setTransform(-425.825,103.1);

	this.shape_689 = new cjs.Shape();
	this.shape_689.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_689.setTransform(-340.575,74.725);

	this.shape_690 = new cjs.Shape();
	this.shape_690.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_690.setTransform(-383.3,88.725);

	this.shape_691 = new cjs.Shape();
	this.shape_691.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_691.setTransform(-296.25,64.05);

	this.shape_692 = new cjs.Shape();
	this.shape_692.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_692.setTransform(-251.075,56.95);

	this.shape_693 = new cjs.Shape();
	this.shape_693.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_693.setTransform(-205.675,50.875);

	this.shape_694 = new cjs.Shape();
	this.shape_694.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_694.setTransform(-160.5,43.575);

	this.shape_695 = new cjs.Shape();
	this.shape_695.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_695.setTransform(-117.75,28.75);

	this.shape_696 = new cjs.Shape();
	this.shape_696.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_696.setTransform(-122.5,-6.825);

	this.shape_697 = new cjs.Shape();
	this.shape_697.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_697.setTransform(-144.525,-186.225);

	this.shape_698 = new cjs.Shape();
	this.shape_698.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_698.setTransform(-159.025,-28.975);

	this.shape_699 = new cjs.Shape();
	this.shape_699.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_699.setTransform(-200.9,-36.7925);

	this.shape_700 = new cjs.Shape();
	this.shape_700.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_700.setTransform(-243.525,-32.85);

	this.shape_701 = new cjs.Shape();
	this.shape_701.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_701.setTransform(-284.875,-21.325);

	this.shape_702 = new cjs.Shape();
	this.shape_702.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_702.setTransform(-266.575,-120.375);

	this.shape_703 = new cjs.Shape();
	this.shape_703.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_703.setTransform(-313.25,-110.575);

	this.shape_704 = new cjs.Shape();
	this.shape_704.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_704.setTransform(-219.775,-130.875);

	this.shape_705 = new cjs.Shape();
	this.shape_705.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_705.setTransform(-177.075,-151.575);

	this.shape_706 = new cjs.Shape();
	this.shape_706.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_706.setTransform(-37.725,-278.5196);

	this.shape_707 = new cjs.Shape();
	this.shape_707.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_707.setTransform(-114.5,-223.5);

	this.shape_708 = new cjs.Shape();
	this.shape_708.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_708.setTransform(-80.375,-257.35);

	this.shape_709 = new cjs.Shape();
	this.shape_709.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_709.setTransform(-328.05,-10.925);

	this.shape_710 = new cjs.Shape();
	this.shape_710.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_710.setTransform(-373,-12.325);

	this.shape_711 = new cjs.Shape();
	this.shape_711.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_711.setTransform(-358.325,-95.45);

	this.shape_712 = new cjs.Shape();
	this.shape_712.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_712.setTransform(-411.075,-32.2);

	this.shape_713 = new cjs.Shape();
	this.shape_713.graphics.lf(["#3FA9A3","#3FAAA6"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_713.setTransform(-398.975,-71.425);

	this.shape_714 = new cjs.Shape();
	this.shape_714.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_714.setTransform(-510.625,132.625);

	this.shape_715 = new cjs.Shape();
	this.shape_715.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_715.setTransform(-468.325,117.725);

	this.shape_716 = new cjs.Shape();
	this.shape_716.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_716.setTransform(-425.825,103.1);

	this.shape_717 = new cjs.Shape();
	this.shape_717.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_717.setTransform(-340.575,74.725);

	this.shape_718 = new cjs.Shape();
	this.shape_718.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_718.setTransform(-383.3,88.725);

	this.shape_719 = new cjs.Shape();
	this.shape_719.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_719.setTransform(-296.25,64.05);

	this.shape_720 = new cjs.Shape();
	this.shape_720.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_720.setTransform(-251.075,56.95);

	this.shape_721 = new cjs.Shape();
	this.shape_721.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_721.setTransform(-205.675,50.875);

	this.shape_722 = new cjs.Shape();
	this.shape_722.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_722.setTransform(-160.5,43.575);

	this.shape_723 = new cjs.Shape();
	this.shape_723.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_723.setTransform(-117.75,28.75);

	this.shape_724 = new cjs.Shape();
	this.shape_724.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_724.setTransform(-122.5,-6.825);

	this.shape_725 = new cjs.Shape();
	this.shape_725.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_725.setTransform(-144.525,-186.225);

	this.shape_726 = new cjs.Shape();
	this.shape_726.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_726.setTransform(-159.025,-28.975);

	this.shape_727 = new cjs.Shape();
	this.shape_727.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_727.setTransform(-200.9,-36.7925);

	this.shape_728 = new cjs.Shape();
	this.shape_728.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_728.setTransform(-243.525,-32.85);

	this.shape_729 = new cjs.Shape();
	this.shape_729.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_729.setTransform(-284.875,-21.325);

	this.shape_730 = new cjs.Shape();
	this.shape_730.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_730.setTransform(-266.575,-120.375);

	this.shape_731 = new cjs.Shape();
	this.shape_731.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_731.setTransform(-313.25,-110.575);

	this.shape_732 = new cjs.Shape();
	this.shape_732.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_732.setTransform(-219.775,-130.875);

	this.shape_733 = new cjs.Shape();
	this.shape_733.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_733.setTransform(-177.075,-151.575);

	this.shape_734 = new cjs.Shape();
	this.shape_734.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_734.setTransform(-37.725,-278.5196);

	this.shape_735 = new cjs.Shape();
	this.shape_735.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_735.setTransform(-114.5,-223.5);

	this.shape_736 = new cjs.Shape();
	this.shape_736.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_736.setTransform(-80.375,-257.35);

	this.shape_737 = new cjs.Shape();
	this.shape_737.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_737.setTransform(-328.05,-10.925);

	this.shape_738 = new cjs.Shape();
	this.shape_738.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_738.setTransform(-373,-12.325);

	this.shape_739 = new cjs.Shape();
	this.shape_739.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_739.setTransform(-358.325,-95.45);

	this.shape_740 = new cjs.Shape();
	this.shape_740.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_740.setTransform(-411.075,-32.2);

	this.shape_741 = new cjs.Shape();
	this.shape_741.graphics.lf(["#35ADAB","#35AEAD"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_741.setTransform(-398.975,-71.425);

	this.shape_742 = new cjs.Shape();
	this.shape_742.graphics.f("#2BB1B4").s().p("EgmXAg1QgognAAg3QAAg3AognQAngnA3AAQA3AAAnAnQAnAnAAA3QAAA3gnAnQgnAng3AAQg3AAgngngEggFAdPIDVhKIAQAwIjUBKgA5ba8IDUhIIAQAvIjVBJgAyyYsIDVhHIAPAvIjUBHgAsIWeIBrgjQA4gSA2gPIAOAxQgvAMg9AUIhrAjgAlPUmQBogWB6gUIAIAxQiCAWheAUgAB1TZIDjgfIAGAyIjiAfgAI6ScIDigfIAIAyIjjAfgAP9RaQB/gWBhgWIALAwQhaAWiIAXgAW0PtQCGg2AjhCIAsAXQgrBSiXA9gAXdJyQgngjgqgfIAegoQAnAdAtAnQAxArAjArIgnAfQgfglgvgqgAqKIwQBtgGBvgVIAJAxQhzAWhvAGgAxMIuIAPgwQBlAhByAMIgGAyQh3gNhpgigAjXHfQArgNA+gXIBngiIAOAvQgvAPg1AUQg7AVgxAOgA14GAQgvg2gEhGIAzgCQACA1AjAnQAdAhA1AjIgcApQg4glgjgmgAQVF7IANgxQBsAeBhAvIgWAtQhcgthogcgADHFdQBqgaBqgQIAHAxQhgAPhvAbgAJ0FQIgCgyQBzgFBmALIgEAxQhlgKhuAFgA1HAeQBIhSBxhMIAbApQhsBKhCBLgAu+j4QBngyB3gsIARAuQh0AshkAxgAn9miQBqgfB+gdIALAwQh7AdhqAfgAgroPIB1gUIB2gUIAJAxQhEANgzAIIh0AUgAGpppQB7gfBngmIARAvQhmAmiBAhgANfsRQBlg8BVhRIAiAlQhYBUhrA/gAS3xNQAtg6BkiEIAnAeQh3CegbAhgAXd3HQBQhgBQhUIAkAiQhPBVhPBdgAco8lQA7g4AegaQA0guAtgiIAeAoQg0AogpAmQgqAlgvArgEAjOggVIgQgvQCJgvB5AxIgTAuQhogqh3Apg");
	this.shape_742.setTransform(-274.4,-68.0696);

	this.shape_743 = new cjs.Shape();
	this.shape_743.graphics.lf(["#FF5E00","#FF6821"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_743.setTransform(1.75,-253.225);

	this.shape_744 = new cjs.Shape();
	this.shape_744.graphics.lf(["#FF5E00","#FF6821"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_744.setTransform(32.725,-214.9);

	this.shape_745 = new cjs.Shape();
	this.shape_745.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_745.setTransform(67.475,-180.175);

	this.shape_746 = new cjs.Shape();
	this.shape_746.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_746.setTransform(108.425,-153.25);

	this.shape_747 = new cjs.Shape();
	this.shape_747.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_747.setTransform(154.35,-135.525);

	this.shape_748 = new cjs.Shape();
	this.shape_748.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_748.setTransform(202.225,-123.35);

	this.shape_749 = new cjs.Shape();
	this.shape_749.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_749.setTransform(250.45,-113.45);

	this.shape_750 = new cjs.Shape();
	this.shape_750.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIADAEIgCgBIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQANADALAFQAOAHAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_750.setTransform(298.7901,-104.575);

	this.shape_751 = new cjs.Shape();
	this.shape_751.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_751.setTransform(273.8,-86.475);

	this.shape_752 = new cjs.Shape();
	this.shape_752.graphics.lf(["#FF5E00","#FF6821"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_752.setTransform(232.95,-65.4);

	this.shape_753 = new cjs.Shape();
	this.shape_753.graphics.lf(["#FF5E00","#FF6821"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_753.setTransform(205.1312,-32.65);

	this.shape_754 = new cjs.Shape();
	this.shape_754.graphics.lf(["#EA6612","#EA6F30"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_754.setTransform(-510.625,132.625);

	this.shape_755 = new cjs.Shape();
	this.shape_755.graphics.lf(["#EA6612","#EA6F30"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_755.setTransform(-468.325,117.725);

	this.shape_756 = new cjs.Shape();
	this.shape_756.graphics.lf(["#EA6612","#EA6F30"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_756.setTransform(-425.825,103.1);

	this.shape_757 = new cjs.Shape();
	this.shape_757.graphics.lf(["#EA6612","#EA6F30"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_757.setTransform(-340.575,74.725);

	this.shape_758 = new cjs.Shape();
	this.shape_758.graphics.lf(["#EA6612","#EA6F30"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_758.setTransform(-383.3,88.725);

	this.shape_759 = new cjs.Shape();
	this.shape_759.graphics.lf(["#EA6612","#EA6F30"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_759.setTransform(-296.25,64.05);

	this.shape_760 = new cjs.Shape();
	this.shape_760.graphics.lf(["#EA6612","#EA6F30"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_760.setTransform(-251.075,56.95);

	this.shape_761 = new cjs.Shape();
	this.shape_761.graphics.lf(["#EA6612","#EA6F30"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_761.setTransform(-205.675,50.875);

	this.shape_762 = new cjs.Shape();
	this.shape_762.graphics.lf(["#EA6612","#EA6F30"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_762.setTransform(-160.5,43.575);

	this.shape_763 = new cjs.Shape();
	this.shape_763.graphics.lf(["#EA6612","#EA6F30"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_763.setTransform(-117.75,28.75);

	this.shape_764 = new cjs.Shape();
	this.shape_764.graphics.lf(["#EA6612","#EA6F30"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_764.setTransform(273.8,-86.475);

	this.shape_765 = new cjs.Shape();
	this.shape_765.graphics.lf(["#EA6612","#EA6F30"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_765.setTransform(205.1312,-32.65);

	this.shape_766 = new cjs.Shape();
	this.shape_766.graphics.lf(["#EA6612","#EA6F30"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_766.setTransform(232.95,-65.4);

	this.shape_767 = new cjs.Shape();
	this.shape_767.graphics.lf(["#EA6612","#EA6F30"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_767.setTransform(202.225,-123.35);

	this.shape_768 = new cjs.Shape();
	this.shape_768.graphics.lf(["#EA6612","#EA6F30"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_768.setTransform(298.7901,-104.575);

	this.shape_769 = new cjs.Shape();
	this.shape_769.graphics.lf(["#EA6612","#EA6F30"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_769.setTransform(250.45,-113.45);

	this.shape_770 = new cjs.Shape();
	this.shape_770.graphics.lf(["#EA6612","#EA6F30"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_770.setTransform(67.475,-180.175);

	this.shape_771 = new cjs.Shape();
	this.shape_771.graphics.lf(["#EA6612","#EA6F30"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_771.setTransform(154.35,-135.525);

	this.shape_772 = new cjs.Shape();
	this.shape_772.graphics.lf(["#EA6612","#EA6F30"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_772.setTransform(108.425,-153.25);

	this.shape_773 = new cjs.Shape();
	this.shape_773.graphics.lf(["#EA6612","#EA6F30"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_773.setTransform(32.725,-214.9);

	this.shape_774 = new cjs.Shape();
	this.shape_774.graphics.lf(["#EA6612","#EA6F30"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_774.setTransform(-122.5,-6.825);

	this.shape_775 = new cjs.Shape();
	this.shape_775.graphics.lf(["#EA6612","#EA6F30"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_775.setTransform(-144.525,-186.225);

	this.shape_776 = new cjs.Shape();
	this.shape_776.graphics.lf(["#EA6612","#EA6F30"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_776.setTransform(-159.025,-28.975);

	this.shape_777 = new cjs.Shape();
	this.shape_777.graphics.lf(["#EA6612","#EA6F30"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_777.setTransform(-200.9,-36.7925);

	this.shape_778 = new cjs.Shape();
	this.shape_778.graphics.lf(["#EA6612","#EA6F30"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_778.setTransform(-243.525,-32.85);

	this.shape_779 = new cjs.Shape();
	this.shape_779.graphics.lf(["#EA6612","#EA6F30"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_779.setTransform(-284.875,-21.325);

	this.shape_780 = new cjs.Shape();
	this.shape_780.graphics.lf(["#EA6612","#EA6F30"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_780.setTransform(-266.575,-120.375);

	this.shape_781 = new cjs.Shape();
	this.shape_781.graphics.lf(["#EA6612","#EA6F30"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_781.setTransform(-313.25,-110.575);

	this.shape_782 = new cjs.Shape();
	this.shape_782.graphics.lf(["#EA6612","#EA6F30"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_782.setTransform(-219.775,-130.875);

	this.shape_783 = new cjs.Shape();
	this.shape_783.graphics.lf(["#EA6612","#EA6F30"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_783.setTransform(-177.075,-151.575);

	this.shape_784 = new cjs.Shape();
	this.shape_784.graphics.lf(["#EA6612","#EA6F30"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_784.setTransform(-37.725,-278.5196);

	this.shape_785 = new cjs.Shape();
	this.shape_785.graphics.lf(["#EA6612","#EA6F30"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_785.setTransform(1.75,-253.225);

	this.shape_786 = new cjs.Shape();
	this.shape_786.graphics.lf(["#EA6612","#EA6F30"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_786.setTransform(-114.5,-223.5);

	this.shape_787 = new cjs.Shape();
	this.shape_787.graphics.lf(["#EA6612","#EA6F30"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_787.setTransform(-80.375,-257.35);

	this.shape_788 = new cjs.Shape();
	this.shape_788.graphics.lf(["#EA6612","#EA6F30"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_788.setTransform(-328.05,-10.925);

	this.shape_789 = new cjs.Shape();
	this.shape_789.graphics.lf(["#EA6612","#EA6F30"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_789.setTransform(-373,-12.325);

	this.shape_790 = new cjs.Shape();
	this.shape_790.graphics.lf(["#EA6612","#EA6F30"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_790.setTransform(-358.325,-95.45);

	this.shape_791 = new cjs.Shape();
	this.shape_791.graphics.lf(["#EA6612","#EA6F30"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_791.setTransform(-411.075,-32.2);

	this.shape_792 = new cjs.Shape();
	this.shape_792.graphics.lf(["#EA6612","#EA6F30"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_792.setTransform(-398.975,-71.425);

	this.shape_793 = new cjs.Shape();
	this.shape_793.graphics.lf(["#D56F24","#D5773E"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_793.setTransform(-510.625,132.625);

	this.shape_794 = new cjs.Shape();
	this.shape_794.graphics.lf(["#D56F24","#D5773E"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_794.setTransform(-468.325,117.725);

	this.shape_795 = new cjs.Shape();
	this.shape_795.graphics.lf(["#D56F24","#D5773E"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_795.setTransform(-425.825,103.1);

	this.shape_796 = new cjs.Shape();
	this.shape_796.graphics.lf(["#D56F24","#D5773E"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_796.setTransform(-340.575,74.725);

	this.shape_797 = new cjs.Shape();
	this.shape_797.graphics.lf(["#D56F24","#D5773E"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_797.setTransform(-383.3,88.725);

	this.shape_798 = new cjs.Shape();
	this.shape_798.graphics.lf(["#D56F24","#D5773E"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_798.setTransform(-296.25,64.05);

	this.shape_799 = new cjs.Shape();
	this.shape_799.graphics.lf(["#D56F24","#D5773E"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_799.setTransform(-251.075,56.95);

	this.shape_800 = new cjs.Shape();
	this.shape_800.graphics.lf(["#D56F24","#D5773E"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_800.setTransform(-205.675,50.875);

	this.shape_801 = new cjs.Shape();
	this.shape_801.graphics.lf(["#D56F24","#D5773E"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_801.setTransform(-160.5,43.575);

	this.shape_802 = new cjs.Shape();
	this.shape_802.graphics.lf(["#D56F24","#D5773E"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_802.setTransform(-117.75,28.75);

	this.shape_803 = new cjs.Shape();
	this.shape_803.graphics.lf(["#D56F24","#D5773E"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_803.setTransform(273.8,-86.475);

	this.shape_804 = new cjs.Shape();
	this.shape_804.graphics.lf(["#D56F24","#D5773E"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_804.setTransform(205.1312,-32.65);

	this.shape_805 = new cjs.Shape();
	this.shape_805.graphics.lf(["#D56F24","#D5773E"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_805.setTransform(232.95,-65.4);

	this.shape_806 = new cjs.Shape();
	this.shape_806.graphics.lf(["#D56F24","#D5773E"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_806.setTransform(202.225,-123.35);

	this.shape_807 = new cjs.Shape();
	this.shape_807.graphics.lf(["#D56F24","#D5773E"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_807.setTransform(298.7901,-104.575);

	this.shape_808 = new cjs.Shape();
	this.shape_808.graphics.lf(["#D56F24","#D5773E"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_808.setTransform(250.45,-113.45);

	this.shape_809 = new cjs.Shape();
	this.shape_809.graphics.lf(["#D56F24","#D5773E"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_809.setTransform(67.475,-180.175);

	this.shape_810 = new cjs.Shape();
	this.shape_810.graphics.lf(["#D56F24","#D5773E"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_810.setTransform(154.35,-135.525);

	this.shape_811 = new cjs.Shape();
	this.shape_811.graphics.lf(["#D56F24","#D5773E"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_811.setTransform(108.425,-153.25);

	this.shape_812 = new cjs.Shape();
	this.shape_812.graphics.lf(["#D56F24","#D5773E"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_812.setTransform(32.725,-214.9);

	this.shape_813 = new cjs.Shape();
	this.shape_813.graphics.lf(["#D56F24","#D5773E"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_813.setTransform(-122.5,-6.825);

	this.shape_814 = new cjs.Shape();
	this.shape_814.graphics.lf(["#D56F24","#D5773E"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_814.setTransform(-144.525,-186.225);

	this.shape_815 = new cjs.Shape();
	this.shape_815.graphics.lf(["#D56F24","#D5773E"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_815.setTransform(-159.025,-28.975);

	this.shape_816 = new cjs.Shape();
	this.shape_816.graphics.lf(["#D56F24","#D5773E"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_816.setTransform(-200.9,-36.7925);

	this.shape_817 = new cjs.Shape();
	this.shape_817.graphics.lf(["#D56F24","#D5773E"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_817.setTransform(-243.525,-32.85);

	this.shape_818 = new cjs.Shape();
	this.shape_818.graphics.lf(["#D56F24","#D5773E"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_818.setTransform(-284.875,-21.325);

	this.shape_819 = new cjs.Shape();
	this.shape_819.graphics.lf(["#D56F24","#D5773E"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_819.setTransform(-266.575,-120.375);

	this.shape_820 = new cjs.Shape();
	this.shape_820.graphics.lf(["#D56F24","#D5773E"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_820.setTransform(-313.25,-110.575);

	this.shape_821 = new cjs.Shape();
	this.shape_821.graphics.lf(["#D56F24","#D5773E"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_821.setTransform(-219.775,-130.875);

	this.shape_822 = new cjs.Shape();
	this.shape_822.graphics.lf(["#D56F24","#D5773E"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_822.setTransform(-177.075,-151.575);

	this.shape_823 = new cjs.Shape();
	this.shape_823.graphics.lf(["#D56F24","#D5773E"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_823.setTransform(-37.725,-278.5196);

	this.shape_824 = new cjs.Shape();
	this.shape_824.graphics.lf(["#D56F24","#D5773E"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_824.setTransform(1.75,-253.225);

	this.shape_825 = new cjs.Shape();
	this.shape_825.graphics.lf(["#D56F24","#D5773E"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_825.setTransform(-114.5,-223.5);

	this.shape_826 = new cjs.Shape();
	this.shape_826.graphics.lf(["#D56F24","#D5773E"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_826.setTransform(-80.375,-257.35);

	this.shape_827 = new cjs.Shape();
	this.shape_827.graphics.lf(["#D56F24","#D5773E"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_827.setTransform(-328.05,-10.925);

	this.shape_828 = new cjs.Shape();
	this.shape_828.graphics.lf(["#D56F24","#D5773E"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_828.setTransform(-373,-12.325);

	this.shape_829 = new cjs.Shape();
	this.shape_829.graphics.lf(["#D56F24","#D5773E"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_829.setTransform(-358.325,-95.45);

	this.shape_830 = new cjs.Shape();
	this.shape_830.graphics.lf(["#D56F24","#D5773E"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_830.setTransform(-411.075,-32.2);

	this.shape_831 = new cjs.Shape();
	this.shape_831.graphics.lf(["#D56F24","#D5773E"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_831.setTransform(-398.975,-71.425);

	this.shape_832 = new cjs.Shape();
	this.shape_832.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_832.setTransform(-510.625,132.625);

	this.shape_833 = new cjs.Shape();
	this.shape_833.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_833.setTransform(-468.325,117.725);

	this.shape_834 = new cjs.Shape();
	this.shape_834.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_834.setTransform(-425.825,103.1);

	this.shape_835 = new cjs.Shape();
	this.shape_835.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_835.setTransform(-340.575,74.725);

	this.shape_836 = new cjs.Shape();
	this.shape_836.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_836.setTransform(-383.3,88.725);

	this.shape_837 = new cjs.Shape();
	this.shape_837.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_837.setTransform(-296.25,64.05);

	this.shape_838 = new cjs.Shape();
	this.shape_838.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_838.setTransform(-251.075,56.95);

	this.shape_839 = new cjs.Shape();
	this.shape_839.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_839.setTransform(-205.675,50.875);

	this.shape_840 = new cjs.Shape();
	this.shape_840.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_840.setTransform(-160.5,43.575);

	this.shape_841 = new cjs.Shape();
	this.shape_841.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_841.setTransform(-117.75,28.75);

	this.shape_842 = new cjs.Shape();
	this.shape_842.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_842.setTransform(273.8,-86.475);

	this.shape_843 = new cjs.Shape();
	this.shape_843.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_843.setTransform(205.1312,-32.65);

	this.shape_844 = new cjs.Shape();
	this.shape_844.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_844.setTransform(232.95,-65.4);

	this.shape_845 = new cjs.Shape();
	this.shape_845.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_845.setTransform(202.225,-123.35);

	this.shape_846 = new cjs.Shape();
	this.shape_846.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_846.setTransform(298.7901,-104.575);

	this.shape_847 = new cjs.Shape();
	this.shape_847.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_847.setTransform(250.45,-113.45);

	this.shape_848 = new cjs.Shape();
	this.shape_848.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_848.setTransform(67.475,-180.175);

	this.shape_849 = new cjs.Shape();
	this.shape_849.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_849.setTransform(154.35,-135.525);

	this.shape_850 = new cjs.Shape();
	this.shape_850.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_850.setTransform(108.425,-153.25);

	this.shape_851 = new cjs.Shape();
	this.shape_851.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_851.setTransform(32.725,-214.9);

	this.shape_852 = new cjs.Shape();
	this.shape_852.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_852.setTransform(-122.5,-6.825);

	this.shape_853 = new cjs.Shape();
	this.shape_853.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_853.setTransform(-144.525,-186.225);

	this.shape_854 = new cjs.Shape();
	this.shape_854.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_854.setTransform(-159.025,-28.975);

	this.shape_855 = new cjs.Shape();
	this.shape_855.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_855.setTransform(-200.9,-36.7925);

	this.shape_856 = new cjs.Shape();
	this.shape_856.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_856.setTransform(-243.525,-32.85);

	this.shape_857 = new cjs.Shape();
	this.shape_857.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_857.setTransform(-284.875,-21.325);

	this.shape_858 = new cjs.Shape();
	this.shape_858.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_858.setTransform(-266.575,-120.375);

	this.shape_859 = new cjs.Shape();
	this.shape_859.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_859.setTransform(-313.25,-110.575);

	this.shape_860 = new cjs.Shape();
	this.shape_860.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_860.setTransform(-219.775,-130.875);

	this.shape_861 = new cjs.Shape();
	this.shape_861.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_861.setTransform(-177.075,-151.575);

	this.shape_862 = new cjs.Shape();
	this.shape_862.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_862.setTransform(-37.725,-278.5196);

	this.shape_863 = new cjs.Shape();
	this.shape_863.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_863.setTransform(1.75,-253.225);

	this.shape_864 = new cjs.Shape();
	this.shape_864.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_864.setTransform(-114.5,-223.5);

	this.shape_865 = new cjs.Shape();
	this.shape_865.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_865.setTransform(-80.375,-257.35);

	this.shape_866 = new cjs.Shape();
	this.shape_866.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_866.setTransform(-328.05,-10.925);

	this.shape_867 = new cjs.Shape();
	this.shape_867.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_867.setTransform(-373,-12.325);

	this.shape_868 = new cjs.Shape();
	this.shape_868.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_868.setTransform(-358.325,-95.45);

	this.shape_869 = new cjs.Shape();
	this.shape_869.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_869.setTransform(-411.075,-32.2);

	this.shape_870 = new cjs.Shape();
	this.shape_870.graphics.lf(["#BF7736","#BF7E4D"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_870.setTransform(-398.975,-71.425);

	this.shape_871 = new cjs.Shape();
	this.shape_871.graphics.lf(["#AA7F48","#AA855C"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_871.setTransform(-510.625,132.625);

	this.shape_872 = new cjs.Shape();
	this.shape_872.graphics.lf(["#AA7F48","#AA855C"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_872.setTransform(-468.325,117.725);

	this.shape_873 = new cjs.Shape();
	this.shape_873.graphics.lf(["#AA7F48","#AA855C"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_873.setTransform(-425.825,103.1);

	this.shape_874 = new cjs.Shape();
	this.shape_874.graphics.lf(["#AA7F48","#AA855C"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_874.setTransform(-340.575,74.725);

	this.shape_875 = new cjs.Shape();
	this.shape_875.graphics.lf(["#AA7F48","#AA855C"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_875.setTransform(-383.3,88.725);

	this.shape_876 = new cjs.Shape();
	this.shape_876.graphics.lf(["#AA7F48","#AA855C"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_876.setTransform(-296.25,64.05);

	this.shape_877 = new cjs.Shape();
	this.shape_877.graphics.lf(["#AA7F48","#AA855C"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_877.setTransform(-251.075,56.95);

	this.shape_878 = new cjs.Shape();
	this.shape_878.graphics.lf(["#AA7F48","#AA855C"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_878.setTransform(-205.675,50.875);

	this.shape_879 = new cjs.Shape();
	this.shape_879.graphics.lf(["#AA7F48","#AA855C"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_879.setTransform(-160.5,43.575);

	this.shape_880 = new cjs.Shape();
	this.shape_880.graphics.lf(["#AA7F48","#AA855C"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_880.setTransform(-117.75,28.75);

	this.shape_881 = new cjs.Shape();
	this.shape_881.graphics.lf(["#AA7F48","#AA855C"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_881.setTransform(273.8,-86.475);

	this.shape_882 = new cjs.Shape();
	this.shape_882.graphics.lf(["#AA7F48","#AA855C"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_882.setTransform(205.1312,-32.65);

	this.shape_883 = new cjs.Shape();
	this.shape_883.graphics.lf(["#AA7F48","#AA855C"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_883.setTransform(232.95,-65.4);

	this.shape_884 = new cjs.Shape();
	this.shape_884.graphics.lf(["#AA7F48","#AA855C"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_884.setTransform(202.225,-123.35);

	this.shape_885 = new cjs.Shape();
	this.shape_885.graphics.lf(["#AA7F48","#AA855C"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_885.setTransform(298.7901,-104.575);

	this.shape_886 = new cjs.Shape();
	this.shape_886.graphics.lf(["#AA7F48","#AA855C"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_886.setTransform(250.45,-113.45);

	this.shape_887 = new cjs.Shape();
	this.shape_887.graphics.lf(["#AA7F48","#AA855C"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_887.setTransform(67.475,-180.175);

	this.shape_888 = new cjs.Shape();
	this.shape_888.graphics.lf(["#AA7F48","#AA855C"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_888.setTransform(154.35,-135.525);

	this.shape_889 = new cjs.Shape();
	this.shape_889.graphics.lf(["#AA7F48","#AA855C"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_889.setTransform(108.425,-153.25);

	this.shape_890 = new cjs.Shape();
	this.shape_890.graphics.lf(["#AA7F48","#AA855C"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_890.setTransform(32.725,-214.9);

	this.shape_891 = new cjs.Shape();
	this.shape_891.graphics.lf(["#AA7F48","#AA855C"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_891.setTransform(-122.5,-6.825);

	this.shape_892 = new cjs.Shape();
	this.shape_892.graphics.lf(["#AA7F48","#AA855C"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_892.setTransform(-144.525,-186.225);

	this.shape_893 = new cjs.Shape();
	this.shape_893.graphics.lf(["#AA7F48","#AA855C"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_893.setTransform(-159.025,-28.975);

	this.shape_894 = new cjs.Shape();
	this.shape_894.graphics.lf(["#AA7F48","#AA855C"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_894.setTransform(-200.9,-36.7925);

	this.shape_895 = new cjs.Shape();
	this.shape_895.graphics.lf(["#AA7F48","#AA855C"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_895.setTransform(-243.525,-32.85);

	this.shape_896 = new cjs.Shape();
	this.shape_896.graphics.lf(["#AA7F48","#AA855C"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_896.setTransform(-284.875,-21.325);

	this.shape_897 = new cjs.Shape();
	this.shape_897.graphics.lf(["#AA7F48","#AA855C"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_897.setTransform(-266.575,-120.375);

	this.shape_898 = new cjs.Shape();
	this.shape_898.graphics.lf(["#AA7F48","#AA855C"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_898.setTransform(-313.25,-110.575);

	this.shape_899 = new cjs.Shape();
	this.shape_899.graphics.lf(["#AA7F48","#AA855C"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_899.setTransform(-219.775,-130.875);

	this.shape_900 = new cjs.Shape();
	this.shape_900.graphics.lf(["#AA7F48","#AA855C"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_900.setTransform(-177.075,-151.575);

	this.shape_901 = new cjs.Shape();
	this.shape_901.graphics.lf(["#AA7F48","#AA855C"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_901.setTransform(-37.725,-278.5196);

	this.shape_902 = new cjs.Shape();
	this.shape_902.graphics.lf(["#AA7F48","#AA855C"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_902.setTransform(1.75,-253.225);

	this.shape_903 = new cjs.Shape();
	this.shape_903.graphics.lf(["#AA7F48","#AA855C"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_903.setTransform(-114.5,-223.5);

	this.shape_904 = new cjs.Shape();
	this.shape_904.graphics.lf(["#AA7F48","#AA855C"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_904.setTransform(-80.375,-257.35);

	this.shape_905 = new cjs.Shape();
	this.shape_905.graphics.lf(["#AA7F48","#AA855C"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_905.setTransform(-328.05,-10.925);

	this.shape_906 = new cjs.Shape();
	this.shape_906.graphics.lf(["#AA7F48","#AA855C"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_906.setTransform(-373,-12.325);

	this.shape_907 = new cjs.Shape();
	this.shape_907.graphics.lf(["#AA7F48","#AA855C"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_907.setTransform(-358.325,-95.45);

	this.shape_908 = new cjs.Shape();
	this.shape_908.graphics.lf(["#AA7F48","#AA855C"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_908.setTransform(-411.075,-32.2);

	this.shape_909 = new cjs.Shape();
	this.shape_909.graphics.lf(["#AA7F48","#AA855C"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_909.setTransform(-398.975,-71.425);

	this.shape_910 = new cjs.Shape();
	this.shape_910.graphics.lf(["#95885A","#958D6B"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_910.setTransform(-510.625,132.625);

	this.shape_911 = new cjs.Shape();
	this.shape_911.graphics.lf(["#95885A","#958D6B"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_911.setTransform(-468.325,117.725);

	this.shape_912 = new cjs.Shape();
	this.shape_912.graphics.lf(["#95885A","#958D6B"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_912.setTransform(-425.825,103.1);

	this.shape_913 = new cjs.Shape();
	this.shape_913.graphics.lf(["#95885A","#958D6B"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_913.setTransform(-340.575,74.725);

	this.shape_914 = new cjs.Shape();
	this.shape_914.graphics.lf(["#95885A","#958D6B"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_914.setTransform(-383.3,88.725);

	this.shape_915 = new cjs.Shape();
	this.shape_915.graphics.lf(["#95885A","#958D6B"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_915.setTransform(-296.25,64.05);

	this.shape_916 = new cjs.Shape();
	this.shape_916.graphics.lf(["#95885A","#958D6B"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_916.setTransform(-251.075,56.95);

	this.shape_917 = new cjs.Shape();
	this.shape_917.graphics.lf(["#95885A","#958D6B"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_917.setTransform(-205.675,50.875);

	this.shape_918 = new cjs.Shape();
	this.shape_918.graphics.lf(["#95885A","#958D6B"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_918.setTransform(-160.5,43.575);

	this.shape_919 = new cjs.Shape();
	this.shape_919.graphics.lf(["#95885A","#958D6B"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_919.setTransform(-117.75,28.75);

	this.shape_920 = new cjs.Shape();
	this.shape_920.graphics.lf(["#95885A","#958D6B"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_920.setTransform(273.8,-86.475);

	this.shape_921 = new cjs.Shape();
	this.shape_921.graphics.lf(["#95885A","#958D6B"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_921.setTransform(205.1312,-32.65);

	this.shape_922 = new cjs.Shape();
	this.shape_922.graphics.lf(["#95885A","#958D6B"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_922.setTransform(232.95,-65.4);

	this.shape_923 = new cjs.Shape();
	this.shape_923.graphics.lf(["#95885A","#958D6B"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_923.setTransform(202.225,-123.35);

	this.shape_924 = new cjs.Shape();
	this.shape_924.graphics.lf(["#95885A","#958D6B"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_924.setTransform(298.7901,-104.575);

	this.shape_925 = new cjs.Shape();
	this.shape_925.graphics.lf(["#95885A","#958D6B"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_925.setTransform(250.45,-113.45);

	this.shape_926 = new cjs.Shape();
	this.shape_926.graphics.lf(["#95885A","#958D6B"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_926.setTransform(67.475,-180.175);

	this.shape_927 = new cjs.Shape();
	this.shape_927.graphics.lf(["#95885A","#958D6B"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_927.setTransform(154.35,-135.525);

	this.shape_928 = new cjs.Shape();
	this.shape_928.graphics.lf(["#95885A","#958D6B"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_928.setTransform(108.425,-153.25);

	this.shape_929 = new cjs.Shape();
	this.shape_929.graphics.lf(["#95885A","#958D6B"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_929.setTransform(32.725,-214.9);

	this.shape_930 = new cjs.Shape();
	this.shape_930.graphics.lf(["#95885A","#958D6B"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_930.setTransform(-122.5,-6.825);

	this.shape_931 = new cjs.Shape();
	this.shape_931.graphics.lf(["#95885A","#958D6B"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_931.setTransform(-144.525,-186.225);

	this.shape_932 = new cjs.Shape();
	this.shape_932.graphics.lf(["#95885A","#958D6B"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_932.setTransform(-159.025,-28.975);

	this.shape_933 = new cjs.Shape();
	this.shape_933.graphics.lf(["#95885A","#958D6B"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_933.setTransform(-200.9,-36.7925);

	this.shape_934 = new cjs.Shape();
	this.shape_934.graphics.lf(["#95885A","#958D6B"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_934.setTransform(-243.525,-32.85);

	this.shape_935 = new cjs.Shape();
	this.shape_935.graphics.lf(["#95885A","#958D6B"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_935.setTransform(-284.875,-21.325);

	this.shape_936 = new cjs.Shape();
	this.shape_936.graphics.lf(["#95885A","#958D6B"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_936.setTransform(-266.575,-120.375);

	this.shape_937 = new cjs.Shape();
	this.shape_937.graphics.lf(["#95885A","#958D6B"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_937.setTransform(-313.25,-110.575);

	this.shape_938 = new cjs.Shape();
	this.shape_938.graphics.lf(["#95885A","#958D6B"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_938.setTransform(-219.775,-130.875);

	this.shape_939 = new cjs.Shape();
	this.shape_939.graphics.lf(["#95885A","#958D6B"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_939.setTransform(-177.075,-151.575);

	this.shape_940 = new cjs.Shape();
	this.shape_940.graphics.lf(["#95885A","#958D6B"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_940.setTransform(-37.725,-278.5196);

	this.shape_941 = new cjs.Shape();
	this.shape_941.graphics.lf(["#95885A","#958D6B"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_941.setTransform(1.75,-253.225);

	this.shape_942 = new cjs.Shape();
	this.shape_942.graphics.lf(["#95885A","#958D6B"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_942.setTransform(-114.5,-223.5);

	this.shape_943 = new cjs.Shape();
	this.shape_943.graphics.lf(["#95885A","#958D6B"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_943.setTransform(-80.375,-257.35);

	this.shape_944 = new cjs.Shape();
	this.shape_944.graphics.lf(["#95885A","#958D6B"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_944.setTransform(-328.05,-10.925);

	this.shape_945 = new cjs.Shape();
	this.shape_945.graphics.lf(["#95885A","#958D6B"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_945.setTransform(-373,-12.325);

	this.shape_946 = new cjs.Shape();
	this.shape_946.graphics.lf(["#95885A","#958D6B"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_946.setTransform(-358.325,-95.45);

	this.shape_947 = new cjs.Shape();
	this.shape_947.graphics.lf(["#95885A","#958D6B"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_947.setTransform(-411.075,-32.2);

	this.shape_948 = new cjs.Shape();
	this.shape_948.graphics.lf(["#95885A","#958D6B"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_948.setTransform(-398.975,-71.425);

	this.shape_949 = new cjs.Shape();
	this.shape_949.graphics.lf(["#80906C","#809479"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_949.setTransform(-510.625,132.625);

	this.shape_950 = new cjs.Shape();
	this.shape_950.graphics.lf(["#80906C","#809479"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_950.setTransform(-468.325,117.725);

	this.shape_951 = new cjs.Shape();
	this.shape_951.graphics.lf(["#80906C","#809479"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_951.setTransform(-425.825,103.1);

	this.shape_952 = new cjs.Shape();
	this.shape_952.graphics.lf(["#80906C","#809479"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_952.setTransform(-340.575,74.725);

	this.shape_953 = new cjs.Shape();
	this.shape_953.graphics.lf(["#80906C","#809479"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_953.setTransform(-383.3,88.725);

	this.shape_954 = new cjs.Shape();
	this.shape_954.graphics.lf(["#80906C","#809479"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_954.setTransform(-296.25,64.05);

	this.shape_955 = new cjs.Shape();
	this.shape_955.graphics.lf(["#80906C","#809479"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_955.setTransform(-251.075,56.95);

	this.shape_956 = new cjs.Shape();
	this.shape_956.graphics.lf(["#80906C","#809479"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_956.setTransform(-205.675,50.875);

	this.shape_957 = new cjs.Shape();
	this.shape_957.graphics.lf(["#80906C","#809479"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_957.setTransform(-160.5,43.575);

	this.shape_958 = new cjs.Shape();
	this.shape_958.graphics.lf(["#80906C","#809479"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_958.setTransform(-117.75,28.75);

	this.shape_959 = new cjs.Shape();
	this.shape_959.graphics.lf(["#80906C","#809479"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_959.setTransform(273.8,-86.475);

	this.shape_960 = new cjs.Shape();
	this.shape_960.graphics.lf(["#80906C","#809479"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_960.setTransform(205.1312,-32.65);

	this.shape_961 = new cjs.Shape();
	this.shape_961.graphics.lf(["#80906C","#809479"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_961.setTransform(232.95,-65.4);

	this.shape_962 = new cjs.Shape();
	this.shape_962.graphics.lf(["#80906C","#809479"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_962.setTransform(202.225,-123.35);

	this.shape_963 = new cjs.Shape();
	this.shape_963.graphics.lf(["#80906C","#809479"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_963.setTransform(298.7901,-104.575);

	this.shape_964 = new cjs.Shape();
	this.shape_964.graphics.lf(["#80906C","#809479"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_964.setTransform(250.45,-113.45);

	this.shape_965 = new cjs.Shape();
	this.shape_965.graphics.lf(["#80906C","#809479"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_965.setTransform(67.475,-180.175);

	this.shape_966 = new cjs.Shape();
	this.shape_966.graphics.lf(["#80906C","#809479"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_966.setTransform(154.35,-135.525);

	this.shape_967 = new cjs.Shape();
	this.shape_967.graphics.lf(["#80906C","#809479"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_967.setTransform(108.425,-153.25);

	this.shape_968 = new cjs.Shape();
	this.shape_968.graphics.lf(["#80906C","#809479"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_968.setTransform(32.725,-214.9);

	this.shape_969 = new cjs.Shape();
	this.shape_969.graphics.lf(["#80906C","#809479"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_969.setTransform(-122.5,-6.825);

	this.shape_970 = new cjs.Shape();
	this.shape_970.graphics.lf(["#80906C","#809479"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_970.setTransform(-144.525,-186.225);

	this.shape_971 = new cjs.Shape();
	this.shape_971.graphics.lf(["#80906C","#809479"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_971.setTransform(-159.025,-28.975);

	this.shape_972 = new cjs.Shape();
	this.shape_972.graphics.lf(["#80906C","#809479"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_972.setTransform(-200.9,-36.7925);

	this.shape_973 = new cjs.Shape();
	this.shape_973.graphics.lf(["#80906C","#809479"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_973.setTransform(-243.525,-32.85);

	this.shape_974 = new cjs.Shape();
	this.shape_974.graphics.lf(["#80906C","#809479"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_974.setTransform(-284.875,-21.325);

	this.shape_975 = new cjs.Shape();
	this.shape_975.graphics.lf(["#80906C","#809479"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_975.setTransform(-266.575,-120.375);

	this.shape_976 = new cjs.Shape();
	this.shape_976.graphics.lf(["#80906C","#809479"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_976.setTransform(-313.25,-110.575);

	this.shape_977 = new cjs.Shape();
	this.shape_977.graphics.lf(["#80906C","#809479"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_977.setTransform(-219.775,-130.875);

	this.shape_978 = new cjs.Shape();
	this.shape_978.graphics.lf(["#80906C","#809479"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_978.setTransform(-177.075,-151.575);

	this.shape_979 = new cjs.Shape();
	this.shape_979.graphics.lf(["#80906C","#809479"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_979.setTransform(-37.725,-278.5196);

	this.shape_980 = new cjs.Shape();
	this.shape_980.graphics.lf(["#80906C","#809479"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_980.setTransform(1.75,-253.225);

	this.shape_981 = new cjs.Shape();
	this.shape_981.graphics.lf(["#80906C","#809479"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_981.setTransform(-114.5,-223.5);

	this.shape_982 = new cjs.Shape();
	this.shape_982.graphics.lf(["#80906C","#809479"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_982.setTransform(-80.375,-257.35);

	this.shape_983 = new cjs.Shape();
	this.shape_983.graphics.lf(["#80906C","#809479"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_983.setTransform(-328.05,-10.925);

	this.shape_984 = new cjs.Shape();
	this.shape_984.graphics.lf(["#80906C","#809479"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_984.setTransform(-373,-12.325);

	this.shape_985 = new cjs.Shape();
	this.shape_985.graphics.lf(["#80906C","#809479"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_985.setTransform(-358.325,-95.45);

	this.shape_986 = new cjs.Shape();
	this.shape_986.graphics.lf(["#80906C","#809479"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_986.setTransform(-411.075,-32.2);

	this.shape_987 = new cjs.Shape();
	this.shape_987.graphics.lf(["#80906C","#809479"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_987.setTransform(-398.975,-71.425);

	this.shape_988 = new cjs.Shape();
	this.shape_988.graphics.lf(["#6B987E","#6B9B88"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_988.setTransform(-510.625,132.625);

	this.shape_989 = new cjs.Shape();
	this.shape_989.graphics.lf(["#6B987E","#6B9B88"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_989.setTransform(-468.325,117.725);

	this.shape_990 = new cjs.Shape();
	this.shape_990.graphics.lf(["#6B987E","#6B9B88"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_990.setTransform(-425.825,103.1);

	this.shape_991 = new cjs.Shape();
	this.shape_991.graphics.lf(["#6B987E","#6B9B88"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_991.setTransform(-340.575,74.725);

	this.shape_992 = new cjs.Shape();
	this.shape_992.graphics.lf(["#6B987E","#6B9B88"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_992.setTransform(-383.3,88.725);

	this.shape_993 = new cjs.Shape();
	this.shape_993.graphics.lf(["#6B987E","#6B9B88"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_993.setTransform(-296.25,64.05);

	this.shape_994 = new cjs.Shape();
	this.shape_994.graphics.lf(["#6B987E","#6B9B88"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_994.setTransform(-251.075,56.95);

	this.shape_995 = new cjs.Shape();
	this.shape_995.graphics.lf(["#6B987E","#6B9B88"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_995.setTransform(-205.675,50.875);

	this.shape_996 = new cjs.Shape();
	this.shape_996.graphics.lf(["#6B987E","#6B9B88"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_996.setTransform(-160.5,43.575);

	this.shape_997 = new cjs.Shape();
	this.shape_997.graphics.lf(["#6B987E","#6B9B88"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_997.setTransform(-117.75,28.75);

	this.shape_998 = new cjs.Shape();
	this.shape_998.graphics.lf(["#6B987E","#6B9B88"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_998.setTransform(273.8,-86.475);

	this.shape_999 = new cjs.Shape();
	this.shape_999.graphics.lf(["#6B987E","#6B9B88"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_999.setTransform(205.1312,-32.65);

	this.shape_1000 = new cjs.Shape();
	this.shape_1000.graphics.lf(["#6B987E","#6B9B88"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_1000.setTransform(232.95,-65.4);

	this.shape_1001 = new cjs.Shape();
	this.shape_1001.graphics.lf(["#6B987E","#6B9B88"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_1001.setTransform(202.225,-123.35);

	this.shape_1002 = new cjs.Shape();
	this.shape_1002.graphics.lf(["#6B987E","#6B9B88"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_1002.setTransform(298.7901,-104.575);

	this.shape_1003 = new cjs.Shape();
	this.shape_1003.graphics.lf(["#6B987E","#6B9B88"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_1003.setTransform(250.45,-113.45);

	this.shape_1004 = new cjs.Shape();
	this.shape_1004.graphics.lf(["#6B987E","#6B9B88"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_1004.setTransform(67.475,-180.175);

	this.shape_1005 = new cjs.Shape();
	this.shape_1005.graphics.lf(["#6B987E","#6B9B88"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_1005.setTransform(154.35,-135.525);

	this.shape_1006 = new cjs.Shape();
	this.shape_1006.graphics.lf(["#6B987E","#6B9B88"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_1006.setTransform(108.425,-153.25);

	this.shape_1007 = new cjs.Shape();
	this.shape_1007.graphics.lf(["#6B987E","#6B9B88"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_1007.setTransform(32.725,-214.9);

	this.shape_1008 = new cjs.Shape();
	this.shape_1008.graphics.lf(["#6B987E","#6B9B88"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_1008.setTransform(-122.5,-6.825);

	this.shape_1009 = new cjs.Shape();
	this.shape_1009.graphics.lf(["#6B987E","#6B9B88"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_1009.setTransform(-144.525,-186.225);

	this.shape_1010 = new cjs.Shape();
	this.shape_1010.graphics.lf(["#6B987E","#6B9B88"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_1010.setTransform(-159.025,-28.975);

	this.shape_1011 = new cjs.Shape();
	this.shape_1011.graphics.lf(["#6B987E","#6B9B88"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_1011.setTransform(-200.9,-36.7925);

	this.shape_1012 = new cjs.Shape();
	this.shape_1012.graphics.lf(["#6B987E","#6B9B88"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_1012.setTransform(-243.525,-32.85);

	this.shape_1013 = new cjs.Shape();
	this.shape_1013.graphics.lf(["#6B987E","#6B9B88"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_1013.setTransform(-284.875,-21.325);

	this.shape_1014 = new cjs.Shape();
	this.shape_1014.graphics.lf(["#6B987E","#6B9B88"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_1014.setTransform(-266.575,-120.375);

	this.shape_1015 = new cjs.Shape();
	this.shape_1015.graphics.lf(["#6B987E","#6B9B88"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_1015.setTransform(-313.25,-110.575);

	this.shape_1016 = new cjs.Shape();
	this.shape_1016.graphics.lf(["#6B987E","#6B9B88"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_1016.setTransform(-219.775,-130.875);

	this.shape_1017 = new cjs.Shape();
	this.shape_1017.graphics.lf(["#6B987E","#6B9B88"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_1017.setTransform(-177.075,-151.575);

	this.shape_1018 = new cjs.Shape();
	this.shape_1018.graphics.lf(["#6B987E","#6B9B88"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_1018.setTransform(-37.725,-278.5196);

	this.shape_1019 = new cjs.Shape();
	this.shape_1019.graphics.lf(["#6B987E","#6B9B88"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_1019.setTransform(1.75,-253.225);

	this.shape_1020 = new cjs.Shape();
	this.shape_1020.graphics.lf(["#6B987E","#6B9B88"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_1020.setTransform(-114.5,-223.5);

	this.shape_1021 = new cjs.Shape();
	this.shape_1021.graphics.lf(["#6B987E","#6B9B88"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_1021.setTransform(-80.375,-257.35);

	this.shape_1022 = new cjs.Shape();
	this.shape_1022.graphics.lf(["#6B987E","#6B9B88"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_1022.setTransform(-328.05,-10.925);

	this.shape_1023 = new cjs.Shape();
	this.shape_1023.graphics.lf(["#6B987E","#6B9B88"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_1023.setTransform(-373,-12.325);

	this.shape_1024 = new cjs.Shape();
	this.shape_1024.graphics.lf(["#6B987E","#6B9B88"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_1024.setTransform(-358.325,-95.45);

	this.shape_1025 = new cjs.Shape();
	this.shape_1025.graphics.lf(["#6B987E","#6B9B88"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_1025.setTransform(-411.075,-32.2);

	this.shape_1026 = new cjs.Shape();
	this.shape_1026.graphics.lf(["#6B987E","#6B9B88"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_1026.setTransform(-398.975,-71.425);

	this.shape_1027 = new cjs.Shape();
	this.shape_1027.graphics.lf(["#55A090","#55A297"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_1027.setTransform(-510.625,132.625);

	this.shape_1028 = new cjs.Shape();
	this.shape_1028.graphics.lf(["#55A090","#55A297"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_1028.setTransform(-468.325,117.725);

	this.shape_1029 = new cjs.Shape();
	this.shape_1029.graphics.lf(["#55A090","#55A297"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_1029.setTransform(-425.825,103.1);

	this.shape_1030 = new cjs.Shape();
	this.shape_1030.graphics.lf(["#55A090","#55A297"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_1030.setTransform(-340.575,74.725);

	this.shape_1031 = new cjs.Shape();
	this.shape_1031.graphics.lf(["#55A090","#55A297"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_1031.setTransform(-383.3,88.725);

	this.shape_1032 = new cjs.Shape();
	this.shape_1032.graphics.lf(["#55A090","#55A297"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_1032.setTransform(-296.25,64.05);

	this.shape_1033 = new cjs.Shape();
	this.shape_1033.graphics.lf(["#55A090","#55A297"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_1033.setTransform(-251.075,56.95);

	this.shape_1034 = new cjs.Shape();
	this.shape_1034.graphics.lf(["#55A090","#55A297"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_1034.setTransform(-205.675,50.875);

	this.shape_1035 = new cjs.Shape();
	this.shape_1035.graphics.lf(["#55A090","#55A297"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_1035.setTransform(-160.5,43.575);

	this.shape_1036 = new cjs.Shape();
	this.shape_1036.graphics.lf(["#55A090","#55A297"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_1036.setTransform(-117.75,28.75);

	this.shape_1037 = new cjs.Shape();
	this.shape_1037.graphics.lf(["#55A090","#55A297"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_1037.setTransform(273.8,-86.475);

	this.shape_1038 = new cjs.Shape();
	this.shape_1038.graphics.lf(["#55A090","#55A297"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_1038.setTransform(205.1312,-32.65);

	this.shape_1039 = new cjs.Shape();
	this.shape_1039.graphics.lf(["#55A090","#55A297"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_1039.setTransform(232.95,-65.4);

	this.shape_1040 = new cjs.Shape();
	this.shape_1040.graphics.lf(["#55A090","#55A297"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_1040.setTransform(202.225,-123.35);

	this.shape_1041 = new cjs.Shape();
	this.shape_1041.graphics.lf(["#55A090","#55A297"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_1041.setTransform(298.7901,-104.575);

	this.shape_1042 = new cjs.Shape();
	this.shape_1042.graphics.lf(["#55A090","#55A297"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_1042.setTransform(250.45,-113.45);

	this.shape_1043 = new cjs.Shape();
	this.shape_1043.graphics.lf(["#55A090","#55A297"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_1043.setTransform(67.475,-180.175);

	this.shape_1044 = new cjs.Shape();
	this.shape_1044.graphics.lf(["#55A090","#55A297"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_1044.setTransform(154.35,-135.525);

	this.shape_1045 = new cjs.Shape();
	this.shape_1045.graphics.lf(["#55A090","#55A297"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_1045.setTransform(108.425,-153.25);

	this.shape_1046 = new cjs.Shape();
	this.shape_1046.graphics.lf(["#55A090","#55A297"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_1046.setTransform(32.725,-214.9);

	this.shape_1047 = new cjs.Shape();
	this.shape_1047.graphics.lf(["#55A090","#55A297"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_1047.setTransform(-122.5,-6.825);

	this.shape_1048 = new cjs.Shape();
	this.shape_1048.graphics.lf(["#55A090","#55A297"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_1048.setTransform(-144.525,-186.225);

	this.shape_1049 = new cjs.Shape();
	this.shape_1049.graphics.lf(["#55A090","#55A297"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_1049.setTransform(-159.025,-28.975);

	this.shape_1050 = new cjs.Shape();
	this.shape_1050.graphics.lf(["#55A090","#55A297"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_1050.setTransform(-200.9,-36.7925);

	this.shape_1051 = new cjs.Shape();
	this.shape_1051.graphics.lf(["#55A090","#55A297"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_1051.setTransform(-243.525,-32.85);

	this.shape_1052 = new cjs.Shape();
	this.shape_1052.graphics.lf(["#55A090","#55A297"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_1052.setTransform(-284.875,-21.325);

	this.shape_1053 = new cjs.Shape();
	this.shape_1053.graphics.lf(["#55A090","#55A297"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_1053.setTransform(-266.575,-120.375);

	this.shape_1054 = new cjs.Shape();
	this.shape_1054.graphics.lf(["#55A090","#55A297"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_1054.setTransform(-313.25,-110.575);

	this.shape_1055 = new cjs.Shape();
	this.shape_1055.graphics.lf(["#55A090","#55A297"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_1055.setTransform(-219.775,-130.875);

	this.shape_1056 = new cjs.Shape();
	this.shape_1056.graphics.lf(["#55A090","#55A297"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_1056.setTransform(-177.075,-151.575);

	this.shape_1057 = new cjs.Shape();
	this.shape_1057.graphics.lf(["#55A090","#55A297"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_1057.setTransform(-37.725,-278.5196);

	this.shape_1058 = new cjs.Shape();
	this.shape_1058.graphics.lf(["#55A090","#55A297"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_1058.setTransform(1.75,-253.225);

	this.shape_1059 = new cjs.Shape();
	this.shape_1059.graphics.lf(["#55A090","#55A297"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_1059.setTransform(-114.5,-223.5);

	this.shape_1060 = new cjs.Shape();
	this.shape_1060.graphics.lf(["#55A090","#55A297"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_1060.setTransform(-80.375,-257.35);

	this.shape_1061 = new cjs.Shape();
	this.shape_1061.graphics.lf(["#55A090","#55A297"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_1061.setTransform(-328.05,-10.925);

	this.shape_1062 = new cjs.Shape();
	this.shape_1062.graphics.lf(["#55A090","#55A297"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_1062.setTransform(-373,-12.325);

	this.shape_1063 = new cjs.Shape();
	this.shape_1063.graphics.lf(["#55A090","#55A297"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_1063.setTransform(-358.325,-95.45);

	this.shape_1064 = new cjs.Shape();
	this.shape_1064.graphics.lf(["#55A090","#55A297"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_1064.setTransform(-411.075,-32.2);

	this.shape_1065 = new cjs.Shape();
	this.shape_1065.graphics.lf(["#55A090","#55A297"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_1065.setTransform(-398.975,-71.425);

	this.shape_1066 = new cjs.Shape();
	this.shape_1066.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_1066.setTransform(-510.625,132.625);

	this.shape_1067 = new cjs.Shape();
	this.shape_1067.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_1067.setTransform(-468.325,117.725);

	this.shape_1068 = new cjs.Shape();
	this.shape_1068.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_1068.setTransform(-425.825,103.1);

	this.shape_1069 = new cjs.Shape();
	this.shape_1069.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_1069.setTransform(-340.575,74.725);

	this.shape_1070 = new cjs.Shape();
	this.shape_1070.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_1070.setTransform(-383.3,88.725);

	this.shape_1071 = new cjs.Shape();
	this.shape_1071.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_1071.setTransform(-296.25,64.05);

	this.shape_1072 = new cjs.Shape();
	this.shape_1072.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_1072.setTransform(-251.075,56.95);

	this.shape_1073 = new cjs.Shape();
	this.shape_1073.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_1073.setTransform(-205.675,50.875);

	this.shape_1074 = new cjs.Shape();
	this.shape_1074.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_1074.setTransform(-160.5,43.575);

	this.shape_1075 = new cjs.Shape();
	this.shape_1075.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_1075.setTransform(-117.75,28.75);

	this.shape_1076 = new cjs.Shape();
	this.shape_1076.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_1076.setTransform(273.8,-86.475);

	this.shape_1077 = new cjs.Shape();
	this.shape_1077.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_1077.setTransform(205.1312,-32.65);

	this.shape_1078 = new cjs.Shape();
	this.shape_1078.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_1078.setTransform(232.95,-65.4);

	this.shape_1079 = new cjs.Shape();
	this.shape_1079.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_1079.setTransform(202.225,-123.35);

	this.shape_1080 = new cjs.Shape();
	this.shape_1080.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_1080.setTransform(298.7901,-104.575);

	this.shape_1081 = new cjs.Shape();
	this.shape_1081.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_1081.setTransform(250.45,-113.45);

	this.shape_1082 = new cjs.Shape();
	this.shape_1082.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_1082.setTransform(67.475,-180.175);

	this.shape_1083 = new cjs.Shape();
	this.shape_1083.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_1083.setTransform(154.35,-135.525);

	this.shape_1084 = new cjs.Shape();
	this.shape_1084.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_1084.setTransform(108.425,-153.25);

	this.shape_1085 = new cjs.Shape();
	this.shape_1085.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_1085.setTransform(32.725,-214.9);

	this.shape_1086 = new cjs.Shape();
	this.shape_1086.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_1086.setTransform(-122.5,-6.825);

	this.shape_1087 = new cjs.Shape();
	this.shape_1087.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_1087.setTransform(-144.525,-186.225);

	this.shape_1088 = new cjs.Shape();
	this.shape_1088.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_1088.setTransform(-159.025,-28.975);

	this.shape_1089 = new cjs.Shape();
	this.shape_1089.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_1089.setTransform(-200.9,-36.7925);

	this.shape_1090 = new cjs.Shape();
	this.shape_1090.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_1090.setTransform(-243.525,-32.85);

	this.shape_1091 = new cjs.Shape();
	this.shape_1091.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_1091.setTransform(-284.875,-21.325);

	this.shape_1092 = new cjs.Shape();
	this.shape_1092.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_1092.setTransform(-266.575,-120.375);

	this.shape_1093 = new cjs.Shape();
	this.shape_1093.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_1093.setTransform(-313.25,-110.575);

	this.shape_1094 = new cjs.Shape();
	this.shape_1094.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_1094.setTransform(-219.775,-130.875);

	this.shape_1095 = new cjs.Shape();
	this.shape_1095.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_1095.setTransform(-177.075,-151.575);

	this.shape_1096 = new cjs.Shape();
	this.shape_1096.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_1096.setTransform(-37.725,-278.5196);

	this.shape_1097 = new cjs.Shape();
	this.shape_1097.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_1097.setTransform(1.75,-253.225);

	this.shape_1098 = new cjs.Shape();
	this.shape_1098.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_1098.setTransform(-114.5,-223.5);

	this.shape_1099 = new cjs.Shape();
	this.shape_1099.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_1099.setTransform(-80.375,-257.35);

	this.shape_1100 = new cjs.Shape();
	this.shape_1100.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_1100.setTransform(-328.05,-10.925);

	this.shape_1101 = new cjs.Shape();
	this.shape_1101.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_1101.setTransform(-373,-12.325);

	this.shape_1102 = new cjs.Shape();
	this.shape_1102.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_1102.setTransform(-358.325,-95.45);

	this.shape_1103 = new cjs.Shape();
	this.shape_1103.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_1103.setTransform(-411.075,-32.2);

	this.shape_1104 = new cjs.Shape();
	this.shape_1104.graphics.lf(["#40A9A2","#40AAA5"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_1104.setTransform(-398.975,-71.425);

	this.shape_1105 = new cjs.Shape();
	this.shape_1105.graphics.f("#2BB1B4").s().p("EhAnAg1QgngnAAg3QAAg3AngnQAngnA4AAQA3AAAnAnQAnAnAAA3QAAA3gnAnQgnAng3AAQg4AAgngngEg6UAdPIDVhKIAQAwIjUBKgEgzrAa8IDVhIIAQAvIjVBJgEgtCAYsIDWhHIAPAvIjVBHgEgmXAWeIBrgjQA4gSA2gPIANAxQguAMg+AUIhqAjgA/eUmQBngWB7gUIAIAxQiDAWhdAUgA4aTZIDjgfIAHAyIjiAfgAxUScIDigfIAIAyIjjAfgAqRRaQB/gWBhgWIALAwQhaAWiIAXgAjaPtQCGg2AihCIAtAXQgrBSiYA9gAixJyQgngjgqgfIAdgoQAoAdAtAnQAxArAjArIgnAfQgfglgvgqgEgkZAIwQBtgGBugVIAKAxQhzAWhwAGgEgrbAIuIAPgwQBkAhBzAMIgGAyQh3gNhpgigA9nHfQAsgNA+gXIBmgiIAQAvQgwAPg1AUQg7AVgxAOgEAwuADqIAqAbQhABkAtBbIgtAWQg6h0BQh8gEgwHAGAQgwg2gDhGIAygCQADA1AjAnQAdAhA1AjIgcApQg4glgjgmgAp5F7IANgxQBsAeBgAvIgVAtQhdgthngcgA3HFdQBqgaBqgQIAHAxQhgAPhvAbgAwaFQIgCgyQBygFBnALIgEAxQhmgKhtAFgEAzVABEQBQg8Bzg+IAYAsQhvA9hOA5gEgvWAAeQBHhSBxhMIAcApQhsBKhCBLgEA5kgCeIBogvIBygxIATAuIhwAxIhoAvgEgpNgD4QBngyB2gsIASAuQh0AshlAxgEBAdgFcQgBAFADAGIADAEIgBgBIgPgFQgigJiWgVIAHgxIBzARQAzAIAXAGQAOADALAFQAOAHAGALQAJASgLAQQgFAKgNAHgEgiMgGiQBqgfB9gdIAMAwQh7AdhqAfgEA10gHCIAJgxQBrAVCHAWIgIAyQh1gUh+gYgA66oPIB2gUIB1gUIAJAxQhDANg0AIIh0AUgEAuRgIrIAMgxQBmAZCKAeIgLAxQh2gah7gdgAzmppQB8gfBmgmIASAvQhmAmiBAhgEAoqgKIQg6gQg+gUIAQgvQA2ARA/ASIB3AgIgMAwgAsvsRQBlg8BVhRIAiAlQhYBUhrA/gAfst1IAZgsQBuA/BrAwIgUAtQhvgwhvhAgAZdydIAhglQBeBWBeBFIgeApQhlhMhahTgAnYxNQAug6BjiEIAoAeQh4CegaAhgAUN4KIAngfQBdByBCBIIglAiQhLhThWhqgAix3HQBQhgBQhUIAjAiQhPBVhOBdgAPY+HIAkgiQBABDBgB7IgnAfQheh4g/hDgACZ8lQA7g4AegaQA0guAtgiIAeAoQg0AogqAmQgqAlguArgEAI/ggVIgQgvQCIgvB5AxIgTAuQhngqh3Apg");
	this.shape_1105.setTransform(-106.4599,-68.0696);

	this.shape_1106 = new cjs.Shape();
	this.shape_1106.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_1106.setTransform(231.025,-0.325);

	this.shape_1107 = new cjs.Shape();
	this.shape_1107.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.9,0,11.9,0).s().p("AgFAcIgCAAIAAAAIgBAAIgBgBQg2gQg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_1107.setTransform(273.675,16.25);

	this.shape_1108 = new cjs.Shape();
	this.shape_1108.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_1108.setTransform(320.475,28.6);

	this.shape_1109 = new cjs.Shape();
	this.shape_1109.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_1109.setTransform(367,42.55);

	this.shape_1110 = new cjs.Shape();
	this.shape_1110.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_1110.setTransform(412.875,58.825);

	this.shape_1111 = new cjs.Shape();
	this.shape_1111.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_1111.setTransform(457.5,78.175);

	this.shape_1112 = new cjs.Shape();
	this.shape_1112.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_1112.setTransform(499.575,102.375);

	this.shape_1113 = new cjs.Shape();
	this.shape_1113.graphics.lf(["#FF5E00","#FF6821"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_1113.setTransform(534.05,135.7);

	this.shape_1114 = new cjs.Shape();
	this.shape_1114.graphics.lf(["#FF5E00","#FF6821"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_1114.setTransform(539.325,181.675);

	this.shape_1115 = new cjs.Shape();
	this.shape_1115.graphics.lf(["#F2630B","#F26D2A"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_1115.setTransform(-510.625,132.625);

	this.shape_1116 = new cjs.Shape();
	this.shape_1116.graphics.lf(["#F2630B","#F26D2A"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_1116.setTransform(-468.325,117.725);

	this.shape_1117 = new cjs.Shape();
	this.shape_1117.graphics.lf(["#F2630B","#F26D2A"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_1117.setTransform(-425.825,103.1);

	this.shape_1118 = new cjs.Shape();
	this.shape_1118.graphics.lf(["#F2630B","#F26D2A"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_1118.setTransform(-340.575,74.725);

	this.shape_1119 = new cjs.Shape();
	this.shape_1119.graphics.lf(["#F2630B","#F26D2A"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_1119.setTransform(-383.3,88.725);

	this.shape_1120 = new cjs.Shape();
	this.shape_1120.graphics.lf(["#F2630B","#F26D2A"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_1120.setTransform(-296.25,64.05);

	this.shape_1121 = new cjs.Shape();
	this.shape_1121.graphics.lf(["#F2630B","#F26D2A"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_1121.setTransform(-251.075,56.95);

	this.shape_1122 = new cjs.Shape();
	this.shape_1122.graphics.lf(["#F2630B","#F26D2A"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_1122.setTransform(-205.675,50.875);

	this.shape_1123 = new cjs.Shape();
	this.shape_1123.graphics.lf(["#F2630B","#F26D2A"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_1123.setTransform(-160.5,43.575);

	this.shape_1124 = new cjs.Shape();
	this.shape_1124.graphics.lf(["#F2630B","#F26D2A"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_1124.setTransform(-117.75,28.75);

	this.shape_1125 = new cjs.Shape();
	this.shape_1125.graphics.lf(["#F2630B","#F26D2A"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_1125.setTransform(273.675,16.25);

	this.shape_1126 = new cjs.Shape();
	this.shape_1126.graphics.lf(["#F2630B","#F26D2A"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_1126.setTransform(320.475,28.6);

	this.shape_1127 = new cjs.Shape();
	this.shape_1127.graphics.lf(["#F2630B","#F26D2A"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_1127.setTransform(367,42.55);

	this.shape_1128 = new cjs.Shape();
	this.shape_1128.graphics.lf(["#F2630B","#F26D2A"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_1128.setTransform(457.5,78.175);

	this.shape_1129 = new cjs.Shape();
	this.shape_1129.graphics.lf(["#F2630B","#F26D2A"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_1129.setTransform(412.875,58.825);

	this.shape_1130 = new cjs.Shape();
	this.shape_1130.graphics.lf(["#F2630B","#F26D2A"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_1130.setTransform(539.325,181.675);

	this.shape_1131 = new cjs.Shape();
	this.shape_1131.graphics.lf(["#F2630B","#F26D2A"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_1131.setTransform(534.05,135.7);

	this.shape_1132 = new cjs.Shape();
	this.shape_1132.graphics.lf(["#F2630B","#F26D2A"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_1132.setTransform(499.575,102.375);

	this.shape_1133 = new cjs.Shape();
	this.shape_1133.graphics.lf(["#F2630B","#F26D2A"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_1133.setTransform(273.8,-86.475);

	this.shape_1134 = new cjs.Shape();
	this.shape_1134.graphics.lf(["#F2630B","#F26D2A"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_1134.setTransform(205.1312,-32.65);

	this.shape_1135 = new cjs.Shape();
	this.shape_1135.graphics.lf(["#F2630B","#F26D2A"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_1135.setTransform(231.025,-0.325);

	this.shape_1136 = new cjs.Shape();
	this.shape_1136.graphics.lf(["#F2630B","#F26D2A"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_1136.setTransform(232.95,-65.4);

	this.shape_1137 = new cjs.Shape();
	this.shape_1137.graphics.lf(["#F2630B","#F26D2A"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_1137.setTransform(202.225,-123.35);

	this.shape_1138 = new cjs.Shape();
	this.shape_1138.graphics.lf(["#F2630B","#F26D2A"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_1138.setTransform(298.7901,-104.575);

	this.shape_1139 = new cjs.Shape();
	this.shape_1139.graphics.lf(["#F2630B","#F26D2A"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_1139.setTransform(250.45,-113.45);

	this.shape_1140 = new cjs.Shape();
	this.shape_1140.graphics.lf(["#F2630B","#F26D2A"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_1140.setTransform(67.475,-180.175);

	this.shape_1141 = new cjs.Shape();
	this.shape_1141.graphics.lf(["#F2630B","#F26D2A"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_1141.setTransform(154.35,-135.525);

	this.shape_1142 = new cjs.Shape();
	this.shape_1142.graphics.lf(["#F2630B","#F26D2A"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_1142.setTransform(108.425,-153.25);

	this.shape_1143 = new cjs.Shape();
	this.shape_1143.graphics.lf(["#F2630B","#F26D2A"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_1143.setTransform(32.725,-214.9);

	this.shape_1144 = new cjs.Shape();
	this.shape_1144.graphics.lf(["#F2630B","#F26D2A"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_1144.setTransform(-122.5,-6.825);

	this.shape_1145 = new cjs.Shape();
	this.shape_1145.graphics.lf(["#F2630B","#F26D2A"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_1145.setTransform(-144.525,-186.225);

	this.shape_1146 = new cjs.Shape();
	this.shape_1146.graphics.lf(["#F2630B","#F26D2A"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_1146.setTransform(-159.025,-28.975);

	this.shape_1147 = new cjs.Shape();
	this.shape_1147.graphics.lf(["#F2630B","#F26D2A"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_1147.setTransform(-200.9,-36.7925);

	this.shape_1148 = new cjs.Shape();
	this.shape_1148.graphics.lf(["#F2630B","#F26D2A"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_1148.setTransform(-243.525,-32.85);

	this.shape_1149 = new cjs.Shape();
	this.shape_1149.graphics.lf(["#F2630B","#F26D2A"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_1149.setTransform(-284.875,-21.325);

	this.shape_1150 = new cjs.Shape();
	this.shape_1150.graphics.lf(["#F2630B","#F26D2A"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_1150.setTransform(-266.575,-120.375);

	this.shape_1151 = new cjs.Shape();
	this.shape_1151.graphics.lf(["#F2630B","#F26D2A"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_1151.setTransform(-313.25,-110.575);

	this.shape_1152 = new cjs.Shape();
	this.shape_1152.graphics.lf(["#F2630B","#F26D2A"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_1152.setTransform(-219.775,-130.875);

	this.shape_1153 = new cjs.Shape();
	this.shape_1153.graphics.lf(["#F2630B","#F26D2A"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_1153.setTransform(-177.075,-151.575);

	this.shape_1154 = new cjs.Shape();
	this.shape_1154.graphics.lf(["#F2630B","#F26D2A"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_1154.setTransform(-37.725,-278.5196);

	this.shape_1155 = new cjs.Shape();
	this.shape_1155.graphics.lf(["#F2630B","#F26D2A"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_1155.setTransform(1.75,-253.225);

	this.shape_1156 = new cjs.Shape();
	this.shape_1156.graphics.lf(["#F2630B","#F26D2A"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_1156.setTransform(-114.5,-223.5);

	this.shape_1157 = new cjs.Shape();
	this.shape_1157.graphics.lf(["#F2630B","#F26D2A"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_1157.setTransform(-80.375,-257.35);

	this.shape_1158 = new cjs.Shape();
	this.shape_1158.graphics.lf(["#F2630B","#F26D2A"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_1158.setTransform(-328.05,-10.925);

	this.shape_1159 = new cjs.Shape();
	this.shape_1159.graphics.lf(["#F2630B","#F26D2A"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_1159.setTransform(-373,-12.325);

	this.shape_1160 = new cjs.Shape();
	this.shape_1160.graphics.lf(["#F2630B","#F26D2A"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_1160.setTransform(-358.325,-95.45);

	this.shape_1161 = new cjs.Shape();
	this.shape_1161.graphics.lf(["#F2630B","#F26D2A"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_1161.setTransform(-411.075,-32.2);

	this.shape_1162 = new cjs.Shape();
	this.shape_1162.graphics.lf(["#F2630B","#F26D2A"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_1162.setTransform(-398.975,-71.425);

	this.shape_1163 = new cjs.Shape();
	this.shape_1163.graphics.lf(["#E56817","#E57133"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_1163.setTransform(-510.625,132.625);

	this.shape_1164 = new cjs.Shape();
	this.shape_1164.graphics.lf(["#E56817","#E57133"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_1164.setTransform(-468.325,117.725);

	this.shape_1165 = new cjs.Shape();
	this.shape_1165.graphics.lf(["#E56817","#E57133"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_1165.setTransform(-425.825,103.1);

	this.shape_1166 = new cjs.Shape();
	this.shape_1166.graphics.lf(["#E56817","#E57133"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_1166.setTransform(-340.575,74.725);

	this.shape_1167 = new cjs.Shape();
	this.shape_1167.graphics.lf(["#E56817","#E57133"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_1167.setTransform(-383.3,88.725);

	this.shape_1168 = new cjs.Shape();
	this.shape_1168.graphics.lf(["#E56817","#E57133"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_1168.setTransform(-296.25,64.05);

	this.shape_1169 = new cjs.Shape();
	this.shape_1169.graphics.lf(["#E56817","#E57133"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_1169.setTransform(-251.075,56.95);

	this.shape_1170 = new cjs.Shape();
	this.shape_1170.graphics.lf(["#E56817","#E57133"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_1170.setTransform(-205.675,50.875);

	this.shape_1171 = new cjs.Shape();
	this.shape_1171.graphics.lf(["#E56817","#E57133"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_1171.setTransform(-160.5,43.575);

	this.shape_1172 = new cjs.Shape();
	this.shape_1172.graphics.lf(["#E56817","#E57133"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_1172.setTransform(-117.75,28.75);

	this.shape_1173 = new cjs.Shape();
	this.shape_1173.graphics.lf(["#E56817","#E57133"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_1173.setTransform(273.675,16.25);

	this.shape_1174 = new cjs.Shape();
	this.shape_1174.graphics.lf(["#E56817","#E57133"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_1174.setTransform(320.475,28.6);

	this.shape_1175 = new cjs.Shape();
	this.shape_1175.graphics.lf(["#E56817","#E57133"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_1175.setTransform(367,42.55);

	this.shape_1176 = new cjs.Shape();
	this.shape_1176.graphics.lf(["#E56817","#E57133"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_1176.setTransform(457.5,78.175);

	this.shape_1177 = new cjs.Shape();
	this.shape_1177.graphics.lf(["#E56817","#E57133"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_1177.setTransform(412.875,58.825);

	this.shape_1178 = new cjs.Shape();
	this.shape_1178.graphics.lf(["#E56817","#E57133"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_1178.setTransform(539.325,181.675);

	this.shape_1179 = new cjs.Shape();
	this.shape_1179.graphics.lf(["#E56817","#E57133"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_1179.setTransform(534.05,135.7);

	this.shape_1180 = new cjs.Shape();
	this.shape_1180.graphics.lf(["#E56817","#E57133"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_1180.setTransform(499.575,102.375);

	this.shape_1181 = new cjs.Shape();
	this.shape_1181.graphics.lf(["#E56817","#E57133"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_1181.setTransform(273.8,-86.475);

	this.shape_1182 = new cjs.Shape();
	this.shape_1182.graphics.lf(["#E56817","#E57133"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_1182.setTransform(205.1312,-32.65);

	this.shape_1183 = new cjs.Shape();
	this.shape_1183.graphics.lf(["#E56817","#E57133"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_1183.setTransform(231.025,-0.325);

	this.shape_1184 = new cjs.Shape();
	this.shape_1184.graphics.lf(["#E56817","#E57133"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_1184.setTransform(232.95,-65.4);

	this.shape_1185 = new cjs.Shape();
	this.shape_1185.graphics.lf(["#E56817","#E57133"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_1185.setTransform(202.225,-123.35);

	this.shape_1186 = new cjs.Shape();
	this.shape_1186.graphics.lf(["#E56817","#E57133"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_1186.setTransform(298.7901,-104.575);

	this.shape_1187 = new cjs.Shape();
	this.shape_1187.graphics.lf(["#E56817","#E57133"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_1187.setTransform(250.45,-113.45);

	this.shape_1188 = new cjs.Shape();
	this.shape_1188.graphics.lf(["#E56817","#E57133"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_1188.setTransform(67.475,-180.175);

	this.shape_1189 = new cjs.Shape();
	this.shape_1189.graphics.lf(["#E56817","#E57133"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_1189.setTransform(154.35,-135.525);

	this.shape_1190 = new cjs.Shape();
	this.shape_1190.graphics.lf(["#E56817","#E57133"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_1190.setTransform(108.425,-153.25);

	this.shape_1191 = new cjs.Shape();
	this.shape_1191.graphics.lf(["#E56817","#E57133"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_1191.setTransform(32.725,-214.9);

	this.shape_1192 = new cjs.Shape();
	this.shape_1192.graphics.lf(["#E56817","#E57133"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_1192.setTransform(-122.5,-6.825);

	this.shape_1193 = new cjs.Shape();
	this.shape_1193.graphics.lf(["#E56817","#E57133"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_1193.setTransform(-144.525,-186.225);

	this.shape_1194 = new cjs.Shape();
	this.shape_1194.graphics.lf(["#E56817","#E57133"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_1194.setTransform(-159.025,-28.975);

	this.shape_1195 = new cjs.Shape();
	this.shape_1195.graphics.lf(["#E56817","#E57133"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_1195.setTransform(-200.9,-36.7925);

	this.shape_1196 = new cjs.Shape();
	this.shape_1196.graphics.lf(["#E56817","#E57133"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_1196.setTransform(-243.525,-32.85);

	this.shape_1197 = new cjs.Shape();
	this.shape_1197.graphics.lf(["#E56817","#E57133"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_1197.setTransform(-284.875,-21.325);

	this.shape_1198 = new cjs.Shape();
	this.shape_1198.graphics.lf(["#E56817","#E57133"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_1198.setTransform(-266.575,-120.375);

	this.shape_1199 = new cjs.Shape();
	this.shape_1199.graphics.lf(["#E56817","#E57133"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_1199.setTransform(-313.25,-110.575);

	this.shape_1200 = new cjs.Shape();
	this.shape_1200.graphics.lf(["#E56817","#E57133"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_1200.setTransform(-219.775,-130.875);

	this.shape_1201 = new cjs.Shape();
	this.shape_1201.graphics.lf(["#E56817","#E57133"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_1201.setTransform(-177.075,-151.575);

	this.shape_1202 = new cjs.Shape();
	this.shape_1202.graphics.lf(["#E56817","#E57133"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_1202.setTransform(-37.725,-278.5196);

	this.shape_1203 = new cjs.Shape();
	this.shape_1203.graphics.lf(["#E56817","#E57133"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_1203.setTransform(1.75,-253.225);

	this.shape_1204 = new cjs.Shape();
	this.shape_1204.graphics.lf(["#E56817","#E57133"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_1204.setTransform(-114.5,-223.5);

	this.shape_1205 = new cjs.Shape();
	this.shape_1205.graphics.lf(["#E56817","#E57133"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_1205.setTransform(-80.375,-257.35);

	this.shape_1206 = new cjs.Shape();
	this.shape_1206.graphics.lf(["#E56817","#E57133"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_1206.setTransform(-328.05,-10.925);

	this.shape_1207 = new cjs.Shape();
	this.shape_1207.graphics.lf(["#E56817","#E57133"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_1207.setTransform(-373,-12.325);

	this.shape_1208 = new cjs.Shape();
	this.shape_1208.graphics.lf(["#E56817","#E57133"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_1208.setTransform(-358.325,-95.45);

	this.shape_1209 = new cjs.Shape();
	this.shape_1209.graphics.lf(["#E56817","#E57133"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_1209.setTransform(-411.075,-32.2);

	this.shape_1210 = new cjs.Shape();
	this.shape_1210.graphics.lf(["#E56817","#E57133"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_1210.setTransform(-398.975,-71.425);

	this.shape_1211 = new cjs.Shape();
	this.shape_1211.graphics.lf(["#D76E22","#D7763D"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_1211.setTransform(273.675,16.25);

	this.shape_1212 = new cjs.Shape();
	this.shape_1212.graphics.lf(["#D76E22","#D7763D"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_1212.setTransform(320.475,28.6);

	this.shape_1213 = new cjs.Shape();
	this.shape_1213.graphics.lf(["#D76E22","#D7763D"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_1213.setTransform(367,42.55);

	this.shape_1214 = new cjs.Shape();
	this.shape_1214.graphics.lf(["#D76E22","#D7763D"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_1214.setTransform(457.5,78.175);

	this.shape_1215 = new cjs.Shape();
	this.shape_1215.graphics.lf(["#D76E22","#D7763D"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_1215.setTransform(412.875,58.825);

	this.shape_1216 = new cjs.Shape();
	this.shape_1216.graphics.lf(["#D76E22","#D7763D"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_1216.setTransform(539.325,181.675);

	this.shape_1217 = new cjs.Shape();
	this.shape_1217.graphics.lf(["#D76E22","#D7763D"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_1217.setTransform(534.05,135.7);

	this.shape_1218 = new cjs.Shape();
	this.shape_1218.graphics.lf(["#D76E22","#D7763D"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_1218.setTransform(499.575,102.375);

	this.shape_1219 = new cjs.Shape();
	this.shape_1219.graphics.lf(["#D76E22","#D7763D"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_1219.setTransform(273.8,-86.475);

	this.shape_1220 = new cjs.Shape();
	this.shape_1220.graphics.lf(["#D76E22","#D7763D"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_1220.setTransform(205.1312,-32.65);

	this.shape_1221 = new cjs.Shape();
	this.shape_1221.graphics.lf(["#D76E22","#D7763D"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_1221.setTransform(231.025,-0.325);

	this.shape_1222 = new cjs.Shape();
	this.shape_1222.graphics.lf(["#D76E22","#D7763D"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_1222.setTransform(232.95,-65.4);

	this.shape_1223 = new cjs.Shape();
	this.shape_1223.graphics.lf(["#D76E22","#D7763D"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_1223.setTransform(202.225,-123.35);

	this.shape_1224 = new cjs.Shape();
	this.shape_1224.graphics.lf(["#D76E22","#D7763D"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_1224.setTransform(298.7901,-104.575);

	this.shape_1225 = new cjs.Shape();
	this.shape_1225.graphics.lf(["#D76E22","#D7763D"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_1225.setTransform(250.45,-113.45);

	this.shape_1226 = new cjs.Shape();
	this.shape_1226.graphics.lf(["#D76E22","#D7763D"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_1226.setTransform(67.475,-180.175);

	this.shape_1227 = new cjs.Shape();
	this.shape_1227.graphics.lf(["#D76E22","#D7763D"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_1227.setTransform(154.35,-135.525);

	this.shape_1228 = new cjs.Shape();
	this.shape_1228.graphics.lf(["#D76E22","#D7763D"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_1228.setTransform(108.425,-153.25);

	this.shape_1229 = new cjs.Shape();
	this.shape_1229.graphics.lf(["#D76E22","#D7763D"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_1229.setTransform(32.725,-214.9);

	this.shape_1230 = new cjs.Shape();
	this.shape_1230.graphics.lf(["#D76E22","#D7763D"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_1230.setTransform(1.75,-253.225);

	this.shape_1231 = new cjs.Shape();
	this.shape_1231.graphics.lf(["#CA732D","#CA7A46"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_1231.setTransform(-510.625,132.625);

	this.shape_1232 = new cjs.Shape();
	this.shape_1232.graphics.lf(["#CA732D","#CA7A46"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_1232.setTransform(-468.325,117.725);

	this.shape_1233 = new cjs.Shape();
	this.shape_1233.graphics.lf(["#CA732D","#CA7A46"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_1233.setTransform(-425.825,103.1);

	this.shape_1234 = new cjs.Shape();
	this.shape_1234.graphics.lf(["#CA732D","#CA7A46"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_1234.setTransform(-340.575,74.725);

	this.shape_1235 = new cjs.Shape();
	this.shape_1235.graphics.lf(["#CA732D","#CA7A46"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_1235.setTransform(-383.3,88.725);

	this.shape_1236 = new cjs.Shape();
	this.shape_1236.graphics.lf(["#CA732D","#CA7A46"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_1236.setTransform(-296.25,64.05);

	this.shape_1237 = new cjs.Shape();
	this.shape_1237.graphics.lf(["#CA732D","#CA7A46"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_1237.setTransform(-251.075,56.95);

	this.shape_1238 = new cjs.Shape();
	this.shape_1238.graphics.lf(["#CA732D","#CA7A46"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_1238.setTransform(-205.675,50.875);

	this.shape_1239 = new cjs.Shape();
	this.shape_1239.graphics.lf(["#CA732D","#CA7A46"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_1239.setTransform(-160.5,43.575);

	this.shape_1240 = new cjs.Shape();
	this.shape_1240.graphics.lf(["#CA732D","#CA7A46"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_1240.setTransform(-117.75,28.75);

	this.shape_1241 = new cjs.Shape();
	this.shape_1241.graphics.lf(["#CA732D","#CA7A46"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_1241.setTransform(273.675,16.25);

	this.shape_1242 = new cjs.Shape();
	this.shape_1242.graphics.lf(["#CA732D","#CA7A46"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_1242.setTransform(320.475,28.6);

	this.shape_1243 = new cjs.Shape();
	this.shape_1243.graphics.lf(["#CA732D","#CA7A46"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_1243.setTransform(367,42.55);

	this.shape_1244 = new cjs.Shape();
	this.shape_1244.graphics.lf(["#CA732D","#CA7A46"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_1244.setTransform(457.5,78.175);

	this.shape_1245 = new cjs.Shape();
	this.shape_1245.graphics.lf(["#CA732D","#CA7A46"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_1245.setTransform(412.875,58.825);

	this.shape_1246 = new cjs.Shape();
	this.shape_1246.graphics.lf(["#CA732D","#CA7A46"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_1246.setTransform(539.325,181.675);

	this.shape_1247 = new cjs.Shape();
	this.shape_1247.graphics.lf(["#CA732D","#CA7A46"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_1247.setTransform(534.05,135.7);

	this.shape_1248 = new cjs.Shape();
	this.shape_1248.graphics.lf(["#CA732D","#CA7A46"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_1248.setTransform(499.575,102.375);

	this.shape_1249 = new cjs.Shape();
	this.shape_1249.graphics.lf(["#CA732D","#CA7A46"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_1249.setTransform(273.8,-86.475);

	this.shape_1250 = new cjs.Shape();
	this.shape_1250.graphics.lf(["#CA732D","#CA7A46"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_1250.setTransform(205.1312,-32.65);

	this.shape_1251 = new cjs.Shape();
	this.shape_1251.graphics.lf(["#CA732D","#CA7A46"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_1251.setTransform(231.025,-0.325);

	this.shape_1252 = new cjs.Shape();
	this.shape_1252.graphics.lf(["#CA732D","#CA7A46"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_1252.setTransform(232.95,-65.4);

	this.shape_1253 = new cjs.Shape();
	this.shape_1253.graphics.lf(["#CA732D","#CA7A46"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_1253.setTransform(202.225,-123.35);

	this.shape_1254 = new cjs.Shape();
	this.shape_1254.graphics.lf(["#CA732D","#CA7A46"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_1254.setTransform(298.7901,-104.575);

	this.shape_1255 = new cjs.Shape();
	this.shape_1255.graphics.lf(["#CA732D","#CA7A46"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_1255.setTransform(250.45,-113.45);

	this.shape_1256 = new cjs.Shape();
	this.shape_1256.graphics.lf(["#CA732D","#CA7A46"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_1256.setTransform(67.475,-180.175);

	this.shape_1257 = new cjs.Shape();
	this.shape_1257.graphics.lf(["#CA732D","#CA7A46"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_1257.setTransform(154.35,-135.525);

	this.shape_1258 = new cjs.Shape();
	this.shape_1258.graphics.lf(["#CA732D","#CA7A46"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_1258.setTransform(108.425,-153.25);

	this.shape_1259 = new cjs.Shape();
	this.shape_1259.graphics.lf(["#CA732D","#CA7A46"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_1259.setTransform(32.725,-214.9);

	this.shape_1260 = new cjs.Shape();
	this.shape_1260.graphics.lf(["#CA732D","#CA7A46"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_1260.setTransform(-122.5,-6.825);

	this.shape_1261 = new cjs.Shape();
	this.shape_1261.graphics.lf(["#CA732D","#CA7A46"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_1261.setTransform(-144.525,-186.225);

	this.shape_1262 = new cjs.Shape();
	this.shape_1262.graphics.lf(["#CA732D","#CA7A46"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_1262.setTransform(-159.025,-28.975);

	this.shape_1263 = new cjs.Shape();
	this.shape_1263.graphics.lf(["#CA732D","#CA7A46"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_1263.setTransform(-200.9,-36.7925);

	this.shape_1264 = new cjs.Shape();
	this.shape_1264.graphics.lf(["#CA732D","#CA7A46"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_1264.setTransform(-243.525,-32.85);

	this.shape_1265 = new cjs.Shape();
	this.shape_1265.graphics.lf(["#CA732D","#CA7A46"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_1265.setTransform(-284.875,-21.325);

	this.shape_1266 = new cjs.Shape();
	this.shape_1266.graphics.lf(["#CA732D","#CA7A46"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_1266.setTransform(-266.575,-120.375);

	this.shape_1267 = new cjs.Shape();
	this.shape_1267.graphics.lf(["#CA732D","#CA7A46"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_1267.setTransform(-313.25,-110.575);

	this.shape_1268 = new cjs.Shape();
	this.shape_1268.graphics.lf(["#CA732D","#CA7A46"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_1268.setTransform(-219.775,-130.875);

	this.shape_1269 = new cjs.Shape();
	this.shape_1269.graphics.lf(["#CA732D","#CA7A46"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_1269.setTransform(-177.075,-151.575);

	this.shape_1270 = new cjs.Shape();
	this.shape_1270.graphics.lf(["#CA732D","#CA7A46"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_1270.setTransform(-37.725,-278.5196);

	this.shape_1271 = new cjs.Shape();
	this.shape_1271.graphics.lf(["#CA732D","#CA7A46"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_1271.setTransform(1.75,-253.225);

	this.shape_1272 = new cjs.Shape();
	this.shape_1272.graphics.lf(["#CA732D","#CA7A46"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_1272.setTransform(-114.5,-223.5);

	this.shape_1273 = new cjs.Shape();
	this.shape_1273.graphics.lf(["#CA732D","#CA7A46"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_1273.setTransform(-80.375,-257.35);

	this.shape_1274 = new cjs.Shape();
	this.shape_1274.graphics.lf(["#CA732D","#CA7A46"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_1274.setTransform(-328.05,-10.925);

	this.shape_1275 = new cjs.Shape();
	this.shape_1275.graphics.lf(["#CA732D","#CA7A46"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_1275.setTransform(-373,-12.325);

	this.shape_1276 = new cjs.Shape();
	this.shape_1276.graphics.lf(["#CA732D","#CA7A46"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_1276.setTransform(-358.325,-95.45);

	this.shape_1277 = new cjs.Shape();
	this.shape_1277.graphics.lf(["#CA732D","#CA7A46"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_1277.setTransform(-411.075,-32.2);

	this.shape_1278 = new cjs.Shape();
	this.shape_1278.graphics.lf(["#CA732D","#CA7A46"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_1278.setTransform(-398.975,-71.425);

	this.shape_1279 = new cjs.Shape();
	this.shape_1279.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_1279.setTransform(-510.625,132.625);

	this.shape_1280 = new cjs.Shape();
	this.shape_1280.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_1280.setTransform(-468.325,117.725);

	this.shape_1281 = new cjs.Shape();
	this.shape_1281.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_1281.setTransform(-425.825,103.1);

	this.shape_1282 = new cjs.Shape();
	this.shape_1282.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_1282.setTransform(-340.575,74.725);

	this.shape_1283 = new cjs.Shape();
	this.shape_1283.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_1283.setTransform(-383.3,88.725);

	this.shape_1284 = new cjs.Shape();
	this.shape_1284.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_1284.setTransform(-296.25,64.05);

	this.shape_1285 = new cjs.Shape();
	this.shape_1285.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_1285.setTransform(-251.075,56.95);

	this.shape_1286 = new cjs.Shape();
	this.shape_1286.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_1286.setTransform(-205.675,50.875);

	this.shape_1287 = new cjs.Shape();
	this.shape_1287.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_1287.setTransform(-160.5,43.575);

	this.shape_1288 = new cjs.Shape();
	this.shape_1288.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_1288.setTransform(-117.75,28.75);

	this.shape_1289 = new cjs.Shape();
	this.shape_1289.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_1289.setTransform(273.675,16.25);

	this.shape_1290 = new cjs.Shape();
	this.shape_1290.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_1290.setTransform(320.475,28.6);

	this.shape_1291 = new cjs.Shape();
	this.shape_1291.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_1291.setTransform(367,42.55);

	this.shape_1292 = new cjs.Shape();
	this.shape_1292.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_1292.setTransform(457.5,78.175);

	this.shape_1293 = new cjs.Shape();
	this.shape_1293.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_1293.setTransform(412.875,58.825);

	this.shape_1294 = new cjs.Shape();
	this.shape_1294.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_1294.setTransform(539.325,181.675);

	this.shape_1295 = new cjs.Shape();
	this.shape_1295.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_1295.setTransform(534.05,135.7);

	this.shape_1296 = new cjs.Shape();
	this.shape_1296.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_1296.setTransform(499.575,102.375);

	this.shape_1297 = new cjs.Shape();
	this.shape_1297.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_1297.setTransform(273.8,-86.475);

	this.shape_1298 = new cjs.Shape();
	this.shape_1298.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_1298.setTransform(205.1312,-32.65);

	this.shape_1299 = new cjs.Shape();
	this.shape_1299.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_1299.setTransform(231.025,-0.325);

	this.shape_1300 = new cjs.Shape();
	this.shape_1300.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_1300.setTransform(232.95,-65.4);

	this.shape_1301 = new cjs.Shape();
	this.shape_1301.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_1301.setTransform(202.225,-123.35);

	this.shape_1302 = new cjs.Shape();
	this.shape_1302.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_1302.setTransform(298.7901,-104.575);

	this.shape_1303 = new cjs.Shape();
	this.shape_1303.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_1303.setTransform(250.45,-113.45);

	this.shape_1304 = new cjs.Shape();
	this.shape_1304.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_1304.setTransform(67.475,-180.175);

	this.shape_1305 = new cjs.Shape();
	this.shape_1305.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_1305.setTransform(154.35,-135.525);

	this.shape_1306 = new cjs.Shape();
	this.shape_1306.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_1306.setTransform(108.425,-153.25);

	this.shape_1307 = new cjs.Shape();
	this.shape_1307.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_1307.setTransform(32.725,-214.9);

	this.shape_1308 = new cjs.Shape();
	this.shape_1308.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_1308.setTransform(-122.5,-6.825);

	this.shape_1309 = new cjs.Shape();
	this.shape_1309.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_1309.setTransform(-144.525,-186.225);

	this.shape_1310 = new cjs.Shape();
	this.shape_1310.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_1310.setTransform(-159.025,-28.975);

	this.shape_1311 = new cjs.Shape();
	this.shape_1311.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_1311.setTransform(-200.9,-36.7925);

	this.shape_1312 = new cjs.Shape();
	this.shape_1312.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_1312.setTransform(-243.525,-32.85);

	this.shape_1313 = new cjs.Shape();
	this.shape_1313.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_1313.setTransform(-284.875,-21.325);

	this.shape_1314 = new cjs.Shape();
	this.shape_1314.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_1314.setTransform(-266.575,-120.375);

	this.shape_1315 = new cjs.Shape();
	this.shape_1315.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_1315.setTransform(-313.25,-110.575);

	this.shape_1316 = new cjs.Shape();
	this.shape_1316.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_1316.setTransform(-219.775,-130.875);

	this.shape_1317 = new cjs.Shape();
	this.shape_1317.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_1317.setTransform(-177.075,-151.575);

	this.shape_1318 = new cjs.Shape();
	this.shape_1318.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_1318.setTransform(-37.725,-278.5196);

	this.shape_1319 = new cjs.Shape();
	this.shape_1319.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_1319.setTransform(1.75,-253.225);

	this.shape_1320 = new cjs.Shape();
	this.shape_1320.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_1320.setTransform(-114.5,-223.5);

	this.shape_1321 = new cjs.Shape();
	this.shape_1321.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_1321.setTransform(-80.375,-257.35);

	this.shape_1322 = new cjs.Shape();
	this.shape_1322.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_1322.setTransform(-328.05,-10.925);

	this.shape_1323 = new cjs.Shape();
	this.shape_1323.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_1323.setTransform(-373,-12.325);

	this.shape_1324 = new cjs.Shape();
	this.shape_1324.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_1324.setTransform(-358.325,-95.45);

	this.shape_1325 = new cjs.Shape();
	this.shape_1325.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_1325.setTransform(-411.075,-32.2);

	this.shape_1326 = new cjs.Shape();
	this.shape_1326.graphics.lf(["#BD7838","#BD7F4F"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_1326.setTransform(-398.975,-71.425);

	this.shape_1327 = new cjs.Shape();
	this.shape_1327.graphics.lf(["#B07D44","#B08358"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_1327.setTransform(-510.625,132.625);

	this.shape_1328 = new cjs.Shape();
	this.shape_1328.graphics.lf(["#B07D44","#B08358"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_1328.setTransform(-468.325,117.725);

	this.shape_1329 = new cjs.Shape();
	this.shape_1329.graphics.lf(["#B07D44","#B08358"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_1329.setTransform(-425.825,103.1);

	this.shape_1330 = new cjs.Shape();
	this.shape_1330.graphics.lf(["#B07D44","#B08358"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_1330.setTransform(-340.575,74.725);

	this.shape_1331 = new cjs.Shape();
	this.shape_1331.graphics.lf(["#B07D44","#B08358"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_1331.setTransform(-383.3,88.725);

	this.shape_1332 = new cjs.Shape();
	this.shape_1332.graphics.lf(["#B07D44","#B08358"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_1332.setTransform(-296.25,64.05);

	this.shape_1333 = new cjs.Shape();
	this.shape_1333.graphics.lf(["#B07D44","#B08358"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_1333.setTransform(-251.075,56.95);

	this.shape_1334 = new cjs.Shape();
	this.shape_1334.graphics.lf(["#B07D44","#B08358"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_1334.setTransform(-205.675,50.875);

	this.shape_1335 = new cjs.Shape();
	this.shape_1335.graphics.lf(["#B07D44","#B08358"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_1335.setTransform(-160.5,43.575);

	this.shape_1336 = new cjs.Shape();
	this.shape_1336.graphics.lf(["#B07D44","#B08358"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_1336.setTransform(-117.75,28.75);

	this.shape_1337 = new cjs.Shape();
	this.shape_1337.graphics.lf(["#B07D44","#B08358"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_1337.setTransform(273.675,16.25);

	this.shape_1338 = new cjs.Shape();
	this.shape_1338.graphics.lf(["#B07D44","#B08358"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_1338.setTransform(320.475,28.6);

	this.shape_1339 = new cjs.Shape();
	this.shape_1339.graphics.lf(["#B07D44","#B08358"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_1339.setTransform(367,42.55);

	this.shape_1340 = new cjs.Shape();
	this.shape_1340.graphics.lf(["#B07D44","#B08358"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_1340.setTransform(457.5,78.175);

	this.shape_1341 = new cjs.Shape();
	this.shape_1341.graphics.lf(["#B07D44","#B08358"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_1341.setTransform(412.875,58.825);

	this.shape_1342 = new cjs.Shape();
	this.shape_1342.graphics.lf(["#B07D44","#B08358"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_1342.setTransform(539.325,181.675);

	this.shape_1343 = new cjs.Shape();
	this.shape_1343.graphics.lf(["#B07D44","#B08358"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_1343.setTransform(534.05,135.7);

	this.shape_1344 = new cjs.Shape();
	this.shape_1344.graphics.lf(["#B07D44","#B08358"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_1344.setTransform(499.575,102.375);

	this.shape_1345 = new cjs.Shape();
	this.shape_1345.graphics.lf(["#B07D44","#B08358"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_1345.setTransform(273.8,-86.475);

	this.shape_1346 = new cjs.Shape();
	this.shape_1346.graphics.lf(["#B07D44","#B08358"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_1346.setTransform(205.1312,-32.65);

	this.shape_1347 = new cjs.Shape();
	this.shape_1347.graphics.lf(["#B07D44","#B08358"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_1347.setTransform(231.025,-0.325);

	this.shape_1348 = new cjs.Shape();
	this.shape_1348.graphics.lf(["#B07D44","#B08358"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_1348.setTransform(232.95,-65.4);

	this.shape_1349 = new cjs.Shape();
	this.shape_1349.graphics.lf(["#B07D44","#B08358"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_1349.setTransform(202.225,-123.35);

	this.shape_1350 = new cjs.Shape();
	this.shape_1350.graphics.lf(["#B07D44","#B08358"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_1350.setTransform(298.7901,-104.575);

	this.shape_1351 = new cjs.Shape();
	this.shape_1351.graphics.lf(["#B07D44","#B08358"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_1351.setTransform(250.45,-113.45);

	this.shape_1352 = new cjs.Shape();
	this.shape_1352.graphics.lf(["#B07D44","#B08358"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_1352.setTransform(67.475,-180.175);

	this.shape_1353 = new cjs.Shape();
	this.shape_1353.graphics.lf(["#B07D44","#B08358"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_1353.setTransform(154.35,-135.525);

	this.shape_1354 = new cjs.Shape();
	this.shape_1354.graphics.lf(["#B07D44","#B08358"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_1354.setTransform(108.425,-153.25);

	this.shape_1355 = new cjs.Shape();
	this.shape_1355.graphics.lf(["#B07D44","#B08358"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_1355.setTransform(32.725,-214.9);

	this.shape_1356 = new cjs.Shape();
	this.shape_1356.graphics.lf(["#B07D44","#B08358"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_1356.setTransform(-122.5,-6.825);

	this.shape_1357 = new cjs.Shape();
	this.shape_1357.graphics.lf(["#B07D44","#B08358"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_1357.setTransform(-144.525,-186.225);

	this.shape_1358 = new cjs.Shape();
	this.shape_1358.graphics.lf(["#B07D44","#B08358"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_1358.setTransform(-159.025,-28.975);

	this.shape_1359 = new cjs.Shape();
	this.shape_1359.graphics.lf(["#B07D44","#B08358"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_1359.setTransform(-200.9,-36.7925);

	this.shape_1360 = new cjs.Shape();
	this.shape_1360.graphics.lf(["#B07D44","#B08358"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_1360.setTransform(-243.525,-32.85);

	this.shape_1361 = new cjs.Shape();
	this.shape_1361.graphics.lf(["#B07D44","#B08358"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_1361.setTransform(-284.875,-21.325);

	this.shape_1362 = new cjs.Shape();
	this.shape_1362.graphics.lf(["#B07D44","#B08358"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_1362.setTransform(-266.575,-120.375);

	this.shape_1363 = new cjs.Shape();
	this.shape_1363.graphics.lf(["#B07D44","#B08358"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_1363.setTransform(-313.25,-110.575);

	this.shape_1364 = new cjs.Shape();
	this.shape_1364.graphics.lf(["#B07D44","#B08358"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_1364.setTransform(-219.775,-130.875);

	this.shape_1365 = new cjs.Shape();
	this.shape_1365.graphics.lf(["#B07D44","#B08358"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_1365.setTransform(-177.075,-151.575);

	this.shape_1366 = new cjs.Shape();
	this.shape_1366.graphics.lf(["#B07D44","#B08358"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_1366.setTransform(-37.725,-278.5196);

	this.shape_1367 = new cjs.Shape();
	this.shape_1367.graphics.lf(["#B07D44","#B08358"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_1367.setTransform(1.75,-253.225);

	this.shape_1368 = new cjs.Shape();
	this.shape_1368.graphics.lf(["#B07D44","#B08358"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_1368.setTransform(-114.5,-223.5);

	this.shape_1369 = new cjs.Shape();
	this.shape_1369.graphics.lf(["#B07D44","#B08358"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_1369.setTransform(-80.375,-257.35);

	this.shape_1370 = new cjs.Shape();
	this.shape_1370.graphics.lf(["#B07D44","#B08358"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_1370.setTransform(-328.05,-10.925);

	this.shape_1371 = new cjs.Shape();
	this.shape_1371.graphics.lf(["#B07D44","#B08358"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_1371.setTransform(-373,-12.325);

	this.shape_1372 = new cjs.Shape();
	this.shape_1372.graphics.lf(["#B07D44","#B08358"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_1372.setTransform(-358.325,-95.45);

	this.shape_1373 = new cjs.Shape();
	this.shape_1373.graphics.lf(["#B07D44","#B08358"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_1373.setTransform(-411.075,-32.2);

	this.shape_1374 = new cjs.Shape();
	this.shape_1374.graphics.lf(["#B07D44","#B08358"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_1374.setTransform(-398.975,-71.425);

	this.shape_1375 = new cjs.Shape();
	this.shape_1375.graphics.lf(["#A2824F","#A28861"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_1375.setTransform(-510.625,132.625);

	this.shape_1376 = new cjs.Shape();
	this.shape_1376.graphics.lf(["#A2824F","#A28861"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_1376.setTransform(-468.325,117.725);

	this.shape_1377 = new cjs.Shape();
	this.shape_1377.graphics.lf(["#A2824F","#A28861"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_1377.setTransform(-425.825,103.1);

	this.shape_1378 = new cjs.Shape();
	this.shape_1378.graphics.lf(["#A2824F","#A28861"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_1378.setTransform(-340.575,74.725);

	this.shape_1379 = new cjs.Shape();
	this.shape_1379.graphics.lf(["#A2824F","#A28861"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_1379.setTransform(-383.3,88.725);

	this.shape_1380 = new cjs.Shape();
	this.shape_1380.graphics.lf(["#A2824F","#A28861"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_1380.setTransform(-296.25,64.05);

	this.shape_1381 = new cjs.Shape();
	this.shape_1381.graphics.lf(["#A2824F","#A28861"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_1381.setTransform(-251.075,56.95);

	this.shape_1382 = new cjs.Shape();
	this.shape_1382.graphics.lf(["#A2824F","#A28861"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_1382.setTransform(-205.675,50.875);

	this.shape_1383 = new cjs.Shape();
	this.shape_1383.graphics.lf(["#A2824F","#A28861"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_1383.setTransform(-160.5,43.575);

	this.shape_1384 = new cjs.Shape();
	this.shape_1384.graphics.lf(["#A2824F","#A28861"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_1384.setTransform(-117.75,28.75);

	this.shape_1385 = new cjs.Shape();
	this.shape_1385.graphics.lf(["#A2824F","#A28861"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_1385.setTransform(273.675,16.25);

	this.shape_1386 = new cjs.Shape();
	this.shape_1386.graphics.lf(["#A2824F","#A28861"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_1386.setTransform(320.475,28.6);

	this.shape_1387 = new cjs.Shape();
	this.shape_1387.graphics.lf(["#A2824F","#A28861"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_1387.setTransform(367,42.55);

	this.shape_1388 = new cjs.Shape();
	this.shape_1388.graphics.lf(["#A2824F","#A28861"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_1388.setTransform(457.5,78.175);

	this.shape_1389 = new cjs.Shape();
	this.shape_1389.graphics.lf(["#A2824F","#A28861"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_1389.setTransform(412.875,58.825);

	this.shape_1390 = new cjs.Shape();
	this.shape_1390.graphics.lf(["#A2824F","#A28861"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_1390.setTransform(539.325,181.675);

	this.shape_1391 = new cjs.Shape();
	this.shape_1391.graphics.lf(["#A2824F","#A28861"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_1391.setTransform(534.05,135.7);

	this.shape_1392 = new cjs.Shape();
	this.shape_1392.graphics.lf(["#A2824F","#A28861"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_1392.setTransform(499.575,102.375);

	this.shape_1393 = new cjs.Shape();
	this.shape_1393.graphics.lf(["#A2824F","#A28861"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_1393.setTransform(273.8,-86.475);

	this.shape_1394 = new cjs.Shape();
	this.shape_1394.graphics.lf(["#A2824F","#A28861"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_1394.setTransform(205.1312,-32.65);

	this.shape_1395 = new cjs.Shape();
	this.shape_1395.graphics.lf(["#A2824F","#A28861"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_1395.setTransform(231.025,-0.325);

	this.shape_1396 = new cjs.Shape();
	this.shape_1396.graphics.lf(["#A2824F","#A28861"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_1396.setTransform(232.95,-65.4);

	this.shape_1397 = new cjs.Shape();
	this.shape_1397.graphics.lf(["#A2824F","#A28861"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_1397.setTransform(202.225,-123.35);

	this.shape_1398 = new cjs.Shape();
	this.shape_1398.graphics.lf(["#A2824F","#A28861"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_1398.setTransform(298.7901,-104.575);

	this.shape_1399 = new cjs.Shape();
	this.shape_1399.graphics.lf(["#A2824F","#A28861"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_1399.setTransform(250.45,-113.45);

	this.shape_1400 = new cjs.Shape();
	this.shape_1400.graphics.lf(["#A2824F","#A28861"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_1400.setTransform(67.475,-180.175);

	this.shape_1401 = new cjs.Shape();
	this.shape_1401.graphics.lf(["#A2824F","#A28861"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_1401.setTransform(154.35,-135.525);

	this.shape_1402 = new cjs.Shape();
	this.shape_1402.graphics.lf(["#A2824F","#A28861"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_1402.setTransform(108.425,-153.25);

	this.shape_1403 = new cjs.Shape();
	this.shape_1403.graphics.lf(["#A2824F","#A28861"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_1403.setTransform(32.725,-214.9);

	this.shape_1404 = new cjs.Shape();
	this.shape_1404.graphics.lf(["#A2824F","#A28861"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_1404.setTransform(-122.5,-6.825);

	this.shape_1405 = new cjs.Shape();
	this.shape_1405.graphics.lf(["#A2824F","#A28861"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_1405.setTransform(-144.525,-186.225);

	this.shape_1406 = new cjs.Shape();
	this.shape_1406.graphics.lf(["#A2824F","#A28861"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_1406.setTransform(-159.025,-28.975);

	this.shape_1407 = new cjs.Shape();
	this.shape_1407.graphics.lf(["#A2824F","#A28861"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_1407.setTransform(-200.9,-36.7925);

	this.shape_1408 = new cjs.Shape();
	this.shape_1408.graphics.lf(["#A2824F","#A28861"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_1408.setTransform(-243.525,-32.85);

	this.shape_1409 = new cjs.Shape();
	this.shape_1409.graphics.lf(["#A2824F","#A28861"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_1409.setTransform(-284.875,-21.325);

	this.shape_1410 = new cjs.Shape();
	this.shape_1410.graphics.lf(["#A2824F","#A28861"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_1410.setTransform(-266.575,-120.375);

	this.shape_1411 = new cjs.Shape();
	this.shape_1411.graphics.lf(["#A2824F","#A28861"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_1411.setTransform(-313.25,-110.575);

	this.shape_1412 = new cjs.Shape();
	this.shape_1412.graphics.lf(["#A2824F","#A28861"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_1412.setTransform(-219.775,-130.875);

	this.shape_1413 = new cjs.Shape();
	this.shape_1413.graphics.lf(["#A2824F","#A28861"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_1413.setTransform(-177.075,-151.575);

	this.shape_1414 = new cjs.Shape();
	this.shape_1414.graphics.lf(["#A2824F","#A28861"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_1414.setTransform(-37.725,-278.5196);

	this.shape_1415 = new cjs.Shape();
	this.shape_1415.graphics.lf(["#A2824F","#A28861"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_1415.setTransform(1.75,-253.225);

	this.shape_1416 = new cjs.Shape();
	this.shape_1416.graphics.lf(["#A2824F","#A28861"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_1416.setTransform(-114.5,-223.5);

	this.shape_1417 = new cjs.Shape();
	this.shape_1417.graphics.lf(["#A2824F","#A28861"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_1417.setTransform(-80.375,-257.35);

	this.shape_1418 = new cjs.Shape();
	this.shape_1418.graphics.lf(["#A2824F","#A28861"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_1418.setTransform(-328.05,-10.925);

	this.shape_1419 = new cjs.Shape();
	this.shape_1419.graphics.lf(["#A2824F","#A28861"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_1419.setTransform(-373,-12.325);

	this.shape_1420 = new cjs.Shape();
	this.shape_1420.graphics.lf(["#A2824F","#A28861"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_1420.setTransform(-358.325,-95.45);

	this.shape_1421 = new cjs.Shape();
	this.shape_1421.graphics.lf(["#A2824F","#A28861"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_1421.setTransform(-411.075,-32.2);

	this.shape_1422 = new cjs.Shape();
	this.shape_1422.graphics.lf(["#A2824F","#A28861"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_1422.setTransform(-398.975,-71.425);

	this.shape_1423 = new cjs.Shape();
	this.shape_1423.graphics.lf(["#95885A","#958D6B"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_1423.setTransform(273.675,16.25);

	this.shape_1424 = new cjs.Shape();
	this.shape_1424.graphics.lf(["#95885A","#958D6B"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_1424.setTransform(320.475,28.6);

	this.shape_1425 = new cjs.Shape();
	this.shape_1425.graphics.lf(["#95885A","#958D6B"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_1425.setTransform(367,42.55);

	this.shape_1426 = new cjs.Shape();
	this.shape_1426.graphics.lf(["#95885A","#958D6B"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_1426.setTransform(457.5,78.175);

	this.shape_1427 = new cjs.Shape();
	this.shape_1427.graphics.lf(["#95885A","#958D6B"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_1427.setTransform(412.875,58.825);

	this.shape_1428 = new cjs.Shape();
	this.shape_1428.graphics.lf(["#95885A","#958D6B"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_1428.setTransform(539.325,181.675);

	this.shape_1429 = new cjs.Shape();
	this.shape_1429.graphics.lf(["#95885A","#958D6B"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_1429.setTransform(534.05,135.7);

	this.shape_1430 = new cjs.Shape();
	this.shape_1430.graphics.lf(["#95885A","#958D6B"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_1430.setTransform(499.575,102.375);

	this.shape_1431 = new cjs.Shape();
	this.shape_1431.graphics.lf(["#95885A","#958D6B"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_1431.setTransform(231.025,-0.325);

	this.shape_1432 = new cjs.Shape();
	this.shape_1432.graphics.lf(["#888D65","#889174"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_1432.setTransform(-510.625,132.625);

	this.shape_1433 = new cjs.Shape();
	this.shape_1433.graphics.lf(["#888D65","#889174"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_1433.setTransform(-468.325,117.725);

	this.shape_1434 = new cjs.Shape();
	this.shape_1434.graphics.lf(["#888D65","#889174"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_1434.setTransform(-425.825,103.1);

	this.shape_1435 = new cjs.Shape();
	this.shape_1435.graphics.lf(["#888D65","#889174"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_1435.setTransform(-340.575,74.725);

	this.shape_1436 = new cjs.Shape();
	this.shape_1436.graphics.lf(["#888D65","#889174"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_1436.setTransform(-383.3,88.725);

	this.shape_1437 = new cjs.Shape();
	this.shape_1437.graphics.lf(["#888D65","#889174"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_1437.setTransform(-296.25,64.05);

	this.shape_1438 = new cjs.Shape();
	this.shape_1438.graphics.lf(["#888D65","#889174"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_1438.setTransform(-251.075,56.95);

	this.shape_1439 = new cjs.Shape();
	this.shape_1439.graphics.lf(["#888D65","#889174"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_1439.setTransform(-205.675,50.875);

	this.shape_1440 = new cjs.Shape();
	this.shape_1440.graphics.lf(["#888D65","#889174"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_1440.setTransform(-160.5,43.575);

	this.shape_1441 = new cjs.Shape();
	this.shape_1441.graphics.lf(["#888D65","#889174"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_1441.setTransform(-117.75,28.75);

	this.shape_1442 = new cjs.Shape();
	this.shape_1442.graphics.lf(["#888D65","#889174"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_1442.setTransform(273.675,16.25);

	this.shape_1443 = new cjs.Shape();
	this.shape_1443.graphics.lf(["#888D65","#889174"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_1443.setTransform(320.475,28.6);

	this.shape_1444 = new cjs.Shape();
	this.shape_1444.graphics.lf(["#888D65","#889174"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_1444.setTransform(367,42.55);

	this.shape_1445 = new cjs.Shape();
	this.shape_1445.graphics.lf(["#888D65","#889174"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_1445.setTransform(457.5,78.175);

	this.shape_1446 = new cjs.Shape();
	this.shape_1446.graphics.lf(["#888D65","#889174"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_1446.setTransform(412.875,58.825);

	this.shape_1447 = new cjs.Shape();
	this.shape_1447.graphics.lf(["#888D65","#889174"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_1447.setTransform(539.325,181.675);

	this.shape_1448 = new cjs.Shape();
	this.shape_1448.graphics.lf(["#888D65","#889174"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_1448.setTransform(534.05,135.7);

	this.shape_1449 = new cjs.Shape();
	this.shape_1449.graphics.lf(["#888D65","#889174"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_1449.setTransform(499.575,102.375);

	this.shape_1450 = new cjs.Shape();
	this.shape_1450.graphics.lf(["#888D65","#889174"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_1450.setTransform(273.8,-86.475);

	this.shape_1451 = new cjs.Shape();
	this.shape_1451.graphics.lf(["#888D65","#889174"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_1451.setTransform(205.1312,-32.65);

	this.shape_1452 = new cjs.Shape();
	this.shape_1452.graphics.lf(["#888D65","#889174"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_1452.setTransform(231.025,-0.325);

	this.shape_1453 = new cjs.Shape();
	this.shape_1453.graphics.lf(["#888D65","#889174"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_1453.setTransform(232.95,-65.4);

	this.shape_1454 = new cjs.Shape();
	this.shape_1454.graphics.lf(["#888D65","#889174"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_1454.setTransform(202.225,-123.35);

	this.shape_1455 = new cjs.Shape();
	this.shape_1455.graphics.lf(["#888D65","#889174"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_1455.setTransform(298.7901,-104.575);

	this.shape_1456 = new cjs.Shape();
	this.shape_1456.graphics.lf(["#888D65","#889174"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_1456.setTransform(250.45,-113.45);

	this.shape_1457 = new cjs.Shape();
	this.shape_1457.graphics.lf(["#888D65","#889174"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_1457.setTransform(67.475,-180.175);

	this.shape_1458 = new cjs.Shape();
	this.shape_1458.graphics.lf(["#888D65","#889174"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_1458.setTransform(154.35,-135.525);

	this.shape_1459 = new cjs.Shape();
	this.shape_1459.graphics.lf(["#888D65","#889174"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_1459.setTransform(108.425,-153.25);

	this.shape_1460 = new cjs.Shape();
	this.shape_1460.graphics.lf(["#888D65","#889174"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_1460.setTransform(32.725,-214.9);

	this.shape_1461 = new cjs.Shape();
	this.shape_1461.graphics.lf(["#888D65","#889174"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_1461.setTransform(-122.5,-6.825);

	this.shape_1462 = new cjs.Shape();
	this.shape_1462.graphics.lf(["#888D65","#889174"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_1462.setTransform(-144.525,-186.225);

	this.shape_1463 = new cjs.Shape();
	this.shape_1463.graphics.lf(["#888D65","#889174"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_1463.setTransform(-159.025,-28.975);

	this.shape_1464 = new cjs.Shape();
	this.shape_1464.graphics.lf(["#888D65","#889174"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_1464.setTransform(-200.9,-36.7925);

	this.shape_1465 = new cjs.Shape();
	this.shape_1465.graphics.lf(["#888D65","#889174"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_1465.setTransform(-243.525,-32.85);

	this.shape_1466 = new cjs.Shape();
	this.shape_1466.graphics.lf(["#888D65","#889174"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_1466.setTransform(-284.875,-21.325);

	this.shape_1467 = new cjs.Shape();
	this.shape_1467.graphics.lf(["#888D65","#889174"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_1467.setTransform(-266.575,-120.375);

	this.shape_1468 = new cjs.Shape();
	this.shape_1468.graphics.lf(["#888D65","#889174"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_1468.setTransform(-313.25,-110.575);

	this.shape_1469 = new cjs.Shape();
	this.shape_1469.graphics.lf(["#888D65","#889174"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_1469.setTransform(-219.775,-130.875);

	this.shape_1470 = new cjs.Shape();
	this.shape_1470.graphics.lf(["#888D65","#889174"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_1470.setTransform(-177.075,-151.575);

	this.shape_1471 = new cjs.Shape();
	this.shape_1471.graphics.lf(["#888D65","#889174"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_1471.setTransform(-37.725,-278.5196);

	this.shape_1472 = new cjs.Shape();
	this.shape_1472.graphics.lf(["#888D65","#889174"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_1472.setTransform(1.75,-253.225);

	this.shape_1473 = new cjs.Shape();
	this.shape_1473.graphics.lf(["#888D65","#889174"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_1473.setTransform(-114.5,-223.5);

	this.shape_1474 = new cjs.Shape();
	this.shape_1474.graphics.lf(["#888D65","#889174"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_1474.setTransform(-80.375,-257.35);

	this.shape_1475 = new cjs.Shape();
	this.shape_1475.graphics.lf(["#888D65","#889174"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_1475.setTransform(-328.05,-10.925);

	this.shape_1476 = new cjs.Shape();
	this.shape_1476.graphics.lf(["#888D65","#889174"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_1476.setTransform(-373,-12.325);

	this.shape_1477 = new cjs.Shape();
	this.shape_1477.graphics.lf(["#888D65","#889174"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_1477.setTransform(-358.325,-95.45);

	this.shape_1478 = new cjs.Shape();
	this.shape_1478.graphics.lf(["#888D65","#889174"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_1478.setTransform(-411.075,-32.2);

	this.shape_1479 = new cjs.Shape();
	this.shape_1479.graphics.lf(["#888D65","#889174"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_1479.setTransform(-398.975,-71.425);

	this.shape_1480 = new cjs.Shape();
	this.shape_1480.graphics.lf(["#7B9271","#7B967D"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_1480.setTransform(-510.625,132.625);

	this.shape_1481 = new cjs.Shape();
	this.shape_1481.graphics.lf(["#7B9271","#7B967D"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_1481.setTransform(-468.325,117.725);

	this.shape_1482 = new cjs.Shape();
	this.shape_1482.graphics.lf(["#7B9271","#7B967D"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_1482.setTransform(-425.825,103.1);

	this.shape_1483 = new cjs.Shape();
	this.shape_1483.graphics.lf(["#7B9271","#7B967D"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_1483.setTransform(-340.575,74.725);

	this.shape_1484 = new cjs.Shape();
	this.shape_1484.graphics.lf(["#7B9271","#7B967D"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_1484.setTransform(-383.3,88.725);

	this.shape_1485 = new cjs.Shape();
	this.shape_1485.graphics.lf(["#7B9271","#7B967D"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_1485.setTransform(-296.25,64.05);

	this.shape_1486 = new cjs.Shape();
	this.shape_1486.graphics.lf(["#7B9271","#7B967D"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_1486.setTransform(-251.075,56.95);

	this.shape_1487 = new cjs.Shape();
	this.shape_1487.graphics.lf(["#7B9271","#7B967D"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_1487.setTransform(-205.675,50.875);

	this.shape_1488 = new cjs.Shape();
	this.shape_1488.graphics.lf(["#7B9271","#7B967D"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_1488.setTransform(-160.5,43.575);

	this.shape_1489 = new cjs.Shape();
	this.shape_1489.graphics.lf(["#7B9271","#7B967D"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_1489.setTransform(-117.75,28.75);

	this.shape_1490 = new cjs.Shape();
	this.shape_1490.graphics.lf(["#7B9271","#7B967D"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_1490.setTransform(273.675,16.25);

	this.shape_1491 = new cjs.Shape();
	this.shape_1491.graphics.lf(["#7B9271","#7B967D"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_1491.setTransform(320.475,28.6);

	this.shape_1492 = new cjs.Shape();
	this.shape_1492.graphics.lf(["#7B9271","#7B967D"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_1492.setTransform(367,42.55);

	this.shape_1493 = new cjs.Shape();
	this.shape_1493.graphics.lf(["#7B9271","#7B967D"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_1493.setTransform(457.5,78.175);

	this.shape_1494 = new cjs.Shape();
	this.shape_1494.graphics.lf(["#7B9271","#7B967D"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_1494.setTransform(412.875,58.825);

	this.shape_1495 = new cjs.Shape();
	this.shape_1495.graphics.lf(["#7B9271","#7B967D"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_1495.setTransform(539.325,181.675);

	this.shape_1496 = new cjs.Shape();
	this.shape_1496.graphics.lf(["#7B9271","#7B967D"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_1496.setTransform(534.05,135.7);

	this.shape_1497 = new cjs.Shape();
	this.shape_1497.graphics.lf(["#7B9271","#7B967D"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_1497.setTransform(499.575,102.375);

	this.shape_1498 = new cjs.Shape();
	this.shape_1498.graphics.lf(["#7B9271","#7B967D"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_1498.setTransform(273.8,-86.475);

	this.shape_1499 = new cjs.Shape();
	this.shape_1499.graphics.lf(["#7B9271","#7B967D"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_1499.setTransform(205.1312,-32.65);

	this.shape_1500 = new cjs.Shape();
	this.shape_1500.graphics.lf(["#7B9271","#7B967D"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_1500.setTransform(231.025,-0.325);

	this.shape_1501 = new cjs.Shape();
	this.shape_1501.graphics.lf(["#7B9271","#7B967D"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_1501.setTransform(232.95,-65.4);

	this.shape_1502 = new cjs.Shape();
	this.shape_1502.graphics.lf(["#7B9271","#7B967D"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_1502.setTransform(202.225,-123.35);

	this.shape_1503 = new cjs.Shape();
	this.shape_1503.graphics.lf(["#7B9271","#7B967D"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_1503.setTransform(298.7901,-104.575);

	this.shape_1504 = new cjs.Shape();
	this.shape_1504.graphics.lf(["#7B9271","#7B967D"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_1504.setTransform(250.45,-113.45);

	this.shape_1505 = new cjs.Shape();
	this.shape_1505.graphics.lf(["#7B9271","#7B967D"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_1505.setTransform(67.475,-180.175);

	this.shape_1506 = new cjs.Shape();
	this.shape_1506.graphics.lf(["#7B9271","#7B967D"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_1506.setTransform(154.35,-135.525);

	this.shape_1507 = new cjs.Shape();
	this.shape_1507.graphics.lf(["#7B9271","#7B967D"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_1507.setTransform(108.425,-153.25);

	this.shape_1508 = new cjs.Shape();
	this.shape_1508.graphics.lf(["#7B9271","#7B967D"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_1508.setTransform(32.725,-214.9);

	this.shape_1509 = new cjs.Shape();
	this.shape_1509.graphics.lf(["#7B9271","#7B967D"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_1509.setTransform(-122.5,-6.825);

	this.shape_1510 = new cjs.Shape();
	this.shape_1510.graphics.lf(["#7B9271","#7B967D"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_1510.setTransform(-144.525,-186.225);

	this.shape_1511 = new cjs.Shape();
	this.shape_1511.graphics.lf(["#7B9271","#7B967D"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_1511.setTransform(-159.025,-28.975);

	this.shape_1512 = new cjs.Shape();
	this.shape_1512.graphics.lf(["#7B9271","#7B967D"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_1512.setTransform(-200.9,-36.7925);

	this.shape_1513 = new cjs.Shape();
	this.shape_1513.graphics.lf(["#7B9271","#7B967D"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_1513.setTransform(-243.525,-32.85);

	this.shape_1514 = new cjs.Shape();
	this.shape_1514.graphics.lf(["#7B9271","#7B967D"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_1514.setTransform(-284.875,-21.325);

	this.shape_1515 = new cjs.Shape();
	this.shape_1515.graphics.lf(["#7B9271","#7B967D"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_1515.setTransform(-266.575,-120.375);

	this.shape_1516 = new cjs.Shape();
	this.shape_1516.graphics.lf(["#7B9271","#7B967D"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_1516.setTransform(-313.25,-110.575);

	this.shape_1517 = new cjs.Shape();
	this.shape_1517.graphics.lf(["#7B9271","#7B967D"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_1517.setTransform(-219.775,-130.875);

	this.shape_1518 = new cjs.Shape();
	this.shape_1518.graphics.lf(["#7B9271","#7B967D"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_1518.setTransform(-177.075,-151.575);

	this.shape_1519 = new cjs.Shape();
	this.shape_1519.graphics.lf(["#7B9271","#7B967D"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_1519.setTransform(-37.725,-278.5196);

	this.shape_1520 = new cjs.Shape();
	this.shape_1520.graphics.lf(["#7B9271","#7B967D"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_1520.setTransform(1.75,-253.225);

	this.shape_1521 = new cjs.Shape();
	this.shape_1521.graphics.lf(["#7B9271","#7B967D"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_1521.setTransform(-114.5,-223.5);

	this.shape_1522 = new cjs.Shape();
	this.shape_1522.graphics.lf(["#7B9271","#7B967D"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_1522.setTransform(-80.375,-257.35);

	this.shape_1523 = new cjs.Shape();
	this.shape_1523.graphics.lf(["#7B9271","#7B967D"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_1523.setTransform(-328.05,-10.925);

	this.shape_1524 = new cjs.Shape();
	this.shape_1524.graphics.lf(["#7B9271","#7B967D"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_1524.setTransform(-373,-12.325);

	this.shape_1525 = new cjs.Shape();
	this.shape_1525.graphics.lf(["#7B9271","#7B967D"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_1525.setTransform(-358.325,-95.45);

	this.shape_1526 = new cjs.Shape();
	this.shape_1526.graphics.lf(["#7B9271","#7B967D"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_1526.setTransform(-411.075,-32.2);

	this.shape_1527 = new cjs.Shape();
	this.shape_1527.graphics.lf(["#7B9271","#7B967D"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_1527.setTransform(-398.975,-71.425);

	this.shape_1528 = new cjs.Shape();
	this.shape_1528.graphics.lf(["#6D977C","#6D9A86"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_1528.setTransform(-510.625,132.625);

	this.shape_1529 = new cjs.Shape();
	this.shape_1529.graphics.lf(["#6D977C","#6D9A86"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_1529.setTransform(-468.325,117.725);

	this.shape_1530 = new cjs.Shape();
	this.shape_1530.graphics.lf(["#6D977C","#6D9A86"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_1530.setTransform(-425.825,103.1);

	this.shape_1531 = new cjs.Shape();
	this.shape_1531.graphics.lf(["#6D977C","#6D9A86"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_1531.setTransform(-340.575,74.725);

	this.shape_1532 = new cjs.Shape();
	this.shape_1532.graphics.lf(["#6D977C","#6D9A86"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_1532.setTransform(-383.3,88.725);

	this.shape_1533 = new cjs.Shape();
	this.shape_1533.graphics.lf(["#6D977C","#6D9A86"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_1533.setTransform(-296.25,64.05);

	this.shape_1534 = new cjs.Shape();
	this.shape_1534.graphics.lf(["#6D977C","#6D9A86"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_1534.setTransform(-251.075,56.95);

	this.shape_1535 = new cjs.Shape();
	this.shape_1535.graphics.lf(["#6D977C","#6D9A86"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_1535.setTransform(-205.675,50.875);

	this.shape_1536 = new cjs.Shape();
	this.shape_1536.graphics.lf(["#6D977C","#6D9A86"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_1536.setTransform(-160.5,43.575);

	this.shape_1537 = new cjs.Shape();
	this.shape_1537.graphics.lf(["#6D977C","#6D9A86"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_1537.setTransform(-117.75,28.75);

	this.shape_1538 = new cjs.Shape();
	this.shape_1538.graphics.lf(["#6D977C","#6D9A86"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_1538.setTransform(273.675,16.25);

	this.shape_1539 = new cjs.Shape();
	this.shape_1539.graphics.lf(["#6D977C","#6D9A86"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_1539.setTransform(320.475,28.6);

	this.shape_1540 = new cjs.Shape();
	this.shape_1540.graphics.lf(["#6D977C","#6D9A86"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_1540.setTransform(367,42.55);

	this.shape_1541 = new cjs.Shape();
	this.shape_1541.graphics.lf(["#6D977C","#6D9A86"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_1541.setTransform(457.5,78.175);

	this.shape_1542 = new cjs.Shape();
	this.shape_1542.graphics.lf(["#6D977C","#6D9A86"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_1542.setTransform(412.875,58.825);

	this.shape_1543 = new cjs.Shape();
	this.shape_1543.graphics.lf(["#6D977C","#6D9A86"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_1543.setTransform(539.325,181.675);

	this.shape_1544 = new cjs.Shape();
	this.shape_1544.graphics.lf(["#6D977C","#6D9A86"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_1544.setTransform(534.05,135.7);

	this.shape_1545 = new cjs.Shape();
	this.shape_1545.graphics.lf(["#6D977C","#6D9A86"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_1545.setTransform(499.575,102.375);

	this.shape_1546 = new cjs.Shape();
	this.shape_1546.graphics.lf(["#6D977C","#6D9A86"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_1546.setTransform(273.8,-86.475);

	this.shape_1547 = new cjs.Shape();
	this.shape_1547.graphics.lf(["#6D977C","#6D9A86"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_1547.setTransform(205.1312,-32.65);

	this.shape_1548 = new cjs.Shape();
	this.shape_1548.graphics.lf(["#6D977C","#6D9A86"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_1548.setTransform(231.025,-0.325);

	this.shape_1549 = new cjs.Shape();
	this.shape_1549.graphics.lf(["#6D977C","#6D9A86"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_1549.setTransform(232.95,-65.4);

	this.shape_1550 = new cjs.Shape();
	this.shape_1550.graphics.lf(["#6D977C","#6D9A86"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_1550.setTransform(202.225,-123.35);

	this.shape_1551 = new cjs.Shape();
	this.shape_1551.graphics.lf(["#6D977C","#6D9A86"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_1551.setTransform(298.7901,-104.575);

	this.shape_1552 = new cjs.Shape();
	this.shape_1552.graphics.lf(["#6D977C","#6D9A86"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_1552.setTransform(250.45,-113.45);

	this.shape_1553 = new cjs.Shape();
	this.shape_1553.graphics.lf(["#6D977C","#6D9A86"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_1553.setTransform(67.475,-180.175);

	this.shape_1554 = new cjs.Shape();
	this.shape_1554.graphics.lf(["#6D977C","#6D9A86"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_1554.setTransform(154.35,-135.525);

	this.shape_1555 = new cjs.Shape();
	this.shape_1555.graphics.lf(["#6D977C","#6D9A86"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_1555.setTransform(108.425,-153.25);

	this.shape_1556 = new cjs.Shape();
	this.shape_1556.graphics.lf(["#6D977C","#6D9A86"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_1556.setTransform(32.725,-214.9);

	this.shape_1557 = new cjs.Shape();
	this.shape_1557.graphics.lf(["#6D977C","#6D9A86"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_1557.setTransform(-122.5,-6.825);

	this.shape_1558 = new cjs.Shape();
	this.shape_1558.graphics.lf(["#6D977C","#6D9A86"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_1558.setTransform(-144.525,-186.225);

	this.shape_1559 = new cjs.Shape();
	this.shape_1559.graphics.lf(["#6D977C","#6D9A86"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_1559.setTransform(-159.025,-28.975);

	this.shape_1560 = new cjs.Shape();
	this.shape_1560.graphics.lf(["#6D977C","#6D9A86"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_1560.setTransform(-200.9,-36.7925);

	this.shape_1561 = new cjs.Shape();
	this.shape_1561.graphics.lf(["#6D977C","#6D9A86"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_1561.setTransform(-243.525,-32.85);

	this.shape_1562 = new cjs.Shape();
	this.shape_1562.graphics.lf(["#6D977C","#6D9A86"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_1562.setTransform(-284.875,-21.325);

	this.shape_1563 = new cjs.Shape();
	this.shape_1563.graphics.lf(["#6D977C","#6D9A86"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_1563.setTransform(-266.575,-120.375);

	this.shape_1564 = new cjs.Shape();
	this.shape_1564.graphics.lf(["#6D977C","#6D9A86"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_1564.setTransform(-313.25,-110.575);

	this.shape_1565 = new cjs.Shape();
	this.shape_1565.graphics.lf(["#6D977C","#6D9A86"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_1565.setTransform(-219.775,-130.875);

	this.shape_1566 = new cjs.Shape();
	this.shape_1566.graphics.lf(["#6D977C","#6D9A86"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_1566.setTransform(-177.075,-151.575);

	this.shape_1567 = new cjs.Shape();
	this.shape_1567.graphics.lf(["#6D977C","#6D9A86"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_1567.setTransform(-37.725,-278.5196);

	this.shape_1568 = new cjs.Shape();
	this.shape_1568.graphics.lf(["#6D977C","#6D9A86"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_1568.setTransform(1.75,-253.225);

	this.shape_1569 = new cjs.Shape();
	this.shape_1569.graphics.lf(["#6D977C","#6D9A86"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_1569.setTransform(-114.5,-223.5);

	this.shape_1570 = new cjs.Shape();
	this.shape_1570.graphics.lf(["#6D977C","#6D9A86"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_1570.setTransform(-80.375,-257.35);

	this.shape_1571 = new cjs.Shape();
	this.shape_1571.graphics.lf(["#6D977C","#6D9A86"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_1571.setTransform(-328.05,-10.925);

	this.shape_1572 = new cjs.Shape();
	this.shape_1572.graphics.lf(["#6D977C","#6D9A86"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_1572.setTransform(-373,-12.325);

	this.shape_1573 = new cjs.Shape();
	this.shape_1573.graphics.lf(["#6D977C","#6D9A86"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_1573.setTransform(-358.325,-95.45);

	this.shape_1574 = new cjs.Shape();
	this.shape_1574.graphics.lf(["#6D977C","#6D9A86"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_1574.setTransform(-411.075,-32.2);

	this.shape_1575 = new cjs.Shape();
	this.shape_1575.graphics.lf(["#6D977C","#6D9A86"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_1575.setTransform(-398.975,-71.425);

	this.shape_1576 = new cjs.Shape();
	this.shape_1576.graphics.lf(["#609C87","#609F8F"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_1576.setTransform(-510.625,132.625);

	this.shape_1577 = new cjs.Shape();
	this.shape_1577.graphics.lf(["#609C87","#609F8F"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_1577.setTransform(-468.325,117.725);

	this.shape_1578 = new cjs.Shape();
	this.shape_1578.graphics.lf(["#609C87","#609F8F"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_1578.setTransform(-425.825,103.1);

	this.shape_1579 = new cjs.Shape();
	this.shape_1579.graphics.lf(["#609C87","#609F8F"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_1579.setTransform(-340.575,74.725);

	this.shape_1580 = new cjs.Shape();
	this.shape_1580.graphics.lf(["#609C87","#609F8F"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_1580.setTransform(-383.3,88.725);

	this.shape_1581 = new cjs.Shape();
	this.shape_1581.graphics.lf(["#609C87","#609F8F"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_1581.setTransform(-296.25,64.05);

	this.shape_1582 = new cjs.Shape();
	this.shape_1582.graphics.lf(["#609C87","#609F8F"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_1582.setTransform(-251.075,56.95);

	this.shape_1583 = new cjs.Shape();
	this.shape_1583.graphics.lf(["#609C87","#609F8F"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_1583.setTransform(-205.675,50.875);

	this.shape_1584 = new cjs.Shape();
	this.shape_1584.graphics.lf(["#609C87","#609F8F"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_1584.setTransform(-160.5,43.575);

	this.shape_1585 = new cjs.Shape();
	this.shape_1585.graphics.lf(["#609C87","#609F8F"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_1585.setTransform(-117.75,28.75);

	this.shape_1586 = new cjs.Shape();
	this.shape_1586.graphics.lf(["#609C87","#609F8F"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_1586.setTransform(273.675,16.25);

	this.shape_1587 = new cjs.Shape();
	this.shape_1587.graphics.lf(["#609C87","#609F8F"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_1587.setTransform(320.475,28.6);

	this.shape_1588 = new cjs.Shape();
	this.shape_1588.graphics.lf(["#609C87","#609F8F"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_1588.setTransform(367,42.55);

	this.shape_1589 = new cjs.Shape();
	this.shape_1589.graphics.lf(["#609C87","#609F8F"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_1589.setTransform(457.5,78.175);

	this.shape_1590 = new cjs.Shape();
	this.shape_1590.graphics.lf(["#609C87","#609F8F"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_1590.setTransform(412.875,58.825);

	this.shape_1591 = new cjs.Shape();
	this.shape_1591.graphics.lf(["#609C87","#609F8F"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_1591.setTransform(539.325,181.675);

	this.shape_1592 = new cjs.Shape();
	this.shape_1592.graphics.lf(["#609C87","#609F8F"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_1592.setTransform(534.05,135.7);

	this.shape_1593 = new cjs.Shape();
	this.shape_1593.graphics.lf(["#609C87","#609F8F"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_1593.setTransform(499.575,102.375);

	this.shape_1594 = new cjs.Shape();
	this.shape_1594.graphics.lf(["#609C87","#609F8F"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_1594.setTransform(273.8,-86.475);

	this.shape_1595 = new cjs.Shape();
	this.shape_1595.graphics.lf(["#609C87","#609F8F"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_1595.setTransform(205.1312,-32.65);

	this.shape_1596 = new cjs.Shape();
	this.shape_1596.graphics.lf(["#609C87","#609F8F"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_1596.setTransform(231.025,-0.325);

	this.shape_1597 = new cjs.Shape();
	this.shape_1597.graphics.lf(["#609C87","#609F8F"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_1597.setTransform(232.95,-65.4);

	this.shape_1598 = new cjs.Shape();
	this.shape_1598.graphics.lf(["#609C87","#609F8F"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_1598.setTransform(202.225,-123.35);

	this.shape_1599 = new cjs.Shape();
	this.shape_1599.graphics.lf(["#609C87","#609F8F"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_1599.setTransform(298.7901,-104.575);

	this.shape_1600 = new cjs.Shape();
	this.shape_1600.graphics.lf(["#609C87","#609F8F"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_1600.setTransform(250.45,-113.45);

	this.shape_1601 = new cjs.Shape();
	this.shape_1601.graphics.lf(["#609C87","#609F8F"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_1601.setTransform(67.475,-180.175);

	this.shape_1602 = new cjs.Shape();
	this.shape_1602.graphics.lf(["#609C87","#609F8F"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_1602.setTransform(154.35,-135.525);

	this.shape_1603 = new cjs.Shape();
	this.shape_1603.graphics.lf(["#609C87","#609F8F"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_1603.setTransform(108.425,-153.25);

	this.shape_1604 = new cjs.Shape();
	this.shape_1604.graphics.lf(["#609C87","#609F8F"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_1604.setTransform(32.725,-214.9);

	this.shape_1605 = new cjs.Shape();
	this.shape_1605.graphics.lf(["#609C87","#609F8F"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_1605.setTransform(-122.5,-6.825);

	this.shape_1606 = new cjs.Shape();
	this.shape_1606.graphics.lf(["#609C87","#609F8F"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_1606.setTransform(-144.525,-186.225);

	this.shape_1607 = new cjs.Shape();
	this.shape_1607.graphics.lf(["#609C87","#609F8F"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_1607.setTransform(-159.025,-28.975);

	this.shape_1608 = new cjs.Shape();
	this.shape_1608.graphics.lf(["#609C87","#609F8F"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_1608.setTransform(-200.9,-36.7925);

	this.shape_1609 = new cjs.Shape();
	this.shape_1609.graphics.lf(["#609C87","#609F8F"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_1609.setTransform(-243.525,-32.85);

	this.shape_1610 = new cjs.Shape();
	this.shape_1610.graphics.lf(["#609C87","#609F8F"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_1610.setTransform(-284.875,-21.325);

	this.shape_1611 = new cjs.Shape();
	this.shape_1611.graphics.lf(["#609C87","#609F8F"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_1611.setTransform(-266.575,-120.375);

	this.shape_1612 = new cjs.Shape();
	this.shape_1612.graphics.lf(["#609C87","#609F8F"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_1612.setTransform(-313.25,-110.575);

	this.shape_1613 = new cjs.Shape();
	this.shape_1613.graphics.lf(["#609C87","#609F8F"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_1613.setTransform(-219.775,-130.875);

	this.shape_1614 = new cjs.Shape();
	this.shape_1614.graphics.lf(["#609C87","#609F8F"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_1614.setTransform(-177.075,-151.575);

	this.shape_1615 = new cjs.Shape();
	this.shape_1615.graphics.lf(["#609C87","#609F8F"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_1615.setTransform(-37.725,-278.5196);

	this.shape_1616 = new cjs.Shape();
	this.shape_1616.graphics.lf(["#609C87","#609F8F"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_1616.setTransform(1.75,-253.225);

	this.shape_1617 = new cjs.Shape();
	this.shape_1617.graphics.lf(["#609C87","#609F8F"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_1617.setTransform(-114.5,-223.5);

	this.shape_1618 = new cjs.Shape();
	this.shape_1618.graphics.lf(["#609C87","#609F8F"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_1618.setTransform(-80.375,-257.35);

	this.shape_1619 = new cjs.Shape();
	this.shape_1619.graphics.lf(["#609C87","#609F8F"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_1619.setTransform(-328.05,-10.925);

	this.shape_1620 = new cjs.Shape();
	this.shape_1620.graphics.lf(["#609C87","#609F8F"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_1620.setTransform(-373,-12.325);

	this.shape_1621 = new cjs.Shape();
	this.shape_1621.graphics.lf(["#609C87","#609F8F"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_1621.setTransform(-358.325,-95.45);

	this.shape_1622 = new cjs.Shape();
	this.shape_1622.graphics.lf(["#609C87","#609F8F"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_1622.setTransform(-411.075,-32.2);

	this.shape_1623 = new cjs.Shape();
	this.shape_1623.graphics.lf(["#609C87","#609F8F"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_1623.setTransform(-398.975,-71.425);

	this.shape_1624 = new cjs.Shape();
	this.shape_1624.graphics.lf(["#53A192","#53A398"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_1624.setTransform(273.675,16.25);

	this.shape_1625 = new cjs.Shape();
	this.shape_1625.graphics.lf(["#53A192","#53A398"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_1625.setTransform(320.475,28.6);

	this.shape_1626 = new cjs.Shape();
	this.shape_1626.graphics.lf(["#53A192","#53A398"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_1626.setTransform(367,42.55);

	this.shape_1627 = new cjs.Shape();
	this.shape_1627.graphics.lf(["#53A192","#53A398"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_1627.setTransform(457.5,78.175);

	this.shape_1628 = new cjs.Shape();
	this.shape_1628.graphics.lf(["#53A192","#53A398"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_1628.setTransform(412.875,58.825);

	this.shape_1629 = new cjs.Shape();
	this.shape_1629.graphics.lf(["#53A192","#53A398"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_1629.setTransform(539.325,181.675);

	this.shape_1630 = new cjs.Shape();
	this.shape_1630.graphics.lf(["#53A192","#53A398"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_1630.setTransform(534.05,135.7);

	this.shape_1631 = new cjs.Shape();
	this.shape_1631.graphics.lf(["#53A192","#53A398"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_1631.setTransform(499.575,102.375);

	this.shape_1632 = new cjs.Shape();
	this.shape_1632.graphics.lf(["#53A192","#53A398"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_1632.setTransform(273.8,-86.475);

	this.shape_1633 = new cjs.Shape();
	this.shape_1633.graphics.lf(["#53A192","#53A398"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_1633.setTransform(205.1312,-32.65);

	this.shape_1634 = new cjs.Shape();
	this.shape_1634.graphics.lf(["#53A192","#53A398"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_1634.setTransform(231.025,-0.325);

	this.shape_1635 = new cjs.Shape();
	this.shape_1635.graphics.lf(["#53A192","#53A398"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_1635.setTransform(232.95,-65.4);

	this.shape_1636 = new cjs.Shape();
	this.shape_1636.graphics.lf(["#53A192","#53A398"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_1636.setTransform(202.225,-123.35);

	this.shape_1637 = new cjs.Shape();
	this.shape_1637.graphics.lf(["#53A192","#53A398"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_1637.setTransform(298.7901,-104.575);

	this.shape_1638 = new cjs.Shape();
	this.shape_1638.graphics.lf(["#53A192","#53A398"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_1638.setTransform(250.45,-113.45);

	this.shape_1639 = new cjs.Shape();
	this.shape_1639.graphics.lf(["#53A192","#53A398"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_1639.setTransform(67.475,-180.175);

	this.shape_1640 = new cjs.Shape();
	this.shape_1640.graphics.lf(["#53A192","#53A398"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_1640.setTransform(154.35,-135.525);

	this.shape_1641 = new cjs.Shape();
	this.shape_1641.graphics.lf(["#53A192","#53A398"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_1641.setTransform(108.425,-153.25);

	this.shape_1642 = new cjs.Shape();
	this.shape_1642.graphics.lf(["#53A192","#53A398"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_1642.setTransform(32.725,-214.9);

	this.shape_1643 = new cjs.Shape();
	this.shape_1643.graphics.lf(["#53A192","#53A398"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_1643.setTransform(1.75,-253.225);

	this.shape_1644 = new cjs.Shape();
	this.shape_1644.graphics.lf(["#46A79E","#46A8A2"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_1644.setTransform(-510.625,132.625);

	this.shape_1645 = new cjs.Shape();
	this.shape_1645.graphics.lf(["#46A79E","#46A8A2"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_1645.setTransform(-468.325,117.725);

	this.shape_1646 = new cjs.Shape();
	this.shape_1646.graphics.lf(["#46A79E","#46A8A2"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_1646.setTransform(-425.825,103.1);

	this.shape_1647 = new cjs.Shape();
	this.shape_1647.graphics.lf(["#46A79E","#46A8A2"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_1647.setTransform(-340.575,74.725);

	this.shape_1648 = new cjs.Shape();
	this.shape_1648.graphics.lf(["#46A79E","#46A8A2"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_1648.setTransform(-383.3,88.725);

	this.shape_1649 = new cjs.Shape();
	this.shape_1649.graphics.lf(["#46A79E","#46A8A2"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_1649.setTransform(-296.25,64.05);

	this.shape_1650 = new cjs.Shape();
	this.shape_1650.graphics.lf(["#46A79E","#46A8A2"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_1650.setTransform(-251.075,56.95);

	this.shape_1651 = new cjs.Shape();
	this.shape_1651.graphics.lf(["#46A79E","#46A8A2"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_1651.setTransform(-205.675,50.875);

	this.shape_1652 = new cjs.Shape();
	this.shape_1652.graphics.lf(["#46A79E","#46A8A2"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_1652.setTransform(-160.5,43.575);

	this.shape_1653 = new cjs.Shape();
	this.shape_1653.graphics.lf(["#46A79E","#46A8A2"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_1653.setTransform(-117.75,28.75);

	this.shape_1654 = new cjs.Shape();
	this.shape_1654.graphics.lf(["#46A79E","#46A8A2"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_1654.setTransform(273.675,16.25);

	this.shape_1655 = new cjs.Shape();
	this.shape_1655.graphics.lf(["#46A79E","#46A8A2"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_1655.setTransform(320.475,28.6);

	this.shape_1656 = new cjs.Shape();
	this.shape_1656.graphics.lf(["#46A79E","#46A8A2"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_1656.setTransform(367,42.55);

	this.shape_1657 = new cjs.Shape();
	this.shape_1657.graphics.lf(["#46A79E","#46A8A2"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_1657.setTransform(457.5,78.175);

	this.shape_1658 = new cjs.Shape();
	this.shape_1658.graphics.lf(["#46A79E","#46A8A2"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_1658.setTransform(412.875,58.825);

	this.shape_1659 = new cjs.Shape();
	this.shape_1659.graphics.lf(["#46A79E","#46A8A2"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_1659.setTransform(539.325,181.675);

	this.shape_1660 = new cjs.Shape();
	this.shape_1660.graphics.lf(["#46A79E","#46A8A2"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_1660.setTransform(534.05,135.7);

	this.shape_1661 = new cjs.Shape();
	this.shape_1661.graphics.lf(["#46A79E","#46A8A2"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_1661.setTransform(499.575,102.375);

	this.shape_1662 = new cjs.Shape();
	this.shape_1662.graphics.lf(["#46A79E","#46A8A2"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_1662.setTransform(273.8,-86.475);

	this.shape_1663 = new cjs.Shape();
	this.shape_1663.graphics.lf(["#46A79E","#46A8A2"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_1663.setTransform(205.1312,-32.65);

	this.shape_1664 = new cjs.Shape();
	this.shape_1664.graphics.lf(["#46A79E","#46A8A2"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_1664.setTransform(231.025,-0.325);

	this.shape_1665 = new cjs.Shape();
	this.shape_1665.graphics.lf(["#46A79E","#46A8A2"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_1665.setTransform(232.95,-65.4);

	this.shape_1666 = new cjs.Shape();
	this.shape_1666.graphics.lf(["#46A79E","#46A8A2"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_1666.setTransform(202.225,-123.35);

	this.shape_1667 = new cjs.Shape();
	this.shape_1667.graphics.lf(["#46A79E","#46A8A2"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_1667.setTransform(298.7901,-104.575);

	this.shape_1668 = new cjs.Shape();
	this.shape_1668.graphics.lf(["#46A79E","#46A8A2"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_1668.setTransform(250.45,-113.45);

	this.shape_1669 = new cjs.Shape();
	this.shape_1669.graphics.lf(["#46A79E","#46A8A2"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_1669.setTransform(67.475,-180.175);

	this.shape_1670 = new cjs.Shape();
	this.shape_1670.graphics.lf(["#46A79E","#46A8A2"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_1670.setTransform(154.35,-135.525);

	this.shape_1671 = new cjs.Shape();
	this.shape_1671.graphics.lf(["#46A79E","#46A8A2"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_1671.setTransform(108.425,-153.25);

	this.shape_1672 = new cjs.Shape();
	this.shape_1672.graphics.lf(["#46A79E","#46A8A2"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_1672.setTransform(32.725,-214.9);

	this.shape_1673 = new cjs.Shape();
	this.shape_1673.graphics.lf(["#46A79E","#46A8A2"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_1673.setTransform(-122.5,-6.825);

	this.shape_1674 = new cjs.Shape();
	this.shape_1674.graphics.lf(["#46A79E","#46A8A2"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_1674.setTransform(-144.525,-186.225);

	this.shape_1675 = new cjs.Shape();
	this.shape_1675.graphics.lf(["#46A79E","#46A8A2"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_1675.setTransform(-159.025,-28.975);

	this.shape_1676 = new cjs.Shape();
	this.shape_1676.graphics.lf(["#46A79E","#46A8A2"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_1676.setTransform(-200.9,-36.7925);

	this.shape_1677 = new cjs.Shape();
	this.shape_1677.graphics.lf(["#46A79E","#46A8A2"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_1677.setTransform(-243.525,-32.85);

	this.shape_1678 = new cjs.Shape();
	this.shape_1678.graphics.lf(["#46A79E","#46A8A2"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_1678.setTransform(-284.875,-21.325);

	this.shape_1679 = new cjs.Shape();
	this.shape_1679.graphics.lf(["#46A79E","#46A8A2"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_1679.setTransform(-266.575,-120.375);

	this.shape_1680 = new cjs.Shape();
	this.shape_1680.graphics.lf(["#46A79E","#46A8A2"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_1680.setTransform(-313.25,-110.575);

	this.shape_1681 = new cjs.Shape();
	this.shape_1681.graphics.lf(["#46A79E","#46A8A2"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_1681.setTransform(-219.775,-130.875);

	this.shape_1682 = new cjs.Shape();
	this.shape_1682.graphics.lf(["#46A79E","#46A8A2"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_1682.setTransform(-177.075,-151.575);

	this.shape_1683 = new cjs.Shape();
	this.shape_1683.graphics.lf(["#46A79E","#46A8A2"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_1683.setTransform(-37.725,-278.5196);

	this.shape_1684 = new cjs.Shape();
	this.shape_1684.graphics.lf(["#46A79E","#46A8A2"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_1684.setTransform(1.75,-253.225);

	this.shape_1685 = new cjs.Shape();
	this.shape_1685.graphics.lf(["#46A79E","#46A8A2"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_1685.setTransform(-114.5,-223.5);

	this.shape_1686 = new cjs.Shape();
	this.shape_1686.graphics.lf(["#46A79E","#46A8A2"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_1686.setTransform(-80.375,-257.35);

	this.shape_1687 = new cjs.Shape();
	this.shape_1687.graphics.lf(["#46A79E","#46A8A2"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_1687.setTransform(-328.05,-10.925);

	this.shape_1688 = new cjs.Shape();
	this.shape_1688.graphics.lf(["#46A79E","#46A8A2"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_1688.setTransform(-373,-12.325);

	this.shape_1689 = new cjs.Shape();
	this.shape_1689.graphics.lf(["#46A79E","#46A8A2"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_1689.setTransform(-358.325,-95.45);

	this.shape_1690 = new cjs.Shape();
	this.shape_1690.graphics.lf(["#46A79E","#46A8A2"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_1690.setTransform(-411.075,-32.2);

	this.shape_1691 = new cjs.Shape();
	this.shape_1691.graphics.lf(["#46A79E","#46A8A2"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_1691.setTransform(-398.975,-71.425);

	this.shape_1692 = new cjs.Shape();
	this.shape_1692.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_1692.setTransform(-510.625,132.625);

	this.shape_1693 = new cjs.Shape();
	this.shape_1693.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_1693.setTransform(-468.325,117.725);

	this.shape_1694 = new cjs.Shape();
	this.shape_1694.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_1694.setTransform(-425.825,103.1);

	this.shape_1695 = new cjs.Shape();
	this.shape_1695.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_1695.setTransform(-340.575,74.725);

	this.shape_1696 = new cjs.Shape();
	this.shape_1696.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_1696.setTransform(-383.3,88.725);

	this.shape_1697 = new cjs.Shape();
	this.shape_1697.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_1697.setTransform(-296.25,64.05);

	this.shape_1698 = new cjs.Shape();
	this.shape_1698.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_1698.setTransform(-251.075,56.95);

	this.shape_1699 = new cjs.Shape();
	this.shape_1699.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_1699.setTransform(-205.675,50.875);

	this.shape_1700 = new cjs.Shape();
	this.shape_1700.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_1700.setTransform(-160.5,43.575);

	this.shape_1701 = new cjs.Shape();
	this.shape_1701.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_1701.setTransform(-117.75,28.75);

	this.shape_1702 = new cjs.Shape();
	this.shape_1702.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_1702.setTransform(273.675,16.25);

	this.shape_1703 = new cjs.Shape();
	this.shape_1703.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_1703.setTransform(320.475,28.6);

	this.shape_1704 = new cjs.Shape();
	this.shape_1704.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_1704.setTransform(367,42.55);

	this.shape_1705 = new cjs.Shape();
	this.shape_1705.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_1705.setTransform(457.5,78.175);

	this.shape_1706 = new cjs.Shape();
	this.shape_1706.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_1706.setTransform(412.875,58.825);

	this.shape_1707 = new cjs.Shape();
	this.shape_1707.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_1707.setTransform(539.325,181.675);

	this.shape_1708 = new cjs.Shape();
	this.shape_1708.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_1708.setTransform(534.05,135.7);

	this.shape_1709 = new cjs.Shape();
	this.shape_1709.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_1709.setTransform(499.575,102.375);

	this.shape_1710 = new cjs.Shape();
	this.shape_1710.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_1710.setTransform(273.8,-86.475);

	this.shape_1711 = new cjs.Shape();
	this.shape_1711.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_1711.setTransform(205.1312,-32.65);

	this.shape_1712 = new cjs.Shape();
	this.shape_1712.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_1712.setTransform(231.025,-0.325);

	this.shape_1713 = new cjs.Shape();
	this.shape_1713.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_1713.setTransform(232.95,-65.4);

	this.shape_1714 = new cjs.Shape();
	this.shape_1714.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_1714.setTransform(202.225,-123.35);

	this.shape_1715 = new cjs.Shape();
	this.shape_1715.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_1715.setTransform(298.7901,-104.575);

	this.shape_1716 = new cjs.Shape();
	this.shape_1716.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_1716.setTransform(250.45,-113.45);

	this.shape_1717 = new cjs.Shape();
	this.shape_1717.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_1717.setTransform(67.475,-180.175);

	this.shape_1718 = new cjs.Shape();
	this.shape_1718.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_1718.setTransform(154.35,-135.525);

	this.shape_1719 = new cjs.Shape();
	this.shape_1719.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_1719.setTransform(108.425,-153.25);

	this.shape_1720 = new cjs.Shape();
	this.shape_1720.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_1720.setTransform(32.725,-214.9);

	this.shape_1721 = new cjs.Shape();
	this.shape_1721.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_1721.setTransform(-122.5,-6.825);

	this.shape_1722 = new cjs.Shape();
	this.shape_1722.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_1722.setTransform(-144.525,-186.225);

	this.shape_1723 = new cjs.Shape();
	this.shape_1723.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_1723.setTransform(-159.025,-28.975);

	this.shape_1724 = new cjs.Shape();
	this.shape_1724.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_1724.setTransform(-200.9,-36.7925);

	this.shape_1725 = new cjs.Shape();
	this.shape_1725.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_1725.setTransform(-243.525,-32.85);

	this.shape_1726 = new cjs.Shape();
	this.shape_1726.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_1726.setTransform(-284.875,-21.325);

	this.shape_1727 = new cjs.Shape();
	this.shape_1727.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_1727.setTransform(-266.575,-120.375);

	this.shape_1728 = new cjs.Shape();
	this.shape_1728.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_1728.setTransform(-313.25,-110.575);

	this.shape_1729 = new cjs.Shape();
	this.shape_1729.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_1729.setTransform(-219.775,-130.875);

	this.shape_1730 = new cjs.Shape();
	this.shape_1730.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_1730.setTransform(-177.075,-151.575);

	this.shape_1731 = new cjs.Shape();
	this.shape_1731.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_1731.setTransform(-37.725,-278.5196);

	this.shape_1732 = new cjs.Shape();
	this.shape_1732.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_1732.setTransform(1.75,-253.225);

	this.shape_1733 = new cjs.Shape();
	this.shape_1733.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_1733.setTransform(-114.5,-223.5);

	this.shape_1734 = new cjs.Shape();
	this.shape_1734.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_1734.setTransform(-80.375,-257.35);

	this.shape_1735 = new cjs.Shape();
	this.shape_1735.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_1735.setTransform(-328.05,-10.925);

	this.shape_1736 = new cjs.Shape();
	this.shape_1736.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_1736.setTransform(-373,-12.325);

	this.shape_1737 = new cjs.Shape();
	this.shape_1737.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_1737.setTransform(-358.325,-95.45);

	this.shape_1738 = new cjs.Shape();
	this.shape_1738.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_1738.setTransform(-411.075,-32.2);

	this.shape_1739 = new cjs.Shape();
	this.shape_1739.graphics.lf(["#38ACA9","#38ACAB"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_1739.setTransform(-398.975,-71.425);

	this.shape_1740 = new cjs.Shape();
	this.shape_1740.graphics.f("#2BB1B4").s().p("EBRgAkvQBFhqAPhrIAyAHQgQB0hNB2gEBQYAa2IAlgiQBdBpArBpIgvATQgphjhVhggEhS+AdGQgngnAAg3QAAg3AngnQAngnA4AAQA2AAAnAnQAnAnAAA3QAAA3gnAnQgnAng2AAQg4AAgngngEhMrAZgIDVhKIAPAwIjTBKgEBKjAWKIAagqQBxBFBaBHIgfAnQhVhDhxhGgEhGCAXNIDVhIIAQAvIjVBJgEg/ZAU9IDVhHIAQAvIjVBHgEBD4ASpIAVgtQBxAzBrA4IgYAsQhng2hyg0gEg4uASvIBrgjQA3gSA3gPIANAxQgvAMg9AUIhqAjgEgx1AQ3QBngWB7gUIAIAxQiDAWhdAUgEA84APxIARguQBuAoB1AwIgTAuQhpgrh4gtgEgqxAPqIDjgfIAGAyIjhAfgEgjrAOtIDigfIAHAyIjjAfgEA1sANWIAPgwQCGAqBiAhIgQAwQh3gphwgigA8oNrQB+gWBhgWIAMAwQhaAWiIAXgA1yL+QCGg2AjhCIAsAXQgqBSiYA9gEAuaALPIANgwQBjAaCIAnIgOAwQhmgdiEgkgEAo8AJ5IgCAAIAAgBIgBAAIgBAAQg2gQg3gUIAQgvIBsAjIByAbIgLAwgEAgnAGVIAcgqQBRA2B0AzIgUAuQh3g0hWg5gA1IGDQgogjgpgfIAdgoQAoAdAtAnQAwArAkArIgnAfQggglgugqgEg2wAFBQBtgGBugVIAJAxQhyAWhwAGgEg9yAE/IAOgwQBlAhByAMIgFAyQh3gNhpgigEgv+ADwQAsgNA+gXIBmgiIAQAvQgwAPg1AUQg8AVgwAOgAeXgEIAqAaQhABkAtBbIgtAWQg6h0BQh7gEhCfACRQgvg2gDhGIAygCQACA1AkAnQAdAhA1AjIgcApQg5glgjgmgA8RCMIAOgxQBsAeBgAvIgWAtQhcgthogcgEgpfABuQBqgaBrgQIAHAxQhgAPhvAbgEgixABhIgCgyQBygFBnALIgFAxQhlgKhtAFgEAg+gCqQBQg8Byg/IAYAsQhuA+hOA5gEhBtgDQQBHhTBxhMIAcApQhsBKhDBMgEAnNgGNIBogvIBygxIATAuIhwAxIhoAvgEg7kgHnQBngyB2gsIARAuQhzAshlAxgEAuGgJLQgCAFAEAGIADAEIgCgBIgOgFQgigJiWgVIAHgxIBzARQAzAIAXAGQAOADALAFQANAHAHALQAIASgKAQQgGAKgMAHgEg0kgKRQBqgfB+gdIALAwQh6AdhrAfgEAjcgKxIAKgxQBrAVCGAWIgIAyQh0gUh/gYgEgtSgL+IB2gUIB2gUIAJAxQhEANgzAIIh1AUgAb6saIAMgxQBmAZCKAeIgMAxQh1gah7gdgEgl9gNYQB7gfBngmIARAvQhmAmiAAhgAWTt3Qg6gQg+gUIAPgvQA2ARBAASIB3AgIgNAwgA/HwAQBmg8BVhRIAiAlQhZBUhqA/gANVxkIAZgsQBtA/BsAwIgUAtQhwgwhuhAgAHG2MIAhglQBeBWBeBFIgeApQhlhMhahTgA5v08QAug6BjiEIAoAeQh4CegaAhgAB275IAngfQBcByBCBIIglAiQhKhThWhqgA1I62QBQhgBQhUIAkAiQhQBVhPBdgEgC+gh2IAkgiQBABDBfB7IgmAfQheh4g/hDgEgP9ggUQA7g4AegaQAzguAtgiIAfAoQg0AogqAmQgqAlgvArgEgJXgkEIgQgvQCIgvB5AxIgTAuQhngqh3Apg");
	this.shape_1740.setTransform(11.05,-44.1946);

	this.shape_1741 = new cjs.Shape();
	this.shape_1741.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.2,0,11.3,0).s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_1741.setTransform(509.25,218.425);

	this.shape_1742 = new cjs.Shape();
	this.shape_1742.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12.2,0,12.2,0).s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_1742.setTransform(467.65,244.375);

	this.shape_1743 = new cjs.Shape();
	this.shape_1743.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12.5,0,12.6,0).s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_1743.setTransform(420.95,258.85);

	this.shape_1744 = new cjs.Shape();
	this.shape_1744.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12.4,0,12.5,0).s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_1744.setTransform(371.7,260.625);

	this.shape_1745 = new cjs.Shape();
	this.shape_1745.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12.5,0,12.6,0).s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_1745.setTransform(323.275,252.65);

	this.shape_1746 = new cjs.Shape();
	this.shape_1746.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12.4,0,12.5,0).s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_1746.setTransform(275.975,239.275);

	this.shape_1747 = new cjs.Shape();
	this.shape_1747.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12.4,0,12.5,0).s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_1747.setTransform(229.275,223.775);

	this.shape_1748 = new cjs.Shape();
	this.shape_1748.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12.4,0,12.5,0).s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_1748.setTransform(182.575,208.375);

	this.shape_1749 = new cjs.Shape();
	this.shape_1749.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12.5,0,12.6,0).s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_1749.setTransform(135.325,194.675);

	this.shape_1750 = new cjs.Shape();
	this.shape_1750.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12.5,0,12.6,0).s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_1750.setTransform(87.3,183.95);

	this.shape_1751 = new cjs.Shape();
	this.shape_1751.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12.4,0,12.5,0).s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_1751.setTransform(38.6,177.125);

	this.shape_1752 = new cjs.Shape();
	this.shape_1752.graphics.lf(["#FF5E00","#FF6821"],[0,1],-12.1,0,12.1,0).s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_1752.setTransform(-10.3,174.675);

	this.shape_1753 = new cjs.Shape();
	this.shape_1753.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.6,0,11.7,0).s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_1753.setTransform(-56.975,176.2);

	this.shape_1754 = new cjs.Shape();
	this.shape_1754.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.8,0,11.8,0).s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_1754.setTransform(-102.95,180.925);

	this.shape_1755 = new cjs.Shape();
	this.shape_1755.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.8,0,11.9,0).s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_1755.setTransform(-148.35,189.375);

	this.shape_1756 = new cjs.Shape();
	this.shape_1756.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.7,0,11.8,0).s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_1756.setTransform(-193.025,201.275);

	this.shape_1757 = new cjs.Shape();
	this.shape_1757.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.7,0,11.8,0).s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_1757.setTransform(-237.125,215.025);

	this.shape_1758 = new cjs.Shape();
	this.shape_1758.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.8,0,11.8,0).s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_1758.setTransform(-281.5,227.7);

	this.shape_1759 = new cjs.Shape();
	this.shape_1759.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.7,0,11.8,0).s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_1759.setTransform(-326.875,236.275);

	this.shape_1760 = new cjs.Shape();
	this.shape_1760.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.6,0,11.6,0).s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_1760.setTransform(-372.975,239.5188);

	this.shape_1761 = new cjs.Shape();
	this.shape_1761.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.7,0,11.7,0).s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_1761.setTransform(-419.25,237.75);

	this.shape_1762 = new cjs.Shape();
	this.shape_1762.graphics.lf(["#FF5E00","#FF6821"],[0,1],-11.8,0,11.8,0).s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_1762.setTransform(-465.05,232.125);

	this.shape_1763 = new cjs.Shape();
	this.shape_1763.graphics.lf(["#FF5E00","#FF6821"],[0,1],-6.2,0,6.3,0).s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_1763.setTransform(-504.875,224.85);

	this.shape_1764 = new cjs.Shape();
	this.shape_1764.graphics.lf(["#F66208","#F66B27"],[0,1],-11.8,0,11.8,0).s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_1764.setTransform(-465.05,232.125);

	this.shape_1765 = new cjs.Shape();
	this.shape_1765.graphics.lf(["#F66208","#F66B27"],[0,1],-11.7,0,11.7,0).s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_1765.setTransform(-419.25,237.75);

	this.shape_1766 = new cjs.Shape();
	this.shape_1766.graphics.lf(["#F66208","#F66B27"],[0,1],-11.6,0,11.6,0).s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_1766.setTransform(-372.975,239.5188);

	this.shape_1767 = new cjs.Shape();
	this.shape_1767.graphics.lf(["#F66208","#F66B27"],[0,1],-6.2,0,6.3,0).s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_1767.setTransform(-504.875,224.85);

	this.shape_1768 = new cjs.Shape();
	this.shape_1768.graphics.lf(["#F66208","#F66B27"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_1768.setTransform(-510.625,132.625);

	this.shape_1769 = new cjs.Shape();
	this.shape_1769.graphics.lf(["#F66208","#F66B27"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_1769.setTransform(-468.325,117.725);

	this.shape_1770 = new cjs.Shape();
	this.shape_1770.graphics.lf(["#F66208","#F66B27"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_1770.setTransform(-425.825,103.1);

	this.shape_1771 = new cjs.Shape();
	this.shape_1771.graphics.lf(["#F66208","#F66B27"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_1771.setTransform(-340.575,74.725);

	this.shape_1772 = new cjs.Shape();
	this.shape_1772.graphics.lf(["#F66208","#F66B27"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_1772.setTransform(-383.3,88.725);

	this.shape_1773 = new cjs.Shape();
	this.shape_1773.graphics.lf(["#F66208","#F66B27"],[0,1],-11.7,0,11.8,0).s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_1773.setTransform(-326.875,236.275);

	this.shape_1774 = new cjs.Shape();
	this.shape_1774.graphics.lf(["#F66208","#F66B27"],[0,1],-11.8,0,11.8,0).s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_1774.setTransform(-281.5,227.7);

	this.shape_1775 = new cjs.Shape();
	this.shape_1775.graphics.lf(["#F66208","#F66B27"],[0,1],-11.7,0,11.8,0).s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_1775.setTransform(-237.125,215.025);

	this.shape_1776 = new cjs.Shape();
	this.shape_1776.graphics.lf(["#F66208","#F66B27"],[0,1],-11.7,0,11.8,0).s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_1776.setTransform(-193.025,201.275);

	this.shape_1777 = new cjs.Shape();
	this.shape_1777.graphics.lf(["#F66208","#F66B27"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_1777.setTransform(-296.25,64.05);

	this.shape_1778 = new cjs.Shape();
	this.shape_1778.graphics.lf(["#F66208","#F66B27"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_1778.setTransform(-251.075,56.95);

	this.shape_1779 = new cjs.Shape();
	this.shape_1779.graphics.lf(["#F66208","#F66B27"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_1779.setTransform(-205.675,50.875);

	this.shape_1780 = new cjs.Shape();
	this.shape_1780.graphics.lf(["#F66208","#F66B27"],[0,1],-11.6,0,11.7,0).s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_1780.setTransform(-56.975,176.2);

	this.shape_1781 = new cjs.Shape();
	this.shape_1781.graphics.lf(["#F66208","#F66B27"],[0,1],-11.8,0,11.8,0).s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_1781.setTransform(-102.95,180.925);

	this.shape_1782 = new cjs.Shape();
	this.shape_1782.graphics.lf(["#F66208","#F66B27"],[0,1],-11.8,0,11.9,0).s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_1782.setTransform(-148.35,189.375);

	this.shape_1783 = new cjs.Shape();
	this.shape_1783.graphics.lf(["#F66208","#F66B27"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_1783.setTransform(-160.5,43.575);

	this.shape_1784 = new cjs.Shape();
	this.shape_1784.graphics.lf(["#F66208","#F66B27"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_1784.setTransform(-117.75,28.75);

	this.shape_1785 = new cjs.Shape();
	this.shape_1785.graphics.lf(["#F66208","#F66B27"],[0,1],-12.4,0,12.5,0).s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_1785.setTransform(182.575,208.375);

	this.shape_1786 = new cjs.Shape();
	this.shape_1786.graphics.lf(["#F66208","#F66B27"],[0,1],-12.4,0,12.5,0).s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_1786.setTransform(229.275,223.775);

	this.shape_1787 = new cjs.Shape();
	this.shape_1787.graphics.lf(["#F66208","#F66B27"],[0,1],-12.4,0,12.5,0).s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_1787.setTransform(275.975,239.275);

	this.shape_1788 = new cjs.Shape();
	this.shape_1788.graphics.lf(["#F66208","#F66B27"],[0,1],-12.5,0,12.6,0).s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_1788.setTransform(135.325,194.675);

	this.shape_1789 = new cjs.Shape();
	this.shape_1789.graphics.lf(["#F66208","#F66B27"],[0,1],-12.5,0,12.6,0).s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_1789.setTransform(87.3,183.95);

	this.shape_1790 = new cjs.Shape();
	this.shape_1790.graphics.lf(["#F66208","#F66B27"],[0,1],-12.1,0,12.1,0).s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_1790.setTransform(-10.3,174.675);

	this.shape_1791 = new cjs.Shape();
	this.shape_1791.graphics.lf(["#F66208","#F66B27"],[0,1],-12.4,0,12.5,0).s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_1791.setTransform(38.6,177.125);

	this.shape_1792 = new cjs.Shape();
	this.shape_1792.graphics.lf(["#F66208","#F66B27"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_1792.setTransform(273.675,16.25);

	this.shape_1793 = new cjs.Shape();
	this.shape_1793.graphics.lf(["#F66208","#F66B27"],[0,1],-11.2,0,11.3,0).s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_1793.setTransform(509.25,218.425);

	this.shape_1794 = new cjs.Shape();
	this.shape_1794.graphics.lf(["#F66208","#F66B27"],[0,1],-12.5,0,12.6,0).s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_1794.setTransform(323.275,252.65);

	this.shape_1795 = new cjs.Shape();
	this.shape_1795.graphics.lf(["#F66208","#F66B27"],[0,1],-12.4,0,12.5,0).s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_1795.setTransform(371.7,260.625);

	this.shape_1796 = new cjs.Shape();
	this.shape_1796.graphics.lf(["#F66208","#F66B27"],[0,1],-12.5,0,12.6,0).s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_1796.setTransform(420.95,258.85);

	this.shape_1797 = new cjs.Shape();
	this.shape_1797.graphics.lf(["#F66208","#F66B27"],[0,1],-12.2,0,12.2,0).s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_1797.setTransform(467.65,244.375);

	this.shape_1798 = new cjs.Shape();
	this.shape_1798.graphics.lf(["#F66208","#F66B27"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_1798.setTransform(320.475,28.6);

	this.shape_1799 = new cjs.Shape();
	this.shape_1799.graphics.lf(["#F66208","#F66B27"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_1799.setTransform(367,42.55);

	this.shape_1800 = new cjs.Shape();
	this.shape_1800.graphics.lf(["#F66208","#F66B27"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_1800.setTransform(457.5,78.175);

	this.shape_1801 = new cjs.Shape();
	this.shape_1801.graphics.lf(["#F66208","#F66B27"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_1801.setTransform(412.875,58.825);

	this.shape_1802 = new cjs.Shape();
	this.shape_1802.graphics.lf(["#F66208","#F66B27"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_1802.setTransform(539.325,181.675);

	this.shape_1803 = new cjs.Shape();
	this.shape_1803.graphics.lf(["#F66208","#F66B27"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_1803.setTransform(534.05,135.7);

	this.shape_1804 = new cjs.Shape();
	this.shape_1804.graphics.lf(["#F66208","#F66B27"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_1804.setTransform(499.575,102.375);

	this.shape_1805 = new cjs.Shape();
	this.shape_1805.graphics.lf(["#F66208","#F66B27"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_1805.setTransform(273.8,-86.475);

	this.shape_1806 = new cjs.Shape();
	this.shape_1806.graphics.lf(["#F66208","#F66B27"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_1806.setTransform(205.1312,-32.65);

	this.shape_1807 = new cjs.Shape();
	this.shape_1807.graphics.lf(["#F66208","#F66B27"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_1807.setTransform(231.025,-0.325);

	this.shape_1808 = new cjs.Shape();
	this.shape_1808.graphics.lf(["#F66208","#F66B27"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_1808.setTransform(232.95,-65.4);

	this.shape_1809 = new cjs.Shape();
	this.shape_1809.graphics.lf(["#F66208","#F66B27"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_1809.setTransform(202.225,-123.35);

	this.shape_1810 = new cjs.Shape();
	this.shape_1810.graphics.lf(["#F66208","#F66B27"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_1810.setTransform(298.7901,-104.575);

	this.shape_1811 = new cjs.Shape();
	this.shape_1811.graphics.lf(["#F66208","#F66B27"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_1811.setTransform(250.45,-113.45);

	this.shape_1812 = new cjs.Shape();
	this.shape_1812.graphics.lf(["#F66208","#F66B27"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_1812.setTransform(67.475,-180.175);

	this.shape_1813 = new cjs.Shape();
	this.shape_1813.graphics.lf(["#F66208","#F66B27"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_1813.setTransform(154.35,-135.525);

	this.shape_1814 = new cjs.Shape();
	this.shape_1814.graphics.lf(["#F66208","#F66B27"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_1814.setTransform(108.425,-153.25);

	this.shape_1815 = new cjs.Shape();
	this.shape_1815.graphics.lf(["#F66208","#F66B27"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_1815.setTransform(32.725,-214.9);

	this.shape_1816 = new cjs.Shape();
	this.shape_1816.graphics.lf(["#F66208","#F66B27"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_1816.setTransform(-122.5,-6.825);

	this.shape_1817 = new cjs.Shape();
	this.shape_1817.graphics.lf(["#F66208","#F66B27"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_1817.setTransform(-144.525,-186.225);

	this.shape_1818 = new cjs.Shape();
	this.shape_1818.graphics.lf(["#F66208","#F66B27"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_1818.setTransform(-159.025,-28.975);

	this.shape_1819 = new cjs.Shape();
	this.shape_1819.graphics.lf(["#F66208","#F66B27"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_1819.setTransform(-200.9,-36.7925);

	this.shape_1820 = new cjs.Shape();
	this.shape_1820.graphics.lf(["#F66208","#F66B27"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_1820.setTransform(-243.525,-32.85);

	this.shape_1821 = new cjs.Shape();
	this.shape_1821.graphics.lf(["#F66208","#F66B27"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_1821.setTransform(-284.875,-21.325);

	this.shape_1822 = new cjs.Shape();
	this.shape_1822.graphics.lf(["#F66208","#F66B27"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_1822.setTransform(-266.575,-120.375);

	this.shape_1823 = new cjs.Shape();
	this.shape_1823.graphics.lf(["#F66208","#F66B27"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_1823.setTransform(-313.25,-110.575);

	this.shape_1824 = new cjs.Shape();
	this.shape_1824.graphics.lf(["#F66208","#F66B27"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_1824.setTransform(-219.775,-130.875);

	this.shape_1825 = new cjs.Shape();
	this.shape_1825.graphics.lf(["#F66208","#F66B27"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_1825.setTransform(-177.075,-151.575);

	this.shape_1826 = new cjs.Shape();
	this.shape_1826.graphics.lf(["#F66208","#F66B27"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_1826.setTransform(-37.725,-278.5196);

	this.shape_1827 = new cjs.Shape();
	this.shape_1827.graphics.lf(["#F66208","#F66B27"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_1827.setTransform(1.75,-253.225);

	this.shape_1828 = new cjs.Shape();
	this.shape_1828.graphics.lf(["#F66208","#F66B27"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_1828.setTransform(-114.5,-223.5);

	this.shape_1829 = new cjs.Shape();
	this.shape_1829.graphics.lf(["#F66208","#F66B27"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_1829.setTransform(-80.375,-257.35);

	this.shape_1830 = new cjs.Shape();
	this.shape_1830.graphics.lf(["#F66208","#F66B27"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_1830.setTransform(-328.05,-10.925);

	this.shape_1831 = new cjs.Shape();
	this.shape_1831.graphics.lf(["#F66208","#F66B27"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_1831.setTransform(-373,-12.325);

	this.shape_1832 = new cjs.Shape();
	this.shape_1832.graphics.lf(["#F66208","#F66B27"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_1832.setTransform(-358.325,-95.45);

	this.shape_1833 = new cjs.Shape();
	this.shape_1833.graphics.lf(["#F66208","#F66B27"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_1833.setTransform(-411.075,-32.2);

	this.shape_1834 = new cjs.Shape();
	this.shape_1834.graphics.lf(["#F66208","#F66B27"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_1834.setTransform(-398.975,-71.425);

	this.shape_1835 = new cjs.Shape();
	this.shape_1835.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.8,0,11.8,0).s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_1835.setTransform(-465.05,232.125);

	this.shape_1836 = new cjs.Shape();
	this.shape_1836.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.7,0,11.7,0).s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_1836.setTransform(-419.25,237.75);

	this.shape_1837 = new cjs.Shape();
	this.shape_1837.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.6,0,11.6,0).s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_1837.setTransform(-372.975,239.5188);

	this.shape_1838 = new cjs.Shape();
	this.shape_1838.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-6.2,0,6.3,0).s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_1838.setTransform(-504.875,224.85);

	this.shape_1839 = new cjs.Shape();
	this.shape_1839.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_1839.setTransform(-510.625,132.625);

	this.shape_1840 = new cjs.Shape();
	this.shape_1840.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_1840.setTransform(-468.325,117.725);

	this.shape_1841 = new cjs.Shape();
	this.shape_1841.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_1841.setTransform(-425.825,103.1);

	this.shape_1842 = new cjs.Shape();
	this.shape_1842.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_1842.setTransform(-340.575,74.725);

	this.shape_1843 = new cjs.Shape();
	this.shape_1843.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_1843.setTransform(-383.3,88.725);

	this.shape_1844 = new cjs.Shape();
	this.shape_1844.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.7,0,11.8,0).s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_1844.setTransform(-326.875,236.275);

	this.shape_1845 = new cjs.Shape();
	this.shape_1845.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.8,0,11.8,0).s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_1845.setTransform(-281.5,227.7);

	this.shape_1846 = new cjs.Shape();
	this.shape_1846.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.7,0,11.8,0).s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_1846.setTransform(-237.125,215.025);

	this.shape_1847 = new cjs.Shape();
	this.shape_1847.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.7,0,11.8,0).s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_1847.setTransform(-193.025,201.275);

	this.shape_1848 = new cjs.Shape();
	this.shape_1848.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_1848.setTransform(-296.25,64.05);

	this.shape_1849 = new cjs.Shape();
	this.shape_1849.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_1849.setTransform(-251.075,56.95);

	this.shape_1850 = new cjs.Shape();
	this.shape_1850.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_1850.setTransform(-205.675,50.875);

	this.shape_1851 = new cjs.Shape();
	this.shape_1851.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.6,0,11.7,0).s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_1851.setTransform(-56.975,176.2);

	this.shape_1852 = new cjs.Shape();
	this.shape_1852.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.8,0,11.8,0).s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_1852.setTransform(-102.95,180.925);

	this.shape_1853 = new cjs.Shape();
	this.shape_1853.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.8,0,11.9,0).s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_1853.setTransform(-148.35,189.375);

	this.shape_1854 = new cjs.Shape();
	this.shape_1854.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_1854.setTransform(-160.5,43.575);

	this.shape_1855 = new cjs.Shape();
	this.shape_1855.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_1855.setTransform(-117.75,28.75);

	this.shape_1856 = new cjs.Shape();
	this.shape_1856.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12.4,0,12.5,0).s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_1856.setTransform(182.575,208.375);

	this.shape_1857 = new cjs.Shape();
	this.shape_1857.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12.4,0,12.5,0).s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_1857.setTransform(229.275,223.775);

	this.shape_1858 = new cjs.Shape();
	this.shape_1858.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12.4,0,12.5,0).s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_1858.setTransform(275.975,239.275);

	this.shape_1859 = new cjs.Shape();
	this.shape_1859.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12.5,0,12.6,0).s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_1859.setTransform(135.325,194.675);

	this.shape_1860 = new cjs.Shape();
	this.shape_1860.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12.5,0,12.6,0).s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_1860.setTransform(87.3,183.95);

	this.shape_1861 = new cjs.Shape();
	this.shape_1861.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12.1,0,12.1,0).s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_1861.setTransform(-10.3,174.675);

	this.shape_1862 = new cjs.Shape();
	this.shape_1862.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12.4,0,12.5,0).s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_1862.setTransform(38.6,177.125);

	this.shape_1863 = new cjs.Shape();
	this.shape_1863.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_1863.setTransform(273.675,16.25);

	this.shape_1864 = new cjs.Shape();
	this.shape_1864.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.2,0,11.3,0).s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_1864.setTransform(509.25,218.425);

	this.shape_1865 = new cjs.Shape();
	this.shape_1865.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12.5,0,12.6,0).s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_1865.setTransform(323.275,252.65);

	this.shape_1866 = new cjs.Shape();
	this.shape_1866.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12.4,0,12.5,0).s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_1866.setTransform(371.7,260.625);

	this.shape_1867 = new cjs.Shape();
	this.shape_1867.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12.5,0,12.6,0).s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_1867.setTransform(420.95,258.85);

	this.shape_1868 = new cjs.Shape();
	this.shape_1868.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12.2,0,12.2,0).s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_1868.setTransform(467.65,244.375);

	this.shape_1869 = new cjs.Shape();
	this.shape_1869.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_1869.setTransform(320.475,28.6);

	this.shape_1870 = new cjs.Shape();
	this.shape_1870.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_1870.setTransform(367,42.55);

	this.shape_1871 = new cjs.Shape();
	this.shape_1871.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_1871.setTransform(457.5,78.175);

	this.shape_1872 = new cjs.Shape();
	this.shape_1872.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_1872.setTransform(412.875,58.825);

	this.shape_1873 = new cjs.Shape();
	this.shape_1873.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_1873.setTransform(539.325,181.675);

	this.shape_1874 = new cjs.Shape();
	this.shape_1874.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_1874.setTransform(534.05,135.7);

	this.shape_1875 = new cjs.Shape();
	this.shape_1875.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_1875.setTransform(499.575,102.375);

	this.shape_1876 = new cjs.Shape();
	this.shape_1876.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_1876.setTransform(273.8,-86.475);

	this.shape_1877 = new cjs.Shape();
	this.shape_1877.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_1877.setTransform(205.1312,-32.65);

	this.shape_1878 = new cjs.Shape();
	this.shape_1878.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_1878.setTransform(231.025,-0.325);

	this.shape_1879 = new cjs.Shape();
	this.shape_1879.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_1879.setTransform(232.95,-65.4);

	this.shape_1880 = new cjs.Shape();
	this.shape_1880.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_1880.setTransform(202.225,-123.35);

	this.shape_1881 = new cjs.Shape();
	this.shape_1881.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_1881.setTransform(298.7901,-104.575);

	this.shape_1882 = new cjs.Shape();
	this.shape_1882.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_1882.setTransform(250.45,-113.45);

	this.shape_1883 = new cjs.Shape();
	this.shape_1883.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_1883.setTransform(67.475,-180.175);

	this.shape_1884 = new cjs.Shape();
	this.shape_1884.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_1884.setTransform(154.35,-135.525);

	this.shape_1885 = new cjs.Shape();
	this.shape_1885.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_1885.setTransform(108.425,-153.25);

	this.shape_1886 = new cjs.Shape();
	this.shape_1886.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_1886.setTransform(32.725,-214.9);

	this.shape_1887 = new cjs.Shape();
	this.shape_1887.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_1887.setTransform(-122.5,-6.825);

	this.shape_1888 = new cjs.Shape();
	this.shape_1888.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_1888.setTransform(-144.525,-186.225);

	this.shape_1889 = new cjs.Shape();
	this.shape_1889.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_1889.setTransform(-159.025,-28.975);

	this.shape_1890 = new cjs.Shape();
	this.shape_1890.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_1890.setTransform(-200.9,-36.7925);

	this.shape_1891 = new cjs.Shape();
	this.shape_1891.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_1891.setTransform(-243.525,-32.85);

	this.shape_1892 = new cjs.Shape();
	this.shape_1892.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_1892.setTransform(-284.875,-21.325);

	this.shape_1893 = new cjs.Shape();
	this.shape_1893.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_1893.setTransform(-266.575,-120.375);

	this.shape_1894 = new cjs.Shape();
	this.shape_1894.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_1894.setTransform(-313.25,-110.575);

	this.shape_1895 = new cjs.Shape();
	this.shape_1895.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_1895.setTransform(-219.775,-130.875);

	this.shape_1896 = new cjs.Shape();
	this.shape_1896.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_1896.setTransform(-177.075,-151.575);

	this.shape_1897 = new cjs.Shape();
	this.shape_1897.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_1897.setTransform(-37.725,-278.5196);

	this.shape_1898 = new cjs.Shape();
	this.shape_1898.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_1898.setTransform(1.75,-253.225);

	this.shape_1899 = new cjs.Shape();
	this.shape_1899.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_1899.setTransform(-114.5,-223.5);

	this.shape_1900 = new cjs.Shape();
	this.shape_1900.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_1900.setTransform(-80.375,-257.35);

	this.shape_1901 = new cjs.Shape();
	this.shape_1901.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_1901.setTransform(-328.05,-10.925);

	this.shape_1902 = new cjs.Shape();
	this.shape_1902.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_1902.setTransform(-373,-12.325);

	this.shape_1903 = new cjs.Shape();
	this.shape_1903.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_1903.setTransform(-358.325,-95.45);

	this.shape_1904 = new cjs.Shape();
	this.shape_1904.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_1904.setTransform(-411.075,-32.2);

	this.shape_1905 = new cjs.Shape();
	this.shape_1905.graphics.lf(["#ED6510","#ED6E2E"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_1905.setTransform(-398.975,-71.425);

	this.shape_1906 = new cjs.Shape();
	this.shape_1906.graphics.lf(["#E36917","#E37234"],[0,1],-11.8,0,11.8,0).s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_1906.setTransform(-465.05,232.125);

	this.shape_1907 = new cjs.Shape();
	this.shape_1907.graphics.lf(["#E36917","#E37234"],[0,1],-11.7,0,11.7,0).s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_1907.setTransform(-419.25,237.75);

	this.shape_1908 = new cjs.Shape();
	this.shape_1908.graphics.lf(["#E36917","#E37234"],[0,1],-11.6,0,11.6,0).s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_1908.setTransform(-372.975,239.5188);

	this.shape_1909 = new cjs.Shape();
	this.shape_1909.graphics.lf(["#E36917","#E37234"],[0,1],-6.2,0,6.3,0).s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_1909.setTransform(-504.875,224.85);

	this.shape_1910 = new cjs.Shape();
	this.shape_1910.graphics.lf(["#E36917","#E37234"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_1910.setTransform(-510.625,132.625);

	this.shape_1911 = new cjs.Shape();
	this.shape_1911.graphics.lf(["#E36917","#E37234"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_1911.setTransform(-468.325,117.725);

	this.shape_1912 = new cjs.Shape();
	this.shape_1912.graphics.lf(["#E36917","#E37234"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_1912.setTransform(-425.825,103.1);

	this.shape_1913 = new cjs.Shape();
	this.shape_1913.graphics.lf(["#E36917","#E37234"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_1913.setTransform(-340.575,74.725);

	this.shape_1914 = new cjs.Shape();
	this.shape_1914.graphics.lf(["#E36917","#E37234"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_1914.setTransform(-383.3,88.725);

	this.shape_1915 = new cjs.Shape();
	this.shape_1915.graphics.lf(["#E36917","#E37234"],[0,1],-11.7,0,11.8,0).s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_1915.setTransform(-326.875,236.275);

	this.shape_1916 = new cjs.Shape();
	this.shape_1916.graphics.lf(["#E36917","#E37234"],[0,1],-11.8,0,11.8,0).s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_1916.setTransform(-281.5,227.7);

	this.shape_1917 = new cjs.Shape();
	this.shape_1917.graphics.lf(["#E36917","#E37234"],[0,1],-11.7,0,11.8,0).s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_1917.setTransform(-237.125,215.025);

	this.shape_1918 = new cjs.Shape();
	this.shape_1918.graphics.lf(["#E36917","#E37234"],[0,1],-11.7,0,11.8,0).s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_1918.setTransform(-193.025,201.275);

	this.shape_1919 = new cjs.Shape();
	this.shape_1919.graphics.lf(["#E36917","#E37234"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_1919.setTransform(-296.25,64.05);

	this.shape_1920 = new cjs.Shape();
	this.shape_1920.graphics.lf(["#E36917","#E37234"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_1920.setTransform(-251.075,56.95);

	this.shape_1921 = new cjs.Shape();
	this.shape_1921.graphics.lf(["#E36917","#E37234"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_1921.setTransform(-205.675,50.875);

	this.shape_1922 = new cjs.Shape();
	this.shape_1922.graphics.lf(["#E36917","#E37234"],[0,1],-11.6,0,11.7,0).s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_1922.setTransform(-56.975,176.2);

	this.shape_1923 = new cjs.Shape();
	this.shape_1923.graphics.lf(["#E36917","#E37234"],[0,1],-11.8,0,11.8,0).s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_1923.setTransform(-102.95,180.925);

	this.shape_1924 = new cjs.Shape();
	this.shape_1924.graphics.lf(["#E36917","#E37234"],[0,1],-11.8,0,11.9,0).s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_1924.setTransform(-148.35,189.375);

	this.shape_1925 = new cjs.Shape();
	this.shape_1925.graphics.lf(["#E36917","#E37234"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_1925.setTransform(-160.5,43.575);

	this.shape_1926 = new cjs.Shape();
	this.shape_1926.graphics.lf(["#E36917","#E37234"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_1926.setTransform(-117.75,28.75);

	this.shape_1927 = new cjs.Shape();
	this.shape_1927.graphics.lf(["#E36917","#E37234"],[0,1],-12.4,0,12.5,0).s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_1927.setTransform(182.575,208.375);

	this.shape_1928 = new cjs.Shape();
	this.shape_1928.graphics.lf(["#E36917","#E37234"],[0,1],-12.4,0,12.5,0).s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_1928.setTransform(229.275,223.775);

	this.shape_1929 = new cjs.Shape();
	this.shape_1929.graphics.lf(["#E36917","#E37234"],[0,1],-12.4,0,12.5,0).s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_1929.setTransform(275.975,239.275);

	this.shape_1930 = new cjs.Shape();
	this.shape_1930.graphics.lf(["#E36917","#E37234"],[0,1],-12.5,0,12.6,0).s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_1930.setTransform(135.325,194.675);

	this.shape_1931 = new cjs.Shape();
	this.shape_1931.graphics.lf(["#E36917","#E37234"],[0,1],-12.5,0,12.6,0).s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_1931.setTransform(87.3,183.95);

	this.shape_1932 = new cjs.Shape();
	this.shape_1932.graphics.lf(["#E36917","#E37234"],[0,1],-12.1,0,12.1,0).s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_1932.setTransform(-10.3,174.675);

	this.shape_1933 = new cjs.Shape();
	this.shape_1933.graphics.lf(["#E36917","#E37234"],[0,1],-12.4,0,12.5,0).s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_1933.setTransform(38.6,177.125);

	this.shape_1934 = new cjs.Shape();
	this.shape_1934.graphics.lf(["#E36917","#E37234"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_1934.setTransform(273.675,16.25);

	this.shape_1935 = new cjs.Shape();
	this.shape_1935.graphics.lf(["#E36917","#E37234"],[0,1],-11.2,0,11.3,0).s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_1935.setTransform(509.25,218.425);

	this.shape_1936 = new cjs.Shape();
	this.shape_1936.graphics.lf(["#E36917","#E37234"],[0,1],-12.5,0,12.6,0).s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_1936.setTransform(323.275,252.65);

	this.shape_1937 = new cjs.Shape();
	this.shape_1937.graphics.lf(["#E36917","#E37234"],[0,1],-12.4,0,12.5,0).s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_1937.setTransform(371.7,260.625);

	this.shape_1938 = new cjs.Shape();
	this.shape_1938.graphics.lf(["#E36917","#E37234"],[0,1],-12.5,0,12.6,0).s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_1938.setTransform(420.95,258.85);

	this.shape_1939 = new cjs.Shape();
	this.shape_1939.graphics.lf(["#E36917","#E37234"],[0,1],-12.2,0,12.2,0).s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_1939.setTransform(467.65,244.375);

	this.shape_1940 = new cjs.Shape();
	this.shape_1940.graphics.lf(["#E36917","#E37234"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_1940.setTransform(320.475,28.6);

	this.shape_1941 = new cjs.Shape();
	this.shape_1941.graphics.lf(["#E36917","#E37234"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_1941.setTransform(367,42.55);

	this.shape_1942 = new cjs.Shape();
	this.shape_1942.graphics.lf(["#E36917","#E37234"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_1942.setTransform(457.5,78.175);

	this.shape_1943 = new cjs.Shape();
	this.shape_1943.graphics.lf(["#E36917","#E37234"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_1943.setTransform(412.875,58.825);

	this.shape_1944 = new cjs.Shape();
	this.shape_1944.graphics.lf(["#E36917","#E37234"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_1944.setTransform(539.325,181.675);

	this.shape_1945 = new cjs.Shape();
	this.shape_1945.graphics.lf(["#E36917","#E37234"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_1945.setTransform(534.05,135.7);

	this.shape_1946 = new cjs.Shape();
	this.shape_1946.graphics.lf(["#E36917","#E37234"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_1946.setTransform(499.575,102.375);

	this.shape_1947 = new cjs.Shape();
	this.shape_1947.graphics.lf(["#E36917","#E37234"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_1947.setTransform(273.8,-86.475);

	this.shape_1948 = new cjs.Shape();
	this.shape_1948.graphics.lf(["#E36917","#E37234"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_1948.setTransform(205.1312,-32.65);

	this.shape_1949 = new cjs.Shape();
	this.shape_1949.graphics.lf(["#E36917","#E37234"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_1949.setTransform(231.025,-0.325);

	this.shape_1950 = new cjs.Shape();
	this.shape_1950.graphics.lf(["#E36917","#E37234"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_1950.setTransform(232.95,-65.4);

	this.shape_1951 = new cjs.Shape();
	this.shape_1951.graphics.lf(["#E36917","#E37234"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_1951.setTransform(202.225,-123.35);

	this.shape_1952 = new cjs.Shape();
	this.shape_1952.graphics.lf(["#E36917","#E37234"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_1952.setTransform(298.7901,-104.575);

	this.shape_1953 = new cjs.Shape();
	this.shape_1953.graphics.lf(["#E36917","#E37234"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_1953.setTransform(250.45,-113.45);

	this.shape_1954 = new cjs.Shape();
	this.shape_1954.graphics.lf(["#E36917","#E37234"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_1954.setTransform(67.475,-180.175);

	this.shape_1955 = new cjs.Shape();
	this.shape_1955.graphics.lf(["#E36917","#E37234"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_1955.setTransform(154.35,-135.525);

	this.shape_1956 = new cjs.Shape();
	this.shape_1956.graphics.lf(["#E36917","#E37234"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_1956.setTransform(108.425,-153.25);

	this.shape_1957 = new cjs.Shape();
	this.shape_1957.graphics.lf(["#E36917","#E37234"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_1957.setTransform(32.725,-214.9);

	this.shape_1958 = new cjs.Shape();
	this.shape_1958.graphics.lf(["#E36917","#E37234"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_1958.setTransform(-122.5,-6.825);

	this.shape_1959 = new cjs.Shape();
	this.shape_1959.graphics.lf(["#E36917","#E37234"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_1959.setTransform(-144.525,-186.225);

	this.shape_1960 = new cjs.Shape();
	this.shape_1960.graphics.lf(["#E36917","#E37234"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_1960.setTransform(-159.025,-28.975);

	this.shape_1961 = new cjs.Shape();
	this.shape_1961.graphics.lf(["#E36917","#E37234"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_1961.setTransform(-200.9,-36.7925);

	this.shape_1962 = new cjs.Shape();
	this.shape_1962.graphics.lf(["#E36917","#E37234"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_1962.setTransform(-243.525,-32.85);

	this.shape_1963 = new cjs.Shape();
	this.shape_1963.graphics.lf(["#E36917","#E37234"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_1963.setTransform(-284.875,-21.325);

	this.shape_1964 = new cjs.Shape();
	this.shape_1964.graphics.lf(["#E36917","#E37234"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_1964.setTransform(-266.575,-120.375);

	this.shape_1965 = new cjs.Shape();
	this.shape_1965.graphics.lf(["#E36917","#E37234"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_1965.setTransform(-313.25,-110.575);

	this.shape_1966 = new cjs.Shape();
	this.shape_1966.graphics.lf(["#E36917","#E37234"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_1966.setTransform(-219.775,-130.875);

	this.shape_1967 = new cjs.Shape();
	this.shape_1967.graphics.lf(["#E36917","#E37234"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_1967.setTransform(-177.075,-151.575);

	this.shape_1968 = new cjs.Shape();
	this.shape_1968.graphics.lf(["#E36917","#E37234"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_1968.setTransform(-37.725,-278.5196);

	this.shape_1969 = new cjs.Shape();
	this.shape_1969.graphics.lf(["#E36917","#E37234"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_1969.setTransform(1.75,-253.225);

	this.shape_1970 = new cjs.Shape();
	this.shape_1970.graphics.lf(["#E36917","#E37234"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_1970.setTransform(-114.5,-223.5);

	this.shape_1971 = new cjs.Shape();
	this.shape_1971.graphics.lf(["#E36917","#E37234"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_1971.setTransform(-80.375,-257.35);

	this.shape_1972 = new cjs.Shape();
	this.shape_1972.graphics.lf(["#E36917","#E37234"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_1972.setTransform(-328.05,-10.925);

	this.shape_1973 = new cjs.Shape();
	this.shape_1973.graphics.lf(["#E36917","#E37234"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_1973.setTransform(-373,-12.325);

	this.shape_1974 = new cjs.Shape();
	this.shape_1974.graphics.lf(["#E36917","#E37234"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_1974.setTransform(-358.325,-95.45);

	this.shape_1975 = new cjs.Shape();
	this.shape_1975.graphics.lf(["#E36917","#E37234"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_1975.setTransform(-411.075,-32.2);

	this.shape_1976 = new cjs.Shape();
	this.shape_1976.graphics.lf(["#E36917","#E37234"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_1976.setTransform(-398.975,-71.425);

	this.shape_1977 = new cjs.Shape();
	this.shape_1977.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.8,0,11.8,0).s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_1977.setTransform(-465.05,232.125);

	this.shape_1978 = new cjs.Shape();
	this.shape_1978.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.7,0,11.7,0).s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_1978.setTransform(-419.25,237.75);

	this.shape_1979 = new cjs.Shape();
	this.shape_1979.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.6,0,11.6,0).s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_1979.setTransform(-372.975,239.5188);

	this.shape_1980 = new cjs.Shape();
	this.shape_1980.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-6.2,0,6.3,0).s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_1980.setTransform(-504.875,224.85);

	this.shape_1981 = new cjs.Shape();
	this.shape_1981.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_1981.setTransform(-510.625,132.625);

	this.shape_1982 = new cjs.Shape();
	this.shape_1982.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_1982.setTransform(-468.325,117.725);

	this.shape_1983 = new cjs.Shape();
	this.shape_1983.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_1983.setTransform(-425.825,103.1);

	this.shape_1984 = new cjs.Shape();
	this.shape_1984.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_1984.setTransform(-340.575,74.725);

	this.shape_1985 = new cjs.Shape();
	this.shape_1985.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_1985.setTransform(-383.3,88.725);

	this.shape_1986 = new cjs.Shape();
	this.shape_1986.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.7,0,11.8,0).s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_1986.setTransform(-326.875,236.275);

	this.shape_1987 = new cjs.Shape();
	this.shape_1987.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.8,0,11.8,0).s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_1987.setTransform(-281.5,227.7);

	this.shape_1988 = new cjs.Shape();
	this.shape_1988.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.7,0,11.8,0).s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_1988.setTransform(-237.125,215.025);

	this.shape_1989 = new cjs.Shape();
	this.shape_1989.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.7,0,11.8,0).s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_1989.setTransform(-193.025,201.275);

	this.shape_1990 = new cjs.Shape();
	this.shape_1990.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_1990.setTransform(-296.25,64.05);

	this.shape_1991 = new cjs.Shape();
	this.shape_1991.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_1991.setTransform(-251.075,56.95);

	this.shape_1992 = new cjs.Shape();
	this.shape_1992.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_1992.setTransform(-205.675,50.875);

	this.shape_1993 = new cjs.Shape();
	this.shape_1993.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.6,0,11.7,0).s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_1993.setTransform(-56.975,176.2);

	this.shape_1994 = new cjs.Shape();
	this.shape_1994.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.8,0,11.8,0).s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_1994.setTransform(-102.95,180.925);

	this.shape_1995 = new cjs.Shape();
	this.shape_1995.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.8,0,11.9,0).s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_1995.setTransform(-148.35,189.375);

	this.shape_1996 = new cjs.Shape();
	this.shape_1996.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_1996.setTransform(-160.5,43.575);

	this.shape_1997 = new cjs.Shape();
	this.shape_1997.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_1997.setTransform(-117.75,28.75);

	this.shape_1998 = new cjs.Shape();
	this.shape_1998.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12.4,0,12.5,0).s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_1998.setTransform(182.575,208.375);

	this.shape_1999 = new cjs.Shape();
	this.shape_1999.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12.4,0,12.5,0).s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_1999.setTransform(229.275,223.775);

	this.shape_2000 = new cjs.Shape();
	this.shape_2000.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12.4,0,12.5,0).s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_2000.setTransform(275.975,239.275);

	this.shape_2001 = new cjs.Shape();
	this.shape_2001.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12.5,0,12.6,0).s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_2001.setTransform(135.325,194.675);

	this.shape_2002 = new cjs.Shape();
	this.shape_2002.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12.5,0,12.6,0).s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_2002.setTransform(87.3,183.95);

	this.shape_2003 = new cjs.Shape();
	this.shape_2003.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12.1,0,12.1,0).s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_2003.setTransform(-10.3,174.675);

	this.shape_2004 = new cjs.Shape();
	this.shape_2004.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12.4,0,12.5,0).s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_2004.setTransform(38.6,177.125);

	this.shape_2005 = new cjs.Shape();
	this.shape_2005.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_2005.setTransform(273.675,16.25);

	this.shape_2006 = new cjs.Shape();
	this.shape_2006.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.2,0,11.3,0).s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_2006.setTransform(509.25,218.425);

	this.shape_2007 = new cjs.Shape();
	this.shape_2007.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12.5,0,12.6,0).s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_2007.setTransform(323.275,252.65);

	this.shape_2008 = new cjs.Shape();
	this.shape_2008.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12.4,0,12.5,0).s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_2008.setTransform(371.7,260.625);

	this.shape_2009 = new cjs.Shape();
	this.shape_2009.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12.5,0,12.6,0).s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_2009.setTransform(420.95,258.85);

	this.shape_2010 = new cjs.Shape();
	this.shape_2010.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12.2,0,12.2,0).s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_2010.setTransform(467.65,244.375);

	this.shape_2011 = new cjs.Shape();
	this.shape_2011.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_2011.setTransform(320.475,28.6);

	this.shape_2012 = new cjs.Shape();
	this.shape_2012.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_2012.setTransform(367,42.55);

	this.shape_2013 = new cjs.Shape();
	this.shape_2013.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_2013.setTransform(457.5,78.175);

	this.shape_2014 = new cjs.Shape();
	this.shape_2014.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_2014.setTransform(412.875,58.825);

	this.shape_2015 = new cjs.Shape();
	this.shape_2015.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_2015.setTransform(539.325,181.675);

	this.shape_2016 = new cjs.Shape();
	this.shape_2016.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_2016.setTransform(534.05,135.7);

	this.shape_2017 = new cjs.Shape();
	this.shape_2017.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_2017.setTransform(499.575,102.375);

	this.shape_2018 = new cjs.Shape();
	this.shape_2018.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_2018.setTransform(273.8,-86.475);

	this.shape_2019 = new cjs.Shape();
	this.shape_2019.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_2019.setTransform(205.1312,-32.65);

	this.shape_2020 = new cjs.Shape();
	this.shape_2020.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_2020.setTransform(231.025,-0.325);

	this.shape_2021 = new cjs.Shape();
	this.shape_2021.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_2021.setTransform(232.95,-65.4);

	this.shape_2022 = new cjs.Shape();
	this.shape_2022.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_2022.setTransform(202.225,-123.35);

	this.shape_2023 = new cjs.Shape();
	this.shape_2023.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_2023.setTransform(298.7901,-104.575);

	this.shape_2024 = new cjs.Shape();
	this.shape_2024.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_2024.setTransform(250.45,-113.45);

	this.shape_2025 = new cjs.Shape();
	this.shape_2025.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_2025.setTransform(67.475,-180.175);

	this.shape_2026 = new cjs.Shape();
	this.shape_2026.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_2026.setTransform(154.35,-135.525);

	this.shape_2027 = new cjs.Shape();
	this.shape_2027.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_2027.setTransform(108.425,-153.25);

	this.shape_2028 = new cjs.Shape();
	this.shape_2028.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_2028.setTransform(32.725,-214.9);

	this.shape_2029 = new cjs.Shape();
	this.shape_2029.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_2029.setTransform(-122.5,-6.825);

	this.shape_2030 = new cjs.Shape();
	this.shape_2030.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_2030.setTransform(-144.525,-186.225);

	this.shape_2031 = new cjs.Shape();
	this.shape_2031.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_2031.setTransform(-159.025,-28.975);

	this.shape_2032 = new cjs.Shape();
	this.shape_2032.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_2032.setTransform(-200.9,-36.7925);

	this.shape_2033 = new cjs.Shape();
	this.shape_2033.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_2033.setTransform(-243.525,-32.85);

	this.shape_2034 = new cjs.Shape();
	this.shape_2034.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_2034.setTransform(-284.875,-21.325);

	this.shape_2035 = new cjs.Shape();
	this.shape_2035.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_2035.setTransform(-266.575,-120.375);

	this.shape_2036 = new cjs.Shape();
	this.shape_2036.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_2036.setTransform(-313.25,-110.575);

	this.shape_2037 = new cjs.Shape();
	this.shape_2037.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_2037.setTransform(-219.775,-130.875);

	this.shape_2038 = new cjs.Shape();
	this.shape_2038.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_2038.setTransform(-177.075,-151.575);

	this.shape_2039 = new cjs.Shape();
	this.shape_2039.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_2039.setTransform(-37.725,-278.5196);

	this.shape_2040 = new cjs.Shape();
	this.shape_2040.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_2040.setTransform(1.75,-253.225);

	this.shape_2041 = new cjs.Shape();
	this.shape_2041.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_2041.setTransform(-114.5,-223.5);

	this.shape_2042 = new cjs.Shape();
	this.shape_2042.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_2042.setTransform(-80.375,-257.35);

	this.shape_2043 = new cjs.Shape();
	this.shape_2043.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_2043.setTransform(-328.05,-10.925);

	this.shape_2044 = new cjs.Shape();
	this.shape_2044.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_2044.setTransform(-373,-12.325);

	this.shape_2045 = new cjs.Shape();
	this.shape_2045.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_2045.setTransform(-358.325,-95.45);

	this.shape_2046 = new cjs.Shape();
	this.shape_2046.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_2046.setTransform(-411.075,-32.2);

	this.shape_2047 = new cjs.Shape();
	this.shape_2047.graphics.lf(["#DA6C1F","#DA753B"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_2047.setTransform(-398.975,-71.425);

	this.shape_2048 = new cjs.Shape();
	this.shape_2048.graphics.lf(["#D17027","#D17841"],[0,1],-11.8,0,11.8,0).s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_2048.setTransform(-465.05,232.125);

	this.shape_2049 = new cjs.Shape();
	this.shape_2049.graphics.lf(["#D17027","#D17841"],[0,1],-11.7,0,11.7,0).s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_2049.setTransform(-419.25,237.75);

	this.shape_2050 = new cjs.Shape();
	this.shape_2050.graphics.lf(["#D17027","#D17841"],[0,1],-11.6,0,11.6,0).s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_2050.setTransform(-372.975,239.5188);

	this.shape_2051 = new cjs.Shape();
	this.shape_2051.graphics.lf(["#D17027","#D17841"],[0,1],-6.2,0,6.3,0).s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_2051.setTransform(-504.875,224.85);

	this.shape_2052 = new cjs.Shape();
	this.shape_2052.graphics.lf(["#D17027","#D17841"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_2052.setTransform(-510.625,132.625);

	this.shape_2053 = new cjs.Shape();
	this.shape_2053.graphics.lf(["#D17027","#D17841"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_2053.setTransform(-468.325,117.725);

	this.shape_2054 = new cjs.Shape();
	this.shape_2054.graphics.lf(["#D17027","#D17841"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_2054.setTransform(-425.825,103.1);

	this.shape_2055 = new cjs.Shape();
	this.shape_2055.graphics.lf(["#D17027","#D17841"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_2055.setTransform(-340.575,74.725);

	this.shape_2056 = new cjs.Shape();
	this.shape_2056.graphics.lf(["#D17027","#D17841"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_2056.setTransform(-383.3,88.725);

	this.shape_2057 = new cjs.Shape();
	this.shape_2057.graphics.lf(["#D17027","#D17841"],[0,1],-11.7,0,11.8,0).s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_2057.setTransform(-326.875,236.275);

	this.shape_2058 = new cjs.Shape();
	this.shape_2058.graphics.lf(["#D17027","#D17841"],[0,1],-11.8,0,11.8,0).s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_2058.setTransform(-281.5,227.7);

	this.shape_2059 = new cjs.Shape();
	this.shape_2059.graphics.lf(["#D17027","#D17841"],[0,1],-11.7,0,11.8,0).s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_2059.setTransform(-237.125,215.025);

	this.shape_2060 = new cjs.Shape();
	this.shape_2060.graphics.lf(["#D17027","#D17841"],[0,1],-11.7,0,11.8,0).s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_2060.setTransform(-193.025,201.275);

	this.shape_2061 = new cjs.Shape();
	this.shape_2061.graphics.lf(["#D17027","#D17841"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_2061.setTransform(-296.25,64.05);

	this.shape_2062 = new cjs.Shape();
	this.shape_2062.graphics.lf(["#D17027","#D17841"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_2062.setTransform(-251.075,56.95);

	this.shape_2063 = new cjs.Shape();
	this.shape_2063.graphics.lf(["#D17027","#D17841"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_2063.setTransform(-205.675,50.875);

	this.shape_2064 = new cjs.Shape();
	this.shape_2064.graphics.lf(["#D17027","#D17841"],[0,1],-11.6,0,11.7,0).s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_2064.setTransform(-56.975,176.2);

	this.shape_2065 = new cjs.Shape();
	this.shape_2065.graphics.lf(["#D17027","#D17841"],[0,1],-11.8,0,11.8,0).s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_2065.setTransform(-102.95,180.925);

	this.shape_2066 = new cjs.Shape();
	this.shape_2066.graphics.lf(["#D17027","#D17841"],[0,1],-11.8,0,11.9,0).s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_2066.setTransform(-148.35,189.375);

	this.shape_2067 = new cjs.Shape();
	this.shape_2067.graphics.lf(["#D17027","#D17841"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_2067.setTransform(-160.5,43.575);

	this.shape_2068 = new cjs.Shape();
	this.shape_2068.graphics.lf(["#D17027","#D17841"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_2068.setTransform(-117.75,28.75);

	this.shape_2069 = new cjs.Shape();
	this.shape_2069.graphics.lf(["#D17027","#D17841"],[0,1],-12.4,0,12.5,0).s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_2069.setTransform(182.575,208.375);

	this.shape_2070 = new cjs.Shape();
	this.shape_2070.graphics.lf(["#D17027","#D17841"],[0,1],-12.4,0,12.5,0).s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_2070.setTransform(229.275,223.775);

	this.shape_2071 = new cjs.Shape();
	this.shape_2071.graphics.lf(["#D17027","#D17841"],[0,1],-12.4,0,12.5,0).s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_2071.setTransform(275.975,239.275);

	this.shape_2072 = new cjs.Shape();
	this.shape_2072.graphics.lf(["#D17027","#D17841"],[0,1],-12.5,0,12.6,0).s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_2072.setTransform(135.325,194.675);

	this.shape_2073 = new cjs.Shape();
	this.shape_2073.graphics.lf(["#D17027","#D17841"],[0,1],-12.5,0,12.6,0).s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_2073.setTransform(87.3,183.95);

	this.shape_2074 = new cjs.Shape();
	this.shape_2074.graphics.lf(["#D17027","#D17841"],[0,1],-12.1,0,12.1,0).s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_2074.setTransform(-10.3,174.675);

	this.shape_2075 = new cjs.Shape();
	this.shape_2075.graphics.lf(["#D17027","#D17841"],[0,1],-12.4,0,12.5,0).s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_2075.setTransform(38.6,177.125);

	this.shape_2076 = new cjs.Shape();
	this.shape_2076.graphics.lf(["#D17027","#D17841"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_2076.setTransform(273.675,16.25);

	this.shape_2077 = new cjs.Shape();
	this.shape_2077.graphics.lf(["#D17027","#D17841"],[0,1],-11.2,0,11.3,0).s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_2077.setTransform(509.25,218.425);

	this.shape_2078 = new cjs.Shape();
	this.shape_2078.graphics.lf(["#D17027","#D17841"],[0,1],-12.5,0,12.6,0).s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_2078.setTransform(323.275,252.65);

	this.shape_2079 = new cjs.Shape();
	this.shape_2079.graphics.lf(["#D17027","#D17841"],[0,1],-12.4,0,12.5,0).s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_2079.setTransform(371.7,260.625);

	this.shape_2080 = new cjs.Shape();
	this.shape_2080.graphics.lf(["#D17027","#D17841"],[0,1],-12.5,0,12.6,0).s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_2080.setTransform(420.95,258.85);

	this.shape_2081 = new cjs.Shape();
	this.shape_2081.graphics.lf(["#D17027","#D17841"],[0,1],-12.2,0,12.2,0).s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_2081.setTransform(467.65,244.375);

	this.shape_2082 = new cjs.Shape();
	this.shape_2082.graphics.lf(["#D17027","#D17841"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_2082.setTransform(320.475,28.6);

	this.shape_2083 = new cjs.Shape();
	this.shape_2083.graphics.lf(["#D17027","#D17841"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_2083.setTransform(367,42.55);

	this.shape_2084 = new cjs.Shape();
	this.shape_2084.graphics.lf(["#D17027","#D17841"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_2084.setTransform(457.5,78.175);

	this.shape_2085 = new cjs.Shape();
	this.shape_2085.graphics.lf(["#D17027","#D17841"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_2085.setTransform(412.875,58.825);

	this.shape_2086 = new cjs.Shape();
	this.shape_2086.graphics.lf(["#D17027","#D17841"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_2086.setTransform(539.325,181.675);

	this.shape_2087 = new cjs.Shape();
	this.shape_2087.graphics.lf(["#D17027","#D17841"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_2087.setTransform(534.05,135.7);

	this.shape_2088 = new cjs.Shape();
	this.shape_2088.graphics.lf(["#D17027","#D17841"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_2088.setTransform(499.575,102.375);

	this.shape_2089 = new cjs.Shape();
	this.shape_2089.graphics.lf(["#D17027","#D17841"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_2089.setTransform(273.8,-86.475);

	this.shape_2090 = new cjs.Shape();
	this.shape_2090.graphics.lf(["#D17027","#D17841"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_2090.setTransform(205.1312,-32.65);

	this.shape_2091 = new cjs.Shape();
	this.shape_2091.graphics.lf(["#D17027","#D17841"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_2091.setTransform(231.025,-0.325);

	this.shape_2092 = new cjs.Shape();
	this.shape_2092.graphics.lf(["#D17027","#D17841"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_2092.setTransform(232.95,-65.4);

	this.shape_2093 = new cjs.Shape();
	this.shape_2093.graphics.lf(["#D17027","#D17841"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_2093.setTransform(202.225,-123.35);

	this.shape_2094 = new cjs.Shape();
	this.shape_2094.graphics.lf(["#D17027","#D17841"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_2094.setTransform(298.7901,-104.575);

	this.shape_2095 = new cjs.Shape();
	this.shape_2095.graphics.lf(["#D17027","#D17841"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_2095.setTransform(250.45,-113.45);

	this.shape_2096 = new cjs.Shape();
	this.shape_2096.graphics.lf(["#D17027","#D17841"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_2096.setTransform(67.475,-180.175);

	this.shape_2097 = new cjs.Shape();
	this.shape_2097.graphics.lf(["#D17027","#D17841"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_2097.setTransform(154.35,-135.525);

	this.shape_2098 = new cjs.Shape();
	this.shape_2098.graphics.lf(["#D17027","#D17841"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_2098.setTransform(108.425,-153.25);

	this.shape_2099 = new cjs.Shape();
	this.shape_2099.graphics.lf(["#D17027","#D17841"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_2099.setTransform(32.725,-214.9);

	this.shape_2100 = new cjs.Shape();
	this.shape_2100.graphics.lf(["#D17027","#D17841"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_2100.setTransform(-122.5,-6.825);

	this.shape_2101 = new cjs.Shape();
	this.shape_2101.graphics.lf(["#D17027","#D17841"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_2101.setTransform(-144.525,-186.225);

	this.shape_2102 = new cjs.Shape();
	this.shape_2102.graphics.lf(["#D17027","#D17841"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_2102.setTransform(-159.025,-28.975);

	this.shape_2103 = new cjs.Shape();
	this.shape_2103.graphics.lf(["#D17027","#D17841"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_2103.setTransform(-200.9,-36.7925);

	this.shape_2104 = new cjs.Shape();
	this.shape_2104.graphics.lf(["#D17027","#D17841"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_2104.setTransform(-243.525,-32.85);

	this.shape_2105 = new cjs.Shape();
	this.shape_2105.graphics.lf(["#D17027","#D17841"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_2105.setTransform(-284.875,-21.325);

	this.shape_2106 = new cjs.Shape();
	this.shape_2106.graphics.lf(["#D17027","#D17841"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_2106.setTransform(-266.575,-120.375);

	this.shape_2107 = new cjs.Shape();
	this.shape_2107.graphics.lf(["#D17027","#D17841"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_2107.setTransform(-313.25,-110.575);

	this.shape_2108 = new cjs.Shape();
	this.shape_2108.graphics.lf(["#D17027","#D17841"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_2108.setTransform(-219.775,-130.875);

	this.shape_2109 = new cjs.Shape();
	this.shape_2109.graphics.lf(["#D17027","#D17841"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_2109.setTransform(-177.075,-151.575);

	this.shape_2110 = new cjs.Shape();
	this.shape_2110.graphics.lf(["#D17027","#D17841"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_2110.setTransform(-37.725,-278.5196);

	this.shape_2111 = new cjs.Shape();
	this.shape_2111.graphics.lf(["#D17027","#D17841"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_2111.setTransform(1.75,-253.225);

	this.shape_2112 = new cjs.Shape();
	this.shape_2112.graphics.lf(["#D17027","#D17841"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_2112.setTransform(-114.5,-223.5);

	this.shape_2113 = new cjs.Shape();
	this.shape_2113.graphics.lf(["#D17027","#D17841"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_2113.setTransform(-80.375,-257.35);

	this.shape_2114 = new cjs.Shape();
	this.shape_2114.graphics.lf(["#D17027","#D17841"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_2114.setTransform(-328.05,-10.925);

	this.shape_2115 = new cjs.Shape();
	this.shape_2115.graphics.lf(["#D17027","#D17841"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_2115.setTransform(-373,-12.325);

	this.shape_2116 = new cjs.Shape();
	this.shape_2116.graphics.lf(["#D17027","#D17841"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_2116.setTransform(-358.325,-95.45);

	this.shape_2117 = new cjs.Shape();
	this.shape_2117.graphics.lf(["#D17027","#D17841"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_2117.setTransform(-411.075,-32.2);

	this.shape_2118 = new cjs.Shape();
	this.shape_2118.graphics.lf(["#D17027","#D17841"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_2118.setTransform(-398.975,-71.425);

	this.shape_2119 = new cjs.Shape();
	this.shape_2119.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.8,0,11.8,0).s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_2119.setTransform(-465.05,232.125);

	this.shape_2120 = new cjs.Shape();
	this.shape_2120.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.7,0,11.7,0).s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_2120.setTransform(-419.25,237.75);

	this.shape_2121 = new cjs.Shape();
	this.shape_2121.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.6,0,11.6,0).s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_2121.setTransform(-372.975,239.5188);

	this.shape_2122 = new cjs.Shape();
	this.shape_2122.graphics.lf(["#C8742F","#C87B47"],[0,1],-6.2,0,6.3,0).s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_2122.setTransform(-504.875,224.85);

	this.shape_2123 = new cjs.Shape();
	this.shape_2123.graphics.lf(["#C8742F","#C87B47"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_2123.setTransform(-510.625,132.625);

	this.shape_2124 = new cjs.Shape();
	this.shape_2124.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_2124.setTransform(-468.325,117.725);

	this.shape_2125 = new cjs.Shape();
	this.shape_2125.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_2125.setTransform(-425.825,103.1);

	this.shape_2126 = new cjs.Shape();
	this.shape_2126.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_2126.setTransform(-340.575,74.725);

	this.shape_2127 = new cjs.Shape();
	this.shape_2127.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_2127.setTransform(-383.3,88.725);

	this.shape_2128 = new cjs.Shape();
	this.shape_2128.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.7,0,11.8,0).s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_2128.setTransform(-326.875,236.275);

	this.shape_2129 = new cjs.Shape();
	this.shape_2129.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.8,0,11.8,0).s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_2129.setTransform(-281.5,227.7);

	this.shape_2130 = new cjs.Shape();
	this.shape_2130.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.7,0,11.8,0).s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_2130.setTransform(-237.125,215.025);

	this.shape_2131 = new cjs.Shape();
	this.shape_2131.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.7,0,11.8,0).s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_2131.setTransform(-193.025,201.275);

	this.shape_2132 = new cjs.Shape();
	this.shape_2132.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_2132.setTransform(-296.25,64.05);

	this.shape_2133 = new cjs.Shape();
	this.shape_2133.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_2133.setTransform(-251.075,56.95);

	this.shape_2134 = new cjs.Shape();
	this.shape_2134.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_2134.setTransform(-205.675,50.875);

	this.shape_2135 = new cjs.Shape();
	this.shape_2135.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.6,0,11.7,0).s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_2135.setTransform(-56.975,176.2);

	this.shape_2136 = new cjs.Shape();
	this.shape_2136.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.8,0,11.8,0).s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_2136.setTransform(-102.95,180.925);

	this.shape_2137 = new cjs.Shape();
	this.shape_2137.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.8,0,11.9,0).s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_2137.setTransform(-148.35,189.375);

	this.shape_2138 = new cjs.Shape();
	this.shape_2138.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_2138.setTransform(-160.5,43.575);

	this.shape_2139 = new cjs.Shape();
	this.shape_2139.graphics.lf(["#C8742F","#C87B47"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_2139.setTransform(-117.75,28.75);

	this.shape_2140 = new cjs.Shape();
	this.shape_2140.graphics.lf(["#C8742F","#C87B47"],[0,1],-12.4,0,12.5,0).s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_2140.setTransform(182.575,208.375);

	this.shape_2141 = new cjs.Shape();
	this.shape_2141.graphics.lf(["#C8742F","#C87B47"],[0,1],-12.4,0,12.5,0).s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_2141.setTransform(229.275,223.775);

	this.shape_2142 = new cjs.Shape();
	this.shape_2142.graphics.lf(["#C8742F","#C87B47"],[0,1],-12.4,0,12.5,0).s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_2142.setTransform(275.975,239.275);

	this.shape_2143 = new cjs.Shape();
	this.shape_2143.graphics.lf(["#C8742F","#C87B47"],[0,1],-12.5,0,12.6,0).s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_2143.setTransform(135.325,194.675);

	this.shape_2144 = new cjs.Shape();
	this.shape_2144.graphics.lf(["#C8742F","#C87B47"],[0,1],-12.5,0,12.6,0).s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_2144.setTransform(87.3,183.95);

	this.shape_2145 = new cjs.Shape();
	this.shape_2145.graphics.lf(["#C8742F","#C87B47"],[0,1],-12.1,0,12.1,0).s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_2145.setTransform(-10.3,174.675);

	this.shape_2146 = new cjs.Shape();
	this.shape_2146.graphics.lf(["#C8742F","#C87B47"],[0,1],-12.4,0,12.5,0).s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_2146.setTransform(38.6,177.125);

	this.shape_2147 = new cjs.Shape();
	this.shape_2147.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_2147.setTransform(273.675,16.25);

	this.shape_2148 = new cjs.Shape();
	this.shape_2148.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.2,0,11.3,0).s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_2148.setTransform(509.25,218.425);

	this.shape_2149 = new cjs.Shape();
	this.shape_2149.graphics.lf(["#C8742F","#C87B47"],[0,1],-12.5,0,12.6,0).s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_2149.setTransform(323.275,252.65);

	this.shape_2150 = new cjs.Shape();
	this.shape_2150.graphics.lf(["#C8742F","#C87B47"],[0,1],-12.4,0,12.5,0).s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_2150.setTransform(371.7,260.625);

	this.shape_2151 = new cjs.Shape();
	this.shape_2151.graphics.lf(["#C8742F","#C87B47"],[0,1],-12.5,0,12.6,0).s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_2151.setTransform(420.95,258.85);

	this.shape_2152 = new cjs.Shape();
	this.shape_2152.graphics.lf(["#C8742F","#C87B47"],[0,1],-12.2,0,12.2,0).s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_2152.setTransform(467.65,244.375);

	this.shape_2153 = new cjs.Shape();
	this.shape_2153.graphics.lf(["#C8742F","#C87B47"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_2153.setTransform(320.475,28.6);

	this.shape_2154 = new cjs.Shape();
	this.shape_2154.graphics.lf(["#C8742F","#C87B47"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_2154.setTransform(367,42.55);

	this.shape_2155 = new cjs.Shape();
	this.shape_2155.graphics.lf(["#C8742F","#C87B47"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_2155.setTransform(457.5,78.175);

	this.shape_2156 = new cjs.Shape();
	this.shape_2156.graphics.lf(["#C8742F","#C87B47"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_2156.setTransform(412.875,58.825);

	this.shape_2157 = new cjs.Shape();
	this.shape_2157.graphics.lf(["#C8742F","#C87B47"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_2157.setTransform(539.325,181.675);

	this.shape_2158 = new cjs.Shape();
	this.shape_2158.graphics.lf(["#C8742F","#C87B47"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_2158.setTransform(534.05,135.7);

	this.shape_2159 = new cjs.Shape();
	this.shape_2159.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_2159.setTransform(499.575,102.375);

	this.shape_2160 = new cjs.Shape();
	this.shape_2160.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_2160.setTransform(273.8,-86.475);

	this.shape_2161 = new cjs.Shape();
	this.shape_2161.graphics.lf(["#C8742F","#C87B47"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_2161.setTransform(205.1312,-32.65);

	this.shape_2162 = new cjs.Shape();
	this.shape_2162.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_2162.setTransform(231.025,-0.325);

	this.shape_2163 = new cjs.Shape();
	this.shape_2163.graphics.lf(["#C8742F","#C87B47"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_2163.setTransform(232.95,-65.4);

	this.shape_2164 = new cjs.Shape();
	this.shape_2164.graphics.lf(["#C8742F","#C87B47"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_2164.setTransform(202.225,-123.35);

	this.shape_2165 = new cjs.Shape();
	this.shape_2165.graphics.lf(["#C8742F","#C87B47"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_2165.setTransform(298.7901,-104.575);

	this.shape_2166 = new cjs.Shape();
	this.shape_2166.graphics.lf(["#C8742F","#C87B47"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_2166.setTransform(250.45,-113.45);

	this.shape_2167 = new cjs.Shape();
	this.shape_2167.graphics.lf(["#C8742F","#C87B47"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_2167.setTransform(67.475,-180.175);

	this.shape_2168 = new cjs.Shape();
	this.shape_2168.graphics.lf(["#C8742F","#C87B47"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_2168.setTransform(154.35,-135.525);

	this.shape_2169 = new cjs.Shape();
	this.shape_2169.graphics.lf(["#C8742F","#C87B47"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_2169.setTransform(108.425,-153.25);

	this.shape_2170 = new cjs.Shape();
	this.shape_2170.graphics.lf(["#C8742F","#C87B47"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_2170.setTransform(32.725,-214.9);

	this.shape_2171 = new cjs.Shape();
	this.shape_2171.graphics.lf(["#C8742F","#C87B47"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_2171.setTransform(-122.5,-6.825);

	this.shape_2172 = new cjs.Shape();
	this.shape_2172.graphics.lf(["#C8742F","#C87B47"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_2172.setTransform(-144.525,-186.225);

	this.shape_2173 = new cjs.Shape();
	this.shape_2173.graphics.lf(["#C8742F","#C87B47"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_2173.setTransform(-159.025,-28.975);

	this.shape_2174 = new cjs.Shape();
	this.shape_2174.graphics.lf(["#C8742F","#C87B47"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_2174.setTransform(-200.9,-36.7925);

	this.shape_2175 = new cjs.Shape();
	this.shape_2175.graphics.lf(["#C8742F","#C87B47"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_2175.setTransform(-243.525,-32.85);

	this.shape_2176 = new cjs.Shape();
	this.shape_2176.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_2176.setTransform(-284.875,-21.325);

	this.shape_2177 = new cjs.Shape();
	this.shape_2177.graphics.lf(["#C8742F","#C87B47"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_2177.setTransform(-266.575,-120.375);

	this.shape_2178 = new cjs.Shape();
	this.shape_2178.graphics.lf(["#C8742F","#C87B47"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_2178.setTransform(-313.25,-110.575);

	this.shape_2179 = new cjs.Shape();
	this.shape_2179.graphics.lf(["#C8742F","#C87B47"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_2179.setTransform(-219.775,-130.875);

	this.shape_2180 = new cjs.Shape();
	this.shape_2180.graphics.lf(["#C8742F","#C87B47"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_2180.setTransform(-177.075,-151.575);

	this.shape_2181 = new cjs.Shape();
	this.shape_2181.graphics.lf(["#C8742F","#C87B47"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_2181.setTransform(-37.725,-278.5196);

	this.shape_2182 = new cjs.Shape();
	this.shape_2182.graphics.lf(["#C8742F","#C87B47"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_2182.setTransform(1.75,-253.225);

	this.shape_2183 = new cjs.Shape();
	this.shape_2183.graphics.lf(["#C8742F","#C87B47"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_2183.setTransform(-114.5,-223.5);

	this.shape_2184 = new cjs.Shape();
	this.shape_2184.graphics.lf(["#C8742F","#C87B47"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_2184.setTransform(-80.375,-257.35);

	this.shape_2185 = new cjs.Shape();
	this.shape_2185.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_2185.setTransform(-328.05,-10.925);

	this.shape_2186 = new cjs.Shape();
	this.shape_2186.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_2186.setTransform(-373,-12.325);

	this.shape_2187 = new cjs.Shape();
	this.shape_2187.graphics.lf(["#C8742F","#C87B47"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_2187.setTransform(-358.325,-95.45);

	this.shape_2188 = new cjs.Shape();
	this.shape_2188.graphics.lf(["#C8742F","#C87B47"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_2188.setTransform(-411.075,-32.2);

	this.shape_2189 = new cjs.Shape();
	this.shape_2189.graphics.lf(["#C8742F","#C87B47"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_2189.setTransform(-398.975,-71.425);

	this.shape_2190 = new cjs.Shape();
	this.shape_2190.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.8,0,11.8,0).s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_2190.setTransform(-465.05,232.125);

	this.shape_2191 = new cjs.Shape();
	this.shape_2191.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.7,0,11.7,0).s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_2191.setTransform(-419.25,237.75);

	this.shape_2192 = new cjs.Shape();
	this.shape_2192.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.6,0,11.6,0).s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_2192.setTransform(-372.975,239.5188);

	this.shape_2193 = new cjs.Shape();
	this.shape_2193.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-6.2,0,6.3,0).s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_2193.setTransform(-504.875,224.85);

	this.shape_2194 = new cjs.Shape();
	this.shape_2194.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_2194.setTransform(-510.625,132.625);

	this.shape_2195 = new cjs.Shape();
	this.shape_2195.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_2195.setTransform(-468.325,117.725);

	this.shape_2196 = new cjs.Shape();
	this.shape_2196.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_2196.setTransform(-425.825,103.1);

	this.shape_2197 = new cjs.Shape();
	this.shape_2197.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_2197.setTransform(-340.575,74.725);

	this.shape_2198 = new cjs.Shape();
	this.shape_2198.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_2198.setTransform(-383.3,88.725);

	this.shape_2199 = new cjs.Shape();
	this.shape_2199.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.7,0,11.8,0).s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_2199.setTransform(-326.875,236.275);

	this.shape_2200 = new cjs.Shape();
	this.shape_2200.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.8,0,11.8,0).s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_2200.setTransform(-281.5,227.7);

	this.shape_2201 = new cjs.Shape();
	this.shape_2201.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.7,0,11.8,0).s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_2201.setTransform(-237.125,215.025);

	this.shape_2202 = new cjs.Shape();
	this.shape_2202.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.7,0,11.8,0).s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_2202.setTransform(-193.025,201.275);

	this.shape_2203 = new cjs.Shape();
	this.shape_2203.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_2203.setTransform(-296.25,64.05);

	this.shape_2204 = new cjs.Shape();
	this.shape_2204.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_2204.setTransform(-251.075,56.95);

	this.shape_2205 = new cjs.Shape();
	this.shape_2205.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_2205.setTransform(-205.675,50.875);

	this.shape_2206 = new cjs.Shape();
	this.shape_2206.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.6,0,11.7,0).s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_2206.setTransform(-56.975,176.2);

	this.shape_2207 = new cjs.Shape();
	this.shape_2207.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.8,0,11.8,0).s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_2207.setTransform(-102.95,180.925);

	this.shape_2208 = new cjs.Shape();
	this.shape_2208.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.8,0,11.9,0).s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_2208.setTransform(-148.35,189.375);

	this.shape_2209 = new cjs.Shape();
	this.shape_2209.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_2209.setTransform(-160.5,43.575);

	this.shape_2210 = new cjs.Shape();
	this.shape_2210.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_2210.setTransform(-117.75,28.75);

	this.shape_2211 = new cjs.Shape();
	this.shape_2211.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12.4,0,12.5,0).s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_2211.setTransform(182.575,208.375);

	this.shape_2212 = new cjs.Shape();
	this.shape_2212.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12.4,0,12.5,0).s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_2212.setTransform(229.275,223.775);

	this.shape_2213 = new cjs.Shape();
	this.shape_2213.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12.4,0,12.5,0).s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_2213.setTransform(275.975,239.275);

	this.shape_2214 = new cjs.Shape();
	this.shape_2214.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12.5,0,12.6,0).s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_2214.setTransform(135.325,194.675);

	this.shape_2215 = new cjs.Shape();
	this.shape_2215.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12.5,0,12.6,0).s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_2215.setTransform(87.3,183.95);

	this.shape_2216 = new cjs.Shape();
	this.shape_2216.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12.1,0,12.1,0).s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_2216.setTransform(-10.3,174.675);

	this.shape_2217 = new cjs.Shape();
	this.shape_2217.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12.4,0,12.5,0).s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_2217.setTransform(38.6,177.125);

	this.shape_2218 = new cjs.Shape();
	this.shape_2218.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_2218.setTransform(273.675,16.25);

	this.shape_2219 = new cjs.Shape();
	this.shape_2219.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.2,0,11.3,0).s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_2219.setTransform(509.25,218.425);

	this.shape_2220 = new cjs.Shape();
	this.shape_2220.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12.5,0,12.6,0).s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_2220.setTransform(323.275,252.65);

	this.shape_2221 = new cjs.Shape();
	this.shape_2221.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12.4,0,12.5,0).s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_2221.setTransform(371.7,260.625);

	this.shape_2222 = new cjs.Shape();
	this.shape_2222.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12.5,0,12.6,0).s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_2222.setTransform(420.95,258.85);

	this.shape_2223 = new cjs.Shape();
	this.shape_2223.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12.2,0,12.2,0).s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_2223.setTransform(467.65,244.375);

	this.shape_2224 = new cjs.Shape();
	this.shape_2224.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_2224.setTransform(320.475,28.6);

	this.shape_2225 = new cjs.Shape();
	this.shape_2225.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_2225.setTransform(367,42.55);

	this.shape_2226 = new cjs.Shape();
	this.shape_2226.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_2226.setTransform(457.5,78.175);

	this.shape_2227 = new cjs.Shape();
	this.shape_2227.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_2227.setTransform(412.875,58.825);

	this.shape_2228 = new cjs.Shape();
	this.shape_2228.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_2228.setTransform(539.325,181.675);

	this.shape_2229 = new cjs.Shape();
	this.shape_2229.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_2229.setTransform(534.05,135.7);

	this.shape_2230 = new cjs.Shape();
	this.shape_2230.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_2230.setTransform(499.575,102.375);

	this.shape_2231 = new cjs.Shape();
	this.shape_2231.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_2231.setTransform(273.8,-86.475);

	this.shape_2232 = new cjs.Shape();
	this.shape_2232.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_2232.setTransform(205.1312,-32.65);

	this.shape_2233 = new cjs.Shape();
	this.shape_2233.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_2233.setTransform(231.025,-0.325);

	this.shape_2234 = new cjs.Shape();
	this.shape_2234.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_2234.setTransform(232.95,-65.4);

	this.shape_2235 = new cjs.Shape();
	this.shape_2235.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_2235.setTransform(202.225,-123.35);

	this.shape_2236 = new cjs.Shape();
	this.shape_2236.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_2236.setTransform(298.7901,-104.575);

	this.shape_2237 = new cjs.Shape();
	this.shape_2237.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_2237.setTransform(250.45,-113.45);

	this.shape_2238 = new cjs.Shape();
	this.shape_2238.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_2238.setTransform(67.475,-180.175);

	this.shape_2239 = new cjs.Shape();
	this.shape_2239.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_2239.setTransform(154.35,-135.525);

	this.shape_2240 = new cjs.Shape();
	this.shape_2240.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_2240.setTransform(108.425,-153.25);

	this.shape_2241 = new cjs.Shape();
	this.shape_2241.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_2241.setTransform(32.725,-214.9);

	this.shape_2242 = new cjs.Shape();
	this.shape_2242.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_2242.setTransform(-122.5,-6.825);

	this.shape_2243 = new cjs.Shape();
	this.shape_2243.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_2243.setTransform(-144.525,-186.225);

	this.shape_2244 = new cjs.Shape();
	this.shape_2244.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_2244.setTransform(-159.025,-28.975);

	this.shape_2245 = new cjs.Shape();
	this.shape_2245.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_2245.setTransform(-200.9,-36.7925);

	this.shape_2246 = new cjs.Shape();
	this.shape_2246.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_2246.setTransform(-243.525,-32.85);

	this.shape_2247 = new cjs.Shape();
	this.shape_2247.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_2247.setTransform(-284.875,-21.325);

	this.shape_2248 = new cjs.Shape();
	this.shape_2248.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_2248.setTransform(-266.575,-120.375);

	this.shape_2249 = new cjs.Shape();
	this.shape_2249.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_2249.setTransform(-313.25,-110.575);

	this.shape_2250 = new cjs.Shape();
	this.shape_2250.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_2250.setTransform(-219.775,-130.875);

	this.shape_2251 = new cjs.Shape();
	this.shape_2251.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_2251.setTransform(-177.075,-151.575);

	this.shape_2252 = new cjs.Shape();
	this.shape_2252.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_2252.setTransform(-37.725,-278.5196);

	this.shape_2253 = new cjs.Shape();
	this.shape_2253.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_2253.setTransform(1.75,-253.225);

	this.shape_2254 = new cjs.Shape();
	this.shape_2254.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_2254.setTransform(-114.5,-223.5);

	this.shape_2255 = new cjs.Shape();
	this.shape_2255.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_2255.setTransform(-80.375,-257.35);

	this.shape_2256 = new cjs.Shape();
	this.shape_2256.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_2256.setTransform(-328.05,-10.925);

	this.shape_2257 = new cjs.Shape();
	this.shape_2257.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_2257.setTransform(-373,-12.325);

	this.shape_2258 = new cjs.Shape();
	this.shape_2258.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_2258.setTransform(-358.325,-95.45);

	this.shape_2259 = new cjs.Shape();
	this.shape_2259.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_2259.setTransform(-411.075,-32.2);

	this.shape_2260 = new cjs.Shape();
	this.shape_2260.graphics.lf(["#BE7737","#BE7E4E"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_2260.setTransform(-398.975,-71.425);

	this.shape_2261 = new cjs.Shape();
	this.shape_2261.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.8,0,11.8,0).s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_2261.setTransform(-465.05,232.125);

	this.shape_2262 = new cjs.Shape();
	this.shape_2262.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.7,0,11.7,0).s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_2262.setTransform(-419.25,237.75);

	this.shape_2263 = new cjs.Shape();
	this.shape_2263.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.6,0,11.6,0).s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_2263.setTransform(-372.975,239.5188);

	this.shape_2264 = new cjs.Shape();
	this.shape_2264.graphics.lf(["#B57B3F","#B58154"],[0,1],-6.2,0,6.3,0).s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_2264.setTransform(-504.875,224.85);

	this.shape_2265 = new cjs.Shape();
	this.shape_2265.graphics.lf(["#B57B3F","#B58154"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_2265.setTransform(-510.625,132.625);

	this.shape_2266 = new cjs.Shape();
	this.shape_2266.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_2266.setTransform(-468.325,117.725);

	this.shape_2267 = new cjs.Shape();
	this.shape_2267.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_2267.setTransform(-425.825,103.1);

	this.shape_2268 = new cjs.Shape();
	this.shape_2268.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_2268.setTransform(-340.575,74.725);

	this.shape_2269 = new cjs.Shape();
	this.shape_2269.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_2269.setTransform(-383.3,88.725);

	this.shape_2270 = new cjs.Shape();
	this.shape_2270.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.7,0,11.8,0).s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_2270.setTransform(-326.875,236.275);

	this.shape_2271 = new cjs.Shape();
	this.shape_2271.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.8,0,11.8,0).s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_2271.setTransform(-281.5,227.7);

	this.shape_2272 = new cjs.Shape();
	this.shape_2272.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.7,0,11.8,0).s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_2272.setTransform(-237.125,215.025);

	this.shape_2273 = new cjs.Shape();
	this.shape_2273.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.7,0,11.8,0).s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_2273.setTransform(-193.025,201.275);

	this.shape_2274 = new cjs.Shape();
	this.shape_2274.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_2274.setTransform(-296.25,64.05);

	this.shape_2275 = new cjs.Shape();
	this.shape_2275.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_2275.setTransform(-251.075,56.95);

	this.shape_2276 = new cjs.Shape();
	this.shape_2276.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_2276.setTransform(-205.675,50.875);

	this.shape_2277 = new cjs.Shape();
	this.shape_2277.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.6,0,11.7,0).s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_2277.setTransform(-56.975,176.2);

	this.shape_2278 = new cjs.Shape();
	this.shape_2278.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.8,0,11.8,0).s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_2278.setTransform(-102.95,180.925);

	this.shape_2279 = new cjs.Shape();
	this.shape_2279.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.8,0,11.9,0).s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_2279.setTransform(-148.35,189.375);

	this.shape_2280 = new cjs.Shape();
	this.shape_2280.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_2280.setTransform(-160.5,43.575);

	this.shape_2281 = new cjs.Shape();
	this.shape_2281.graphics.lf(["#B57B3F","#B58154"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_2281.setTransform(-117.75,28.75);

	this.shape_2282 = new cjs.Shape();
	this.shape_2282.graphics.lf(["#B57B3F","#B58154"],[0,1],-12.4,0,12.5,0).s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_2282.setTransform(182.575,208.375);

	this.shape_2283 = new cjs.Shape();
	this.shape_2283.graphics.lf(["#B57B3F","#B58154"],[0,1],-12.4,0,12.5,0).s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_2283.setTransform(229.275,223.775);

	this.shape_2284 = new cjs.Shape();
	this.shape_2284.graphics.lf(["#B57B3F","#B58154"],[0,1],-12.4,0,12.5,0).s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_2284.setTransform(275.975,239.275);

	this.shape_2285 = new cjs.Shape();
	this.shape_2285.graphics.lf(["#B57B3F","#B58154"],[0,1],-12.5,0,12.6,0).s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_2285.setTransform(135.325,194.675);

	this.shape_2286 = new cjs.Shape();
	this.shape_2286.graphics.lf(["#B57B3F","#B58154"],[0,1],-12.5,0,12.6,0).s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_2286.setTransform(87.3,183.95);

	this.shape_2287 = new cjs.Shape();
	this.shape_2287.graphics.lf(["#B57B3F","#B58154"],[0,1],-12.1,0,12.1,0).s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_2287.setTransform(-10.3,174.675);

	this.shape_2288 = new cjs.Shape();
	this.shape_2288.graphics.lf(["#B57B3F","#B58154"],[0,1],-12.4,0,12.5,0).s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_2288.setTransform(38.6,177.125);

	this.shape_2289 = new cjs.Shape();
	this.shape_2289.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_2289.setTransform(273.675,16.25);

	this.shape_2290 = new cjs.Shape();
	this.shape_2290.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.2,0,11.3,0).s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_2290.setTransform(509.25,218.425);

	this.shape_2291 = new cjs.Shape();
	this.shape_2291.graphics.lf(["#B57B3F","#B58154"],[0,1],-12.5,0,12.6,0).s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_2291.setTransform(323.275,252.65);

	this.shape_2292 = new cjs.Shape();
	this.shape_2292.graphics.lf(["#B57B3F","#B58154"],[0,1],-12.4,0,12.5,0).s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_2292.setTransform(371.7,260.625);

	this.shape_2293 = new cjs.Shape();
	this.shape_2293.graphics.lf(["#B57B3F","#B58154"],[0,1],-12.5,0,12.6,0).s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_2293.setTransform(420.95,258.85);

	this.shape_2294 = new cjs.Shape();
	this.shape_2294.graphics.lf(["#B57B3F","#B58154"],[0,1],-12.2,0,12.2,0).s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_2294.setTransform(467.65,244.375);

	this.shape_2295 = new cjs.Shape();
	this.shape_2295.graphics.lf(["#B57B3F","#B58154"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_2295.setTransform(320.475,28.6);

	this.shape_2296 = new cjs.Shape();
	this.shape_2296.graphics.lf(["#B57B3F","#B58154"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_2296.setTransform(367,42.55);

	this.shape_2297 = new cjs.Shape();
	this.shape_2297.graphics.lf(["#B57B3F","#B58154"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_2297.setTransform(457.5,78.175);

	this.shape_2298 = new cjs.Shape();
	this.shape_2298.graphics.lf(["#B57B3F","#B58154"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_2298.setTransform(412.875,58.825);

	this.shape_2299 = new cjs.Shape();
	this.shape_2299.graphics.lf(["#B57B3F","#B58154"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_2299.setTransform(539.325,181.675);

	this.shape_2300 = new cjs.Shape();
	this.shape_2300.graphics.lf(["#B57B3F","#B58154"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_2300.setTransform(534.05,135.7);

	this.shape_2301 = new cjs.Shape();
	this.shape_2301.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_2301.setTransform(499.575,102.375);

	this.shape_2302 = new cjs.Shape();
	this.shape_2302.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_2302.setTransform(273.8,-86.475);

	this.shape_2303 = new cjs.Shape();
	this.shape_2303.graphics.lf(["#B57B3F","#B58154"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_2303.setTransform(205.1312,-32.65);

	this.shape_2304 = new cjs.Shape();
	this.shape_2304.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_2304.setTransform(231.025,-0.325);

	this.shape_2305 = new cjs.Shape();
	this.shape_2305.graphics.lf(["#B57B3F","#B58154"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_2305.setTransform(232.95,-65.4);

	this.shape_2306 = new cjs.Shape();
	this.shape_2306.graphics.lf(["#B57B3F","#B58154"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_2306.setTransform(202.225,-123.35);

	this.shape_2307 = new cjs.Shape();
	this.shape_2307.graphics.lf(["#B57B3F","#B58154"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_2307.setTransform(298.7901,-104.575);

	this.shape_2308 = new cjs.Shape();
	this.shape_2308.graphics.lf(["#B57B3F","#B58154"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_2308.setTransform(250.45,-113.45);

	this.shape_2309 = new cjs.Shape();
	this.shape_2309.graphics.lf(["#B57B3F","#B58154"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_2309.setTransform(67.475,-180.175);

	this.shape_2310 = new cjs.Shape();
	this.shape_2310.graphics.lf(["#B57B3F","#B58154"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_2310.setTransform(154.35,-135.525);

	this.shape_2311 = new cjs.Shape();
	this.shape_2311.graphics.lf(["#B57B3F","#B58154"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_2311.setTransform(108.425,-153.25);

	this.shape_2312 = new cjs.Shape();
	this.shape_2312.graphics.lf(["#B57B3F","#B58154"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_2312.setTransform(32.725,-214.9);

	this.shape_2313 = new cjs.Shape();
	this.shape_2313.graphics.lf(["#B57B3F","#B58154"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_2313.setTransform(-122.5,-6.825);

	this.shape_2314 = new cjs.Shape();
	this.shape_2314.graphics.lf(["#B57B3F","#B58154"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_2314.setTransform(-144.525,-186.225);

	this.shape_2315 = new cjs.Shape();
	this.shape_2315.graphics.lf(["#B57B3F","#B58154"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_2315.setTransform(-159.025,-28.975);

	this.shape_2316 = new cjs.Shape();
	this.shape_2316.graphics.lf(["#B57B3F","#B58154"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_2316.setTransform(-200.9,-36.7925);

	this.shape_2317 = new cjs.Shape();
	this.shape_2317.graphics.lf(["#B57B3F","#B58154"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_2317.setTransform(-243.525,-32.85);

	this.shape_2318 = new cjs.Shape();
	this.shape_2318.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_2318.setTransform(-284.875,-21.325);

	this.shape_2319 = new cjs.Shape();
	this.shape_2319.graphics.lf(["#B57B3F","#B58154"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_2319.setTransform(-266.575,-120.375);

	this.shape_2320 = new cjs.Shape();
	this.shape_2320.graphics.lf(["#B57B3F","#B58154"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_2320.setTransform(-313.25,-110.575);

	this.shape_2321 = new cjs.Shape();
	this.shape_2321.graphics.lf(["#B57B3F","#B58154"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_2321.setTransform(-219.775,-130.875);

	this.shape_2322 = new cjs.Shape();
	this.shape_2322.graphics.lf(["#B57B3F","#B58154"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_2322.setTransform(-177.075,-151.575);

	this.shape_2323 = new cjs.Shape();
	this.shape_2323.graphics.lf(["#B57B3F","#B58154"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_2323.setTransform(-37.725,-278.5196);

	this.shape_2324 = new cjs.Shape();
	this.shape_2324.graphics.lf(["#B57B3F","#B58154"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_2324.setTransform(1.75,-253.225);

	this.shape_2325 = new cjs.Shape();
	this.shape_2325.graphics.lf(["#B57B3F","#B58154"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_2325.setTransform(-114.5,-223.5);

	this.shape_2326 = new cjs.Shape();
	this.shape_2326.graphics.lf(["#B57B3F","#B58154"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_2326.setTransform(-80.375,-257.35);

	this.shape_2327 = new cjs.Shape();
	this.shape_2327.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_2327.setTransform(-328.05,-10.925);

	this.shape_2328 = new cjs.Shape();
	this.shape_2328.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_2328.setTransform(-373,-12.325);

	this.shape_2329 = new cjs.Shape();
	this.shape_2329.graphics.lf(["#B57B3F","#B58154"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_2329.setTransform(-358.325,-95.45);

	this.shape_2330 = new cjs.Shape();
	this.shape_2330.graphics.lf(["#B57B3F","#B58154"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_2330.setTransform(-411.075,-32.2);

	this.shape_2331 = new cjs.Shape();
	this.shape_2331.graphics.lf(["#B57B3F","#B58154"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_2331.setTransform(-398.975,-71.425);

	this.shape_2332 = new cjs.Shape();
	this.shape_2332.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.8,0,11.8,0).s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_2332.setTransform(-465.05,232.125);

	this.shape_2333 = new cjs.Shape();
	this.shape_2333.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.7,0,11.7,0).s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_2333.setTransform(-419.25,237.75);

	this.shape_2334 = new cjs.Shape();
	this.shape_2334.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.6,0,11.6,0).s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_2334.setTransform(-372.975,239.5188);

	this.shape_2335 = new cjs.Shape();
	this.shape_2335.graphics.lf(["#AC7E46","#AC855B"],[0,1],-6.2,0,6.3,0).s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_2335.setTransform(-504.875,224.85);

	this.shape_2336 = new cjs.Shape();
	this.shape_2336.graphics.lf(["#AC7E46","#AC855B"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_2336.setTransform(-510.625,132.625);

	this.shape_2337 = new cjs.Shape();
	this.shape_2337.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_2337.setTransform(-468.325,117.725);

	this.shape_2338 = new cjs.Shape();
	this.shape_2338.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_2338.setTransform(-425.825,103.1);

	this.shape_2339 = new cjs.Shape();
	this.shape_2339.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_2339.setTransform(-340.575,74.725);

	this.shape_2340 = new cjs.Shape();
	this.shape_2340.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_2340.setTransform(-383.3,88.725);

	this.shape_2341 = new cjs.Shape();
	this.shape_2341.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.7,0,11.8,0).s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_2341.setTransform(-326.875,236.275);

	this.shape_2342 = new cjs.Shape();
	this.shape_2342.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.8,0,11.8,0).s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_2342.setTransform(-281.5,227.7);

	this.shape_2343 = new cjs.Shape();
	this.shape_2343.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.7,0,11.8,0).s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_2343.setTransform(-237.125,215.025);

	this.shape_2344 = new cjs.Shape();
	this.shape_2344.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.7,0,11.8,0).s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_2344.setTransform(-193.025,201.275);

	this.shape_2345 = new cjs.Shape();
	this.shape_2345.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_2345.setTransform(-296.25,64.05);

	this.shape_2346 = new cjs.Shape();
	this.shape_2346.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_2346.setTransform(-251.075,56.95);

	this.shape_2347 = new cjs.Shape();
	this.shape_2347.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_2347.setTransform(-205.675,50.875);

	this.shape_2348 = new cjs.Shape();
	this.shape_2348.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.6,0,11.7,0).s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_2348.setTransform(-56.975,176.2);

	this.shape_2349 = new cjs.Shape();
	this.shape_2349.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.8,0,11.8,0).s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_2349.setTransform(-102.95,180.925);

	this.shape_2350 = new cjs.Shape();
	this.shape_2350.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.8,0,11.9,0).s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_2350.setTransform(-148.35,189.375);

	this.shape_2351 = new cjs.Shape();
	this.shape_2351.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_2351.setTransform(-160.5,43.575);

	this.shape_2352 = new cjs.Shape();
	this.shape_2352.graphics.lf(["#AC7E46","#AC855B"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_2352.setTransform(-117.75,28.75);

	this.shape_2353 = new cjs.Shape();
	this.shape_2353.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12.4,0,12.5,0).s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_2353.setTransform(182.575,208.375);

	this.shape_2354 = new cjs.Shape();
	this.shape_2354.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12.4,0,12.5,0).s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_2354.setTransform(229.275,223.775);

	this.shape_2355 = new cjs.Shape();
	this.shape_2355.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12.4,0,12.5,0).s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_2355.setTransform(275.975,239.275);

	this.shape_2356 = new cjs.Shape();
	this.shape_2356.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12.5,0,12.6,0).s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_2356.setTransform(135.325,194.675);

	this.shape_2357 = new cjs.Shape();
	this.shape_2357.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12.5,0,12.6,0).s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_2357.setTransform(87.3,183.95);

	this.shape_2358 = new cjs.Shape();
	this.shape_2358.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12.1,0,12.1,0).s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_2358.setTransform(-10.3,174.675);

	this.shape_2359 = new cjs.Shape();
	this.shape_2359.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12.4,0,12.5,0).s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_2359.setTransform(38.6,177.125);

	this.shape_2360 = new cjs.Shape();
	this.shape_2360.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_2360.setTransform(273.675,16.25);

	this.shape_2361 = new cjs.Shape();
	this.shape_2361.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.2,0,11.3,0).s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_2361.setTransform(509.25,218.425);

	this.shape_2362 = new cjs.Shape();
	this.shape_2362.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12.5,0,12.6,0).s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_2362.setTransform(323.275,252.65);

	this.shape_2363 = new cjs.Shape();
	this.shape_2363.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12.4,0,12.5,0).s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_2363.setTransform(371.7,260.625);

	this.shape_2364 = new cjs.Shape();
	this.shape_2364.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12.5,0,12.6,0).s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_2364.setTransform(420.95,258.85);

	this.shape_2365 = new cjs.Shape();
	this.shape_2365.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12.2,0,12.2,0).s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_2365.setTransform(467.65,244.375);

	this.shape_2366 = new cjs.Shape();
	this.shape_2366.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_2366.setTransform(320.475,28.6);

	this.shape_2367 = new cjs.Shape();
	this.shape_2367.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_2367.setTransform(367,42.55);

	this.shape_2368 = new cjs.Shape();
	this.shape_2368.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_2368.setTransform(457.5,78.175);

	this.shape_2369 = new cjs.Shape();
	this.shape_2369.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_2369.setTransform(412.875,58.825);

	this.shape_2370 = new cjs.Shape();
	this.shape_2370.graphics.lf(["#AC7E46","#AC855B"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_2370.setTransform(539.325,181.675);

	this.shape_2371 = new cjs.Shape();
	this.shape_2371.graphics.lf(["#AC7E46","#AC855B"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_2371.setTransform(534.05,135.7);

	this.shape_2372 = new cjs.Shape();
	this.shape_2372.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_2372.setTransform(499.575,102.375);

	this.shape_2373 = new cjs.Shape();
	this.shape_2373.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_2373.setTransform(273.8,-86.475);

	this.shape_2374 = new cjs.Shape();
	this.shape_2374.graphics.lf(["#AC7E46","#AC855B"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_2374.setTransform(205.1312,-32.65);

	this.shape_2375 = new cjs.Shape();
	this.shape_2375.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_2375.setTransform(231.025,-0.325);

	this.shape_2376 = new cjs.Shape();
	this.shape_2376.graphics.lf(["#AC7E46","#AC855B"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_2376.setTransform(232.95,-65.4);

	this.shape_2377 = new cjs.Shape();
	this.shape_2377.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_2377.setTransform(202.225,-123.35);

	this.shape_2378 = new cjs.Shape();
	this.shape_2378.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_2378.setTransform(298.7901,-104.575);

	this.shape_2379 = new cjs.Shape();
	this.shape_2379.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_2379.setTransform(250.45,-113.45);

	this.shape_2380 = new cjs.Shape();
	this.shape_2380.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_2380.setTransform(67.475,-180.175);

	this.shape_2381 = new cjs.Shape();
	this.shape_2381.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_2381.setTransform(154.35,-135.525);

	this.shape_2382 = new cjs.Shape();
	this.shape_2382.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_2382.setTransform(108.425,-153.25);

	this.shape_2383 = new cjs.Shape();
	this.shape_2383.graphics.lf(["#AC7E46","#AC855B"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_2383.setTransform(32.725,-214.9);

	this.shape_2384 = new cjs.Shape();
	this.shape_2384.graphics.lf(["#AC7E46","#AC855B"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_2384.setTransform(-122.5,-6.825);

	this.shape_2385 = new cjs.Shape();
	this.shape_2385.graphics.lf(["#AC7E46","#AC855B"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_2385.setTransform(-144.525,-186.225);

	this.shape_2386 = new cjs.Shape();
	this.shape_2386.graphics.lf(["#AC7E46","#AC855B"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_2386.setTransform(-159.025,-28.975);

	this.shape_2387 = new cjs.Shape();
	this.shape_2387.graphics.lf(["#AC7E46","#AC855B"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_2387.setTransform(-200.9,-36.7925);

	this.shape_2388 = new cjs.Shape();
	this.shape_2388.graphics.lf(["#AC7E46","#AC855B"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_2388.setTransform(-243.525,-32.85);

	this.shape_2389 = new cjs.Shape();
	this.shape_2389.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_2389.setTransform(-284.875,-21.325);

	this.shape_2390 = new cjs.Shape();
	this.shape_2390.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_2390.setTransform(-266.575,-120.375);

	this.shape_2391 = new cjs.Shape();
	this.shape_2391.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_2391.setTransform(-313.25,-110.575);

	this.shape_2392 = new cjs.Shape();
	this.shape_2392.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_2392.setTransform(-219.775,-130.875);

	this.shape_2393 = new cjs.Shape();
	this.shape_2393.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_2393.setTransform(-177.075,-151.575);

	this.shape_2394 = new cjs.Shape();
	this.shape_2394.graphics.lf(["#AC7E46","#AC855B"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_2394.setTransform(-37.725,-278.5196);

	this.shape_2395 = new cjs.Shape();
	this.shape_2395.graphics.lf(["#AC7E46","#AC855B"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_2395.setTransform(1.75,-253.225);

	this.shape_2396 = new cjs.Shape();
	this.shape_2396.graphics.lf(["#AC7E46","#AC855B"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_2396.setTransform(-114.5,-223.5);

	this.shape_2397 = new cjs.Shape();
	this.shape_2397.graphics.lf(["#AC7E46","#AC855B"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_2397.setTransform(-80.375,-257.35);

	this.shape_2398 = new cjs.Shape();
	this.shape_2398.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_2398.setTransform(-328.05,-10.925);

	this.shape_2399 = new cjs.Shape();
	this.shape_2399.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_2399.setTransform(-373,-12.325);

	this.shape_2400 = new cjs.Shape();
	this.shape_2400.graphics.lf(["#AC7E46","#AC855B"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_2400.setTransform(-358.325,-95.45);

	this.shape_2401 = new cjs.Shape();
	this.shape_2401.graphics.lf(["#AC7E46","#AC855B"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_2401.setTransform(-411.075,-32.2);

	this.shape_2402 = new cjs.Shape();
	this.shape_2402.graphics.lf(["#AC7E46","#AC855B"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_2402.setTransform(-398.975,-71.425);

	this.shape_2403 = new cjs.Shape();
	this.shape_2403.graphics.lf(["#A3824E","#A38861"],[0,1],-11.8,0,11.8,0).s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_2403.setTransform(-465.05,232.125);

	this.shape_2404 = new cjs.Shape();
	this.shape_2404.graphics.lf(["#A3824E","#A38861"],[0,1],-11.7,0,11.7,0).s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_2404.setTransform(-419.25,237.75);

	this.shape_2405 = new cjs.Shape();
	this.shape_2405.graphics.lf(["#A3824E","#A38861"],[0,1],-11.6,0,11.6,0).s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_2405.setTransform(-372.975,239.5188);

	this.shape_2406 = new cjs.Shape();
	this.shape_2406.graphics.lf(["#A3824E","#A38861"],[0,1],-6.2,0,6.3,0).s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_2406.setTransform(-504.875,224.85);

	this.shape_2407 = new cjs.Shape();
	this.shape_2407.graphics.lf(["#A3824E","#A38861"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_2407.setTransform(-510.625,132.625);

	this.shape_2408 = new cjs.Shape();
	this.shape_2408.graphics.lf(["#A3824E","#A38861"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_2408.setTransform(-468.325,117.725);

	this.shape_2409 = new cjs.Shape();
	this.shape_2409.graphics.lf(["#A3824E","#A38861"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_2409.setTransform(-425.825,103.1);

	this.shape_2410 = new cjs.Shape();
	this.shape_2410.graphics.lf(["#A3824E","#A38861"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_2410.setTransform(-340.575,74.725);

	this.shape_2411 = new cjs.Shape();
	this.shape_2411.graphics.lf(["#A3824E","#A38861"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_2411.setTransform(-383.3,88.725);

	this.shape_2412 = new cjs.Shape();
	this.shape_2412.graphics.lf(["#A3824E","#A38861"],[0,1],-11.7,0,11.8,0).s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_2412.setTransform(-326.875,236.275);

	this.shape_2413 = new cjs.Shape();
	this.shape_2413.graphics.lf(["#A3824E","#A38861"],[0,1],-11.8,0,11.8,0).s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_2413.setTransform(-281.5,227.7);

	this.shape_2414 = new cjs.Shape();
	this.shape_2414.graphics.lf(["#A3824E","#A38861"],[0,1],-11.7,0,11.8,0).s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_2414.setTransform(-237.125,215.025);

	this.shape_2415 = new cjs.Shape();
	this.shape_2415.graphics.lf(["#A3824E","#A38861"],[0,1],-11.7,0,11.8,0).s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_2415.setTransform(-193.025,201.275);

	this.shape_2416 = new cjs.Shape();
	this.shape_2416.graphics.lf(["#A3824E","#A38861"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_2416.setTransform(-296.25,64.05);

	this.shape_2417 = new cjs.Shape();
	this.shape_2417.graphics.lf(["#A3824E","#A38861"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_2417.setTransform(-251.075,56.95);

	this.shape_2418 = new cjs.Shape();
	this.shape_2418.graphics.lf(["#A3824E","#A38861"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_2418.setTransform(-205.675,50.875);

	this.shape_2419 = new cjs.Shape();
	this.shape_2419.graphics.lf(["#A3824E","#A38861"],[0,1],-11.6,0,11.7,0).s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_2419.setTransform(-56.975,176.2);

	this.shape_2420 = new cjs.Shape();
	this.shape_2420.graphics.lf(["#A3824E","#A38861"],[0,1],-11.8,0,11.8,0).s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_2420.setTransform(-102.95,180.925);

	this.shape_2421 = new cjs.Shape();
	this.shape_2421.graphics.lf(["#A3824E","#A38861"],[0,1],-11.8,0,11.9,0).s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_2421.setTransform(-148.35,189.375);

	this.shape_2422 = new cjs.Shape();
	this.shape_2422.graphics.lf(["#A3824E","#A38861"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_2422.setTransform(-160.5,43.575);

	this.shape_2423 = new cjs.Shape();
	this.shape_2423.graphics.lf(["#A3824E","#A38861"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_2423.setTransform(-117.75,28.75);

	this.shape_2424 = new cjs.Shape();
	this.shape_2424.graphics.lf(["#A3824E","#A38861"],[0,1],-12.4,0,12.5,0).s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_2424.setTransform(182.575,208.375);

	this.shape_2425 = new cjs.Shape();
	this.shape_2425.graphics.lf(["#A3824E","#A38861"],[0,1],-12.4,0,12.5,0).s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_2425.setTransform(229.275,223.775);

	this.shape_2426 = new cjs.Shape();
	this.shape_2426.graphics.lf(["#A3824E","#A38861"],[0,1],-12.4,0,12.5,0).s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_2426.setTransform(275.975,239.275);

	this.shape_2427 = new cjs.Shape();
	this.shape_2427.graphics.lf(["#A3824E","#A38861"],[0,1],-12.5,0,12.6,0).s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_2427.setTransform(135.325,194.675);

	this.shape_2428 = new cjs.Shape();
	this.shape_2428.graphics.lf(["#A3824E","#A38861"],[0,1],-12.5,0,12.6,0).s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_2428.setTransform(87.3,183.95);

	this.shape_2429 = new cjs.Shape();
	this.shape_2429.graphics.lf(["#A3824E","#A38861"],[0,1],-12.1,0,12.1,0).s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_2429.setTransform(-10.3,174.675);

	this.shape_2430 = new cjs.Shape();
	this.shape_2430.graphics.lf(["#A3824E","#A38861"],[0,1],-12.4,0,12.5,0).s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_2430.setTransform(38.6,177.125);

	this.shape_2431 = new cjs.Shape();
	this.shape_2431.graphics.lf(["#A3824E","#A38861"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_2431.setTransform(273.675,16.25);

	this.shape_2432 = new cjs.Shape();
	this.shape_2432.graphics.lf(["#A3824E","#A38861"],[0,1],-11.2,0,11.3,0).s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_2432.setTransform(509.25,218.425);

	this.shape_2433 = new cjs.Shape();
	this.shape_2433.graphics.lf(["#A3824E","#A38861"],[0,1],-12.5,0,12.6,0).s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_2433.setTransform(323.275,252.65);

	this.shape_2434 = new cjs.Shape();
	this.shape_2434.graphics.lf(["#A3824E","#A38861"],[0,1],-12.4,0,12.5,0).s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_2434.setTransform(371.7,260.625);

	this.shape_2435 = new cjs.Shape();
	this.shape_2435.graphics.lf(["#A3824E","#A38861"],[0,1],-12.5,0,12.6,0).s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_2435.setTransform(420.95,258.85);

	this.shape_2436 = new cjs.Shape();
	this.shape_2436.graphics.lf(["#A3824E","#A38861"],[0,1],-12.2,0,12.2,0).s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_2436.setTransform(467.65,244.375);

	this.shape_2437 = new cjs.Shape();
	this.shape_2437.graphics.lf(["#A3824E","#A38861"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_2437.setTransform(320.475,28.6);

	this.shape_2438 = new cjs.Shape();
	this.shape_2438.graphics.lf(["#A3824E","#A38861"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_2438.setTransform(367,42.55);

	this.shape_2439 = new cjs.Shape();
	this.shape_2439.graphics.lf(["#A3824E","#A38861"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_2439.setTransform(457.5,78.175);

	this.shape_2440 = new cjs.Shape();
	this.shape_2440.graphics.lf(["#A3824E","#A38861"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_2440.setTransform(412.875,58.825);

	this.shape_2441 = new cjs.Shape();
	this.shape_2441.graphics.lf(["#A3824E","#A38861"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_2441.setTransform(539.325,181.675);

	this.shape_2442 = new cjs.Shape();
	this.shape_2442.graphics.lf(["#A3824E","#A38861"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_2442.setTransform(534.05,135.7);

	this.shape_2443 = new cjs.Shape();
	this.shape_2443.graphics.lf(["#A3824E","#A38861"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_2443.setTransform(499.575,102.375);

	this.shape_2444 = new cjs.Shape();
	this.shape_2444.graphics.lf(["#A3824E","#A38861"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_2444.setTransform(273.8,-86.475);

	this.shape_2445 = new cjs.Shape();
	this.shape_2445.graphics.lf(["#A3824E","#A38861"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_2445.setTransform(205.1312,-32.65);

	this.shape_2446 = new cjs.Shape();
	this.shape_2446.graphics.lf(["#A3824E","#A38861"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_2446.setTransform(231.025,-0.325);

	this.shape_2447 = new cjs.Shape();
	this.shape_2447.graphics.lf(["#A3824E","#A38861"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_2447.setTransform(232.95,-65.4);

	this.shape_2448 = new cjs.Shape();
	this.shape_2448.graphics.lf(["#A3824E","#A38861"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_2448.setTransform(202.225,-123.35);

	this.shape_2449 = new cjs.Shape();
	this.shape_2449.graphics.lf(["#A3824E","#A38861"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_2449.setTransform(298.7901,-104.575);

	this.shape_2450 = new cjs.Shape();
	this.shape_2450.graphics.lf(["#A3824E","#A38861"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_2450.setTransform(250.45,-113.45);

	this.shape_2451 = new cjs.Shape();
	this.shape_2451.graphics.lf(["#A3824E","#A38861"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_2451.setTransform(67.475,-180.175);

	this.shape_2452 = new cjs.Shape();
	this.shape_2452.graphics.lf(["#A3824E","#A38861"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_2452.setTransform(154.35,-135.525);

	this.shape_2453 = new cjs.Shape();
	this.shape_2453.graphics.lf(["#A3824E","#A38861"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_2453.setTransform(108.425,-153.25);

	this.shape_2454 = new cjs.Shape();
	this.shape_2454.graphics.lf(["#A3824E","#A38861"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_2454.setTransform(32.725,-214.9);

	this.shape_2455 = new cjs.Shape();
	this.shape_2455.graphics.lf(["#A3824E","#A38861"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_2455.setTransform(-122.5,-6.825);

	this.shape_2456 = new cjs.Shape();
	this.shape_2456.graphics.lf(["#A3824E","#A38861"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_2456.setTransform(-144.525,-186.225);

	this.shape_2457 = new cjs.Shape();
	this.shape_2457.graphics.lf(["#A3824E","#A38861"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_2457.setTransform(-159.025,-28.975);

	this.shape_2458 = new cjs.Shape();
	this.shape_2458.graphics.lf(["#A3824E","#A38861"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_2458.setTransform(-200.9,-36.7925);

	this.shape_2459 = new cjs.Shape();
	this.shape_2459.graphics.lf(["#A3824E","#A38861"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_2459.setTransform(-243.525,-32.85);

	this.shape_2460 = new cjs.Shape();
	this.shape_2460.graphics.lf(["#A3824E","#A38861"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_2460.setTransform(-284.875,-21.325);

	this.shape_2461 = new cjs.Shape();
	this.shape_2461.graphics.lf(["#A3824E","#A38861"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_2461.setTransform(-266.575,-120.375);

	this.shape_2462 = new cjs.Shape();
	this.shape_2462.graphics.lf(["#A3824E","#A38861"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_2462.setTransform(-313.25,-110.575);

	this.shape_2463 = new cjs.Shape();
	this.shape_2463.graphics.lf(["#A3824E","#A38861"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_2463.setTransform(-219.775,-130.875);

	this.shape_2464 = new cjs.Shape();
	this.shape_2464.graphics.lf(["#A3824E","#A38861"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_2464.setTransform(-177.075,-151.575);

	this.shape_2465 = new cjs.Shape();
	this.shape_2465.graphics.lf(["#A3824E","#A38861"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_2465.setTransform(-37.725,-278.5196);

	this.shape_2466 = new cjs.Shape();
	this.shape_2466.graphics.lf(["#A3824E","#A38861"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_2466.setTransform(1.75,-253.225);

	this.shape_2467 = new cjs.Shape();
	this.shape_2467.graphics.lf(["#A3824E","#A38861"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_2467.setTransform(-114.5,-223.5);

	this.shape_2468 = new cjs.Shape();
	this.shape_2468.graphics.lf(["#A3824E","#A38861"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_2468.setTransform(-80.375,-257.35);

	this.shape_2469 = new cjs.Shape();
	this.shape_2469.graphics.lf(["#A3824E","#A38861"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_2469.setTransform(-328.05,-10.925);

	this.shape_2470 = new cjs.Shape();
	this.shape_2470.graphics.lf(["#A3824E","#A38861"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_2470.setTransform(-373,-12.325);

	this.shape_2471 = new cjs.Shape();
	this.shape_2471.graphics.lf(["#A3824E","#A38861"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_2471.setTransform(-358.325,-95.45);

	this.shape_2472 = new cjs.Shape();
	this.shape_2472.graphics.lf(["#A3824E","#A38861"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_2472.setTransform(-411.075,-32.2);

	this.shape_2473 = new cjs.Shape();
	this.shape_2473.graphics.lf(["#A3824E","#A38861"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_2473.setTransform(-398.975,-71.425);

	this.shape_2474 = new cjs.Shape();
	this.shape_2474.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.8,0,11.8,0).s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_2474.setTransform(-465.05,232.125);

	this.shape_2475 = new cjs.Shape();
	this.shape_2475.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.7,0,11.7,0).s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_2475.setTransform(-419.25,237.75);

	this.shape_2476 = new cjs.Shape();
	this.shape_2476.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.6,0,11.6,0).s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_2476.setTransform(-372.975,239.5188);

	this.shape_2477 = new cjs.Shape();
	this.shape_2477.graphics.lf(["#9A8656","#9A8B67"],[0,1],-6.2,0,6.3,0).s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_2477.setTransform(-504.875,224.85);

	this.shape_2478 = new cjs.Shape();
	this.shape_2478.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.7,0,11.8,0).s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_2478.setTransform(-326.875,236.275);

	this.shape_2479 = new cjs.Shape();
	this.shape_2479.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.8,0,11.8,0).s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_2479.setTransform(-281.5,227.7);

	this.shape_2480 = new cjs.Shape();
	this.shape_2480.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.7,0,11.8,0).s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_2480.setTransform(-237.125,215.025);

	this.shape_2481 = new cjs.Shape();
	this.shape_2481.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.7,0,11.8,0).s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_2481.setTransform(-193.025,201.275);

	this.shape_2482 = new cjs.Shape();
	this.shape_2482.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.6,0,11.7,0).s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_2482.setTransform(-56.975,176.2);

	this.shape_2483 = new cjs.Shape();
	this.shape_2483.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.8,0,11.8,0).s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_2483.setTransform(-102.95,180.925);

	this.shape_2484 = new cjs.Shape();
	this.shape_2484.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.8,0,11.9,0).s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_2484.setTransform(-148.35,189.375);

	this.shape_2485 = new cjs.Shape();
	this.shape_2485.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12.4,0,12.5,0).s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_2485.setTransform(182.575,208.375);

	this.shape_2486 = new cjs.Shape();
	this.shape_2486.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12.4,0,12.5,0).s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_2486.setTransform(229.275,223.775);

	this.shape_2487 = new cjs.Shape();
	this.shape_2487.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12.4,0,12.5,0).s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_2487.setTransform(275.975,239.275);

	this.shape_2488 = new cjs.Shape();
	this.shape_2488.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12.5,0,12.6,0).s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_2488.setTransform(135.325,194.675);

	this.shape_2489 = new cjs.Shape();
	this.shape_2489.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12.5,0,12.6,0).s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_2489.setTransform(87.3,183.95);

	this.shape_2490 = new cjs.Shape();
	this.shape_2490.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12.1,0,12.1,0).s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_2490.setTransform(-10.3,174.675);

	this.shape_2491 = new cjs.Shape();
	this.shape_2491.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12.4,0,12.5,0).s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_2491.setTransform(38.6,177.125);

	this.shape_2492 = new cjs.Shape();
	this.shape_2492.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_2492.setTransform(273.675,16.25);

	this.shape_2493 = new cjs.Shape();
	this.shape_2493.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.2,0,11.3,0).s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_2493.setTransform(509.25,218.425);

	this.shape_2494 = new cjs.Shape();
	this.shape_2494.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12.5,0,12.6,0).s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_2494.setTransform(323.275,252.65);

	this.shape_2495 = new cjs.Shape();
	this.shape_2495.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12.4,0,12.5,0).s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_2495.setTransform(371.7,260.625);

	this.shape_2496 = new cjs.Shape();
	this.shape_2496.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12.5,0,12.6,0).s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_2496.setTransform(420.95,258.85);

	this.shape_2497 = new cjs.Shape();
	this.shape_2497.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12.2,0,12.2,0).s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_2497.setTransform(467.65,244.375);

	this.shape_2498 = new cjs.Shape();
	this.shape_2498.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_2498.setTransform(320.475,28.6);

	this.shape_2499 = new cjs.Shape();
	this.shape_2499.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_2499.setTransform(367,42.55);

	this.shape_2500 = new cjs.Shape();
	this.shape_2500.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_2500.setTransform(457.5,78.175);

	this.shape_2501 = new cjs.Shape();
	this.shape_2501.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_2501.setTransform(412.875,58.825);

	this.shape_2502 = new cjs.Shape();
	this.shape_2502.graphics.lf(["#9A8656","#9A8B67"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_2502.setTransform(539.325,181.675);

	this.shape_2503 = new cjs.Shape();
	this.shape_2503.graphics.lf(["#9A8656","#9A8B67"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_2503.setTransform(534.05,135.7);

	this.shape_2504 = new cjs.Shape();
	this.shape_2504.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_2504.setTransform(499.575,102.375);

	this.shape_2505 = new cjs.Shape();
	this.shape_2505.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_2505.setTransform(273.8,-86.475);

	this.shape_2506 = new cjs.Shape();
	this.shape_2506.graphics.lf(["#9A8656","#9A8B67"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_2506.setTransform(205.1312,-32.65);

	this.shape_2507 = new cjs.Shape();
	this.shape_2507.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_2507.setTransform(231.025,-0.325);

	this.shape_2508 = new cjs.Shape();
	this.shape_2508.graphics.lf(["#9A8656","#9A8B67"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_2508.setTransform(232.95,-65.4);

	this.shape_2509 = new cjs.Shape();
	this.shape_2509.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_2509.setTransform(202.225,-123.35);

	this.shape_2510 = new cjs.Shape();
	this.shape_2510.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_2510.setTransform(298.7901,-104.575);

	this.shape_2511 = new cjs.Shape();
	this.shape_2511.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_2511.setTransform(250.45,-113.45);

	this.shape_2512 = new cjs.Shape();
	this.shape_2512.graphics.lf(["#9A8656","#9A8B67"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_2512.setTransform(67.475,-180.175);

	this.shape_2513 = new cjs.Shape();
	this.shape_2513.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_2513.setTransform(154.35,-135.525);

	this.shape_2514 = new cjs.Shape();
	this.shape_2514.graphics.lf(["#9A8656","#9A8B67"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_2514.setTransform(108.425,-153.25);

	this.shape_2515 = new cjs.Shape();
	this.shape_2515.graphics.lf(["#9A8656","#9A8B67"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_2515.setTransform(32.725,-214.9);

	this.shape_2516 = new cjs.Shape();
	this.shape_2516.graphics.lf(["#9A8656","#9A8B67"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_2516.setTransform(1.75,-253.225);

	this.shape_2517 = new cjs.Shape();
	this.shape_2517.graphics.lf(["#90895E","#908E6E"],[0,1],-11.8,0,11.8,0).s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_2517.setTransform(-465.05,232.125);

	this.shape_2518 = new cjs.Shape();
	this.shape_2518.graphics.lf(["#90895E","#908E6E"],[0,1],-11.7,0,11.7,0).s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_2518.setTransform(-419.25,237.75);

	this.shape_2519 = new cjs.Shape();
	this.shape_2519.graphics.lf(["#90895E","#908E6E"],[0,1],-11.6,0,11.6,0).s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_2519.setTransform(-372.975,239.5188);

	this.shape_2520 = new cjs.Shape();
	this.shape_2520.graphics.lf(["#90895E","#908E6E"],[0,1],-6.2,0,6.3,0).s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_2520.setTransform(-504.875,224.85);

	this.shape_2521 = new cjs.Shape();
	this.shape_2521.graphics.lf(["#90895E","#908E6E"],[0,1],-11.7,0,11.8,0).s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_2521.setTransform(-326.875,236.275);

	this.shape_2522 = new cjs.Shape();
	this.shape_2522.graphics.lf(["#90895E","#908E6E"],[0,1],-11.8,0,11.8,0).s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_2522.setTransform(-281.5,227.7);

	this.shape_2523 = new cjs.Shape();
	this.shape_2523.graphics.lf(["#90895E","#908E6E"],[0,1],-11.7,0,11.8,0).s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_2523.setTransform(-237.125,215.025);

	this.shape_2524 = new cjs.Shape();
	this.shape_2524.graphics.lf(["#90895E","#908E6E"],[0,1],-11.7,0,11.8,0).s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_2524.setTransform(-193.025,201.275);

	this.shape_2525 = new cjs.Shape();
	this.shape_2525.graphics.lf(["#90895E","#908E6E"],[0,1],-11.6,0,11.7,0).s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_2525.setTransform(-56.975,176.2);

	this.shape_2526 = new cjs.Shape();
	this.shape_2526.graphics.lf(["#90895E","#908E6E"],[0,1],-11.8,0,11.8,0).s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_2526.setTransform(-102.95,180.925);

	this.shape_2527 = new cjs.Shape();
	this.shape_2527.graphics.lf(["#90895E","#908E6E"],[0,1],-11.8,0,11.9,0).s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_2527.setTransform(-148.35,189.375);

	this.shape_2528 = new cjs.Shape();
	this.shape_2528.graphics.lf(["#90895E","#908E6E"],[0,1],-12.4,0,12.5,0).s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_2528.setTransform(182.575,208.375);

	this.shape_2529 = new cjs.Shape();
	this.shape_2529.graphics.lf(["#90895E","#908E6E"],[0,1],-12.4,0,12.5,0).s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_2529.setTransform(229.275,223.775);

	this.shape_2530 = new cjs.Shape();
	this.shape_2530.graphics.lf(["#90895E","#908E6E"],[0,1],-12.4,0,12.5,0).s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_2530.setTransform(275.975,239.275);

	this.shape_2531 = new cjs.Shape();
	this.shape_2531.graphics.lf(["#90895E","#908E6E"],[0,1],-12.5,0,12.6,0).s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_2531.setTransform(135.325,194.675);

	this.shape_2532 = new cjs.Shape();
	this.shape_2532.graphics.lf(["#90895E","#908E6E"],[0,1],-12.5,0,12.6,0).s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_2532.setTransform(87.3,183.95);

	this.shape_2533 = new cjs.Shape();
	this.shape_2533.graphics.lf(["#90895E","#908E6E"],[0,1],-12.1,0,12.1,0).s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_2533.setTransform(-10.3,174.675);

	this.shape_2534 = new cjs.Shape();
	this.shape_2534.graphics.lf(["#90895E","#908E6E"],[0,1],-12.4,0,12.5,0).s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_2534.setTransform(38.6,177.125);

	this.shape_2535 = new cjs.Shape();
	this.shape_2535.graphics.lf(["#90895E","#908E6E"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_2535.setTransform(273.675,16.25);

	this.shape_2536 = new cjs.Shape();
	this.shape_2536.graphics.lf(["#90895E","#908E6E"],[0,1],-11.2,0,11.3,0).s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_2536.setTransform(509.25,218.425);

	this.shape_2537 = new cjs.Shape();
	this.shape_2537.graphics.lf(["#90895E","#908E6E"],[0,1],-12.5,0,12.6,0).s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_2537.setTransform(323.275,252.65);

	this.shape_2538 = new cjs.Shape();
	this.shape_2538.graphics.lf(["#90895E","#908E6E"],[0,1],-12.4,0,12.5,0).s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_2538.setTransform(371.7,260.625);

	this.shape_2539 = new cjs.Shape();
	this.shape_2539.graphics.lf(["#90895E","#908E6E"],[0,1],-12.5,0,12.6,0).s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_2539.setTransform(420.95,258.85);

	this.shape_2540 = new cjs.Shape();
	this.shape_2540.graphics.lf(["#90895E","#908E6E"],[0,1],-12.2,0,12.2,0).s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_2540.setTransform(467.65,244.375);

	this.shape_2541 = new cjs.Shape();
	this.shape_2541.graphics.lf(["#90895E","#908E6E"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_2541.setTransform(320.475,28.6);

	this.shape_2542 = new cjs.Shape();
	this.shape_2542.graphics.lf(["#90895E","#908E6E"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_2542.setTransform(367,42.55);

	this.shape_2543 = new cjs.Shape();
	this.shape_2543.graphics.lf(["#90895E","#908E6E"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_2543.setTransform(457.5,78.175);

	this.shape_2544 = new cjs.Shape();
	this.shape_2544.graphics.lf(["#90895E","#908E6E"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_2544.setTransform(412.875,58.825);

	this.shape_2545 = new cjs.Shape();
	this.shape_2545.graphics.lf(["#90895E","#908E6E"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_2545.setTransform(539.325,181.675);

	this.shape_2546 = new cjs.Shape();
	this.shape_2546.graphics.lf(["#90895E","#908E6E"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_2546.setTransform(534.05,135.7);

	this.shape_2547 = new cjs.Shape();
	this.shape_2547.graphics.lf(["#90895E","#908E6E"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_2547.setTransform(499.575,102.375);

	this.shape_2548 = new cjs.Shape();
	this.shape_2548.graphics.lf(["#90895E","#908E6E"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_2548.setTransform(273.8,-86.475);

	this.shape_2549 = new cjs.Shape();
	this.shape_2549.graphics.lf(["#90895E","#908E6E"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_2549.setTransform(205.1312,-32.65);

	this.shape_2550 = new cjs.Shape();
	this.shape_2550.graphics.lf(["#90895E","#908E6E"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_2550.setTransform(231.025,-0.325);

	this.shape_2551 = new cjs.Shape();
	this.shape_2551.graphics.lf(["#90895E","#908E6E"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_2551.setTransform(232.95,-65.4);

	this.shape_2552 = new cjs.Shape();
	this.shape_2552.graphics.lf(["#90895E","#908E6E"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_2552.setTransform(202.225,-123.35);

	this.shape_2553 = new cjs.Shape();
	this.shape_2553.graphics.lf(["#90895E","#908E6E"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_2553.setTransform(298.7901,-104.575);

	this.shape_2554 = new cjs.Shape();
	this.shape_2554.graphics.lf(["#90895E","#908E6E"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_2554.setTransform(250.45,-113.45);

	this.shape_2555 = new cjs.Shape();
	this.shape_2555.graphics.lf(["#90895E","#908E6E"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_2555.setTransform(67.475,-180.175);

	this.shape_2556 = new cjs.Shape();
	this.shape_2556.graphics.lf(["#90895E","#908E6E"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_2556.setTransform(154.35,-135.525);

	this.shape_2557 = new cjs.Shape();
	this.shape_2557.graphics.lf(["#90895E","#908E6E"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_2557.setTransform(108.425,-153.25);

	this.shape_2558 = new cjs.Shape();
	this.shape_2558.graphics.lf(["#90895E","#908E6E"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_2558.setTransform(32.725,-214.9);

	this.shape_2559 = new cjs.Shape();
	this.shape_2559.graphics.lf(["#90895E","#908E6E"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_2559.setTransform(1.75,-253.225);

	this.shape_2560 = new cjs.Shape();
	this.shape_2560.graphics.lf(["#878D66","#879174"],[0,1],-11.8,0,11.8,0).s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_2560.setTransform(-465.05,232.125);

	this.shape_2561 = new cjs.Shape();
	this.shape_2561.graphics.lf(["#878D66","#879174"],[0,1],-11.7,0,11.7,0).s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_2561.setTransform(-419.25,237.75);

	this.shape_2562 = new cjs.Shape();
	this.shape_2562.graphics.lf(["#878D66","#879174"],[0,1],-11.6,0,11.6,0).s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_2562.setTransform(-372.975,239.5188);

	this.shape_2563 = new cjs.Shape();
	this.shape_2563.graphics.lf(["#878D66","#879174"],[0,1],-6.2,0,6.3,0).s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_2563.setTransform(-504.875,224.85);

	this.shape_2564 = new cjs.Shape();
	this.shape_2564.graphics.lf(["#878D66","#879174"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_2564.setTransform(-510.625,132.625);

	this.shape_2565 = new cjs.Shape();
	this.shape_2565.graphics.lf(["#878D66","#879174"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_2565.setTransform(-468.325,117.725);

	this.shape_2566 = new cjs.Shape();
	this.shape_2566.graphics.lf(["#878D66","#879174"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_2566.setTransform(-425.825,103.1);

	this.shape_2567 = new cjs.Shape();
	this.shape_2567.graphics.lf(["#878D66","#879174"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_2567.setTransform(-340.575,74.725);

	this.shape_2568 = new cjs.Shape();
	this.shape_2568.graphics.lf(["#878D66","#879174"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_2568.setTransform(-383.3,88.725);

	this.shape_2569 = new cjs.Shape();
	this.shape_2569.graphics.lf(["#878D66","#879174"],[0,1],-11.7,0,11.8,0).s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_2569.setTransform(-326.875,236.275);

	this.shape_2570 = new cjs.Shape();
	this.shape_2570.graphics.lf(["#878D66","#879174"],[0,1],-11.8,0,11.8,0).s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_2570.setTransform(-281.5,227.7);

	this.shape_2571 = new cjs.Shape();
	this.shape_2571.graphics.lf(["#878D66","#879174"],[0,1],-11.7,0,11.8,0).s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_2571.setTransform(-237.125,215.025);

	this.shape_2572 = new cjs.Shape();
	this.shape_2572.graphics.lf(["#878D66","#879174"],[0,1],-11.7,0,11.8,0).s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_2572.setTransform(-193.025,201.275);

	this.shape_2573 = new cjs.Shape();
	this.shape_2573.graphics.lf(["#878D66","#879174"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_2573.setTransform(-296.25,64.05);

	this.shape_2574 = new cjs.Shape();
	this.shape_2574.graphics.lf(["#878D66","#879174"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_2574.setTransform(-251.075,56.95);

	this.shape_2575 = new cjs.Shape();
	this.shape_2575.graphics.lf(["#878D66","#879174"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_2575.setTransform(-205.675,50.875);

	this.shape_2576 = new cjs.Shape();
	this.shape_2576.graphics.lf(["#878D66","#879174"],[0,1],-11.6,0,11.7,0).s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_2576.setTransform(-56.975,176.2);

	this.shape_2577 = new cjs.Shape();
	this.shape_2577.graphics.lf(["#878D66","#879174"],[0,1],-11.8,0,11.8,0).s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_2577.setTransform(-102.95,180.925);

	this.shape_2578 = new cjs.Shape();
	this.shape_2578.graphics.lf(["#878D66","#879174"],[0,1],-11.8,0,11.9,0).s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_2578.setTransform(-148.35,189.375);

	this.shape_2579 = new cjs.Shape();
	this.shape_2579.graphics.lf(["#878D66","#879174"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_2579.setTransform(-160.5,43.575);

	this.shape_2580 = new cjs.Shape();
	this.shape_2580.graphics.lf(["#878D66","#879174"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_2580.setTransform(-117.75,28.75);

	this.shape_2581 = new cjs.Shape();
	this.shape_2581.graphics.lf(["#878D66","#879174"],[0,1],-12.4,0,12.5,0).s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_2581.setTransform(182.575,208.375);

	this.shape_2582 = new cjs.Shape();
	this.shape_2582.graphics.lf(["#878D66","#879174"],[0,1],-12.4,0,12.5,0).s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_2582.setTransform(229.275,223.775);

	this.shape_2583 = new cjs.Shape();
	this.shape_2583.graphics.lf(["#878D66","#879174"],[0,1],-12.4,0,12.5,0).s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_2583.setTransform(275.975,239.275);

	this.shape_2584 = new cjs.Shape();
	this.shape_2584.graphics.lf(["#878D66","#879174"],[0,1],-12.5,0,12.6,0).s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_2584.setTransform(135.325,194.675);

	this.shape_2585 = new cjs.Shape();
	this.shape_2585.graphics.lf(["#878D66","#879174"],[0,1],-12.5,0,12.6,0).s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_2585.setTransform(87.3,183.95);

	this.shape_2586 = new cjs.Shape();
	this.shape_2586.graphics.lf(["#878D66","#879174"],[0,1],-12.1,0,12.1,0).s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_2586.setTransform(-10.3,174.675);

	this.shape_2587 = new cjs.Shape();
	this.shape_2587.graphics.lf(["#878D66","#879174"],[0,1],-12.4,0,12.5,0).s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_2587.setTransform(38.6,177.125);

	this.shape_2588 = new cjs.Shape();
	this.shape_2588.graphics.lf(["#878D66","#879174"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_2588.setTransform(273.675,16.25);

	this.shape_2589 = new cjs.Shape();
	this.shape_2589.graphics.lf(["#878D66","#879174"],[0,1],-11.2,0,11.3,0).s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_2589.setTransform(509.25,218.425);

	this.shape_2590 = new cjs.Shape();
	this.shape_2590.graphics.lf(["#878D66","#879174"],[0,1],-12.5,0,12.6,0).s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_2590.setTransform(323.275,252.65);

	this.shape_2591 = new cjs.Shape();
	this.shape_2591.graphics.lf(["#878D66","#879174"],[0,1],-12.4,0,12.5,0).s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_2591.setTransform(371.7,260.625);

	this.shape_2592 = new cjs.Shape();
	this.shape_2592.graphics.lf(["#878D66","#879174"],[0,1],-12.5,0,12.6,0).s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_2592.setTransform(420.95,258.85);

	this.shape_2593 = new cjs.Shape();
	this.shape_2593.graphics.lf(["#878D66","#879174"],[0,1],-12.2,0,12.2,0).s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_2593.setTransform(467.65,244.375);

	this.shape_2594 = new cjs.Shape();
	this.shape_2594.graphics.lf(["#878D66","#879174"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_2594.setTransform(320.475,28.6);

	this.shape_2595 = new cjs.Shape();
	this.shape_2595.graphics.lf(["#878D66","#879174"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_2595.setTransform(367,42.55);

	this.shape_2596 = new cjs.Shape();
	this.shape_2596.graphics.lf(["#878D66","#879174"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_2596.setTransform(457.5,78.175);

	this.shape_2597 = new cjs.Shape();
	this.shape_2597.graphics.lf(["#878D66","#879174"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_2597.setTransform(412.875,58.825);

	this.shape_2598 = new cjs.Shape();
	this.shape_2598.graphics.lf(["#878D66","#879174"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_2598.setTransform(539.325,181.675);

	this.shape_2599 = new cjs.Shape();
	this.shape_2599.graphics.lf(["#878D66","#879174"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_2599.setTransform(534.05,135.7);

	this.shape_2600 = new cjs.Shape();
	this.shape_2600.graphics.lf(["#878D66","#879174"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_2600.setTransform(499.575,102.375);

	this.shape_2601 = new cjs.Shape();
	this.shape_2601.graphics.lf(["#878D66","#879174"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_2601.setTransform(273.8,-86.475);

	this.shape_2602 = new cjs.Shape();
	this.shape_2602.graphics.lf(["#878D66","#879174"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_2602.setTransform(205.1312,-32.65);

	this.shape_2603 = new cjs.Shape();
	this.shape_2603.graphics.lf(["#878D66","#879174"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_2603.setTransform(231.025,-0.325);

	this.shape_2604 = new cjs.Shape();
	this.shape_2604.graphics.lf(["#878D66","#879174"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_2604.setTransform(232.95,-65.4);

	this.shape_2605 = new cjs.Shape();
	this.shape_2605.graphics.lf(["#878D66","#879174"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_2605.setTransform(202.225,-123.35);

	this.shape_2606 = new cjs.Shape();
	this.shape_2606.graphics.lf(["#878D66","#879174"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_2606.setTransform(298.7901,-104.575);

	this.shape_2607 = new cjs.Shape();
	this.shape_2607.graphics.lf(["#878D66","#879174"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_2607.setTransform(250.45,-113.45);

	this.shape_2608 = new cjs.Shape();
	this.shape_2608.graphics.lf(["#878D66","#879174"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_2608.setTransform(67.475,-180.175);

	this.shape_2609 = new cjs.Shape();
	this.shape_2609.graphics.lf(["#878D66","#879174"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_2609.setTransform(154.35,-135.525);

	this.shape_2610 = new cjs.Shape();
	this.shape_2610.graphics.lf(["#878D66","#879174"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_2610.setTransform(108.425,-153.25);

	this.shape_2611 = new cjs.Shape();
	this.shape_2611.graphics.lf(["#878D66","#879174"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_2611.setTransform(32.725,-214.9);

	this.shape_2612 = new cjs.Shape();
	this.shape_2612.graphics.lf(["#878D66","#879174"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_2612.setTransform(-122.5,-6.825);

	this.shape_2613 = new cjs.Shape();
	this.shape_2613.graphics.lf(["#878D66","#879174"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_2613.setTransform(-144.525,-186.225);

	this.shape_2614 = new cjs.Shape();
	this.shape_2614.graphics.lf(["#878D66","#879174"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_2614.setTransform(-159.025,-28.975);

	this.shape_2615 = new cjs.Shape();
	this.shape_2615.graphics.lf(["#878D66","#879174"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_2615.setTransform(-200.9,-36.7925);

	this.shape_2616 = new cjs.Shape();
	this.shape_2616.graphics.lf(["#878D66","#879174"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_2616.setTransform(-243.525,-32.85);

	this.shape_2617 = new cjs.Shape();
	this.shape_2617.graphics.lf(["#878D66","#879174"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_2617.setTransform(-284.875,-21.325);

	this.shape_2618 = new cjs.Shape();
	this.shape_2618.graphics.lf(["#878D66","#879174"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_2618.setTransform(-266.575,-120.375);

	this.shape_2619 = new cjs.Shape();
	this.shape_2619.graphics.lf(["#878D66","#879174"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_2619.setTransform(-313.25,-110.575);

	this.shape_2620 = new cjs.Shape();
	this.shape_2620.graphics.lf(["#878D66","#879174"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_2620.setTransform(-219.775,-130.875);

	this.shape_2621 = new cjs.Shape();
	this.shape_2621.graphics.lf(["#878D66","#879174"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_2621.setTransform(-177.075,-151.575);

	this.shape_2622 = new cjs.Shape();
	this.shape_2622.graphics.lf(["#878D66","#879174"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_2622.setTransform(-37.725,-278.5196);

	this.shape_2623 = new cjs.Shape();
	this.shape_2623.graphics.lf(["#878D66","#879174"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_2623.setTransform(1.75,-253.225);

	this.shape_2624 = new cjs.Shape();
	this.shape_2624.graphics.lf(["#878D66","#879174"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_2624.setTransform(-114.5,-223.5);

	this.shape_2625 = new cjs.Shape();
	this.shape_2625.graphics.lf(["#878D66","#879174"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_2625.setTransform(-80.375,-257.35);

	this.shape_2626 = new cjs.Shape();
	this.shape_2626.graphics.lf(["#878D66","#879174"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_2626.setTransform(-328.05,-10.925);

	this.shape_2627 = new cjs.Shape();
	this.shape_2627.graphics.lf(["#878D66","#879174"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_2627.setTransform(-373,-12.325);

	this.shape_2628 = new cjs.Shape();
	this.shape_2628.graphics.lf(["#878D66","#879174"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_2628.setTransform(-358.325,-95.45);

	this.shape_2629 = new cjs.Shape();
	this.shape_2629.graphics.lf(["#878D66","#879174"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_2629.setTransform(-411.075,-32.2);

	this.shape_2630 = new cjs.Shape();
	this.shape_2630.graphics.lf(["#878D66","#879174"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_2630.setTransform(-398.975,-71.425);

	this.shape_2631 = new cjs.Shape();
	this.shape_2631.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.8,0,11.8,0).s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_2631.setTransform(-465.05,232.125);

	this.shape_2632 = new cjs.Shape();
	this.shape_2632.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.7,0,11.7,0).s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_2632.setTransform(-419.25,237.75);

	this.shape_2633 = new cjs.Shape();
	this.shape_2633.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.6,0,11.6,0).s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_2633.setTransform(-372.975,239.5188);

	this.shape_2634 = new cjs.Shape();
	this.shape_2634.graphics.lf(["#7E916E","#7E947A"],[0,1],-6.2,0,6.3,0).s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_2634.setTransform(-504.875,224.85);

	this.shape_2635 = new cjs.Shape();
	this.shape_2635.graphics.lf(["#7E916E","#7E947A"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_2635.setTransform(-510.625,132.625);

	this.shape_2636 = new cjs.Shape();
	this.shape_2636.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_2636.setTransform(-468.325,117.725);

	this.shape_2637 = new cjs.Shape();
	this.shape_2637.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_2637.setTransform(-425.825,103.1);

	this.shape_2638 = new cjs.Shape();
	this.shape_2638.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_2638.setTransform(-340.575,74.725);

	this.shape_2639 = new cjs.Shape();
	this.shape_2639.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_2639.setTransform(-383.3,88.725);

	this.shape_2640 = new cjs.Shape();
	this.shape_2640.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.7,0,11.8,0).s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_2640.setTransform(-326.875,236.275);

	this.shape_2641 = new cjs.Shape();
	this.shape_2641.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.8,0,11.8,0).s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_2641.setTransform(-281.5,227.7);

	this.shape_2642 = new cjs.Shape();
	this.shape_2642.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.7,0,11.8,0).s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_2642.setTransform(-237.125,215.025);

	this.shape_2643 = new cjs.Shape();
	this.shape_2643.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.7,0,11.8,0).s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_2643.setTransform(-193.025,201.275);

	this.shape_2644 = new cjs.Shape();
	this.shape_2644.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_2644.setTransform(-296.25,64.05);

	this.shape_2645 = new cjs.Shape();
	this.shape_2645.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_2645.setTransform(-251.075,56.95);

	this.shape_2646 = new cjs.Shape();
	this.shape_2646.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_2646.setTransform(-205.675,50.875);

	this.shape_2647 = new cjs.Shape();
	this.shape_2647.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.6,0,11.7,0).s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_2647.setTransform(-56.975,176.2);

	this.shape_2648 = new cjs.Shape();
	this.shape_2648.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.8,0,11.8,0).s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_2648.setTransform(-102.95,180.925);

	this.shape_2649 = new cjs.Shape();
	this.shape_2649.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.8,0,11.9,0).s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_2649.setTransform(-148.35,189.375);

	this.shape_2650 = new cjs.Shape();
	this.shape_2650.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_2650.setTransform(-160.5,43.575);

	this.shape_2651 = new cjs.Shape();
	this.shape_2651.graphics.lf(["#7E916E","#7E947A"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_2651.setTransform(-117.75,28.75);

	this.shape_2652 = new cjs.Shape();
	this.shape_2652.graphics.lf(["#7E916E","#7E947A"],[0,1],-12.4,0,12.5,0).s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_2652.setTransform(182.575,208.375);

	this.shape_2653 = new cjs.Shape();
	this.shape_2653.graphics.lf(["#7E916E","#7E947A"],[0,1],-12.4,0,12.5,0).s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_2653.setTransform(229.275,223.775);

	this.shape_2654 = new cjs.Shape();
	this.shape_2654.graphics.lf(["#7E916E","#7E947A"],[0,1],-12.4,0,12.5,0).s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_2654.setTransform(275.975,239.275);

	this.shape_2655 = new cjs.Shape();
	this.shape_2655.graphics.lf(["#7E916E","#7E947A"],[0,1],-12.5,0,12.6,0).s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_2655.setTransform(135.325,194.675);

	this.shape_2656 = new cjs.Shape();
	this.shape_2656.graphics.lf(["#7E916E","#7E947A"],[0,1],-12.5,0,12.6,0).s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_2656.setTransform(87.3,183.95);

	this.shape_2657 = new cjs.Shape();
	this.shape_2657.graphics.lf(["#7E916E","#7E947A"],[0,1],-12.1,0,12.1,0).s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_2657.setTransform(-10.3,174.675);

	this.shape_2658 = new cjs.Shape();
	this.shape_2658.graphics.lf(["#7E916E","#7E947A"],[0,1],-12.4,0,12.5,0).s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_2658.setTransform(38.6,177.125);

	this.shape_2659 = new cjs.Shape();
	this.shape_2659.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_2659.setTransform(273.675,16.25);

	this.shape_2660 = new cjs.Shape();
	this.shape_2660.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.2,0,11.3,0).s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_2660.setTransform(509.25,218.425);

	this.shape_2661 = new cjs.Shape();
	this.shape_2661.graphics.lf(["#7E916E","#7E947A"],[0,1],-12.5,0,12.6,0).s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_2661.setTransform(323.275,252.65);

	this.shape_2662 = new cjs.Shape();
	this.shape_2662.graphics.lf(["#7E916E","#7E947A"],[0,1],-12.4,0,12.5,0).s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_2662.setTransform(371.7,260.625);

	this.shape_2663 = new cjs.Shape();
	this.shape_2663.graphics.lf(["#7E916E","#7E947A"],[0,1],-12.5,0,12.6,0).s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_2663.setTransform(420.95,258.85);

	this.shape_2664 = new cjs.Shape();
	this.shape_2664.graphics.lf(["#7E916E","#7E947A"],[0,1],-12.2,0,12.2,0).s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_2664.setTransform(467.65,244.375);

	this.shape_2665 = new cjs.Shape();
	this.shape_2665.graphics.lf(["#7E916E","#7E947A"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_2665.setTransform(320.475,28.6);

	this.shape_2666 = new cjs.Shape();
	this.shape_2666.graphics.lf(["#7E916E","#7E947A"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_2666.setTransform(367,42.55);

	this.shape_2667 = new cjs.Shape();
	this.shape_2667.graphics.lf(["#7E916E","#7E947A"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_2667.setTransform(457.5,78.175);

	this.shape_2668 = new cjs.Shape();
	this.shape_2668.graphics.lf(["#7E916E","#7E947A"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_2668.setTransform(412.875,58.825);

	this.shape_2669 = new cjs.Shape();
	this.shape_2669.graphics.lf(["#7E916E","#7E947A"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_2669.setTransform(539.325,181.675);

	this.shape_2670 = new cjs.Shape();
	this.shape_2670.graphics.lf(["#7E916E","#7E947A"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_2670.setTransform(534.05,135.7);

	this.shape_2671 = new cjs.Shape();
	this.shape_2671.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_2671.setTransform(499.575,102.375);

	this.shape_2672 = new cjs.Shape();
	this.shape_2672.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_2672.setTransform(273.8,-86.475);

	this.shape_2673 = new cjs.Shape();
	this.shape_2673.graphics.lf(["#7E916E","#7E947A"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_2673.setTransform(205.1312,-32.65);

	this.shape_2674 = new cjs.Shape();
	this.shape_2674.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_2674.setTransform(231.025,-0.325);

	this.shape_2675 = new cjs.Shape();
	this.shape_2675.graphics.lf(["#7E916E","#7E947A"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_2675.setTransform(232.95,-65.4);

	this.shape_2676 = new cjs.Shape();
	this.shape_2676.graphics.lf(["#7E916E","#7E947A"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_2676.setTransform(202.225,-123.35);

	this.shape_2677 = new cjs.Shape();
	this.shape_2677.graphics.lf(["#7E916E","#7E947A"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_2677.setTransform(298.7901,-104.575);

	this.shape_2678 = new cjs.Shape();
	this.shape_2678.graphics.lf(["#7E916E","#7E947A"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_2678.setTransform(250.45,-113.45);

	this.shape_2679 = new cjs.Shape();
	this.shape_2679.graphics.lf(["#7E916E","#7E947A"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_2679.setTransform(67.475,-180.175);

	this.shape_2680 = new cjs.Shape();
	this.shape_2680.graphics.lf(["#7E916E","#7E947A"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_2680.setTransform(154.35,-135.525);

	this.shape_2681 = new cjs.Shape();
	this.shape_2681.graphics.lf(["#7E916E","#7E947A"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_2681.setTransform(108.425,-153.25);

	this.shape_2682 = new cjs.Shape();
	this.shape_2682.graphics.lf(["#7E916E","#7E947A"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_2682.setTransform(32.725,-214.9);

	this.shape_2683 = new cjs.Shape();
	this.shape_2683.graphics.lf(["#7E916E","#7E947A"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_2683.setTransform(-122.5,-6.825);

	this.shape_2684 = new cjs.Shape();
	this.shape_2684.graphics.lf(["#7E916E","#7E947A"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_2684.setTransform(-144.525,-186.225);

	this.shape_2685 = new cjs.Shape();
	this.shape_2685.graphics.lf(["#7E916E","#7E947A"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_2685.setTransform(-159.025,-28.975);

	this.shape_2686 = new cjs.Shape();
	this.shape_2686.graphics.lf(["#7E916E","#7E947A"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_2686.setTransform(-200.9,-36.7925);

	this.shape_2687 = new cjs.Shape();
	this.shape_2687.graphics.lf(["#7E916E","#7E947A"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_2687.setTransform(-243.525,-32.85);

	this.shape_2688 = new cjs.Shape();
	this.shape_2688.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_2688.setTransform(-284.875,-21.325);

	this.shape_2689 = new cjs.Shape();
	this.shape_2689.graphics.lf(["#7E916E","#7E947A"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_2689.setTransform(-266.575,-120.375);

	this.shape_2690 = new cjs.Shape();
	this.shape_2690.graphics.lf(["#7E916E","#7E947A"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_2690.setTransform(-313.25,-110.575);

	this.shape_2691 = new cjs.Shape();
	this.shape_2691.graphics.lf(["#7E916E","#7E947A"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_2691.setTransform(-219.775,-130.875);

	this.shape_2692 = new cjs.Shape();
	this.shape_2692.graphics.lf(["#7E916E","#7E947A"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_2692.setTransform(-177.075,-151.575);

	this.shape_2693 = new cjs.Shape();
	this.shape_2693.graphics.lf(["#7E916E","#7E947A"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_2693.setTransform(-37.725,-278.5196);

	this.shape_2694 = new cjs.Shape();
	this.shape_2694.graphics.lf(["#7E916E","#7E947A"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_2694.setTransform(1.75,-253.225);

	this.shape_2695 = new cjs.Shape();
	this.shape_2695.graphics.lf(["#7E916E","#7E947A"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_2695.setTransform(-114.5,-223.5);

	this.shape_2696 = new cjs.Shape();
	this.shape_2696.graphics.lf(["#7E916E","#7E947A"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_2696.setTransform(-80.375,-257.35);

	this.shape_2697 = new cjs.Shape();
	this.shape_2697.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_2697.setTransform(-328.05,-10.925);

	this.shape_2698 = new cjs.Shape();
	this.shape_2698.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_2698.setTransform(-373,-12.325);

	this.shape_2699 = new cjs.Shape();
	this.shape_2699.graphics.lf(["#7E916E","#7E947A"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_2699.setTransform(-358.325,-95.45);

	this.shape_2700 = new cjs.Shape();
	this.shape_2700.graphics.lf(["#7E916E","#7E947A"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_2700.setTransform(-411.075,-32.2);

	this.shape_2701 = new cjs.Shape();
	this.shape_2701.graphics.lf(["#7E916E","#7E947A"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_2701.setTransform(-398.975,-71.425);

	this.shape_2702 = new cjs.Shape();
	this.shape_2702.graphics.lf(["#759475","#759881"],[0,1],-11.8,0,11.8,0).s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_2702.setTransform(-465.05,232.125);

	this.shape_2703 = new cjs.Shape();
	this.shape_2703.graphics.lf(["#759475","#759881"],[0,1],-11.7,0,11.7,0).s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_2703.setTransform(-419.25,237.75);

	this.shape_2704 = new cjs.Shape();
	this.shape_2704.graphics.lf(["#759475","#759881"],[0,1],-11.6,0,11.6,0).s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_2704.setTransform(-372.975,239.5188);

	this.shape_2705 = new cjs.Shape();
	this.shape_2705.graphics.lf(["#759475","#759881"],[0,1],-6.2,0,6.3,0).s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_2705.setTransform(-504.875,224.85);

	this.shape_2706 = new cjs.Shape();
	this.shape_2706.graphics.lf(["#759475","#759881"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_2706.setTransform(-510.625,132.625);

	this.shape_2707 = new cjs.Shape();
	this.shape_2707.graphics.lf(["#759475","#759881"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_2707.setTransform(-468.325,117.725);

	this.shape_2708 = new cjs.Shape();
	this.shape_2708.graphics.lf(["#759475","#759881"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_2708.setTransform(-425.825,103.1);

	this.shape_2709 = new cjs.Shape();
	this.shape_2709.graphics.lf(["#759475","#759881"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_2709.setTransform(-340.575,74.725);

	this.shape_2710 = new cjs.Shape();
	this.shape_2710.graphics.lf(["#759475","#759881"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_2710.setTransform(-383.3,88.725);

	this.shape_2711 = new cjs.Shape();
	this.shape_2711.graphics.lf(["#759475","#759881"],[0,1],-11.7,0,11.8,0).s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_2711.setTransform(-326.875,236.275);

	this.shape_2712 = new cjs.Shape();
	this.shape_2712.graphics.lf(["#759475","#759881"],[0,1],-11.8,0,11.8,0).s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_2712.setTransform(-281.5,227.7);

	this.shape_2713 = new cjs.Shape();
	this.shape_2713.graphics.lf(["#759475","#759881"],[0,1],-11.7,0,11.8,0).s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_2713.setTransform(-237.125,215.025);

	this.shape_2714 = new cjs.Shape();
	this.shape_2714.graphics.lf(["#759475","#759881"],[0,1],-11.7,0,11.8,0).s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_2714.setTransform(-193.025,201.275);

	this.shape_2715 = new cjs.Shape();
	this.shape_2715.graphics.lf(["#759475","#759881"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_2715.setTransform(-296.25,64.05);

	this.shape_2716 = new cjs.Shape();
	this.shape_2716.graphics.lf(["#759475","#759881"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_2716.setTransform(-251.075,56.95);

	this.shape_2717 = new cjs.Shape();
	this.shape_2717.graphics.lf(["#759475","#759881"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_2717.setTransform(-205.675,50.875);

	this.shape_2718 = new cjs.Shape();
	this.shape_2718.graphics.lf(["#759475","#759881"],[0,1],-11.6,0,11.7,0).s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_2718.setTransform(-56.975,176.2);

	this.shape_2719 = new cjs.Shape();
	this.shape_2719.graphics.lf(["#759475","#759881"],[0,1],-11.8,0,11.8,0).s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_2719.setTransform(-102.95,180.925);

	this.shape_2720 = new cjs.Shape();
	this.shape_2720.graphics.lf(["#759475","#759881"],[0,1],-11.8,0,11.9,0).s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_2720.setTransform(-148.35,189.375);

	this.shape_2721 = new cjs.Shape();
	this.shape_2721.graphics.lf(["#759475","#759881"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_2721.setTransform(-160.5,43.575);

	this.shape_2722 = new cjs.Shape();
	this.shape_2722.graphics.lf(["#759475","#759881"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_2722.setTransform(-117.75,28.75);

	this.shape_2723 = new cjs.Shape();
	this.shape_2723.graphics.lf(["#759475","#759881"],[0,1],-12.4,0,12.5,0).s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_2723.setTransform(182.575,208.375);

	this.shape_2724 = new cjs.Shape();
	this.shape_2724.graphics.lf(["#759475","#759881"],[0,1],-12.4,0,12.5,0).s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_2724.setTransform(229.275,223.775);

	this.shape_2725 = new cjs.Shape();
	this.shape_2725.graphics.lf(["#759475","#759881"],[0,1],-12.4,0,12.5,0).s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_2725.setTransform(275.975,239.275);

	this.shape_2726 = new cjs.Shape();
	this.shape_2726.graphics.lf(["#759475","#759881"],[0,1],-12.5,0,12.6,0).s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_2726.setTransform(135.325,194.675);

	this.shape_2727 = new cjs.Shape();
	this.shape_2727.graphics.lf(["#759475","#759881"],[0,1],-12.5,0,12.6,0).s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_2727.setTransform(87.3,183.95);

	this.shape_2728 = new cjs.Shape();
	this.shape_2728.graphics.lf(["#759475","#759881"],[0,1],-12.1,0,12.1,0).s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_2728.setTransform(-10.3,174.675);

	this.shape_2729 = new cjs.Shape();
	this.shape_2729.graphics.lf(["#759475","#759881"],[0,1],-12.4,0,12.5,0).s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_2729.setTransform(38.6,177.125);

	this.shape_2730 = new cjs.Shape();
	this.shape_2730.graphics.lf(["#759475","#759881"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_2730.setTransform(273.675,16.25);

	this.shape_2731 = new cjs.Shape();
	this.shape_2731.graphics.lf(["#759475","#759881"],[0,1],-11.2,0,11.3,0).s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_2731.setTransform(509.25,218.425);

	this.shape_2732 = new cjs.Shape();
	this.shape_2732.graphics.lf(["#759475","#759881"],[0,1],-12.5,0,12.6,0).s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_2732.setTransform(323.275,252.65);

	this.shape_2733 = new cjs.Shape();
	this.shape_2733.graphics.lf(["#759475","#759881"],[0,1],-12.4,0,12.5,0).s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_2733.setTransform(371.7,260.625);

	this.shape_2734 = new cjs.Shape();
	this.shape_2734.graphics.lf(["#759475","#759881"],[0,1],-12.5,0,12.6,0).s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_2734.setTransform(420.95,258.85);

	this.shape_2735 = new cjs.Shape();
	this.shape_2735.graphics.lf(["#759475","#759881"],[0,1],-12.2,0,12.2,0).s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_2735.setTransform(467.65,244.375);

	this.shape_2736 = new cjs.Shape();
	this.shape_2736.graphics.lf(["#759475","#759881"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_2736.setTransform(320.475,28.6);

	this.shape_2737 = new cjs.Shape();
	this.shape_2737.graphics.lf(["#759475","#759881"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_2737.setTransform(367,42.55);

	this.shape_2738 = new cjs.Shape();
	this.shape_2738.graphics.lf(["#759475","#759881"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_2738.setTransform(457.5,78.175);

	this.shape_2739 = new cjs.Shape();
	this.shape_2739.graphics.lf(["#759475","#759881"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_2739.setTransform(412.875,58.825);

	this.shape_2740 = new cjs.Shape();
	this.shape_2740.graphics.lf(["#759475","#759881"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_2740.setTransform(539.325,181.675);

	this.shape_2741 = new cjs.Shape();
	this.shape_2741.graphics.lf(["#759475","#759881"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_2741.setTransform(534.05,135.7);

	this.shape_2742 = new cjs.Shape();
	this.shape_2742.graphics.lf(["#759475","#759881"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_2742.setTransform(499.575,102.375);

	this.shape_2743 = new cjs.Shape();
	this.shape_2743.graphics.lf(["#759475","#759881"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_2743.setTransform(273.8,-86.475);

	this.shape_2744 = new cjs.Shape();
	this.shape_2744.graphics.lf(["#759475","#759881"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_2744.setTransform(205.1312,-32.65);

	this.shape_2745 = new cjs.Shape();
	this.shape_2745.graphics.lf(["#759475","#759881"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_2745.setTransform(231.025,-0.325);

	this.shape_2746 = new cjs.Shape();
	this.shape_2746.graphics.lf(["#759475","#759881"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_2746.setTransform(232.95,-65.4);

	this.shape_2747 = new cjs.Shape();
	this.shape_2747.graphics.lf(["#759475","#759881"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_2747.setTransform(202.225,-123.35);

	this.shape_2748 = new cjs.Shape();
	this.shape_2748.graphics.lf(["#759475","#759881"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_2748.setTransform(298.7901,-104.575);

	this.shape_2749 = new cjs.Shape();
	this.shape_2749.graphics.lf(["#759475","#759881"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_2749.setTransform(250.45,-113.45);

	this.shape_2750 = new cjs.Shape();
	this.shape_2750.graphics.lf(["#759475","#759881"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_2750.setTransform(67.475,-180.175);

	this.shape_2751 = new cjs.Shape();
	this.shape_2751.graphics.lf(["#759475","#759881"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_2751.setTransform(154.35,-135.525);

	this.shape_2752 = new cjs.Shape();
	this.shape_2752.graphics.lf(["#759475","#759881"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_2752.setTransform(108.425,-153.25);

	this.shape_2753 = new cjs.Shape();
	this.shape_2753.graphics.lf(["#759475","#759881"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_2753.setTransform(32.725,-214.9);

	this.shape_2754 = new cjs.Shape();
	this.shape_2754.graphics.lf(["#759475","#759881"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_2754.setTransform(-122.5,-6.825);

	this.shape_2755 = new cjs.Shape();
	this.shape_2755.graphics.lf(["#759475","#759881"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_2755.setTransform(-144.525,-186.225);

	this.shape_2756 = new cjs.Shape();
	this.shape_2756.graphics.lf(["#759475","#759881"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_2756.setTransform(-159.025,-28.975);

	this.shape_2757 = new cjs.Shape();
	this.shape_2757.graphics.lf(["#759475","#759881"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_2757.setTransform(-200.9,-36.7925);

	this.shape_2758 = new cjs.Shape();
	this.shape_2758.graphics.lf(["#759475","#759881"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_2758.setTransform(-243.525,-32.85);

	this.shape_2759 = new cjs.Shape();
	this.shape_2759.graphics.lf(["#759475","#759881"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_2759.setTransform(-284.875,-21.325);

	this.shape_2760 = new cjs.Shape();
	this.shape_2760.graphics.lf(["#759475","#759881"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_2760.setTransform(-266.575,-120.375);

	this.shape_2761 = new cjs.Shape();
	this.shape_2761.graphics.lf(["#759475","#759881"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_2761.setTransform(-313.25,-110.575);

	this.shape_2762 = new cjs.Shape();
	this.shape_2762.graphics.lf(["#759475","#759881"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_2762.setTransform(-219.775,-130.875);

	this.shape_2763 = new cjs.Shape();
	this.shape_2763.graphics.lf(["#759475","#759881"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_2763.setTransform(-177.075,-151.575);

	this.shape_2764 = new cjs.Shape();
	this.shape_2764.graphics.lf(["#759475","#759881"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_2764.setTransform(-37.725,-278.5196);

	this.shape_2765 = new cjs.Shape();
	this.shape_2765.graphics.lf(["#759475","#759881"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_2765.setTransform(1.75,-253.225);

	this.shape_2766 = new cjs.Shape();
	this.shape_2766.graphics.lf(["#759475","#759881"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_2766.setTransform(-114.5,-223.5);

	this.shape_2767 = new cjs.Shape();
	this.shape_2767.graphics.lf(["#759475","#759881"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_2767.setTransform(-80.375,-257.35);

	this.shape_2768 = new cjs.Shape();
	this.shape_2768.graphics.lf(["#759475","#759881"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_2768.setTransform(-328.05,-10.925);

	this.shape_2769 = new cjs.Shape();
	this.shape_2769.graphics.lf(["#759475","#759881"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_2769.setTransform(-373,-12.325);

	this.shape_2770 = new cjs.Shape();
	this.shape_2770.graphics.lf(["#759475","#759881"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_2770.setTransform(-358.325,-95.45);

	this.shape_2771 = new cjs.Shape();
	this.shape_2771.graphics.lf(["#759475","#759881"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_2771.setTransform(-411.075,-32.2);

	this.shape_2772 = new cjs.Shape();
	this.shape_2772.graphics.lf(["#759475","#759881"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_2772.setTransform(-398.975,-71.425);

	this.shape_2773 = new cjs.Shape();
	this.shape_2773.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.8,0,11.8,0).s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_2773.setTransform(-465.05,232.125);

	this.shape_2774 = new cjs.Shape();
	this.shape_2774.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.7,0,11.7,0).s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_2774.setTransform(-419.25,237.75);

	this.shape_2775 = new cjs.Shape();
	this.shape_2775.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.6,0,11.6,0).s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_2775.setTransform(-372.975,239.5188);

	this.shape_2776 = new cjs.Shape();
	this.shape_2776.graphics.lf(["#6C987D","#6C9B87"],[0,1],-6.2,0,6.3,0).s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_2776.setTransform(-504.875,224.85);

	this.shape_2777 = new cjs.Shape();
	this.shape_2777.graphics.lf(["#6C987D","#6C9B87"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_2777.setTransform(-510.625,132.625);

	this.shape_2778 = new cjs.Shape();
	this.shape_2778.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_2778.setTransform(-468.325,117.725);

	this.shape_2779 = new cjs.Shape();
	this.shape_2779.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_2779.setTransform(-425.825,103.1);

	this.shape_2780 = new cjs.Shape();
	this.shape_2780.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_2780.setTransform(-340.575,74.725);

	this.shape_2781 = new cjs.Shape();
	this.shape_2781.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_2781.setTransform(-383.3,88.725);

	this.shape_2782 = new cjs.Shape();
	this.shape_2782.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.7,0,11.8,0).s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_2782.setTransform(-326.875,236.275);

	this.shape_2783 = new cjs.Shape();
	this.shape_2783.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.8,0,11.8,0).s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_2783.setTransform(-281.5,227.7);

	this.shape_2784 = new cjs.Shape();
	this.shape_2784.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.7,0,11.8,0).s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_2784.setTransform(-237.125,215.025);

	this.shape_2785 = new cjs.Shape();
	this.shape_2785.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.7,0,11.8,0).s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_2785.setTransform(-193.025,201.275);

	this.shape_2786 = new cjs.Shape();
	this.shape_2786.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_2786.setTransform(-296.25,64.05);

	this.shape_2787 = new cjs.Shape();
	this.shape_2787.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_2787.setTransform(-251.075,56.95);

	this.shape_2788 = new cjs.Shape();
	this.shape_2788.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_2788.setTransform(-205.675,50.875);

	this.shape_2789 = new cjs.Shape();
	this.shape_2789.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.6,0,11.7,0).s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_2789.setTransform(-56.975,176.2);

	this.shape_2790 = new cjs.Shape();
	this.shape_2790.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.8,0,11.8,0).s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_2790.setTransform(-102.95,180.925);

	this.shape_2791 = new cjs.Shape();
	this.shape_2791.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.8,0,11.9,0).s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_2791.setTransform(-148.35,189.375);

	this.shape_2792 = new cjs.Shape();
	this.shape_2792.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_2792.setTransform(-160.5,43.575);

	this.shape_2793 = new cjs.Shape();
	this.shape_2793.graphics.lf(["#6C987D","#6C9B87"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_2793.setTransform(-117.75,28.75);

	this.shape_2794 = new cjs.Shape();
	this.shape_2794.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12.4,0,12.5,0).s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_2794.setTransform(182.575,208.375);

	this.shape_2795 = new cjs.Shape();
	this.shape_2795.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12.4,0,12.5,0).s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_2795.setTransform(229.275,223.775);

	this.shape_2796 = new cjs.Shape();
	this.shape_2796.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12.4,0,12.5,0).s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_2796.setTransform(275.975,239.275);

	this.shape_2797 = new cjs.Shape();
	this.shape_2797.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12.5,0,12.6,0).s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_2797.setTransform(135.325,194.675);

	this.shape_2798 = new cjs.Shape();
	this.shape_2798.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12.5,0,12.6,0).s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_2798.setTransform(87.3,183.95);

	this.shape_2799 = new cjs.Shape();
	this.shape_2799.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12.1,0,12.1,0).s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_2799.setTransform(-10.3,174.675);

	this.shape_2800 = new cjs.Shape();
	this.shape_2800.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12.4,0,12.5,0).s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_2800.setTransform(38.6,177.125);

	this.shape_2801 = new cjs.Shape();
	this.shape_2801.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_2801.setTransform(273.675,16.25);

	this.shape_2802 = new cjs.Shape();
	this.shape_2802.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.2,0,11.3,0).s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_2802.setTransform(509.25,218.425);

	this.shape_2803 = new cjs.Shape();
	this.shape_2803.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12.5,0,12.6,0).s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_2803.setTransform(323.275,252.65);

	this.shape_2804 = new cjs.Shape();
	this.shape_2804.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12.4,0,12.5,0).s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_2804.setTransform(371.7,260.625);

	this.shape_2805 = new cjs.Shape();
	this.shape_2805.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12.5,0,12.6,0).s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_2805.setTransform(420.95,258.85);

	this.shape_2806 = new cjs.Shape();
	this.shape_2806.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12.2,0,12.2,0).s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_2806.setTransform(467.65,244.375);

	this.shape_2807 = new cjs.Shape();
	this.shape_2807.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_2807.setTransform(320.475,28.6);

	this.shape_2808 = new cjs.Shape();
	this.shape_2808.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_2808.setTransform(367,42.55);

	this.shape_2809 = new cjs.Shape();
	this.shape_2809.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_2809.setTransform(457.5,78.175);

	this.shape_2810 = new cjs.Shape();
	this.shape_2810.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_2810.setTransform(412.875,58.825);

	this.shape_2811 = new cjs.Shape();
	this.shape_2811.graphics.lf(["#6C987D","#6C9B87"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_2811.setTransform(539.325,181.675);

	this.shape_2812 = new cjs.Shape();
	this.shape_2812.graphics.lf(["#6C987D","#6C9B87"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_2812.setTransform(534.05,135.7);

	this.shape_2813 = new cjs.Shape();
	this.shape_2813.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_2813.setTransform(499.575,102.375);

	this.shape_2814 = new cjs.Shape();
	this.shape_2814.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_2814.setTransform(273.8,-86.475);

	this.shape_2815 = new cjs.Shape();
	this.shape_2815.graphics.lf(["#6C987D","#6C9B87"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_2815.setTransform(205.1312,-32.65);

	this.shape_2816 = new cjs.Shape();
	this.shape_2816.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_2816.setTransform(231.025,-0.325);

	this.shape_2817 = new cjs.Shape();
	this.shape_2817.graphics.lf(["#6C987D","#6C9B87"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_2817.setTransform(232.95,-65.4);

	this.shape_2818 = new cjs.Shape();
	this.shape_2818.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_2818.setTransform(202.225,-123.35);

	this.shape_2819 = new cjs.Shape();
	this.shape_2819.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_2819.setTransform(298.7901,-104.575);

	this.shape_2820 = new cjs.Shape();
	this.shape_2820.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_2820.setTransform(250.45,-113.45);

	this.shape_2821 = new cjs.Shape();
	this.shape_2821.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_2821.setTransform(67.475,-180.175);

	this.shape_2822 = new cjs.Shape();
	this.shape_2822.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_2822.setTransform(154.35,-135.525);

	this.shape_2823 = new cjs.Shape();
	this.shape_2823.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_2823.setTransform(108.425,-153.25);

	this.shape_2824 = new cjs.Shape();
	this.shape_2824.graphics.lf(["#6C987D","#6C9B87"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_2824.setTransform(32.725,-214.9);

	this.shape_2825 = new cjs.Shape();
	this.shape_2825.graphics.lf(["#6C987D","#6C9B87"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_2825.setTransform(-122.5,-6.825);

	this.shape_2826 = new cjs.Shape();
	this.shape_2826.graphics.lf(["#6C987D","#6C9B87"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_2826.setTransform(-144.525,-186.225);

	this.shape_2827 = new cjs.Shape();
	this.shape_2827.graphics.lf(["#6C987D","#6C9B87"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_2827.setTransform(-159.025,-28.975);

	this.shape_2828 = new cjs.Shape();
	this.shape_2828.graphics.lf(["#6C987D","#6C9B87"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_2828.setTransform(-200.9,-36.7925);

	this.shape_2829 = new cjs.Shape();
	this.shape_2829.graphics.lf(["#6C987D","#6C9B87"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_2829.setTransform(-243.525,-32.85);

	this.shape_2830 = new cjs.Shape();
	this.shape_2830.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_2830.setTransform(-284.875,-21.325);

	this.shape_2831 = new cjs.Shape();
	this.shape_2831.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_2831.setTransform(-266.575,-120.375);

	this.shape_2832 = new cjs.Shape();
	this.shape_2832.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_2832.setTransform(-313.25,-110.575);

	this.shape_2833 = new cjs.Shape();
	this.shape_2833.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_2833.setTransform(-219.775,-130.875);

	this.shape_2834 = new cjs.Shape();
	this.shape_2834.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_2834.setTransform(-177.075,-151.575);

	this.shape_2835 = new cjs.Shape();
	this.shape_2835.graphics.lf(["#6C987D","#6C9B87"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_2835.setTransform(-37.725,-278.5196);

	this.shape_2836 = new cjs.Shape();
	this.shape_2836.graphics.lf(["#6C987D","#6C9B87"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_2836.setTransform(1.75,-253.225);

	this.shape_2837 = new cjs.Shape();
	this.shape_2837.graphics.lf(["#6C987D","#6C9B87"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_2837.setTransform(-114.5,-223.5);

	this.shape_2838 = new cjs.Shape();
	this.shape_2838.graphics.lf(["#6C987D","#6C9B87"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_2838.setTransform(-80.375,-257.35);

	this.shape_2839 = new cjs.Shape();
	this.shape_2839.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_2839.setTransform(-328.05,-10.925);

	this.shape_2840 = new cjs.Shape();
	this.shape_2840.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_2840.setTransform(-373,-12.325);

	this.shape_2841 = new cjs.Shape();
	this.shape_2841.graphics.lf(["#6C987D","#6C9B87"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_2841.setTransform(-358.325,-95.45);

	this.shape_2842 = new cjs.Shape();
	this.shape_2842.graphics.lf(["#6C987D","#6C9B87"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_2842.setTransform(-411.075,-32.2);

	this.shape_2843 = new cjs.Shape();
	this.shape_2843.graphics.lf(["#6C987D","#6C9B87"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_2843.setTransform(-398.975,-71.425);

	this.shape_2844 = new cjs.Shape();
	this.shape_2844.graphics.lf(["#629B85","#629E8E"],[0,1],-11.8,0,11.8,0).s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_2844.setTransform(-465.05,232.125);

	this.shape_2845 = new cjs.Shape();
	this.shape_2845.graphics.lf(["#629B85","#629E8E"],[0,1],-11.7,0,11.7,0).s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_2845.setTransform(-419.25,237.75);

	this.shape_2846 = new cjs.Shape();
	this.shape_2846.graphics.lf(["#629B85","#629E8E"],[0,1],-11.6,0,11.6,0).s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_2846.setTransform(-372.975,239.5188);

	this.shape_2847 = new cjs.Shape();
	this.shape_2847.graphics.lf(["#629B85","#629E8E"],[0,1],-6.2,0,6.3,0).s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_2847.setTransform(-504.875,224.85);

	this.shape_2848 = new cjs.Shape();
	this.shape_2848.graphics.lf(["#629B85","#629E8E"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_2848.setTransform(-510.625,132.625);

	this.shape_2849 = new cjs.Shape();
	this.shape_2849.graphics.lf(["#629B85","#629E8E"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_2849.setTransform(-468.325,117.725);

	this.shape_2850 = new cjs.Shape();
	this.shape_2850.graphics.lf(["#629B85","#629E8E"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_2850.setTransform(-425.825,103.1);

	this.shape_2851 = new cjs.Shape();
	this.shape_2851.graphics.lf(["#629B85","#629E8E"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_2851.setTransform(-340.575,74.725);

	this.shape_2852 = new cjs.Shape();
	this.shape_2852.graphics.lf(["#629B85","#629E8E"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_2852.setTransform(-383.3,88.725);

	this.shape_2853 = new cjs.Shape();
	this.shape_2853.graphics.lf(["#629B85","#629E8E"],[0,1],-11.7,0,11.8,0).s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_2853.setTransform(-326.875,236.275);

	this.shape_2854 = new cjs.Shape();
	this.shape_2854.graphics.lf(["#629B85","#629E8E"],[0,1],-11.8,0,11.8,0).s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_2854.setTransform(-281.5,227.7);

	this.shape_2855 = new cjs.Shape();
	this.shape_2855.graphics.lf(["#629B85","#629E8E"],[0,1],-11.7,0,11.8,0).s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_2855.setTransform(-237.125,215.025);

	this.shape_2856 = new cjs.Shape();
	this.shape_2856.graphics.lf(["#629B85","#629E8E"],[0,1],-11.7,0,11.8,0).s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_2856.setTransform(-193.025,201.275);

	this.shape_2857 = new cjs.Shape();
	this.shape_2857.graphics.lf(["#629B85","#629E8E"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_2857.setTransform(-296.25,64.05);

	this.shape_2858 = new cjs.Shape();
	this.shape_2858.graphics.lf(["#629B85","#629E8E"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_2858.setTransform(-251.075,56.95);

	this.shape_2859 = new cjs.Shape();
	this.shape_2859.graphics.lf(["#629B85","#629E8E"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_2859.setTransform(-205.675,50.875);

	this.shape_2860 = new cjs.Shape();
	this.shape_2860.graphics.lf(["#629B85","#629E8E"],[0,1],-11.6,0,11.7,0).s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_2860.setTransform(-56.975,176.2);

	this.shape_2861 = new cjs.Shape();
	this.shape_2861.graphics.lf(["#629B85","#629E8E"],[0,1],-11.8,0,11.8,0).s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_2861.setTransform(-102.95,180.925);

	this.shape_2862 = new cjs.Shape();
	this.shape_2862.graphics.lf(["#629B85","#629E8E"],[0,1],-11.8,0,11.9,0).s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_2862.setTransform(-148.35,189.375);

	this.shape_2863 = new cjs.Shape();
	this.shape_2863.graphics.lf(["#629B85","#629E8E"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_2863.setTransform(-160.5,43.575);

	this.shape_2864 = new cjs.Shape();
	this.shape_2864.graphics.lf(["#629B85","#629E8E"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_2864.setTransform(-117.75,28.75);

	this.shape_2865 = new cjs.Shape();
	this.shape_2865.graphics.lf(["#629B85","#629E8E"],[0,1],-12.4,0,12.5,0).s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_2865.setTransform(182.575,208.375);

	this.shape_2866 = new cjs.Shape();
	this.shape_2866.graphics.lf(["#629B85","#629E8E"],[0,1],-12.4,0,12.5,0).s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_2866.setTransform(229.275,223.775);

	this.shape_2867 = new cjs.Shape();
	this.shape_2867.graphics.lf(["#629B85","#629E8E"],[0,1],-12.4,0,12.5,0).s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_2867.setTransform(275.975,239.275);

	this.shape_2868 = new cjs.Shape();
	this.shape_2868.graphics.lf(["#629B85","#629E8E"],[0,1],-12.5,0,12.6,0).s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_2868.setTransform(135.325,194.675);

	this.shape_2869 = new cjs.Shape();
	this.shape_2869.graphics.lf(["#629B85","#629E8E"],[0,1],-12.5,0,12.6,0).s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_2869.setTransform(87.3,183.95);

	this.shape_2870 = new cjs.Shape();
	this.shape_2870.graphics.lf(["#629B85","#629E8E"],[0,1],-12.1,0,12.1,0).s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_2870.setTransform(-10.3,174.675);

	this.shape_2871 = new cjs.Shape();
	this.shape_2871.graphics.lf(["#629B85","#629E8E"],[0,1],-12.4,0,12.5,0).s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_2871.setTransform(38.6,177.125);

	this.shape_2872 = new cjs.Shape();
	this.shape_2872.graphics.lf(["#629B85","#629E8E"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_2872.setTransform(273.675,16.25);

	this.shape_2873 = new cjs.Shape();
	this.shape_2873.graphics.lf(["#629B85","#629E8E"],[0,1],-11.2,0,11.3,0).s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_2873.setTransform(509.25,218.425);

	this.shape_2874 = new cjs.Shape();
	this.shape_2874.graphics.lf(["#629B85","#629E8E"],[0,1],-12.5,0,12.6,0).s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_2874.setTransform(323.275,252.65);

	this.shape_2875 = new cjs.Shape();
	this.shape_2875.graphics.lf(["#629B85","#629E8E"],[0,1],-12.4,0,12.5,0).s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_2875.setTransform(371.7,260.625);

	this.shape_2876 = new cjs.Shape();
	this.shape_2876.graphics.lf(["#629B85","#629E8E"],[0,1],-12.5,0,12.6,0).s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_2876.setTransform(420.95,258.85);

	this.shape_2877 = new cjs.Shape();
	this.shape_2877.graphics.lf(["#629B85","#629E8E"],[0,1],-12.2,0,12.2,0).s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_2877.setTransform(467.65,244.375);

	this.shape_2878 = new cjs.Shape();
	this.shape_2878.graphics.lf(["#629B85","#629E8E"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_2878.setTransform(320.475,28.6);

	this.shape_2879 = new cjs.Shape();
	this.shape_2879.graphics.lf(["#629B85","#629E8E"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_2879.setTransform(367,42.55);

	this.shape_2880 = new cjs.Shape();
	this.shape_2880.graphics.lf(["#629B85","#629E8E"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_2880.setTransform(457.5,78.175);

	this.shape_2881 = new cjs.Shape();
	this.shape_2881.graphics.lf(["#629B85","#629E8E"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_2881.setTransform(412.875,58.825);

	this.shape_2882 = new cjs.Shape();
	this.shape_2882.graphics.lf(["#629B85","#629E8E"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_2882.setTransform(539.325,181.675);

	this.shape_2883 = new cjs.Shape();
	this.shape_2883.graphics.lf(["#629B85","#629E8E"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_2883.setTransform(534.05,135.7);

	this.shape_2884 = new cjs.Shape();
	this.shape_2884.graphics.lf(["#629B85","#629E8E"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_2884.setTransform(499.575,102.375);

	this.shape_2885 = new cjs.Shape();
	this.shape_2885.graphics.lf(["#629B85","#629E8E"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_2885.setTransform(273.8,-86.475);

	this.shape_2886 = new cjs.Shape();
	this.shape_2886.graphics.lf(["#629B85","#629E8E"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_2886.setTransform(205.1312,-32.65);

	this.shape_2887 = new cjs.Shape();
	this.shape_2887.graphics.lf(["#629B85","#629E8E"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_2887.setTransform(231.025,-0.325);

	this.shape_2888 = new cjs.Shape();
	this.shape_2888.graphics.lf(["#629B85","#629E8E"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_2888.setTransform(232.95,-65.4);

	this.shape_2889 = new cjs.Shape();
	this.shape_2889.graphics.lf(["#629B85","#629E8E"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_2889.setTransform(202.225,-123.35);

	this.shape_2890 = new cjs.Shape();
	this.shape_2890.graphics.lf(["#629B85","#629E8E"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_2890.setTransform(298.7901,-104.575);

	this.shape_2891 = new cjs.Shape();
	this.shape_2891.graphics.lf(["#629B85","#629E8E"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_2891.setTransform(250.45,-113.45);

	this.shape_2892 = new cjs.Shape();
	this.shape_2892.graphics.lf(["#629B85","#629E8E"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_2892.setTransform(67.475,-180.175);

	this.shape_2893 = new cjs.Shape();
	this.shape_2893.graphics.lf(["#629B85","#629E8E"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_2893.setTransform(154.35,-135.525);

	this.shape_2894 = new cjs.Shape();
	this.shape_2894.graphics.lf(["#629B85","#629E8E"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_2894.setTransform(108.425,-153.25);

	this.shape_2895 = new cjs.Shape();
	this.shape_2895.graphics.lf(["#629B85","#629E8E"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_2895.setTransform(32.725,-214.9);

	this.shape_2896 = new cjs.Shape();
	this.shape_2896.graphics.lf(["#629B85","#629E8E"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_2896.setTransform(-122.5,-6.825);

	this.shape_2897 = new cjs.Shape();
	this.shape_2897.graphics.lf(["#629B85","#629E8E"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_2897.setTransform(-144.525,-186.225);

	this.shape_2898 = new cjs.Shape();
	this.shape_2898.graphics.lf(["#629B85","#629E8E"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_2898.setTransform(-159.025,-28.975);

	this.shape_2899 = new cjs.Shape();
	this.shape_2899.graphics.lf(["#629B85","#629E8E"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_2899.setTransform(-200.9,-36.7925);

	this.shape_2900 = new cjs.Shape();
	this.shape_2900.graphics.lf(["#629B85","#629E8E"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_2900.setTransform(-243.525,-32.85);

	this.shape_2901 = new cjs.Shape();
	this.shape_2901.graphics.lf(["#629B85","#629E8E"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_2901.setTransform(-284.875,-21.325);

	this.shape_2902 = new cjs.Shape();
	this.shape_2902.graphics.lf(["#629B85","#629E8E"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_2902.setTransform(-266.575,-120.375);

	this.shape_2903 = new cjs.Shape();
	this.shape_2903.graphics.lf(["#629B85","#629E8E"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_2903.setTransform(-313.25,-110.575);

	this.shape_2904 = new cjs.Shape();
	this.shape_2904.graphics.lf(["#629B85","#629E8E"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_2904.setTransform(-219.775,-130.875);

	this.shape_2905 = new cjs.Shape();
	this.shape_2905.graphics.lf(["#629B85","#629E8E"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_2905.setTransform(-177.075,-151.575);

	this.shape_2906 = new cjs.Shape();
	this.shape_2906.graphics.lf(["#629B85","#629E8E"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_2906.setTransform(-37.725,-278.5196);

	this.shape_2907 = new cjs.Shape();
	this.shape_2907.graphics.lf(["#629B85","#629E8E"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_2907.setTransform(1.75,-253.225);

	this.shape_2908 = new cjs.Shape();
	this.shape_2908.graphics.lf(["#629B85","#629E8E"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_2908.setTransform(-114.5,-223.5);

	this.shape_2909 = new cjs.Shape();
	this.shape_2909.graphics.lf(["#629B85","#629E8E"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_2909.setTransform(-80.375,-257.35);

	this.shape_2910 = new cjs.Shape();
	this.shape_2910.graphics.lf(["#629B85","#629E8E"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_2910.setTransform(-328.05,-10.925);

	this.shape_2911 = new cjs.Shape();
	this.shape_2911.graphics.lf(["#629B85","#629E8E"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_2911.setTransform(-373,-12.325);

	this.shape_2912 = new cjs.Shape();
	this.shape_2912.graphics.lf(["#629B85","#629E8E"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_2912.setTransform(-358.325,-95.45);

	this.shape_2913 = new cjs.Shape();
	this.shape_2913.graphics.lf(["#629B85","#629E8E"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_2913.setTransform(-411.075,-32.2);

	this.shape_2914 = new cjs.Shape();
	this.shape_2914.graphics.lf(["#629B85","#629E8E"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_2914.setTransform(-398.975,-71.425);

	this.shape_2915 = new cjs.Shape();
	this.shape_2915.graphics.lf(["#599F8D","#59A194"],[0,1],-11.8,0,11.8,0).s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_2915.setTransform(-465.05,232.125);

	this.shape_2916 = new cjs.Shape();
	this.shape_2916.graphics.lf(["#599F8D","#59A194"],[0,1],-11.7,0,11.7,0).s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_2916.setTransform(-419.25,237.75);

	this.shape_2917 = new cjs.Shape();
	this.shape_2917.graphics.lf(["#599F8D","#59A194"],[0,1],-11.6,0,11.6,0).s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_2917.setTransform(-372.975,239.5188);

	this.shape_2918 = new cjs.Shape();
	this.shape_2918.graphics.lf(["#599F8D","#59A194"],[0,1],-6.2,0,6.3,0).s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_2918.setTransform(-504.875,224.85);

	this.shape_2919 = new cjs.Shape();
	this.shape_2919.graphics.lf(["#599F8D","#59A194"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_2919.setTransform(-510.625,132.625);

	this.shape_2920 = new cjs.Shape();
	this.shape_2920.graphics.lf(["#599F8D","#59A194"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_2920.setTransform(-468.325,117.725);

	this.shape_2921 = new cjs.Shape();
	this.shape_2921.graphics.lf(["#599F8D","#59A194"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_2921.setTransform(-425.825,103.1);

	this.shape_2922 = new cjs.Shape();
	this.shape_2922.graphics.lf(["#599F8D","#59A194"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_2922.setTransform(-340.575,74.725);

	this.shape_2923 = new cjs.Shape();
	this.shape_2923.graphics.lf(["#599F8D","#59A194"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_2923.setTransform(-383.3,88.725);

	this.shape_2924 = new cjs.Shape();
	this.shape_2924.graphics.lf(["#599F8D","#59A194"],[0,1],-11.7,0,11.8,0).s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_2924.setTransform(-326.875,236.275);

	this.shape_2925 = new cjs.Shape();
	this.shape_2925.graphics.lf(["#599F8D","#59A194"],[0,1],-11.8,0,11.8,0).s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_2925.setTransform(-281.5,227.7);

	this.shape_2926 = new cjs.Shape();
	this.shape_2926.graphics.lf(["#599F8D","#59A194"],[0,1],-11.7,0,11.8,0).s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_2926.setTransform(-237.125,215.025);

	this.shape_2927 = new cjs.Shape();
	this.shape_2927.graphics.lf(["#599F8D","#59A194"],[0,1],-11.7,0,11.8,0).s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_2927.setTransform(-193.025,201.275);

	this.shape_2928 = new cjs.Shape();
	this.shape_2928.graphics.lf(["#599F8D","#59A194"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_2928.setTransform(-296.25,64.05);

	this.shape_2929 = new cjs.Shape();
	this.shape_2929.graphics.lf(["#599F8D","#59A194"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_2929.setTransform(-251.075,56.95);

	this.shape_2930 = new cjs.Shape();
	this.shape_2930.graphics.lf(["#599F8D","#59A194"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_2930.setTransform(-205.675,50.875);

	this.shape_2931 = new cjs.Shape();
	this.shape_2931.graphics.lf(["#599F8D","#59A194"],[0,1],-11.6,0,11.7,0).s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_2931.setTransform(-56.975,176.2);

	this.shape_2932 = new cjs.Shape();
	this.shape_2932.graphics.lf(["#599F8D","#59A194"],[0,1],-11.8,0,11.8,0).s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_2932.setTransform(-102.95,180.925);

	this.shape_2933 = new cjs.Shape();
	this.shape_2933.graphics.lf(["#599F8D","#59A194"],[0,1],-11.8,0,11.9,0).s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_2933.setTransform(-148.35,189.375);

	this.shape_2934 = new cjs.Shape();
	this.shape_2934.graphics.lf(["#599F8D","#59A194"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_2934.setTransform(-160.5,43.575);

	this.shape_2935 = new cjs.Shape();
	this.shape_2935.graphics.lf(["#599F8D","#59A194"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_2935.setTransform(-117.75,28.75);

	this.shape_2936 = new cjs.Shape();
	this.shape_2936.graphics.lf(["#599F8D","#59A194"],[0,1],-12.4,0,12.5,0).s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_2936.setTransform(182.575,208.375);

	this.shape_2937 = new cjs.Shape();
	this.shape_2937.graphics.lf(["#599F8D","#59A194"],[0,1],-12.4,0,12.5,0).s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_2937.setTransform(229.275,223.775);

	this.shape_2938 = new cjs.Shape();
	this.shape_2938.graphics.lf(["#599F8D","#59A194"],[0,1],-12.4,0,12.5,0).s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_2938.setTransform(275.975,239.275);

	this.shape_2939 = new cjs.Shape();
	this.shape_2939.graphics.lf(["#599F8D","#59A194"],[0,1],-12.5,0,12.6,0).s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_2939.setTransform(135.325,194.675);

	this.shape_2940 = new cjs.Shape();
	this.shape_2940.graphics.lf(["#599F8D","#59A194"],[0,1],-12.5,0,12.6,0).s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_2940.setTransform(87.3,183.95);

	this.shape_2941 = new cjs.Shape();
	this.shape_2941.graphics.lf(["#599F8D","#59A194"],[0,1],-12.1,0,12.1,0).s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_2941.setTransform(-10.3,174.675);

	this.shape_2942 = new cjs.Shape();
	this.shape_2942.graphics.lf(["#599F8D","#59A194"],[0,1],-12.4,0,12.5,0).s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_2942.setTransform(38.6,177.125);

	this.shape_2943 = new cjs.Shape();
	this.shape_2943.graphics.lf(["#599F8D","#59A194"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_2943.setTransform(273.675,16.25);

	this.shape_2944 = new cjs.Shape();
	this.shape_2944.graphics.lf(["#599F8D","#59A194"],[0,1],-11.2,0,11.3,0).s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_2944.setTransform(509.25,218.425);

	this.shape_2945 = new cjs.Shape();
	this.shape_2945.graphics.lf(["#599F8D","#59A194"],[0,1],-12.5,0,12.6,0).s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_2945.setTransform(323.275,252.65);

	this.shape_2946 = new cjs.Shape();
	this.shape_2946.graphics.lf(["#599F8D","#59A194"],[0,1],-12.4,0,12.5,0).s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_2946.setTransform(371.7,260.625);

	this.shape_2947 = new cjs.Shape();
	this.shape_2947.graphics.lf(["#599F8D","#59A194"],[0,1],-12.5,0,12.6,0).s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_2947.setTransform(420.95,258.85);

	this.shape_2948 = new cjs.Shape();
	this.shape_2948.graphics.lf(["#599F8D","#59A194"],[0,1],-12.2,0,12.2,0).s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_2948.setTransform(467.65,244.375);

	this.shape_2949 = new cjs.Shape();
	this.shape_2949.graphics.lf(["#599F8D","#59A194"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_2949.setTransform(320.475,28.6);

	this.shape_2950 = new cjs.Shape();
	this.shape_2950.graphics.lf(["#599F8D","#59A194"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_2950.setTransform(367,42.55);

	this.shape_2951 = new cjs.Shape();
	this.shape_2951.graphics.lf(["#599F8D","#59A194"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_2951.setTransform(457.5,78.175);

	this.shape_2952 = new cjs.Shape();
	this.shape_2952.graphics.lf(["#599F8D","#59A194"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_2952.setTransform(412.875,58.825);

	this.shape_2953 = new cjs.Shape();
	this.shape_2953.graphics.lf(["#599F8D","#59A194"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_2953.setTransform(539.325,181.675);

	this.shape_2954 = new cjs.Shape();
	this.shape_2954.graphics.lf(["#599F8D","#59A194"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_2954.setTransform(534.05,135.7);

	this.shape_2955 = new cjs.Shape();
	this.shape_2955.graphics.lf(["#599F8D","#59A194"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_2955.setTransform(499.575,102.375);

	this.shape_2956 = new cjs.Shape();
	this.shape_2956.graphics.lf(["#599F8D","#59A194"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_2956.setTransform(273.8,-86.475);

	this.shape_2957 = new cjs.Shape();
	this.shape_2957.graphics.lf(["#599F8D","#59A194"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_2957.setTransform(205.1312,-32.65);

	this.shape_2958 = new cjs.Shape();
	this.shape_2958.graphics.lf(["#599F8D","#59A194"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_2958.setTransform(231.025,-0.325);

	this.shape_2959 = new cjs.Shape();
	this.shape_2959.graphics.lf(["#599F8D","#59A194"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_2959.setTransform(232.95,-65.4);

	this.shape_2960 = new cjs.Shape();
	this.shape_2960.graphics.lf(["#599F8D","#59A194"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_2960.setTransform(202.225,-123.35);

	this.shape_2961 = new cjs.Shape();
	this.shape_2961.graphics.lf(["#599F8D","#59A194"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_2961.setTransform(298.7901,-104.575);

	this.shape_2962 = new cjs.Shape();
	this.shape_2962.graphics.lf(["#599F8D","#59A194"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_2962.setTransform(250.45,-113.45);

	this.shape_2963 = new cjs.Shape();
	this.shape_2963.graphics.lf(["#599F8D","#59A194"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_2963.setTransform(67.475,-180.175);

	this.shape_2964 = new cjs.Shape();
	this.shape_2964.graphics.lf(["#599F8D","#59A194"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_2964.setTransform(154.35,-135.525);

	this.shape_2965 = new cjs.Shape();
	this.shape_2965.graphics.lf(["#599F8D","#59A194"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_2965.setTransform(108.425,-153.25);

	this.shape_2966 = new cjs.Shape();
	this.shape_2966.graphics.lf(["#599F8D","#59A194"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_2966.setTransform(32.725,-214.9);

	this.shape_2967 = new cjs.Shape();
	this.shape_2967.graphics.lf(["#599F8D","#59A194"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_2967.setTransform(-122.5,-6.825);

	this.shape_2968 = new cjs.Shape();
	this.shape_2968.graphics.lf(["#599F8D","#59A194"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_2968.setTransform(-144.525,-186.225);

	this.shape_2969 = new cjs.Shape();
	this.shape_2969.graphics.lf(["#599F8D","#59A194"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_2969.setTransform(-159.025,-28.975);

	this.shape_2970 = new cjs.Shape();
	this.shape_2970.graphics.lf(["#599F8D","#59A194"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_2970.setTransform(-200.9,-36.7925);

	this.shape_2971 = new cjs.Shape();
	this.shape_2971.graphics.lf(["#599F8D","#59A194"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_2971.setTransform(-243.525,-32.85);

	this.shape_2972 = new cjs.Shape();
	this.shape_2972.graphics.lf(["#599F8D","#59A194"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_2972.setTransform(-284.875,-21.325);

	this.shape_2973 = new cjs.Shape();
	this.shape_2973.graphics.lf(["#599F8D","#59A194"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_2973.setTransform(-266.575,-120.375);

	this.shape_2974 = new cjs.Shape();
	this.shape_2974.graphics.lf(["#599F8D","#59A194"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_2974.setTransform(-313.25,-110.575);

	this.shape_2975 = new cjs.Shape();
	this.shape_2975.graphics.lf(["#599F8D","#59A194"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_2975.setTransform(-219.775,-130.875);

	this.shape_2976 = new cjs.Shape();
	this.shape_2976.graphics.lf(["#599F8D","#59A194"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_2976.setTransform(-177.075,-151.575);

	this.shape_2977 = new cjs.Shape();
	this.shape_2977.graphics.lf(["#599F8D","#59A194"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_2977.setTransform(-37.725,-278.5196);

	this.shape_2978 = new cjs.Shape();
	this.shape_2978.graphics.lf(["#599F8D","#59A194"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_2978.setTransform(1.75,-253.225);

	this.shape_2979 = new cjs.Shape();
	this.shape_2979.graphics.lf(["#599F8D","#59A194"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_2979.setTransform(-114.5,-223.5);

	this.shape_2980 = new cjs.Shape();
	this.shape_2980.graphics.lf(["#599F8D","#59A194"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_2980.setTransform(-80.375,-257.35);

	this.shape_2981 = new cjs.Shape();
	this.shape_2981.graphics.lf(["#599F8D","#59A194"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_2981.setTransform(-328.05,-10.925);

	this.shape_2982 = new cjs.Shape();
	this.shape_2982.graphics.lf(["#599F8D","#59A194"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_2982.setTransform(-373,-12.325);

	this.shape_2983 = new cjs.Shape();
	this.shape_2983.graphics.lf(["#599F8D","#59A194"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_2983.setTransform(-358.325,-95.45);

	this.shape_2984 = new cjs.Shape();
	this.shape_2984.graphics.lf(["#599F8D","#59A194"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_2984.setTransform(-411.075,-32.2);

	this.shape_2985 = new cjs.Shape();
	this.shape_2985.graphics.lf(["#599F8D","#59A194"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_2985.setTransform(-398.975,-71.425);

	this.shape_2986 = new cjs.Shape();
	this.shape_2986.graphics.lf(["#50A395","#50A49A"],[0,1],-11.8,0,11.8,0).s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_2986.setTransform(-465.05,232.125);

	this.shape_2987 = new cjs.Shape();
	this.shape_2987.graphics.lf(["#50A395","#50A49A"],[0,1],-11.7,0,11.7,0).s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_2987.setTransform(-419.25,237.75);

	this.shape_2988 = new cjs.Shape();
	this.shape_2988.graphics.lf(["#50A395","#50A49A"],[0,1],-11.6,0,11.6,0).s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_2988.setTransform(-372.975,239.5188);

	this.shape_2989 = new cjs.Shape();
	this.shape_2989.graphics.lf(["#50A395","#50A49A"],[0,1],-6.2,0,6.3,0).s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_2989.setTransform(-504.875,224.85);

	this.shape_2990 = new cjs.Shape();
	this.shape_2990.graphics.lf(["#50A395","#50A49A"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_2990.setTransform(-510.625,132.625);

	this.shape_2991 = new cjs.Shape();
	this.shape_2991.graphics.lf(["#50A395","#50A49A"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_2991.setTransform(-468.325,117.725);

	this.shape_2992 = new cjs.Shape();
	this.shape_2992.graphics.lf(["#50A395","#50A49A"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_2992.setTransform(-425.825,103.1);

	this.shape_2993 = new cjs.Shape();
	this.shape_2993.graphics.lf(["#50A395","#50A49A"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_2993.setTransform(-340.575,74.725);

	this.shape_2994 = new cjs.Shape();
	this.shape_2994.graphics.lf(["#50A395","#50A49A"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_2994.setTransform(-383.3,88.725);

	this.shape_2995 = new cjs.Shape();
	this.shape_2995.graphics.lf(["#50A395","#50A49A"],[0,1],-11.7,0,11.8,0).s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_2995.setTransform(-326.875,236.275);

	this.shape_2996 = new cjs.Shape();
	this.shape_2996.graphics.lf(["#50A395","#50A49A"],[0,1],-11.8,0,11.8,0).s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_2996.setTransform(-281.5,227.7);

	this.shape_2997 = new cjs.Shape();
	this.shape_2997.graphics.lf(["#50A395","#50A49A"],[0,1],-11.7,0,11.8,0).s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_2997.setTransform(-237.125,215.025);

	this.shape_2998 = new cjs.Shape();
	this.shape_2998.graphics.lf(["#50A395","#50A49A"],[0,1],-11.7,0,11.8,0).s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_2998.setTransform(-193.025,201.275);

	this.shape_2999 = new cjs.Shape();
	this.shape_2999.graphics.lf(["#50A395","#50A49A"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_2999.setTransform(-296.25,64.05);

	this.shape_3000 = new cjs.Shape();
	this.shape_3000.graphics.lf(["#50A395","#50A49A"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_3000.setTransform(-251.075,56.95);

	this.shape_3001 = new cjs.Shape();
	this.shape_3001.graphics.lf(["#50A395","#50A49A"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_3001.setTransform(-205.675,50.875);

	this.shape_3002 = new cjs.Shape();
	this.shape_3002.graphics.lf(["#50A395","#50A49A"],[0,1],-11.6,0,11.7,0).s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_3002.setTransform(-56.975,176.2);

	this.shape_3003 = new cjs.Shape();
	this.shape_3003.graphics.lf(["#50A395","#50A49A"],[0,1],-11.8,0,11.8,0).s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_3003.setTransform(-102.95,180.925);

	this.shape_3004 = new cjs.Shape();
	this.shape_3004.graphics.lf(["#50A395","#50A49A"],[0,1],-11.8,0,11.9,0).s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_3004.setTransform(-148.35,189.375);

	this.shape_3005 = new cjs.Shape();
	this.shape_3005.graphics.lf(["#50A395","#50A49A"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_3005.setTransform(-160.5,43.575);

	this.shape_3006 = new cjs.Shape();
	this.shape_3006.graphics.lf(["#50A395","#50A49A"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_3006.setTransform(-117.75,28.75);

	this.shape_3007 = new cjs.Shape();
	this.shape_3007.graphics.lf(["#50A395","#50A49A"],[0,1],-12.4,0,12.5,0).s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_3007.setTransform(182.575,208.375);

	this.shape_3008 = new cjs.Shape();
	this.shape_3008.graphics.lf(["#50A395","#50A49A"],[0,1],-12.4,0,12.5,0).s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_3008.setTransform(229.275,223.775);

	this.shape_3009 = new cjs.Shape();
	this.shape_3009.graphics.lf(["#50A395","#50A49A"],[0,1],-12.4,0,12.5,0).s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_3009.setTransform(275.975,239.275);

	this.shape_3010 = new cjs.Shape();
	this.shape_3010.graphics.lf(["#50A395","#50A49A"],[0,1],-12.5,0,12.6,0).s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_3010.setTransform(135.325,194.675);

	this.shape_3011 = new cjs.Shape();
	this.shape_3011.graphics.lf(["#50A395","#50A49A"],[0,1],-12.5,0,12.6,0).s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_3011.setTransform(87.3,183.95);

	this.shape_3012 = new cjs.Shape();
	this.shape_3012.graphics.lf(["#50A395","#50A49A"],[0,1],-12.1,0,12.1,0).s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_3012.setTransform(-10.3,174.675);

	this.shape_3013 = new cjs.Shape();
	this.shape_3013.graphics.lf(["#50A395","#50A49A"],[0,1],-12.4,0,12.5,0).s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_3013.setTransform(38.6,177.125);

	this.shape_3014 = new cjs.Shape();
	this.shape_3014.graphics.lf(["#50A395","#50A49A"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_3014.setTransform(273.675,16.25);

	this.shape_3015 = new cjs.Shape();
	this.shape_3015.graphics.lf(["#50A395","#50A49A"],[0,1],-11.2,0,11.3,0).s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_3015.setTransform(509.25,218.425);

	this.shape_3016 = new cjs.Shape();
	this.shape_3016.graphics.lf(["#50A395","#50A49A"],[0,1],-12.5,0,12.6,0).s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_3016.setTransform(323.275,252.65);

	this.shape_3017 = new cjs.Shape();
	this.shape_3017.graphics.lf(["#50A395","#50A49A"],[0,1],-12.4,0,12.5,0).s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_3017.setTransform(371.7,260.625);

	this.shape_3018 = new cjs.Shape();
	this.shape_3018.graphics.lf(["#50A395","#50A49A"],[0,1],-12.5,0,12.6,0).s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_3018.setTransform(420.95,258.85);

	this.shape_3019 = new cjs.Shape();
	this.shape_3019.graphics.lf(["#50A395","#50A49A"],[0,1],-12.2,0,12.2,0).s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_3019.setTransform(467.65,244.375);

	this.shape_3020 = new cjs.Shape();
	this.shape_3020.graphics.lf(["#50A395","#50A49A"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_3020.setTransform(320.475,28.6);

	this.shape_3021 = new cjs.Shape();
	this.shape_3021.graphics.lf(["#50A395","#50A49A"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_3021.setTransform(367,42.55);

	this.shape_3022 = new cjs.Shape();
	this.shape_3022.graphics.lf(["#50A395","#50A49A"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_3022.setTransform(457.5,78.175);

	this.shape_3023 = new cjs.Shape();
	this.shape_3023.graphics.lf(["#50A395","#50A49A"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_3023.setTransform(412.875,58.825);

	this.shape_3024 = new cjs.Shape();
	this.shape_3024.graphics.lf(["#50A395","#50A49A"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_3024.setTransform(539.325,181.675);

	this.shape_3025 = new cjs.Shape();
	this.shape_3025.graphics.lf(["#50A395","#50A49A"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_3025.setTransform(534.05,135.7);

	this.shape_3026 = new cjs.Shape();
	this.shape_3026.graphics.lf(["#50A395","#50A49A"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_3026.setTransform(499.575,102.375);

	this.shape_3027 = new cjs.Shape();
	this.shape_3027.graphics.lf(["#50A395","#50A49A"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_3027.setTransform(273.8,-86.475);

	this.shape_3028 = new cjs.Shape();
	this.shape_3028.graphics.lf(["#50A395","#50A49A"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_3028.setTransform(205.1312,-32.65);

	this.shape_3029 = new cjs.Shape();
	this.shape_3029.graphics.lf(["#50A395","#50A49A"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_3029.setTransform(231.025,-0.325);

	this.shape_3030 = new cjs.Shape();
	this.shape_3030.graphics.lf(["#50A395","#50A49A"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_3030.setTransform(232.95,-65.4);

	this.shape_3031 = new cjs.Shape();
	this.shape_3031.graphics.lf(["#50A395","#50A49A"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_3031.setTransform(202.225,-123.35);

	this.shape_3032 = new cjs.Shape();
	this.shape_3032.graphics.lf(["#50A395","#50A49A"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_3032.setTransform(298.7901,-104.575);

	this.shape_3033 = new cjs.Shape();
	this.shape_3033.graphics.lf(["#50A395","#50A49A"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_3033.setTransform(250.45,-113.45);

	this.shape_3034 = new cjs.Shape();
	this.shape_3034.graphics.lf(["#50A395","#50A49A"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_3034.setTransform(67.475,-180.175);

	this.shape_3035 = new cjs.Shape();
	this.shape_3035.graphics.lf(["#50A395","#50A49A"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_3035.setTransform(154.35,-135.525);

	this.shape_3036 = new cjs.Shape();
	this.shape_3036.graphics.lf(["#50A395","#50A49A"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_3036.setTransform(108.425,-153.25);

	this.shape_3037 = new cjs.Shape();
	this.shape_3037.graphics.lf(["#50A395","#50A49A"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_3037.setTransform(32.725,-214.9);

	this.shape_3038 = new cjs.Shape();
	this.shape_3038.graphics.lf(["#50A395","#50A49A"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_3038.setTransform(-122.5,-6.825);

	this.shape_3039 = new cjs.Shape();
	this.shape_3039.graphics.lf(["#50A395","#50A49A"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_3039.setTransform(-144.525,-186.225);

	this.shape_3040 = new cjs.Shape();
	this.shape_3040.graphics.lf(["#50A395","#50A49A"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_3040.setTransform(-159.025,-28.975);

	this.shape_3041 = new cjs.Shape();
	this.shape_3041.graphics.lf(["#50A395","#50A49A"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_3041.setTransform(-200.9,-36.7925);

	this.shape_3042 = new cjs.Shape();
	this.shape_3042.graphics.lf(["#50A395","#50A49A"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_3042.setTransform(-243.525,-32.85);

	this.shape_3043 = new cjs.Shape();
	this.shape_3043.graphics.lf(["#50A395","#50A49A"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_3043.setTransform(-284.875,-21.325);

	this.shape_3044 = new cjs.Shape();
	this.shape_3044.graphics.lf(["#50A395","#50A49A"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_3044.setTransform(-266.575,-120.375);

	this.shape_3045 = new cjs.Shape();
	this.shape_3045.graphics.lf(["#50A395","#50A49A"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_3045.setTransform(-313.25,-110.575);

	this.shape_3046 = new cjs.Shape();
	this.shape_3046.graphics.lf(["#50A395","#50A49A"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_3046.setTransform(-219.775,-130.875);

	this.shape_3047 = new cjs.Shape();
	this.shape_3047.graphics.lf(["#50A395","#50A49A"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_3047.setTransform(-177.075,-151.575);

	this.shape_3048 = new cjs.Shape();
	this.shape_3048.graphics.lf(["#50A395","#50A49A"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_3048.setTransform(-37.725,-278.5196);

	this.shape_3049 = new cjs.Shape();
	this.shape_3049.graphics.lf(["#50A395","#50A49A"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_3049.setTransform(1.75,-253.225);

	this.shape_3050 = new cjs.Shape();
	this.shape_3050.graphics.lf(["#50A395","#50A49A"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_3050.setTransform(-114.5,-223.5);

	this.shape_3051 = new cjs.Shape();
	this.shape_3051.graphics.lf(["#50A395","#50A49A"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_3051.setTransform(-80.375,-257.35);

	this.shape_3052 = new cjs.Shape();
	this.shape_3052.graphics.lf(["#50A395","#50A49A"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_3052.setTransform(-328.05,-10.925);

	this.shape_3053 = new cjs.Shape();
	this.shape_3053.graphics.lf(["#50A395","#50A49A"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_3053.setTransform(-373,-12.325);

	this.shape_3054 = new cjs.Shape();
	this.shape_3054.graphics.lf(["#50A395","#50A49A"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_3054.setTransform(-358.325,-95.45);

	this.shape_3055 = new cjs.Shape();
	this.shape_3055.graphics.lf(["#50A395","#50A49A"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_3055.setTransform(-411.075,-32.2);

	this.shape_3056 = new cjs.Shape();
	this.shape_3056.graphics.lf(["#50A395","#50A49A"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_3056.setTransform(-398.975,-71.425);

	this.shape_3057 = new cjs.Shape();
	this.shape_3057.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.8,0,11.8,0).s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_3057.setTransform(-465.05,232.125);

	this.shape_3058 = new cjs.Shape();
	this.shape_3058.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.7,0,11.7,0).s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_3058.setTransform(-419.25,237.75);

	this.shape_3059 = new cjs.Shape();
	this.shape_3059.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.6,0,11.6,0).s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_3059.setTransform(-372.975,239.5188);

	this.shape_3060 = new cjs.Shape();
	this.shape_3060.graphics.lf(["#47A69D","#47A7A1"],[0,1],-6.2,0,6.3,0).s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_3060.setTransform(-504.875,224.85);

	this.shape_3061 = new cjs.Shape();
	this.shape_3061.graphics.lf(["#47A69D","#47A7A1"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_3061.setTransform(-510.625,132.625);

	this.shape_3062 = new cjs.Shape();
	this.shape_3062.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_3062.setTransform(-468.325,117.725);

	this.shape_3063 = new cjs.Shape();
	this.shape_3063.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_3063.setTransform(-425.825,103.1);

	this.shape_3064 = new cjs.Shape();
	this.shape_3064.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_3064.setTransform(-340.575,74.725);

	this.shape_3065 = new cjs.Shape();
	this.shape_3065.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_3065.setTransform(-383.3,88.725);

	this.shape_3066 = new cjs.Shape();
	this.shape_3066.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.7,0,11.8,0).s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_3066.setTransform(-326.875,236.275);

	this.shape_3067 = new cjs.Shape();
	this.shape_3067.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.8,0,11.8,0).s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_3067.setTransform(-281.5,227.7);

	this.shape_3068 = new cjs.Shape();
	this.shape_3068.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.7,0,11.8,0).s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_3068.setTransform(-237.125,215.025);

	this.shape_3069 = new cjs.Shape();
	this.shape_3069.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.7,0,11.8,0).s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_3069.setTransform(-193.025,201.275);

	this.shape_3070 = new cjs.Shape();
	this.shape_3070.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_3070.setTransform(-296.25,64.05);

	this.shape_3071 = new cjs.Shape();
	this.shape_3071.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_3071.setTransform(-251.075,56.95);

	this.shape_3072 = new cjs.Shape();
	this.shape_3072.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_3072.setTransform(-205.675,50.875);

	this.shape_3073 = new cjs.Shape();
	this.shape_3073.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.6,0,11.7,0).s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_3073.setTransform(-56.975,176.2);

	this.shape_3074 = new cjs.Shape();
	this.shape_3074.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.8,0,11.8,0).s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_3074.setTransform(-102.95,180.925);

	this.shape_3075 = new cjs.Shape();
	this.shape_3075.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.8,0,11.9,0).s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_3075.setTransform(-148.35,189.375);

	this.shape_3076 = new cjs.Shape();
	this.shape_3076.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_3076.setTransform(-160.5,43.575);

	this.shape_3077 = new cjs.Shape();
	this.shape_3077.graphics.lf(["#47A69D","#47A7A1"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_3077.setTransform(-117.75,28.75);

	this.shape_3078 = new cjs.Shape();
	this.shape_3078.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12.4,0,12.5,0).s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_3078.setTransform(182.575,208.375);

	this.shape_3079 = new cjs.Shape();
	this.shape_3079.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12.4,0,12.5,0).s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_3079.setTransform(229.275,223.775);

	this.shape_3080 = new cjs.Shape();
	this.shape_3080.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12.4,0,12.5,0).s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_3080.setTransform(275.975,239.275);

	this.shape_3081 = new cjs.Shape();
	this.shape_3081.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12.5,0,12.6,0).s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_3081.setTransform(135.325,194.675);

	this.shape_3082 = new cjs.Shape();
	this.shape_3082.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12.5,0,12.6,0).s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_3082.setTransform(87.3,183.95);

	this.shape_3083 = new cjs.Shape();
	this.shape_3083.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12.1,0,12.1,0).s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_3083.setTransform(-10.3,174.675);

	this.shape_3084 = new cjs.Shape();
	this.shape_3084.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12.4,0,12.5,0).s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_3084.setTransform(38.6,177.125);

	this.shape_3085 = new cjs.Shape();
	this.shape_3085.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_3085.setTransform(273.675,16.25);

	this.shape_3086 = new cjs.Shape();
	this.shape_3086.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.2,0,11.3,0).s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_3086.setTransform(509.25,218.425);

	this.shape_3087 = new cjs.Shape();
	this.shape_3087.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12.5,0,12.6,0).s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_3087.setTransform(323.275,252.65);

	this.shape_3088 = new cjs.Shape();
	this.shape_3088.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12.4,0,12.5,0).s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_3088.setTransform(371.7,260.625);

	this.shape_3089 = new cjs.Shape();
	this.shape_3089.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12.5,0,12.6,0).s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_3089.setTransform(420.95,258.85);

	this.shape_3090 = new cjs.Shape();
	this.shape_3090.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12.2,0,12.2,0).s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_3090.setTransform(467.65,244.375);

	this.shape_3091 = new cjs.Shape();
	this.shape_3091.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_3091.setTransform(320.475,28.6);

	this.shape_3092 = new cjs.Shape();
	this.shape_3092.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_3092.setTransform(367,42.55);

	this.shape_3093 = new cjs.Shape();
	this.shape_3093.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_3093.setTransform(457.5,78.175);

	this.shape_3094 = new cjs.Shape();
	this.shape_3094.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_3094.setTransform(412.875,58.825);

	this.shape_3095 = new cjs.Shape();
	this.shape_3095.graphics.lf(["#47A69D","#47A7A1"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_3095.setTransform(539.325,181.675);

	this.shape_3096 = new cjs.Shape();
	this.shape_3096.graphics.lf(["#47A69D","#47A7A1"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_3096.setTransform(534.05,135.7);

	this.shape_3097 = new cjs.Shape();
	this.shape_3097.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_3097.setTransform(499.575,102.375);

	this.shape_3098 = new cjs.Shape();
	this.shape_3098.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_3098.setTransform(273.8,-86.475);

	this.shape_3099 = new cjs.Shape();
	this.shape_3099.graphics.lf(["#47A69D","#47A7A1"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_3099.setTransform(205.1312,-32.65);

	this.shape_3100 = new cjs.Shape();
	this.shape_3100.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_3100.setTransform(231.025,-0.325);

	this.shape_3101 = new cjs.Shape();
	this.shape_3101.graphics.lf(["#47A69D","#47A7A1"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_3101.setTransform(232.95,-65.4);

	this.shape_3102 = new cjs.Shape();
	this.shape_3102.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_3102.setTransform(202.225,-123.35);

	this.shape_3103 = new cjs.Shape();
	this.shape_3103.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_3103.setTransform(298.7901,-104.575);

	this.shape_3104 = new cjs.Shape();
	this.shape_3104.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_3104.setTransform(250.45,-113.45);

	this.shape_3105 = new cjs.Shape();
	this.shape_3105.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_3105.setTransform(67.475,-180.175);

	this.shape_3106 = new cjs.Shape();
	this.shape_3106.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_3106.setTransform(154.35,-135.525);

	this.shape_3107 = new cjs.Shape();
	this.shape_3107.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_3107.setTransform(108.425,-153.25);

	this.shape_3108 = new cjs.Shape();
	this.shape_3108.graphics.lf(["#47A69D","#47A7A1"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_3108.setTransform(32.725,-214.9);

	this.shape_3109 = new cjs.Shape();
	this.shape_3109.graphics.lf(["#47A69D","#47A7A1"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_3109.setTransform(-122.5,-6.825);

	this.shape_3110 = new cjs.Shape();
	this.shape_3110.graphics.lf(["#47A69D","#47A7A1"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_3110.setTransform(-144.525,-186.225);

	this.shape_3111 = new cjs.Shape();
	this.shape_3111.graphics.lf(["#47A69D","#47A7A1"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_3111.setTransform(-159.025,-28.975);

	this.shape_3112 = new cjs.Shape();
	this.shape_3112.graphics.lf(["#47A69D","#47A7A1"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_3112.setTransform(-200.9,-36.7925);

	this.shape_3113 = new cjs.Shape();
	this.shape_3113.graphics.lf(["#47A69D","#47A7A1"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_3113.setTransform(-243.525,-32.85);

	this.shape_3114 = new cjs.Shape();
	this.shape_3114.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_3114.setTransform(-284.875,-21.325);

	this.shape_3115 = new cjs.Shape();
	this.shape_3115.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_3115.setTransform(-266.575,-120.375);

	this.shape_3116 = new cjs.Shape();
	this.shape_3116.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_3116.setTransform(-313.25,-110.575);

	this.shape_3117 = new cjs.Shape();
	this.shape_3117.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_3117.setTransform(-219.775,-130.875);

	this.shape_3118 = new cjs.Shape();
	this.shape_3118.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_3118.setTransform(-177.075,-151.575);

	this.shape_3119 = new cjs.Shape();
	this.shape_3119.graphics.lf(["#47A69D","#47A7A1"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_3119.setTransform(-37.725,-278.5196);

	this.shape_3120 = new cjs.Shape();
	this.shape_3120.graphics.lf(["#47A69D","#47A7A1"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_3120.setTransform(1.75,-253.225);

	this.shape_3121 = new cjs.Shape();
	this.shape_3121.graphics.lf(["#47A69D","#47A7A1"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_3121.setTransform(-114.5,-223.5);

	this.shape_3122 = new cjs.Shape();
	this.shape_3122.graphics.lf(["#47A69D","#47A7A1"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_3122.setTransform(-80.375,-257.35);

	this.shape_3123 = new cjs.Shape();
	this.shape_3123.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_3123.setTransform(-328.05,-10.925);

	this.shape_3124 = new cjs.Shape();
	this.shape_3124.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_3124.setTransform(-373,-12.325);

	this.shape_3125 = new cjs.Shape();
	this.shape_3125.graphics.lf(["#47A69D","#47A7A1"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_3125.setTransform(-358.325,-95.45);

	this.shape_3126 = new cjs.Shape();
	this.shape_3126.graphics.lf(["#47A69D","#47A7A1"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_3126.setTransform(-411.075,-32.2);

	this.shape_3127 = new cjs.Shape();
	this.shape_3127.graphics.lf(["#47A69D","#47A7A1"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_3127.setTransform(-398.975,-71.425);

	this.shape_3128 = new cjs.Shape();
	this.shape_3128.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.8,0,11.8,0).s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_3128.setTransform(-465.05,232.125);

	this.shape_3129 = new cjs.Shape();
	this.shape_3129.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.7,0,11.7,0).s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_3129.setTransform(-419.25,237.75);

	this.shape_3130 = new cjs.Shape();
	this.shape_3130.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.6,0,11.6,0).s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_3130.setTransform(-372.975,239.5188);

	this.shape_3131 = new cjs.Shape();
	this.shape_3131.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-6.2,0,6.3,0).s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_3131.setTransform(-504.875,224.85);

	this.shape_3132 = new cjs.Shape();
	this.shape_3132.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_3132.setTransform(-510.625,132.625);

	this.shape_3133 = new cjs.Shape();
	this.shape_3133.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_3133.setTransform(-468.325,117.725);

	this.shape_3134 = new cjs.Shape();
	this.shape_3134.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_3134.setTransform(-425.825,103.1);

	this.shape_3135 = new cjs.Shape();
	this.shape_3135.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_3135.setTransform(-340.575,74.725);

	this.shape_3136 = new cjs.Shape();
	this.shape_3136.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_3136.setTransform(-383.3,88.725);

	this.shape_3137 = new cjs.Shape();
	this.shape_3137.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.7,0,11.8,0).s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_3137.setTransform(-326.875,236.275);

	this.shape_3138 = new cjs.Shape();
	this.shape_3138.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.8,0,11.8,0).s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_3138.setTransform(-281.5,227.7);

	this.shape_3139 = new cjs.Shape();
	this.shape_3139.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.7,0,11.8,0).s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_3139.setTransform(-237.125,215.025);

	this.shape_3140 = new cjs.Shape();
	this.shape_3140.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.7,0,11.8,0).s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_3140.setTransform(-193.025,201.275);

	this.shape_3141 = new cjs.Shape();
	this.shape_3141.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_3141.setTransform(-296.25,64.05);

	this.shape_3142 = new cjs.Shape();
	this.shape_3142.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_3142.setTransform(-251.075,56.95);

	this.shape_3143 = new cjs.Shape();
	this.shape_3143.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_3143.setTransform(-205.675,50.875);

	this.shape_3144 = new cjs.Shape();
	this.shape_3144.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.6,0,11.7,0).s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_3144.setTransform(-56.975,176.2);

	this.shape_3145 = new cjs.Shape();
	this.shape_3145.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.8,0,11.8,0).s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_3145.setTransform(-102.95,180.925);

	this.shape_3146 = new cjs.Shape();
	this.shape_3146.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.8,0,11.9,0).s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_3146.setTransform(-148.35,189.375);

	this.shape_3147 = new cjs.Shape();
	this.shape_3147.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_3147.setTransform(-160.5,43.575);

	this.shape_3148 = new cjs.Shape();
	this.shape_3148.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_3148.setTransform(-117.75,28.75);

	this.shape_3149 = new cjs.Shape();
	this.shape_3149.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12.4,0,12.5,0).s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_3149.setTransform(182.575,208.375);

	this.shape_3150 = new cjs.Shape();
	this.shape_3150.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12.4,0,12.5,0).s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_3150.setTransform(229.275,223.775);

	this.shape_3151 = new cjs.Shape();
	this.shape_3151.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12.4,0,12.5,0).s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_3151.setTransform(275.975,239.275);

	this.shape_3152 = new cjs.Shape();
	this.shape_3152.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12.5,0,12.6,0).s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_3152.setTransform(135.325,194.675);

	this.shape_3153 = new cjs.Shape();
	this.shape_3153.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12.5,0,12.6,0).s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_3153.setTransform(87.3,183.95);

	this.shape_3154 = new cjs.Shape();
	this.shape_3154.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12.1,0,12.1,0).s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_3154.setTransform(-10.3,174.675);

	this.shape_3155 = new cjs.Shape();
	this.shape_3155.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12.4,0,12.5,0).s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_3155.setTransform(38.6,177.125);

	this.shape_3156 = new cjs.Shape();
	this.shape_3156.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_3156.setTransform(273.675,16.25);

	this.shape_3157 = new cjs.Shape();
	this.shape_3157.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.2,0,11.3,0).s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_3157.setTransform(509.25,218.425);

	this.shape_3158 = new cjs.Shape();
	this.shape_3158.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12.5,0,12.6,0).s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_3158.setTransform(323.275,252.65);

	this.shape_3159 = new cjs.Shape();
	this.shape_3159.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12.4,0,12.5,0).s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_3159.setTransform(371.7,260.625);

	this.shape_3160 = new cjs.Shape();
	this.shape_3160.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12.5,0,12.6,0).s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_3160.setTransform(420.95,258.85);

	this.shape_3161 = new cjs.Shape();
	this.shape_3161.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12.2,0,12.2,0).s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_3161.setTransform(467.65,244.375);

	this.shape_3162 = new cjs.Shape();
	this.shape_3162.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_3162.setTransform(320.475,28.6);

	this.shape_3163 = new cjs.Shape();
	this.shape_3163.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_3163.setTransform(367,42.55);

	this.shape_3164 = new cjs.Shape();
	this.shape_3164.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_3164.setTransform(457.5,78.175);

	this.shape_3165 = new cjs.Shape();
	this.shape_3165.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_3165.setTransform(412.875,58.825);

	this.shape_3166 = new cjs.Shape();
	this.shape_3166.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_3166.setTransform(539.325,181.675);

	this.shape_3167 = new cjs.Shape();
	this.shape_3167.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_3167.setTransform(534.05,135.7);

	this.shape_3168 = new cjs.Shape();
	this.shape_3168.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_3168.setTransform(499.575,102.375);

	this.shape_3169 = new cjs.Shape();
	this.shape_3169.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_3169.setTransform(273.8,-86.475);

	this.shape_3170 = new cjs.Shape();
	this.shape_3170.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_3170.setTransform(205.1312,-32.65);

	this.shape_3171 = new cjs.Shape();
	this.shape_3171.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_3171.setTransform(231.025,-0.325);

	this.shape_3172 = new cjs.Shape();
	this.shape_3172.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_3172.setTransform(232.95,-65.4);

	this.shape_3173 = new cjs.Shape();
	this.shape_3173.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_3173.setTransform(202.225,-123.35);

	this.shape_3174 = new cjs.Shape();
	this.shape_3174.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_3174.setTransform(298.7901,-104.575);

	this.shape_3175 = new cjs.Shape();
	this.shape_3175.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_3175.setTransform(250.45,-113.45);

	this.shape_3176 = new cjs.Shape();
	this.shape_3176.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_3176.setTransform(67.475,-180.175);

	this.shape_3177 = new cjs.Shape();
	this.shape_3177.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_3177.setTransform(154.35,-135.525);

	this.shape_3178 = new cjs.Shape();
	this.shape_3178.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_3178.setTransform(108.425,-153.25);

	this.shape_3179 = new cjs.Shape();
	this.shape_3179.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_3179.setTransform(32.725,-214.9);

	this.shape_3180 = new cjs.Shape();
	this.shape_3180.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_3180.setTransform(-122.5,-6.825);

	this.shape_3181 = new cjs.Shape();
	this.shape_3181.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_3181.setTransform(-144.525,-186.225);

	this.shape_3182 = new cjs.Shape();
	this.shape_3182.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_3182.setTransform(-159.025,-28.975);

	this.shape_3183 = new cjs.Shape();
	this.shape_3183.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_3183.setTransform(-200.9,-36.7925);

	this.shape_3184 = new cjs.Shape();
	this.shape_3184.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_3184.setTransform(-243.525,-32.85);

	this.shape_3185 = new cjs.Shape();
	this.shape_3185.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_3185.setTransform(-284.875,-21.325);

	this.shape_3186 = new cjs.Shape();
	this.shape_3186.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_3186.setTransform(-266.575,-120.375);

	this.shape_3187 = new cjs.Shape();
	this.shape_3187.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_3187.setTransform(-313.25,-110.575);

	this.shape_3188 = new cjs.Shape();
	this.shape_3188.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_3188.setTransform(-219.775,-130.875);

	this.shape_3189 = new cjs.Shape();
	this.shape_3189.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_3189.setTransform(-177.075,-151.575);

	this.shape_3190 = new cjs.Shape();
	this.shape_3190.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_3190.setTransform(-37.725,-278.5196);

	this.shape_3191 = new cjs.Shape();
	this.shape_3191.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_3191.setTransform(1.75,-253.225);

	this.shape_3192 = new cjs.Shape();
	this.shape_3192.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_3192.setTransform(-114.5,-223.5);

	this.shape_3193 = new cjs.Shape();
	this.shape_3193.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_3193.setTransform(-80.375,-257.35);

	this.shape_3194 = new cjs.Shape();
	this.shape_3194.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_3194.setTransform(-328.05,-10.925);

	this.shape_3195 = new cjs.Shape();
	this.shape_3195.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_3195.setTransform(-373,-12.325);

	this.shape_3196 = new cjs.Shape();
	this.shape_3196.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_3196.setTransform(-358.325,-95.45);

	this.shape_3197 = new cjs.Shape();
	this.shape_3197.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_3197.setTransform(-411.075,-32.2);

	this.shape_3198 = new cjs.Shape();
	this.shape_3198.graphics.lf(["#3DAAA4","#3DABA7"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_3198.setTransform(-398.975,-71.425);

	this.shape_3199 = new cjs.Shape();
	this.shape_3199.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.8,0,11.8,0).s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_3199.setTransform(-465.05,232.125);

	this.shape_3200 = new cjs.Shape();
	this.shape_3200.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.7,0,11.7,0).s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_3200.setTransform(-419.25,237.75);

	this.shape_3201 = new cjs.Shape();
	this.shape_3201.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.6,0,11.6,0).s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_3201.setTransform(-372.975,239.5188);

	this.shape_3202 = new cjs.Shape();
	this.shape_3202.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-6.2,0,6.3,0).s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_3202.setTransform(-504.875,224.85);

	this.shape_3203 = new cjs.Shape();
	this.shape_3203.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-13.3,0,13.4,0).s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_3203.setTransform(-510.625,132.625);

	this.shape_3204 = new cjs.Shape();
	this.shape_3204.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.4,0,11.4,0).s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_3204.setTransform(-468.325,117.725);

	this.shape_3205 = new cjs.Shape();
	this.shape_3205.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.4,0,11.4,0).s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_3205.setTransform(-425.825,103.1);

	this.shape_3206 = new cjs.Shape();
	this.shape_3206.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.5,0,11.5,0).s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_3206.setTransform(-340.575,74.725);

	this.shape_3207 = new cjs.Shape();
	this.shape_3207.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.4,0,11.5,0).s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_3207.setTransform(-383.3,88.725);

	this.shape_3208 = new cjs.Shape();
	this.shape_3208.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.7,0,11.8,0).s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_3208.setTransform(-326.875,236.275);

	this.shape_3209 = new cjs.Shape();
	this.shape_3209.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.8,0,11.8,0).s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_3209.setTransform(-281.5,227.7);

	this.shape_3210 = new cjs.Shape();
	this.shape_3210.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.7,0,11.8,0).s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_3210.setTransform(-237.125,215.025);

	this.shape_3211 = new cjs.Shape();
	this.shape_3211.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.7,0,11.8,0).s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_3211.setTransform(-193.025,201.275);

	this.shape_3212 = new cjs.Shape();
	this.shape_3212.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.7,0,11.7,0).s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_3212.setTransform(-296.25,64.05);

	this.shape_3213 = new cjs.Shape();
	this.shape_3213.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_3213.setTransform(-251.075,56.95);

	this.shape_3214 = new cjs.Shape();
	this.shape_3214.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.6,0,11.7,0).s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_3214.setTransform(-205.675,50.875);

	this.shape_3215 = new cjs.Shape();
	this.shape_3215.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.6,0,11.7,0).s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_3215.setTransform(-56.975,176.2);

	this.shape_3216 = new cjs.Shape();
	this.shape_3216.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.8,0,11.8,0).s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_3216.setTransform(-102.95,180.925);

	this.shape_3217 = new cjs.Shape();
	this.shape_3217.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.8,0,11.9,0).s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_3217.setTransform(-148.35,189.375);

	this.shape_3218 = new cjs.Shape();
	this.shape_3218.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.7,0,11.8,0).s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_3218.setTransform(-160.5,43.575);

	this.shape_3219 = new cjs.Shape();
	this.shape_3219.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-10.6,0,10.7,0).s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_3219.setTransform(-117.75,28.75);

	this.shape_3220 = new cjs.Shape();
	this.shape_3220.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12.4,0,12.5,0).s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_3220.setTransform(182.575,208.375);

	this.shape_3221 = new cjs.Shape();
	this.shape_3221.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12.4,0,12.5,0).s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_3221.setTransform(229.275,223.775);

	this.shape_3222 = new cjs.Shape();
	this.shape_3222.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12.4,0,12.5,0).s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_3222.setTransform(275.975,239.275);

	this.shape_3223 = new cjs.Shape();
	this.shape_3223.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12.5,0,12.6,0).s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_3223.setTransform(135.325,194.675);

	this.shape_3224 = new cjs.Shape();
	this.shape_3224.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12.5,0,12.6,0).s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_3224.setTransform(87.3,183.95);

	this.shape_3225 = new cjs.Shape();
	this.shape_3225.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12.1,0,12.1,0).s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_3225.setTransform(-10.3,174.675);

	this.shape_3226 = new cjs.Shape();
	this.shape_3226.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12.4,0,12.5,0).s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_3226.setTransform(38.6,177.125);

	this.shape_3227 = new cjs.Shape();
	this.shape_3227.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.9,0,11.9,0).s().p("AgFAcQg6gRg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_3227.setTransform(273.675,16.25);

	this.shape_3228 = new cjs.Shape();
	this.shape_3228.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.2,0,11.3,0).s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_3228.setTransform(509.25,218.425);

	this.shape_3229 = new cjs.Shape();
	this.shape_3229.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12.5,0,12.6,0).s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_3229.setTransform(323.275,252.65);

	this.shape_3230 = new cjs.Shape();
	this.shape_3230.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12.4,0,12.5,0).s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_3230.setTransform(371.7,260.625);

	this.shape_3231 = new cjs.Shape();
	this.shape_3231.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12.5,0,12.6,0).s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_3231.setTransform(420.95,258.85);

	this.shape_3232 = new cjs.Shape();
	this.shape_3232.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12.2,0,12.2,0).s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_3232.setTransform(467.65,244.375);

	this.shape_3233 = new cjs.Shape();
	this.shape_3233.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12.3,0,12.4,0).s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_3233.setTransform(320.475,28.6);

	this.shape_3234 = new cjs.Shape();
	this.shape_3234.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12.3,0,12.4,0).s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_3234.setTransform(367,42.55);

	this.shape_3235 = new cjs.Shape();
	this.shape_3235.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12,0,12.1,0).s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_3235.setTransform(457.5,78.175);

	this.shape_3236 = new cjs.Shape();
	this.shape_3236.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12.2,0,12.3,0).s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_3236.setTransform(412.875,58.825);

	this.shape_3237 = new cjs.Shape();
	this.shape_3237.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-6.7,0,6.8,0).s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_3237.setTransform(539.325,181.675);

	this.shape_3238 = new cjs.Shape();
	this.shape_3238.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-8.6,0,8.7,0).s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_3238.setTransform(534.05,135.7);

	this.shape_3239 = new cjs.Shape();
	this.shape_3239.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.4,0,11.4,0).s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_3239.setTransform(499.575,102.375);

	this.shape_3240 = new cjs.Shape();
	this.shape_3240.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.8,0,11.9,0).s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_3240.setTransform(273.8,-86.475);

	this.shape_3241 = new cjs.Shape();
	this.shape_3241.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-4.4,0,4.4,0).s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_3241.setTransform(205.1312,-32.65);

	this.shape_3242 = new cjs.Shape();
	this.shape_3242.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.2,0,11.2,0).s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_3242.setTransform(231.025,-0.325);

	this.shape_3243 = new cjs.Shape();
	this.shape_3243.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-10.9,0,11,0).s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_3243.setTransform(232.95,-65.4);

	this.shape_3244 = new cjs.Shape();
	this.shape_3244.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12.5,0,12.6,0).s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_3244.setTransform(202.225,-123.35);

	this.shape_3245 = new cjs.Shape();
	this.shape_3245.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12.2,0,12.3,0).s().p("ABJAQQgCAFAEAGIABADIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQAmAPAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_3245.setTransform(298.7901,-104.575);

	this.shape_3246 = new cjs.Shape();
	this.shape_3246.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12.5,0,12.6,0).s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_3246.setTransform(250.45,-113.45);

	this.shape_3247 = new cjs.Shape();
	this.shape_3247.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11,0,11.1,0).s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_3247.setTransform(67.475,-180.175);

	this.shape_3248 = new cjs.Shape();
	this.shape_3248.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12.6,0,12.6,0).s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_3248.setTransform(154.35,-135.525);

	this.shape_3249 = new cjs.Shape();
	this.shape_3249.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12,0,12.1,0).s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_3249.setTransform(108.425,-153.25);

	this.shape_3250 = new cjs.Shape();
	this.shape_3250.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-9.8,0,9.9,0).s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_3250.setTransform(32.725,-214.9);

	this.shape_3251 = new cjs.Shape();
	this.shape_3251.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-9.9,0,9.9,0).s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_3251.setTransform(-122.5,-6.825);

	this.shape_3252 = new cjs.Shape();
	this.shape_3252.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-9.2,0,9.3,0).s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_3252.setTransform(-144.525,-186.225);

	this.shape_3253 = new cjs.Shape();
	this.shape_3253.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-10.8,0,10.9,0).s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_3253.setTransform(-159.025,-28.975);

	this.shape_3254 = new cjs.Shape();
	this.shape_3254.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-10.8,0,10.9,0).s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_3254.setTransform(-200.9,-36.7925);

	this.shape_3255 = new cjs.Shape();
	this.shape_3255.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-10.9,0,11,0).s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_3255.setTransform(-243.525,-32.85);

	this.shape_3256 = new cjs.Shape();
	this.shape_3256.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.1,0,11.2,0).s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_3256.setTransform(-284.875,-21.325);

	this.shape_3257 = new cjs.Shape();
	this.shape_3257.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12.2,0,12.3,0).s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_3257.setTransform(-266.575,-120.375);

	this.shape_3258 = new cjs.Shape();
	this.shape_3258.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12.1,0,12.2,0).s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_3258.setTransform(-313.25,-110.575);

	this.shape_3259 = new cjs.Shape();
	this.shape_3259.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12.1,0,12.2,0).s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_3259.setTransform(-219.775,-130.875);

	this.shape_3260 = new cjs.Shape();
	this.shape_3260.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11,0,11,0).s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_3260.setTransform(-177.075,-151.575);

	this.shape_3261 = new cjs.Shape();
	this.shape_3261.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-12.8,0,12.9,0).s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_3261.setTransform(-37.725,-278.5196);

	this.shape_3262 = new cjs.Shape();
	this.shape_3262.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-9.8,0,9.8,0).s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_3262.setTransform(1.75,-253.225);

	this.shape_3263 = new cjs.Shape();
	this.shape_3263.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-9.8,0,9.8,0).s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_3263.setTransform(-114.5,-223.5);

	this.shape_3264 = new cjs.Shape();
	this.shape_3264.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-10.8,0,10.8,0).s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_3264.setTransform(-80.375,-257.35);

	this.shape_3265 = new cjs.Shape();
	this.shape_3265.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.4,0,11.5,0).s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_3265.setTransform(-328.05,-10.925);

	this.shape_3266 = new cjs.Shape();
	this.shape_3266.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.5,0,11.5,0).s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_3266.setTransform(-373,-12.325);

	this.shape_3267 = new cjs.Shape();
	this.shape_3267.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-11.9,0,11.9,0).s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_3267.setTransform(-358.325,-95.45);

	this.shape_3268 = new cjs.Shape();
	this.shape_3268.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-8.4,0,8.5,0).s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_3268.setTransform(-411.075,-32.2);

	this.shape_3269 = new cjs.Shape();
	this.shape_3269.graphics.lf(["#34ADAC","#34AEAE"],[0,1],-10.6,0,10.6,0).s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_3269.setTransform(-398.975,-71.425);

	this.shape_3270 = new cjs.Shape();
	this.shape_3270.graphics.f("#2BB1B4").s().p("EA2aAqXIAHgyQB5AQB5AEIgBAyQh3gEiBgQgEA+GApxQB/gMBwgbIAMAxQh+Adh5ALgEAu0Ao0IAOgxQB5AhB1AYIgLAxQhrgWiGgjgEBFcAoCQBwgsBsg7IAYAsQhxA+hxArgEAndAmlIAPgwQCBArBpAgIgOAwQhbgciQgvgEg9zAnPIABgyQB3ACBugFIACAyQhUAEhZAAIg7gBgEhFDAmyIAGgxQB8AMBoAHIgDAyQhwgHh3gNgEg2oAmLQB1gMBugSIAJAxQhxASh2AMgEhMOAlxIAIgxQB1AUBvAQIgHAyQhzgRhygUgEgvjAlCQBtgZBzgeIAMAwQh4AhhpAXgEAgKAkHIAQgvIDpBPIgQAwgEhRlAkuIAKgwIBzAXIgJAygEBMFAkaQA2gmAsgkQAwglAugqIAhAlQgoAmg3AsQgzAogxAjgEgonAjLIDdhFIAPAvIjdBFgEAY2AhwIAPgvQBlAeCGAsIgPAvQiMgthfgdgEghuAhAQBsghBygiIAOAxQhwAghtAigARdfuIAMgxQCGAhBpAeIgNAwQh2ggh4gegA6wfBQB3gdBsgXIAKAxQh7AbhmAZgEBRgAfPQBFhqAPhrIAyAHQgQB0hNB2gAJ9eMIAIgyQB8AVB3AYIgKAxQh8gZh1gTgAzpdjQBqgSB8gPIAGAyQhxANhzATgACXdSIADgyQB4AJB+APIgGAyQh8gPh3gJgAsccqQCFgKBigFIADAyQh3AGhvAJgAlNdGIgBgyIB2gBIB8ACIAAAxgEBQYAVWIAlgiQBdBpArBpIgvATQgphjhVhggEhS+AXmQgngnAAg3QAAg3AngnQAngnA4AAQA2AAAnAnQAnAnAAA3QAAA3gnAnQgnAng2AAQg4AAgngngEhMrAUAIDVhKIAPAwIjTBKgEBKjAQqIAagqQBxBFBaBHIgfAnQhVhDhxhGgEhGCARtIDVhIIAQAvIjVBJgEg/ZAPdIDVhHIAQAvIjVBHgEBD4ANJIAVgtQBxAzBrA4IgYAsQhng2hyg0gEg4uANPIBrgjQA3gSA3gPIANAxQgvAMg9AUIhqAjgEgx1ALXQBngWB7gUIAIAxQiDAWhdAUgEA84AKRIARguQBuAoB1AwIgTAuQhpgrh4gtgEgqxAKKIDjgfIAGAyIjhAfgEgjrAJNIDigfIAHAyIjjAfgEA1sAH2IAPgwQCGAqBiAhIgQAwQh3gphwgigA8oILQB+gWBhgWIAMAwQhaAWiIAXgA1yGeQCGg2AjhCIAsAXQgqBSiYA9gEAuaAFvIANgwQBjAaCIAnIgOAwQhmgdiEgkgEAo8AEZIgCAAIAAgBIgBAAIgBAAQg2gQg3gUIAQgvIBsAjIByAbIgLAwgEAgnAA1IAcgqQBRA2B0AzIgUAuQh3g0hWg5gA1IAjQgogjgpgeIAdgoQAoAdAtAnQAwAqAkArIgnAfQggglgugqgEg2wgAeQBtgGBugVIAJAxQhyAVhwAGgEg9ygAgIAOgwQBlAhByAMIgFAxQh3gNhpghgEgv+gBvQAsgNA+gXIBmgiIAQAvQgwAPg1AUQg8AVgwAOgAeXlkIAqAbQhABkAtBbIgtAWQg6h0BQh8gEhCfgDOQgvg2gDhGIAygCQACA1AkAnQAdAhA1AjIgcApQg5glgjgmgA8RjTIAOgxQBsAeBgAvIgWAtQhcgthogcgEgpfgDxQBqgaBrgQIAHAxQhgAPhvAbgEgixgD+IgCgyQBygFBnALIgFAxQhlgKhtAFgEAg+gIKQBQg8Byg/IAYAsQhuA+hOA5gEhBtgIwQBHhTBxhMIAcApQhsBKhDBMgEAnNgLtIBogvIBygxIATAuIhwAxIhoAvgEg7kgNHQBngyB2gsIARAuQhzAshlAxgEAuGgOrQgCAFAEAGIADAEIgCgBIgOgFQgigJiWgVIAHgxIBzARQAzAIAXAGQAOADALAFQANAHAHALQAIASgKAQQgGAKgMAHgEg0kgPxQBqgfB+gdIALAwQh6AdhrAfgEAjcgQRIAKgxQBrAVCGAWIgIAyQh0gUh/gYgEgtSgReIB2gUIB2gUIAJAxQhEANgzAIIh1AUgAb6x6IAMgxQBmAZCKAeIgMAxQh1gah7gdgEgl9gS4QB7gfBngmIARAvQhmAmiAAhgAWTzXQg6gQg+gUIAPgvQA2ARBAASIB3AgIgNAwgA/H1gQBmg8BVhRIAiAlQhZBUhqA/gANV3EIAZgsQBtA/BsAwIgUAtQhwgwhuhAgAHG7sIAhglQBeBWBeBFIgeApQhlhMhahTgA5v6cQAug6BjiEIAoAeQh4CegaAhgEAB2ghZIAngfQBcByBCBIIglAiQhKhThWhqgEgVIggWQBQhgBQhUIAkAiQhQBVhPBdgEgC+gnWIAkgiQBABDBfB7IgmAfQheh4g/hDgEgP9gl0QA7g4AegaQAzguAtgiIAfAoQg0AogqAmQgqAlgvArgEgJXgpkIgQgvQCIgvB5AxIgTAuQhngqh3Apg");
	this.shape_3270.setTransform(11.05,-8.9946);
	this.shape_3270._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_154}]},130).to({state:[{t:this.shape_155},{t:this.shape_154}]},5).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_154}]},5).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_154}]},5).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_154}]},5).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_154}]},5).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_154}]},5).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_154}]},5).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_154}]},5).to({state:[{t:this.shape_163},{t:this.shape_162},{t:this.shape_161},{t:this.shape_160},{t:this.shape_159},{t:this.shape_157},{t:this.shape_158},{t:this.shape_156},{t:this.shape_155},{t:this.shape_154}]},5).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_154}]},53).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_154}]},4).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_154}]},3).to({state:[{t:this.shape_172},{t:this.shape_171},{t:this.shape_173},{t:this.shape_170},{t:this.shape_169},{t:this.shape_180},{t:this.shape_179},{t:this.shape_181},{t:this.shape_177},{t:this.shape_176},{t:this.shape_174},{t:this.shape_175},{t:this.shape_168},{t:this.shape_167},{t:this.shape_166},{t:this.shape_165},{t:this.shape_178},{t:this.shape_164},{t:this.shape_163},{t:this.shape_162},{t:this.shape_161},{t:this.shape_160},{t:this.shape_159},{t:this.shape_157},{t:this.shape_158},{t:this.shape_156},{t:this.shape_155},{t:this.shape_154}]},28).to({state:[{t:this.shape_209},{t:this.shape_208},{t:this.shape_207},{t:this.shape_206},{t:this.shape_205},{t:this.shape_204},{t:this.shape_203},{t:this.shape_202},{t:this.shape_201},{t:this.shape_200},{t:this.shape_199},{t:this.shape_198},{t:this.shape_197},{t:this.shape_196},{t:this.shape_195},{t:this.shape_194},{t:this.shape_193},{t:this.shape_192},{t:this.shape_191},{t:this.shape_190},{t:this.shape_189},{t:this.shape_188},{t:this.shape_187},{t:this.shape_186},{t:this.shape_185},{t:this.shape_184},{t:this.shape_183},{t:this.shape_182}]},1).to({state:[{t:this.shape_237},{t:this.shape_236},{t:this.shape_235},{t:this.shape_234},{t:this.shape_233},{t:this.shape_232},{t:this.shape_231},{t:this.shape_230},{t:this.shape_229},{t:this.shape_228},{t:this.shape_227},{t:this.shape_226},{t:this.shape_225},{t:this.shape_224},{t:this.shape_223},{t:this.shape_222},{t:this.shape_221},{t:this.shape_220},{t:this.shape_219},{t:this.shape_218},{t:this.shape_217},{t:this.shape_216},{t:this.shape_215},{t:this.shape_214},{t:this.shape_213},{t:this.shape_212},{t:this.shape_211},{t:this.shape_210}]},1).to({state:[{t:this.shape_265},{t:this.shape_264},{t:this.shape_263},{t:this.shape_262},{t:this.shape_261},{t:this.shape_260},{t:this.shape_259},{t:this.shape_258},{t:this.shape_257},{t:this.shape_256},{t:this.shape_255},{t:this.shape_254},{t:this.shape_253},{t:this.shape_252},{t:this.shape_251},{t:this.shape_250},{t:this.shape_249},{t:this.shape_248},{t:this.shape_247},{t:this.shape_246},{t:this.shape_245},{t:this.shape_244},{t:this.shape_243},{t:this.shape_242},{t:this.shape_241},{t:this.shape_240},{t:this.shape_239},{t:this.shape_238}]},1).to({state:[{t:this.shape_293},{t:this.shape_292},{t:this.shape_291},{t:this.shape_290},{t:this.shape_289},{t:this.shape_288},{t:this.shape_287},{t:this.shape_286},{t:this.shape_285},{t:this.shape_284},{t:this.shape_283},{t:this.shape_282},{t:this.shape_281},{t:this.shape_280},{t:this.shape_279},{t:this.shape_278},{t:this.shape_277},{t:this.shape_276},{t:this.shape_275},{t:this.shape_274},{t:this.shape_273},{t:this.shape_272},{t:this.shape_271},{t:this.shape_270},{t:this.shape_269},{t:this.shape_268},{t:this.shape_267},{t:this.shape_266}]},1).to({state:[{t:this.shape_321},{t:this.shape_320},{t:this.shape_319},{t:this.shape_318},{t:this.shape_317},{t:this.shape_316},{t:this.shape_315},{t:this.shape_314},{t:this.shape_313},{t:this.shape_312},{t:this.shape_311},{t:this.shape_310},{t:this.shape_309},{t:this.shape_308},{t:this.shape_307},{t:this.shape_306},{t:this.shape_305},{t:this.shape_304},{t:this.shape_303},{t:this.shape_302},{t:this.shape_301},{t:this.shape_300},{t:this.shape_299},{t:this.shape_298},{t:this.shape_297},{t:this.shape_296},{t:this.shape_295},{t:this.shape_294}]},1).to({state:[{t:this.shape_349},{t:this.shape_348},{t:this.shape_347},{t:this.shape_346},{t:this.shape_345},{t:this.shape_344},{t:this.shape_343},{t:this.shape_342},{t:this.shape_341},{t:this.shape_340},{t:this.shape_339},{t:this.shape_338},{t:this.shape_337},{t:this.shape_336},{t:this.shape_335},{t:this.shape_334},{t:this.shape_333},{t:this.shape_332},{t:this.shape_331},{t:this.shape_330},{t:this.shape_329},{t:this.shape_328},{t:this.shape_327},{t:this.shape_326},{t:this.shape_325},{t:this.shape_324},{t:this.shape_323},{t:this.shape_322}]},1).to({state:[{t:this.shape_377},{t:this.shape_376},{t:this.shape_375},{t:this.shape_374},{t:this.shape_373},{t:this.shape_372},{t:this.shape_371},{t:this.shape_370},{t:this.shape_369},{t:this.shape_368},{t:this.shape_367},{t:this.shape_366},{t:this.shape_365},{t:this.shape_364},{t:this.shape_363},{t:this.shape_362},{t:this.shape_361},{t:this.shape_360},{t:this.shape_359},{t:this.shape_358},{t:this.shape_357},{t:this.shape_356},{t:this.shape_355},{t:this.shape_354},{t:this.shape_353},{t:this.shape_352},{t:this.shape_351},{t:this.shape_350}]},1).to({state:[{t:this.shape_405},{t:this.shape_404},{t:this.shape_403},{t:this.shape_402},{t:this.shape_401},{t:this.shape_400},{t:this.shape_399},{t:this.shape_398},{t:this.shape_397},{t:this.shape_396},{t:this.shape_395},{t:this.shape_394},{t:this.shape_393},{t:this.shape_392},{t:this.shape_391},{t:this.shape_390},{t:this.shape_389},{t:this.shape_388},{t:this.shape_387},{t:this.shape_386},{t:this.shape_385},{t:this.shape_384},{t:this.shape_383},{t:this.shape_382},{t:this.shape_381},{t:this.shape_380},{t:this.shape_379},{t:this.shape_378}]},1).to({state:[{t:this.shape_433},{t:this.shape_432},{t:this.shape_431},{t:this.shape_430},{t:this.shape_429},{t:this.shape_428},{t:this.shape_427},{t:this.shape_426},{t:this.shape_425},{t:this.shape_424},{t:this.shape_423},{t:this.shape_422},{t:this.shape_421},{t:this.shape_420},{t:this.shape_419},{t:this.shape_418},{t:this.shape_417},{t:this.shape_416},{t:this.shape_415},{t:this.shape_414},{t:this.shape_413},{t:this.shape_412},{t:this.shape_411},{t:this.shape_410},{t:this.shape_409},{t:this.shape_408},{t:this.shape_407},{t:this.shape_406}]},1).to({state:[{t:this.shape_461},{t:this.shape_460},{t:this.shape_459},{t:this.shape_458},{t:this.shape_457},{t:this.shape_456},{t:this.shape_455},{t:this.shape_454},{t:this.shape_453},{t:this.shape_452},{t:this.shape_451},{t:this.shape_450},{t:this.shape_449},{t:this.shape_448},{t:this.shape_447},{t:this.shape_446},{t:this.shape_445},{t:this.shape_444},{t:this.shape_443},{t:this.shape_442},{t:this.shape_441},{t:this.shape_440},{t:this.shape_439},{t:this.shape_438},{t:this.shape_437},{t:this.shape_436},{t:this.shape_435},{t:this.shape_434}]},1).to({state:[{t:this.shape_489},{t:this.shape_488},{t:this.shape_487},{t:this.shape_486},{t:this.shape_485},{t:this.shape_484},{t:this.shape_483},{t:this.shape_482},{t:this.shape_481},{t:this.shape_480},{t:this.shape_479},{t:this.shape_478},{t:this.shape_477},{t:this.shape_476},{t:this.shape_475},{t:this.shape_474},{t:this.shape_473},{t:this.shape_472},{t:this.shape_471},{t:this.shape_470},{t:this.shape_469},{t:this.shape_468},{t:this.shape_467},{t:this.shape_466},{t:this.shape_465},{t:this.shape_464},{t:this.shape_463},{t:this.shape_462}]},1).to({state:[{t:this.shape_517},{t:this.shape_516},{t:this.shape_515},{t:this.shape_514},{t:this.shape_513},{t:this.shape_512},{t:this.shape_511},{t:this.shape_510},{t:this.shape_509},{t:this.shape_508},{t:this.shape_507},{t:this.shape_506},{t:this.shape_505},{t:this.shape_504},{t:this.shape_503},{t:this.shape_502},{t:this.shape_501},{t:this.shape_500},{t:this.shape_499},{t:this.shape_498},{t:this.shape_497},{t:this.shape_496},{t:this.shape_495},{t:this.shape_494},{t:this.shape_493},{t:this.shape_492},{t:this.shape_491},{t:this.shape_490}]},1).to({state:[{t:this.shape_545},{t:this.shape_544},{t:this.shape_543},{t:this.shape_542},{t:this.shape_541},{t:this.shape_540},{t:this.shape_539},{t:this.shape_538},{t:this.shape_537},{t:this.shape_536},{t:this.shape_535},{t:this.shape_534},{t:this.shape_533},{t:this.shape_532},{t:this.shape_531},{t:this.shape_530},{t:this.shape_529},{t:this.shape_528},{t:this.shape_527},{t:this.shape_526},{t:this.shape_525},{t:this.shape_524},{t:this.shape_523},{t:this.shape_522},{t:this.shape_521},{t:this.shape_520},{t:this.shape_519},{t:this.shape_518}]},1).to({state:[{t:this.shape_573},{t:this.shape_572},{t:this.shape_571},{t:this.shape_570},{t:this.shape_569},{t:this.shape_568},{t:this.shape_567},{t:this.shape_566},{t:this.shape_565},{t:this.shape_564},{t:this.shape_563},{t:this.shape_562},{t:this.shape_561},{t:this.shape_560},{t:this.shape_559},{t:this.shape_558},{t:this.shape_557},{t:this.shape_556},{t:this.shape_555},{t:this.shape_554},{t:this.shape_553},{t:this.shape_552},{t:this.shape_551},{t:this.shape_550},{t:this.shape_549},{t:this.shape_548},{t:this.shape_547},{t:this.shape_546}]},1).to({state:[{t:this.shape_601},{t:this.shape_600},{t:this.shape_599},{t:this.shape_598},{t:this.shape_597},{t:this.shape_596},{t:this.shape_595},{t:this.shape_594},{t:this.shape_593},{t:this.shape_592},{t:this.shape_591},{t:this.shape_590},{t:this.shape_589},{t:this.shape_588},{t:this.shape_587},{t:this.shape_586},{t:this.shape_585},{t:this.shape_584},{t:this.shape_583},{t:this.shape_582},{t:this.shape_581},{t:this.shape_580},{t:this.shape_579},{t:this.shape_578},{t:this.shape_577},{t:this.shape_576},{t:this.shape_575},{t:this.shape_574}]},1).to({state:[{t:this.shape_629},{t:this.shape_628},{t:this.shape_627},{t:this.shape_626},{t:this.shape_625},{t:this.shape_624},{t:this.shape_623},{t:this.shape_622},{t:this.shape_621},{t:this.shape_620},{t:this.shape_619},{t:this.shape_618},{t:this.shape_617},{t:this.shape_616},{t:this.shape_615},{t:this.shape_614},{t:this.shape_613},{t:this.shape_612},{t:this.shape_611},{t:this.shape_610},{t:this.shape_609},{t:this.shape_608},{t:this.shape_607},{t:this.shape_606},{t:this.shape_605},{t:this.shape_604},{t:this.shape_603},{t:this.shape_602}]},1).to({state:[{t:this.shape_657},{t:this.shape_656},{t:this.shape_655},{t:this.shape_654},{t:this.shape_653},{t:this.shape_652},{t:this.shape_651},{t:this.shape_650},{t:this.shape_649},{t:this.shape_648},{t:this.shape_647},{t:this.shape_646},{t:this.shape_645},{t:this.shape_644},{t:this.shape_643},{t:this.shape_642},{t:this.shape_641},{t:this.shape_640},{t:this.shape_639},{t:this.shape_638},{t:this.shape_637},{t:this.shape_636},{t:this.shape_635},{t:this.shape_634},{t:this.shape_633},{t:this.shape_632},{t:this.shape_631},{t:this.shape_630}]},1).to({state:[{t:this.shape_685},{t:this.shape_684},{t:this.shape_683},{t:this.shape_682},{t:this.shape_681},{t:this.shape_680},{t:this.shape_679},{t:this.shape_678},{t:this.shape_677},{t:this.shape_676},{t:this.shape_675},{t:this.shape_674},{t:this.shape_673},{t:this.shape_672},{t:this.shape_671},{t:this.shape_670},{t:this.shape_669},{t:this.shape_668},{t:this.shape_667},{t:this.shape_666},{t:this.shape_665},{t:this.shape_664},{t:this.shape_663},{t:this.shape_662},{t:this.shape_661},{t:this.shape_660},{t:this.shape_659},{t:this.shape_658}]},1).to({state:[{t:this.shape_713},{t:this.shape_712},{t:this.shape_711},{t:this.shape_710},{t:this.shape_709},{t:this.shape_708},{t:this.shape_707},{t:this.shape_706},{t:this.shape_705},{t:this.shape_704},{t:this.shape_703},{t:this.shape_702},{t:this.shape_701},{t:this.shape_700},{t:this.shape_699},{t:this.shape_698},{t:this.shape_697},{t:this.shape_696},{t:this.shape_695},{t:this.shape_694},{t:this.shape_693},{t:this.shape_692},{t:this.shape_691},{t:this.shape_690},{t:this.shape_689},{t:this.shape_688},{t:this.shape_687},{t:this.shape_686}]},1).to({state:[{t:this.shape_741},{t:this.shape_740},{t:this.shape_739},{t:this.shape_738},{t:this.shape_737},{t:this.shape_736},{t:this.shape_735},{t:this.shape_734},{t:this.shape_733},{t:this.shape_732},{t:this.shape_731},{t:this.shape_730},{t:this.shape_729},{t:this.shape_728},{t:this.shape_727},{t:this.shape_726},{t:this.shape_725},{t:this.shape_724},{t:this.shape_723},{t:this.shape_722},{t:this.shape_721},{t:this.shape_720},{t:this.shape_719},{t:this.shape_718},{t:this.shape_717},{t:this.shape_716},{t:this.shape_715},{t:this.shape_714}]},1).to({state:[{t:this.shape_742}]},1).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_154}]},1).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_751},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_751},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_751},{t:this.shape_154}]},3).to({state:[{t:this.shape_743},{t:this.shape_744},{t:this.shape_746},{t:this.shape_747},{t:this.shape_745},{t:this.shape_749},{t:this.shape_750},{t:this.shape_748},{t:this.shape_752},{t:this.shape_753},{t:this.shape_751},{t:this.shape_172},{t:this.shape_171},{t:this.shape_173},{t:this.shape_170},{t:this.shape_169},{t:this.shape_180},{t:this.shape_179},{t:this.shape_181},{t:this.shape_177},{t:this.shape_176},{t:this.shape_174},{t:this.shape_175},{t:this.shape_168},{t:this.shape_167},{t:this.shape_166},{t:this.shape_165},{t:this.shape_178},{t:this.shape_164},{t:this.shape_163},{t:this.shape_162},{t:this.shape_161},{t:this.shape_160},{t:this.shape_159},{t:this.shape_157},{t:this.shape_158},{t:this.shape_156},{t:this.shape_155},{t:this.shape_154}]},25).to({state:[{t:this.shape_792},{t:this.shape_791},{t:this.shape_790},{t:this.shape_789},{t:this.shape_788},{t:this.shape_787},{t:this.shape_786},{t:this.shape_785},{t:this.shape_784},{t:this.shape_783},{t:this.shape_782},{t:this.shape_781},{t:this.shape_780},{t:this.shape_779},{t:this.shape_778},{t:this.shape_777},{t:this.shape_776},{t:this.shape_775},{t:this.shape_774},{t:this.shape_773},{t:this.shape_772},{t:this.shape_771},{t:this.shape_770},{t:this.shape_769},{t:this.shape_768},{t:this.shape_767},{t:this.shape_766},{t:this.shape_765},{t:this.shape_764},{t:this.shape_763},{t:this.shape_762},{t:this.shape_761},{t:this.shape_760},{t:this.shape_759},{t:this.shape_758},{t:this.shape_757},{t:this.shape_756},{t:this.shape_755},{t:this.shape_754}]},1).to({state:[{t:this.shape_831},{t:this.shape_830},{t:this.shape_829},{t:this.shape_828},{t:this.shape_827},{t:this.shape_826},{t:this.shape_825},{t:this.shape_824},{t:this.shape_823},{t:this.shape_822},{t:this.shape_821},{t:this.shape_820},{t:this.shape_819},{t:this.shape_818},{t:this.shape_817},{t:this.shape_816},{t:this.shape_815},{t:this.shape_814},{t:this.shape_813},{t:this.shape_812},{t:this.shape_811},{t:this.shape_810},{t:this.shape_809},{t:this.shape_808},{t:this.shape_807},{t:this.shape_806},{t:this.shape_805},{t:this.shape_804},{t:this.shape_803},{t:this.shape_802},{t:this.shape_801},{t:this.shape_800},{t:this.shape_799},{t:this.shape_798},{t:this.shape_797},{t:this.shape_796},{t:this.shape_795},{t:this.shape_794},{t:this.shape_793}]},1).to({state:[{t:this.shape_870},{t:this.shape_869},{t:this.shape_868},{t:this.shape_867},{t:this.shape_866},{t:this.shape_865},{t:this.shape_864},{t:this.shape_863},{t:this.shape_862},{t:this.shape_861},{t:this.shape_860},{t:this.shape_859},{t:this.shape_858},{t:this.shape_857},{t:this.shape_856},{t:this.shape_855},{t:this.shape_854},{t:this.shape_853},{t:this.shape_852},{t:this.shape_851},{t:this.shape_850},{t:this.shape_849},{t:this.shape_848},{t:this.shape_847},{t:this.shape_846},{t:this.shape_845},{t:this.shape_844},{t:this.shape_843},{t:this.shape_842},{t:this.shape_841},{t:this.shape_840},{t:this.shape_839},{t:this.shape_838},{t:this.shape_837},{t:this.shape_836},{t:this.shape_835},{t:this.shape_834},{t:this.shape_833},{t:this.shape_832}]},1).to({state:[{t:this.shape_909},{t:this.shape_908},{t:this.shape_907},{t:this.shape_906},{t:this.shape_905},{t:this.shape_904},{t:this.shape_903},{t:this.shape_902},{t:this.shape_901},{t:this.shape_900},{t:this.shape_899},{t:this.shape_898},{t:this.shape_897},{t:this.shape_896},{t:this.shape_895},{t:this.shape_894},{t:this.shape_893},{t:this.shape_892},{t:this.shape_891},{t:this.shape_890},{t:this.shape_889},{t:this.shape_888},{t:this.shape_887},{t:this.shape_886},{t:this.shape_885},{t:this.shape_884},{t:this.shape_883},{t:this.shape_882},{t:this.shape_881},{t:this.shape_880},{t:this.shape_879},{t:this.shape_878},{t:this.shape_877},{t:this.shape_876},{t:this.shape_875},{t:this.shape_874},{t:this.shape_873},{t:this.shape_872},{t:this.shape_871}]},1).to({state:[{t:this.shape_948},{t:this.shape_947},{t:this.shape_946},{t:this.shape_945},{t:this.shape_944},{t:this.shape_943},{t:this.shape_942},{t:this.shape_941},{t:this.shape_940},{t:this.shape_939},{t:this.shape_938},{t:this.shape_937},{t:this.shape_936},{t:this.shape_935},{t:this.shape_934},{t:this.shape_933},{t:this.shape_932},{t:this.shape_931},{t:this.shape_930},{t:this.shape_929},{t:this.shape_928},{t:this.shape_927},{t:this.shape_926},{t:this.shape_925},{t:this.shape_924},{t:this.shape_923},{t:this.shape_922},{t:this.shape_921},{t:this.shape_920},{t:this.shape_919},{t:this.shape_918},{t:this.shape_917},{t:this.shape_916},{t:this.shape_915},{t:this.shape_914},{t:this.shape_913},{t:this.shape_912},{t:this.shape_911},{t:this.shape_910}]},1).to({state:[{t:this.shape_987},{t:this.shape_986},{t:this.shape_985},{t:this.shape_984},{t:this.shape_983},{t:this.shape_982},{t:this.shape_981},{t:this.shape_980},{t:this.shape_979},{t:this.shape_978},{t:this.shape_977},{t:this.shape_976},{t:this.shape_975},{t:this.shape_974},{t:this.shape_973},{t:this.shape_972},{t:this.shape_971},{t:this.shape_970},{t:this.shape_969},{t:this.shape_968},{t:this.shape_967},{t:this.shape_966},{t:this.shape_965},{t:this.shape_964},{t:this.shape_963},{t:this.shape_962},{t:this.shape_961},{t:this.shape_960},{t:this.shape_959},{t:this.shape_958},{t:this.shape_957},{t:this.shape_956},{t:this.shape_955},{t:this.shape_954},{t:this.shape_953},{t:this.shape_952},{t:this.shape_951},{t:this.shape_950},{t:this.shape_949}]},1).to({state:[{t:this.shape_1026},{t:this.shape_1025},{t:this.shape_1024},{t:this.shape_1023},{t:this.shape_1022},{t:this.shape_1021},{t:this.shape_1020},{t:this.shape_1019},{t:this.shape_1018},{t:this.shape_1017},{t:this.shape_1016},{t:this.shape_1015},{t:this.shape_1014},{t:this.shape_1013},{t:this.shape_1012},{t:this.shape_1011},{t:this.shape_1010},{t:this.shape_1009},{t:this.shape_1008},{t:this.shape_1007},{t:this.shape_1006},{t:this.shape_1005},{t:this.shape_1004},{t:this.shape_1003},{t:this.shape_1002},{t:this.shape_1001},{t:this.shape_1000},{t:this.shape_999},{t:this.shape_998},{t:this.shape_997},{t:this.shape_996},{t:this.shape_995},{t:this.shape_994},{t:this.shape_993},{t:this.shape_992},{t:this.shape_991},{t:this.shape_990},{t:this.shape_989},{t:this.shape_988}]},1).to({state:[{t:this.shape_1065},{t:this.shape_1064},{t:this.shape_1063},{t:this.shape_1062},{t:this.shape_1061},{t:this.shape_1060},{t:this.shape_1059},{t:this.shape_1058},{t:this.shape_1057},{t:this.shape_1056},{t:this.shape_1055},{t:this.shape_1054},{t:this.shape_1053},{t:this.shape_1052},{t:this.shape_1051},{t:this.shape_1050},{t:this.shape_1049},{t:this.shape_1048},{t:this.shape_1047},{t:this.shape_1046},{t:this.shape_1045},{t:this.shape_1044},{t:this.shape_1043},{t:this.shape_1042},{t:this.shape_1041},{t:this.shape_1040},{t:this.shape_1039},{t:this.shape_1038},{t:this.shape_1037},{t:this.shape_1036},{t:this.shape_1035},{t:this.shape_1034},{t:this.shape_1033},{t:this.shape_1032},{t:this.shape_1031},{t:this.shape_1030},{t:this.shape_1029},{t:this.shape_1028},{t:this.shape_1027}]},1).to({state:[{t:this.shape_1104},{t:this.shape_1103},{t:this.shape_1102},{t:this.shape_1101},{t:this.shape_1100},{t:this.shape_1099},{t:this.shape_1098},{t:this.shape_1097},{t:this.shape_1096},{t:this.shape_1095},{t:this.shape_1094},{t:this.shape_1093},{t:this.shape_1092},{t:this.shape_1091},{t:this.shape_1090},{t:this.shape_1089},{t:this.shape_1088},{t:this.shape_1087},{t:this.shape_1086},{t:this.shape_1085},{t:this.shape_1084},{t:this.shape_1083},{t:this.shape_1082},{t:this.shape_1081},{t:this.shape_1080},{t:this.shape_1079},{t:this.shape_1078},{t:this.shape_1077},{t:this.shape_1076},{t:this.shape_1075},{t:this.shape_1074},{t:this.shape_1073},{t:this.shape_1072},{t:this.shape_1071},{t:this.shape_1070},{t:this.shape_1069},{t:this.shape_1068},{t:this.shape_1067},{t:this.shape_1066}]},1).to({state:[{t:this.shape_1105}]},1).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_154}]},1).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_154}]},9).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1107},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1108},{t:this.shape_1107},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1107},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1110},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1107},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1107},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1107},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1107},{t:this.shape_154}]},2).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1107},{t:this.shape_154}]},2).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1107},{t:this.shape_154}]},2).to({state:[{t:this.shape_744},{t:this.shape_743},{t:this.shape_746},{t:this.shape_747},{t:this.shape_745},{t:this.shape_749},{t:this.shape_750},{t:this.shape_748},{t:this.shape_752},{t:this.shape_1106},{t:this.shape_753},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1107},{t:this.shape_172},{t:this.shape_171},{t:this.shape_173},{t:this.shape_170},{t:this.shape_169},{t:this.shape_180},{t:this.shape_179},{t:this.shape_181},{t:this.shape_177},{t:this.shape_176},{t:this.shape_174},{t:this.shape_175},{t:this.shape_168},{t:this.shape_167},{t:this.shape_166},{t:this.shape_165},{t:this.shape_178},{t:this.shape_164},{t:this.shape_163},{t:this.shape_162},{t:this.shape_160},{t:this.shape_161},{t:this.shape_159},{t:this.shape_157},{t:this.shape_158},{t:this.shape_156},{t:this.shape_155},{t:this.shape_154}]},22).to({state:[{t:this.shape_1162},{t:this.shape_1161},{t:this.shape_1160},{t:this.shape_1159},{t:this.shape_1158},{t:this.shape_1157},{t:this.shape_1156},{t:this.shape_1155},{t:this.shape_1154},{t:this.shape_1153},{t:this.shape_1152},{t:this.shape_1151},{t:this.shape_1150},{t:this.shape_1149},{t:this.shape_1148},{t:this.shape_1147},{t:this.shape_1146},{t:this.shape_1145},{t:this.shape_1144},{t:this.shape_1143},{t:this.shape_1142},{t:this.shape_1141},{t:this.shape_1140},{t:this.shape_1139},{t:this.shape_1138},{t:this.shape_1137},{t:this.shape_1136},{t:this.shape_1135},{t:this.shape_1134},{t:this.shape_1133},{t:this.shape_1132},{t:this.shape_1131},{t:this.shape_1130},{t:this.shape_1129},{t:this.shape_1128},{t:this.shape_1127},{t:this.shape_1126},{t:this.shape_1125},{t:this.shape_1124},{t:this.shape_1123},{t:this.shape_1122},{t:this.shape_1121},{t:this.shape_1120},{t:this.shape_1119},{t:this.shape_1118},{t:this.shape_1117},{t:this.shape_1116},{t:this.shape_1115}]},1).to({state:[{t:this.shape_1210},{t:this.shape_1209},{t:this.shape_1208},{t:this.shape_1207},{t:this.shape_1206},{t:this.shape_1205},{t:this.shape_1204},{t:this.shape_1203},{t:this.shape_1202},{t:this.shape_1201},{t:this.shape_1200},{t:this.shape_1199},{t:this.shape_1198},{t:this.shape_1197},{t:this.shape_1196},{t:this.shape_1195},{t:this.shape_1194},{t:this.shape_1193},{t:this.shape_1192},{t:this.shape_1191},{t:this.shape_1190},{t:this.shape_1189},{t:this.shape_1188},{t:this.shape_1187},{t:this.shape_1186},{t:this.shape_1185},{t:this.shape_1184},{t:this.shape_1183},{t:this.shape_1182},{t:this.shape_1181},{t:this.shape_1180},{t:this.shape_1179},{t:this.shape_1178},{t:this.shape_1177},{t:this.shape_1176},{t:this.shape_1175},{t:this.shape_1174},{t:this.shape_1173},{t:this.shape_1172},{t:this.shape_1171},{t:this.shape_1170},{t:this.shape_1169},{t:this.shape_1168},{t:this.shape_1167},{t:this.shape_1166},{t:this.shape_1165},{t:this.shape_1164},{t:this.shape_1163}]},1).to({state:[{t:this.shape_293},{t:this.shape_292},{t:this.shape_291},{t:this.shape_290},{t:this.shape_289},{t:this.shape_288},{t:this.shape_287},{t:this.shape_1230},{t:this.shape_286},{t:this.shape_285},{t:this.shape_284},{t:this.shape_283},{t:this.shape_282},{t:this.shape_281},{t:this.shape_280},{t:this.shape_279},{t:this.shape_278},{t:this.shape_277},{t:this.shape_276},{t:this.shape_1229},{t:this.shape_1228},{t:this.shape_1227},{t:this.shape_1226},{t:this.shape_1225},{t:this.shape_1224},{t:this.shape_1223},{t:this.shape_1222},{t:this.shape_1221},{t:this.shape_1220},{t:this.shape_1219},{t:this.shape_1218},{t:this.shape_1217},{t:this.shape_1216},{t:this.shape_1215},{t:this.shape_1214},{t:this.shape_1213},{t:this.shape_1212},{t:this.shape_1211},{t:this.shape_275},{t:this.shape_274},{t:this.shape_273},{t:this.shape_272},{t:this.shape_271},{t:this.shape_270},{t:this.shape_269},{t:this.shape_268},{t:this.shape_267},{t:this.shape_266}]},1).to({state:[{t:this.shape_1278},{t:this.shape_1277},{t:this.shape_1276},{t:this.shape_1275},{t:this.shape_1274},{t:this.shape_1273},{t:this.shape_1272},{t:this.shape_1271},{t:this.shape_1270},{t:this.shape_1269},{t:this.shape_1268},{t:this.shape_1267},{t:this.shape_1266},{t:this.shape_1265},{t:this.shape_1264},{t:this.shape_1263},{t:this.shape_1262},{t:this.shape_1261},{t:this.shape_1260},{t:this.shape_1259},{t:this.shape_1258},{t:this.shape_1257},{t:this.shape_1256},{t:this.shape_1255},{t:this.shape_1254},{t:this.shape_1253},{t:this.shape_1252},{t:this.shape_1251},{t:this.shape_1250},{t:this.shape_1249},{t:this.shape_1248},{t:this.shape_1247},{t:this.shape_1246},{t:this.shape_1245},{t:this.shape_1244},{t:this.shape_1243},{t:this.shape_1242},{t:this.shape_1241},{t:this.shape_1240},{t:this.shape_1239},{t:this.shape_1238},{t:this.shape_1237},{t:this.shape_1236},{t:this.shape_1235},{t:this.shape_1234},{t:this.shape_1233},{t:this.shape_1232},{t:this.shape_1231}]},1).to({state:[{t:this.shape_1326},{t:this.shape_1325},{t:this.shape_1324},{t:this.shape_1323},{t:this.shape_1322},{t:this.shape_1321},{t:this.shape_1320},{t:this.shape_1319},{t:this.shape_1318},{t:this.shape_1317},{t:this.shape_1316},{t:this.shape_1315},{t:this.shape_1314},{t:this.shape_1313},{t:this.shape_1312},{t:this.shape_1311},{t:this.shape_1310},{t:this.shape_1309},{t:this.shape_1308},{t:this.shape_1307},{t:this.shape_1306},{t:this.shape_1305},{t:this.shape_1304},{t:this.shape_1303},{t:this.shape_1302},{t:this.shape_1301},{t:this.shape_1300},{t:this.shape_1299},{t:this.shape_1298},{t:this.shape_1297},{t:this.shape_1296},{t:this.shape_1295},{t:this.shape_1294},{t:this.shape_1293},{t:this.shape_1292},{t:this.shape_1291},{t:this.shape_1290},{t:this.shape_1289},{t:this.shape_1288},{t:this.shape_1287},{t:this.shape_1286},{t:this.shape_1285},{t:this.shape_1284},{t:this.shape_1283},{t:this.shape_1282},{t:this.shape_1281},{t:this.shape_1280},{t:this.shape_1279}]},1).to({state:[{t:this.shape_1374},{t:this.shape_1373},{t:this.shape_1372},{t:this.shape_1371},{t:this.shape_1370},{t:this.shape_1369},{t:this.shape_1368},{t:this.shape_1367},{t:this.shape_1366},{t:this.shape_1365},{t:this.shape_1364},{t:this.shape_1363},{t:this.shape_1362},{t:this.shape_1361},{t:this.shape_1360},{t:this.shape_1359},{t:this.shape_1358},{t:this.shape_1357},{t:this.shape_1356},{t:this.shape_1355},{t:this.shape_1354},{t:this.shape_1353},{t:this.shape_1352},{t:this.shape_1351},{t:this.shape_1350},{t:this.shape_1349},{t:this.shape_1348},{t:this.shape_1347},{t:this.shape_1346},{t:this.shape_1345},{t:this.shape_1344},{t:this.shape_1343},{t:this.shape_1342},{t:this.shape_1341},{t:this.shape_1340},{t:this.shape_1339},{t:this.shape_1338},{t:this.shape_1337},{t:this.shape_1336},{t:this.shape_1335},{t:this.shape_1334},{t:this.shape_1333},{t:this.shape_1332},{t:this.shape_1331},{t:this.shape_1330},{t:this.shape_1329},{t:this.shape_1328},{t:this.shape_1327}]},1).to({state:[{t:this.shape_1422},{t:this.shape_1421},{t:this.shape_1420},{t:this.shape_1419},{t:this.shape_1418},{t:this.shape_1417},{t:this.shape_1416},{t:this.shape_1415},{t:this.shape_1414},{t:this.shape_1413},{t:this.shape_1412},{t:this.shape_1411},{t:this.shape_1410},{t:this.shape_1409},{t:this.shape_1408},{t:this.shape_1407},{t:this.shape_1406},{t:this.shape_1405},{t:this.shape_1404},{t:this.shape_1403},{t:this.shape_1402},{t:this.shape_1401},{t:this.shape_1400},{t:this.shape_1399},{t:this.shape_1398},{t:this.shape_1397},{t:this.shape_1396},{t:this.shape_1395},{t:this.shape_1394},{t:this.shape_1393},{t:this.shape_1392},{t:this.shape_1391},{t:this.shape_1390},{t:this.shape_1389},{t:this.shape_1388},{t:this.shape_1387},{t:this.shape_1386},{t:this.shape_1385},{t:this.shape_1384},{t:this.shape_1383},{t:this.shape_1382},{t:this.shape_1381},{t:this.shape_1380},{t:this.shape_1379},{t:this.shape_1378},{t:this.shape_1377},{t:this.shape_1376},{t:this.shape_1375}]},1).to({state:[{t:this.shape_948},{t:this.shape_947},{t:this.shape_946},{t:this.shape_945},{t:this.shape_944},{t:this.shape_943},{t:this.shape_942},{t:this.shape_941},{t:this.shape_940},{t:this.shape_939},{t:this.shape_938},{t:this.shape_937},{t:this.shape_936},{t:this.shape_935},{t:this.shape_934},{t:this.shape_933},{t:this.shape_932},{t:this.shape_931},{t:this.shape_930},{t:this.shape_929},{t:this.shape_928},{t:this.shape_927},{t:this.shape_926},{t:this.shape_925},{t:this.shape_924},{t:this.shape_923},{t:this.shape_922},{t:this.shape_1431},{t:this.shape_921},{t:this.shape_920},{t:this.shape_1430},{t:this.shape_1429},{t:this.shape_1428},{t:this.shape_1427},{t:this.shape_1426},{t:this.shape_1425},{t:this.shape_1424},{t:this.shape_1423},{t:this.shape_919},{t:this.shape_918},{t:this.shape_917},{t:this.shape_916},{t:this.shape_915},{t:this.shape_914},{t:this.shape_913},{t:this.shape_912},{t:this.shape_911},{t:this.shape_910}]},1).to({state:[{t:this.shape_1479},{t:this.shape_1478},{t:this.shape_1477},{t:this.shape_1476},{t:this.shape_1475},{t:this.shape_1474},{t:this.shape_1473},{t:this.shape_1472},{t:this.shape_1471},{t:this.shape_1470},{t:this.shape_1469},{t:this.shape_1468},{t:this.shape_1467},{t:this.shape_1466},{t:this.shape_1465},{t:this.shape_1464},{t:this.shape_1463},{t:this.shape_1462},{t:this.shape_1461},{t:this.shape_1460},{t:this.shape_1459},{t:this.shape_1458},{t:this.shape_1457},{t:this.shape_1456},{t:this.shape_1455},{t:this.shape_1454},{t:this.shape_1453},{t:this.shape_1452},{t:this.shape_1451},{t:this.shape_1450},{t:this.shape_1449},{t:this.shape_1448},{t:this.shape_1447},{t:this.shape_1446},{t:this.shape_1445},{t:this.shape_1444},{t:this.shape_1443},{t:this.shape_1442},{t:this.shape_1441},{t:this.shape_1440},{t:this.shape_1439},{t:this.shape_1438},{t:this.shape_1437},{t:this.shape_1436},{t:this.shape_1435},{t:this.shape_1434},{t:this.shape_1433},{t:this.shape_1432}]},1).to({state:[{t:this.shape_1527},{t:this.shape_1526},{t:this.shape_1525},{t:this.shape_1524},{t:this.shape_1523},{t:this.shape_1522},{t:this.shape_1521},{t:this.shape_1520},{t:this.shape_1519},{t:this.shape_1518},{t:this.shape_1517},{t:this.shape_1516},{t:this.shape_1515},{t:this.shape_1514},{t:this.shape_1513},{t:this.shape_1512},{t:this.shape_1511},{t:this.shape_1510},{t:this.shape_1509},{t:this.shape_1508},{t:this.shape_1507},{t:this.shape_1506},{t:this.shape_1505},{t:this.shape_1504},{t:this.shape_1503},{t:this.shape_1502},{t:this.shape_1501},{t:this.shape_1500},{t:this.shape_1499},{t:this.shape_1498},{t:this.shape_1497},{t:this.shape_1496},{t:this.shape_1495},{t:this.shape_1494},{t:this.shape_1493},{t:this.shape_1492},{t:this.shape_1491},{t:this.shape_1490},{t:this.shape_1489},{t:this.shape_1488},{t:this.shape_1487},{t:this.shape_1486},{t:this.shape_1485},{t:this.shape_1484},{t:this.shape_1483},{t:this.shape_1482},{t:this.shape_1481},{t:this.shape_1480}]},1).to({state:[{t:this.shape_1575},{t:this.shape_1574},{t:this.shape_1573},{t:this.shape_1572},{t:this.shape_1571},{t:this.shape_1570},{t:this.shape_1569},{t:this.shape_1568},{t:this.shape_1567},{t:this.shape_1566},{t:this.shape_1565},{t:this.shape_1564},{t:this.shape_1563},{t:this.shape_1562},{t:this.shape_1561},{t:this.shape_1560},{t:this.shape_1559},{t:this.shape_1558},{t:this.shape_1557},{t:this.shape_1556},{t:this.shape_1555},{t:this.shape_1554},{t:this.shape_1553},{t:this.shape_1552},{t:this.shape_1551},{t:this.shape_1550},{t:this.shape_1549},{t:this.shape_1548},{t:this.shape_1547},{t:this.shape_1546},{t:this.shape_1545},{t:this.shape_1544},{t:this.shape_1543},{t:this.shape_1542},{t:this.shape_1541},{t:this.shape_1540},{t:this.shape_1539},{t:this.shape_1538},{t:this.shape_1537},{t:this.shape_1536},{t:this.shape_1535},{t:this.shape_1534},{t:this.shape_1533},{t:this.shape_1532},{t:this.shape_1531},{t:this.shape_1530},{t:this.shape_1529},{t:this.shape_1528}]},1).to({state:[{t:this.shape_1623},{t:this.shape_1622},{t:this.shape_1621},{t:this.shape_1620},{t:this.shape_1619},{t:this.shape_1618},{t:this.shape_1617},{t:this.shape_1616},{t:this.shape_1615},{t:this.shape_1614},{t:this.shape_1613},{t:this.shape_1612},{t:this.shape_1611},{t:this.shape_1610},{t:this.shape_1609},{t:this.shape_1608},{t:this.shape_1607},{t:this.shape_1606},{t:this.shape_1605},{t:this.shape_1604},{t:this.shape_1603},{t:this.shape_1602},{t:this.shape_1601},{t:this.shape_1600},{t:this.shape_1599},{t:this.shape_1598},{t:this.shape_1597},{t:this.shape_1596},{t:this.shape_1595},{t:this.shape_1594},{t:this.shape_1593},{t:this.shape_1592},{t:this.shape_1591},{t:this.shape_1590},{t:this.shape_1589},{t:this.shape_1588},{t:this.shape_1587},{t:this.shape_1586},{t:this.shape_1585},{t:this.shape_1584},{t:this.shape_1583},{t:this.shape_1582},{t:this.shape_1581},{t:this.shape_1580},{t:this.shape_1579},{t:this.shape_1578},{t:this.shape_1577},{t:this.shape_1576}]},1).to({state:[{t:this.shape_657},{t:this.shape_656},{t:this.shape_655},{t:this.shape_654},{t:this.shape_653},{t:this.shape_652},{t:this.shape_651},{t:this.shape_1643},{t:this.shape_650},{t:this.shape_649},{t:this.shape_648},{t:this.shape_647},{t:this.shape_646},{t:this.shape_645},{t:this.shape_644},{t:this.shape_643},{t:this.shape_642},{t:this.shape_641},{t:this.shape_640},{t:this.shape_1642},{t:this.shape_1641},{t:this.shape_1640},{t:this.shape_1639},{t:this.shape_1638},{t:this.shape_1637},{t:this.shape_1636},{t:this.shape_1635},{t:this.shape_1634},{t:this.shape_1633},{t:this.shape_1632},{t:this.shape_1631},{t:this.shape_1630},{t:this.shape_1629},{t:this.shape_1628},{t:this.shape_1627},{t:this.shape_1626},{t:this.shape_1625},{t:this.shape_1624},{t:this.shape_639},{t:this.shape_638},{t:this.shape_637},{t:this.shape_636},{t:this.shape_635},{t:this.shape_634},{t:this.shape_633},{t:this.shape_632},{t:this.shape_631},{t:this.shape_630}]},1).to({state:[{t:this.shape_1691},{t:this.shape_1690},{t:this.shape_1689},{t:this.shape_1688},{t:this.shape_1687},{t:this.shape_1686},{t:this.shape_1685},{t:this.shape_1684},{t:this.shape_1683},{t:this.shape_1682},{t:this.shape_1681},{t:this.shape_1680},{t:this.shape_1679},{t:this.shape_1678},{t:this.shape_1677},{t:this.shape_1676},{t:this.shape_1675},{t:this.shape_1674},{t:this.shape_1673},{t:this.shape_1672},{t:this.shape_1671},{t:this.shape_1670},{t:this.shape_1669},{t:this.shape_1668},{t:this.shape_1667},{t:this.shape_1666},{t:this.shape_1665},{t:this.shape_1664},{t:this.shape_1663},{t:this.shape_1662},{t:this.shape_1661},{t:this.shape_1660},{t:this.shape_1659},{t:this.shape_1658},{t:this.shape_1657},{t:this.shape_1656},{t:this.shape_1655},{t:this.shape_1654},{t:this.shape_1653},{t:this.shape_1652},{t:this.shape_1651},{t:this.shape_1650},{t:this.shape_1649},{t:this.shape_1648},{t:this.shape_1647},{t:this.shape_1646},{t:this.shape_1645},{t:this.shape_1644}]},1).to({state:[{t:this.shape_1739},{t:this.shape_1738},{t:this.shape_1737},{t:this.shape_1736},{t:this.shape_1735},{t:this.shape_1734},{t:this.shape_1733},{t:this.shape_1732},{t:this.shape_1731},{t:this.shape_1730},{t:this.shape_1729},{t:this.shape_1728},{t:this.shape_1727},{t:this.shape_1726},{t:this.shape_1725},{t:this.shape_1724},{t:this.shape_1723},{t:this.shape_1722},{t:this.shape_1721},{t:this.shape_1720},{t:this.shape_1719},{t:this.shape_1718},{t:this.shape_1717},{t:this.shape_1716},{t:this.shape_1715},{t:this.shape_1714},{t:this.shape_1713},{t:this.shape_1712},{t:this.shape_1711},{t:this.shape_1710},{t:this.shape_1709},{t:this.shape_1708},{t:this.shape_1707},{t:this.shape_1706},{t:this.shape_1705},{t:this.shape_1704},{t:this.shape_1703},{t:this.shape_1702},{t:this.shape_1701},{t:this.shape_1700},{t:this.shape_1699},{t:this.shape_1698},{t:this.shape_1697},{t:this.shape_1696},{t:this.shape_1695},{t:this.shape_1694},{t:this.shape_1693},{t:this.shape_1692}]},1).to({state:[{t:this.shape_1740}]},1).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1741},{t:this.shape_1107},{t:this.shape_154}]},1).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1742},{t:this.shape_1741},{t:this.shape_1107},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1742},{t:this.shape_1743},{t:this.shape_1741},{t:this.shape_1107},{t:this.shape_154}]},2).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1742},{t:this.shape_1743},{t:this.shape_1744},{t:this.shape_1741},{t:this.shape_1107},{t:this.shape_154}]},3).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1742},{t:this.shape_1743},{t:this.shape_1744},{t:this.shape_1745},{t:this.shape_1741},{t:this.shape_1107},{t:this.shape_154}]},2).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1742},{t:this.shape_1743},{t:this.shape_1744},{t:this.shape_1745},{t:this.shape_1741},{t:this.shape_1107},{t:this.shape_1746},{t:this.shape_154}]},2).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1742},{t:this.shape_1743},{t:this.shape_1744},{t:this.shape_1745},{t:this.shape_1741},{t:this.shape_1107},{t:this.shape_1746},{t:this.shape_1747},{t:this.shape_154}]},2).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1742},{t:this.shape_1743},{t:this.shape_1744},{t:this.shape_1745},{t:this.shape_1741},{t:this.shape_1107},{t:this.shape_1746},{t:this.shape_1747},{t:this.shape_1748},{t:this.shape_154}]},2).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1742},{t:this.shape_1743},{t:this.shape_1744},{t:this.shape_1745},{t:this.shape_1741},{t:this.shape_1107},{t:this.shape_1749},{t:this.shape_1746},{t:this.shape_1747},{t:this.shape_1748},{t:this.shape_154}]},2).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1742},{t:this.shape_1743},{t:this.shape_1744},{t:this.shape_1745},{t:this.shape_1741},{t:this.shape_1107},{t:this.shape_1750},{t:this.shape_1749},{t:this.shape_1746},{t:this.shape_1747},{t:this.shape_1748},{t:this.shape_154}]},2).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1742},{t:this.shape_1743},{t:this.shape_1744},{t:this.shape_1745},{t:this.shape_1741},{t:this.shape_1107},{t:this.shape_1751},{t:this.shape_1750},{t:this.shape_1749},{t:this.shape_1746},{t:this.shape_1747},{t:this.shape_1748},{t:this.shape_154}]},2).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1742},{t:this.shape_1743},{t:this.shape_1744},{t:this.shape_1745},{t:this.shape_1741},{t:this.shape_1107},{t:this.shape_1751},{t:this.shape_1752},{t:this.shape_1750},{t:this.shape_1749},{t:this.shape_1746},{t:this.shape_1747},{t:this.shape_1748},{t:this.shape_154}]},1).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1742},{t:this.shape_1743},{t:this.shape_1744},{t:this.shape_1745},{t:this.shape_1741},{t:this.shape_1107},{t:this.shape_1751},{t:this.shape_1752},{t:this.shape_1750},{t:this.shape_1749},{t:this.shape_1746},{t:this.shape_1747},{t:this.shape_1748},{t:this.shape_1753},{t:this.shape_154}]},1).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1742},{t:this.shape_1743},{t:this.shape_1744},{t:this.shape_1745},{t:this.shape_1741},{t:this.shape_1107},{t:this.shape_1751},{t:this.shape_1752},{t:this.shape_1750},{t:this.shape_1749},{t:this.shape_1746},{t:this.shape_1747},{t:this.shape_1748},{t:this.shape_1754},{t:this.shape_1753},{t:this.shape_154}]},1).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1742},{t:this.shape_1743},{t:this.shape_1744},{t:this.shape_1745},{t:this.shape_1741},{t:this.shape_1107},{t:this.shape_1751},{t:this.shape_1752},{t:this.shape_1750},{t:this.shape_1749},{t:this.shape_1746},{t:this.shape_1747},{t:this.shape_1748},{t:this.shape_1755},{t:this.shape_1754},{t:this.shape_1753},{t:this.shape_154}]},2).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1742},{t:this.shape_1743},{t:this.shape_1744},{t:this.shape_1745},{t:this.shape_1741},{t:this.shape_1107},{t:this.shape_1751},{t:this.shape_1752},{t:this.shape_1750},{t:this.shape_1749},{t:this.shape_1746},{t:this.shape_1747},{t:this.shape_1748},{t:this.shape_1755},{t:this.shape_1754},{t:this.shape_1753},{t:this.shape_1756},{t:this.shape_154}]},2).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1742},{t:this.shape_1743},{t:this.shape_1744},{t:this.shape_1745},{t:this.shape_1741},{t:this.shape_1107},{t:this.shape_1751},{t:this.shape_1752},{t:this.shape_1750},{t:this.shape_1749},{t:this.shape_1746},{t:this.shape_1747},{t:this.shape_1748},{t:this.shape_1755},{t:this.shape_1754},{t:this.shape_1753},{t:this.shape_1756},{t:this.shape_1757},{t:this.shape_154}]},2).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1742},{t:this.shape_1743},{t:this.shape_1744},{t:this.shape_1745},{t:this.shape_1741},{t:this.shape_1107},{t:this.shape_1751},{t:this.shape_1752},{t:this.shape_1750},{t:this.shape_1749},{t:this.shape_1746},{t:this.shape_1747},{t:this.shape_1748},{t:this.shape_1755},{t:this.shape_1754},{t:this.shape_1753},{t:this.shape_1756},{t:this.shape_1757},{t:this.shape_1758},{t:this.shape_154}]},2).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1742},{t:this.shape_1743},{t:this.shape_1744},{t:this.shape_1745},{t:this.shape_1741},{t:this.shape_1107},{t:this.shape_1751},{t:this.shape_1752},{t:this.shape_1750},{t:this.shape_1749},{t:this.shape_1746},{t:this.shape_1747},{t:this.shape_1748},{t:this.shape_1755},{t:this.shape_1754},{t:this.shape_1753},{t:this.shape_1756},{t:this.shape_1757},{t:this.shape_1758},{t:this.shape_1759},{t:this.shape_154}]},2).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1742},{t:this.shape_1743},{t:this.shape_1744},{t:this.shape_1745},{t:this.shape_1741},{t:this.shape_1107},{t:this.shape_1751},{t:this.shape_1752},{t:this.shape_1750},{t:this.shape_1749},{t:this.shape_1746},{t:this.shape_1747},{t:this.shape_1748},{t:this.shape_1755},{t:this.shape_1754},{t:this.shape_1753},{t:this.shape_1756},{t:this.shape_1757},{t:this.shape_1758},{t:this.shape_1759},{t:this.shape_154},{t:this.shape_1760}]},2).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1742},{t:this.shape_1743},{t:this.shape_1744},{t:this.shape_1745},{t:this.shape_1741},{t:this.shape_1107},{t:this.shape_1751},{t:this.shape_1752},{t:this.shape_1750},{t:this.shape_1749},{t:this.shape_1746},{t:this.shape_1747},{t:this.shape_1748},{t:this.shape_1755},{t:this.shape_1754},{t:this.shape_1753},{t:this.shape_1756},{t:this.shape_1757},{t:this.shape_1758},{t:this.shape_1759},{t:this.shape_154},{t:this.shape_1760},{t:this.shape_1761}]},2).to({state:[{t:this.shape_155},{t:this.shape_156},{t:this.shape_157},{t:this.shape_158},{t:this.shape_159},{t:this.shape_160},{t:this.shape_161},{t:this.shape_162},{t:this.shape_163},{t:this.shape_164},{t:this.shape_165},{t:this.shape_166},{t:this.shape_167},{t:this.shape_168},{t:this.shape_169},{t:this.shape_170},{t:this.shape_171},{t:this.shape_172},{t:this.shape_173},{t:this.shape_174},{t:this.shape_175},{t:this.shape_176},{t:this.shape_177},{t:this.shape_178},{t:this.shape_179},{t:this.shape_180},{t:this.shape_181},{t:this.shape_743},{t:this.shape_744},{t:this.shape_745},{t:this.shape_746},{t:this.shape_747},{t:this.shape_748},{t:this.shape_749},{t:this.shape_750},{t:this.shape_752},{t:this.shape_753},{t:this.shape_1106},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1742},{t:this.shape_1743},{t:this.shape_1744},{t:this.shape_1745},{t:this.shape_1741},{t:this.shape_1107},{t:this.shape_1751},{t:this.shape_1752},{t:this.shape_1750},{t:this.shape_1749},{t:this.shape_1746},{t:this.shape_1747},{t:this.shape_1748},{t:this.shape_1755},{t:this.shape_1754},{t:this.shape_1753},{t:this.shape_1756},{t:this.shape_1757},{t:this.shape_1758},{t:this.shape_1759},{t:this.shape_1763},{t:this.shape_1760},{t:this.shape_1761},{t:this.shape_1762},{t:this.shape_154}]},2).to({state:[{t:this.shape_744},{t:this.shape_743},{t:this.shape_746},{t:this.shape_747},{t:this.shape_745},{t:this.shape_749},{t:this.shape_750},{t:this.shape_748},{t:this.shape_752},{t:this.shape_1106},{t:this.shape_753},{t:this.shape_751},{t:this.shape_1112},{t:this.shape_1113},{t:this.shape_1114},{t:this.shape_1110},{t:this.shape_1111},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1742},{t:this.shape_1743},{t:this.shape_1745},{t:this.shape_1744},{t:this.shape_1741},{t:this.shape_1107},{t:this.shape_1752},{t:this.shape_1751},{t:this.shape_1750},{t:this.shape_1749},{t:this.shape_1746},{t:this.shape_1747},{t:this.shape_1748},{t:this.shape_172},{t:this.shape_171},{t:this.shape_173},{t:this.shape_170},{t:this.shape_169},{t:this.shape_180},{t:this.shape_179},{t:this.shape_181},{t:this.shape_177},{t:this.shape_176},{t:this.shape_174},{t:this.shape_175},{t:this.shape_168},{t:this.shape_167},{t:this.shape_166},{t:this.shape_165},{t:this.shape_178},{t:this.shape_164},{t:this.shape_163},{t:this.shape_162},{t:this.shape_1755},{t:this.shape_1754},{t:this.shape_1753},{t:this.shape_160},{t:this.shape_161},{t:this.shape_159},{t:this.shape_1757},{t:this.shape_1756},{t:this.shape_1758},{t:this.shape_1759},{t:this.shape_157},{t:this.shape_158},{t:this.shape_156},{t:this.shape_155},{t:this.shape_154},{t:this.shape_1763},{t:this.shape_1760},{t:this.shape_1761},{t:this.shape_1762}]},27).to({state:[{t:this.shape_1834},{t:this.shape_1833},{t:this.shape_1832},{t:this.shape_1831},{t:this.shape_1830},{t:this.shape_1829},{t:this.shape_1828},{t:this.shape_1827},{t:this.shape_1826},{t:this.shape_1825},{t:this.shape_1824},{t:this.shape_1823},{t:this.shape_1822},{t:this.shape_1821},{t:this.shape_1820},{t:this.shape_1819},{t:this.shape_1818},{t:this.shape_1817},{t:this.shape_1816},{t:this.shape_1815},{t:this.shape_1814},{t:this.shape_1813},{t:this.shape_1812},{t:this.shape_1811},{t:this.shape_1810},{t:this.shape_1809},{t:this.shape_1808},{t:this.shape_1807},{t:this.shape_1806},{t:this.shape_1805},{t:this.shape_1804},{t:this.shape_1803},{t:this.shape_1802},{t:this.shape_1801},{t:this.shape_1800},{t:this.shape_1799},{t:this.shape_1798},{t:this.shape_1797},{t:this.shape_1796},{t:this.shape_1795},{t:this.shape_1794},{t:this.shape_1793},{t:this.shape_1792},{t:this.shape_1791},{t:this.shape_1790},{t:this.shape_1789},{t:this.shape_1788},{t:this.shape_1787},{t:this.shape_1786},{t:this.shape_1785},{t:this.shape_1784},{t:this.shape_1783},{t:this.shape_1782},{t:this.shape_1781},{t:this.shape_1780},{t:this.shape_1779},{t:this.shape_1778},{t:this.shape_1777},{t:this.shape_1776},{t:this.shape_1775},{t:this.shape_1774},{t:this.shape_1773},{t:this.shape_1772},{t:this.shape_1771},{t:this.shape_1770},{t:this.shape_1769},{t:this.shape_1768},{t:this.shape_1767},{t:this.shape_1766},{t:this.shape_1765},{t:this.shape_1764}]},1).to({state:[{t:this.shape_1905},{t:this.shape_1904},{t:this.shape_1903},{t:this.shape_1902},{t:this.shape_1901},{t:this.shape_1900},{t:this.shape_1899},{t:this.shape_1898},{t:this.shape_1897},{t:this.shape_1896},{t:this.shape_1895},{t:this.shape_1894},{t:this.shape_1893},{t:this.shape_1892},{t:this.shape_1891},{t:this.shape_1890},{t:this.shape_1889},{t:this.shape_1888},{t:this.shape_1887},{t:this.shape_1886},{t:this.shape_1885},{t:this.shape_1884},{t:this.shape_1883},{t:this.shape_1882},{t:this.shape_1881},{t:this.shape_1880},{t:this.shape_1879},{t:this.shape_1878},{t:this.shape_1877},{t:this.shape_1876},{t:this.shape_1875},{t:this.shape_1874},{t:this.shape_1873},{t:this.shape_1872},{t:this.shape_1871},{t:this.shape_1870},{t:this.shape_1869},{t:this.shape_1868},{t:this.shape_1867},{t:this.shape_1866},{t:this.shape_1865},{t:this.shape_1864},{t:this.shape_1863},{t:this.shape_1862},{t:this.shape_1861},{t:this.shape_1860},{t:this.shape_1859},{t:this.shape_1858},{t:this.shape_1857},{t:this.shape_1856},{t:this.shape_1855},{t:this.shape_1854},{t:this.shape_1853},{t:this.shape_1852},{t:this.shape_1851},{t:this.shape_1850},{t:this.shape_1849},{t:this.shape_1848},{t:this.shape_1847},{t:this.shape_1846},{t:this.shape_1845},{t:this.shape_1844},{t:this.shape_1843},{t:this.shape_1842},{t:this.shape_1841},{t:this.shape_1840},{t:this.shape_1839},{t:this.shape_1838},{t:this.shape_1837},{t:this.shape_1836},{t:this.shape_1835}]},1).to({state:[{t:this.shape_1976},{t:this.shape_1975},{t:this.shape_1974},{t:this.shape_1973},{t:this.shape_1972},{t:this.shape_1971},{t:this.shape_1970},{t:this.shape_1969},{t:this.shape_1968},{t:this.shape_1967},{t:this.shape_1966},{t:this.shape_1965},{t:this.shape_1964},{t:this.shape_1963},{t:this.shape_1962},{t:this.shape_1961},{t:this.shape_1960},{t:this.shape_1959},{t:this.shape_1958},{t:this.shape_1957},{t:this.shape_1956},{t:this.shape_1955},{t:this.shape_1954},{t:this.shape_1953},{t:this.shape_1952},{t:this.shape_1951},{t:this.shape_1950},{t:this.shape_1949},{t:this.shape_1948},{t:this.shape_1947},{t:this.shape_1946},{t:this.shape_1945},{t:this.shape_1944},{t:this.shape_1943},{t:this.shape_1942},{t:this.shape_1941},{t:this.shape_1940},{t:this.shape_1939},{t:this.shape_1938},{t:this.shape_1937},{t:this.shape_1936},{t:this.shape_1935},{t:this.shape_1934},{t:this.shape_1933},{t:this.shape_1932},{t:this.shape_1931},{t:this.shape_1930},{t:this.shape_1929},{t:this.shape_1928},{t:this.shape_1927},{t:this.shape_1926},{t:this.shape_1925},{t:this.shape_1924},{t:this.shape_1923},{t:this.shape_1922},{t:this.shape_1921},{t:this.shape_1920},{t:this.shape_1919},{t:this.shape_1918},{t:this.shape_1917},{t:this.shape_1916},{t:this.shape_1915},{t:this.shape_1914},{t:this.shape_1913},{t:this.shape_1912},{t:this.shape_1911},{t:this.shape_1910},{t:this.shape_1909},{t:this.shape_1908},{t:this.shape_1907},{t:this.shape_1906}]},1).to({state:[{t:this.shape_2047},{t:this.shape_2046},{t:this.shape_2045},{t:this.shape_2044},{t:this.shape_2043},{t:this.shape_2042},{t:this.shape_2041},{t:this.shape_2040},{t:this.shape_2039},{t:this.shape_2038},{t:this.shape_2037},{t:this.shape_2036},{t:this.shape_2035},{t:this.shape_2034},{t:this.shape_2033},{t:this.shape_2032},{t:this.shape_2031},{t:this.shape_2030},{t:this.shape_2029},{t:this.shape_2028},{t:this.shape_2027},{t:this.shape_2026},{t:this.shape_2025},{t:this.shape_2024},{t:this.shape_2023},{t:this.shape_2022},{t:this.shape_2021},{t:this.shape_2020},{t:this.shape_2019},{t:this.shape_2018},{t:this.shape_2017},{t:this.shape_2016},{t:this.shape_2015},{t:this.shape_2014},{t:this.shape_2013},{t:this.shape_2012},{t:this.shape_2011},{t:this.shape_2010},{t:this.shape_2009},{t:this.shape_2008},{t:this.shape_2007},{t:this.shape_2006},{t:this.shape_2005},{t:this.shape_2004},{t:this.shape_2003},{t:this.shape_2002},{t:this.shape_2001},{t:this.shape_2000},{t:this.shape_1999},{t:this.shape_1998},{t:this.shape_1997},{t:this.shape_1996},{t:this.shape_1995},{t:this.shape_1994},{t:this.shape_1993},{t:this.shape_1992},{t:this.shape_1991},{t:this.shape_1990},{t:this.shape_1989},{t:this.shape_1988},{t:this.shape_1987},{t:this.shape_1986},{t:this.shape_1985},{t:this.shape_1984},{t:this.shape_1983},{t:this.shape_1982},{t:this.shape_1981},{t:this.shape_1980},{t:this.shape_1979},{t:this.shape_1978},{t:this.shape_1977}]},1).to({state:[{t:this.shape_2118},{t:this.shape_2117},{t:this.shape_2116},{t:this.shape_2115},{t:this.shape_2114},{t:this.shape_2113},{t:this.shape_2112},{t:this.shape_2111},{t:this.shape_2110},{t:this.shape_2109},{t:this.shape_2108},{t:this.shape_2107},{t:this.shape_2106},{t:this.shape_2105},{t:this.shape_2104},{t:this.shape_2103},{t:this.shape_2102},{t:this.shape_2101},{t:this.shape_2100},{t:this.shape_2099},{t:this.shape_2098},{t:this.shape_2097},{t:this.shape_2096},{t:this.shape_2095},{t:this.shape_2094},{t:this.shape_2093},{t:this.shape_2092},{t:this.shape_2091},{t:this.shape_2090},{t:this.shape_2089},{t:this.shape_2088},{t:this.shape_2087},{t:this.shape_2086},{t:this.shape_2085},{t:this.shape_2084},{t:this.shape_2083},{t:this.shape_2082},{t:this.shape_2081},{t:this.shape_2080},{t:this.shape_2079},{t:this.shape_2078},{t:this.shape_2077},{t:this.shape_2076},{t:this.shape_2075},{t:this.shape_2074},{t:this.shape_2073},{t:this.shape_2072},{t:this.shape_2071},{t:this.shape_2070},{t:this.shape_2069},{t:this.shape_2068},{t:this.shape_2067},{t:this.shape_2066},{t:this.shape_2065},{t:this.shape_2064},{t:this.shape_2063},{t:this.shape_2062},{t:this.shape_2061},{t:this.shape_2060},{t:this.shape_2059},{t:this.shape_2058},{t:this.shape_2057},{t:this.shape_2056},{t:this.shape_2055},{t:this.shape_2054},{t:this.shape_2053},{t:this.shape_2052},{t:this.shape_2051},{t:this.shape_2050},{t:this.shape_2049},{t:this.shape_2048}]},1).to({state:[{t:this.shape_2189},{t:this.shape_2188},{t:this.shape_2187},{t:this.shape_2186},{t:this.shape_2185},{t:this.shape_2184},{t:this.shape_2183},{t:this.shape_2182},{t:this.shape_2181},{t:this.shape_2180},{t:this.shape_2179},{t:this.shape_2178},{t:this.shape_2177},{t:this.shape_2176},{t:this.shape_2175},{t:this.shape_2174},{t:this.shape_2173},{t:this.shape_2172},{t:this.shape_2171},{t:this.shape_2170},{t:this.shape_2169},{t:this.shape_2168},{t:this.shape_2167},{t:this.shape_2166},{t:this.shape_2165},{t:this.shape_2164},{t:this.shape_2163},{t:this.shape_2162},{t:this.shape_2161},{t:this.shape_2160},{t:this.shape_2159},{t:this.shape_2158},{t:this.shape_2157},{t:this.shape_2156},{t:this.shape_2155},{t:this.shape_2154},{t:this.shape_2153},{t:this.shape_2152},{t:this.shape_2151},{t:this.shape_2150},{t:this.shape_2149},{t:this.shape_2148},{t:this.shape_2147},{t:this.shape_2146},{t:this.shape_2145},{t:this.shape_2144},{t:this.shape_2143},{t:this.shape_2142},{t:this.shape_2141},{t:this.shape_2140},{t:this.shape_2139},{t:this.shape_2138},{t:this.shape_2137},{t:this.shape_2136},{t:this.shape_2135},{t:this.shape_2134},{t:this.shape_2133},{t:this.shape_2132},{t:this.shape_2131},{t:this.shape_2130},{t:this.shape_2129},{t:this.shape_2128},{t:this.shape_2127},{t:this.shape_2126},{t:this.shape_2125},{t:this.shape_2124},{t:this.shape_2123},{t:this.shape_2122},{t:this.shape_2121},{t:this.shape_2120},{t:this.shape_2119}]},1).to({state:[{t:this.shape_2260},{t:this.shape_2259},{t:this.shape_2258},{t:this.shape_2257},{t:this.shape_2256},{t:this.shape_2255},{t:this.shape_2254},{t:this.shape_2253},{t:this.shape_2252},{t:this.shape_2251},{t:this.shape_2250},{t:this.shape_2249},{t:this.shape_2248},{t:this.shape_2247},{t:this.shape_2246},{t:this.shape_2245},{t:this.shape_2244},{t:this.shape_2243},{t:this.shape_2242},{t:this.shape_2241},{t:this.shape_2240},{t:this.shape_2239},{t:this.shape_2238},{t:this.shape_2237},{t:this.shape_2236},{t:this.shape_2235},{t:this.shape_2234},{t:this.shape_2233},{t:this.shape_2232},{t:this.shape_2231},{t:this.shape_2230},{t:this.shape_2229},{t:this.shape_2228},{t:this.shape_2227},{t:this.shape_2226},{t:this.shape_2225},{t:this.shape_2224},{t:this.shape_2223},{t:this.shape_2222},{t:this.shape_2221},{t:this.shape_2220},{t:this.shape_2219},{t:this.shape_2218},{t:this.shape_2217},{t:this.shape_2216},{t:this.shape_2215},{t:this.shape_2214},{t:this.shape_2213},{t:this.shape_2212},{t:this.shape_2211},{t:this.shape_2210},{t:this.shape_2209},{t:this.shape_2208},{t:this.shape_2207},{t:this.shape_2206},{t:this.shape_2205},{t:this.shape_2204},{t:this.shape_2203},{t:this.shape_2202},{t:this.shape_2201},{t:this.shape_2200},{t:this.shape_2199},{t:this.shape_2198},{t:this.shape_2197},{t:this.shape_2196},{t:this.shape_2195},{t:this.shape_2194},{t:this.shape_2193},{t:this.shape_2192},{t:this.shape_2191},{t:this.shape_2190}]},1).to({state:[{t:this.shape_2331},{t:this.shape_2330},{t:this.shape_2329},{t:this.shape_2328},{t:this.shape_2327},{t:this.shape_2326},{t:this.shape_2325},{t:this.shape_2324},{t:this.shape_2323},{t:this.shape_2322},{t:this.shape_2321},{t:this.shape_2320},{t:this.shape_2319},{t:this.shape_2318},{t:this.shape_2317},{t:this.shape_2316},{t:this.shape_2315},{t:this.shape_2314},{t:this.shape_2313},{t:this.shape_2312},{t:this.shape_2311},{t:this.shape_2310},{t:this.shape_2309},{t:this.shape_2308},{t:this.shape_2307},{t:this.shape_2306},{t:this.shape_2305},{t:this.shape_2304},{t:this.shape_2303},{t:this.shape_2302},{t:this.shape_2301},{t:this.shape_2300},{t:this.shape_2299},{t:this.shape_2298},{t:this.shape_2297},{t:this.shape_2296},{t:this.shape_2295},{t:this.shape_2294},{t:this.shape_2293},{t:this.shape_2292},{t:this.shape_2291},{t:this.shape_2290},{t:this.shape_2289},{t:this.shape_2288},{t:this.shape_2287},{t:this.shape_2286},{t:this.shape_2285},{t:this.shape_2284},{t:this.shape_2283},{t:this.shape_2282},{t:this.shape_2281},{t:this.shape_2280},{t:this.shape_2279},{t:this.shape_2278},{t:this.shape_2277},{t:this.shape_2276},{t:this.shape_2275},{t:this.shape_2274},{t:this.shape_2273},{t:this.shape_2272},{t:this.shape_2271},{t:this.shape_2270},{t:this.shape_2269},{t:this.shape_2268},{t:this.shape_2267},{t:this.shape_2266},{t:this.shape_2265},{t:this.shape_2264},{t:this.shape_2263},{t:this.shape_2262},{t:this.shape_2261}]},1).to({state:[{t:this.shape_2402},{t:this.shape_2401},{t:this.shape_2400},{t:this.shape_2399},{t:this.shape_2398},{t:this.shape_2397},{t:this.shape_2396},{t:this.shape_2395},{t:this.shape_2394},{t:this.shape_2393},{t:this.shape_2392},{t:this.shape_2391},{t:this.shape_2390},{t:this.shape_2389},{t:this.shape_2388},{t:this.shape_2387},{t:this.shape_2386},{t:this.shape_2385},{t:this.shape_2384},{t:this.shape_2383},{t:this.shape_2382},{t:this.shape_2381},{t:this.shape_2380},{t:this.shape_2379},{t:this.shape_2378},{t:this.shape_2377},{t:this.shape_2376},{t:this.shape_2375},{t:this.shape_2374},{t:this.shape_2373},{t:this.shape_2372},{t:this.shape_2371},{t:this.shape_2370},{t:this.shape_2369},{t:this.shape_2368},{t:this.shape_2367},{t:this.shape_2366},{t:this.shape_2365},{t:this.shape_2364},{t:this.shape_2363},{t:this.shape_2362},{t:this.shape_2361},{t:this.shape_2360},{t:this.shape_2359},{t:this.shape_2358},{t:this.shape_2357},{t:this.shape_2356},{t:this.shape_2355},{t:this.shape_2354},{t:this.shape_2353},{t:this.shape_2352},{t:this.shape_2351},{t:this.shape_2350},{t:this.shape_2349},{t:this.shape_2348},{t:this.shape_2347},{t:this.shape_2346},{t:this.shape_2345},{t:this.shape_2344},{t:this.shape_2343},{t:this.shape_2342},{t:this.shape_2341},{t:this.shape_2340},{t:this.shape_2339},{t:this.shape_2338},{t:this.shape_2337},{t:this.shape_2336},{t:this.shape_2335},{t:this.shape_2334},{t:this.shape_2333},{t:this.shape_2332}]},1).to({state:[{t:this.shape_2473},{t:this.shape_2472},{t:this.shape_2471},{t:this.shape_2470},{t:this.shape_2469},{t:this.shape_2468},{t:this.shape_2467},{t:this.shape_2466},{t:this.shape_2465},{t:this.shape_2464},{t:this.shape_2463},{t:this.shape_2462},{t:this.shape_2461},{t:this.shape_2460},{t:this.shape_2459},{t:this.shape_2458},{t:this.shape_2457},{t:this.shape_2456},{t:this.shape_2455},{t:this.shape_2454},{t:this.shape_2453},{t:this.shape_2452},{t:this.shape_2451},{t:this.shape_2450},{t:this.shape_2449},{t:this.shape_2448},{t:this.shape_2447},{t:this.shape_2446},{t:this.shape_2445},{t:this.shape_2444},{t:this.shape_2443},{t:this.shape_2442},{t:this.shape_2441},{t:this.shape_2440},{t:this.shape_2439},{t:this.shape_2438},{t:this.shape_2437},{t:this.shape_2436},{t:this.shape_2435},{t:this.shape_2434},{t:this.shape_2433},{t:this.shape_2432},{t:this.shape_2431},{t:this.shape_2430},{t:this.shape_2429},{t:this.shape_2428},{t:this.shape_2427},{t:this.shape_2426},{t:this.shape_2425},{t:this.shape_2424},{t:this.shape_2423},{t:this.shape_2422},{t:this.shape_2421},{t:this.shape_2420},{t:this.shape_2419},{t:this.shape_2418},{t:this.shape_2417},{t:this.shape_2416},{t:this.shape_2415},{t:this.shape_2414},{t:this.shape_2413},{t:this.shape_2412},{t:this.shape_2411},{t:this.shape_2410},{t:this.shape_2409},{t:this.shape_2408},{t:this.shape_2407},{t:this.shape_2406},{t:this.shape_2405},{t:this.shape_2404},{t:this.shape_2403}]},1).to({state:[{t:this.shape_461},{t:this.shape_460},{t:this.shape_459},{t:this.shape_458},{t:this.shape_457},{t:this.shape_456},{t:this.shape_455},{t:this.shape_2516},{t:this.shape_454},{t:this.shape_453},{t:this.shape_452},{t:this.shape_451},{t:this.shape_450},{t:this.shape_449},{t:this.shape_448},{t:this.shape_447},{t:this.shape_446},{t:this.shape_445},{t:this.shape_444},{t:this.shape_2515},{t:this.shape_2514},{t:this.shape_2513},{t:this.shape_2512},{t:this.shape_2511},{t:this.shape_2510},{t:this.shape_2509},{t:this.shape_2508},{t:this.shape_2507},{t:this.shape_2506},{t:this.shape_2505},{t:this.shape_2504},{t:this.shape_2503},{t:this.shape_2502},{t:this.shape_2501},{t:this.shape_2500},{t:this.shape_2499},{t:this.shape_2498},{t:this.shape_2497},{t:this.shape_2496},{t:this.shape_2495},{t:this.shape_2494},{t:this.shape_2493},{t:this.shape_2492},{t:this.shape_2491},{t:this.shape_2490},{t:this.shape_2489},{t:this.shape_2488},{t:this.shape_2487},{t:this.shape_2486},{t:this.shape_2485},{t:this.shape_443},{t:this.shape_442},{t:this.shape_2484},{t:this.shape_2483},{t:this.shape_2482},{t:this.shape_441},{t:this.shape_440},{t:this.shape_439},{t:this.shape_2481},{t:this.shape_2480},{t:this.shape_2479},{t:this.shape_2478},{t:this.shape_438},{t:this.shape_437},{t:this.shape_436},{t:this.shape_435},{t:this.shape_434},{t:this.shape_2477},{t:this.shape_2476},{t:this.shape_2475},{t:this.shape_2474}]},1).to({state:[{t:this.shape_489},{t:this.shape_488},{t:this.shape_487},{t:this.shape_486},{t:this.shape_485},{t:this.shape_484},{t:this.shape_483},{t:this.shape_2559},{t:this.shape_482},{t:this.shape_481},{t:this.shape_480},{t:this.shape_479},{t:this.shape_478},{t:this.shape_477},{t:this.shape_476},{t:this.shape_475},{t:this.shape_474},{t:this.shape_473},{t:this.shape_472},{t:this.shape_2558},{t:this.shape_2557},{t:this.shape_2556},{t:this.shape_2555},{t:this.shape_2554},{t:this.shape_2553},{t:this.shape_2552},{t:this.shape_2551},{t:this.shape_2550},{t:this.shape_2549},{t:this.shape_2548},{t:this.shape_2547},{t:this.shape_2546},{t:this.shape_2545},{t:this.shape_2544},{t:this.shape_2543},{t:this.shape_2542},{t:this.shape_2541},{t:this.shape_2540},{t:this.shape_2539},{t:this.shape_2538},{t:this.shape_2537},{t:this.shape_2536},{t:this.shape_2535},{t:this.shape_2534},{t:this.shape_2533},{t:this.shape_2532},{t:this.shape_2531},{t:this.shape_2530},{t:this.shape_2529},{t:this.shape_2528},{t:this.shape_471},{t:this.shape_470},{t:this.shape_2527},{t:this.shape_2526},{t:this.shape_2525},{t:this.shape_469},{t:this.shape_468},{t:this.shape_467},{t:this.shape_2524},{t:this.shape_2523},{t:this.shape_2522},{t:this.shape_2521},{t:this.shape_466},{t:this.shape_465},{t:this.shape_464},{t:this.shape_463},{t:this.shape_462},{t:this.shape_2520},{t:this.shape_2519},{t:this.shape_2518},{t:this.shape_2517}]},1).to({state:[{t:this.shape_2630},{t:this.shape_2629},{t:this.shape_2628},{t:this.shape_2627},{t:this.shape_2626},{t:this.shape_2625},{t:this.shape_2624},{t:this.shape_2623},{t:this.shape_2622},{t:this.shape_2621},{t:this.shape_2620},{t:this.shape_2619},{t:this.shape_2618},{t:this.shape_2617},{t:this.shape_2616},{t:this.shape_2615},{t:this.shape_2614},{t:this.shape_2613},{t:this.shape_2612},{t:this.shape_2611},{t:this.shape_2610},{t:this.shape_2609},{t:this.shape_2608},{t:this.shape_2607},{t:this.shape_2606},{t:this.shape_2605},{t:this.shape_2604},{t:this.shape_2603},{t:this.shape_2602},{t:this.shape_2601},{t:this.shape_2600},{t:this.shape_2599},{t:this.shape_2598},{t:this.shape_2597},{t:this.shape_2596},{t:this.shape_2595},{t:this.shape_2594},{t:this.shape_2593},{t:this.shape_2592},{t:this.shape_2591},{t:this.shape_2590},{t:this.shape_2589},{t:this.shape_2588},{t:this.shape_2587},{t:this.shape_2586},{t:this.shape_2585},{t:this.shape_2584},{t:this.shape_2583},{t:this.shape_2582},{t:this.shape_2581},{t:this.shape_2580},{t:this.shape_2579},{t:this.shape_2578},{t:this.shape_2577},{t:this.shape_2576},{t:this.shape_2575},{t:this.shape_2574},{t:this.shape_2573},{t:this.shape_2572},{t:this.shape_2571},{t:this.shape_2570},{t:this.shape_2569},{t:this.shape_2568},{t:this.shape_2567},{t:this.shape_2566},{t:this.shape_2565},{t:this.shape_2564},{t:this.shape_2563},{t:this.shape_2562},{t:this.shape_2561},{t:this.shape_2560}]},1).to({state:[{t:this.shape_2701},{t:this.shape_2700},{t:this.shape_2699},{t:this.shape_2698},{t:this.shape_2697},{t:this.shape_2696},{t:this.shape_2695},{t:this.shape_2694},{t:this.shape_2693},{t:this.shape_2692},{t:this.shape_2691},{t:this.shape_2690},{t:this.shape_2689},{t:this.shape_2688},{t:this.shape_2687},{t:this.shape_2686},{t:this.shape_2685},{t:this.shape_2684},{t:this.shape_2683},{t:this.shape_2682},{t:this.shape_2681},{t:this.shape_2680},{t:this.shape_2679},{t:this.shape_2678},{t:this.shape_2677},{t:this.shape_2676},{t:this.shape_2675},{t:this.shape_2674},{t:this.shape_2673},{t:this.shape_2672},{t:this.shape_2671},{t:this.shape_2670},{t:this.shape_2669},{t:this.shape_2668},{t:this.shape_2667},{t:this.shape_2666},{t:this.shape_2665},{t:this.shape_2664},{t:this.shape_2663},{t:this.shape_2662},{t:this.shape_2661},{t:this.shape_2660},{t:this.shape_2659},{t:this.shape_2658},{t:this.shape_2657},{t:this.shape_2656},{t:this.shape_2655},{t:this.shape_2654},{t:this.shape_2653},{t:this.shape_2652},{t:this.shape_2651},{t:this.shape_2650},{t:this.shape_2649},{t:this.shape_2648},{t:this.shape_2647},{t:this.shape_2646},{t:this.shape_2645},{t:this.shape_2644},{t:this.shape_2643},{t:this.shape_2642},{t:this.shape_2641},{t:this.shape_2640},{t:this.shape_2639},{t:this.shape_2638},{t:this.shape_2637},{t:this.shape_2636},{t:this.shape_2635},{t:this.shape_2634},{t:this.shape_2633},{t:this.shape_2632},{t:this.shape_2631}]},1).to({state:[{t:this.shape_2772},{t:this.shape_2771},{t:this.shape_2770},{t:this.shape_2769},{t:this.shape_2768},{t:this.shape_2767},{t:this.shape_2766},{t:this.shape_2765},{t:this.shape_2764},{t:this.shape_2763},{t:this.shape_2762},{t:this.shape_2761},{t:this.shape_2760},{t:this.shape_2759},{t:this.shape_2758},{t:this.shape_2757},{t:this.shape_2756},{t:this.shape_2755},{t:this.shape_2754},{t:this.shape_2753},{t:this.shape_2752},{t:this.shape_2751},{t:this.shape_2750},{t:this.shape_2749},{t:this.shape_2748},{t:this.shape_2747},{t:this.shape_2746},{t:this.shape_2745},{t:this.shape_2744},{t:this.shape_2743},{t:this.shape_2742},{t:this.shape_2741},{t:this.shape_2740},{t:this.shape_2739},{t:this.shape_2738},{t:this.shape_2737},{t:this.shape_2736},{t:this.shape_2735},{t:this.shape_2734},{t:this.shape_2733},{t:this.shape_2732},{t:this.shape_2731},{t:this.shape_2730},{t:this.shape_2729},{t:this.shape_2728},{t:this.shape_2727},{t:this.shape_2726},{t:this.shape_2725},{t:this.shape_2724},{t:this.shape_2723},{t:this.shape_2722},{t:this.shape_2721},{t:this.shape_2720},{t:this.shape_2719},{t:this.shape_2718},{t:this.shape_2717},{t:this.shape_2716},{t:this.shape_2715},{t:this.shape_2714},{t:this.shape_2713},{t:this.shape_2712},{t:this.shape_2711},{t:this.shape_2710},{t:this.shape_2709},{t:this.shape_2708},{t:this.shape_2707},{t:this.shape_2706},{t:this.shape_2705},{t:this.shape_2704},{t:this.shape_2703},{t:this.shape_2702}]},1).to({state:[{t:this.shape_2843},{t:this.shape_2842},{t:this.shape_2841},{t:this.shape_2840},{t:this.shape_2839},{t:this.shape_2838},{t:this.shape_2837},{t:this.shape_2836},{t:this.shape_2835},{t:this.shape_2834},{t:this.shape_2833},{t:this.shape_2832},{t:this.shape_2831},{t:this.shape_2830},{t:this.shape_2829},{t:this.shape_2828},{t:this.shape_2827},{t:this.shape_2826},{t:this.shape_2825},{t:this.shape_2824},{t:this.shape_2823},{t:this.shape_2822},{t:this.shape_2821},{t:this.shape_2820},{t:this.shape_2819},{t:this.shape_2818},{t:this.shape_2817},{t:this.shape_2816},{t:this.shape_2815},{t:this.shape_2814},{t:this.shape_2813},{t:this.shape_2812},{t:this.shape_2811},{t:this.shape_2810},{t:this.shape_2809},{t:this.shape_2808},{t:this.shape_2807},{t:this.shape_2806},{t:this.shape_2805},{t:this.shape_2804},{t:this.shape_2803},{t:this.shape_2802},{t:this.shape_2801},{t:this.shape_2800},{t:this.shape_2799},{t:this.shape_2798},{t:this.shape_2797},{t:this.shape_2796},{t:this.shape_2795},{t:this.shape_2794},{t:this.shape_2793},{t:this.shape_2792},{t:this.shape_2791},{t:this.shape_2790},{t:this.shape_2789},{t:this.shape_2788},{t:this.shape_2787},{t:this.shape_2786},{t:this.shape_2785},{t:this.shape_2784},{t:this.shape_2783},{t:this.shape_2782},{t:this.shape_2781},{t:this.shape_2780},{t:this.shape_2779},{t:this.shape_2778},{t:this.shape_2777},{t:this.shape_2776},{t:this.shape_2775},{t:this.shape_2774},{t:this.shape_2773}]},1).to({state:[{t:this.shape_2914},{t:this.shape_2913},{t:this.shape_2912},{t:this.shape_2911},{t:this.shape_2910},{t:this.shape_2909},{t:this.shape_2908},{t:this.shape_2907},{t:this.shape_2906},{t:this.shape_2905},{t:this.shape_2904},{t:this.shape_2903},{t:this.shape_2902},{t:this.shape_2901},{t:this.shape_2900},{t:this.shape_2899},{t:this.shape_2898},{t:this.shape_2897},{t:this.shape_2896},{t:this.shape_2895},{t:this.shape_2894},{t:this.shape_2893},{t:this.shape_2892},{t:this.shape_2891},{t:this.shape_2890},{t:this.shape_2889},{t:this.shape_2888},{t:this.shape_2887},{t:this.shape_2886},{t:this.shape_2885},{t:this.shape_2884},{t:this.shape_2883},{t:this.shape_2882},{t:this.shape_2881},{t:this.shape_2880},{t:this.shape_2879},{t:this.shape_2878},{t:this.shape_2877},{t:this.shape_2876},{t:this.shape_2875},{t:this.shape_2874},{t:this.shape_2873},{t:this.shape_2872},{t:this.shape_2871},{t:this.shape_2870},{t:this.shape_2869},{t:this.shape_2868},{t:this.shape_2867},{t:this.shape_2866},{t:this.shape_2865},{t:this.shape_2864},{t:this.shape_2863},{t:this.shape_2862},{t:this.shape_2861},{t:this.shape_2860},{t:this.shape_2859},{t:this.shape_2858},{t:this.shape_2857},{t:this.shape_2856},{t:this.shape_2855},{t:this.shape_2854},{t:this.shape_2853},{t:this.shape_2852},{t:this.shape_2851},{t:this.shape_2850},{t:this.shape_2849},{t:this.shape_2848},{t:this.shape_2847},{t:this.shape_2846},{t:this.shape_2845},{t:this.shape_2844}]},1).to({state:[{t:this.shape_2985},{t:this.shape_2984},{t:this.shape_2983},{t:this.shape_2982},{t:this.shape_2981},{t:this.shape_2980},{t:this.shape_2979},{t:this.shape_2978},{t:this.shape_2977},{t:this.shape_2976},{t:this.shape_2975},{t:this.shape_2974},{t:this.shape_2973},{t:this.shape_2972},{t:this.shape_2971},{t:this.shape_2970},{t:this.shape_2969},{t:this.shape_2968},{t:this.shape_2967},{t:this.shape_2966},{t:this.shape_2965},{t:this.shape_2964},{t:this.shape_2963},{t:this.shape_2962},{t:this.shape_2961},{t:this.shape_2960},{t:this.shape_2959},{t:this.shape_2958},{t:this.shape_2957},{t:this.shape_2956},{t:this.shape_2955},{t:this.shape_2954},{t:this.shape_2953},{t:this.shape_2952},{t:this.shape_2951},{t:this.shape_2950},{t:this.shape_2949},{t:this.shape_2948},{t:this.shape_2947},{t:this.shape_2946},{t:this.shape_2945},{t:this.shape_2944},{t:this.shape_2943},{t:this.shape_2942},{t:this.shape_2941},{t:this.shape_2940},{t:this.shape_2939},{t:this.shape_2938},{t:this.shape_2937},{t:this.shape_2936},{t:this.shape_2935},{t:this.shape_2934},{t:this.shape_2933},{t:this.shape_2932},{t:this.shape_2931},{t:this.shape_2930},{t:this.shape_2929},{t:this.shape_2928},{t:this.shape_2927},{t:this.shape_2926},{t:this.shape_2925},{t:this.shape_2924},{t:this.shape_2923},{t:this.shape_2922},{t:this.shape_2921},{t:this.shape_2920},{t:this.shape_2919},{t:this.shape_2918},{t:this.shape_2917},{t:this.shape_2916},{t:this.shape_2915}]},1).to({state:[{t:this.shape_3056},{t:this.shape_3055},{t:this.shape_3054},{t:this.shape_3053},{t:this.shape_3052},{t:this.shape_3051},{t:this.shape_3050},{t:this.shape_3049},{t:this.shape_3048},{t:this.shape_3047},{t:this.shape_3046},{t:this.shape_3045},{t:this.shape_3044},{t:this.shape_3043},{t:this.shape_3042},{t:this.shape_3041},{t:this.shape_3040},{t:this.shape_3039},{t:this.shape_3038},{t:this.shape_3037},{t:this.shape_3036},{t:this.shape_3035},{t:this.shape_3034},{t:this.shape_3033},{t:this.shape_3032},{t:this.shape_3031},{t:this.shape_3030},{t:this.shape_3029},{t:this.shape_3028},{t:this.shape_3027},{t:this.shape_3026},{t:this.shape_3025},{t:this.shape_3024},{t:this.shape_3023},{t:this.shape_3022},{t:this.shape_3021},{t:this.shape_3020},{t:this.shape_3019},{t:this.shape_3018},{t:this.shape_3017},{t:this.shape_3016},{t:this.shape_3015},{t:this.shape_3014},{t:this.shape_3013},{t:this.shape_3012},{t:this.shape_3011},{t:this.shape_3010},{t:this.shape_3009},{t:this.shape_3008},{t:this.shape_3007},{t:this.shape_3006},{t:this.shape_3005},{t:this.shape_3004},{t:this.shape_3003},{t:this.shape_3002},{t:this.shape_3001},{t:this.shape_3000},{t:this.shape_2999},{t:this.shape_2998},{t:this.shape_2997},{t:this.shape_2996},{t:this.shape_2995},{t:this.shape_2994},{t:this.shape_2993},{t:this.shape_2992},{t:this.shape_2991},{t:this.shape_2990},{t:this.shape_2989},{t:this.shape_2988},{t:this.shape_2987},{t:this.shape_2986}]},1).to({state:[{t:this.shape_3127},{t:this.shape_3126},{t:this.shape_3125},{t:this.shape_3124},{t:this.shape_3123},{t:this.shape_3122},{t:this.shape_3121},{t:this.shape_3120},{t:this.shape_3119},{t:this.shape_3118},{t:this.shape_3117},{t:this.shape_3116},{t:this.shape_3115},{t:this.shape_3114},{t:this.shape_3113},{t:this.shape_3112},{t:this.shape_3111},{t:this.shape_3110},{t:this.shape_3109},{t:this.shape_3108},{t:this.shape_3107},{t:this.shape_3106},{t:this.shape_3105},{t:this.shape_3104},{t:this.shape_3103},{t:this.shape_3102},{t:this.shape_3101},{t:this.shape_3100},{t:this.shape_3099},{t:this.shape_3098},{t:this.shape_3097},{t:this.shape_3096},{t:this.shape_3095},{t:this.shape_3094},{t:this.shape_3093},{t:this.shape_3092},{t:this.shape_3091},{t:this.shape_3090},{t:this.shape_3089},{t:this.shape_3088},{t:this.shape_3087},{t:this.shape_3086},{t:this.shape_3085},{t:this.shape_3084},{t:this.shape_3083},{t:this.shape_3082},{t:this.shape_3081},{t:this.shape_3080},{t:this.shape_3079},{t:this.shape_3078},{t:this.shape_3077},{t:this.shape_3076},{t:this.shape_3075},{t:this.shape_3074},{t:this.shape_3073},{t:this.shape_3072},{t:this.shape_3071},{t:this.shape_3070},{t:this.shape_3069},{t:this.shape_3068},{t:this.shape_3067},{t:this.shape_3066},{t:this.shape_3065},{t:this.shape_3064},{t:this.shape_3063},{t:this.shape_3062},{t:this.shape_3061},{t:this.shape_3060},{t:this.shape_3059},{t:this.shape_3058},{t:this.shape_3057}]},1).to({state:[{t:this.shape_3198},{t:this.shape_3197},{t:this.shape_3196},{t:this.shape_3195},{t:this.shape_3194},{t:this.shape_3193},{t:this.shape_3192},{t:this.shape_3191},{t:this.shape_3190},{t:this.shape_3189},{t:this.shape_3188},{t:this.shape_3187},{t:this.shape_3186},{t:this.shape_3185},{t:this.shape_3184},{t:this.shape_3183},{t:this.shape_3182},{t:this.shape_3181},{t:this.shape_3180},{t:this.shape_3179},{t:this.shape_3178},{t:this.shape_3177},{t:this.shape_3176},{t:this.shape_3175},{t:this.shape_3174},{t:this.shape_3173},{t:this.shape_3172},{t:this.shape_3171},{t:this.shape_3170},{t:this.shape_3169},{t:this.shape_3168},{t:this.shape_3167},{t:this.shape_3166},{t:this.shape_3165},{t:this.shape_3164},{t:this.shape_3163},{t:this.shape_3162},{t:this.shape_3161},{t:this.shape_3160},{t:this.shape_3159},{t:this.shape_3158},{t:this.shape_3157},{t:this.shape_3156},{t:this.shape_3155},{t:this.shape_3154},{t:this.shape_3153},{t:this.shape_3152},{t:this.shape_3151},{t:this.shape_3150},{t:this.shape_3149},{t:this.shape_3148},{t:this.shape_3147},{t:this.shape_3146},{t:this.shape_3145},{t:this.shape_3144},{t:this.shape_3143},{t:this.shape_3142},{t:this.shape_3141},{t:this.shape_3140},{t:this.shape_3139},{t:this.shape_3138},{t:this.shape_3137},{t:this.shape_3136},{t:this.shape_3135},{t:this.shape_3134},{t:this.shape_3133},{t:this.shape_3132},{t:this.shape_3131},{t:this.shape_3130},{t:this.shape_3129},{t:this.shape_3128}]},1).to({state:[{t:this.shape_3269},{t:this.shape_3268},{t:this.shape_3267},{t:this.shape_3266},{t:this.shape_3265},{t:this.shape_3264},{t:this.shape_3263},{t:this.shape_3262},{t:this.shape_3261},{t:this.shape_3260},{t:this.shape_3259},{t:this.shape_3258},{t:this.shape_3257},{t:this.shape_3256},{t:this.shape_3255},{t:this.shape_3254},{t:this.shape_3253},{t:this.shape_3252},{t:this.shape_3251},{t:this.shape_3250},{t:this.shape_3249},{t:this.shape_3248},{t:this.shape_3247},{t:this.shape_3246},{t:this.shape_3245},{t:this.shape_3244},{t:this.shape_3243},{t:this.shape_3242},{t:this.shape_3241},{t:this.shape_3240},{t:this.shape_3239},{t:this.shape_3238},{t:this.shape_3237},{t:this.shape_3236},{t:this.shape_3235},{t:this.shape_3234},{t:this.shape_3233},{t:this.shape_3232},{t:this.shape_3231},{t:this.shape_3230},{t:this.shape_3229},{t:this.shape_3228},{t:this.shape_3227},{t:this.shape_3226},{t:this.shape_3225},{t:this.shape_3224},{t:this.shape_3223},{t:this.shape_3222},{t:this.shape_3221},{t:this.shape_3220},{t:this.shape_3219},{t:this.shape_3218},{t:this.shape_3217},{t:this.shape_3216},{t:this.shape_3215},{t:this.shape_3214},{t:this.shape_3213},{t:this.shape_3212},{t:this.shape_3211},{t:this.shape_3210},{t:this.shape_3209},{t:this.shape_3208},{t:this.shape_3207},{t:this.shape_3206},{t:this.shape_3205},{t:this.shape_3204},{t:this.shape_3203},{t:this.shape_3202},{t:this.shape_3201},{t:this.shape_3200},{t:this.shape_3199}]},1).to({state:[{t:this.shape_3270}]},1).to({state:[{t:this.shape_3270}]},1).to({state:[{t:this.shape_3270}]},1).to({state:[{t:this.shape_3270}]},1).to({state:[{t:this.shape_3270}]},1).to({state:[{t:this.shape_3270}]},1).to({state:[{t:this.shape_3270}]},1).to({state:[{t:this.shape_3270}]},1).to({state:[{t:this.shape_3270}]},1).to({state:[{t:this.shape_3270}]},1).to({state:[{t:this.shape_3270}]},1).to({state:[{t:this.shape_3270}]},1).to({state:[{t:this.shape_3270}]},1).to({state:[{t:this.shape_3270}]},1).to({state:[{t:this.shape_3270}]},1).to({state:[{t:this.shape_3270}]},1).to({state:[{t:this.shape_3270}]},1).to({state:[{t:this.shape_3270}]},1).to({state:[{t:this.shape_3270}]},1).to({state:[{t:this.shape_3270}]},1).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.shape_3270).wait(559).to({_off:false},0).wait(20));

	// pathMove
	this.shape_3271 = new cjs.Shape();
	this.shape_3271.graphics.f("#FFFFFF").s().p("AhdBeQgngnAAg3QAAg2AngnQAngnA2AAQA3AAAnAnQAnAnAAA2QAAA3gnAnQgnAng3AAQg2AAgngng");
	this.shape_3271.setTransform(-510.625,132.625);

	this.shape_3272 = new cjs.Shape();
	this.shape_3272.graphics.f("#FFFFFF").s().p("AhxANIDThJIAQAwIjTBJg");
	this.shape_3272.setTransform(-468.325,117.725);

	this.shape_3273 = new cjs.Shape();
	this.shape_3273.graphics.f("#FFFFFF").s().p("AhxAMIDThHIAQAwIjTBHg");
	this.shape_3273.setTransform(-425.825,103.1);

	this.shape_3274 = new cjs.Shape();
	this.shape_3274.graphics.f("#FFFFFF").s().p("AhxAMIDUhGIAPAvIjTBGg");
	this.shape_3274.setTransform(-383.3,88.725);

	this.shape_3275 = new cjs.Shape();
	this.shape_3275.graphics.f("#FFFFFF").s().p("AhyAKIBrgiQA3gSA2gPIANAxQguALg+AUIhpAjg");
	this.shape_3275.setTransform(-340.575,74.725);

	this.shape_3276 = new cjs.Shape();
	this.shape_3276.graphics.f("#FFFFFF").s().p("Ah0gCQBngWB6gVIAIAxQiCAWhdATg");
	this.shape_3276.setTransform(-296.25,64.05);

	this.shape_3277 = new cjs.Shape();
	this.shape_3277.graphics.f("#FFFFFF").s().p("Ah0gIIDigfIAHAwIjhAgg");
	this.shape_3277.setTransform(-251.075,56.95);

	this.shape_3278 = new cjs.Shape();
	this.shape_3278.graphics.f("#FFFFFF").s().p("Ah0gIIDhgfIAIAwIjiAfg");
	this.shape_3278.setTransform(-205.675,50.875);

	this.shape_3279 = new cjs.Shape();
	this.shape_3279.graphics.f("#FFFFFF").s().p("Ah1gCQB+gVBhgXIALAwQhaAViHAYg");
	this.shape_3279.setTransform(-160.5,43.575);

	this.shape_3280 = new cjs.Shape();
	this.shape_3280.graphics.f("#FFFFFF").s().p("AhqAkQCFg1AjhBIAsAXQgqBQiXA+g");
	this.shape_3280.setTransform(-117.75,28.75);

	this.shape_3281 = new cjs.Shape();
	this.shape_3281.graphics.f("#FFFFFF").s().p("AgRANQgnghgqggIAegoQAnAdAsAoQAxApAjArIgnAgQgfgmgugqg");
	this.shape_3281.setTransform(-122.5,-6.825);

	this.shape_3282 = new cjs.Shape();
	this.shape_3282.graphics.f("#FFFFFF").s().p("AhsgLIANgxQBrAeBhAuIgWAtQhbgthogbg");
	this.shape_3282.setTransform(-159.025,-28.975);

	this.shape_3283 = new cjs.Shape();
	this.shape_3283.graphics.f("#FFFFFF").s().p("AhqAXIgCgxQBygFBmALIgEAwQhlgKhtAFg");
	this.shape_3283.setTransform(-200.9,-36.7925);

	this.shape_3284 = new cjs.Shape();
	this.shape_3284.graphics.f("#FFFFFF").s().p("AhtgCQBqgaBpgRIAIAxQhhAPhuAbg");
	this.shape_3284.setTransform(-243.525,-32.85);

	this.shape_3285 = new cjs.Shape();
	this.shape_3285.graphics.f("#FFFFFF").s().p("AhvALQAsgMA+gWIBlgjIAQAwQgwAOg1ATQg6AVgxAPg");
	this.shape_3285.setTransform(-284.875,-21.325);

	this.shape_3286 = new cjs.Shape();
	this.shape_3286.graphics.f("#FFFFFF").s().p("AhxgKQBtgHBtgVIAJAwQhyAWhvAHg");
	this.shape_3286.setTransform(-328.05,-10.925);

	this.shape_3287 = new cjs.Shape();
	this.shape_3287.graphics.f("#FFFFFF").s().p("AhyAAIAPguQBkAgByANIgGAwQh2gMhpgjg");
	this.shape_3287.setTransform(-373,-12.325);

	this.shape_3288 = new cjs.Shape();
	this.shape_3288.graphics.f("#FFFFFF").s().p("AghAZQgwg1gDhFIAygCQADA0AiAoQAdAfA1AjIgcAqQg4gmgigmg");
	this.shape_3288.setTransform(-411.075,-32.2);

	this.shape_3289 = new cjs.Shape();
	this.shape_3289.graphics.f("#FFFFFF").s().p("AhpA/QBHhRBwhNIAcApQhrBKhCBMg");
	this.shape_3289.setTransform(-398.975,-71.425);

	this.shape_3290 = new cjs.Shape();
	this.shape_3290.graphics.f("#FFFFFF").s().p("Ah2AZQBmgyB2gsIARAvQh0AqhjAyg");
	this.shape_3290.setTransform(-358.325,-95.45);

	this.shape_3291 = new cjs.Shape();
	this.shape_3291.graphics.f("#FFFFFF").s().p("Ah5AGQBqgeB9gdIALAwQh5AchrAfg");
	this.shape_3291.setTransform(-313.25,-110.575);

	this.shape_3292 = new cjs.Shape();
	this.shape_3292.graphics.f("#FFFFFF").s().p("Ah5gEIB2gUIB0gUIAJAwQhDANg0AIIhzAUg");
	this.shape_3292.setTransform(-266.575,-120.375);

	this.shape_3293 = new cjs.Shape();
	this.shape_3293.graphics.f("#FFFFFF").s().p("Ah5AKQB7geBmgmIASAvQhmAliAAhg");
	this.shape_3293.setTransform(-219.775,-130.875);

	this.shape_3294 = new cjs.Shape();
	this.shape_3294.graphics.f("#FFFFFF").s().p("AhtAxQBlg7BUhRIAiAlQhYBThqA/g");
	this.shape_3294.setTransform(-177.075,-151.575);

	this.shape_3295 = new cjs.Shape();
	this.shape_3295.graphics.f("#FFFFFF").s().p("AhbBPQAug6BiiCIAnAeQh2CdgaAgg");
	this.shape_3295.setTransform(-144.525,-186.225);

	this.shape_3296 = new cjs.Shape();
	this.shape_3296.graphics.f("#FFFFFF").s().p("AhhBKQBQhfBPhUIAkAiQhPBVhOBcg");
	this.shape_3296.setTransform(-114.5,-223.5);

	this.shape_3297 = new cjs.Shape();
	this.shape_3297.graphics.f("#FFFFFF").s().p("AhrA+QA7g3AegZQAzguAtgiIAeAnQg0AogqAlQgpAlguAsg");
	this.shape_3297.setTransform(-80.375,-257.35);

	this.shape_3298 = new cjs.Shape();
	this.shape_3298.graphics.f("#FFFFFF").s().p("AhwAiIgQguQCIgvB5AyIgTAtQhngph3Ang");
	this.shape_3298.setTransform(-37.725,-278.5196);

	this.shape_3299 = new cjs.Shape();
	this.shape_3299.graphics.f("#FFFFFF").s().p("AhhhLIAkgjQA/BEBgB6IgnAfQhdh3g/hDg");
	this.shape_3299.setTransform(1.75,-253.225);

	this.shape_3300 = new cjs.Shape();
	this.shape_3300.graphics.f("#FFFFFF").s().p("AhihOIAngfQBcBxBCBIIglAiQhKhThWhpg");
	this.shape_3300.setTransform(32.725,-214.9);

	this.shape_3301 = new cjs.Shape();
	this.shape_3301.graphics.f("#FFFFFF").s().p("Ahug8IAiglQBdBWBeBEIgeApQhkhMhbhSg");
	this.shape_3301.setTransform(67.475,-180.175);

	this.shape_3302 = new cjs.Shape();
	this.shape_3302.graphics.f("#FFFFFF").s().p("Ah4ghIAZgsQBtA/BrAuIgUAuQhugxhvg+g");
	this.shape_3302.setTransform(108.425,-153.25);

	this.shape_3303 = new cjs.Shape();
	this.shape_3303.graphics.f("#FFFFFF").s().p("AgFAaQg6gQg+gTIAPgwQA2ASA/ARIB3AfIgNAxg");
	this.shape_3303.setTransform(154.35,-135.525);

	this.shape_3304 = new cjs.Shape();
	this.shape_3304.graphics.f("#FFFFFF").s().p("Ah9gCIAMgxQBmAZCJAdIgLAxQh1gah7gcg");
	this.shape_3304.setTransform(202.225,-123.35);

	this.shape_3305 = new cjs.Shape();
	this.shape_3305.graphics.f("#FFFFFF").s().p("Ah9ACIAKgvQBrAUCFAXIgIAwQh0gTh+gZg");
	this.shape_3305.setTransform(250.45,-113.45);

	this.shape_3306 = new cjs.Shape();
	this.shape_3306.graphics.f("#FFFFFF").s().p("ABJAQQgCAFAEAGIADAEIgCgBIgPgFQghgJiVgUIAHgxIByARQAzAIAXAGQANADALAFQAOAHAHAKQAIASgKAQQgGAKgMAHg");
	this.shape_3306.setTransform(298.7901,-104.575);

	this.shape_3307 = new cjs.Shape();
	this.shape_3307.graphics.f("#FFFFFF").s().p("Ah1AZIBnguIBygxIATAuIhxAwIhmAvg");
	this.shape_3307.setTransform(273.8,-86.475);

	this.shape_3308 = new cjs.Shape();
	this.shape_3308.graphics.f("#FFFFFF").s().p("AhsApQBQg7Bxg+IAYArQhtA9hOA6g");
	this.shape_3308.setTransform(232.95,-65.4);

	this.shape_3309 = new cjs.Shape();
	this.shape_3309.graphics.f("#FFFFFF").s().p("AACh3IAqAbQg/BiAsBcIgsAWQg6h0BPh7g");
	this.shape_3309.setTransform(205.1312,-32.65);

	this.shape_3310 = new cjs.Shape();
	this.shape_3310.graphics.f("#FFFFFF").s().p("AhvghIAbgpQBRA2BzAxIgUAuQh2g0hVg4g");
	this.shape_3310.setTransform(231.025,-0.325);

	this.shape_3311 = new cjs.Shape();
	this.shape_3311.graphics.f("#FFFFFF").s().p("AgFAcIgCAAIAAAAIgBAAIgBgBQg2gQg3gSIAQgvIBqAjIBzAaIgLAwg");
	this.shape_3311.setTransform(273.675,16.25);

	this.shape_3312 = new cjs.Shape();
	this.shape_3312.graphics.f("#FFFFFF").s().p("Ah7gIIANgwQBjAaCHAmIgOAxQhmgeiDgjg");
	this.shape_3312.setTransform(320.475,28.6);

	this.shape_3313 = new cjs.Shape();
	this.shape_3313.graphics.f("#FFFFFF").s().p("Ah6gMIAOgxQCFArBjAgIgRAvQh1gohwghg");
	this.shape_3313.setTransform(367,42.55);

	this.shape_3314 = new cjs.Shape();
	this.shape_3314.graphics.f("#FFFFFF").s().p("Ah5gUIARguQBtAoB1AvIgTAuQhogrh4gsg");
	this.shape_3314.setTransform(412.875,58.825);

	this.shape_3315 = new cjs.Shape();
	this.shape_3315.graphics.f("#FFFFFF").s().p("Ah4gdIAWguQBvAzBrA3IgXAtQhng2hygzg");
	this.shape_3315.setTransform(457.5,78.175);

	this.shape_3316 = new cjs.Shape();
	this.shape_3316.graphics.f("#FFFFFF").s().p("AhxguIAagrQBvBGBaBGIgeAnQhVhDhwhFg");
	this.shape_3316.setTransform(499.575,102.375);

	this.shape_3317 = new cjs.Shape();
	this.shape_3317.graphics.f("#FFFFFF").s().p("AhVhQIAlghQBcBoArBpIgvASQgohjhVhfg");
	this.shape_3317.setTransform(534.05,135.7);

	this.shape_3318 = new cjs.Shape();
	this.shape_3318.graphics.f("#FFFFFF").s().p("AhCBdQBFhqAPhqIAxAHQgQBzhLB1g");
	this.shape_3318.setTransform(539.325,181.675);

	this.shape_3319 = new cjs.Shape();
	this.shape_3319.graphics.f("#FFFFFF").s().p("AhwA4QA2gmAsgjQAvglAugqIAhAlQgoAmg3ArQgyAogxAjg");
	this.shape_3319.setTransform(509.25,218.425);

	this.shape_3320 = new cjs.Shape();
	this.shape_3320.graphics.f("#FFFFFF").s().p("Ah5AcQBwgqBrg8IAYAsQhxA9hwAsg");
	this.shape_3320.setTransform(467.65,244.375);

	this.shape_3321 = new cjs.Shape();
	this.shape_3321.graphics.f("#FFFFFF").s().p("Ah8gEQB+gMBwgbIAMAvQh+Adh4AMg");
	this.shape_3321.setTransform(420.95,258.85);

	this.shape_3322 = new cjs.Shape();
	this.shape_3322.graphics.f("#FFFFFF").s().p("Ah7APIAGgxQB5AQB4AEIgBAxQh2gEiAgQg");
	this.shape_3322.setTransform(371.7,260.625);

	this.shape_3323 = new cjs.Shape();
	this.shape_3323.graphics.f("#FFFFFF").s().p("Ah9gEIANgwQB4AhB2AXIgLAxQhsgXiEgig");
	this.shape_3323.setTransform(323.275,252.65);

	this.shape_3324 = new cjs.Shape();
	this.shape_3324.graphics.f("#FFFFFF").s().p("Ah8gNIAQgvQCAAqBpAfIgPAwQhagbiQgvg");
	this.shape_3324.setTransform(275.975,239.275);

	this.shape_3325 = new cjs.Shape();
	this.shape_3325.graphics.f("#FFFFFF").s().p("Ah8gPIAQgvIDpBOIgQAvg");
	this.shape_3325.setTransform(229.275,223.775);

	this.shape_3326 = new cjs.Shape();
	this.shape_3326.graphics.f("#FFFFFF").s().p("Ah8gMIAPgwQBlAfCFAqIgQAwQiKguhfgbg");
	this.shape_3326.setTransform(182.575,208.375);

	this.shape_3327 = new cjs.Shape();
	this.shape_3327.graphics.f("#FFFFFF").s().p("Ah8gFIALgxQCGAhBoAcIgNAwQh0ggh4gcg");
	this.shape_3327.setTransform(135.325,194.675);

	this.shape_3328 = new cjs.Shape();
	this.shape_3328.graphics.f("#FFFFFF").s().p("Ah8ADIAHgxQB8AUB2AZIgKAwQh7gZh0gTg");
	this.shape_3328.setTransform(87.3,183.95);

	this.shape_3329 = new cjs.Shape();
	this.shape_3329.graphics.f("#FFFFFF").s().p("Ah7ANIADgxQB4AJB8APIgFAxQh8gPh2gJg");
	this.shape_3329.setTransform(38.6,177.125);

	this.shape_3330 = new cjs.Shape();
	this.shape_3330.graphics.f("#FFFFFF").s().p("Ah3AZIgBgxIB2gBIB7ACIgBAxg");
	this.shape_3330.setTransform(-10.3,174.675);

	this.shape_3331 = new cjs.Shape();
	this.shape_3331.graphics.f("#FFFFFF").s().p("Ah0gRQCEgKBigEIADAwQh2AGhvAKg");
	this.shape_3331.setTransform(-56.975,176.2);

	this.shape_3332 = new cjs.Shape();
	this.shape_3332.graphics.f("#FFFFFF").s().p("Ah1gHQBqgSB7gPIAGAxQhxANhyATg");
	this.shape_3332.setTransform(-102.95,180.925);

	this.shape_3333 = new cjs.Shape();
	this.shape_3333.graphics.f("#FFFFFF").s().p("Ah2ACQB2gcBsgXIAKAxQh6AZhmAZg");
	this.shape_3333.setTransform(-148.35,189.375);

	this.shape_3334 = new cjs.Shape();
	this.shape_3334.graphics.f("#FFFFFF").s().p("Ah1AJQBrggByghIAOAwQhxAghrAhg");
	this.shape_3334.setTransform(-193.025,201.275);

	this.shape_3335 = new cjs.Shape();
	this.shape_3335.graphics.f("#FFFFFF").s().p("Ah1ALIDchEIAPAvIjcBEg");
	this.shape_3335.setTransform(-237.125,215.025);

	this.shape_3336 = new cjs.Shape();
	this.shape_3336.graphics.f("#FFFFFF").s().p("Ah1ADQBtgXBxgfIANAwQh4AghoAXg");
	this.shape_3336.setTransform(-281.5,227.7);

	this.shape_3337 = new cjs.Shape();
	this.shape_3337.graphics.f("#FFFFFF").s().p("Ah1gJQB1gMBugSIAIAxQhxASh1AMg");
	this.shape_3337.setTransform(-326.875,236.275);

	this.shape_3338 = new cjs.Shape();
	this.shape_3338.graphics.f("#FFFFFF").s().p("AhzAaIABgxQB2ACBugFIACAxQhTAEhYAAIg8gBg");
	this.shape_3338.setTransform(-372.975,239.5188);

	this.shape_3339 = new cjs.Shape();
	this.shape_3339.graphics.f("#FFFFFF").s().p("Ah0APIAGgxQB7ANBoAGIgDAxQhwgHh2gMg");
	this.shape_3339.setTransform(-419.25,237.75);

	this.shape_3340 = new cjs.Shape();
	this.shape_3340.graphics.f("#FFFFFF").s().p("Ag+AMIALgvIByAXIgKAxg");
	this.shape_3340.setTransform(-504.875,224.85);

	this.shape_3341 = new cjs.Shape();
	this.shape_3341.graphics.f("#FFFFFF").s().p("Ah1AGIAIgwQB0AUBvAQIgHAxQhygRhygUg");
	this.shape_3341.setTransform(-465.05,232.125);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_3271}]}).to({state:[{t:this.shape_3272},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3319},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3319},{t:this.shape_3320},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3319},{t:this.shape_3320},{t:this.shape_3321},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3319},{t:this.shape_3320},{t:this.shape_3321},{t:this.shape_3322},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3319},{t:this.shape_3320},{t:this.shape_3321},{t:this.shape_3322},{t:this.shape_3323},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3319},{t:this.shape_3320},{t:this.shape_3321},{t:this.shape_3322},{t:this.shape_3323},{t:this.shape_3324},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3319},{t:this.shape_3320},{t:this.shape_3321},{t:this.shape_3322},{t:this.shape_3323},{t:this.shape_3324},{t:this.shape_3325},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3319},{t:this.shape_3320},{t:this.shape_3321},{t:this.shape_3322},{t:this.shape_3323},{t:this.shape_3324},{t:this.shape_3325},{t:this.shape_3326},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3319},{t:this.shape_3320},{t:this.shape_3321},{t:this.shape_3322},{t:this.shape_3323},{t:this.shape_3324},{t:this.shape_3325},{t:this.shape_3326},{t:this.shape_3327},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3319},{t:this.shape_3320},{t:this.shape_3321},{t:this.shape_3322},{t:this.shape_3323},{t:this.shape_3324},{t:this.shape_3325},{t:this.shape_3326},{t:this.shape_3327},{t:this.shape_3328},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3319},{t:this.shape_3320},{t:this.shape_3321},{t:this.shape_3322},{t:this.shape_3323},{t:this.shape_3324},{t:this.shape_3325},{t:this.shape_3326},{t:this.shape_3327},{t:this.shape_3328},{t:this.shape_3329},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3319},{t:this.shape_3320},{t:this.shape_3321},{t:this.shape_3322},{t:this.shape_3323},{t:this.shape_3324},{t:this.shape_3325},{t:this.shape_3326},{t:this.shape_3327},{t:this.shape_3328},{t:this.shape_3329},{t:this.shape_3330},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3319},{t:this.shape_3320},{t:this.shape_3321},{t:this.shape_3322},{t:this.shape_3323},{t:this.shape_3324},{t:this.shape_3325},{t:this.shape_3326},{t:this.shape_3327},{t:this.shape_3328},{t:this.shape_3329},{t:this.shape_3330},{t:this.shape_3331},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3319},{t:this.shape_3320},{t:this.shape_3321},{t:this.shape_3322},{t:this.shape_3323},{t:this.shape_3324},{t:this.shape_3325},{t:this.shape_3326},{t:this.shape_3327},{t:this.shape_3328},{t:this.shape_3329},{t:this.shape_3330},{t:this.shape_3331},{t:this.shape_3332},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3319},{t:this.shape_3320},{t:this.shape_3321},{t:this.shape_3322},{t:this.shape_3323},{t:this.shape_3324},{t:this.shape_3325},{t:this.shape_3326},{t:this.shape_3327},{t:this.shape_3328},{t:this.shape_3329},{t:this.shape_3330},{t:this.shape_3331},{t:this.shape_3332},{t:this.shape_3333},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3319},{t:this.shape_3320},{t:this.shape_3321},{t:this.shape_3322},{t:this.shape_3323},{t:this.shape_3324},{t:this.shape_3325},{t:this.shape_3326},{t:this.shape_3327},{t:this.shape_3328},{t:this.shape_3329},{t:this.shape_3330},{t:this.shape_3331},{t:this.shape_3332},{t:this.shape_3333},{t:this.shape_3334},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3319},{t:this.shape_3320},{t:this.shape_3321},{t:this.shape_3322},{t:this.shape_3323},{t:this.shape_3324},{t:this.shape_3325},{t:this.shape_3326},{t:this.shape_3327},{t:this.shape_3328},{t:this.shape_3329},{t:this.shape_3330},{t:this.shape_3331},{t:this.shape_3332},{t:this.shape_3333},{t:this.shape_3334},{t:this.shape_3335},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3319},{t:this.shape_3320},{t:this.shape_3321},{t:this.shape_3322},{t:this.shape_3323},{t:this.shape_3324},{t:this.shape_3325},{t:this.shape_3326},{t:this.shape_3327},{t:this.shape_3328},{t:this.shape_3329},{t:this.shape_3330},{t:this.shape_3331},{t:this.shape_3332},{t:this.shape_3333},{t:this.shape_3334},{t:this.shape_3335},{t:this.shape_3336},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3319},{t:this.shape_3320},{t:this.shape_3321},{t:this.shape_3322},{t:this.shape_3323},{t:this.shape_3324},{t:this.shape_3325},{t:this.shape_3326},{t:this.shape_3327},{t:this.shape_3328},{t:this.shape_3329},{t:this.shape_3330},{t:this.shape_3331},{t:this.shape_3332},{t:this.shape_3333},{t:this.shape_3334},{t:this.shape_3335},{t:this.shape_3336},{t:this.shape_3337},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3319},{t:this.shape_3320},{t:this.shape_3321},{t:this.shape_3322},{t:this.shape_3323},{t:this.shape_3324},{t:this.shape_3325},{t:this.shape_3326},{t:this.shape_3327},{t:this.shape_3328},{t:this.shape_3329},{t:this.shape_3330},{t:this.shape_3331},{t:this.shape_3332},{t:this.shape_3333},{t:this.shape_3334},{t:this.shape_3335},{t:this.shape_3336},{t:this.shape_3337},{t:this.shape_3338},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3319},{t:this.shape_3320},{t:this.shape_3321},{t:this.shape_3322},{t:this.shape_3323},{t:this.shape_3324},{t:this.shape_3325},{t:this.shape_3326},{t:this.shape_3327},{t:this.shape_3328},{t:this.shape_3329},{t:this.shape_3330},{t:this.shape_3331},{t:this.shape_3332},{t:this.shape_3333},{t:this.shape_3334},{t:this.shape_3335},{t:this.shape_3336},{t:this.shape_3337},{t:this.shape_3338},{t:this.shape_3339},{t:this.shape_3271}]},1).to({state:[{t:this.shape_3272},{t:this.shape_3273},{t:this.shape_3274},{t:this.shape_3275},{t:this.shape_3276},{t:this.shape_3277},{t:this.shape_3278},{t:this.shape_3279},{t:this.shape_3280},{t:this.shape_3281},{t:this.shape_3282},{t:this.shape_3283},{t:this.shape_3284},{t:this.shape_3285},{t:this.shape_3286},{t:this.shape_3287},{t:this.shape_3288},{t:this.shape_3289},{t:this.shape_3290},{t:this.shape_3291},{t:this.shape_3292},{t:this.shape_3293},{t:this.shape_3294},{t:this.shape_3295},{t:this.shape_3296},{t:this.shape_3297},{t:this.shape_3298},{t:this.shape_3299},{t:this.shape_3300},{t:this.shape_3301},{t:this.shape_3302},{t:this.shape_3303},{t:this.shape_3304},{t:this.shape_3305},{t:this.shape_3306},{t:this.shape_3307},{t:this.shape_3308},{t:this.shape_3309},{t:this.shape_3310},{t:this.shape_3311},{t:this.shape_3312},{t:this.shape_3313},{t:this.shape_3314},{t:this.shape_3315},{t:this.shape_3316},{t:this.shape_3317},{t:this.shape_3318},{t:this.shape_3319},{t:this.shape_3320},{t:this.shape_3321},{t:this.shape_3322},{t:this.shape_3323},{t:this.shape_3324},{t:this.shape_3325},{t:this.shape_3326},{t:this.shape_3327},{t:this.shape_3328},{t:this.shape_3329},{t:this.shape_3330},{t:this.shape_3331},{t:this.shape_3332},{t:this.shape_3333},{t:this.shape_3334},{t:this.shape_3335},{t:this.shape_3336},{t:this.shape_3337},{t:this.shape_3338},{t:this.shape_3339},{t:this.shape_3341},{t:this.shape_3340},{t:this.shape_3271}]},1).wait(509));

	this.filterCacheList = [];
	this.filterCacheList.push({instance: this.instance_15, startFrame:69, endFrame:69, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_15, startFrame:70, endFrame:510, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_15, startFrame:511, endFrame:517, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_15, startFrame:518, endFrame:537, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_15, startFrame:538, endFrame:561, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_15, startFrame:561, endFrame:579, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_16, startFrame:47, endFrame:47, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_16, startFrame:48, endFrame:426, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_16, startFrame:427, endFrame:438, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_16, startFrame:439, endFrame:450, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_16, startFrame:451, endFrame:466, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_16, startFrame:466, endFrame:579, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_17, startFrame:37, endFrame:37, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_17, startFrame:38, endFrame:360, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_17, startFrame:361, endFrame:374, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_17, startFrame:375, endFrame:384, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_17, startFrame:385, endFrame:394, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_17, startFrame:394, endFrame:579, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_18, startFrame:26, endFrame:26, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_18, startFrame:27, endFrame:280, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_18, startFrame:281, endFrame:287, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_18, startFrame:288, endFrame:308, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_18, startFrame:309, endFrame:330, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_18, startFrame:330, endFrame:579, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_19, startFrame:8, endFrame:8, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_19, startFrame:9, endFrame:175, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_19, startFrame:176, endFrame:213, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_19, startFrame:214, endFrame:228, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_19, startFrame:229, endFrame:330, x:-31, y:-20, w:63, h:40});
	this.filterCacheList.push({instance: this.instance_19, startFrame:330, endFrame:579, x:-31, y:-20, w:63, h:40});
	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-596.1,-459,1182.5,723.1);


(lib.downloadButton_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// up
	this.up = new lib.DownloadPdfButtonUp();
	this.up.name = "up";
	this.up.setTransform(0,2.5);

	this.timeline.addTween(cjs.Tween.get(this.up).wait(1));

	// down
	this.down = new lib.DownloadPdfButtonDown();
	this.down.name = "down";

	this.timeline.addTween(cjs.Tween.get(this.down).wait(1));

	// over
	this.over = new lib.DownloadPdfButtonOver();
	this.over.name = "over";
	this.over.setTransform(0,0.5);

	this.timeline.addTween(cjs.Tween.get(this.over).wait(1));

	// disabled
	this.disabled = new lib.DownloadPdfButtonDisabled();
	this.disabled.name = "disabled";
	this.disabled.setTransform(0,0.5);

	this.timeline.addTween(cjs.Tween.get(this.disabled).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.downloadButton_1, new cjs.Rectangle(-297,-83.5,594,167), null);


(lib.pijlUpDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {trustUp:0,trustDown:1,groupSpiritUp:2,groupSpiritDown:3,genericUp:4,genericDown:5};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.pijlAni = new lib.ArrowAnimation_orange();
	this.pijlAni.name = "pijlAni";
	this.pijlAni.setTransform(-0.5,9.5);

	this.pijlAni_1 = new lib.ArrowAnimation_green();
	this.pijlAni_1.name = "pijlAni_1";
	this.pijlAni_1.setTransform(-0.5,5.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.pijlAni,p:{rotation:0,y:9.5}}]}).to({state:[{t:this.pijlAni,p:{rotation:180,y:-5.4}}]},1).to({state:[{t:this.pijlAni_1,p:{rotation:0,y:5.5}}]},1).to({state:[{t:this.pijlAni_1,p:{rotation:180,y:-6}}]},1).to({state:[{t:this.pijlAni,p:{rotation:0,y:5.5}}]},1).to({state:[{t:this.pijlAni,p:{rotation:180,y:-5.4}}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-24.5,-90.5,48.1,184.5);


(lib.NonInteractiveConversationScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// narrativeTextField
	this.textPanel = new lib.chapterPanel_1();
	this.textPanel.name = "textPanel";
	this.textPanel.setTransform(0,396.1);

	this.backButton = new lib.ConversationButton_Primary();
	this.backButton.name = "backButton";
	this.backButton.setTransform(-849.9,455.05,1,1,0,0,0,-2,-0.5);

	this.continueButton = new lib.ConversationButton_Primary();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(849.4,455.55);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.continueButton},{t:this.backButton},{t:this.textPanel}]}).wait(1));

	// BG
	this.bgImageContainer = new lib.ChapterIntroductionImageContainer();
	this.bgImageContainer.name = "bgImageContainer";

	this.timeline.addTween(cjs.Tween.get(this.bgImageContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NonInteractiveConversationScreenSkin, new cjs.Rectangle(-1120.5,-540.5,2241,1081), null);


(lib.MissionBriefingScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// panel
	this.panel = new lib.Coach_Introduction_Panel();
	this.panel.name = "panel";
	this.panel.setTransform(-416.05,-3.95,1,1,0,0,0,0,-0.5);

	this.timeline.addTween(cjs.Tween.get(this.panel).wait(1));

	// roboGuru
	this.coach = new lib.roboGuru_missionbrief();
	this.coach.name = "coach";
	this.coach.setTransform(578.2,190.15,1,1,-0.0358,0,0,-0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.coach).wait(1));

	// bgImageContainer
	this.bgImageContainer = new lib.missionbriefingBg_blurred();
	this.bgImageContainer.name = "bgImageContainer";

	this.timeline.addTween(cjs.Tween.get(this.bgImageContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.MissionBriefingScreenSkin, new cjs.Rectangle(-1120.5,-540.5,2778.5,2997.4), null);


(lib.LoadingScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textField
	this.loadingPanel = new lib.loading();
	this.loadingPanel.name = "loadingPanel";
	this.loadingPanel.setTransform(0,440.15);

	this.timeline.addTween(cjs.Tween.get(this.loadingPanel).wait(1));

	// path
	this.progressionPath = new lib.progressionPath();
	this.progressionPath.name = "progressionPath";
	this.progressionPath.setTransform(59,31.1);

	this.timeline.addTween(cjs.Tween.get(this.progressionPath).wait(1));
	this.progressionPath.addEventListener("tick", AdobeAn.handleFilterCache);

	// bg_def
	this.instance = new lib.loadingScreenBG();
	this.instance.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg_temp
	this.instance_1 = new lib.loadingBG();
	this.instance_1.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Laag_4
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(255,255,255,0)").ss(1,1,1).p("Eiu/hUXMFd/AAAMAAACovMld/AAAg");
	this.shape.setTransform(-0.025,0);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#000000").s().p("Eiu/BUYMAAAiovMFd/AAAMAAACovg");
	this.shape_1.setTransform(-0.025,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LoadingScreenSkin, new cjs.Rectangle(-1121,-541,2242,1082), null);


(lib.InputDemoScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// input
	this.verder = new lib.ConversationButton_Primary();
	this.verder.name = "verder";
	this.verder.setTransform(10.95,125.75,1,1,0,0,0,-0.8,-0.8);

	this.demoInput = new lib.demoInput_1();
	this.demoInput.name = "demoInput";
	this.demoInput.setTransform(2.5,4.5,1,1,0,0,0,-0.5,3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.demoInput},{t:this.verder}]}).wait(1));

	// roboTextField
	this.panel = new lib.roboGuruPanel();
	this.panel.name = "panel";
	this.panel.setTransform(0,-268.75);

	this.timeline.addTween(cjs.Tween.get(this.panel).wait(1));

	// Screen_over
	this.overlay = new lib.DarkendOverlay();
	this.overlay.name = "overlay";
	this.overlay.setTransform(-5,0);

	this.timeline.addTween(cjs.Tween.get(this.overlay).wait(1));

	// Background
	this.instance = new lib.Endframe();
	this.instance.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.InputDemoScreen, new cjs.Rectangle(-1125,-540.5,2245.5,1081), null);


(lib.ConversationResultScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// titleTextField
	this.titleTextField = new cjs.Text("[Einde gesprek]", "bold 48px 'JetBrains Mono'", "#FFFFFF");
	this.titleTextField.name = "titleTextField";
	this.titleTextField.textAlign = "center";
	this.titleTextField.lineHeight = 65;
	this.titleTextField.lineWidth = 1292;
	this.titleTextField.parent = this;
	this.titleTextField.setTransform(0,-438);
ranj.TextOffsetFixer.fix(this.titleTextField);

	this.timeline.addTween(cjs.Tween.get(this.titleTextField).wait(1));

	// continueButton
	this.continueButton = new lib.ConversationButton_Primary();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(0,0,1,1,0,0,0,-0.5,-0.5);

	this.timeline.addTween(cjs.Tween.get(this.continueButton).wait(1));

	// characterTrackerPanel2
	this.characterTrackerPanel1 = new lib.CharacterFeedbackPanel();
	this.characterTrackerPanel1.name = "characterTrackerPanel1";
	this.characterTrackerPanel1.setTransform(561.15,64.45);

	this.timeline.addTween(cjs.Tween.get(this.characterTrackerPanel1).wait(1));

	// characterTrackerPanel1
	this.characterTrackerPanel2 = new lib.CharacterFeedbackPanel();
	this.characterTrackerPanel2.name = "characterTrackerPanel2";
	this.characterTrackerPanel2.setTransform(-567.1,64.45);

	this.timeline.addTween(cjs.Tween.get(this.characterTrackerPanel2).wait(1));

	// vignette
	this.vignette = new lib.vignette();
	this.vignette.name = "vignette";
	this.vignette.setTransform(0,-341.95);

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("ECsfgT/IFDAAMAAAAn/IlDAAEixgAUAQgBz2ABz1QAAgCAAgDQAAgCAAgCIAAgL");
	this.shape.setTransform(16.1479,-412.025);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.vignette}]}).wait(1));

	// backgroundImageContainer
	this.backgroundImageContainer = new lib.ConversationPreviewBackgroundImageContainer();
	this.backgroundImageContainer.name = "backgroundImageContainer";

	this.timeline.addTween(cjs.Tween.get(this.backgroundImageContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationResultScreenSkin, new cjs.Rectangle(-1121,-541.9,2274.3,1082.4), null);


(lib.ConversationPreviewScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// backButton
	this.continueButton = new lib.ConversationButton_Primary();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(-1.5,0,1,1,0,0,0,-2,-0.5);

	this.backButton = new lib.ConversationButton_Primary();
	this.backButton.name = "backButton";
	this.backButton.setTransform(-863.4,-459.5,1,1,0,0,0,-2,-0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.backButton},{t:this.continueButton}]}).wait(1));

	// characterTrackerPanel2
	this.characterTrackerPanel1 = new lib.CharacterFeedbackPanel();
	this.characterTrackerPanel1.name = "characterTrackerPanel1";
	this.characterTrackerPanel1.setTransform(561.15,64.45);

	this.timeline.addTween(cjs.Tween.get(this.characterTrackerPanel1).wait(1));

	// characterTrackerPanel1
	this.characterTrackerPanel2 = new lib.CharacterFeedbackPanel();
	this.characterTrackerPanel2.name = "characterTrackerPanel2";
	this.characterTrackerPanel2.setTransform(-567.1,64.45);

	this.timeline.addTween(cjs.Tween.get(this.characterTrackerPanel2).wait(1));

	// backgroundImageContainer
	this.backgroundImageContainer = new lib.ConversationPreviewBackgroundImageContainer();
	this.backgroundImageContainer.name = "backgroundImageContainer";

	this.timeline.addTween(cjs.Tween.get(this.backgroundImageContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationPreviewScreenSkin, new cjs.Rectangle(-1120.5,-540.5,2241,1081), null);


(lib.ConversationOutcomeScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// narrativeTextField
	this.textPanel = new lib.chapterPanel_1();
	this.textPanel.name = "textPanel";
	this.textPanel.setTransform(0,396.1);

	this.backButton = new lib.ConversationButton_Primary();
	this.backButton.name = "backButton";
	this.backButton.setTransform(-849.9,455.05,1,1,0,0,0,-2,-0.5);

	this.continueButton = new lib.ConversationButton_Primary();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(849.4,455.55);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.continueButton},{t:this.backButton},{t:this.textPanel}]}).wait(1));

	// BG
	this.bgImageContainer = new lib.ChapterIntroductionImageContainer();
	this.bgImageContainer.name = "bgImageContainer";

	this.timeline.addTween(cjs.Tween.get(this.bgImageContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationOutcomeScreenSkin, new cjs.Rectangle(-1120.5,-540.5,2241,1081), null);


(lib.ConversationIntroductionScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// buttons
	this.textPanel = new lib.chapterPanel_1();
	this.textPanel.name = "textPanel";
	this.textPanel.setTransform(0,396.1);

	this.backButton = new lib.ConversationButton_Primary();
	this.backButton.name = "backButton";
	this.backButton.setTransform(-849.9,455.05,1,1,0,0,0,-2,-0.5);

	this.continueButton = new lib.ConversationButton_Primary();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(849.4,455.55);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.continueButton},{t:this.backButton},{t:this.textPanel}]}).wait(1));

	// BG
	this.bgImageContainer = new lib.ChapterIntroductionImageContainer();
	this.bgImageContainer.name = "bgImageContainer";

	this.timeline.addTween(cjs.Tween.get(this.bgImageContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationIntroductionScreenSkin, new cjs.Rectangle(-1120.5,-540.5,2241,1081), null);


(lib.ConversationFeedbackScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textHeader
	this.contentTextHeader = new cjs.Text("Einde gesprek", "45px 'JetBrains Mono'", "#FFFFFF");
	this.contentTextHeader.name = "contentTextHeader";
	this.contentTextHeader.lineHeight = 61;
	this.contentTextHeader.lineWidth = 1073;
	this.contentTextHeader.parent = this;
	this.contentTextHeader.setTransform(-773.5,-525);
ranj.TextOffsetFixer.fix(this.contentTextHeader);

	this.timeline.addTween(cjs.Tween.get(this.contentTextHeader).wait(1));

	// panel
	this.panel = new lib.Coach_Feedback_Panel();
	this.panel.name = "panel";
	this.panel.setTransform(-403,19.5,1,1,0,0,0,0,-0.5);

	this.timeline.addTween(cjs.Tween.get(this.panel).wait(1));

	// robby
	this.robbyReflection = new lib.Robby_popup();
	this.robbyReflection.name = "robbyReflection";
	this.robbyReflection.setTransform(541,135.5);

	this.timeline.addTween(cjs.Tween.get(this.robbyReflection).wait(1));

	// disabled
	this.disabledDialog = new lib.dialogDisabled_black();
	this.disabledDialog.name = "disabledDialog";
	this.disabledDialog.setTransform(-38,8);
	this.disabledDialog.filters = [new cjs.BlurFilter(2, 2, 3)];
	this.disabledDialog.cache(-319,-249,473,365);

	this.timeline.addTween(cjs.Tween.get(this.disabledDialog).wait(1));

	// Layer_2
	this.vignette = new lib.vignette();
	this.vignette.name = "vignette";
	this.vignette.setTransform(0,-340);

	this.timeline.addTween(cjs.Tween.get(this.vignette).wait(1));

	// bgImageContainer
	this.bgImageContainer = new lib.missionbriefingBg_blurred();
	this.bgImageContainer.name = "bgImageContainer";

	this.timeline.addTween(cjs.Tween.get(this.bgImageContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationFeedbackScreenSkin, new cjs.Rectangle(-1120.5,-540.5,2266,2207), null);


(lib.ChapterIntroductionScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// narrativeTextField
	this.textPanel = new lib.chapterPanel_1();
	this.textPanel.name = "textPanel";
	this.textPanel.setTransform(0,396.1);

	this.backButton = new lib.ConversationButton_Primary();
	this.backButton.name = "backButton";
	this.backButton.setTransform(-849.9,455.05,1,1,0,0,0,-2,-0.5);

	this.continueButton = new lib.ConversationButton_Primary();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(849.4,455.55);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.continueButton},{t:this.backButton},{t:this.textPanel}]}).wait(1));

	// BG
	this.bgImageContainer = new lib.ChapterIntroductionImageContainer();
	this.bgImageContainer.name = "bgImageContainer";

	this.timeline.addTween(cjs.Tween.get(this.bgImageContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChapterIntroductionScreenSkin, new cjs.Rectangle(-1120.5,-540.5,2241,1081), null);


(lib.ChapterHubScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// navigation
	this.previousButton = new lib.Dialog_Arrow_button_terug();
	this.previousButton.name = "previousButton";
	this.previousButton.setTransform(-852,0,1,1,0,0,0,-2,-0.5);

	this.nextButton = new lib.Dialog_Arrow_button_verder();
	this.nextButton.name = "nextButton";
	this.nextButton.setTransform(868.9,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.nextButton},{t:this.previousButton}]}).wait(1));

	// roboGuru
	this.coachButton = new lib.RoboGuru_Help();
	this.coachButton.name = "coachButton";
	this.coachButton.setTransform(726.45,419.5);

	this.timeline.addTween(cjs.Tween.get(this.coachButton).wait(1));

	// teaserPanel
	this.teaserPanel = new lib.ConversationTeaserPanel();
	this.teaserPanel.name = "teaserPanel";
	this.teaserPanel.setTransform(0,-389.65);

	this.timeline.addTween(cjs.Tween.get(this.teaserPanel).wait(1));

	// tile_conversation_5
	this.tile_conversation_5 = new lib.HubTile_chapter_1_conversation_5();
	this.tile_conversation_5.name = "tile_conversation_5";

	this.timeline.addTween(cjs.Tween.get(this.tile_conversation_5).wait(1));

	// tile_conversation_4
	this.tile_conversation_4 = new lib.HubTile_chapter_1_conversation_4();
	this.tile_conversation_4.name = "tile_conversation_4";

	this.timeline.addTween(cjs.Tween.get(this.tile_conversation_4).wait(1));

	// tile_conversation_3
	this.tile_conversation_3 = new lib.HubTile_chapter_1_conversation_3();
	this.tile_conversation_3.name = "tile_conversation_3";

	this.timeline.addTween(cjs.Tween.get(this.tile_conversation_3).wait(1));

	// tile_conversation_2
	this.tile_conversation_2 = new lib.HubTile_chapter_1_conversation_2();
	this.tile_conversation_2.name = "tile_conversation_2";

	this.timeline.addTween(cjs.Tween.get(this.tile_conversation_2).wait(1));

	// tile_conversation_1
	this.tile_conversation_1 = new lib.HubTile_chapter_1_conversation_1();
	this.tile_conversation_1.name = "tile_conversation_1";

	this.timeline.addTween(cjs.Tween.get(this.tile_conversation_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChapterHubScreenSkin, new cjs.Rectangle(-1120.5,-540.5,2241,1081), null);


(lib.EndOfGamePanelScore = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// titleTextField
	this.titleTextField = new cjs.Text("Eindscore:", "bold 48px 'JetBrains Mono'", "#FFFFFF");
	this.titleTextField.name = "titleTextField";
	this.titleTextField.textAlign = "center";
	this.titleTextField.lineHeight = 65;
	this.titleTextField.lineWidth = 648;
	this.titleTextField.parent = this;
	this.titleTextField.setTransform(0,-497.6);
ranj.TextOffsetFixer.fix(this.titleTextField);

	this.timeline.addTween(cjs.Tween.get(this.titleTextField).wait(1));

	// scoreMeter
	this.scoreMeter = new lib.teamOmeter();
	this.scoreMeter.name = "scoreMeter";
	this.scoreMeter.setTransform(0,-45.6);

	this.timeline.addTween(cjs.Tween.get(this.scoreMeter).wait(1));

	// trustTextField
	this.scoreHeaderTextField = new cjs.Text("Jouw score in de game:", "bold 34px 'JetBrains Mono'", "#FFFFFF");
	this.scoreHeaderTextField.name = "scoreHeaderTextField";
	this.scoreHeaderTextField.textAlign = "center";
	this.scoreHeaderTextField.lineHeight = 47;
	this.scoreHeaderTextField.lineWidth = 1196;
	this.scoreHeaderTextField.parent = this;
	this.scoreHeaderTextField.setTransform(0,332.4);
ranj.TextOffsetFixer.fix(this.scoreHeaderTextField);

	this.trustTextField = new cjs.Text("100% Vertrouwen in jou", "bold 34px 'JetBrains Mono'", "#FFFFFF");
	this.trustTextField.name = "trustTextField";
	this.trustTextField.textAlign = "center";
	this.trustTextField.lineHeight = 47;
	this.trustTextField.lineWidth = 1196;
	this.trustTextField.parent = this;
	this.trustTextField.setTransform(0,432.4);
ranj.TextOffsetFixer.fix(this.trustTextField);

	this.groupSpiritTextField = new cjs.Text("100% Groepsgevoel", "bold 34px 'JetBrains Mono'", "#FFFFFF");
	this.groupSpiritTextField.name = "groupSpiritTextField";
	this.groupSpiritTextField.textAlign = "center";
	this.groupSpiritTextField.lineHeight = 47;
	this.groupSpiritTextField.lineWidth = 1196;
	this.groupSpiritTextField.parent = this;
	this.groupSpiritTextField.setTransform(0,381.3);
ranj.TextOffsetFixer.fix(this.groupSpiritTextField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.groupSpiritTextField},{t:this.trustTextField},{t:this.scoreHeaderTextField}]}).wait(1));

	// bg_endofgame_jpg
	this.instance = new lib.bg_endofgame();
	this.instance.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EndOfGamePanelScore, new cjs.Rectangle(-1120,-540,2240,1080), null);


(lib.onboardingPanelMore = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// header
	this.headerTextField = new cjs.Text("He waar kan ik je mee helpen?????????]\nHe waar kan ik je mee helpen?????????]\nHe waar kan ik je mee helpen?????????]\nHe waar kan ik je mee helpen?????????]", "28px 'JetBrains Mono'", "#FE9625");
	this.headerTextField.name = "headerTextField";
	this.headerTextField.lineHeight = 39;
	this.headerTextField.lineWidth = 640;
	this.headerTextField.parent = this;
	this.headerTextField.setTransform(-470.8,-98.2);
ranj.TextOffsetFixer.fix(this.headerTextField);

	this.timeline.addTween(cjs.Tween.get(this.headerTextField).wait(1));

	// buttons
	this.instance = new lib.RoboGuru_Buttontok();
	this.instance.setTransform(226,39,1,1,0,0,0,0,2.4);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_2
	this.instance_1 = new lib.roboGuru_help_panel();
	this.instance_1.setTransform(-543,-150);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.onboardingPanelMore, new cjs.Rectangle(-543,-150,890,288), null);


(lib.Dialog_AIResponse_panel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.pijlenUpDown = new lib.pijlUpDown();
	this.pijlenUpDown.name = "pijlenUpDown";
	this.pijlenUpDown.setTransform(255.5,4);

	this.timeline.addTween(cjs.Tween.get(this.pijlenUpDown).wait(1));

	// text
	this.responseText = new cjs.Text("PLACEHOLDER PLACEHOLDER PLACEHOLDER]]] PLACEHOLDERRRRPLACEHOLDER PLACEHOLDER]", "22px 'JetBrains Mono'", "#FE9625");
	this.responseText.name = "responseText";
	this.responseText.lineHeight = 31;
	this.responseText.lineWidth = 505;
	this.responseText.parent = this;
	this.responseText.setTransform(-281.05,-22.5);
ranj.TextOffsetFixer.fix(this.responseText);

	this.timeline.addTween(cjs.Tween.get(this.responseText).wait(1));

	// BG
	this.instance = new lib.Dialog_Chat_AIResponse_Panel();
	this.instance.setTransform(-309,-37);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Dialog_AIResponse_panel, new cjs.Rectangle(-309,-37,611,135), null);


(lib.ConversationScreenInputField = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// sendButton
	this.sendButton = new lib.Conversation_SendButton();
	this.sendButton.name = "sendButton";
	this.sendButton.setTransform(1343.6,52.5);

	this.timeline.addTween(cjs.Tween.get(this.sendButton).wait(1));

	// bodytext
	this.inputText = new cjs.Text("[Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem....}\n[Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem....}\n[Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem....}\n[Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem....}", "22px 'JetBrains Mono'", "#FFFFFF");
	this.inputText.name = "inputText";
	this.inputText.lineHeight = 31;
	this.inputText.lineWidth = 1259;
	this.inputText.parent = this;
	this.inputText.setTransform(28.7,-10.45);
ranj.TextOffsetFixer.fix(this.inputText);

	this.timeline.addTween(cjs.Tween.get(this.inputText).wait(1));

	// Layer_2
	this.instance = new lib.Dialog_Chat_Panel_Input6();
	this.instance.setTransform(-11,-44);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationScreenInputField, new cjs.Rectangle(-11,-44,1444.6,205), null);


(lib.ConversationResponse2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.actionPanel = new lib.Dialog_Action_Panel();
	this.actionPanel.name = "actionPanel";
	this.actionPanel.setTransform(111.7,-184.55);

	this.timeline.addTween(cjs.Tween.get(this.actionPanel).wait(1));

	// profile
	this.profilePicture = new lib.profilePicture();
	this.profilePicture.name = "profilePicture";
	this.profilePicture.setTransform(453.8,-71);

	this.timeline.addTween(cjs.Tween.get(this.profilePicture).wait(1));

	// text
	this.conversationPanel = new lib.ConversationPanel();
	this.conversationPanel.name = "conversationPanel";
	this.conversationPanel.setTransform(40.7,-92);

	this.timeline.addTween(cjs.Tween.get(this.conversationPanel).wait(1));

	// AIResponse
	this.aiBotResponse = new lib.Dialog_AIResponse_panel();
	this.aiBotResponse.name = "aiBotResponse";
	this.aiBotResponse.setTransform(42,-20);

	this.timeline.addTween(cjs.Tween.get(this.aiBotResponse).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationResponse2, new cjs.Rectangle(-285.3,-220.5,872.9000000000001,298.5), null);


(lib.ConversationResponse1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// ProfilePicture
	this.actionPanel = new lib.Dialog_Action_Panel();
	this.actionPanel.name = "actionPanel";
	this.actionPanel.setTransform(-123.5,-187);

	this.profilePicture = new lib.profilePicture();
	this.profilePicture.name = "profilePicture";
	this.profilePicture.setTransform(-458.8,-72.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.profilePicture},{t:this.actionPanel}]}).wait(1));

	// background
	this.conversationPanel = new lib.ConversationPanel();
	this.conversationPanel.name = "conversationPanel";
	this.conversationPanel.setTransform(-53.5,-94.7);

	this.timeline.addTween(cjs.Tween.get(this.conversationPanel).wait(1));

	// AIResponse
	this.aiBotResponse = new lib.Dialog_AIResponse_panel();
	this.aiBotResponse.name = "aiBotResponse";
	this.aiBotResponse.setTransform(-54,-23.25);

	this.timeline.addTween(cjs.Tween.get(this.aiBotResponse).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationResponse1, new cjs.Rectangle(-597.5,-223,872,297.8), null);


(lib.ConversationRefelctionScreenInputField = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// sendButton
	this.sendButton = new lib.Conversation_SendButton();
	this.sendButton.name = "sendButton";
	this.sendButton.setTransform(1055.55,51);

	this.timeline.addTween(cjs.Tween.get(this.sendButton).wait(1));

	// bodytext
	this.inputText = new cjs.Text("[Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum\n[Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum\n[Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum\n[Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum", "22px 'JetBrains Mono'", "#FFFFFF");
	this.inputText.name = "inputText";
	this.inputText.lineHeight = 31;
	this.inputText.lineWidth = 956;
	this.inputText.parent = this;
	this.inputText.setTransform(40.7,-6.45);
ranj.TextOffsetFixer.fix(this.inputText);

	this.timeline.addTween(cjs.Tween.get(this.inputText).wait(1));

	// Layer_2
	this.instance = new lib.ReflectionInput();
	this.instance.setTransform(-11,-44);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationRefelctionScreenInputField, new cjs.Rectangle(-11,-44,1164,195), null);


(lib.ConversationCoachPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// header
	this.headerTextField = new cjs.Text("He waar kan ik je mee helpen?", "32px 'JetBrains Mono'", "#FE9625");
	this.headerTextField.name = "headerTextField";
	this.headerTextField.lineHeight = 44;
	this.headerTextField.lineWidth = 763;
	this.headerTextField.parent = this;
	this.headerTextField.setTransform(-473.8,-102.2);
ranj.TextOffsetFixer.fix(this.headerTextField);

	this.timeline.addTween(cjs.Tween.get(this.headerTextField).wait(1));

	// buttons
	this.briefingButton = new lib.PlaceholderButton();
	this.briefingButton.name = "briefingButton";
	this.briefingButton.setTransform(-99.35,41,1,1,0,0,0,0,-5);

	this.hintButton = new lib.PlaceholderButton();
	this.hintButton.name = "hintButton";
	this.hintButton.setTransform(-99.35,-26.75,1,1,0,0,0,0,-5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.hintButton},{t:this.briefingButton}]}).wait(1));

	// Layer_2
	this.instance = new lib.roboGuru_help_panel();
	this.instance.setTransform(-543,-150);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationCoachPanel, new cjs.Rectangle(-543,-150,890,288), null);


(lib.ConversationReflectionReadyPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.divTextField = new cjs.Text("------------------------------------------------------------------", "26px 'JetBrains Mono'", "#FE9625");
	this.divTextField.name = "divTextField";
	this.divTextField.lineHeight = 36;
	this.divTextField.lineWidth = 1031;
	this.divTextField.parent = this;
	this.divTextField.setTransform(-515.5,-37.6);
ranj.TextOffsetFixer.fix(this.divTextField);

	this.promptTextField = new cjs.Text("CKlaar met reflecteren?]", "26px 'JetBrains Mono'", "#FE9625");
	this.promptTextField.name = "promptTextField";
	this.promptTextField.lineHeight = 36;
	this.promptTextField.lineWidth = 766;
	this.promptTextField.parent = this;
	this.promptTextField.setTransform(-515.5,0.7);
ranj.TextOffsetFixer.fix(this.promptTextField);

	this.finishButton = new lib.RoboGuru_ButtonBekijkImpact();
	this.finishButton.name = "finishButton";
	this.finishButton.setTransform(391.05,19.15);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.finishButton},{t:this.promptTextField},{t:this.divTextField}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationReflectionReadyPanel, new cjs.Rectangle(-517.5,-39.6,1035,79.30000000000001), null);


(lib.OnboardingStep_SelectScenario = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Arrow
	this.arrow = new lib.arrow();
	this.arrow.name = "arrow";
	this.arrow.setTransform(-18.2,-212.8);

	this.timeline.addTween(cjs.Tween.get(this.arrow).wait(1));

	// coachPanel
	this.coachPanel = new lib.onboardingPanel();
	this.coachPanel.name = "coachPanel";
	this.coachPanel.setTransform(493.85,233,1,1,0,0,0,-10.5,32.5);

	this.timeline.addTween(cjs.Tween.get(this.coachPanel).wait(1));

	// pluseRing
	this.pulseRingTimmer = new lib.Dialog_pulseRing_animationTimmer();
	this.pulseRingTimmer.name = "pulseRingTimmer";
	this.pulseRingTimmer.setTransform(728.2,414.75);

	this.timeline.addTween(cjs.Tween.get(this.pulseRingTimmer).wait(1));

	// coachButton
	this.coachButton = new lib.RoboGuru_OnboardingSelect();
	this.coachButton.name = "coachButton";
	this.coachButton.setTransform(726.45,419.5);

	this.timeline.addTween(cjs.Tween.get(this.coachButton).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.OnboardingStep_SelectScenario, new cjs.Rectangle(-1120.5,-540.5,2242.3,1081), null);


(lib.OnboardingStep_ConversationPlayerInput = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Arrow
	this.arrow = new lib.arrow();
	this.arrow.name = "arrow";
	this.arrow.setTransform(-760.05,270.9);

	this.timeline.addTween(cjs.Tween.get(this.arrow).wait(1));

	// coachPanel
	this.coachPanel = new lib.onboardingPanel();
	this.coachPanel.name = "coachPanel";
	this.coachPanel.setTransform(493.8,233,1,1,0,0,0,-10.5,32.5);

	this.timeline.addTween(cjs.Tween.get(this.coachPanel).wait(1));

	// pluseRing
	this.pulseRingTimmer = new lib.Dialog_pulseRing_animationTimmer();
	this.pulseRingTimmer.name = "pulseRingTimmer";
	this.pulseRingTimmer.setTransform(728.2,414.75);

	this.timeline.addTween(cjs.Tween.get(this.pulseRingTimmer).wait(1));

	// coachButton
	this.coachButton = new lib.RoboGuru_OnboardingSelect();
	this.coachButton.name = "coachButton";
	this.coachButton.setTransform(726.45,419.5);

	this.timeline.addTween(cjs.Tween.get(this.coachButton).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.OnboardingStep_ConversationPlayerInput, new cjs.Rectangle(-1120.5,-571.6,2241,1112.1), null);


(lib.OnboardingStep_ConversationHandOff = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Arrow
	this.arrow = new lib.arrow();
	this.arrow.name = "arrow";
	this.arrow.setTransform(725.75,260.9);

	this.timeline.addTween(cjs.Tween.get(this.arrow).wait(1));

	// coachPanel
	this.coachPanel = new lib.onboardingPanel();
	this.coachPanel.name = "coachPanel";
	this.coachPanel.setTransform(317.8,233,1,1,0,0,0,-10.5,32.5);

	this.timeline.addTween(cjs.Tween.get(this.coachPanel).wait(1));

	// pluseRing
	this.pulseRingTimmer = new lib.Dialog_pulseRing_animationTimmer();
	this.pulseRingTimmer.name = "pulseRingTimmer";
	this.pulseRingTimmer.setTransform(728.2,414.75);

	this.timeline.addTween(cjs.Tween.get(this.pulseRingTimmer).wait(1));

	// coachButton
	this.coachButton = new lib.RoboGuru_OnboardingSelect();
	this.coachButton.name = "coachButton";
	this.coachButton.setTransform(726.45,419.5);

	this.timeline.addTween(cjs.Tween.get(this.coachButton).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.OnboardingStep_ConversationHandOff, new cjs.Rectangle(-1120.5,-571.6,2241,1112.1), null);


(lib.roboGuru_introduction = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_284 = function() {
		this.stop()
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(284).call(this.frame_284).wait(1));

	// Layer_4
	this.instance = new lib.robby_popup_ani_intro("synched",0);
	this.instance.setTransform(-1962.55,-147.15,0.9639,0.9639,24.972,0,0,-0.2,0.1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:0,regY:0,scaleX:0.9534,scaleY:1.0418,rotation:0,skewX:18.5456,skewY:14.7159,x:-1516.4,y:-947.85,startPosition:20},20).to({scaleX:1.0907,scaleY:0.8902,rotation:16.0744,skewX:0,skewY:0,x:-1621.6,y:-753.7,startPosition:39},19).to({regX:-0.6,regY:-0.2,scaleX:1.0295,scaleY:0.9859,rotation:0,skewX:31.1327,skewY:30.4388,x:-1429.1,y:-908.05,startPosition:67},28).to({regY:-0.1,scaleY:0.986,skewX:21.8837,skewY:21.1905,x:-1527.7,y:-908,startPosition:99},32,cjs.Ease.cubicInOut).to({regY:-0.2,scaleY:0.9859,skewX:31.1327,skewY:30.4388,x:-1429.1,y:-908.05,startPosition:131},32,cjs.Ease.cubicInOut).to({regY:-0.1,scaleY:0.986,skewX:21.8837,skewY:21.1905,x:-1527.7,y:-908,startPosition:163},32,cjs.Ease.cubicInOut).to({regY:-0.2,scaleY:0.9859,skewX:31.1327,skewY:30.4388,x:-1429.1,y:-908.05,startPosition:195},32,cjs.Ease.cubicInOut).to({regY:-0.1,scaleY:0.986,skewX:21.8837,skewY:21.1905,x:-1527.7,y:-908,startPosition:227},32,cjs.Ease.cubicInOut).to({regY:-0.2,scaleY:0.9859,skewX:31.1327,skewY:30.4388,x:-1429.1,y:-908.05,startPosition:254},27,cjs.Ease.cubicInOut).to({regX:-0.7,regY:-0.5,scaleX:1.0512,scaleY:0.9642,skewX:20.8778,skewY:20.1818,x:-1560.45,y:-862,startPosition:270},16,cjs.Ease.cubicInOut).to({regX:-0.4,regY:-0.1,scaleX:1.0478,scaleY:0.9695,rotation:20.6076,skewX:0,skewY:0,x:-1540.45,y:-877.4,startPosition:284},14,cjs.Ease.cubicInOut).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2351.8,-1355.7,1490.3000000000002,1910);


(lib.Robby_popupEnd = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_207 = function() {
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(207).call(this.frame_207).wait(1));

	// Layer_1
	this.instance = new lib.robby_popup_aniEnd("synched",0);
	this.instance.setTransform(-1962.55,-147.15,0.9639,0.9639,24.972,0,0,-0.2,0.1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:0,regY:0,scaleX:0.9534,scaleY:1.0418,rotation:0,skewX:18.5456,skewY:14.7159,x:-1516.4,y:-947.85,startPosition:22},22).to({scaleX:1.0907,scaleY:0.8903,rotation:20.8126,skewX:0,skewY:0,x:-1651.25,y:-679.45,startPosition:36},14,cjs.Ease.quadInOut).to({regX:-0.6,regY:-0.1,scaleX:1.0295,scaleY:0.986,rotation:0,skewX:21.8837,skewY:21.1905,x:-1527.7,y:-908,startPosition:54},18,cjs.Ease.quadInOut).to({regY:-0.2,skewX:15.4091,skewY:14.7153,x:-1599.25,y:-889.25,startPosition:68},14).to({regX:-0.7,regY:-0.3,scaleX:1.0294,scaleY:0.9859,skewX:24.3596,skewY:23.6659,x:-1548.3,y:-845.6,startPosition:101},33).to({regX:-0.6,regY:-0.2,scaleX:1.0295,scaleY:0.986,skewX:15.4091,skewY:14.7153,x:-1599.25,y:-889.25,startPosition:124},23).to({regX:-0.7,regY:-0.3,scaleX:1.0294,scaleY:0.9859,skewX:24.3596,skewY:23.6659,x:-1548.3,y:-845.6,startPosition:154},30).to({regX:-0.4,regY:-0.1,scaleX:1.0478,scaleY:0.9695,rotation:20.6076,skewX:0,skewY:0,x:-1575.1,y:-828.35,startPosition:165},11).to({regY:-0.2,scaleX:1.0477,scaleY:0.9984,rotation:0,skewX:32.4125,skewY:29.323,x:-1505.7,y:-906.4,startPosition:184},19,cjs.Ease.cubicInOut).to({regX:-0.2,regY:0,scaleX:1.0943,scaleY:0.875,rotation:26.9002,skewX:0,skewY:0,x:-1994.7,y:-309.8,startPosition:206},22,cjs.Ease.cubicInOut).to({_off:true},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2398.1,-1354,1487.5,1908.3);


(lib.panelEndScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bodyText
	this.bodyText = new cjs.Text("[[[[Een teamversterker is iemand die teams]]]]]]]]]]\n[[[[Een teamversterker is iemand die teams]]]]]]]]]]\n[[[[Een teamversterker is iemand die teams]]]]]]]]]]\n[[[[Een teamversterker is iemand die teams]]]]]]]]]]\n[[[[Een teamversterker is iemand die teams]]]]]]]]]]", "22px 'JetBrains Mono'", "#FFFFFF");
	this.bodyText.name = "bodyText";
	this.bodyText.textAlign = "center";
	this.bodyText.lineHeight = 31;
	this.bodyText.lineWidth = 702;
	this.bodyText.parent = this;
	this.bodyText.setTransform(0,-74.5);
ranj.TextOffsetFixer.fix(this.bodyText);

	this.timeline.addTween(cjs.Tween.get(this.bodyText).wait(1));

	// headerText
	this.headerText = new cjs.Text("Gefeliciteerd! Ferry", "34px 'JetBrains Mono'", "#FFFFFF");
	this.headerText.name = "headerText";
	this.headerText.textAlign = "center";
	this.headerText.lineHeight = 47;
	this.headerText.lineWidth = 664;
	this.headerText.parent = this;
	this.headerText.setTransform(-2,-123);
ranj.TextOffsetFixer.fix(this.headerText);

	this.timeline.addTween(cjs.Tween.get(this.headerText).wait(1));

	// hintText
	this.hintText = new cjs.Text("Bij het verversen van de pagina kun je jouw rapportage]]]]]]]]]]\nBij het verversen van de pagina kun je jouw rapportage]]]]]]]]]]", "18px 'JetBrains Mono'", "#FFFFFF");
	this.hintText.name = "hintText";
	this.hintText.textAlign = "center";
	this.hintText.lineHeight = 26;
	this.hintText.lineWidth = 699;
	this.hintText.parent = this;
	this.hintText.setTransform(-0.5,161.65);
ranj.TextOffsetFixer.fix(this.hintText);

	this.timeline.addTween(cjs.Tween.get(this.hintText).wait(1));

	// continueButton
	this.continueButton = new lib.ConversationButton_Primary();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(-1.55,117.95,1,1,0,0,0,-0.8,-0.8);

	this.timeline.addTween(cjs.Tween.get(this.continueButton).wait(1));

	// download_button
	this.downloadPersonalReportButton = new lib.downloadButton_1();
	this.downloadPersonalReportButton.name = "downloadPersonalReportButton";
	this.downloadPersonalReportButton.setTransform(20.95,120.75);

	this.timeline.addTween(cjs.Tween.get(this.downloadPersonalReportButton).wait(1));

	// panelEndScreen_png
	this.instance = new lib.panel_end();
	this.instance.setTransform(-385,-156);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.panelEndScreen, new cjs.Rectangle(-385,-156,767,412), null);


(lib.ConversationReflectionPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// scrollPane
	this.scrollPane = new lib.ConversationReflectionScrollPane();
	this.scrollPane.name = "scrollPane";
	this.scrollPane.setTransform(-528.8,-350.55);

	this.timeline.addTween(cjs.Tween.get(this.scrollPane).wait(1));

	// scrollbar
	this.scrollBar = new lib.ConversationScrollBar();
	this.scrollBar.name = "scrollBar";
	this.scrollBar.setTransform(521.65,-350.55);

	this.timeline.addTween(cjs.Tween.get(this.scrollBar).wait(1));

	// readyPanel
	this.readyPanel = new lib.ConversationReflectionReadyPanel();
	this.readyPanel.name = "readyPanel";
	this.readyPanel.setTransform(-11.3,289.2);

	this.timeline.addTween(cjs.Tween.get(this.readyPanel).wait(1));

	// panel
	this.instance = new lib.roboGuru_feedbackPanel();
	this.instance.setTransform(-603,-407.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationReflectionPanel, new cjs.Rectangle(-603,-407.5,1206,815), null);


(lib.PlayerNameInputScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// input
	this.nameInputPanel = new lib.nameInputPanel();
	this.nameInputPanel.name = "nameInputPanel";
	this.nameInputPanel.setTransform(-397,322.55);

	this.timeline.addTween(cjs.Tween.get(this.nameInputPanel).wait(1));

	// roboTextField
	this.panel = new lib.roboGuruPanel();
	this.panel.name = "panel";
	this.panel.setTransform(-397,-304.05);

	this.timeline.addTween(cjs.Tween.get(this.panel).wait(1));

	// roboGuru
	this.coach = new lib.roboGuru_introduction();
	this.coach.name = "coach";
	this.coach.setTransform(447.05,1104.15,1,1,0,35.2752,-144.7248,-1878.6,42.6);

	this.timeline.addTween(cjs.Tween.get(this.coach).wait(1));

	// Screen_over
	this.overlay = new lib.DarkendOverlay();
	this.overlay.name = "overlay";

	this.timeline.addTween(cjs.Tween.get(this.overlay).wait(1));

	// Background
	this.instance = new lib.Endframe();
	this.instance.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlayerNameInputScreenSkin, new cjs.Rectangle(-1120.5,-540.5,2241,2203.9), null);


(lib.ConversationScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// sessionIdTextField
	this.sessionIdTextField = new cjs.Text("Session id: 64d2b5ec-a43c-4f97-b8e9-5024acf99ab0", "16px 'Arial'", "#999999");
	this.sessionIdTextField.name = "sessionIdTextField";
	this.sessionIdTextField.textAlign = "right";
	this.sessionIdTextField.lineHeight = 18;
	this.sessionIdTextField.lineWidth = 550;
	this.sessionIdTextField.parent = this;
	this.sessionIdTextField.setTransform(956.6,516.5);
ranj.TextOffsetFixer.fix(this.sessionIdTextField);

	this.timeline.addTween(cjs.Tween.get(this.sessionIdTextField).wait(1));

	// coachPanel
	this.coachPanel = new lib.ConversationCoachPanel();
	this.coachPanel.name = "coachPanel";
	this.coachPanel.setTransform(741.35,429.3,1,1,0,0,0,236.8,228.8);

	this.timeline.addTween(cjs.Tween.get(this.coachPanel).wait(1));

	// pluseRing
	this.pulseRingTimmer = new lib.Dialog_pulseRing_animationTimmer();
	this.pulseRingTimmer.name = "pulseRingTimmer";
	this.pulseRingTimmer.setTransform(728.2,414.75);

	this.timeline.addTween(cjs.Tween.get(this.pulseRingTimmer).wait(1));

	// coachButton
	this.coachButton = new lib.RoboGuru_Help();
	this.coachButton.name = "coachButton";
	this.coachButton.setTransform(726.45,419.5);

	this.timeline.addTween(cjs.Tween.get(this.coachButton).wait(1));

	// playerSpeechPanel
	this.playerSpeechPanel = new lib.DialogOutputField();
	this.playerSpeechPanel.name = "playerSpeechPanel";
	this.playerSpeechPanel.setTransform(-309.5,262);

	this.timeline.addTween(cjs.Tween.get(this.playerSpeechPanel).wait(1));

	// coachHintPanel
	this.coachHintPanel = new lib.RoboGuruOutputField();
	this.coachHintPanel.name = "coachHintPanel";
	this.coachHintPanel.setTransform(-309.5,262.6);

	this.timeline.addTween(cjs.Tween.get(this.coachHintPanel).wait(1));

	// responseFields
	this.responseField1 = new lib.ConversationResponse2();
	this.responseField1.name = "responseField1";
	this.responseField1.setTransform(306.15,-279.95);

	this.responseField2 = new lib.ConversationResponse1();
	this.responseField2.name = "responseField2";
	this.responseField2.setTransform(-300.85,-277.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.responseField2},{t:this.responseField1}]}).wait(1));

	// backButton
	this.backButton = new lib.ConversationButton_Primary();
	this.backButton.name = "backButton";
	this.backButton.setTransform(-889.35,-490.15,1,1,0,0,0,-0.5,0);

	this.timeline.addTween(cjs.Tween.get(this.backButton).wait(1));

	// endButton
	this.endButton = new lib.ConversationButton_Primary();
	this.endButton.name = "endButton";
	this.endButton.setTransform(0,416.1);

	this.timeline.addTween(cjs.Tween.get(this.endButton).wait(1));

	// continueButton
	this.nextButton = new lib.ConversationButton_Primary();
	this.nextButton.name = "nextButton";
	this.nextButton.setTransform(0,416.1);

	this.timeline.addTween(cjs.Tween.get(this.nextButton).wait(1));

	// inputField
	this.inputPanel = new lib.ConversationScreenInputField();
	this.inputPanel.name = "inputPanel";
	this.inputPanel.setTransform(83.5,412.6,1,1,0,0,0,900,50);

	this.timeline.addTween(cjs.Tween.get(this.inputPanel).wait(1));

	// bg_image
	this.bgImageContainer = new lib.conversation_Bg_Dialog01();
	this.bgImageContainer.name = "bgImageContainer";

	this.timeline.addTween(cjs.Tween.get(this.bgImageContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationScreenSkin, new cjs.Rectangle(-1120.5,-571.6,2241,1112.1), null);


(lib.ConversationReflectionScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// sessionIdTextField
	this.sessionIdTextField = new cjs.Text("Session id: 64d2b5ec-a43c-4f97-b8e9-5024acf99ab0", "16px 'Arial'", "#999999");
	this.sessionIdTextField.name = "sessionIdTextField";
	this.sessionIdTextField.textAlign = "right";
	this.sessionIdTextField.lineHeight = 18;
	this.sessionIdTextField.lineWidth = 550;
	this.sessionIdTextField.parent = this;
	this.sessionIdTextField.setTransform(956.6,516.5);
ranj.TextOffsetFixer.fix(this.sessionIdTextField);

	this.timeline.addTween(cjs.Tween.get(this.sessionIdTextField).wait(1));

	// title
	this.titleTextField = new cjs.Text("Feedback & reflectie", "48px 'JetBrains Mono'", "#FFFFFF");
	this.titleTextField.name = "titleTextField";
	this.titleTextField.lineHeight = 65;
	this.titleTextField.lineWidth = 1073;
	this.titleTextField.parent = this;
	this.titleTextField.setTransform(-773.5,-525);
ranj.TextOffsetFixer.fix(this.titleTextField);

	this.timeline.addTween(cjs.Tween.get(this.titleTextField).wait(1));

	// robby
	this.robbyReflection = new lib.Robby_popup();
	this.robbyReflection.name = "robbyReflection";
	this.robbyReflection.setTransform(593,135.5);

	this.timeline.addTween(cjs.Tween.get(this.robbyReflection).wait(1));

	// panel
	this.reflectionPanel = new lib.ConversationReflectionPanel();
	this.reflectionPanel.name = "reflectionPanel";
	this.reflectionPanel.setTransform(-245,-62.5);

	this.timeline.addTween(cjs.Tween.get(this.reflectionPanel).wait(1));

	// inputField
	this.inputPanel = new lib.ConversationRefelctionScreenInputField();
	this.inputPanel.name = "inputPanel";
	this.inputPanel.setTransform(83.5,412.6,1,1,0,0,0,900,50);

	this.timeline.addTween(cjs.Tween.get(this.inputPanel).wait(1));

	// vignette
	this.vignette = new lib.vignette();
	this.vignette.name = "vignette";
	this.vignette.setTransform(0,-340);

	this.timeline.addTween(cjs.Tween.get(this.vignette).wait(1));

	// bg_image
	this.bgImageContainer = new lib.conversation_Bg_Dialog01();
	this.bgImageContainer.name = "bgImageContainer";

	this.timeline.addTween(cjs.Tween.get(this.bgImageContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationReflectionScreenSkin, new cjs.Rectangle(-1120.5,-540.5,2318,2207), null);


(lib.CoachIntroductionScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// panel
	this.panel = new lib.Coach_Introduction_Panel();
	this.panel.name = "panel";
	this.panel.setTransform(-416.05,-3.95,1,1,0,0,0,0,-0.5);

	this.timeline.addTween(cjs.Tween.get(this.panel).wait(1));

	// coach
	this.coach = new lib.roboGuru_introduction("synched",284);
	this.coach.name = "coach";
	this.coach.setTransform(446.95,1104.1,1,1,0,35.2752,-144.7248,-1878.5,42.6);

	this.timeline.addTween(cjs.Tween.get(this.coach).wait(1));

	// overlay
	this.overlay = new lib.DarkendOverlay();
	this.overlay.name = "overlay";

	this.timeline.addTween(cjs.Tween.get(this.overlay).wait(1));

	// Background
	this.introBg = new lib.Introduction_BG();
	this.introBg.name = "introBg";

	this.timeline.addTween(cjs.Tween.get(this.introBg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.CoachIntroductionScreenSkin, new cjs.Rectangle(-1120.5,-540.5,2241,1252.3), null);


(lib.EndOfGamePanelOverview = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// coach
	this.coach = new lib.Robby_popupEnd();
	this.coach.name = "coach";
	this.coach.setTransform(1628.05,1166.85,1,1,-29.9992,0,0,41.2,1225.2);

	this.timeline.addTween(cjs.Tween.get(this.coach).wait(1));

	// panelEndScreen
	this.descriptivePanel = new lib.panelEndScreen();
	this.descriptivePanel.name = "descriptivePanel";
	this.descriptivePanel.setTransform(-5.5,-286.05);

	this.timeline.addTween(cjs.Tween.get(this.descriptivePanel).wait(1));

	// scoreHeaderTextField
	this.scoreHeaderTextField = new cjs.Text("Jouw score in de game:", "bold 34px 'JetBrains Mono'", "#FFFFFF");
	this.scoreHeaderTextField.name = "scoreHeaderTextField";
	this.scoreHeaderTextField.textAlign = "center";
	this.scoreHeaderTextField.lineHeight = 47;
	this.scoreHeaderTextField.lineWidth = 1196;
	this.scoreHeaderTextField.parent = this;
	this.scoreHeaderTextField.setTransform(0,361.4);
ranj.TextOffsetFixer.fix(this.scoreHeaderTextField);

	this.timeline.addTween(cjs.Tween.get(this.scoreHeaderTextField).wait(1));

	// trustTextField
	this.trustTextField = new cjs.Text("100% Vertrouwen in jou", "bold 34px 'JetBrains Mono'", "#FFFFFF");
	this.trustTextField.name = "trustTextField";
	this.trustTextField.textAlign = "center";
	this.trustTextField.lineHeight = 47;
	this.trustTextField.lineWidth = 1196;
	this.trustTextField.parent = this;
	this.trustTextField.setTransform(0,461.4);
ranj.TextOffsetFixer.fix(this.trustTextField);

	this.timeline.addTween(cjs.Tween.get(this.trustTextField).wait(1));

	// groupSpiritTextField
	this.groupSpiritTextField = new cjs.Text("100% Groepsgevoel", "bold 34px 'JetBrains Mono'", "#FFFFFF");
	this.groupSpiritTextField.name = "groupSpiritTextField";
	this.groupSpiritTextField.textAlign = "center";
	this.groupSpiritTextField.lineHeight = 47;
	this.groupSpiritTextField.lineWidth = 1196;
	this.groupSpiritTextField.parent = this;
	this.groupSpiritTextField.setTransform(0,410.3);
ranj.TextOffsetFixer.fix(this.groupSpiritTextField);

	this.timeline.addTween(cjs.Tween.get(this.groupSpiritTextField).wait(1));

	// confetti
	this.confetti = new lib.ConfettiOverlay();
	this.confetti.name = "confetti";
	this.confetti.setTransform(37.5,-15.5);

	this.timeline.addTween(cjs.Tween.get(this.confetti).wait(1));

	// scoreMeter
	this.scoreMeter = new lib.teamOmeter();
	this.scoreMeter.name = "scoreMeter";
	this.scoreMeter.setTransform(0,156.9,0.5083,0.5083);

	this.timeline.addTween(cjs.Tween.get(this.scoreMeter).wait(1));

	// scoreMeterStartPos
	this.scoreMeterStart = new lib.teamOmeter();
	this.scoreMeterStart.name = "scoreMeterStart";
	this.scoreMeterStart.setTransform(0,-45.6);

	this.timeline.addTween(cjs.Tween.get(this.scoreMeterStart).wait(1));

	// bg_endofgame2_jpg
	this.instance = new lib.bg_endofgame2();
	this.instance.setTransform(-1120,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EndOfGamePanelOverview, new cjs.Rectangle(-1120,-540,2240,2176.5), null);


(lib.EndOfGameScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// overviewPanel
	this.overviewPanel = new lib.EndOfGamePanelOverview();
	this.overviewPanel.name = "overviewPanel";

	this.timeline.addTween(cjs.Tween.get(this.overviewPanel).wait(1));

	// scorePanel
	this.scorePanel = new lib.EndOfGamePanelScore();
	this.scorePanel.name = "scorePanel";

	this.timeline.addTween(cjs.Tween.get(this.scorePanel).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EndOfGameScreenSkin, new cjs.Rectangle(-1120.5,-540.5,2241,2177), null);


// stage content:
(lib.MainAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);
// library properties:
lib.properties = {
	id: '6742645E4BD55D40985CB08A6C609BD7',
	width: 1920,
	height: 1080,
	fps: 60,
	color: "#000000",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/MainAssets/AICoach_Robby_Error.png", id:"MainAssets_AICoach_Robby_Error", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/AICoach_Robby_Feedback.png", id:"MainAssets_AICoach_Robby_Feedback", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/AICoach_RoboHead_eyes.png", id:"MainAssets_AICoach_RoboHead_eyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/AICoach_RoboHead_mid_noeyes.png", id:"MainAssets_AICoach_RoboHead_mid_noeyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/armachter_feedback.png", id:"MainAssets_armachter_feedback", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/armvoor.png", id:"MainAssets_armvoor", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/armvoor_feedback.png", id:"MainAssets_armvoor_feedback", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/armvoor_zwaai.png", id:"MainAssets_armvoor_zwaai", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/benen.png", id:"MainAssets_benen", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/bg_endofgame.jpg", id:"MainAssets_bg_endofgame", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/bg_endofgame2.jpg", id:"MainAssets_bg_endofgame2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/blueCircle.png", id:"MainAssets_blueCircle", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/bodyRobbieZwaai.png", id:"MainAssets_bodyRobbieZwaai", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/c01_hub_tile.jpg", id:"MainAssets_c01_hub_tile", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/c01_hub_tile_disabled.png", id:"MainAssets_c01_hub_tile_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/c01_hub_tile_over.png", id:"MainAssets_c01_hub_tile_over", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/c02_hub_tile.jpg", id:"MainAssets_c02_hub_tile", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/c02_hub_tile_disabled.png", id:"MainAssets_c02_hub_tile_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/c02_hub_tile_over.png", id:"MainAssets_c02_hub_tile_over", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/c03_hub_tile.jpg", id:"MainAssets_c03_hub_tile", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/c03_hub_tile_disabled.png", id:"MainAssets_c03_hub_tile_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/c03_hub_tile_over.png", id:"MainAssets_c03_hub_tile_over", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/c04_hub_tile.jpg", id:"MainAssets_c04_hub_tile", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/c04_hub_tile_disabled.png", id:"MainAssets_c04_hub_tile_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/c04_hub_tile_over.png", id:"MainAssets_c04_hub_tile_over", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/c05_hub_tile.jpg", id:"MainAssets_c05_hub_tile", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/c05_hub_tile_disabled.png", id:"MainAssets_c05_hub_tile_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/c05_hub_tile_over.png", id:"MainAssets_c05_hub_tile_over", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/chapterPanel.png", id:"MainAssets_chapterPanel", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ChapterScreen_BGHst01.png", id:"MainAssets_ChapterScreen_BGHst01", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/CharacterFeedbackGroep.png", id:"MainAssets_CharacterFeedbackGroep", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/CharacterFeedbackHartje.png", id:"MainAssets_CharacterFeedbackHartje", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/CharacterFeedbackPanel_balkje.png", id:"MainAssets_CharacterFeedbackPanel_balkje", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/CharacterFeedbackPanel_balkje_1.png", id:"MainAssets_CharacterFeedbackPanel_balkje_1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/CharacterFeedbackPanel_balkjeGroen.png", id:"MainAssets_CharacterFeedbackPanel_balkjeGroen", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/CharacterFeedbackPanel_balkjeOranje.png", id:"MainAssets_CharacterFeedbackPanel_balkjeOranje", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/CharacterFeedbackPanel_kort.png", id:"MainAssets_CharacterFeedbackPanel_kort", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/CharacterFeedbackSingle.png", id:"MainAssets_CharacterFeedbackSingle", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/CharacterFeedbackSmiley.png", id:"MainAssets_CharacterFeedbackSmiley", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/colors.png", id:"MainAssets_colors", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/colors_off.png", id:"MainAssets_colors_off", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Con_BG_Dialog02.png", id:"MainAssets_Con_BG_Dialog02", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Con_BG_Dialog_01_Total_disabled.png", id:"MainAssets_Con_BG_Dialog_01_Total_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Con_BG_Dialog_01_Total_newBlurred.png", id:"MainAssets_Con_BG_Dialog_01_Total_newBlurred", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Con_panel_Dialog_01_over.png", id:"MainAssets_Con_panel_Dialog_01_over", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ConfettiBlauw1.png", id:"MainAssets_ConfettiBlauw1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ConfettiBlauw2.png", id:"MainAssets_ConfettiBlauw2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ConfettiGeel1.png", id:"MainAssets_ConfettiGeel1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ConfettiGeel2.png", id:"MainAssets_ConfettiGeel2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ConfettiGeel2_1.png", id:"MainAssets_ConfettiGeel2_1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ConfettiGroen1.png", id:"MainAssets_ConfettiGroen1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ConfettiGroen2.png", id:"MainAssets_ConfettiGroen2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ConfettiOranje1.png", id:"MainAssets_ConfettiOranje1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ConfettiOranje2.png", id:"MainAssets_ConfettiOranje2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ConfettiViolet1.png", id:"MainAssets_ConfettiViolet1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ConfettiViolet2.png", id:"MainAssets_ConfettiViolet2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/demoInput.png", id:"MainAssets_demoInput", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Dialog_Chat_Action_Panel3.png", id:"MainAssets_Dialog_Chat_Action_Panel3", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Dialog_Chat_AIResponse_Panel.png", id:"MainAssets_Dialog_Chat_AIResponse_Panel", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Dialog_Chat_Outputfield4.png", id:"MainAssets_Dialog_Chat_Outputfield4", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Dialog_Chat_Panel_Input6.png", id:"MainAssets_Dialog_Chat_Panel_Input6", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Dialog_Chat_Send_button_Down3.png", id:"MainAssets_Dialog_Chat_Send_button_Down3", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Dialog_Chat_Send_button_Over3.png", id:"MainAssets_Dialog_Chat_Send_button_Over3", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Dialog_Chat_Send_button_Up3.png", id:"MainAssets_Dialog_Chat_Send_button_Up3", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Dialog_panel3_blue.png", id:"MainAssets_Dialog_panel3_blue", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Dialog_Robot_Circle_BG_blue.png", id:"MainAssets_Dialog_Robot_Circle_BG_blue", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Dialog_Robot_Circle_inner_circle.png", id:"MainAssets_Dialog_Robot_Circle_inner_circle", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/DialogScr_CharacterProfile_BG3.png", id:"MainAssets_DialogScr_CharacterProfile_BG3", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/DialogScr_CharacterProfile_broder2.png", id:"MainAssets_DialogScr_CharacterProfile_broder2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/download_Icon.png", id:"MainAssets_download_Icon", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/download_Icon_up.png", id:"MainAssets_download_Icon_up", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Download_over.png", id:"MainAssets_Download_over", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/downloadButton.png", id:"MainAssets_downloadButton", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/downloading_pdf.png", id:"MainAssets_downloading_pdf", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/elips.png", id:"MainAssets_elips", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/elipse_glow.png", id:"MainAssets_elipse_glow", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Endframe.png", id:"MainAssets_Endframe", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/EndofGameScreen.jpg", id:"MainAssets_EndofGameScreen", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/eten.png", id:"MainAssets_eten", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/feel.png", id:"MainAssets_feel", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/GameSaved.png", id:"MainAssets_GameSaved", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/group.png", id:"MainAssets_group", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/handje.png", id:"MainAssets_handje", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/hut.png", id:"MainAssets_hut", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/loadingBG.jpg", id:"MainAssets_loadingBG", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/loadingScreenBG.jpg", id:"MainAssets_loadingScreenBG", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/locked.png", id:"MainAssets_locked", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Map_point.png", id:"MainAssets_Map_point", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/mission_briefing_background.png", id:"MainAssets_mission_briefing_background", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/naamInvoerOK_down.png", id:"MainAssets_naamInvoerOK_down", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/naamInvoerOK_over.png", id:"MainAssets_naamInvoerOK_over", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/naamInvoerOK_up.png", id:"MainAssets_naamInvoerOK_up", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/naamInvoerPanel.png", id:"MainAssets_naamInvoerPanel", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/npc_erik_1.png", id:"MainAssets_npc_erik_1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/panel_end.png", id:"MainAssets_panel_end", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/pijltje.png", id:"MainAssets_pijltje", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/pijlUp.png", id:"MainAssets_pijlUp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/pijlUpGreen.png", id:"MainAssets_pijlUpGreen", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/pinpoint_disabled.png", id:"MainAssets_pinpoint_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Pinpoint_green.png", id:"MainAssets_Pinpoint_green", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/pinpoint_orange.png", id:"MainAssets_pinpoint_orange", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PRIMARY.png", id:"MainAssets_PRIMARY", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PRIMARY_DOWN.png", id:"MainAssets_PRIMARY_DOWN", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PRIMARY_OVER.png", id:"MainAssets_PRIMARY_OVER", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ReflectionInput.png", id:"MainAssets_ReflectionInput", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/RightArrow_down.png", id:"MainAssets_RightArrow_down", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/RightArrow_over.png", id:"MainAssets_RightArrow_over", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/RightArrow_up.png", id:"MainAssets_RightArrow_up", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Robby_headless_feedback.png", id:"MainAssets_Robby_headless_feedback", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/roboGuru_feedbackPanel.png", id:"MainAssets_roboGuru_feedbackPanel", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/roboGuru_feedbackPanel_1.png", id:"MainAssets_roboGuru_feedbackPanel_1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/roboGuru_help_outputField.png", id:"MainAssets_roboGuru_help_outputField", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/roboGuru_help_panel.png", id:"MainAssets_roboGuru_help_panel", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/roboGuru_input.png", id:"MainAssets_roboGuru_input", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/roboGuru_missionPanel.png", id:"MainAssets_roboGuru_missionPanel", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/RoboGuru_totaal2.png", id:"MainAssets_RoboGuru_totaal2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/RobotInputPanel.png", id:"MainAssets_RobotInputPanel", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/scharm.png", id:"MainAssets_scharm", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/signaal.png", id:"MainAssets_signaal", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/solo.png", id:"MainAssets_solo", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/vuur.png", id:"MainAssets_vuur", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/water.png", id:"MainAssets_water", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/wijzer.png", id:"MainAssets_wijzer", bundle:"MainAssets"}
	],
	preloads: []
};



an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(lib.MainAssets = {}, images, ss, createjs, AdobeAn = AdobeAn||{});
var AdobeAn;
module.exports = lib.MainAssets;